webpackJsonp([10],{

/***/ "++bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItemChildren__ = __webpack_require__("3G6k");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'actions-table-layout',
  components: { DropdownItemChildren: __WEBPACK_IMPORTED_MODULE_0__DropdownItemChildren__["a" /* default */] },
  props: {
    colorBtn: {
      default: 'btn-default'
    },
    showLabel: {
      default: false,
      type: Boolean
    },
    children: {
      required: true
    }
  },

  computed: {
    classBtnAction: function classBtnAction() {
      return 'btn btn-fill dropdown-toggle btn-icon ' + this.colorBtn;
    }
  }
});

/***/ }),

/***/ "+2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+2e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatelessFactory_vue__ = __webpack_require__("q66r");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("OBu8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-412a3de7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatelessFactory_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+33O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_services_LGPD__ = __webpack_require__("rdXj");
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamps-report-simplified',
  props: ['eventSelected', 'allEvents', 'csvSeparator', 'enableLGPD'],
  data: function data() {
    return {
      lamps: [],
      events: {},
      csvHeaders: {
        lamps: {
          'event.reference': 'Referência',
          'event.city': 'Município',
          'customer.uc': 'UC',
          'customer.holder': 'Titular',
          'customer.address.city': 'Cidade',
          'user': 'Atendente da troca',
          'items': {
            'type': 'Tipo',
            'power': 'Potência',
            'room': 'Cômodo',
            'usageHoursPerDay': 'Quantidade de Horas',
            'rushHour': 'Lâmpada utilizada em horário de pico?'
          },
          'createdAt': 'Data da troca da lâmpada'
        }
      },
      loading: false
    };
  },

  methods: {
    resetValues: function resetValues() {
      this.lamps = [];
    },
    runReport: function runReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('progress', { current: 0, total: 0 });
                _this.loading = true;
                _this.resetValues();
                _context.prev = 3;
                _context.next = 6;
                return _this.getEvent();

              case 6:
                _this.events = _context.sent;
                _context.next = 9;
                return _this.getLamps();

              case 9:
                _this.lamps = _context.sent;

                if (_this.lamps.length > 0) {
                  _this.getReportLamps();
                } else {
                  _this.$notify('Não há lâmpadas para este evento');
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.$notify({
                  message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
                  type: 'danger'
                });

              case 17:
                _context.prev = 17;

                _this.loading = false;
                return _context.finish(17);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 13, 17, 20]]);
      }))();
    },
    getEvent: function getEvent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(_this2.eventSelected.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(eventId) {
                    var event;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__["a" /* default */].collection('events').find(eventId);

                          case 2:
                            event = _context2.sent;
                            return _context2.abrupt('return', event);

                          case 4:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getCustomer: function getCustomer(customerId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__["a" /* default */].db("trg_eqpi_notiasc_admin").limit(999999).collection('customers').find(customerId));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getLamps: function getLamps() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var promiseLamps;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                promiseLamps = _this4.eventSelected.reduce(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5(lastLamps, eventId) {
                    var lamps, newLamps;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__["a" /* default */].db("trg_eqpi_notiasc_admin").limit(999999).collection('lamps').where('eventId', eventId).get();

                          case 2:
                            lamps = _context5.sent;

                            lamps = lamps.map(function (lamp) {
                              var eventId = lamp.eventId;
                              var event = _this4.events.find(function (event) {
                                return event._id === eventId;
                              });
                              lamp.user = _this4.usersIdName[lamp.userId];
                              lamp.event = {
                                reference: event.reference,
                                city: event.city
                              };
                              return _this4.getCustomer(lamp.customer.id).then(function (customer) {
                                console.log('customer', customer);
                                lamp.customer.address = customer.address;
                                return lamp;
                              });
                            });
                            newLamps = lamps ? [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(lastLamps), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(lamps)) : lastLamps;
                            return _context5.abrupt('return', newLamps);

                          case 6:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this4);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }(), []);
                return _context6.abrupt('return', promiseLamps.then(function (allLamps) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(allLamps);
                }));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    getReportLamps: function getReportLamps() {
      var _this5 = this;

      var csv = '';
      csv += this.addHeader(this.csvHeaders.lamps);
      csv += '\n';
      var itemKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.lamps.items);
      var itemIndex = 0;
      var total = this.lamps.reduce(function (acc, cur) {
        return cur.items ? acc + cur.items.length : acc + 0;
      }, 0);
      this.lamps.forEach(function (lamp) {
        if (lamp.items && lamp.items.length) {
          lamp.items.forEach(function (item, i) {
            csv += '' + lamp.event.reference + _this5.csvSeparator;
            csv += '' + lamp.event.city + _this5.csvSeparator;
            csv += '' + lamp.customer.uc + _this5.csvSeparator;

            csv += '' + _this5.getHolderName(lamp.customer) + _this5.csvSeparator;

            csv += '' + (lamp.customer.address ? lamp.customer.address.city : '"-"') + _this5.csvSeparator;
            csv += '' + lamp.user + _this5.csvSeparator;
            itemKeys.forEach(function (itemKey) {
              if (itemKey === 'rushHour') {
                csv += item[itemKey] ? 'Sim' + _this5.csvSeparator : 'N\xE3o' + _this5.csvSeparator;
              } else {
                csv += itemKey ? '' + item[itemKey] + _this5.csvSeparator : '' + _this5.csvSeparator;
              }
            });
            csv += '' + _this5.$moment(new Date(lamp.createdAt).toISOString()).format('DD-MM-YYYY HH:mm:ss') + _this5.csvSeparator;
            csv += '\n';
            itemIndex++;
            _this5.$emit('progress', { current: itemIndex, total: total });
          });
        }
      });
      this.download(csv);
    },
    addHeader: function addHeader(headers) {
      var _this6 = this;

      var csv = '';
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(headers).forEach(function (header) {
        if (headers[header] !== null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(headers[header]) === 'object') {
          csv += _this6.addHeader(headers[header]);
        } else {
          csv += '' + headers[header] + _this6.csvSeparator;
        }
      });
      return csv;
    },
    download: function download(csv) {
      var blob = __WEBPACK_IMPORTED_MODULE_7_blob_util___default.a.createBlob([csv], { type: 'text/plain' });
      var date = this.$moment(new Date()).format('DD-MM-YYYY');
      __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(blob, 'Relat\xF3rio_Simplificado_Lampadas_' + date + '.csv');
    },
    getHolderName: function getHolderName(customer) {
      if (this.enableLGPD) {
        return __WEBPACK_IMPORTED_MODULE_11_src_services_LGPD__["a" /* default */].obfuscateString(customer.holder);
      }

      return customer.holder;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('users', ['usersIdName']))
});

/***/ }),

/***/ "+3Uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__ = __webpack_require__("fd3O");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-enel',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },
  data: function data() {
    return {
      company: 'ENEL'
    };
  },
  mounted: function mounted() {
    console.log(this.config, this.dateTimeDelivery);
  }
});

/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+EX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerCard__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormLamps__ = __webpack_require__("G5/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListLamps__ = __webpack_require__("Ov/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AlertLamps__ = __webpack_require__("jGXj");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LampsAlert: __WEBPACK_IMPORTED_MODULE_6__AlertLamps__["a" /* default */], LampsForm: __WEBPACK_IMPORTED_MODULE_4__FormLamps__["a" /* default */], LampsList: __WEBPACK_IMPORTED_MODULE_5__ListLamps__["a" /* default */], CustomerCard: __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerCard__["a" /* default */], CircleChartCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */] },
  data: function data() {
    return {
      entityName: 'Lâmpadas',
      eventId: '',
      currentEventStockLamps: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['eventSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', { config: 'project' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('events', { eventsOptions: 'optionsById', events: 'events' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', { allLamps: 'lamps', countLamps: 'countLamps' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', { customer: 'customer' }), {

    lampsHasSeason: {
      get: function get() {
        return this.config.lamps.hasOwnProperty('hasSeason') && this.config.lamps.hasSeason;
      }
    },

    lampsSeasonRange: {
      get: function get() {
        return this.config.lamps.hasOwnProperty('seasonRange') ? this.config.lamps.seasonRange : 0;
      }
    },

    lampsStartOfValidPeriod: function lampsStartOfValidPeriod() {
      if (this.lampsHasSeason && this.lampsSeasonRange > 0) {
        return this.$moment().subtract(this.lampsSeasonRange, 'months').toISOString();
      } else if (this.lampsHasSeason && this.lampsSeasonRange === 0) {
        return new Date().setDate(1).setMonth(1).setHours(0).setMinute(0).setSeconds(0);
      }
    },
    eventsOptions: function eventsOptions() {
      var _this = this;

      return this.events.map(function (item) {
        return {
          value: item._id,
          label: item.reference + ' - ' + item.city + ' - ' + item.place + ' - ' + _this.$moment(item.startDate).format('LLL')
        };
      });
    },


    event: function event() {
      var _this2 = this;

      return this.eventId ? this.events.find(function (item) {
        return item._id === _this2.eventId;
      }) : this.events[0];
    },

    showNewLampForm: function showNewLampForm() {
      return this.eventId !== '' && this.currentEventStockLamps > 0 && this.lampsLeft > 0 && this.event;
    },
    lampsPercentage: function lampsPercentage() {
      return this.countLamps && this.lampsMaxProject ? Math.floor(this.countLamps / this.lampsMaxProject * 100) : 0;
    },
    lampsLeft: function lampsLeft() {
      return this.lampsMaxProject - this.countLamps;
    },
    lampsMaxProject: function lampsMaxProject() {
      return this.config.lamps.max;
    },
    id: function id() {
      return this.$route.params.id;
    },
    ticketsRoute: function ticketsRoute() {
      if (this.customer._id) {
        return {
          name: 'customers.tickets',
          params: { id: this.customer._id }
        };
      } else {
        return { name: 'customers.index' };
      }
    },
    showAlert: function showAlert() {
      return this.lampsLeft <= 0 || this.eventsOptions.length <= 1 || this.eventId === '' <= 0 || this.currentEventStockLamps <= 0;
    },


    alertText: function alertText() {
      if (this.lampsLeft <= 0) {
        return 'Foi atingido o limite de lâmpadas para este cliente no projeto.';
      }
      if (this.eventsOptions.length <= 1) {
        return 'Não há eventos iniciados para que seja posśivel trocar a lâmpada.';
      } else if (this.eventId === '') {
        return 'Selecione um evento para efetuar alguma troca de lâmpadas.';
      } else if (this.currentEventStockLamps <= 0 && this.eventId !== '') {
        return 'O evento escolhido não possui mais lâmpadas em estoque.';
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', {
    fetchOne: 'fetchOne',
    resetCustomer: 'resetOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('lamps', {
    resetLamp: 'resetOne',
    resetLamps: 'resetAll',
    fetchLampsByCustomerId: 'fetchLampsByCustomerId',
    countLampsByEvent: 'countLampsByEvent'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('events', {
    resetEvents: 'resetAll',
    eventsViewAll: 'fetchViewAll',
    fetchEvents: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), {
    fetchCustomer: function fetchCustomer() {
      this.fetchOne(this.id);
      this.fetchLampsByCustomerId(this.id);
    },
    getLampsStockOfEvent: function getLampsStockOfEvent() {
      var _this3 = this;

      this.countLampsByEvent(this.eventId).then(function (result) {
        var deliveryLamps = result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0;
        _this3.currentEventStockLamps = parseInt(_this3.events.find(function (item) {
          return item._id === _this3.eventId;
        }).numberOfLamps) - deliveryLamps;
      }).catch(function (err) {
        console.log(err);
      });
    },
    resetDatas: function resetDatas() {
      this.eventId = '';
      this.resetCustomer();
      this.resetEvents();
      this.resetLamp();
      this.resetLamps();
    },
    fetchDatas: function fetchDatas() {
      if (this.eventId !== '') {
        this.getLampsStockOfEvent();
      }
      this.fetchUsers();
      this.fetchCustomer();
      this.fetchEvents({
        'where': [{ 'status': 1 }],
        'select': ['_id', 'city', 'reference', 'place', 'startDate', 'status', 'numberOfLamps', 'companyTerms', 'lamp']
      });
    }
  }),

  mounted: function mounted() {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config');
    }
    this.resetDatas();
    this.fetchDatas();
  }
});

/***/ }),

/***/ "+FyI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("xp4f");
function injectStyle (ssrContext) {
  __webpack_require__("vIES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+IUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Igr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"name":_vm.randomName,"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.value === true},on:{"input":function($event){return _vm.$emit('input', true)}}}),_vm._v(" "),_c('span',[_vm._v("Sim")]),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":_vm.randomName},domProps:{"value":_vm.value,"checked":_vm.value === false},on:{"input":function($event){return _vm.$emit('input', false)}}}),_vm._v(" "),_c('span',[_vm._v("Não")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+L3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Roles',
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'roles.index';
    }
  }
});

/***/ }),

/***/ "+NH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+PwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermIasc-energisa-pb',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },


    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Paraíba';
    },
    abbreviation: function abbreviation() {
      return 'Energisa';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },

    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 25',
        neighborhood: 'Cristo Redentor',
        city: 'João Pessoa',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '09.095.183/0001-40';
    },
    numberState: function numberState() {
      return '16.015.823-0';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "+TgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YesNoRadio__ = __webpack_require__("bkdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampEventConfigFormConmponent',
  components: {
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_1__YesNoRadio__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', { modelValidations: 'validations' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* mapFields */])(['numberOfLamps']), {
    event: {
      get: function get() {
        return this.$store.state.events.one;
      }
    }
  })
});

/***/ }),

/***/ "+VkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-celpa-Jurunas',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PA'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "+VxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("18Zw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b1554c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("Kudb");
function injectStyle (ssrContext) {
  __webpack_require__("6Ha9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b1554c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:("progress-bar-" + _vm.type),style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._t("default")],2)]):_vm._l((_vm.values),function(progress){return _c('div',{staticClass:"progress-bar",class:("progress-bar-" + (progress.type)),style:(("width: " + (progress.value) + "%;"))},[_c('span',{staticClass:"sr-only"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Y4W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+a/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disableSendingDocumentation)?_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Enviar documentação"},on:{"click":function($event){return _vm.handleDocumentation()}}},[_c('i',{staticClass:"ti-upload"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ddt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.surveyDoc)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.surveyDoc._id === ''),expression:"surveyDoc._id === ''"}],staticClass:"survey-view-images"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.images),function(image,index){return (_vm.surveyDoc._id !== '')?_c('a',{key:index,attrs:{"href":(_vm.host + "/" + _vm.db + "/" + (_vm.surveyDoc._id) + "/" + image + ".jpg"),"target":"_blank"}},[_c('img',{staticClass:"image-survey",attrs:{"src":(_vm.host + "/" + _vm.db + "/" + (_vm.surveyDoc._id) + "/" + image + ".jpg"),"alt":image}})]):_vm._e()})],2):_c('div',[_c('p',[_vm._v("Nenhuma imagem encontrada para esta pesquisa")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('strong',[_vm._v(" Imagens ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+iY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['requiredText', 'email', 'number', 'url', 'idSource', 'idDestination'])),
  data: function data() {
    return {
      model: {
        requiredText: '',
        email: '',
        number: '',
        url: '',
        idSource: '',
        idDestination: ''
      },
      modelValidations: {
        requiredText: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        number: {
          required: true,
          decimal: true
        },
        url: {
          required: true,
          url: true
        },
        idSource: {
          required: true
        },
        idDestination: {
          required: true,
          confirmed: 'idSource'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "+mNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Paper Dashboard Headings")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Created using "),_c('a',{attrs:{"href":"https://www.google.com/fonts/specimen/Muli"}},[_vm._v("Muli")]),_vm._v(" Font Family\n          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"typo-line"},[_c('h1',[_c('p',{staticClass:"category"},[_vm._v("Header 1")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Header 2")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h3',[_c('p',{staticClass:"category"},[_vm._v("Header 3")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h4',[_c('p',{staticClass:"category"},[_vm._v("Header 4")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h5',[_c('p',{staticClass:"category"},[_vm._v("Header 5")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h6',[_c('p',{staticClass:"category"},[_vm._v("Header 6")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',[_c('span',{staticClass:"category"},[_vm._v("Paragraph")]),_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("\n                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n              ")]),_vm._v(" "),_c('small',[_vm._v("\n                Steve Jobs, CEO Apple\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Coloured Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              Text Primary - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              Text Info - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              Text Success - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              Text Warning - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              Text Danger - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Small Tag")]),_vm._v("Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\".small\" is a tag for the headers")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Lists")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unordered List")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',{staticClass:"list-unstyled"},[_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Ordered List")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unstyled List")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Inline List")]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Blockquotes")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Default Blockquote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Blockquote with Citation")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]),_vm._v(" "),_c('small',[_vm._v("Someone famous in\n                    "),_c('cite',{attrs:{"title":"Source Title"}},[_vm._v("Source Title")])])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Code")]),_vm._v(" "),_c('p',[_vm._v("This is "),_c('code',[_vm._v(".css-class-as-code")]),_vm._v(", an example of an inline code element. Wrap inline code within a "),_c('code',[_vm._v("\n              <code>...</code>")]),_vm._v("tag.")]),_vm._v(" "),_c('pre',[_vm._v("1. #This is an example of preformatted text. 2. #Here is another line of code")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+nA3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+oqb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eventIdSelected: '',
      loading: false,
      progress: 0,
      total: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('events', {
    events: 'sortedByReference'
  }), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', { fetchTickets: 'fetchAll', upsertTickets: 'updateMany', updateMany: 'updateMany' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('events', { findEvent: 'fetchOne', upsertEvent: 'upsert' }), {
    handleRemoveAttachmentFromLamps: function handleRemoveAttachmentFromLamps() {
      var _this = this;

      this.loading = true;
      this.total = 0;
      this.fetchTickets({ where: { eventId: this.eventIdSelected, winner: true }, limit: 9999999 }).then(function (docs) {
        return _this.removeWinnerTrue(docs);
      }).catch(function (err) {
        console.log('failed fetch ticket', err);
      });
    },
    removeWinnerTrue: function removeWinnerTrue(docs) {
      var _this2 = this;

      docs = docs.map(function (item) {
        item.winner = false;
        delete item.rankingNow;
        delete item.rankingOriginal;
        return item;
      });
      this.total = docs.length + 1;
      if (docs.length === 0) {
        this.notifyNotWinners(docs);
      } else {
        this.askConfirmation(docs).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(valid) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!valid) {
                      _context.next = 3;
                      break;
                    }

                    _context.next = 3;
                    return _this2.removeWinners(docs);

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    removeWinners: function removeWinners(docs) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.findEvent(_this3.eventIdSelected);

              case 2:
                event = _context2.sent;

                event.drawn = false;
                docs.push(event);
                _context2.prev = 5;
                _context2.next = 8;
                return _this3.updateMany(docs);

              case 8:
                _this3.notifyFinish();
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                console.log(_context2.t0);
                _this3.notifyFailure(_context2.t0);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 11]]);
      }))();
    },
    notifyNotWinners: function notifyNotWinners(docs) {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Existem ' + docs.length + ' winner=true.',
        text: 'Todos os tickets est\xE3o com "winner = false".',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    askConfirmation: function askConfirmation(docs) {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Existem ' + docs.length + ' winner=true.',
        html: 'Voc\xEA quer setar "winner = false" em todos os tickets?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, faça isso!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      var _this4 = this;

      this.loading = false;
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      }).then(function () {
        _this4.notifyEventUpdated();
      });
    },
    notifyEventUpdated: function notifyEventUpdated() {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        width: 1000,
        title: 'Foi removido sorteio do evento.',
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      });
    },
    notifyFailure: function notifyFailure(err) {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        width: 1000,
        title: 'Ocorreu um erro ao executar essa ação.',
        text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "+qzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signature-customer-ticket',
  props: {
    customer: {}
  }
});

/***/ }),

/***/ "+rP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconsTicketList_vue__ = __webpack_require__("5cHp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52339c88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconsTicketList_vue__ = __webpack_require__("DHuO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconsTicketList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52339c88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconsTicketList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+vOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventPhotos__ = __webpack_require__("ldPe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filesService__ = __webpack_require__("K03o");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__filesService__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_service__ = __webpack_require__("OQ7E");
/* unused harmony namespace reexport */




/***/ }),

/***/ "/0KN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-fill btn-block",attrs:{"type":"submit","disabled":_vm.loading || _vm.unableToSend},on:{"click":function($event){$event.preventDefault();return _vm.handleSelectFile()}}},[_vm._v("\n    Enviar images\n  ")]),_vm._v(" "),_c('input',{ref:"filesContainer",staticClass:"form-control",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/png,image/jpeg","multiple":""},on:{"change":function($event){return _vm.handleFiles($event)}}}),_vm._v(" "),(_vm.filesSelected)?_c('span',[_vm._v(_vm._s(_vm.selectedFiles))]):_vm._e(),_vm._v(" "),(_vm.filesSelected)?_c('button',{staticClass:"btn btn-fill btn-block btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.loading || _vm.unableToSend},on:{"click":function($event){$event.preventDefault();return _vm.handleSaveFiles()}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/0ZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomerCard',

  props: {
    customer: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true,
      type: Boolean
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('users', { users: 'usersIdName', loading: 'loading' }), {
    hasAdditionalData: function hasAdditionalData() {
      return this.customer.hasOwnProperty('address') && this.customer.address.complement && this.customer.address.complement.length > 0;
    },
    phone1: function phone1() {
      return this.customer.hasOwnProperty('phone') && this.customer.phone[0] ? this.customer.phone[0] : this.customer.hasOwnProperty('phone1') ? this.customer.phone1 : '-';
    },
    phone2: function phone2() {
      return this.customer.hasOwnProperty('phone') && this.customer.phone[1] ? this.customer.phone[1] : this.customer.hasOwnProperty('phone2') ? this.customer.phone2 : '-';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll'
  }), {
    editAdditionalData: function editAdditionalData() {
      this.$emit('editAdditionalData', this.customer);
    }
  }),

  mounted: function mounted() {
    this.fetchUsers({ limit: 999 });
  }
});

/***/ }),

/***/ "/7BP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnRunLottery_vue__ = __webpack_require__("PGgh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08381c76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnRunLottery_vue__ = __webpack_require__("cl5G");
function injectStyle (ssrContext) {
  __webpack_require__("vtxa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08381c76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnRunLottery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08381c76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnRunLottery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/DEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.syncRate)+" %\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/GdS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term-enel-go",staticStyle:{"margin":"0.1cm"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.company)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.address)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cpnj)+" e Inscrição Estadual no. "+_vm._s(_vm.stateRegistration)+", doravante denominada "+_vm._s(_vm.shortname)+", e o(a) "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", Ceará, UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto ENEL Comunidades” cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela ENEL;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da ENEL, para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do “ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA” cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(3)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"/static/img/enel-compartilha-logo.gif"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 text-center"},[_c('h3',[_vm._v("Termo Comodato")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto Enel Compartilha Eficiência. O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL está desenvolvendo o \"Enel Compartilha Eficiência\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL buscando viabilizar essa prática nas comunidades atendidas pelo \"Enel Compartilha Eficiência\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da ENEL;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela ENEL ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela ENEL, o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela ENEL em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a ENEL;\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/GfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-list-winners card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Ganhadores ("+_vm._s(_vm.tickets.length)+")")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tickets}},[_c('el-table-column',{attrs:{"label":"Nome","property":"customer"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.customer.holder)+"\n          "),(scope.row.energyMetering)?_c('i',{staticClass:"ti-bolt"}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"UC"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.customer.uc)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":"nota"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.survey && scope.row.survey.data)?[_vm._v(" "+_vm._s(scope.row.survey.data.refrigerator.score)+" ")]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":"Posição"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.rankingNow ? scope.row.rankingNow : scope.row.rankingOriginal)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":"Ação"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button',{staticClass:"btn btn-danger btn-fill btn-icon",attrs:{"title":"Marcar como ausente"},on:{"click":function($event){return _vm.$emit('cancelTicket', scope.row._id)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/NqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc-ma',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Maranhão';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética do Maranhão';
    },
    abbreviation: function abbreviation() {
      return 'CEMAR';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      };
    },
    cnpj: function cnpj() {
      return '06.272.793/0001-84';
    },
    numberState: function numberState() {
      return '06.105.848-3';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "/Nqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5cm"}},[_vm._v("\n    "+_vm._s(_vm.payload.customer.address.city)+", "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new
    Date(),'YYYY'))+"\n  ")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    ________________________________________________________________________\n    "),_c('br'),_vm._v("\n    Assinatura do(a) cliente beneficiado\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Ttc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__ = __webpack_require__("37ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__ = __webpack_require__("Pfw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__ = __webpack_require__("DfKf");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RegisterForm: __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__["a" /* default */],
    TypeValidationForm: __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      registerModel: {},
      loginModel: {},
      typeValidationModel: {}
    };
  },

  methods: {
    onRegisterSubmit: function onRegisterSubmit(model, isValid) {
      this.registerModel = model;
    },
    onLoginSubmit: function onLoginSubmit(model, isValid) {
      this.loginModel = model;
    },
    onTypeValidationSubmit: function onTypeValidationSubmit(model, isValid) {
      this.typeValidationModel = model;
    }
  }
});

/***/ }),

/***/ "/YW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tickets-checkin"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p-search',{staticClass:"input-group input-group-lg",attrs:{"placeholder":"Buscar por código do ticket ..."},on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1)]),_vm._v(" "),(_vm.ticketId)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"margin-top":"50px"}}):_vm._e(),_vm._v(" "),(_vm.ticket && _vm.ticketId)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[(_vm.customer)?_c('customer-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingCustomer),expression:"loadingCustomer"}],attrs:{"customer":_vm.customer,"showEditButton":false}}):_vm._e()],1),_vm._v(" "),(!_vm.loadingCustomer)?_c('div',{staticClass:"col-md-4"},[_c('customer-image-card',{attrs:{"has-image":true,"customer":_vm.customer,"showEditButton":false}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('TicketCard',{attrs:{"ticket":_vm.ticket,"event":_vm.event,"stock":_vm.stock}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-4"},[_c('ticket-actions',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ticket._id),expression:"!ticket._id"}]})],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ticket._id),expression:"!ticket._id"}],staticClass:"col-xs-12"},[_c('DocumentsTicketCard',{attrs:{"ticket-id":_vm.ticketId}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Ygr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ZBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showSwal: function showSwal(type) {
      if (type === 'basic') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
      } else if (type === 'title-and-text') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          text: 'It\'s pretty, isn\'t it?',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info btn-fill'
        });
      } else if (type === 'success-message') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Good job!',
          text: 'You clicked the button!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      } else if (type === 'warning-message-and-confirmation') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        });
      } else if (type === 'warning-message-and-cancel') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            });
          }
        });
      } else if (type === 'custom-html') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'HTML example',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: 'You can use <b>bold text</b>, ' + '<a href="http://github.com">links</a> ' + 'and other HTML tags'
        });
      } else if (type === 'auto-close') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Auto close alert!',
          text: 'I will close in 2 seconds.',
          timer: 2000,
          showConfirmButton: false
        });
      } else if (type === 'input-field') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Input something',
          html: '<div class="form-group">' + '<input id="input-field" type="text" class="form-control" />' + '</div>',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            type: 'success',
            html: 'You entered',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false

          });
        }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop);
      }
    }
  }
});

/***/ }),

/***/ "/bpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__ = __webpack_require__("fd3O");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-cemar',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },
  data: function data() {
    return {
      company: 'CEMAR'
    };
  }
});

/***/ }),

/***/ "/iRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnergisaPb_vue__ = __webpack_require__("W48Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c2dece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnergisaPb_vue__ = __webpack_require__("0uOh");
function injectStyle (ssrContext) {
  __webpack_require__("hiwl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11c2dece"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnergisaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c2dece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnergisaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/ijB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_pages_Customers_CustomerCard__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);











__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'replacement-customer',

  props: ['oldWinner', 'tickets', 'automatic', 'replacementCustomerSync', 'customers'],

  components: {
    CustomerCard: __WEBPACK_IMPORTED_MODULE_6_src_pages_Customers_CustomerCard__["a" /* default */]
  },

  data: function data() {
    return {
      replacedCustomer: false,
      newWinner: { address: {} },
      filter: '',
      dataTable: []
    };
  },


  computed: {
    ticketsNotWinner: function ticketsNotWinner() {
      var _this = this;

      return this.tickets.filter(function (obj) {
        var invalid = obj.winner || !obj.eligible || !_this.customers[obj.customerId] || _this.customers[obj.customerId] && _this.customers[obj.customerId].contemplated;
        if (_this.isEventRanking) {
          invalid = invalid || !_this.surveyValid(_this.isTicketSurveyed(obj)) || obj.hasOwnProperty('canceledAt');
        }
        return !invalid;
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', ['replaceTicketWinner']), {
    filtering: function filtering() {
      var _this2 = this;

      if (this.filter === '') {
        this.dataTable = this.ticketsNotWinner;
      } else {
        console.log('passou 1');
        this.dataTable = this.ticketsNotWinner.filter(function (item) {
          return _this2.customers[item.customerId] && (_this2.customers[item.customerId].uc.indexOf(_this2.filter) !== -1 || _this2.customers[item.customerId].cpf.indexOf(_this2.filter) !== -1 || _this2.customers[item.customerId].holder.indexOf(_this2.filter) !== -1) || _this2.customers[item.customerId].holder.indexOf(_this2.filter.toUpperCase()) !== -1 || _this2.customers[item.customerId].holder.indexOf(_this2.filter.toLowerCase()) !== -1;
        });
      }
    },
    handleReplacement: function handleReplacement(random, row) {
      var _this3 = this;

      if (random) {
        var idx = Math.floor(Math.random() * this.ticketsNotWinner.length);
        this.newWinner = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ticketsNotWinner[idx]);
      } else {
        this.newWinner = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.tickets.find(function (item) {
          return row._id === item._id;
        }));
      }

      var obj = { oldWinner: this.oldWinner, newWinner: this.newWinner };

      this.replaceTicketWinner(obj).then(function () {
        _this3.replacedCustomer = true;
        _this3.$notify({
          message: 'Cliente substituído com sucesso',
          type: 'success'
        });
      }).catch(function (err) {
        console.log(err);
        _this3.$notify({
          message: 'Ocorreu algum problema com a substituição.',
          type: 'error'
        });
      });
    },
    printTicket: function printTicket() {
      this.$emit('handleTicketPrint', 0, this.newWinner);
    }
  }),

  mounted: function mounted() {
    this.dataTable = this.ticketsNotWinner;
  },


  watch: {
    oldWinner: function oldWinner() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.replacedCustomer = false;
        _this4.newWinner = { address: {} };
      });
    }
  }
});

/***/ }),

/***/ "/pma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsList_vue__ = __webpack_require__("C/Uu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501633bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsList_vue__ = __webpack_require__("xLa7");
function injectStyle (ssrContext) {
  __webpack_require__("GJfy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-501633bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501633bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/rxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewGeneral_vue__ = __webpack_require__("vq0W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d5cfdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewGeneral_vue__ = __webpack_require__("XuXG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewGeneral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d5cfdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__("gkTP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("X/gF");
function injectStyle (ssrContext) {
  __webpack_require__("qoDK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/Bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['login', 'password'])),
  data: function data() {
    return {
      model: {
        login: '',
        password: ''
      },
      modelValidations: {
        login: {
          required: true,
          min: 5
        },
        password: {
          required: true,
          min: 5
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.model, isValid);
      });
    }
  }
});

/***/ }),

/***/ "01T7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.nameField),expression:"modelValidations.nameField"},{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nameField.invalid),expression:"nameField.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('nameField'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Login")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loginField),expression:"modelValidations.loginField"},{name:"model",rawName:"v-model.trim",value:(_vm.login),expression:"login",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"login"},domProps:{"value":(_vm.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.login=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginField.invalid),expression:"loginField.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('loginField'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.editing ? 'Nova Senha' : 'Senha'))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordField),expression:"modelValidations.passwordField"},{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordField.invalid),expression:"passwordField.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('passwordField'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.editing ? 'Confirmar Nova Senha' : 'Confirmar Senha')+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.confirmPassword),expression:"confirmPassword",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","name":"confirm"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:" row form-group"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Função do usuário")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.roleField),expression:"modelValidations.roleField"}],ref:"selectRole",staticClass:"select-primary",attrs:{"size":"large","name":"role"},on:{"change":_vm.changingRole},model:{value:(_vm.roleValue),callback:function ($$v) {_vm.roleValue=$$v},expression:"roleValue"}},_vm._l((_vm.rolesOptions),function(item,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.roleField.invalid),expression:"roleField.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('roleField'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.handleSave($event)}}},[_vm._v("Salvar\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(" Novo Usuário ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Bz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0Bzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("hPou");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f3063c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("T+Bo");
function injectStyle (ssrContext) {
  __webpack_require__("jTFk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f3063c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0CkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsTicketCard_vue__ = __webpack_require__("WuZ6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50a15e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsTicketCard_vue__ = __webpack_require__("xzFs");
function injectStyle (ssrContext) {
  __webpack_require__("my3Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f50a15e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsTicketCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50a15e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsTicketCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0D/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('vue-csv-import',{attrs:{"map-fields":_vm.mapFields},scopedSlots:_vm._u([{key:"hasHeaders",fn:function(ref){
var headers = ref.headers;
var toggle = ref.toggle;
return [_c('label',[_c('input',{attrs:{"type":"checkbox","id":"hasHeaders"},domProps:{"value":headers},on:{"change":toggle}}),_vm._v("\n      O arquivo tem cabeçalhos?\n    ")])]}},{key:"next",fn:function(ref){
var load = ref.load;
return [_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",on:{"click":function($event){$event.preventDefault();return load($event)}}},[_vm._v("\n      Carregar arquivo\n    ")])]}}]),model:{value:(_vm.customers),callback:function ($$v) {_vm.customers=$$v},expression:"customers"}},[_vm._v(" "),_c('template',{slot:"thead"},[_c('tr',[_c('th',[_vm._v("Campo")]),_vm._v(" "),_c('th',[_vm._v("Referência no arquivo")])])])],2),_vm._v(" "),(_vm.customers.length)?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",on:{"click":function($event){return _vm.handleImport()}}},[_vm._v("\n    Importar Clientes\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'content-footer',
  computed: {
    versionNumber: function versionNumber() {
      return "1.43.1" || '';
    }
  }
});

/***/ }),

/***/ "0Hx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingProject || _vm.loadingCustomer || _vm.loadingEvent || _vm.loadingTicket)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100vh","width":"100%"}},[_c('h3',[_vm._v("Carregando....")])]):_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('DocLocalDate',{attrs:{"city":_vm.event.city}})],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('p',{staticStyle:{"font-size":"16pt","font-weight":"bold"}},[_vm._v("CONFIRMAÇÃO DE CADASTRO – "+_vm._s(_vm.project.name))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("\n      O "+_vm._s(_vm.project.name)+" oferece diversos serviços e benefícios para a comunidade. Você se inscreveu para\n      participar da TROCA DE GELADEIRAS velhas por novas, tudo sem custo para você. Vale lembrar que a quantidade de\n      geladeiras a serem trocadas serão limitadas, por isso, será realizado um processo de seleções com as seguintes\n      etapas:\n    ")])]),_vm._v(" "),_c('div',[_c('ol',[_vm._m(0),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Avaliação do estado de conservação da geladeira.")]),_vm._v("\n        O processo será realizado por um dos nossos Agentes Comunitários que visitará sua residência nos próximos "+_vm._s(_vm.event.doc.daysToVisit)+"\n        dias, devidamente fardados, identificado com crachá e carteira de identidade, para sua segurança.\n      ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Cerimônia de divulgação:")]),_vm._v("\n        Os clientes contemplados serão divulgados no dia "+_vm._s(_vm.event.dateTimeCeremony.toLocaleString('pt-BR', {year:
        'numeric', month: 'long', day: '2-digit'}))+", a partir das 17:00 horas\n        no endereço: "+_vm._s(_vm.event.doc.deliveryAddress)+".\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          É obrigatório que você esteja presente nesse dia ou mande um representante portando este documento, a última\n          conta de energia, documentos originais do titular com foto sob pena de perda do benefício.\n        ")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Troca da geladeira.")]),_vm._v("\n        Os clientes contemplados deverão levar a geladeira velha, avaliada pelo AGENTE COMUNITÁRIO, no dia "+_vm._s(_vm.event.dateTimeDelivery.toLocaleString('pt-BR', {year: 'numeric', month: 'long', day: '2-digit'}))+_vm._s(_vm.event.timeEndDelivery !== '' ? ' às '
        + _vm.event.timeEndDelivery : '')+",\n        com lacre de vistoria intacto até o local do evento e retirar a geladeira nova.\n      ")])])]),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"font-size":"14pt"}},[_vm._v("Cliente")]),_vm._v(" "),_c('p',[_vm._v("Nome: "+_vm._s(_vm.customer.holder))]),_vm._v(" "),_c('p',[_vm._v("Telefone: "+_vm._s(_vm.customer.phones.join(',')))]),_vm._v(" "),_c('p',[_vm._v("CPF: "+_vm._s(_vm.customer.cpf))]),_vm._v(" "),_c('p',[_vm._v("Endereço: "+_vm._s(_vm.addressCustomer))]),_vm._v(" "),_c('p',[_vm._v("UC: "+_vm._s(_vm.customer.uc))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"1cm"}},[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.customer}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',[_c('StagesTableTicket')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('strong',[_vm._v("Inscrição e cadastro:")]),_vm._v(" Esta etapa você já participou;\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('strong',[_vm._v("Seleção das geladeiras:")]),_vm._v("\n        Será feita através da avaliação do sistema que gera um ranking das geladeiras em pior estado de conservação.\n        Essas serão substituídas por geladeiras novas.\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"right"}},[_c('p',[_vm._v("\n      Agradecemos a sua participação!\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0MZc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0O1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIasc_vue__ = __webpack_require__("yk0F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d38448_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIasc_vue__ = __webpack_require__("oGAo");
function injectStyle (ssrContext) {
  __webpack_require__("lAgc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81d38448"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d38448_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Qzi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0W5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncIndex_vue__ = __webpack_require__("NQku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7af6a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncIndex_vue__ = __webpack_require__("19II");
function injectStyle (ssrContext) {
  __webpack_require__("OzZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f7af6a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7af6a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0iWr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-list-winners',

  props: ['tickets']
});

/***/ }),

/***/ "0nFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse',{staticClass:"dashboard-collapse"},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n    Inserir ícones por tags\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('InputRadioIconRefrigeratoMap',{model:{value:(_vm.icon),callback:function ($$v) {_vm.icon=$$v},expression:"icon"}})],1)]),_vm._v(" "),_c('dashboard-form-filters',{attrs:{"showTimeRange":false,"buttom-label":"Aplicar"},on:{"filter":_vm.handleSave}})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0pFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'stock.index';
    }
  }
});

/***/ }),

/***/ "0pTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEquatorialPi_vue__ = __webpack_require__("jDdv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_089adad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEquatorialPi_vue__ = __webpack_require__("KHLO");
function injectStyle (ssrContext) {
  __webpack_require__("Z9M6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-089adad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEquatorialPi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_089adad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEquatorialPi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0pu4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0uOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0vcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0y/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wd btn-fill btn-info",attrs:{"disabled":(_vm.loading || !_vm.eventSelected)},on:{"click":function($event){return _vm.runReport()}}},[_vm._v("\n  Gerar relatório simplificado de lâmpadas\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "11YL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15zP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesIndex_vue__ = __webpack_require__("R5z8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd2c8ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesIndex_vue__ = __webpack_require__("XVkx");
function injectStyle (ssrContext) {
  __webpack_require__("Jir4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cd2c8ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd2c8ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "18Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '<span>Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web developer.</span>'
        },
        icon: 'ti-gift',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
});

/***/ }),

/***/ "19II":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync-index"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isRunningAdmin === true),expression:"isRunningAdmin === true"}]},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",on:{"click":function($event){return _vm.startReplication('admin')}}},[_vm._v("\n          Iniciar Sincronia do Banco Admin\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isRunningDocs === true),expression:"isRunningDocs === true"}]},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",on:{"click":function($event){return _vm.startReplication('docs')}}},[_vm._v("\n          Iniciar Sincronia do Banco de Documentos\n        ")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.jobs.length > 0)?_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.jobs}},[_c('el-table-column',{attrs:{"prop":"source","label":"Banco"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"state","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        Em andamento\n      ")]}}],null,false,201047695)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"start_time","label":"Iniciado Em"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("moment")(new Date(scope.row.start_time),'DD/MM/YYYY HH:mm:ss'))+"\n      ")]}}],null,false,1840369627)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1AW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Api_ApiForm_vue__ = __webpack_require__("B10d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Api_Index_vue__ = __webpack_require__("AN/r");



/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'api',
  component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Api_Index_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'api.index',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Api_ApiForm_vue__["a" /* default */],
    meta: {
      title: 'Api',
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "1D+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsForm_vue__ = __webpack_require__("FFYg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af776fae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsForm_vue__ = __webpack_require__("WXMB");
function injectStyle (ssrContext) {
  __webpack_require__("72C5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af776fae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1EED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StagesTableTicket'
});

/***/ }),

/***/ "1ERB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsConfigForm_vue__ = __webpack_require__("OJEp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e86b70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsConfigForm_vue__ = __webpack_require__("QZfc");
function injectStyle (ssrContext) {
  __webpack_require__("ABlU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63e86b70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsConfigForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e86b70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsConfigForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1I2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"replacement-customer"},[(_vm.replacedCustomer)?_c('h5',[_vm._v("Removido")]):_vm._e(),_vm._v(" "),_c('CustomerCard',{attrs:{"show-edit-button":false,"customer":_vm.customers[_vm.oldWinner.customerId]}}),_vm._v(" "),(_vm.replacedCustomer)?_c('div',[_c('h5',[_vm._v("Novo ganhador")]),_vm._v(" "),_c('CustomerCard',{attrs:{"show-edit-button":false,"customer":_vm.customers[_vm.newWinner.customerId]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center"},[(_vm.newWinner.stockId)?_c('router-link',{attrs:{"to":{name: 'tickets.documentation', params: {id: _vm.newWinner._id }}}},[_c('a',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Enviar documentação"}},[_c('i',{staticClass:"ti-upload"})])]):_vm._e(),_vm._v(" "),(_vm.newWinner.stockId)?_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Imprimir documentação"},on:{"click":function($event){return _vm.handleDocumentsPrint(0, _vm.newWinner)}}},[_c('i',{staticClass:"ti-files"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Imprimir ticket"},on:{"click":function($event){return _vm.printTicket()}}},[_c('i',{staticClass:"ti-receipt"})])],1)])],1):_vm._e(),_vm._v(" "),(!_vm.replacedCustomer)?_c('div',[(_vm.automatic)?_c('div',[_c('div',{staticClass:"row text-right"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-fill btn-primary btn-wd",on:{"click":function($event){return _vm.handleReplacement(true)}}},[_vm._v(" Substituir Aleatoriamente ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"action":"#"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.filter),expression:"filter",modifiers:{"trim":true}}],attrs:{"type":"text"},domProps:{"value":(_vm.filter)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.filtering()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-primary btn-wd",attrs:{"type":"button"},on:{"click":function($event){return _vm.filtering()}}},[_vm._v(" Buscar ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('el-table',{attrs:{"data":_vm.dataTable}},[_c('el-table-column',{attrs:{"property":"holder","label":"Nome","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm.customers[props.row.customerId].holder))]}}],null,false,1723160083)}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"uc","label":"UC","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm.customers[props.row.customerId].uc))]}}],null,false,1368553757)}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"cpf","label":"CPF"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm.customers[props.row.customerId].cpf))]}}],null,false,233496926)}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"_id","label":"Ações"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button',{staticClass:"btn btn-fill btn-primary btn-wd",on:{"click":function($event){return _vm.handleReplacement(false, scope.row)}}},[_vm._v(" Substituir ")])]}}],null,false,1115896210)})],1)],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Kn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('roles.create|roles.edit', _vm.user))?_c('div',{staticClass:"permissions-form",attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-xs-12"},[_c('p',{staticStyle:{"font-size":"2em"}},[_vm._v("\n        Perfil\n        "),(_vm.isNewRole)?_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.role.label),expression:"role.label",modifiers:{"trim":true}}],attrs:{"type":"text"},domProps:{"value":(_vm.role.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.role, "label", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}):_c('span',[_vm._v(_vm._s(_vm.role.label))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xs-12 text-right"},[_c('button',{staticClass:"btn btn-fill btn-wd btn-primary",attrs:{"disabled":_vm.saving},on:{"click":function($event){return _vm.handleSave()}}},[_vm._v("Salvar\n      ")])])]),_vm._v(" "),_vm._l((_vm.permissions),function(module,indexModule){return _c('div',{key:indexModule},[_c('h3',[_vm._v(_vm._s(module.label))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((module.subModules),function(subModule,indexSubModule){return _c('div',{key:indexSubModule,staticClass:"col-lg-3 col-md-6 col-xs-12"},[_c('h5',[_vm._v(_vm._s(subModule.label)+" ")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","id":subModule.label},on:{"change":function($event){_vm.checkAll(subModule.permissions.map(function (permission) { return permission.value }), $event)}}}),_vm._v(" "),_c('label',{attrs:{"for":subModule.label}},[_vm._v("Marcar / Desmarcar todos")])]),_vm._v(" "),_vm._l((subModule.permissions),function(permission,index){return _c('div',{key:index,staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.role.permissions),expression:"role.permissions"}],attrs:{"type":"checkbox","id":permission.value},domProps:{"value":permission.value,"checked":Array.isArray(_vm.role.permissions)?_vm._i(_vm.role.permissions,permission.value)>-1:(_vm.role.permissions)},on:{"change":function($event){var $$a=_vm.role.permissions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=permission.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.role, "permissions", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.role, "permissions", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.role, "permissions", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":permission.value}},[_vm._v(_vm._s(permission.label))])])})],2)}),0)])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1OnC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Uua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("dREt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f71a4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("7C4b");
function injectStyle (ssrContext) {
  __webpack_require__("lwkl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06f71a4d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f71a4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");







var WorldMap = function WorldMap() {
  return {
    component: __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "1p4m")),
    loading: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 200
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    WorldMap: WorldMap
  },
  data: function data() {
    return {
      statsCards: [{
        type: 'warning',
        icon: 'ti-server',
        title: 'Capacity',
        value: '105GB',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }, {
        type: 'success',
        icon: 'ti-wallet',
        title: 'Revenue',
        value: '$1,345',
        footerText: 'Last day',
        footerIcon: 'ti-calendar'
      }, {
        type: 'danger',
        icon: 'ti-pulse',
        title: 'Errors',
        value: '23',
        footerText: 'In the last hour',
        footerIcon: 'ti-timer'
      }, {
        type: 'info',
        icon: 'ti-twitter-alt',
        title: 'Followers',
        value: '+45',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }],
      earningsChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
          series: [[230, 340, 400, 300, 570, 500, 800]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-green'
          }
        }
      }

    };
  }
});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Inputs_Search_vue__ = __webpack_require__("yntV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Layout_ActionsTableLayout__ = __webpack_require__("Rjzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Layout_RouterButton__ = __webpack_require__("kcVo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Layout_ActionButtonClickStateless__ = __webpack_require__("k6dT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Layout_ActionButtonClick__ = __webpack_require__("LPmA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_StatelessFactory__ = __webpack_require__("+2e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Trg_RadioColors_RadioColors__ = __webpack_require__("yuLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_Helper__ = __webpack_require__("leRe");
















var elementUi = __webpack_require__("zL8q");
var elementUiComponents = [];
for (var el in elementUi) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_Helper__["d" /* isFunction */])(elementUi[el])) {
    continue;
  }
  if (!elementUi[el].hasOwnProperty('name')) {
    continue;
  }
  elementUiComponents.push({
    name: elementUi[el].name,
    component: elementUi[el]
  });
}


var GlobalComponents = {
  install: function install(Vue) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elementUiComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var component = _step.value;

        Vue.component(component.name, component.component);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    Vue.component(__WEBPACK_IMPORTED_MODULE_11_src_components_StatelessFactory__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11_src_components_StatelessFactory__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_12_src_components_Trg_RadioColors_RadioColors__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12_src_components_Trg_RadioColors_RadioColors__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7_src_components_Layout_ActionsTableLayout__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7_src_components_Layout_ActionsTableLayout__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_8_src_components_Layout_RouterButton__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8_src_components_Layout_RouterButton__["a" /* default */]);

    Vue.component(__WEBPACK_IMPORTED_MODULE_9_src_components_Layout_ActionButtonClickStateless__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9_src_components_Layout_ActionButtonClickStateless__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_10_src_components_Layout_ActionButtonClick__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10_src_components_Layout_ActionButtonClick__["a" /* default */]);

    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Pagination_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Pagination_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Inputs_Search_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Inputs_Search_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "1nM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1uw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenNewPresenter_vue__ = __webpack_require__("6KSH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fddbb8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenNewPresenter_vue__ = __webpack_require__("qsZe");
function injectStyle (ssrContext) {
  __webpack_require__("oHZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fddbb8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenNewPresenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fddbb8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenNewPresenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+nh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Customers_CustomerDetail__ = __webpack_require__("L1yC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Customers_Customers_vue__ = __webpack_require__("wZqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomersForm_vue__ = __webpack_require__("iFH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Customers_CustomersIndex_vue__ = __webpack_require__("R9H5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Lamps_IndexLamps_vue__ = __webpack_require__("k5IP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketsIndex__ = __webpack_require__("nEwB");







var path = 'customers';
var title = 'Clientes';
/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Customers_Customers_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_3_src_pages_Customers_CustomersIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: ':id/lamps',
    name: path + '.lamps',
    component: __WEBPACK_IMPORTED_MODULE_4_src_pages_Lamps_IndexLamps_vue__["a" /* default */],
    meta: {
      title: 'Troca de Lâmpadas',
      requireAuth: true
    }
  }, {
    path: ':id/tickets',
    name: path + '.tickets',
    component: __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketsIndex__["a" /* default */],
    meta: {
      title: 'Ticket',
      requireAuth: true
    }
  }, {
    path: 'details/:id',
    name: 'customer.detail',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Customers_CustomerDetail__["a" /* default */],
    meta: {
      title: 'Detalhes do Cliente',
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "20hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defineApiEduPost;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiEduService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var baseApiUrl = 'https://educacional-pb.3eengenharia.com.br/api/';


__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = baseApiUrl;

function getAll(dateRange, tags) {
  var query = createQuery('events', { dateRange: dateRange, tags: tags });
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(query).then(function (res) {
    return res.data;
  }).catch(function (err) {
    return err;
  });
}

function createQuery(url, _ref) {
  var dateRange = _ref.dateRange,
      tags = _ref.tags;

  if (dateRange) {
    url += 'startDate=' + dateRange[0] + '&endDate=' + dateRange[1];
  }
  if (tags && tags.length !== 0) {
    url += '&tags=';
    tags.forEach(function (tag) {
      url += tag + ',';
    });
  }
  return url;
}

function getCountSpeeches(_ref2) {
  var dateRange = _ref2.dateRange,
      tags = _ref2.tags;

  console.log('speeches', dateRange, tags);
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('speeches', { dateRange: dateRange, tags: tags }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    return err;
  });
}

function getCountEvents(_ref3) {
  var dateRange = _ref3.dateRange,
      tags = _ref3.tags;

  console.log('events', dateRange, tags);
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('events', { dateRange: dateRange, tags: tags }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    return err;
  });
}

function defineApiEduPost(tags, tagsObj) {
  var tagNames = {};
  for (var categorie in tags) {
    tagNames[categorie] = getTagsNameFromCategorie(tags[categorie], tagsObj);
  }
  return tagNames;
}

var getTagsNameFromCategorie = function getTagsNameFromCategorie(tagsCategorie, tagsObj) {
  var tagNames = [];

  var _loop = function _loop(tagId) {
    var tagDoc = tagsObj.find(function (item) {
      return item._id === tagId;
    });
    if (!tagDoc) return 'continue';
    tagNames.push(tagDoc.name);
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tagsCategorie), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tagId = _step.value;

      var _ret = _loop(tagId);

      if (_ret === 'continue') continue;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return tagNames;
};

var apiEduService = {
  getAll: getAll,
  getCountSpeeches: getCountSpeeches,
  getCountEvents: getCountEvents
};

/***/ }),

/***/ "23/3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "26Lh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPhotosEvent_vue__ = __webpack_require__("ABcX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69db5461_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPhotosEvent_vue__ = __webpack_require__("lC0j");
function injectStyle (ssrContext) {
  __webpack_require__("+iY/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69db5461"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadPhotosEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69db5461_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadPhotosEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2FHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketsDocumentationsPrint_vue__ = __webpack_require__("ZZ2d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6ebfa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketsDocumentationsPrint_vue__ = __webpack_require__("bMjG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketsDocumentationsPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6ebfa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketsDocumentationsPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2SCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('time-line',[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n        11 hours ago via Twitter\n      ")])]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"success","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"info","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n          Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n          What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","href":"#","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"warning","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-warning",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Wue":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Yyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Stock_Stock_vue__ = __webpack_require__("46N4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Stock_StockForm_vue__ = __webpack_require__("IQ/n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Stock_StockIndex_vue__ = __webpack_require__("xAEP");




var path = 'stock';
var title = 'Estoque';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Stock_Stock_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Stock_StockIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Stock_StockForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Stock_StockForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb96846_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("FMOo");
function injectStyle (ssrContext) {
  __webpack_require__("rlIa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb96846_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2dMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'events.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2fI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Manufacturers_Manufacturers_vue__ = __webpack_require__("ICub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Manufacturers_ManufacturersForm_vue__ = __webpack_require__("c/JZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Manufacturers_ManufacturersIndex_vue__ = __webpack_require__("e8bN");




var path = 'manufacturers';
var title = 'Fabricantes';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Manufacturers_Manufacturers_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Manufacturers_ManufacturersIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Manufacturers_ManufacturersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Manufacturers_ManufacturersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "2ic5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnTicketsConfirm_vue__ = __webpack_require__("pJSd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260a9950_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnTicketsConfirm_vue__ = __webpack_require__("X4HA");
function injectStyle (ssrContext) {
  __webpack_require__("cBRn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-260a9950"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnTicketsConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260a9950_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnTicketsConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2lXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyStatusIcons__ = __webpack_require__("SPf8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UsersOptions__ = __webpack_require__("qYwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SurveyCustomerActions__ = __webpack_require__("k0bX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SurveyCustomerContent__ = __webpack_require__("EYrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-tickets-list-to-associate',

  props: {
    filters: {
      required: true,
      default: {
        status: [],
        neighborhood: [],
        users: []
      }
    },
    clean: {
      default: 1
    },
    surveysProp: {
      required: true,
      default: {}
    },
    tickets: { required: true },
    customers: { required: true }
  },

  components: {
    UsersOptions: __WEBPACK_IMPORTED_MODULE_3_src_components_UsersOptions__["a" /* default */],
    SurveyCustomerContent: __WEBPACK_IMPORTED_MODULE_5__SurveyCustomerContent__["a" /* default */],
    SurveyCustomerActions: __WEBPACK_IMPORTED_MODULE_4__SurveyCustomerActions__["a" /* default */],
    SurveyStatusIcons: __WEBPACK_IMPORTED_MODULE_2__SurveyStatusIcons__["a" /* default */]
  },

  data: function data() {
    return {
      indexTicketsChosen: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('users', {
    users: 'users'
  }), {
    surveys: function surveys() {
      return this.surveysProp.reduce(function (acc, curr, index) {
        if (index === 0) {
          acc = {};
        }
        acc[curr.ticketId] = curr;
        return acc;
      }, {});
    },
    ticketsFiltered: function ticketsFiltered() {
      var _this = this;

      return this.tickets.filter(function (ticket) {
        var surveyFound = _this.surveys[ticket._id];
        var ifFilterAssociate = true;
        var ifFilterNotAssociated = true;
        var ifFilterSurveyed = true;
        var ifFilterNotSurveyed = true;
        var ifFilterNeighborhood = true;
        var ifFilterUsers = true;

        if (_this.filters.hasOwnProperty('status')) {
          if (_this.filters.status.indexOf('associated') !== -1) {
            ifFilterAssociate = ticket.surveyAssociated;
          }
          if (_this.filters.status.indexOf('notAssociated') !== -1) {
            ifFilterNotAssociated = !ticket.surveyAssociated;
          }
          if (_this.filters.status.indexOf('surveyed') !== -1) {
            ifFilterSurveyed = surveyFound && surveyFound.hasOwnProperty('data') && ['FINISHED', 'SYNCED'].indexOf(surveyFound.status) !== -1;
          }
          if (_this.filters.status.indexOf('notSurveyed') !== -1) {
            ifFilterNotSurveyed = !surveyFound || surveyFound.status === 'TODO';
          }
        }
        if (_this.filters.hasOwnProperty('neighborhood')) {
          ifFilterNeighborhood = _this.filters.neighborhood.length === 0 || _this.filters.neighborhood.indexOf(_this.customers[ticket.customerId].address.neighborhood) !== -1;
        }
        if (_this.filters.hasOwnProperty('users')) {
          ifFilterUsers = _this.filters.users.length === 0 || _this.filters.users.indexOf(surveyFound.user._id) !== -1;
        }

        return ifFilterAssociate && ifFilterNotAssociated && ifFilterSurveyed && ifFilterNotSurveyed && ifFilterNeighborhood && ifFilterUsers;
      });
    }
  }),

  watch: {
    filters: function filters() {
      this.cleanCheckboxes();
    },
    clean: function clean() {
      this.cleanCheckboxes();
    }
  },

  methods: {
    emitSurveyDocuments: function emitSurveyDocuments() {
      this.$emit('surveyDocuments', this.createNewSurveyDocuments());
    },
    createNewSurveyDocuments: function createNewSurveyDocuments() {
      var _this2 = this;

      return this.tickets.filter(function (item) {
        return _this2.indexTicketsChosen.indexOf(item._id) >= 0;
      }).map(function (ticket) {
        return _this2.createNewSurveyDocument(ticket);
      });
    },
    createNewSurveyDocument: function createNewSurveyDocument(ticket) {
      return {
        ticket: ticket,
        ticketId: ticket._id,
        customer: this.mapCustomerFromTicket(this.customers[ticket.customerId]),
        data: {},
        status: 'TODO'
      };
    },
    mapCustomerFromTicket: function mapCustomerFromTicket(customer) {
      return {
        _id: customer._id,
        holder: customer.holder,
        uc: customer.uc,
        cpf: customer.cpf,
        nationalId: customer.nationalId,
        address: customer.address,
        phones: customer.phones
      };
    },
    clickCheckTicket: function clickCheckTicket(id) {
      var index = 'ref-' + id;
      if (this.$refs[index]) {
        if (this.$refs[index][0].checked) {
          this.indexTicketsChosen.push(id);
        } else {
          this.indexTicketsChosen.splice(this.indexTicketsChosen.indexOf(id), 1);
        }
        this.emitSurveyDocuments();
      }
    },
    clickCheckAllTickets: function clickCheckAllTickets() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs.checkAllTicket.checked) {
          _this3.checkAllBoxs();
        } else {
          _this3.cleanCheckboxes();
        }
        _this3.emitSurveyDocuments();
      });
    },
    getUserAssociated: function getUserAssociated(ticketId) {
      var survey = this.surveys[ticketId];
      if (!survey) {
        return '-';
      }
      var user = this.users.find(function (item) {
        return item._id === survey.user._id;
      });
      return user ? user.name : '-';
    },
    cleanCheckboxes: function cleanCheckboxes() {
      this.indexTicketsChosen = [];
      this.$refs.checkAllTicket.checked = false;
      this.checkAllBoxs();
    },
    checkAllBoxs: function checkAllBoxs() {
      this.indexTicketsChosen = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.ticketsFiltered), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ticket = _step.value;

          var index = 'ref-' + ticket._id;
          if (this.$refs[index] && this.$refs[index][0]) {
            if (this.$refs.checkAllTicket.checked) {
              this.indexTicketsChosen.push(ticket._id);
            }
            this.$refs[index][0].checked = this.$refs.checkAllTicket.checked;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    surveysFound: function surveysFound(ticket) {
      var survey = this.surveys[ticket._id];
      return survey && (survey.status === 'SYNCED' || survey.status === 'FINISHED');
    }
  }
});

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2s9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsReport_vue__ = __webpack_require__("eubD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a4003c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsReport_vue__ = __webpack_require__("cWPn");
function injectStyle (ssrContext) {
  __webpack_require__("Ekgi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a4003c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a4003c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnelCe_DeliveryTermEnelCe__ = __webpack_require__("rrBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnelGo_DeliveryTermEnelGo__ = __webpack_require__("Q0ee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cemar_DeliveryTermCemar__ = __webpack_require__("PkbC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IascPi_DeliveryTermIasc__ = __webpack_require__("i2QB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IascAl_DeliveryTermIasc__ = __webpack_require__("r1X7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IascMa_DeliveryTermIasc__ = __webpack_require__("fnNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnergisaPb_DeliveryTermEnergisaPb__ = __webpack_require__("QtJQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnergisaBorboremaPb_DeliveryTermEnergisaBorboremaPb__ = __webpack_require__("WrSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Celpa_DeliveryTermCelpa__ = __webpack_require__("73g5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EquatorialPi_DeliveryTermEquatorialPi__ = __webpack_require__("0pTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CelpaJurunas_DeliveryTermCelpaJurunas__ = __webpack_require__("HsA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Trg_Terms_DeliveryTermGeneric__ = __webpack_require__("SdWi");















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term',
  components: {
    DeliveryTermGeneric: __WEBPACK_IMPORTED_MODULE_11__components_Trg_Terms_DeliveryTermGeneric__["a" /* default */],
    DeliveryTermCelpaJurunas: __WEBPACK_IMPORTED_MODULE_10__CelpaJurunas_DeliveryTermCelpaJurunas__["a" /* default */],
    DeliveryTermEquatorialPi: __WEBPACK_IMPORTED_MODULE_9__EquatorialPi_DeliveryTermEquatorialPi__["a" /* default */],
    DeliveryTermEnelCe: __WEBPACK_IMPORTED_MODULE_0__EnelCe_DeliveryTermEnelCe__["a" /* default */],
    DeliveryTermCemar: __WEBPACK_IMPORTED_MODULE_2__Cemar_DeliveryTermCemar__["a" /* default */],
    DeliveryTermEnelGo: __WEBPACK_IMPORTED_MODULE_1__EnelGo_DeliveryTermEnelGo__["a" /* default */],
    DeliveryTermIascPi: __WEBPACK_IMPORTED_MODULE_3__IascPi_DeliveryTermIasc__["a" /* default */],
    DeliveryTermIascAl: __WEBPACK_IMPORTED_MODULE_4__IascAl_DeliveryTermIasc__["a" /* default */],
    DeliveryTermIascMa: __WEBPACK_IMPORTED_MODULE_5__IascMa_DeliveryTermIasc__["a" /* default */],
    DeliveryTermEnergisaPb: __WEBPACK_IMPORTED_MODULE_6__EnergisaPb_DeliveryTermEnergisaPb__["a" /* default */],
    DeliveryTermEnergisaBorboremaPb: __WEBPACK_IMPORTED_MODULE_7__EnergisaBorboremaPb_DeliveryTermEnergisaBorboremaPb__["a" /* default */],
    DeliveryTermCelpa: __WEBPACK_IMPORTED_MODULE_8__Celpa_DeliveryTermCelpa__["a" /* default */]
  },
  props: {
    ticket: { required: true },
    manufacturer: { required: true },
    config: { required: true },
    stock: { required: true },
    customer: { required: true },
    companyTerms: { required: true },
    dateTimeDelivery: { required: true }
  },

  computed: {
    state: function state() {
      return this.config.state || false;
    }
  }
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "30zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-categories',

  data: function data() {
    return {
      name: '',
      apiEdu: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('categories', ['categorie']), {
    id: function id() {
      return this.$route.params.id;
    },

    title: function title() {
      return this.id ? 'Editar' : 'Novo';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('categories', {
    upsert: 'upsert',
    fetchCategorie: 'fetchOne',
    resetOne: 'resetOne'
  }), {
    handleSave: function handleSave() {
      var _this = this;

      return this.upsert(this.setDoc()).then(function (res) {
        _this.$router.push({ name: 'categories.index' });
      });
    },
    setDoc: function setDoc() {
      var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.categorie);
      if (this.id) {
        doc['_id'] = this.id;
      }
      doc['name'] = this.name;
      doc['apiEdu'] = this.apiEdu;
      doc['collection'] = 'categories';
      return doc;
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    this.name = '';
    this.apiEdu = false;
    this.resetOne();
    if (this.id) {
      this.fetchCategorie(this.id).then(function (result) {
        _this2.name = result.name;
      });
    }
  }
});

/***/ }),

/***/ "31Jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"title":"Avalia os documentos verificando se há algum duplicado e remove-os do sistema"},on:{"click":function($event){return _vm.handleExec()}}},[_vm._v("\n    Remover tickets duplicados\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "37JD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lending-term"},[(_vm.companyTerms === 'generic')?_c('LendingTermGeneric',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'CE' && _vm.companyTerms === 'enel')?_c('LendingTermEnelCe',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'GO' && _vm.companyTerms === 'enel')?_c('LendingTermEnelGo',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(_vm.state === 'MA' && _vm.companyTerms === 'cemar')?_c('div',[_c('lending-term-cemar',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config,"manufacturer":_vm.manufacturer}}),_vm._v(" "),_c('div',{staticClass:"page-break"}),_vm._v(" "),_c('lending-term-cemar',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config,"manufacturer":_vm.manufacturer}})],1):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'MA' && _vm.companyTerms === 'iasc')?_c('lending-term-iasc-ma',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PI' && _vm.companyTerms === 'iasc')?_c('lending-term-iasc-pi',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PI' && _vm.companyTerms === 'equatorial')?_c('lending-term-equatorial-pi',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'AL' && _vm.companyTerms === 'iasc')?_c('lending-term-iasc-al',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PB' && _vm.companyTerms === 'energisa-paraiba')?_c('lending-term-energisa-pb',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PB' && _vm.companyTerms === 'energisa-borborema')?_c('lending-term-energisa-borborema-pb',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PA' && _vm.companyTerms === 'celpa')?_c('LendingTermCelpa',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e(),_vm._v(" "),(("" + _vm.state) === 'PA' && _vm.companyTerms === 'celpa-jurunas')?_c('LendingTermCelpaJurunas',{attrs:{"customer":_vm.customer,"ticket":_vm.ticket,"config":_vm.config}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "37ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__("tlmh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__("alEA");
function injectStyle (ssrContext) {
  __webpack_require__("8vMF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "39SL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsDocument_vue__ = __webpack_require__("ZLYs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b006aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsDocument_vue__ = __webpack_require__("OwkN");
function injectStyle (ssrContext) {
  __webpack_require__("Hkge")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3b006aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b006aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Be+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__ = __webpack_require__("yvbc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4782a218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__ = __webpack_require__("6aNm");
function injectStyle (ssrContext) {
  __webpack_require__("3zcw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4782a218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4782a218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3C6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.handleRemoveAttachmentFromLamps()}}},[_vm._v("\n    Colocar eligible=true no Tickets\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3D6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-term-enel",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("TERMO DE RECEBIMENTO DE LÂMPADAS")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.type)+" "+_vm._s(_vm.address.street)+", "+_vm._s(_vm.address.number)+" - "+_vm._s(_vm.address.neighborhood)+" - "+_vm._s(_vm.address.city)+" - "+_vm._s(_vm.address.state)+" , inscrita no CNPJ sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual nº "+_vm._s(_vm.numberState)+", e o(a) Sr.(a) "+_vm._s(_vm.customer.holder)+", R.G: "+_vm._s(_vm.customer.nationalId)+", C.P.F.: "+_vm._s(_vm.customer.cpf)+" e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.customer.nis)+", residente e domiciliado (a) na "+_vm._s(_vm.customerFullAddress)+", UC n.º "+_vm._s(_vm.customer.uc)+", firmam o presente Termo de Recebimento de lâmpadas, cujas condições, declarações e compromissos\n    assumidos e acordados encontram - se descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" está desenvolvendo o\n      "),_c('i',[_c('strong',[_vm._v(_vm._s(_vm.projectName))])]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" buscando viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_c('strong',[_vm._v(_vm._s(_vm.projectName))])]),_vm._v("\n      , entre outras ações, disponibilizará lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições seguintes.\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),_vm._v("\n      "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived === '' ?
      '0W' : _vm.powerFluorescentLampsReceived)+"\n      "),_vm._v(" "),_vm._v("\n      e\n      "),_vm._v(" "),_vm._v("\n      "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived === '' ? '0W' :
      _vm.powerIncandescentBulbsReceived)+",\n      "),_vm._v("\n      devendo estas ser entregues à "),_c('strong',[_vm._v(_vm._s(_vm.longname))]),_vm._v(" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à\n      "),_c('strong',[_vm._v(_vm._s(_vm.longname))]),_vm._v(" para substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.longname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.longname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      Em caso de descumprimento de suas obrigações o usuário terá todos os benefícios oriundos do\n      "),_c('strong',[_vm._v(_vm._s(_vm.longname))])])]),_vm._v(" "),_c('p',[_vm._v("\n    Informações da residência visitada\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficam ligadas no horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3G6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownItemChildren_vue__ = __webpack_require__("j47L");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownItemChildren_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ira":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Customers_CustomerCard__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_pages_Customers_CustomerImageCard__ = __webpack_require__("uSbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_pages_Events_EventCard__ = __webpack_require__("ee0G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_pages_Lamps_ListLamps__ = __webpack_require__("Ov/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_pages_Tickets_TicketCard__ = __webpack_require__("VnXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customer-detail',
  components: {
    CustomerCard: __WEBPACK_IMPORTED_MODULE_4_src_pages_Customers_CustomerCard__["a" /* default */],
    CustomerImageCard: __WEBPACK_IMPORTED_MODULE_6_src_pages_Customers_CustomerImageCard__["a" /* default */],
    EventCard: __WEBPACK_IMPORTED_MODULE_7_src_pages_Events_EventCard__["a" /* default */],
    TicketCard: __WEBPACK_IMPORTED_MODULE_9_src_pages_Tickets_TicketCard__["a" /* default */],
    LampsList: __WEBPACK_IMPORTED_MODULE_8_src_pages_Lamps_ListLamps__["a" /* default */]
  },

  data: function data() {
    return {
      currentDate: new Date().getTime()
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('customers', {
    fetchCustomerData: 'fetchCustomerDatas',
    resetCustomer: 'resetOne',
    getUrlImg: 'getUrlImg'
  }), {
    redirectToTicket: function redirectToTicket(ticket) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$router.push({ name: 'tickets.details', params: { id: ticket._id } });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSearch: function handleSearch(event) {
      var _this2 = this;

      if (!event || event === '') {
        this.$notify({
          message: 'Digite uma UC no campo de busca',
          type: 'info'
        });
      } else {
        this.resetCustomer();
        __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].viewQueries({
          connection: 'default',
          ddoc: 'customers-by-uc',
          view: 'customers-by-uc',
          queries: [{ key: event }]
        }).then(function (response) {
          _this2.fetchCustomerData({ id: response[0].rows[0].id });
        });
      }
    },
    getDatas: function getDatas() {
      this.resetCustomer();
      this.fetchCustomerData({ id: this.customerId });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('customers', {
    customer: 'customer',
    loading: 'loading'
  }), {
    tickets: function tickets() {
      return this.customer && this.customer.hasOwnProperty('tickets') ? this.customer.tickets : [];
    },
    lamps: function lamps() {
      if (this.customer && this.customer.hasOwnProperty('lamps')) {
        var items = [];
        for (var indx in this.customer.lamps) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.customer.lamps[indx].items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              item.userId = this.customer.lamps[indx].userId;
              items.push(item);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        return items;
      } else {
        return [];
      }
    },
    customerId: function customerId() {
      return this.$route.params.id;
    }
  }),
  mounted: function mounted() {
    this.currentDate = new Date().getTime();
    this.getUrlImg({ id: this.customerId });
    this.getDatas();
  }
});

/***/ }),

/***/ "3KWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Personal details","before-change":_vm.validateFirstStep,"icon":"ti-user"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Additional Info","before-change":_vm.validateSecondStep,"icon":"ti-settings"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Last step","icon":"ti-check"}},[_c('h2',{staticClass:"text-center text-space"},[_vm._v("Yuhuuu!\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Click on \""),_c('b',[_vm._v("Finish")]),_vm._v("\" to join our community")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3LAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__ = __webpack_require__("Dlhx");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermEnel',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      company: 'Companhia Energética do Ceará - ENEL',
      shortname: 'ENEL',
      address: 'Rua Padre Valdevino, nº 150 – Centro, Fortaleza/CE',
      cpnj: '07.047.251/0001-70',
      stateRegistration: '06.105.848-3',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    };
  },

  computed: {
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    }
  },
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  }
});

/***/ }),

/***/ "3LcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsPrint_vue__ = __webpack_require__("vqd+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e88740_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsPrint_vue__ = __webpack_require__("e2au");
function injectStyle (ssrContext) {
  __webpack_require__("TU94")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58e88740"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e88740_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3MeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3NeS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3O11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingIndex_vue__ = __webpack_require__("hCuU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a467196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingIndex_vue__ = __webpack_require__("kEh0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a467196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3TKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-info btn-icon like",on:{"click":function($event){return _vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Custom table with pagination")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n      We combine "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/quickstart","target":"_blank"}},[_vm._v("Element-UI")]),_vm._v("\n      table functionalities together with a custom pagination component\n      which should provide a very good starting point to integrate tables in your application.\n      Check out more functionalities at "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/table","target":"_blank"}},[_vm._v("Element-UI table documentation")]),_vm._v(".\n     ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Extended tables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Xfj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3aj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateConfigurationsToNewDatabase_vue__ = __webpack_require__("yPnn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1530e1f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateConfigurationsToNewDatabase_vue__ = __webpack_require__("IgVX");
function injectStyle (ssrContext) {
  __webpack_require__("0MZc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1530e1f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateConfigurationsToNewDatabase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1530e1f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateConfigurationsToNewDatabase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3bm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Trg_Tags_ActionsTableTags__ = __webpack_require__("A0Y3");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index-tag',

  components: { ActionsTableTags: __WEBPACK_IMPORTED_MODULE_2__components_Trg_Tags_ActionsTableTags__["a" /* default */] },

  data: function data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['name', 'informativeText']
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('categories', {
    categories: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('tags', {
    tableData: 'tags',
    count: 'count',
    loading: 'loading'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.count;
      return this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),

  watch: {
    currentPage: function currentPage() {
      this.fetch();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('categories', {
    fetchCategories: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tags', ['fetchAll', 'delete']), {
    fetch: function fetch() {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search
      });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetch();
    },
    handleSort: function handleSort(sort) {
      this.fetch();
    },
    handleRemove: function handleRemove(params) {
      var _this = this;

      var swal = __webpack_require__("PBfN");
      swal({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function (res) {
        if (res) {
          _this.delete(params.id).then(function (result) {
            _this.$notify({
              message: 'Registro deletado com sucesso.',
              type: 'success'
            });
            _this.fetch();
          }).catch(function (err) {
            return console.log(err);
          });
        }
      });
    }
  }),

  mounted: function mounted() {
    this.fetchCategories({ limit: 999 });
    this.fetch();
  }
});

/***/ }),

/***/ "3c90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.abbreviation)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3juE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermIasc-al',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return 'Alagoas';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Equatorial Alagoas Distribuidora De Energia S.A.';
    },
    abbreviation: function abbreviation() {
      return 'CEAL';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rua',
        street: 'Fernandes Lima',
        number: '3349',
        neighborhood: 'Farol',
        city: 'Maceió',
        state: 'AL'
      };
    },
    cnpj: function cnpj() {
      return '12.272.084/0001-00';
    },
    numberState: function numberState() {
      return '24007177-8';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "3n+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-open-ticket-print',

  props: {
    ticket: {
      required: true,
      type: Object
    }
  },

  methods: {
    handleTicketPrint: function handleTicketPrint() {
      var routeData = this.$router.resolve({
        name: 'tickets.print',
        params: { id: this.ticket._id }
      });
      window.open(routeData.href, 'ticketWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    }
  }
});

/***/ }),

/***/ "3sUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-router',

  computed: {}
});

/***/ }),

/***/ "3suQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCelpa_vue__ = __webpack_require__("EdOn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e25d9a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCelpa_vue__ = __webpack_require__("jXUP");
function injectStyle (ssrContext) {
  __webpack_require__("mEDQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e25d9a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCelpa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e25d9a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCelpa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3zcw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "43Tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTicketsDocument_vue__ = __webpack_require__("Fihx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383235f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTicketsDocument_vue__ = __webpack_require__("cOy4");
function injectStyle (ssrContext) {
  __webpack_require__("80jj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-383235f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTicketsDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383235f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTicketsDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "46N4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stock_vue__ = __webpack_require__("0pFX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a60dabe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stock_vue__ = __webpack_require__("EmQo");
function injectStyle (ssrContext) {
  __webpack_require__("ZYN3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a60dabe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4AOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('user.reactivate'))?_c('button',{staticClass:"btn btn-info btn-fill btn-icon",attrs:{"type":"button","title":"Reativar"},on:{"click":function($event){return _vm.handleInactivate()}}},[_c('i',{staticClass:"ti-link"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4APc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampTermEquatorialPi',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "4Aiz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[(!_vm.allEvents)?_c('el-select',{staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"","label":""}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd",attrs:{"title":"Este botão irá enviar os dados dos tickets contemplados para o banco de contemplados"},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Migrar Tickets Ganhadores para o banco de CONTEMPLADOS\n  ")]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allEvents),expression:"allEvents"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.allEvents)?_vm._i(_vm.allEvents,null)>-1:(_vm.allEvents)},on:{"change":function($event){var $$a=_vm.allEvents,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allEvents=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allEvents=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allEvents=$$c}}}}),_vm._v(" Todos os eventos?\n\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4GTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('mobile-menu')],1),_vm._v(" "),_c('div',{staticClass:"main-panel",staticStyle:{"padding-right":"0px"}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Jf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc-energisa-borborema-pb',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {

    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Borborema';
    },
    abbreviation: function abbreviation() {
      return 'Energisa';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 158',
        neighborhood: 'Bairro 3 Irmãs',
        city: 'Campina Grande',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '08.826.596/0001-95';
    },
    numberState: function numberState() {
      return '16.003.839/1';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "4Lu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('register-form',{on:{"on-submit":_vm.onRegisterSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('type-validation-form',{on:{"on-submit":_vm.onTypeValidationSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4d5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__ = __webpack_require__("NmlF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__ = __webpack_require__("2SCm");
function injectStyle (ssrContext) {
  __webpack_require__("G5bo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jCY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4llZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4qt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("negu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("yKB+");
function injectStyle (ssrContext) {
  __webpack_require__("H0v/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4twv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5/5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusReplicationView__ = __webpack_require__("HZ2s");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CardStatus',
  components: {
    StatusReplicationView: __WEBPACK_IMPORTED_MODULE_0__StatusReplicationView__["a" /* default */]
  },
  props: {
    database: {
      required: true
    },
    label: {
      required: true
    }
  }
});

/***/ }),

/***/ "53aJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCategories_vue__ = __webpack_require__("hBAi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1767b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCategories_vue__ = __webpack_require__("Scpr");
function injectStyle (ssrContext) {
  __webpack_require__("uhoL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a1767b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1767b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ANv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Bu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__ = __webpack_require__("/YGB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__ = __webpack_require__("4Lu4");
function injectStyle (ssrContext) {
  __webpack_require__("yqcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5X45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("GY//");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("zfG0");
function injectStyle (ssrContext) {
  __webpack_require__("vGh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5Zy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_agile__ = __webpack_require__("6fn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_GalleryComponent__ = __webpack_require__("Z1yA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoContentGmap',
  components: {
    GalleryComponent: __WEBPACK_IMPORTED_MODULE_2_src_components_GalleryComponent__["a" /* default */],
    VueAgile: __WEBPACK_IMPORTED_MODULE_1_vue_agile__["a" /* VueAgile */]
  },
  props: ['infoWinOpen', 'infoContent', 'bgcolor', 'title', 'infoWindowPos'],
  data: function data() {
    return {
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      modalSrc: '',
      showModal: false,
      index: 0,
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        dots: false,
        fade: true,
        navButtons: false
      },
      options2: {
        autoplay: true,
        centerMode: true,
        dots: false,
        navButtons: false,
        slidesToShow: 3,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 5
          }
        }, {
          breakpoint: 1000,
          settings: {
            navButtons: true
          }
        }]
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('gallery', ['defineGallery']), {
    openImgModal: function openImgModal(_ref) {
      var index = _ref.index,
          src = _ref.src;

      this.$emit('openModalDashboard', { index: index, src: src, infoContent: this.infoContent });
      this.defineGallery({ show: true, images: this.infoContent.images, index: index });
    }
  }),
  mounted: function mounted() {
    this.asNavFor1.push(this.$refs.thumbnails);
    this.asNavFor2.push(this.$refs.main);
  }
});

/***/ }),

/***/ "5aY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-print",attrs:{"id":_vm.printId}},[(!_vm.loading)?_c('ticket-document',{attrs:{"loading":_vm.loading,"config":_vm.config,"ticket":_vm.ticket}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5bN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListWinners_vue__ = __webpack_require__("0mul");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc537fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListWinners_vue__ = __webpack_require__("/GfL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListWinners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc537fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListWinners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5cHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icons-ticket-list',

  props: {
    ticket: {
      required: true
    },

    notEligible: {
      default: false
    },

    reason: {
      default: 'Não é elegível'
    }
  },

  computed: {
    hasStock: function hasStock() {
      return this.ticket && this.ticket.stockId;
    },
    oldWinner: function oldWinner() {
      return this.ticket && this.ticket.customer && this.ticket.customer.contemplated;
    },
    winner: function winner() {
      return this.ticket && this.ticket.winner;
    },
    wasDocumented: function wasDocumented() {
      return this.ticket && this.ticket.documentedAt && this.ticket.documentedAt !== null;
    },
    checkIn: function checkIn() {
      return this.ticket && this.ticket.checkIn;
    }
  }
});

/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__("El0Z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("NuQ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5jPH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5p9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonDownloadTermLamps__ = __webpack_require__("eN3z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadTermLamps__ = __webpack_require__("UI3F");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'action-term-lamps',
  components: { UploadTermLamps: __WEBPACK_IMPORTED_MODULE_1__UploadTermLamps__["a" /* default */], ButtonDownloadTermLamps: __WEBPACK_IMPORTED_MODULE_0__ButtonDownloadTermLamps__["a" /* default */] },
  props: {
    customer: { required: true },
    lamps: { required: true },
    eventId: {},
    event: {
      required: true
    }
  }
});

/***/ }),

/***/ "5pax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YesNoRadio__ = __webpack_require__("bkdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GeneralConfigProject',

  components: {
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_4__YesNoRadio__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('project', {
    haveSurveys: 'haveSurveys',
    model: 'model',
    modelValidations: 'validations',
    termsByState: 'termsByState',
    defaultWinnerChoiceModeOptions: 'defaultWinnerChoiceModeOptions'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('states', ['activeStateOptions', 'statesOptions']), {
    activeStateOptions: function activeStateOptions() {
      var _this = this;

      return this.statesOptions.filter(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.termsByState).indexOf(item.value) >= 0;
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('states', { fetchStates: 'fetchAll', setCities: 'setCities' }), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    changeStateName: function changeStateName() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var state;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.getState();

              case 2:
                state = _context.sent;

                if (state && state.length > 0) {
                  _this2.setCities(state[0].cidades);
                  _this2.project.cities = state[0].cidades;
                  _this2.project.company.address.state = state[0].nome;
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getState: function getState() {
      return this.fetchStates({ where: { 'sigla': this.project.state }, limit: 1, noCommit: true });
    }
  })
});

/***/ }),

/***/ "5uDj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5xQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__ = __webpack_require__("V+Sv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d76570d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__ = __webpack_require__("favu");
function injectStyle (ssrContext) {
  __webpack_require__("W5WU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d76570d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "60Pv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60fs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding-top":"3rem"}},[(_vm.showGoogleMap)?_c('div',{staticClass:"eventos-map card"},[_c('div',{staticClass:"header"},[_vm._v("Visão geral no mapa")]),_vm._v(" "),_c('google-maps',{attrs:{"eventsSpecifications":_vm.eventsSpecifications,"trgMarkerCoordinates":_vm.events,"tags":_vm.listTags,"eduMarkerCoodinates":_vm.speeches}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "65F3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "65IR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66Fv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "671N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__ = __webpack_require__("Q8IL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__ = __webpack_require__("M/tb");
function injectStyle (ssrContext) {
  __webpack_require__("7p7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6AyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6CxW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6FTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-select',{staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"","label":""}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd",on:{"click":function($event){_vm.handleRemoverRanking ()}}},[_vm._v("\n    Remover Ranking do Evento\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Ha9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Jf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"reference","label":"Referência","width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"city","label":"Município","sortable":"","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numberOfRefigerators","label":"Geladeiras","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Qtd. tickets","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.ticketsCounter ? _vm.ticketsCounter[scope.row._id] : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Lâmpadas trocadas","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.lampsCounter ? _vm.lampsCounter[scope.row._id] : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","prop":"status","label":"Info.","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('event-icons',{attrs:{"event":scope.row}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startDate","label":"Iniciado em","sortable":"","width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm._f("moment")(new Date(scope.row.startDate),'DD/MM/YYYY'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ações"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('table-actions-events',{attrs:{"dropdown":false,"event":props.row,"show-ranking":_vm.showRanking,"handle-delete":_vm.handleDelete,"config":_vm.config}})],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v(" Mostrando de "+_vm._s(_vm.from + 1)+" até "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" no total.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6KSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnOpenNewPresenter',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), {
    presenter: function presenter() {
      return "https://apresentador.emaisgeladeiras.pi.3eengenharia.com.br";
    }
  }),

  methods: {
    clickOpenPresenter: function clickOpenPresenter() {
      window.open(this.presenter + '/#/' + this.event._id, 'Presenter Window', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false,toolbar=false,fullscreen=yes');
    }
  }
});

/***/ }),

/***/ "6S7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermGeneric_vue__ = __webpack_require__("gCwM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73089418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermGeneric_vue__ = __webpack_require__("QgmI");
function injectStyle (ssrContext) {
  __webpack_require__("Rug+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73089418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermGeneric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73089418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermGeneric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6ULa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc-al',
  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {

    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Equatorial Alagoas Distribuidora De Energia S.A.';
    },
    abbreviation: function abbreviation() {
      return 'CEAL';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rua',
        street: 'Fernandes Lima',
        number: '3349',
        neighborhood: 'Farol',
        city: 'Maceió',
        state: 'AL'
      };
    },
    cnpj: function cnpj() {
      return '12.272.084/0001-00';
    },
    numberState: function numberState() {
      return '24007177-8';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "6ZAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trg_Dashboard_InfoContentGmap__ = __webpack_require__("tGJ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'google-map',
  props: ['trgMarkerCoordinates', 'eduMarkerCoodinates', 'tags', 'eventsSpecifications'],
  components: {
    InfoContentGmap: __WEBPACK_IMPORTED_MODULE_3__Trg_Dashboard_InfoContentGmap__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      modalSrc: '',
      mapName: this.name + '-map',
      center: {
        lat: -3.779033,
        lng: -38.512383
      },
      defaultZoom: 8,
      listMarks: [],
      infoContent: { content: {}, type: '' },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      index: null,
      imageEdu: '/static/img/educacional.png',
      imageTRG: '/static/img/troca_geladeira.png'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('project', ['project']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('eventsSpecifications', ['imagesMap'])),
  watch: {
    eduMarkerCoodinates: function eduMarkerCoodinates() {
      this.getLocationState();
    },
    eventsSpecifications: function eventsSpecifications() {
      this.getLocationState();
    }
  },
  mounted: function mounted() {
    this.getLocationState();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('events', ['getURLPhotosEvent', 'countByKeyView', 'countByViewBetween']), {
    toggleInfoWindow: function toggleInfoWindow(marker, idx, setContent) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.infoWindowPos = marker.gps;
                _context.next = 3;
                return setContent(marker);

              case 3:
                _this.infoContent = _context.sent;

                if (_this.currentMidx === idx) {
                  _this.infoWinOpen = !_this.infoWinOpen;
                } else {
                  _this.infoWinOpen = true;
                  _this.currentMidx = idx;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setContentTRG: function setContentTRG(marker) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var event, lampsCount, participantsCount, photos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event = _this2.trgMarkerCoordinates.find(function (item) {
                  return item._id === marker.eventId;
                });
                _context2.next = 3;
                return _this2.countByKeyView({
                  key: event._id,
                  view: 'count-lamps-by-event',
                  ddoc: 'count-lamps-by-event'
                });

              case 3:
                lampsCount = _context2.sent;
                _context2.next = 6;
                return _this2.countByViewBetween({
                  start_key: [event._id],
                  end_key: [event._id, {}],
                  ddoc: 'count-participants-event',
                  view: 'count-participants-event'
                });

              case 6:
                participantsCount = _context2.sent;
                _context2.next = 9;
                return _this2.getURLPhotosEvent({ _id: event._id });

              case 9:
                photos = _context2.sent;
                return _context2.abrupt('return', {
                  content: {
                    'Referência': event.reference,
                    'Local': event.place,
                    'Cidade': event.city,
                    'Quantidade de Participantes': participantsCount,
                    'Quantidade Geladeiras Entregues': event.numberOfRefigerators,
                    'Quantidade de Lâmpadas Trocadas': lampsCount,
                    'Data Início': _this2.$moment(event.startDate).format('LLL'),
                    'Data Fim': _this2.$moment(event.endDate).format('LLL'),
                    'Data Cerimônia': _this2.$moment(event.dateTimeCeremony).format('LLL'),
                    'Data da Entrega da Geladeira': _this2.$moment(event.dateTimeDelivery).format('LLL') + ' - ' + event.timeEndDelivery,
                    'Latitude': marker.gps.lat,
                    'Longitude': marker.gps.lng
                  },
                  images: photos,
                  type: 'TRG'
                });

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setContentEDU: function setContentEDU(marker) {
      var event = this.trgMarkerCoordinates.find(function (item) {
        return item._id === marker.eventId;
      });
      return {
        content: {
          Local: event.place,
          Cidade: event.city
        },
        type: 'EDU'
      };
    },
    setCenter: function setCenter() {
      var _this3 = this;

      if (!this.trgMarkerCoordinates || !this.eduMarkerCoodinates) {
        return;
      }
      if (this.trgMarkerCoordinates.length !== 0 && this.eduMarkerCoodinates.length !== 0) {
        this.$refs.gmap.$mapPromise.then(function (map) {
          var bounds = new google.maps.LatLngBounds();
          for (var i = 0; i < _this3.trgMarkerCoordinates.length; i++) {
            if (_this3.trgMarkerCoordinates[i].hasOwnProperty('gps')) {
              bounds.extend(_this3.trgMarkerCoordinates[i].gps);
            }
          }
          for (var _i = 0; _i < _this3.eduMarkerCoodinates.length; _i++) {
            if (_this3.eduMarkerCoodinates[_i].hasOwnProperty('gps')) {
              bounds.extend(_this3.eduMarkerCoodinates[_i].gps);
            }
          }
          map.fitBounds(bounds);
        });
      }
    },
    getPinUrl: function getPinUrl(tag) {
      if (tag.hasOwnProperty('refrigeratorIcon') && tag.refrigeratorIcon !== '') {
        return this.imagesMap.basePath + tag.refrigeratorIcon;
      }
      return this.imagesMap.basePath + 'troca_geladeira_0.png';
    },
    waitToCall: function waitToCall() {
      var _this4 = this;

      setTimeout(function () {
        _this4.getLocationState();
      }, 1000);
    },
    getLocationState: function getLocationState() {
      var _this5 = this;

      if (typeof window.google === 'undefined') {
        return this.waitToCall();
      }
      var geocoder = new window.google.maps.Geocoder();
      return geocoder.geocode({ 'address': this.project.state + ', Brasil' }, function (result, status) {
        if (status === 'OK') {
          _this5.center = {
            lat: result[0].geometry.location.lat(),
            lng: result[0].geometry.location.lng()
          };
        }
      }, function (err) {
        return console.log('err, geocode', err);
      });
    },
    getHexColor: function getHexColor(tag) {
      if (!tag || !tag.hasOwnProperty('tags')) {
        return 'F56C6C';
      }

      var currentTag = this.tags.find(function (element) {
        return element._id === tag.tags[0];
      });

      if (!currentTag) {
        return 'F56C6C';
      }

      switch (currentTag.color) {
        case 'Success':
          return '67C23A';
        case 'Warning':
          return 'E6A23C';
        case 'Danger':
          return 'F56C6C';
        case 'Info':
          return '909399';
        case 'Primary':
          return '409EFF';
        default:
          return 'F56C6C';
      }
    }
  })
});

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6aNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v("\n    "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+"\n  ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6bR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnelCe_vue__ = __webpack_require__("3LAN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312ab241_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnelCe_vue__ = __webpack_require__("UAe/");
function injectStyle (ssrContext) {
  __webpack_require__("zH8B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-312ab241"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnelCe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312ab241_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnelCe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bl1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampEventConfigFormConmponent_vue__ = __webpack_require__("+TgX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa2c43ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampEventConfigFormConmponent_vue__ = __webpack_require__("jMRS");
function injectStyle (ssrContext) {
  __webpack_require__("hYB6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa2c43ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampEventConfigFormConmponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa2c43ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampEventConfigFormConmponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6oFk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6w/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseModule__ = __webpack_require__("tv5d");





var collection = 'roles';
var connection = 'config';

var model = {
  name: '',
  label: '',
  permissions: []
};
var validations = {
  name: {
    required: true
  },
  permissions: {
    required: true,
    min: 5
  }
};
var getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["d" /* mapGetters */])());
getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(getters, {
  role: function role(state) {
    return state.one;
  },
  roles: function roles(state) {
    return state.all;
  },
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },

  permissions: function permissions(state) {
    return {
      dashboard: {
        label: 'Dashboard',
        subModules: [{
          label: 'Dashboard',
          permissions: [{ label: 'Visualizar', value: 'dashboard.overview' }]
        }],
        dashboard: [{ label: 'Visualizar', value: 'dashboard.overview' }]
      },
      manage: {
        label: 'Gerenciar',
        subModules: [{
          label: 'Eventos',
          permissions: [{ label: 'Visualizar eventos', value: 'events.index' }, { label: 'Criar eventos', value: 'events.create' }, { label: 'Exibir detalhes dos eventos', value: 'events.details' }, { label: 'Realizar sorteio', value: 'events.lottery' }, { label: 'Visualizar apresentador', value: 'events.view.presenter' }, { label: 'Download do apresentador', value: 'events.download.presenter' }, { label: 'Associar estoque', value: 'events.link.stock' }, { label: 'Imprimir todos os termos', value: 'events.print.terms' }, { label: 'Editar eventos', value: 'events.edit' }, { label: 'Remover eventos', value: 'events.remove' }, { label: 'Baixar relatórios', value: 'events.reports.download' }, { label: 'Download da documentação dos clientes', value: 'events.download.documents' }, { label: 'Imprimir todos os tickets ganhadores', value: 'all.tickets.documents.print' }, { label: 'Substituir ticket ganhador', value: 'events.tickets.replacements' }, { label: 'Enviar fotos do evento', value: 'events.photos.upload' }]
        }, {
          label: 'Especificações',
          permissions: [{ label: 'Auditoria do Ação/Evento', value: 'events.audit' }, { label: 'Visualizar especificações', value: 'eventsSpecifications.index' }, { label: 'Criar especificações', value: 'eventsSpecifications.create' }, { label: 'Editar especificações', value: 'eventsSpecifications.edit' }]
        }, {
          label: 'Ranking',
          permissions: [{ label: 'Visualizar/gerenciar ranking', value: 'ranking.index' }, { label: 'Criar ranking', value: 'ranking.create' }, { label: 'Marcar cliente como ausente no ranking', value: 'ranking.ticket.absent' }, { label: 'Imprimir lista de vencedores', value: 'ranking.print.winners' }]
        }, {
          label: 'Pesquisas',
          permissions: [{ label: 'Visualizar página de pesquisas', value: 'surveys.index' }, { label: 'Associar pesquisas ao usuário', value: 'surveys.associate' }, { label: 'Imprimir lista de associados', value: 'surveys.associated.tickets.print' }, { label: 'Visualizar detalhes da pesquisas', value: 'surveys.view' }, { label: 'Cancelar pesquisa realizada', value: 'surveys.cancel' }]
        }, {
          label: 'Clientes',
          permissions: [{ label: 'Visualizar clientes', value: 'customers.index' }, { label: 'Gerenciar clientes', value: 'customers.manage' }, { label: 'Exibir detalhes do cliente', value: 'customer.detail' }, { label: 'Cadastrar clientes', value: 'customers.create' }, { label: 'Editar clientes', value: 'customers.edit' }, { label: 'Remover clientes', value: 'customers.remove' }, { label: 'Gerenciar tickets', value: 'customers.tickets' }, { label: 'Trocar lâmpadas', value: 'customers.lamps' }, { label: 'Imprimir ticket', value: 'tickets.print' }, { label: 'Imprimir os termos de um cliente', value: 'documents.print' }, { label: 'Imprimir o termo de troca lâmpada', value: 'lamps.print' }]
        }, {
          label: 'Estoques',
          permissions: [{ label: 'Visualizar estoques', value: 'stock.index' }, { label: 'Adicionar novo estoque', value: 'stock.create' }, { label: 'Editar estoques', value: 'stock.edit' }, { label: 'Remover estoques', value: 'stock.remove' }]
        }, {
          label: 'Tickets',
          permissions: [{ label: 'Visualizar detalhes do ticket', value: 'tickets.details' }, { label: 'Registrar presença', value: 'tickets.checkin' }, { label: 'Enviar documentação', value: 'tickets.uploadDoc' }, { label: 'Enviar imagem', value: 'tickets.uploadImg' }, { label: 'Baixar documentação', value: 'tickets.downloadDoc' }, { label: 'Marcar ticket para métrica', value: 'tickets.energyMetering' }]
        }, {
          label: 'Relatórios',
          permissions: [{ label: 'Gerar relatórios', value: 'reports.index' }]
        }]
      },
      config: {
        label: 'Configurações',
        subModules: [{
          label: 'Usuários',
          permissions: [{ label: 'Visualizar usuários', value: 'users.index' }, { label: 'Adicionar usuários', value: 'users.create' }, { label: 'Editar usuários', value: 'users.edit' }, { label: 'Remover usuários', value: 'user.remove' }, { label: 'Inativar usuário', value: 'user.inactivate' }]
        }, {
          label: 'Permissões do Sistema',
          permissions: [{ label: 'Visualizar permissões', value: 'roles.index' }, { label: 'Adicionar permissões', value: 'roles.create' }, { label: 'Editar permissões', value: 'roles.edit' }, { label: 'Remover permissões', value: 'roles.remove' }]
        }, {
          label: 'Projeto',
          permissions: [{ label: 'Visualizar projeto', value: 'project.index' }, { label: 'Editar projeto', value: 'project.edit' }]
        }, {
          label: 'Fabricantes',
          permissions: [{ label: 'Visualizar fabricantes', value: 'manufacturers.index' }, { label: 'Adicionar fabricantes', value: 'manufacturers.create' }, { label: 'Editar fabricantes', value: 'manufacturers.edit' }, { label: 'Remover fabricantes', value: 'manufacturers.remove' }]
        }, {
          label: 'Categorias',
          permissions: [{ label: 'Visualizar categorias', value: 'categories.index' }, { label: 'Adicionar categorias', value: 'categories.create' }, { label: 'Editar categorias', value: 'categories.edit' }, { label: 'Remover categorias', value: 'categories.remove' }]
        }, {
          label: 'Tags',
          permissions: [{ label: 'Visualizar tags', value: 'tags.index' }, { label: 'Adicionar tags', value: 'tags.create' }, { label: 'Editar tags', value: 'tags.edit' }, { label: 'Remover tags', value: 'tags.remove' }]
        }]
      },
      logs: {
        label: 'Logs',
        subModules: [{
          label: 'Logs',
          permissions: [{ label: 'Visualizar logs do cliente', value: 'logs.custoemrs.show' }, { label: 'Visualizar logs do ticket', value: 'logs.tickets.show' }, { label: 'Visualizar logs do evento', value: 'logs.events.show' }, { label: 'Visualizar logs do lâmpadas', value: 'logs.lamps.show' }, { label: 'Visualizar logs do stocks', value: 'logs.stocks.show' }]
        }]
      },
      sync: {
        label: 'Sincronização',
        subModules: [{
          label: 'Sincronização',
          permissions: [{ label: 'Sincronazação do Banco de Dados', value: 'sync.index' }]
        }]
      }
    };
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["a" /* mapStates */])(), {
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    loading: true,
    editing: false
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["c" /* mapActions */])(collection, model, connection)),
  getters: getters
});

/***/ }),

/***/ "6wwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatusReplication'
});

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7138":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_connections__ = __webpack_require__("ZKT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatusView',
  props: {
    connection: {
      required: true
    }
  },
  data: function data() {
    return { syncRate: 0 };
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      return _this.getSyncRate();
    }, 2000);
  },

  methods: {
    getLocalDb: function getLocalDb(conn) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, localDbInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = conn.host.split('//')[1];

                console.log('Conectando ao banco local', url);
                _context.next = 4;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('http://' + conn.user + ':' + conn.pass + '@' + url + '/' + conn.db).then(function (response) {
                    resolve(response.data);
                  });
                });

              case 4:
                localDbInfo = _context.sent;
                return _context.abrupt('return', localDbInfo);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getRemoteDb: function getRemoteDb(conn) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, dbRemoteInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = conn.remote_host.split('//')[1];

                console.log('Conectando ao banco remoto', url);
                _context2.next = 4;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('http://' + conn.remote_user + ':' + conn.remote_pass + '@' + url + '/' + conn.remote_db).then(function (response) {
                    resolve(response.data);
                  });
                });

              case 4:
                dbRemoteInfo = _context2.sent;
                return _context2.abrupt('return', dbRemoteInfo);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getSyncRate: function getSyncRate() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var conn, dbLocalInfo, dbRemoteInfo, localUpdateSeq, remoteUpdateSeq;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                conn = __WEBPACK_IMPORTED_MODULE_3__config_connections__["a" /* default */][_this4.connection];
                _context3.next = 3;
                return _this4.getLocalDb(conn);

              case 3:
                dbLocalInfo = _context3.sent;
                _context3.next = 6;
                return _this4.getRemoteDb(conn);

              case 6:
                dbRemoteInfo = _context3.sent;
                localUpdateSeq = dbLocalInfo.doc_count;
                remoteUpdateSeq = dbRemoteInfo.doc_count;

                _this4.syncRate = (100 - (remoteUpdateSeq - localUpdateSeq) / remoteUpdateSeq * 100).toFixed(2);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "72C5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73g5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCelpa_vue__ = __webpack_require__("MnEK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad586ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCelpa_vue__ = __webpack_require__("UWLN");
function injectStyle (ssrContext) {
  __webpack_require__("IVmL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ad586ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCelpa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad586ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCelpa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "74I8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users__ = __webpack_require__("J8BY");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [{
        prop: 'name',
        label: 'Name',
        minWidth: 200
      }, {
        prop: 'email',
        label: 'Email',
        minWidth: 250
      }, {
        prop: 'age',
        label: 'Age',
        minWidth: 100
      }, {
        prop: 'salary',
        label: 'Salary',
        minWidth: 120
      }],
      tableData: __WEBPACK_IMPORTED_MODULE_12__users__["a" /* default */]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your want to like ' + row.name);
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      var indexToDelete = this.tableData.findIndex(function (tableRow) {
        return tableRow.id === row.id;
      });
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  }
});

/***/ }),

/***/ "7C4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7FZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnelGo_vue__ = __webpack_require__("oHUV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1ed389_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnelGo_vue__ = __webpack_require__("XRLL");
function injectStyle (ssrContext) {
  __webpack_require__("QPLj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f1ed389"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnelGo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1ed389_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnelGo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7HpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nisService_js__ = __webpack_require__("B3wn");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__nisService_js__["a"]; });


/***/ }),

/***/ "7Iex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Events_UploadPhotos_BtnUploadPhotosEvent__ = __webpack_require__("26Lh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Layout_ActionsTableLayout__ = __webpack_require__("Rjzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Layout_RouterButton__ = __webpack_require__("kcVo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qr_code_styling__ = __webpack_require__("UHFk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qr_code_styling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qr_code_styling__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-actions-events',

  mounted: function mounted() {
    if (!this.project || !this.project._id) {
      this.fetchProject('config');
    }
  },


  components: {
    BtnUploadPhotosEvent: __WEBPACK_IMPORTED_MODULE_4_src_pages_Events_UploadPhotos_BtnUploadPhotosEvent__["a" /* default */],
    ActionsTableLayout: __WEBPACK_IMPORTED_MODULE_5_src_components_Layout_ActionsTableLayout__["a" /* default */],
    RouterButton: __WEBPACK_IMPORTED_MODULE_6_src_components_Layout_RouterButton__["a" /* default */]
  },

  props: {
    dropdown: {
      default: true
    },
    showRanking: {
      required: true
    },
    handleDelete: {
      required: true
    },
    event: {
      required: true
    },
    config: {
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['eventLabel', 'project']), {
    colorBtn: function colorBtn() {
      if (this.event.status === 1) {
        return 'btn-success';
      }
      if (this.event.status === 2) {
        return 'btn-danger';
      }
    },

    childrenMenu: function childrenMenu() {
      var children = [];

      if (this.config.hasOwnProperty('event') && this.config.event.hasOwnProperty('hasPhotos') && this.config.event.hasPhotos && this.$can('events.photos.upload')) {
        children.push(this.getBtnUploadPhotos());
      }

      if (this.showRanking(this.event.winnerChoiceMode)) {
        if (this.$can('ranking.index')) {
          children.push(this.getRouterButton('ranking.index', { id: this.event._id }, 'Gerenciar Ranking', 'ti-list-ol', 'success'));
        }
        if (this.$can('surveys.index')) {
          children.push(this.getRouterButton('surveys.index', { id: this.event._id }, 'Associar Pesquisas', 'ti-notepad', 'default'));
        }
      }

      if (this.$can('events.details')) {
        children.push(this.getRouterButton('events.details', { id: this.event._id }, 'Gerenciar Evento', 'ti-settings', 'info'));
      }

      if (this.$can('events.edit')) {
        children.push(this.getRouterButton('events.edit', { id: this.event._id }, 'Editar ' + localStorage.getItem('eventLabel'), 'ti-pencil-alt', 'warning'));
      }

      if (this.$can('events.remove')) {
        children.push({
          component: 'action-button-click-stateless',
          data: {
            props: {
              to: {
                name: 'events.remove',
                params: { id: this.event._id }
              },
              title: 'Remover ' + localStorage.getItem('eventLabel'),
              classStyle: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                btn: true,
                'btn-block': true,
                'btn-flat': true,
                'btn-icon': false
              }, 'btn-danger', true),
              iconClass: 'ti-trash',
              params: {
                id: this.event._id
              },
              handleEvent: {
                click: this.handleDelete
              }
            }
          }
        });
      }

      return children;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), {
    getRouterButton: function getRouterButton(name, params, title, icon, color) {
      return {
        component: __WEBPACK_IMPORTED_MODULE_6_src_components_Layout_RouterButton__["a" /* default */],
        data: {
          props: {
            to: {
              name: name,
              params: params
            },
            title: title,
            classStyle: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
              btn: true,
              'btn-block': true,
              'btn-flat': true,
              'btn-icon': false
            }, 'btn-' + color, true),
            iconClass: icon
          }
        }
      };
    },
    getBtnUploadPhotos: function getBtnUploadPhotos() {
      return {
        component: __WEBPACK_IMPORTED_MODULE_4_src_pages_Events_UploadPhotos_BtnUploadPhotosEvent__["a" /* default */],
        data: {
          class: 'action-btn',
          props: {
            event: this.event
          }
        }
      };
    },
    getOnlineRegisterLink: function getOnlineRegisterLink($eventId) {
      var _this = this;

      var link = this.config.projectOnlineRegister + '/cadastro/' + $eventId;

      if (/https?:\/\//g.test(link)) {
        var wrapper = document.createElement('div');

        var qrCode = new __WEBPACK_IMPORTED_MODULE_7_qr_code_styling___default.a({
          width: 300,
          height: 300,
          data: link
        });
        qrCode.append(wrapper);

        return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          html: '\n            <div class="qrCode"></div>\n            <a href="' + link + '" target="_blank" rel="noopener noreferrer">' + link + '</a>\n          ',
          cancelButtonText: 'Voltar',
          showCancelButton: true,
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Baixar QRCode',
          onBeforeOpen: function onBeforeOpen(content) {
            var div = content.querySelector('.qrCode');
            div.appendChild(wrapper);
          }
        }).then(function () {
          qrCode.download({ name: _this.event.reference });
          _this.getOnlineRegisterLink($eventId);
        }).catch(function () {});
      }
      return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Link inválido',
        type: 'error'
      });
    }
  })
});

/***/ }),

/***/ "7K95":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7NG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7TD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index-surveys'
});

/***/ }),

/***/ "7X6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event && _vm.event.status != 2 && !_vm.ticket.valid && !_vm.ticket.error && !_vm.ticket.winner && (typeof _vm.ticket.valid !== 'undefined'))?_c('button',{staticClass:"btn btn-fill btn-icon btn-danger",attrs:{"title":"Informar erro"},on:{"click":function($event){return _vm.onClick()}}},[_c('i',{staticClass:"ti-close"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7eni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("7TD3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0da6232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("qXFu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0da6232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7huo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Nome completo da empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.longname),expression:"project.company.longname"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-longname"},domProps:{"value":(_vm.project.company.longname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company, "longname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Abreviação da empresa:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.abbreviation),expression:"project.company.abbreviation"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-abbreviation"},domProps:{"value":(_vm.project.company.abbreviation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company, "abbreviation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.cnpj),expression:"project.company.cnpj"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-cnpj"},domProps:{"value":(_vm.project.company.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company, "cnpj", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Número Estadual")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.numberState),expression:"project.company.numberState"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-numberState"},domProps:{"value":(_vm.project.company.numberState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company, "numberState", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Tipo de Logradouro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.type),expression:"project.company.address.type"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-type","pĺaceholder":"Avenida/Rodovia/Rua"},domProps:{"value":(_vm.project.company.address.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company.address, "type", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Logradouro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.street),expression:"project.company.address.street"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-address-street","pĺaceholder":"Augusto Montenegro"},domProps:{"value":(_vm.project.company.address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company.address, "street", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.number),expression:"project.company.address.number"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-address-number","pĺaceholder":"1000/Km 8"},domProps:{"value":(_vm.project.company.address.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company.address, "number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.neighborhood),expression:"project.company.address.neighborhood"}],staticClass:"form-control",attrs:{"type":"text","name":"empresa-address-neighborhood","pĺaceholder":"Conjunto Habitacional Casa Feliz"},domProps:{"value":(_vm.project.company.address.neighborhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company.address, "neighborhood", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Cidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.city),expression:"project.company.address.city"}],staticClass:"form-control",attrs:{"name":"empresa-address-city","required":"","id":"empresa-address-city"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.project.company.address, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.cities),function(city,index){return _c('option',{key:index,domProps:{"value":city}},[_vm._v(_vm._s(city)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Estado")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.company.address.state),expression:"project.company.address.state"}],staticClass:"form-control",attrs:{"readonly":"","type":"text","name":"empresa-address-state","pĺaceholder":"Conjunto Habitacional Casa Feliz"},domProps:{"value":(_vm.project.company.address.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.company.address, "state", $event.target.value)}}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_vm._v("\n        Configurações da Empresa / Concessionária\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_vm._v("\n              Endereço\n            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7p7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7pbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7uvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.download.presenter'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block btn-router",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.handlePresentationFile()}}},[_vm._v("\n  Baixar Arquivo do Apresentador\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "80cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"margin-bottom":"15px"}},[_c('el-collapse',{staticClass:"dashboard-collapse"},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n        Filtros:\n        "),_c('small',{staticStyle:{"margin-left":"20px"}},[_vm._v("\n          "+_vm._s(_vm.textTagsFilters)+_vm._s(_vm.rangeDate.length > 0 && _vm.textTagsFilters !== '' ? ' e entre (' : '')+_vm._s(_vm.rangeDate.length > 0 ? _vm.$moment(_vm.rangeDate[0]).format('LL') + ' e ' + _vm.$moment(_vm.rangeDate[1]).format('LL') + ')' : '')+"\n        ")])]),_vm._v(" "),_c('dashboard-form-filters',{on:{"filter":function($event){return _vm.$emit('filter')}}})],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "80jj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "89uX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-icon',
  props: {
    event: {
      default: {}
    }
  }
});

/***/ }),

/***/ "8CMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Grh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.statsCards),function(stats){return _c('div',{key:stats.value,staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n          "+_vm._s(stats.value)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "+_vm._s(stats.footerText)+"\n        ")])])],1)}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('world-map')],1),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.earningsChart.data,"chart-options":_vm.earningsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("$34,657")]),_vm._v(" "),_c('span',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n            +18%\n          ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n            total earnings "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" ten "),_c('span',{staticClass:"text-muted"},[_vm._v("quarters")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n            Financial Statistics\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-plus"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":70,"title":"Dashboard","description":"Monthly sales target","color":"blue"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":34,"title":"Orders","description":"Completed","color":"green"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":62,"title":"New Visitors","description":"Out of total number","color":"orange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":10,"title":"Subscriptions","description":"Monthly newsletter","color":"brown"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Global Sales by Top Locations")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products that were shipped")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/US.png"}})])]),_vm._v(" "),_c('td',[_vm._v("USA")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        2.920\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        53.23%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/DE.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Germany")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        1.300\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        20.43%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/AU.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Australia")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        760\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        10.35%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/GB.png"}})])]),_vm._v(" "),_c('td',[_vm._v("United Kingdom")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        690\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        7.87%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/RO.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Romania")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        600\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        5.94%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/BR.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Brasil")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        550\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        4.34%\n                      ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8HRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Paper Dashboard PRO")]),_vm._v(" "),_c('h4',[_vm._v("Register for free and experience the dashboard today.")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Free Account")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-bar-chart-alt"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Awesome Performances")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-headphone"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Global Support")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your First Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your Last Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Company"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation"}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"}},[_vm._v("Create Free Account")])])])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8JKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){return _vm.$emit('close')}}},[_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"myContent",style:(("background-color: " + _vm.bgcolor))},[_c('span',{staticClass:"title-card-map"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 3rem"},attrs:{"id":"bodyContent"}},[_c('table',{staticStyle:{"width":"100%"}},_vm._l((Object.keys(_vm.infoContent.content)),function(field,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-right",staticStyle:{"max-width":"25%"}},[_c('strong',[_vm._v(_vm._s(field))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.infoContent.content[field]))])])}),0),_vm._v(" "),(_vm.infoContent.hasOwnProperty('images'))?_c('div',[_c('div',[_c('h5',[_c('strong',[_vm._v("Galeria: ")])])]),_vm._v(" "),(_vm.infoContent.images)?_c('div',[_c('div',{staticClass:"d-flex flex-wrap justify-content-around row"},_vm._l((_vm.infoContent.images),function(image,i){return _c('div',{key:i,staticClass:"col-lg-3",staticStyle:{"margin-bottom":"10px"},on:{"click":function($event){return _vm.openImgModal({index: i, src: image})}}},[_c('img',{staticClass:"image",attrs:{"src":image}})])}),0)]):_c('div',[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("Este evento não possui fotos.")])])]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8P/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"title":"Avalia os documentos verificando se há algum duplicado e remove-os do sistema"},on:{"click":function($event){return _vm.handleExec()}}},[_vm._v("\n    Remover Docs dos Contemplados\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Sj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-list-reserves',

  props: ['tickets']
});

/***/ }),

/***/ "8XB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEquatorialPi_vue__ = __webpack_require__("4APc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb80764_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEquatorialPi_vue__ = __webpack_require__("phuF");
function injectStyle (ssrContext) {
  __webpack_require__("m7R/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bb80764"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEquatorialPi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb80764_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEquatorialPi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8ecr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-go',

  props: {
    payload: {
      type: Object,
      required: true
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    }
  }),
  watch: {
    lampsTmp: function lampsTmp() {
      this.setValues();
    }
  },
  mounted: function mounted() {
    this.setValues();
  },

  methods: {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.lampsTmp), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8suC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'events-options',
  props: {
    multiple: {
      default: false,
      type: Boolean
    },
    event: {
      default: ''
    }
  },
  data: function data() {
    return {
      eventId: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', {
    events: 'optionsById'
  })),
  watch: {
    event: function event() {
      this.eventId = this.event;
    }
  }
});

/***/ }),

/***/ "8vMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/Ay":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("E0D1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86e8e274_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("MsL9");
function injectStyle (ssrContext) {
  __webpack_require__("pGH3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86e8e274_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "95qz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dashboard-filter',{on:{"output":_vm.inputListeners,"filter":_vm.fetch}}),_vm._v(" "),_c('count-cards',{attrs:{"input":_vm.inputDate}}),_vm._v(" "),(_vm.projectOnline)?_c('show-map',{attrs:{"name":"example","allTags":_vm.tags},on:{"openModalDashboard":_vm.openModal}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "979U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip__ = __webpack_require__("WgY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_ImageSuport__ = __webpack_require__("HKKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnDownloadOldPresenter',

  data: function data() {
    return {
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tickets', {
    ticketsWinners: 'winners'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['changeExecution']), {
    handleDocumentsDownload: function handleDocumentsDownload() {
      var _this = this;

      this.changeExecution(true);
      this.loading = true;
      this.zipperDocuments().then(function (res) {
        console.log(res);
        _this.loading = false;
        _this.changeExecution(false);
      }).catch(function (err) {
        console.log(err);
        _this.loading = false;
        _this.changeExecution(false);
      });
    },
    zipperDocuments: function zipperDocuments() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var zip, id, attachments, documents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, anexo, name, value, index, countImages, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _file, regex, ext, fileName, _fileName, data, zipName;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                zip = new __WEBPACK_IMPORTED_MODULE_5_jszip___default.a();
                _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(_this2.ticketsWinners);

              case 2:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 74;
                  break;
                }

                id = _context.t1.value;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').where('referenceId', _this2.ticketsWinners[id]._id).all();

              case 6:
                attachments = _context.sent;
                documents = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(attachments);

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 38;
                  break;
                }

                file = _step.value;
                anexo = false;
                name = null;
                value = null;
                _context.t2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(file._attachments);

              case 19:
                if ((_context.t3 = _context.t2()).done) {
                  _context.next = 35;
                  break;
                }

                index = _context.t3.value;

                name = index;
                _context.next = 24;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').getAttachment(file._id, index);

              case 24:
                anexo = _context.sent;

                if (!(anexo.type === 'image/jpeg')) {
                  _context.next = 31;
                  break;
                }

                _context.next = 28;
                return __WEBPACK_IMPORTED_MODULE_7_src_services_ImageSuport__["a" /* imageSuportService */].resizeImage(anexo, {
                  canvasId: 'canvasPlace',
                  maxWidth: 640,
                  maxHeight: 480,
                  maxQuality: 100
                });

              case 28:
                value = _context.sent;
                _context.next = 32;
                break;

              case 31:
                value = anexo;

              case 32:
                documents.push({
                  name: name,
                  value: value
                });
                _context.next = 19;
                break;

              case 35:
                _iteratorNormalCompletion = true;
                _context.next = 13;
                break;

              case 38:
                _context.next = 44;
                break;

              case 40:
                _context.prev = 40;
                _context.t4 = _context['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context.t4;

              case 44:
                _context.prev = 44;
                _context.prev = 45;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 47:
                _context.prev = 47;

                if (!_didIteratorError) {
                  _context.next = 50;
                  break;
                }

                throw _iteratorError;

              case 50:
                return _context.finish(47);

              case 51:
                return _context.finish(44);

              case 52:
                countImages = 0;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 56;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(documents); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _file = _step2.value;
                  regex = /(?:\.([^.]+))?$/;
                  ext = regex.exec(_file.name);

                  if (_file.value.type === 'application/pdf') {
                    fileName = _this2.customers[_this2.ticketsWinners[id]].uc + ext[0];

                    zip.file(fileName, _file.value, 'application/pdf');
                  } else {
                    countImages += 1;
                    _fileName = _this2.customers[_this2.ticketsWinners[id]].uc + '_imagem_' + countImages + '_' + ext[0];

                    zip.file(_fileName, _file.value.blob);
                  }
                }
                _context.next = 64;
                break;

              case 60:
                _context.prev = 60;
                _context.t5 = _context['catch'](56);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t5;

              case 64:
                _context.prev = 64;
                _context.prev = 65;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 67:
                _context.prev = 67;

                if (!_didIteratorError2) {
                  _context.next = 70;
                  break;
                }

                throw _iteratorError2;

              case 70:
                return _context.finish(67);

              case 71:
                return _context.finish(64);

              case 72:
                _context.next = 2;
                break;

              case 74:
                data = _this2.$moment(_this2.event.endDate).format('DD_MM_YYYY');
                zipName = _this2.event.city + '_' + data + '.zip';

                zip.generateAsync({ type: 'blob' }).then(function (blob) {
                  __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(blob, zipName);
                });

              case 77:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 40, 44, 52], [45,, 47, 51], [56, 60, 64, 72], [65,, 67, 71]]);
      }))();
    }
  })
});

/***/ }),

/***/ "9AYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("\n      As definições abaixo são para o estado de: "),_c('strong',[_vm._v(_vm._s(_vm.project.company.address.state))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"category"},[_vm._v("\n        De qual concessionária serão os termos?\n      ")]),_vm._v(" "),_c('RadioCompaniesDocuments',{attrs:{"currentTerms":_vm.currentTerms},model:{value:(_vm.event.doc.companyTerms),callback:function ($$v) {_vm.$set(_vm.event.doc, "companyTerms", $$v)},expression:"event.doc.companyTerms"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"category"},[_vm._v("\n        Haverá separação entre o termo de comodato e o ticket do cliente?\n      ")]),_vm._v(" "),_c('small',[_vm._v("\n        Ao ativar, o termo de comodato será impresso por outro botão.\n      ")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.event.doc.registerCustomerTicketDocument),callback:function ($$v) {_vm.$set(_vm.event.doc, "registerCustomerTicketDocument", $$v)},expression:"event.doc.registerCustomerTicketDocument"}})],1),_vm._v(" "),(_vm.event.doc.registerCustomerTicketDocument)?_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"category"},[_vm._v("\n        Quantidade de dias para o agente comunitário visitar a casa do cliente?\n      ")]),_vm._v(" "),_c('small',[_vm._v("\n        \"O processo será realizado por um dos nossos Agentes Comunitários que visitará sua residência nos próximos XX\n        dias\"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.doc.daysToVisit),expression:"event.doc.daysToVisit"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.event.doc.daysToVisit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event.doc, "daysToVisit", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Insira exatamente como deverá ser exibido no documento")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h5',[_vm._v("\n      Definição de termos e documentos no Evento.\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9B/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_password_hash_and_salt__ = __webpack_require__("I9c0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_password_hash_and_salt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_password_hash_and_salt__);








var userCouchdb = new __WEBPACK_IMPORTED_MODULE_5__CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'users' });
var configCouchdb = new __WEBPACK_IMPORTED_MODULE_5__CouchdbClass__["a" /* default */]({ connection: 'config', collection: '' });
/* harmony default export */ __webpack_exports__["a"] = ({
  createIndexes: function createIndexes() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createIndex(['collection'], 'collection'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createIndex(['login'], 'login'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createIndex(['createdAt'], 'createdAt'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createIndex(['description'], 'description'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('winners').createIndex(['cpf'], 'cpf'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('states').createIndex(['sigla'], 'sigla'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('states').createIndex(['nome'], 'nome'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createIndex(['customerId'], 'customer._id'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createIndex(['ticketId'], 'ticket._id'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createIndex(['eventId'], 'eventId'), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys_docs').createIndex(['surveyId'], 'surveyId')]);
  },
  createViews: function createViews() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.createFilters(), _this.createCountersViews(), _this.createDashboardPageViews(), _this.createJoinViews(), _this.createCollectionsView(), _this.createEventsViews(), _this.createCustomerViews(), _this.createStocksViews(), _this.createLampsViews(), _this.createTicketsViews(), _this.createDocsViews(), _this.createSurveysViews(), _this.createDashboardView()]);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  deleteViews: function deleteViews() {
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('dashboard');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('dashboard-page');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('customers');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('tickets');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('ticket-by-eventId');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('join');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('lamps');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('stocks');

    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').deleteDesignView('events');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').deleteDesignView('surveys');
    __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('docs').deleteDesignView('docs');
  },
  createDashboardView: function createDashboardView() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('dashboard-counter-model-event-date', 'dashboard-counter-model-event-date', {
      reduce: '_sum',
      map: 'function (doc) {\n          if (doc.hasOwnProperty(\'eventId\') && doc.hasOwnProperty(\'collection\') && doc.hasOwnProperty(\'createdAt\') && !doc.hasOwnProperty(\'deletedAt\')) {\n            if (doc.collection === \'lamps\' && doc.hasOwnProperty(\'items\')) {\n                emit([doc.collection, doc.eventId, doc.createdAt], doc.items.length);\n            }\n            else {\n              emit([doc.collection, doc.eventId, doc.createdAt], 1);\n            }\n\n            if (doc.collection === \'tickets\' && doc.winner === true) {\n              emit([\'winning-tickets\', doc.eventId, doc.createdAt], 1);\n            }\n          }\n        }'
    })]);
  },
  createCountersViews: function createCountersViews() {
    var couchdbDefault = new __WEBPACK_IMPORTED_MODULE_5__CouchdbClass__["a" /* default */]({ connection: 'default' });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([couchdbDefault.createView('counter-collection-created_at', 'counter-collection-created_at', {
      reduce: '_count',
      map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\')  && !doc.hasOwnProperty(\'deletedAt\') && doc.hasOwnProperty(\'createdAt\')) {\n    emit([doc.collection, doc.createdAt], null);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-lamps-by-event-by-type-by-power', 'count-lamps-by-event-by-type-by-power', {
      reduce: '_sum',
      map: 'function (doc) {\n  if (doc.collection === \'lamps\' && doc.hasOwnProperty(\'items\') && doc.items.length > 0  && !doc.hasOwnProperty(\'deletedAt\')) {\n    doc.items.forEach(function (item) {\n      if (item.hasOwnProperty(\'type\')) {\n        emit([doc.eventId, item.type, item.power], 1)\n      }\n    })\n  }\n}\n      '
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('counter-events-refrigerators', 'counter-events-refrigerators', {
      reduce: '_sum',
      map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\') &&\n    doc.collection === \'tickets\' &&\n    doc.hasOwnProperty(\'winner\') &&\n    doc.winner &&\n    doc.hasOwnProperty(\'documentedAt\') &&\n    doc.documentedAt &&\n    doc.documentedAt !== null  && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.eventId, 1);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('counter-events-tickets', 'counter-events-tickets', {
      reduce: '_sum',
      map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\') && doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.eventId, 1);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('counter-events-lamps', 'counter-events-lamps', {
      reduce: '_sum',
      map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\') && doc.collection === \'lamps\' && doc.hasOwnProperty(\'items\') && doc.items && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.eventId, doc.items.length);\n  }\n}'
    })]);
  },
  createStocksViews: function createStocksViews() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('stocks-by-id', 'stocks-by-id', {
      map: 'function (doc) {\n  if (doc.collection === \'stocks\') {\n    emit(doc._id, doc);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('stocks-by-event-id', 'stocks-by-event-id', {
      map: 'function (doc) {\n  if (doc.collection === \'stocks\' && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.eventId, doc);\n  }\n}'
    })]);
  },
  createLampsViews: function createLampsViews() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('lamps-by-event', 'lamps-by-event', {
      map: 'function (doc) {\n  if (doc.collection === \'lamps\') {\n    emit(doc.eventId, doc);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('lamps-by-customer-id', 'lamps-by-customer-id', {
      map: 'function (doc) {\n  if (doc.collection === \'lamps\' && doc.customer && doc.customer.id && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.customer.id, doc);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('lamps-by-customer-uc', 'lamps-by-customer-uc', {
      map: 'function (doc) {\n  if (doc.collection === \'lamps\' && doc.customer && doc.customer.uc && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.customer.uc, doc);\n  }\n}'
    }), __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-participants-event', 'count-participants-event', {
      map: 'function (doc) {\n  if (doc.hasOwnProperty(\'createdAt\') && !doc.hasOwnProperty(\'deletedAt\')) {\n    if (doc.hasOwnProperty(\'eventId\') && doc.hasOwnProperty(\'collection\') && doc.collection === \'tickets\') {\n      emit([doc.eventId, doc.customerId], 1);\n    }\n    if (doc.hasOwnProperty(\'eventId\') && doc.hasOwnProperty(\'customer\') && doc.customer.hasOwnProperty(\'id\') && doc.hasOwnProperty(\'collection\') && doc.collection === \'lamps\') {\n      emit([doc.eventId, doc.customer.id], 1);\n    }\n  \n  }\n}',
      reduce: '_sum'
    })]);
  },
  createSurveysViews: function createSurveysViews() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('counters', 'surveys-by-status', {
                map: 'function (doc) {\n      if (!doc.hasOwnProperty(\'deletedAt\')) {\n        if (doc.status === \'FINISHED\') {\n          emit(\'FINISHED\', 1);\n        }\n        }\n      }',
                reduce: '_sum'
              });

            case 2:
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'status', {
                map: 'function (doc) {\n          if (doc.status && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.status, doc);\n          }\n        }'
              });

            case 4:
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'byEvent', {
                map: 'function (doc) {\n            if (doc.hasOwnProperty(\'event\') && !doc.hasOwnProperty(\'deletedAt\')) {\n\n          emit(doc.event._id, doc);\n          }\n        }'
              });

            case 6:
              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'byUser', {
                map: 'function (doc) {\n  if (doc.hasOwnProperty(\'user\') && doc.hasOwnProperty(\'status\') && doc.status === \'TODO\' && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.user._id, doc);\n  }\n}'
              });

            case 8:
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'by-user-associated', {
                map: 'function (doc) {\n          if (doc.hasOwnProperty(\'user\') && doc.user && doc.user.hasOwnProperty(\'_id\') && doc.user._id && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.user._id, doc);\n          }\n        }'
              });

            case 10:
              _context2.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'ticket-id', {
                map: 'function (doc) {\n          if (doc.ticketId && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.ticketId, doc);\n          }\n        }'
              });

            case 12:
              _context2.next = 14;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'customer-id', {
                map: 'function (doc) {\n          if (doc.customer && doc.customer._id && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.customer._id, doc);\n          }\n        }'
              });

            case 14:
              _context2.next = 16;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'customer-uc', {
                map: 'function (doc) {\n          if (doc.customer && doc.customer.uc && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.customer.uc, doc);\n          }\n        }'
              });

            case 16:
              _context2.next = 18;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('collections', 'customer-cpf', {
                map: 'function (doc) {\n          if (doc.customer && doc.customer.cpf && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.customer.cpf, doc);\n          }\n        }'
              });

            case 18:
              _context2.next = 20;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('counters-surveys-by-status', 'counters-surveys-by-status', {
                map: 'function (doc) {\n        if ( !doc.hasOwnProperty(\'deletedAt\')) {\n  if (doc.status === \'FINISHED\') {\n    emit(\'finished\', 1);\n  } else if (doc.status === \'TODO\') {\n    emit(\'todo\', 1);\n  }\n  }\n}',
                reduce: '_sum'
              });

            case 20:
              _context2.next = 22;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('surveys').createView('surveys-by-event', 'surveys-by-event', {
                map: 'function (doc) {\n  if (doc.hasOwnProperty(\'event\')  && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.event._id, doc);\n  }\n}'
              });

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  createCollectionsView: function createCollectionsView() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _arr, _i, collection, _arr2, _i2, _collection;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _arr = ['lamps', 'customers', 'tickets', 'events', 'stocks', 'manufacturers'];
              _i = 0;

            case 2:
              if (!(_i < _arr.length)) {
                _context3.next = 9;
                break;
              }

              collection = _arr[_i];
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView(collection + '-by-createdAt', collection + '-by-createdAt', {
                map: 'function (doc) {\n          if (doc.collection === \'' + collection + '\' && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.createdAt, doc);\n          }\n        }'
              });

            case 6:
              _i++;
              _context3.next = 2;
              break;

            case 9:
              _context3.next = 11;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('users-by-createdAt', 'users-by-createdAt', {
                map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\') && doc.collection === \'users\' && (!doc.hasOwnProperty(\'inactivated\') || !doc.inactivated) && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.createdAt, null);\n  }\n}',
                reduce: '_count'
              });

            case 11:
              _arr2 = ['lamps', 'customers', 'tickets', 'events', 'stocks', 'manufacturers', 'users'];
              _i2 = 0;

            case 13:
              if (!(_i2 < _arr2.length)) {
                _context3.next = 20;
                break;
              }

              _collection = _arr2[_i2];
              _context3.next = 17;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('collection', _collection, { map: 'function (doc) {\n  if (doc.collection === \'' + _collection + '\' && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.createdAt, doc);\n  }\n}' });

            case 17:
              _i2++;
              _context3.next = 13;
              break;

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  createJoinViews: function createJoinViews() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('event-datas', 'event-datas', {
                map: 'function(doc) {\n        if( !doc.hasOwnProperty(\'deletedAt\')) {\n            if (doc.collection === "events") {\n                emit([doc._id, 0], null);\n            } else if (doc.collection === "tickets") {\n              emit([doc.eventId, 1], doc._id);\n              if (doc.customerId) {\n                emit([doc.eventId, 2], {_id: doc.customerId});\n              }\n              if (doc.stockId) {\n                emit([doc.eventId, 3], {_id: doc.stockId});\n              }\n            } else if (doc.collection === \'lamps\') {\n              emit([doc.eventId, 4], {_id: doc._id})\n            }\n            }\n          }'
              });

            case 2:
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('join-lamps-customer', 'join-lamps-customer', {
                map: 'function(doc) {\n        if ( !doc.hasOwnProperty(\'deletedAt\')) {\n    if (doc.collection === "events") {\n        emit([doc._id, 0], null);\n    } else if (doc.collection === "lamps") {\n      emit([doc.eventId, 1], doc._id);\n      if (doc.customer.id) {\n        emit([doc.eventId, 2], {_id: doc.customer.id});\n      }\n    }\n    }\n  }'
              });

            case 4:
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('join-ticket-event-customer', 'join-ticket-event-customer', {
                map: 'function(doc) {\n    if (doc.collection === "tickets" && !doc.hasOwnProperty(\'deletedAt\')) {\n      emit([doc._id, 0], null);\n      if (doc.eventId) {\n        emit([doc._id, 1], {_id: doc.eventId});\n      }\n      if (doc.customerId) {\n        emit([doc._id, 2], {_id: doc.customerId});\n      }\n      if (doc.stockId) {\n        emit([doc._id, 3], {_id: doc.stockId});\n      }\n    }\n  }'
              });

            case 6:
              _context4.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('join-customer-datas', 'join-customer-datas', {
                map: 'function(doc) {\n        if ( !doc.hasOwnProperty(\'deletedAt\') ){\n    if (doc.collection === "customers") {\n      emit([doc._id, 0], {_id: doc._id});\n    } else if (doc.collection === "tickets") {\n      emit([doc.customerId, 1], {_id: doc._id});\n      if (doc.eventId) {\n        emit([doc.customerId, 2], {_id: doc.eventId});\n      }\n      if (doc.stockId) {\n        emit([doc.customerId, 3], {_id: doc.stockId});\n      }\n    } else if (doc.collection === \'lamps\') {\n      emit([doc.customer.id, 4], {_id: doc._id})\n      emit([doc.customer.id, 5], {_id: doc.eventId})\n    }\n    }\n  }'
              });

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  createDashboardPageViews: function createDashboardPageViews() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-customers-all', 'count-customers-all', {
                reduce: '_count',
                map: 'function (doc) {\n            if(doc.collection === "customers" && doc.hasOwnProperty(\'createdAt\') && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.createdAt, null);\n            }\n          }'
              });

            case 2:
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-tickets-alll', 'count-tickets-alll', {
                reduce: '_sum',
                map: 'function (doc) {\n            if(doc.collection === "tickets" && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc._id, 1);\n            }\n          }'
              });

            case 4:
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-events-all', 'count-events-all', {
                reduce: '_sum',
                map: 'function (doc) {\n            if(doc.collection === "events" && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc._id, 1);\n            }\n          }'
              });

            case 6:
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-events-direct-list-all', 'count-events-direct-list-all', {
                reduce: '_sum',
                map: 'function (doc) {\n            if (doc.directList === true && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc._id, 1);\n            }\n          }'
              });

            case 8:
              _context5.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-lamps-all', 'count-lamps-all', {
                reduce: '_sum',
                map: 'function (doc) {\n            if(doc.collection === "lamps" && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc._id, doc.items.length);\n            }\n          }'
              });

            case 10:
              _context5.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-winners-all', 'count-winners-all', {
                reduce: '_sum',
                map: 'function (doc) {\n            if(doc.collection === "tickets" && doc.documentedAt !== null && doc.winner === true && !doc.hasOwnProperty(\'deletedAt\')){\n              emit(doc._id, 1);\n            }\n          }'
              });

            case 12:
              _context5.next = 14;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('count-lamps-by-event', 'count-lamps-by-event', {
                reduce: '_sum',
                map: 'function (doc) {\n            if(doc.collection === "lamps" && doc.hasOwnProperty(\'eventId\') && doc.eventId && doc.eventId !== null && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.eventId, doc.items.length);\n            }\n          }'
              });

            case 14:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  createEventsViews: function createEventsViews() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('events-winning-tickets', 'events-winning-tickets', {
                map: 'function (doc) {\n        if (doc.collection === \'tickets\' && doc.winner === true && !doc.hasOwnProperty(\'deletedAt\')) {\n          emit(doc.eventId, doc);\n        }\n      }'
              });

            case 2:
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('events-by-city', 'events-by-city', {
                map: 'function (doc) {\n        if (doc.collection === \'events\' && !doc.hasOwnProperty(\'deletedAt\')) {\n          emit(doc.city, doc);\n        }\n      }'
              });

            case 4:
              _context6.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('events-count-tickets', 'events-count-tickets', {
                map: 'function (doc) {\n        if (doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n          emit(doc.eventId, 1);\n        }\n      }',
                reduce: '_sum'
              });

            case 6:
              _context6.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('events-byStartDate', 'events-byStartDate', {
                map: 'function (doc) {\n          if (doc.collection === \'events\' && doc.hasOwnProperty(\'startDate\') && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.startDate, doc);\n          }\n        }'
              });

            case 8:
              _context6.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('events-by-id', 'events-by-id', {
                map: 'function (doc) {\n          if (doc.collection === \'events\' && doc.hasOwnProperty(\'startDate\') && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc._id, doc);\n          }\n        }'
              });

            case 10:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  createCustomerViews: function createCustomerViews() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('customers-by-id', 'customers-by-id', {
                map: 'function (doc) {\n          if (doc.collection === \'customers\' && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc._id, doc);\n          }\n        }'
              });

            case 2:
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('customers-by-uc', 'customers-by-uc', {
                map: 'function (doc) {\n          if (doc.collection === \'customers\' && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.uc, doc);\n          }\n        }'
              });

            case 4:
              _context7.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('customers-by-cpf', 'customers-by-cpf', {
                map: 'function (doc) {\n          if (doc.collection === \'customers\' && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.cpf, doc);\n          }\n        }'
              });

            case 6:
              _context7.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('customers-by-holder', 'customers-by-holder', {
                map: 'function (doc) {\n          if (doc.collection === \'customers\' && !doc.hasOwnProperty(\'deletedAt\')) {\n            emit(doc.holder, doc);\n          }\n        }'
              });

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  createTicketsViews: function createTicketsViews() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-by-eventId-winners', 'tickets-by-eventId-winners', {
                map: '\n          function (doc) {\n            if (doc.collection === \'tickets\' && doc.winner && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.eventId, doc);\n            }\n          }'
              });

            case 2:
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-by-id', 'tickets-by-id', {
                map: 'function (doc) {\n            if (doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc._id, doc);\n            }\n          }'
              });

            case 4:
              _context8.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-by-eventId', 'tickets-by-eventId', {
                map: 'function (doc) {\n            if (doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.eventId, doc);\n            }\n          }'
              });

            case 6:
              _context8.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-associated-by-event', 'tickets-associated-by-event', {
                map: 'function (doc) {\n            if (doc.collection === \'tickets\' && doc.surveyAssociated && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.eventId, doc);\n            }\n          }'
              });

            case 8:
              _context8.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-by-barcode', 'tickets-by-barcode', {
                map: 'function (doc) {\n            if (doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.barcode, doc);\n            }\n          }'
              });

            case 10:
              _context8.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createView('tickets-customer-id', 'tickets-customer-id', {
                map: 'function (doc) {\n            if (doc.collection === \'tickets\' && !doc.hasOwnProperty(\'deletedAt\')) {\n              emit(doc.customerId, doc);\n            }\n          }'
              });

            case 12:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  createDocsViews: function createDocsViews() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('docs').createView('docs-by-reference-id', 'docs-by-reference-id', {
                map: 'function (doc) {\n        if ( !doc.hasOwnProperty(\'deletedAt\') ) {\n\n          emit(doc.referenceId, doc);\n          }\n        }'
              });

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  createFilters: function createFilters() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var collections, filters, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, collection;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              collections = ['customers', 'events', 'lamps', 'manufacturers', 'roles', 'states', 'stocks', 'tickets', 'users'];
              filters = {};
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context10.prev = 5;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(collections); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                collection = _step.value;

                filters[collection] = 'function (doc, req) { \n if (doc.collection === \'' + collection + '\' && !doc.hasOwnProperty(\'deletedAt\')) { \n return true \n } \n return false \n }';
              }
              _context10.next = 13;
              break;

            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10['catch'](5);
              _didIteratorError = true;
              _iteratorError = _context10.t0;

            case 13:
              _context10.prev = 13;
              _context10.prev = 14;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 16:
              _context10.prev = 16;

              if (!_didIteratorError) {
                _context10.next = 19;
                break;
              }

              throw _iteratorError;

            case 19:
              return _context10.finish(16);

            case 20:
              return _context10.finish(13);

            case 21:
              _context10.next = 23;
              return __WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].connection('default').createFilters('collection', filters);

            case 23:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[5, 9, 13, 21], [14,, 16, 20]]);
    }))();
  },
  createAdminUser: function createAdminUser() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return userCouchdb.where('login', "codeseven").first().then(function (result) {
                if (result === null) {
                  _this11.hash("admin2435").then(function (hash) {
                    userCouchdb.insert({
                      'login': "codeseven",
                      'password': hash,
                      'name': 'Codeseven',
                      'role': 'superadmin'
                    });
                  });
                }
              });

            case 2:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  createConfigDoc: function createConfigDoc() {
    return configCouchdb.find('config').then(function (res) {
      console.log('ok', res._id);
    }).catch(function () {
      configCouchdb.insert({
        '_id': 'config'
      });
    });
  },
  createDefaultRoles: function createDefaultRoles() {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _this12.createAdminRole();
              _this12.createAtendeeRole();
              _this12.createSupervisorRole();

            case 3:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  createAtendeeRole: function createAtendeeRole() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return configCouchdb.where('name', 'atendente').get().then(function (result) {
                if (result.length === 0) {
                  configCouchdb._insertBulk([{
                    'name': 'atendente',
                    'label': 'Atendente',
                    'permissions': ['dashboard.overview', 'events.index', 'events.details', 'events.download.presenter', 'events.print.terms', 'events.reports.download', 'customers.index', 'customer.detail', 'customers.create', 'customers.edit', 'customers.tickets', 'customers.lamps', 'tickets.print', 'documents.print', 'lamps.print', 'reports.index', 'tickets.downloadDoc', 'tickets.uploadImg', 'tickets.uploadDoc', 'tickets.checkin', 'tickets.details'],
                    'collection': 'roles'
                  }]);
                }
              });

            case 2:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  createSupervisorRole: function createSupervisorRole() {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return configCouchdb.where('name', 'supervisor').get().then(function (result) {
                if (result.length === 0) {
                  configCouchdb._insertBulk([{
                    'name': 'supervisor',
                    'label': 'Supervisor',
                    'permissions': ['dashboard.overview', 'events.index', 'events.create', 'events.details', 'events.lottery', 'events.download.presenter', 'events.link.stock', 'events.print.terms', 'events.edit', 'events.reports.download', 'events.download.documents', 'events.tickets.replacements', 'customers.index', 'customers.manage', 'customer.detail', 'customers.create', 'customers.edit', 'customers.tickets', 'customers.lamps', 'tickets.print', 'documents.print', 'lamps.print', 'stock.edit', 'stock.create', 'stock.index', 'tickets.energyMetering', 'tickets.downloadDoc', 'tickets.uploadImg', 'tickets.uploadDoc', 'tickets.checkin', 'tickets.details', 'reports.index', 'users.index', 'users.create', 'users.edit', 'manufacturers.index', 'manufacturers.create', 'manufacturers.edit'],
                    'collection': 'roles'
                  }]);
                }
              });

            case 2:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  createAdminRole: function createAdminRole() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return configCouchdb.where('name', 'concessionaria').get().then(function (result) {
                if (result.length === 0) {
                  configCouchdb._insertBulk([{
                    'name': 'concessionaria',
                    'label': 'Concessionária',
                    'permissions': ['dashboard.overview', 'events.index', 'events.details', 'events.download.documents', 'events.reports.download', 'customers.index', 'reports.index', 'tickets.uploadDoc', 'tickets.downloadDoc'],
                    'collection': 'roles'
                  }]);
                }
              });

            case 2:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  hash: function hash(password) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_6_password_hash_and_salt___default()(password).hash(function (error, hash) {
        if (error) {
          reject(error);
        }
        resolve(hash);
      });
    });
  }
});

/***/ }),

/***/ "9C0w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9HaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('StatusReplicationView',{attrs:{"connection":_vm.database}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9N2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  base64ToBinary: function base64ToBinary(dataURI) {
    var BASE64_MARKER = ';base64,';
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var data = dataURI.substring(base64Index);
    var raw = window.atob(data);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }
});

/***/ }),

/***/ "9NRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('btn-upload-file-input',{attrs:{"ticket":_vm.ticket,"event":_vm.event}}),_vm._v(" "),_c('btn-take-photos',{attrs:{"ticket":_vm.ticket,"event":_vm.event}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9NTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermIasc',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },


    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "9O9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(_vm._s(_vm.city)+", "+_vm._s(_vm.day)+" de "+_vm._s(_vm.month)+" de "+_vm._s(_vm.year))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9OEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9RRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTerm_vue__ = __webpack_require__("SXWS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf70918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTerm_vue__ = __webpack_require__("ZRZs");
function injectStyle (ssrContext) {
  __webpack_require__("P0Nf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bf70918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTerm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf70918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTerm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9W3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RemoteConfigForm',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['projectsNames']), {
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  })
});

/***/ }),

/***/ "9ZWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('tickets.energyMetering') && _vm.event && !_vm.event.drawn && _vm.ticket.eligible)?_c('button',{staticClass:"btn btn-fill btn-icon",class:!_vm.ticket.energyMetering ? 'btn-info' : 'btn-warning',attrs:{"title":!_vm.ticket.energyMetering ? 'Marcar para medição' : 'Desmarcar para medição'},on:{"click":function($event){return _vm.checkTicket()}}},[_c('i',{staticClass:"ti-bolt"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9dWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9fQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9gNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("rP9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("KtLi");
function injectStyle (ssrContext) {
  __webpack_require__("ifSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9hHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    couchdbCustomers: function couchdbCustomers() {
      return new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },
    couchdbTickets: function couchdbTickets() {
      return new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },
    couchdbLamps: function couchdbLamps() {
      return new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('customers', {
    fetchCustomers: 'fetchAll',
    upsertCustomer: 'upsert'
  }), {
    handleCustomersContemplado: function handleCustomersContemplado() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contemplados, customers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, customer;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                contemplados = [];
                _context.next = 4;
                return _this.fetchCustomers({
                  limit: 99999999
                });

              case 4:
                customers = _context.sent;


                _this.total = customers.length;

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(customers);

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 20;
                  break;
                }

                customer = _step.value;
                _context.next = 15;
                return _this.checkCustomer(customer);

              case 15:
                customer.cadastroOnline = customer.cadastroOnline || false;

                customer.contemplated && contemplados.push(customer);

              case 17:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                _context.next = 36;
                return _this.couchdbCustomers._updateBulkDocs(contemplados);

              case 36:
                _this.isLoading = false;

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    checkCustomer: function checkCustomer(customer) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tickets, lamps, winnerTickets;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.couchdbTickets.where('customerId', customer._id).limit(99999999).get();

              case 2:
                tickets = _context2.sent;
                _context2.next = 5;
                return _this2.couchdbLamps.where('customer.id', customer._id).limit(99999999).get();

              case 5:
                lamps = _context2.sent;
                winnerTickets = tickets.filter(function (ticket) {
                  return ticket.winner;
                });

                if (!(lamps.length === 0 && winnerTickets.length === 0)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return');

              case 9:

                customer.contemplated = true;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "9m1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAllAboutAnEventWithoutCustomer_vue__ = __webpack_require__("ASlG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d68f382e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAllAboutAnEventWithoutCustomer_vue__ = __webpack_require__("raQp");
function injectStyle (ssrContext) {
  __webpack_require__("D5dz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d68f382e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAllAboutAnEventWithoutCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d68f382e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAllAboutAnEventWithoutCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9nxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9wTj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A0Y3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableTags_vue__ = __webpack_require__("mUSE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98fc879c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableTags_vue__ = __webpack_require__("zXct");
function injectStyle (ssrContext) {
  __webpack_require__("IvGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98fc879c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98fc879c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A82D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnOpenTicketRegisterDocPrint',
  props: {
    ticket: {
      required: true,
      type: Object
    },
    eventProp: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({});
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (this.eventProp.hasOwnProperty('_id')) {
      if (this.equatorialTerm(this.eventProp)) {
        this.showBtn = true;
      }

      return;
    }

    this.fetchEvent(this.ticket.eventId, true).then(function (event) {
      if (_this.equatorialTerm(event)) {
        _this.showBtn = true;
      }
    });
  },
  data: function data() {
    return {
      showBtn: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('events', { fetchEvent: 'fetchOne', loadingEvent: 'loading' }), {
    handleDocumentsPrint: function handleDocumentsPrint() {
      var routeData = this.$router.resolve({
        name: 'tickets.register.print',
        params: { id: this.ticket._id }
      });
      window.open(routeData.href, 'documentsWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    },
    equatorialTerm: function equatorialTerm(event) {
      return event.doc && event.doc.registerCustomerTicketDocument;
    }
  })
});

/***/ }),

/***/ "ABcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DialogUploadPhotosEvent__ = __webpack_require__("Z+/e");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnUploadPhotosEvent',

  components: {
    DialogUploadPhotosEvent: __WEBPACK_IMPORTED_MODULE_4__DialogUploadPhotosEvent__["a" /* default */]
  },

  props: {
    btnClass: {
      default: ''
    },
    event: {
      required: false
    }
  },

  data: function data() {
    return {
      dialog: {
        show: false,
        files: []
      }
    };
  },


  methods: {
    openDialogPhotosEvent: function openDialogPhotosEvent() {
      this.dialog.show = true;
    },
    getFiles: function getFiles(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: 'Informação',
                  text: 'Estamos enviado as fotos para o servidor, por favor, aguarde.',
                  type: 'info',
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  onOpen: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.showLoading();
                              _context.next = 3;
                              return _this.handleFile(event);

                            case 3:
                              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.hideLoading();
                              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.close();

                            case 5:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function onOpen() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    handleFile: function handleFile(event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(event);
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_src_services__["a" /* filesService */].handleImage(event);

              case 4:
                _this2.dialog.files = _context3.sent;

                console.log('imagens', _this2.dialog.files);
                _this2.openDialogPhotosEvent();
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](1);

                console.log('err', _context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[1, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ "ABlU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ADji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"title":"Avalia os documentos verificando se há algum duplicado e remove-os do sistema"},on:{"click":function($event){return _vm.handleExec()}}},[_vm._v("\n    Remover lâmpadas duplicadas\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AGjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCategories_vue__ = __webpack_require__("30zL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e9c780_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCategories_vue__ = __webpack_require__("QbEl");
function injectStyle (ssrContext) {
  __webpack_require__("ZzHm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26e9c780"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e9c780_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AN/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("I4+v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fc0918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("BZli");
function injectStyle (ssrContext) {
  __webpack_require__("0pu4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83fc0918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fc0918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AOK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProjectName',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['project'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['fetchOne'])),
  mounted: function mounted() {
    if (!this.project || !this.project.hasOwnProperty('name') || !this.project.hasOwnProperty('state')) {
      this.fetchOne('config');
    }
  }
});

/***/ }),

/***/ "APnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__ = __webpack_require__("pk/q");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-view-images',

  props: ['survey'],

  data: function data() {
    return {
      images: ['body', 'coil', 'compartments', 'customer', 'doors', 'engine', 'rubber', 'sealingNumber'],
      surveyDoc: { _id: '' }
    };
  },


  computed: {
    host: function host() {
      return "https://couch-trg.3e.eng.br";
    },
    db: function db() {
      return "trg_eqpi_notiasc_surveys_docs";
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].connection('surveys_docs').where('surveyId', this.survey._id).get().then(function (res) {
      console.log(res);
      _this.surveyDoc = res[0];
    });
  }
});

/***/ }),

/***/ "ARCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPrintAllTickets_vue__ = __webpack_require__("sBKk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4f8a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPrintAllTickets_vue__ = __webpack_require__("KULE");
function injectStyle (ssrContext) {
  __webpack_require__("S2QK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a4f8a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPrintAllTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4f8a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPrintAllTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ASlG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_EventsOptions_vue__ = __webpack_require__("oVfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RemoveAllAboutAnEventWithoutCustomer',
  components: {
    EventsOptions: __WEBPACK_IMPORTED_MODULE_5_src_components_EventsOptions_vue__["a" /* default */]
  },

  data: function data() {
    return {
      eventSelectedId: '',
      forceDelete: false,
      isLoading: false
    };
  },

  computed: {
    eventDb: function eventDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
    },
    ticketDb: function ticketDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },
    lampDb: function lampDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },
    stockDb: function stockDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'stocks' });
    },
    docDb: function docDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'docs', collection: 'docs' });
    }
  },

  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Removendo Tickets',
                  message: 'Aguarde',
                  type: 'info',
                  confirmButtonText: 'Remover',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  showCloseButton: true,
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this.deleteTickets();

                            case 2:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function preConfirm() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                            title: 'Removendo Docs',
                            message: 'Aguarde',
                            type: 'info',
                            confirmButtonText: 'Remover',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showCloseButton: true,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true,
                            preConfirm: function () {
                              var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.next = 2;
                                        return _this.deleteDocs();

                                      case 2:
                                      case 'end':
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, _this);
                              }));

                              return function preConfirm() {
                                return _ref3.apply(this, arguments);
                              };
                            }()
                          }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
                            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    _context8.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                      title: 'Removendo lamps',
                                      message: 'Aguarde',
                                      type: 'info',
                                      confirmButtonText: 'Remover',
                                      allowOutsideClick: false,
                                      allowEscapeKey: false,
                                      allowEnterKey: false,
                                      showCloseButton: true,
                                      showConfirmButton: true,
                                      showLoaderOnConfirm: true,
                                      preConfirm: function () {
                                        var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                                          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                                            while (1) {
                                              switch (_context3.prev = _context3.next) {
                                                case 0:
                                                  _context3.next = 2;
                                                  return _this.deleteLamps();

                                                case 2:
                                                case 'end':
                                                  return _context3.stop();
                                              }
                                            }
                                          }, _callee3, _this);
                                        }));

                                        return function preConfirm() {
                                          return _ref5.apply(this, arguments);
                                        };
                                      }()
                                    }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
                                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                                        while (1) {
                                          switch (_context7.prev = _context7.next) {
                                            case 0:
                                              _context7.next = 2;
                                              return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                                title: 'Removendo stocks',
                                                message: 'Aguarde',
                                                type: 'info',
                                                confirmButtonText: 'Remover',
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                                allowEnterKey: false,
                                                showCloseButton: true,
                                                showConfirmButton: true,
                                                showLoaderOnConfirm: true,
                                                preConfirm: function () {
                                                  var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                                                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                                      while (1) {
                                                        switch (_context4.prev = _context4.next) {
                                                          case 0:
                                                            _context4.next = 2;
                                                            return _this.deleteStocks();

                                                          case 2:
                                                          case 'end':
                                                            return _context4.stop();
                                                        }
                                                      }
                                                    }, _callee4, _this);
                                                  }));

                                                  return function preConfirm() {
                                                    return _ref7.apply(this, arguments);
                                                  };
                                                }()
                                              }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
                                                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                                  while (1) {
                                                    switch (_context6.prev = _context6.next) {
                                                      case 0:
                                                        _context6.next = 2;
                                                        return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                                          title: 'Removendo Evento',
                                                          message: 'Aguarde',
                                                          type: 'info',
                                                          confirmButtonText: 'Remover',
                                                          allowOutsideClick: false,
                                                          allowEscapeKey: false,
                                                          allowEnterKey: false,
                                                          showCloseButton: true,
                                                          showConfirmButton: true,
                                                          showLoaderOnConfirm: true,
                                                          preConfirm: function () {
                                                            var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
                                                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                                                while (1) {
                                                                  switch (_context5.prev = _context5.next) {
                                                                    case 0:
                                                                      _context5.next = 2;
                                                                      return _this.deleteEvents();

                                                                    case 2:
                                                                    case 'end':
                                                                      return _context5.stop();
                                                                  }
                                                                }
                                                              }, _callee5, _this);
                                                            }));

                                                            return function preConfirm() {
                                                              return _ref9.apply(this, arguments);
                                                            };
                                                          }()
                                                        });

                                                      case 2:
                                                      case 'end':
                                                        return _context6.stop();
                                                    }
                                                  }
                                                }, _callee6, _this);
                                              })));

                                            case 2:
                                            case 'end':
                                              return _context7.stop();
                                          }
                                        }
                                      }, _callee7, _this);
                                    })));

                                  case 2:
                                  case 'end':
                                    return _context8.stop();
                                }
                              }
                            }, _callee8, _this);
                          })));

                        case 2:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this);
                })));

              case 2:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this);
      }))();
    },
    deleteEvents: function deleteEvents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this2.eventDb.find(_this2.eventSelectedId);

              case 2:
                event = _context11.sent;

                event.deletedAt = new Date();

                if (!_this2.forceDelete) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 7;
                return _this2.eventDb.delete(event._id, true);

              case 7:
                return _context11.abrupt('return');

              case 8:
                _context11.next = 10;
                return _this2.eventDb.upsert(event._id, event);

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this2);
      }))();
    },
    deleteData: function deleteData(couchdb) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var data, deleteData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!_this3.forceDelete) {
                  _context12.next = 6;
                  break;
                }

                _context12.next = 3;
                return couchdb.where('eventId', _this3.eventSelectedId).withTrash().get();

              case 3:
                _context12.t0 = _context12.sent;
                _context12.next = 9;
                break;

              case 6:
                _context12.next = 8;
                return couchdb.where('eventId', _this3.eventSelectedId).get();

              case 8:
                _context12.t0 = _context12.sent;

              case 9:
                data = _context12.t0;

                if (!_this3.forceDelete) {
                  _context12.next = 15;
                  break;
                }

                deleteData = data.map(function (item) {
                  return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    _id: item._id,
                    _rev: item._rev,
                    _deleted: true
                  }));
                });
                _context12.next = 14;
                return couchdb._updateBulkDocs(deleteData);

              case 14:
                return _context12.abrupt('return', data);

              case 15:

                couchdb._updateBulkDocs(data.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { deletedAt: new Date() });
                }));
                return _context12.abrupt('return', data);

              case 17:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this3);
      }))();
    },
    deleteTickets: function deleteTickets() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this4.deleteData(_this4.ticketDb);

              case 2:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this4);
      }))();
    },
    deleteLamps: function deleteLamps() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this5.deleteData(_this5.lampDb);

              case 2:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this5);
      }))();
    },
    deleteStocks: function deleteStocks() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this6.deleteData(_this6.stockDb);

              case 2:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this6);
      }))();
    },
    deleteDocs: function deleteDocs() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var docs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return _this7.docDb.where('referenceId', _this7.eventSelectedId).get();

              case 2:
                docs = _context16.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context16.prev = 6;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(docs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  doc = _step.value;

                  _this7.docDb.delete(doc._id, true);
                }
                _context16.next = 14;
                break;

              case 10:
                _context16.prev = 10;
                _context16.t0 = _context16['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context16.t0;

              case 14:
                _context16.prev = 14;
                _context16.prev = 15;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 17:
                _context16.prev = 17;

                if (!_didIteratorError) {
                  _context16.next = 20;
                  break;
                }

                throw _iteratorError;

              case 20:
                return _context16.finish(17);

              case 21:
                return _context16.finish(14);

              case 22:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this7, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    }
  }
});

/***/ }),

/***/ "AXOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inactivate-user-action',

  props: {
    user: {}
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', {
    loading: 'loading'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', ['upsert']), {
    handleInactivate: function handleInactivate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        text: 'Deseja destivar ' + this.user.name + '?',
        title: 'Atenção',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this.upsert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.user, { inactivate: true })).then(function () {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('Desativado!', 'Usuário desativado com sucesso', 'success');
          _this.$emit('fetch');
        });
      });
    }
  })
});

/***/ }),

/***/ "Aaf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validations__ = __webpack_require__("7HpB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InputNis',
  props: ['value'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', { modelValidations: 'validations' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project']), {
    nisValidation: function nisValidation() {
      return __WEBPACK_IMPORTED_MODULE_1__services_validations__["a" /* nisService */];
    }
  })
});

/***/ }),

/***/ "Ag9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generate-new-tickets',

  data: function data() {
    return {
      period: { start: '', end: '' },
      customers: [],
      eventsFetched: [],
      countTickets: 0,
      eventIdSelected: '',
      loading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    events: {
      get: function get() {
        return this.$store.state.events.all;
      }
    },

    eventSelected: function eventSelected() {
      var _this = this;

      return this.events.find(function (item) {
        return item._id === _this.eventIdSelected;
      });
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleGenerate: function handleGenerate() {
      var _this2 = this;

      this.loading = true;
      this.total = 0;
      this.fetchEventsByCity().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2.eventsFetched = response.rows.map(function (item) {
                    return item.value;
                  });
                  _this2.countTicketsEvent().then(function (res) {
                    _this2.countTickets = res.rows.filter(function (item) {
                      return item.key === _this2.eventSelected._id;
                    }).reduce(function (acc, curr) {
                      return curr.value;
                    }, 0);

                    _this2.fetchCustomers().then(function (docs) {
                      _this2.handleFormGeneration(_this2.setCustomers(docs));
                    }).catch(function (err) {
                      console.log(err);
                      _this2.loading = false;
                    });
                  }).catch(function (err) {
                    return console.log(err);
                  });

                case 2:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    setCustomers: function setCustomers(docs) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var doc = _step.value;

          var customers = doc.rows.map(function (item) {
            return item.value;
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(customers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var customer = _step2.value;

              this.customers.push(customer);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.total = this.customers.length;
    },
    fetchEventsByCity: function fetchEventsByCity() {
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').view({
        ddoc: 'events-by-city',
        view: 'events-by-city',
        key: this.eventSelected.city
      });
    },
    fetchCustomers: function fetchCustomers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(this.eventsFetched.map(function (event) {
        return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').viewBetween({
          ddoc: 'customers-by-createdAt',
          view: 'customers-by-createdAt',
          keys: {
            startKey: event.startDate,
            endKey: event.endDate
          },
          options: { reduce: false, skip: 0, descending: false, ascending: true }
        });
      }));
    },
    countTicketsEvent: function countTicketsEvent() {
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._viewReduce('events-count-tickets', 'events-count-tickets');
    },
    handleFormGeneration: function handleFormGeneration() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.formGeneration().then(function (value) {
                  _this3.total = value;
                  _this3.progress = 0;
                  _this3.generateTickets(value);
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    formGeneration: function formGeneration() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var countCustomers;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                countCustomers = _this4.customers.length;
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Formulário para gerar tickets',
                  html: '<p>Foram encontrados ' + countCustomers + ' clientes cadastrados nos per\xEDodos dos eventos para este m\xFAnicipio: ' + _this4.eventSelected.city + '.</p>' + ('<p>O evento ' + _this4.eventSelected.reference + ' j\xE1 possui ' + _this4.countTickets + ' gerados.</p>') + '<p>Defina abaixo a quantidades de tickets a serem gerados:</p>' + '<input id="swal-qnt-tickets" type="number" max="' + countCustomers + '" class="swal2-input">',
                  focusConfirm: false,
                  preConfirm: function preConfirm() {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                      resolve(document.getElementById('swal-qnt-tickets').value);
                    });
                  }
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    generateTickets: function generateTickets(ammount) {
      var _this5 = this;

      this.verifyTickets(this.customers.map(function (customer) {
        return {
          eventId: _this5.eventSelected._id,
          customerId: customer._id,
          barcode: '' + customer.uc + __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.random(10000000, 99999999),
          collection: 'tickets',
          eligible: true,
          reasonNotEligible: '',
          stockId: null,
          winner: false,
          documentedAt: null,
          checkIn: false,
          createAt: new Date()
        };
      }), ammount).then(function (docs) {
        var tickets = docs.slice(0, ammount);
        _this5.askConfirmation(tickets).then(function (confirm) {
          if (confirm) {
            _this5.runInsert(tickets).then(function () {
              return _this5.notifyFinish();
            }).catch(function (err) {
              return _this5.notifyFailure(err);
            }).finally(function () {
              _this5.loading = false;
            });
          }
        });
      });
    },
    verifyTickets: function verifyTickets(tickets, ammount) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var ticketsValid, _loop, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, payload, _ret;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this6.filterTicketsCreatedByCustomerId(tickets);

              case 2:
                tickets = _context5.sent;

                _this6.total = tickets.length;
                ticketsValid = [];
                _loop = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _loop(payload) {
                  var results, barcodeCheck;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _loop$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').view({ ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: payload.barcode });

                        case 2:
                          results = _context4.sent;
                          barcodeCheck = results.rows.map(function (item) {
                            return item.value;
                          }).find(function (item) {
                            return item.barcode === payload.barcode;
                          });

                          if (!barcodeCheck) {
                            --ammount;
                            ticketsValid.push(payload);
                          }

                          if (!(ammount <= 0)) {
                            _context4.next = 8;
                            break;
                          }

                          _this6.progress = _this6.total;
                          return _context4.abrupt('return', 'break');

                        case 8:
                          _this6.progress++;

                        case 9:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _loop, _this6);
                });
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context5.prev = 9;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(tickets);

              case 11:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context5.next = 20;
                  break;
                }

                payload = _step3.value;
                return _context5.delegateYield(_loop(payload), 't0', 14);

              case 14:
                _ret = _context5.t0;

                if (!(_ret === 'break')) {
                  _context5.next = 17;
                  break;
                }

                return _context5.abrupt('break', 20);

              case 17:
                _iteratorNormalCompletion3 = true;
                _context5.next = 11;
                break;

              case 20:
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t1 = _context5['catch'](9);
                _didIteratorError3 = true;
                _iteratorError3 = _context5.t1;

              case 26:
                _context5.prev = 26;
                _context5.prev = 27;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 29:
                _context5.prev = 29;

                if (!_didIteratorError3) {
                  _context5.next = 32;
                  break;
                }

                throw _iteratorError3;

              case 32:
                return _context5.finish(29);

              case 33:
                return _context5.finish(26);

              case 34:
                return _context5.abrupt('return', ticketsValid);

              case 35:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this6, [[9, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    filterTicketsCreatedByCustomerId: function filterTicketsCreatedByCustomerId(tickets) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var eventTickets;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').view({ ddoc: 'tickets-by-eventId', view: 'tickets-by-eventId', key: _this7.eventSelected._id });

              case 2:
                eventTickets = _context6.sent;

                eventTickets = eventTickets.rows.map(function (item) {
                  return item.value;
                }).reduce(function (acc, curr, index) {
                  if (index === 0) {
                    acc = {};
                  }
                  acc[curr.customerId] = curr;
                  return acc;
                }, {});
                return _context6.abrupt('return', tickets.filter(function (item) {
                  return !eventTickets.hasOwnProperty(item.customerId);
                }));

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    runInsert: function runInsert(docs) {
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._insertBulk(docs);
    },
    askConfirmation: function askConfirmation(tickets) {
      return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: 'Confirmar cria\xE7\xE3o de tickets',
        html: 'V\xE3o ser gerados ' + tickets.length + ' para este evento',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim! Crie os tickets!',
        cancelButtonText: 'Não! Cancele tudo!',
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      this.loading = false;
      return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifyFailure: function notifyFailure(err) {
      return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        width: 1000,
        title: 'Ocorreu um erro ao executar essa ação.',
        text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "AuCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AxDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.project.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ay5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B10d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApiForm_vue__ = __webpack_require__("jtrB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d0a6288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApiForm_vue__ = __webpack_require__("tIWZ");
function injectStyle (ssrContext) {
  __webpack_require__("y+v+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApiForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d0a6288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApiForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B3Om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip__ = __webpack_require__("WgY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_services_ImageSuport__ = __webpack_require__("HKKL");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-download-documents',
  props: {
    icon: {
      default: false
    },
    ticketProp: {
      default: undefined
    }
  },
  methods: {
    zipper: function zipper() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var zip, attachments, documents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, anexo, name, value, index, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _file;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                zip = new __WEBPACK_IMPORTED_MODULE_5_jszip___default.a();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').view({
                  ddoc: 'docs-by-reference-id',
                  view: 'docs-by-reference-id',
                  key: _this.ticketProp ? _this.ticketProp._id : _this.ticket._id
                });

              case 3:
                attachments = _context.sent;

                attachments = attachments.rows.map(function (item) {
                  return item.value;
                });
                documents = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(attachments);

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 36;
                  break;
                }

                file = _step.value;
                anexo = false;
                name = null;
                value = null;
                _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(file._attachments);

              case 17:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 33;
                  break;
                }

                index = _context.t1.value;

                name = index;
                _context.next = 22;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').getAttachment(file._id, index);

              case 22:
                anexo = _context.sent;

                if (!(anexo.type === 'image/jpeg' || anexo.type === 'image/png')) {
                  _context.next = 29;
                  break;
                }

                _context.next = 26;
                return __WEBPACK_IMPORTED_MODULE_8_src_services_ImageSuport__["a" /* imageSuportService */].resizeImage(anexo, {
                  canvasId: 'canvasPlace',
                  maxWidth: 640,
                  maxHeight: 480,
                  maxQuality: 100
                });

              case 26:
                value = _context.sent;
                _context.next = 30;
                break;

              case 29:
                value = anexo;

              case 30:
                documents.push({ name: name, value: value });
                _context.next = 17;
                break;

              case 33:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 36:
                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t2 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t2;

              case 42:
                _context.prev = 42;
                _context.prev = 43;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 45:
                _context.prev = 45;

                if (!_didIteratorError) {
                  _context.next = 48;
                  break;
                }

                throw _iteratorError;

              case 48:
                return _context.finish(45);

              case 49:
                return _context.finish(42);

              case 50:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 53;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(documents); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _file = _step2.value;

                  if (_file.value.type === 'application/pdf') {
                    zip.file(_file.name, _file.value, 'application/pdf');
                  } else {
                    zip.file(_file.name, _file.value.blob);
                  }
                }

                _context.next = 61;
                break;

              case 57:
                _context.prev = 57;
                _context.t3 = _context['catch'](53);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t3;

              case 61:
                _context.prev = 61;
                _context.prev = 62;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 64:
                _context.prev = 64;

                if (!_didIteratorError2) {
                  _context.next = 67;
                  break;
                }

                throw _iteratorError2;

              case 67:
                return _context.finish(64);

              case 68:
                return _context.finish(61);

              case 69:
                zip.generateAsync({ type: 'blob' }).then(function (blob) {
                  __WEBPACK_IMPORTED_MODULE_4_downloadjs___default()(blob, 'documentacao.zip');
                });

              case 70:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 38, 42, 50], [43,, 45, 49], [53, 57, 61, 69], [62,, 64, 68]]);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('tickets', ['ticket']), {
    unabled: function unabled() {
      var tkt = this.ticketProp ? this.ticketProp : this.ticket;
      return tkt && !tkt.documentedAt || !this.$can('tickets.downloadDoc');
    }
  })
});

/***/ }),

/***/ "B3wn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nisService; });
var nisService = {
  validate: validate
};

function validate(nis) {
  if (nis.length === 0 && nis.length < 11) {
    return false;
  }

  var multiplicador = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var soma = 0;
  var resto = void 0;

  for (var i = 0; i < 10; i++) {
    soma += parseInt(nis[i]) * multiplicador[i];
  }

  resto = soma % 11;
  resto = 11 - resto;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto === parseInt(nis[10])) {
    return true;
  } else {
    return false;
  }
}

/***/ }),

/***/ "B4cI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiltersMap_vue__ = __webpack_require__("Mfxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7827e32e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiltersMap_vue__ = __webpack_require__("LuYh");
function injectStyle (ssrContext) {
  __webpack_require__("tBIA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7827e32e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiltersMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7827e32e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiltersMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BItS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("yNZB");
function injectStyle (ssrContext) {
  __webpack_require__("V5Z/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BQAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BYD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p-pagination',{attrs:{"page-count":10},model:{value:(_vm.defaultPagination),callback:function ($$v) {_vm.defaultPagination=$$v},expression:"defaultPagination"}}),_vm._v(" "),_c('p-pagination',{attrs:{"type":"info","page-count":10},model:{value:(_vm.infoPagination),callback:function ($$v) {_vm.infoPagination=$$v},expression:"infoPagination"}})],1)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Colors")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-default btn-fill btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Primary")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd"},[_vm._v("Info")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd"},[_vm._v("Success")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd"},[_vm._v("Warning")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd"},[_vm._v("Danger")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Styles")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-wd"},[_vm._v("Fill")]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-wd"},[_vm._v("Simple")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Buttons with Label and Animation")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                Success\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-times"})]),_vm._v("\n                Danger\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-info btn-fill btn-rotate",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-settings"})]),_vm._v("\n                Settings\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning btn-fill btn-magnify",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-search"})]),_vm._v("\n                Search\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n                Back\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-right",attrs:{"type":"button"}},[_vm._v("\n                Next\n                "),_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sizes")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-lg btn-fill"},[_vm._v("Large")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-fill"},[_vm._v("Small")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-fill"},[_vm._v("X-Small")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Button Group")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Left")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Middle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Right")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagination")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Social buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Filled")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Simple")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BYZs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BZli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ba96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{attrs:{"to":{name: 'project.edit'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-pencil-alt2"}),_vm._v(" Editar\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.config),expression:"!config"}],staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Imagens")]),_vm._v(" "),_c('table',{staticClass:"table images"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgTermLamp,"alt":"img-term-lamp"}})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgTermLending,"alt":"img-term-lamp"}})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgTermDelivery,"alt":"img-term-lamp"}})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgPresenterLeft,"alt":"img-term-lamp"}})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgPresenterRight,"alt":"img-term-lamp"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Configurações gerais")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Nome:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Link do Cadastro Online do projeto:")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.config.projectOnlineRegister,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.config.projectOnlineRegister))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Estado:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.state))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Companhias dos termos:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.companyTerms.toUpperCase()))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Terá pesquisa:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.haveSurveys.toString()))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tipo padrão de ganhadores nos evento.")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.defaultWinnerChoiceMode === 'lottery' ? 'Sorteio' : 'Ranking'))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Exibir mapa na página inicial?")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.viewGoogleMap.toString()))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Verificação de cliente duplicado:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Object.keys(_vm.config.validationCustomer).join(', ')))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Verificação de cliente contemplado anteriormente:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Object.keys(_vm.config.validationContemplatedCustomer).join(', ')))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("O NIS será obrigarótio?")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.requiredNIS.toString()))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Usar processo da LGPD?")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.useLGPD.toString()))])])])]),_vm._v(" "),_c('h5',[_vm._v("Configurações de Eventos")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_vm._m(2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event.hasCeremony.toString()))])]),_vm._v(" "),_c('tr',[_vm._m(3),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event.automaticReplacement.toString()))])]),_vm._v(" "),_c('tr',[_vm._m(4),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? 'Automática' : 'Manual'))])]),_vm._v(" "),_c('tr',[_vm._m(5),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event.customersCanBeRecontemplated.toString()))])]),_vm._v(" "),_c('tr',[_vm._m(6),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event.contemplatedPeriod))])]),_vm._v(" "),_c('tr',[_vm._m(7),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event && _vm.config.event.hasPhotos ?  _vm.config.event.hasPhotos.toString() : ''))])]),_vm._v(" "),_c('tr',[_vm._m(8),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.event && _vm.config.event.managedCsv ? _vm.config.event.managedCsv.toString() : ''))])])])]),_vm._v(" "),_c('h5',[_vm._v("Configurações de Registro")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_vm._m(9),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.register.carrer ? 'Sim' : 'Não'))])])])]),_vm._v(" "),_c('h5',[_vm._v("Configurações de Lâmpadas")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_vm._m(10),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.lamps.powerLampDeliveryLabel)+"W")])]),_vm._v(" "),_c('tr',[_vm._m(11),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.lamps.max))])]),_vm._v(" "),_c('tr',[_vm._m(12),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.lamps.hasSeason.toString()))])]),_vm._v(" "),_c('tr',[_vm._m(13),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.lamps.hasSeason ? _vm.config.lamps.seasonRange : 'indeterminado'))])])])]),_vm._v(" "),_c('h5',[_vm._v("Configurações de Tickets")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_vm._m(14),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.config.ticket.automaticBarcode.toString()))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Configurações do Projeto\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Imagem no termo de lâmpada")]),_vm._v(" "),_c('th',[_vm._v("Imagem no termo de comodato")]),_vm._v(" "),_c('th',[_vm._v("Imagem no protocolo de entrega")]),_vm._v(" "),_c('th',[_vm._v("Imagem topo esquerdo do apresentador")]),_vm._v(" "),_c('th',[_vm._v("Imagem topo direito do apresentador")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Os eventos terão "),_c('strong',[_vm._v("cerimônia?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v(" A "),_c('strong',[_vm._v("substituição")]),_vm._v(" do cliente sorteado será:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("A "),_c('strong',[_vm._v("data")]),_vm._v(" de recebimento no\n                "),_c('strong',[_vm._v("protocolo de entrega")]),_vm._v("(termo de entrega) será manual ou automática?\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Será permitido "),_c('strong',[_vm._v("sortear cliente já contemplados")]),_vm._v("\n                  anteriormente?\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Por quantos anos")]),_vm._v(" os clientes\n                "),_c('strong',[_vm._v("serão")]),_vm._v(" considerados como\n                "),_c('strong',[_vm._v("contemplados?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Haverá "),_c('strong',[_vm._v("envio de fotos")]),_vm._v(" no evento?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Haverá "),_c('strong',[_vm._v("cadastro de clientes via planilha")]),_vm._v("?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("\n                Exibir campo de "),_c('strong',[_vm._v("profissão")]),_vm._v("?\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Potência das lâmpadas entregues na troca")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Quantidade máxima no projeto")]),_vm._v("\n                de lâmpadas a serem trocadas "),_c('strong',[_vm._v("por cliente:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Haverá "),_c('strong',[_vm._v("controle")]),_vm._v(" de lâmpadas por temporada?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Período máximo "),_c('strong',[_vm._v("(em meses)")]),_vm._v(" que o cliente ficará sem poder trocar lâmpada")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("O "),_c('strong',[_vm._v("código de barra")]),_vm._v(" será manual ou automático?")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bkzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIasc_vue__ = __webpack_require__("UbXe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e6d26e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIasc_vue__ = __webpack_require__("zzrw");
function injectStyle (ssrContext) {
  __webpack_require__("6oFk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e6d26e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e6d26e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BlIv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bm7B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BxWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C/Uu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fuse_js__ = __webpack_require__("BDm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Tickets_Actions_BtnOpenTicketDocumentation__ = __webpack_require__("m4I+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_Actions_BtnOpenTicketPrint__ = __webpack_require__("OEJ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_Actions_BtnOpenTicketsDocumentationsPrint__ = __webpack_require__("2FHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Actions_CheckEnergyMeteringTickets__ = __webpack_require__("xH5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Actions_CheckValidOnlineRegister__ = __webpack_require__("th4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_pages_Tickets_Actions_TicketCheckIn__ = __webpack_require__("FMHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_pages_Tickets_Actions_TicketInvalidateError__ = __webpack_require__("zctB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_pages_Tickets_ReplacementCustomer__ = __webpack_require__("Fn6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IconsTicketList__ = __webpack_require__("+rP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Actions_BtnOpenTicketRegisterDocPrint__ = __webpack_require__("hrJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tickets-list',
  components: {
    BtnOpenTicketRegisterDocPrint: __WEBPACK_IMPORTED_MODULE_14__Actions_BtnOpenTicketRegisterDocPrint__["a" /* default */],
    BtnOpenTicketPrint: __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_Actions_BtnOpenTicketPrint__["a" /* default */],
    BtnOpenTicketsDocumentationsPrint: __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_Actions_BtnOpenTicketsDocumentationsPrint__["a" /* default */],
    BtnOpenTicketDocumentation: __WEBPACK_IMPORTED_MODULE_3_src_pages_Tickets_Actions_BtnOpenTicketDocumentation__["a" /* default */],
    ReplacementCustomer: __WEBPACK_IMPORTED_MODULE_10_src_pages_Tickets_ReplacementCustomer__["a" /* default */],
    TicketCheckIn: __WEBPACK_IMPORTED_MODULE_8_src_pages_Tickets_Actions_TicketCheckIn__["a" /* default */],
    TicketInvalidateError: __WEBPACK_IMPORTED_MODULE_9_src_pages_Tickets_Actions_TicketInvalidateError__["a" /* default */],
    IconsTicketList: __WEBPACK_IMPORTED_MODULE_13__IconsTicketList__["a" /* default */],
    CheckEnergyMeteringTickets: __WEBPACK_IMPORTED_MODULE_6__Actions_CheckEnergyMeteringTickets__["a" /* default */],
    CheckValidOnlineRegister: __WEBPACK_IMPORTED_MODULE_7__Actions_CheckValidOnlineRegister__["a" /* default */]
  },

  props: {
    event: {},

    tickets: {
      type: Array,
      required: true
    },

    customers: {
      type: Object,
      required: true
    },

    scope: {
      type: String,
      default: 'customer'
    },

    loading: {
      type: Boolean,
      default: true
    }
  },

  mounted: function mounted() {
    this.setFilters();
    this.setTicketsFiltered();
  },
  data: function data() {
    return {
      loadingFiltered: false,
      page: 1,
      perPage: 30,
      search: '',
      replacementCustomerSync: false,
      winner: {},
      filters: {
        selected: []
      },
      showReplacement: false,
      ticketsFiltered: []
    };
  },


  watch: {
    event: function event() {
      this.setFilters();
      this.setTicketsFiltered();
    },
    tickets: function tickets() {
      this.setTicketsFiltered();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])(['config']), {

    loadingCustomers: {
      get: function get() {
        return this.$store.state.customers.loading;
      }
    },

    loadingEvents: {
      get: function get() {
        return this.$store.state.events.loading;
      }
    },

    loadingTickets: {
      get: function get() {
        return this.$store.state.tickets.loading;
      }
    },

    isEventRanking: function isEventRanking() {
      return this.event && this.event.winnerChoiceMode === 'ranking';
    },


    surveys: {
      get: function get() {
        return this.$store.state.surveys.all.reduce(function (accumulate, current, index) {
          if (index === 0) {
            accumulate = {};
          }
          accumulate[current.ticketId] = current;
          return accumulate;
        }, {});
      }
    },

    filtersOptions: function filtersOptions() {
      var options = [{ value: 'winner', label: 'Ganhadores' }, { value: 'checkIn', label: 'Presentes' }, { value: 'valid', label: 'Válidos' }, { value: 'invalid', label: 'Inválidos' }, { value: 'notCheckIn', label: 'Ausentes' }, { value: 'eligible', label: 'Aptos' }, { value: 'unlegible', label: 'Inaptos' }, { value: 'documented', label: 'Documentados' }, { value: 'notDocumented', label: 'Não Documentados' }, { value: 'withStock', label: 'Com Estoque' }, { value: 'withoutStock', label: 'Sem Estoque' }, { value: 'nonValid', label: 'Pendentes' }];
      if (this.isEventRanking) {
        options.push({ value: 'surveyed', label: 'Pesquisados' });
        options.push({ value: 'notSurveyed', label: 'Não Pesquisados' });
      }
      return options;
    },
    showCustomerColumn: function showCustomerColumn() {
      return this.scope === 'event' && this.customers;
    },
    showEventColumn: function showEventColumn() {
      return this.scope === 'customer' || this.event && this.event.reference;
    },
    showResume: function showResume() {
      return this.scope === 'event';
    },
    getTitle: function getTitle() {
      var _this = this;

      var alreadyOne = false;
      var title = this.filters.selected.length > 0 ? 'Tickets' : 'Tickets Gerados';
      var max = this.filters.selected.length - 1;

      var _loop = function _loop(id) {
        var option = _this.filtersOptions.find(function (option) {
          return option.value === _this.filters.selected[id];
        });
        if (!alreadyOne) {
          alreadyOne = true;
          title = title + ' ' + option.label;
        } else {
          title = id === max ? title + ' e ' + option.label : title + ', ' + option.label;
        }
      };

      for (var id in this.filters.selected) {
        _loop(id);
      }
      return title;
    },
    eventIsDrawn: function eventIsDrawn() {
      return typeof this.event !== 'undefined' && this.event.hasOwnProperty('drawn') && this.event.drawn === true;
    },


    events: {
      get: function get() {
        return this.$store.state.events.all.reduce(function (accumulate, current, index) {
          accumulate = index === 0 ? {} : accumulate;
          accumulate[current._id] = current;
          return accumulate;
        }, {});
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('tickets', ['setChangeCheckInWinner', 'resetOne', 'getTicketsByEvent', 'getTicketsByCustomer']), {
    customerInfo: function customerInfo(customer) {
      if (customer.phone2 === '') {
        return __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
          title: '' + customer.holder,
          text: 'UC: ' + customer.uc + ',\n          CPF: ' + customer.cpf + ',\n          Endere\xE7o: ' + customer.address.street + ', \n          ' + customer.address.number + ', \n          ' + customer.address.neighborhood + ', \n          ' + customer.address.city + '. \n          Telefone: ' + customer.phone1
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
          title: '' + customer.holder,
          text: 'UC: ' + customer.uc + ',\n          CPF: ' + customer.cpf + ',\n          Endere\xE7o: ' + customer.address.street + ', \n          ' + customer.address.number + ', \n          ' + customer.address.neighborhood + ', \n          ' + customer.address.city + '. \n          Telefone 1: ' + customer.phone1 + ', \n          Telefone 2: ' + customer.phone2
        });
      }
    },
    setTicketsFiltered: function setTicketsFiltered() {
      var _this2 = this;

      var filteredTickets = this.tickets;
      this.loadingFiltered = true;
      if (this.search !== '') {
        var options = {
          threshold: 0.0,
          keys: ['barcode', 'customer.cpf', 'customer.holder', 'customer.uc']
        };
        var fuse = new __WEBPACK_IMPORTED_MODULE_2_fuse_js___default.a(filteredTickets.map(function (item) {
          item.customer = _this2.customers[item.customerId];
          return item;
        }), options);

        filteredTickets = fuse.search(this.search).map(function (item) {
          delete item.customer;
          return item;
        });
      }

      this.ticketsFiltered = this.filters.selected.length === 0 ? filteredTickets : filteredTickets.filter(function (ticket) {
        return _this2.filters.selected.indexOf('winner') === -1 || ticket.winner;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('eligible') === -1 || _this2.ticketEligible(ticket);
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('unlegible') === -1 || _this2.notEligible(ticket);
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('valid') === -1 || !ticket.error && ticket.valid && ticket.cadastroOnline;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('invalid') === -1 || ticket.error && ticket.cadastroOnline && ticket.reasonError;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('checkIn') === -1 || ticket.checkIn;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('notCheckIn') === -1 || !ticket.checkIn;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('documented') === -1 || ticket.hasOwnProperty('documentedAt') && ticket.documentedAt !== null;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('notDocumented') === -1 || ticket.documentedAt === null || !ticket.hasOwnProperty('documentedAt');
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('withStock') === -1 || ticket.stockId !== null;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('withoutStock') === -1 || ticket.stockId === null;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('nonValid') === -1 || !ticket.valid && ticket.cadastroOnline && !ticket.reasonError;
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('surveyed') === -1 || _this2.isTicketSurveyed(ticket);
      }).filter(function (ticket) {
        return _this2.filters.selected.indexOf('notSurveyed') === -1 || _this2.isTicketNotSurveyed(ticket);
      });
      this.loadingFiltered = false;
    },
    getEvent: function getEvent(id) {
      if (this.event) {
        return this.event;
      }

      if (this.events.hasOwnProperty(id)) {
        return this.events[id];
      }

      return {};
    },
    changeTickets: function changeTickets(customerId) {
      console.log('event', this.event);
      console.log('events', this.events);
      if (this.event) {
        this.getTicketsByEvent(this.event._id);
      } else {
        this.getTicketsByCustomer(customerId);
      }
    },
    ticketEligible: function ticketEligible(ticket) {
      return ticket.eligible === true && (!this.isEventRanking || this.isEventRanking && this.surveyValid(this.isTicketSurveyed(ticket)));
    },
    notEligible: function notEligible(ticket) {
      var survey = this.surveyTicket(ticket);
      return !ticket.eligible || this.isEventRanking && this.surveyInvalid(survey) && this.isTicketSurveyed(ticket);
    },
    reasonTicket: function reasonTicket(ticket) {
      return ticket.hasOwnProperty('reasonNotEligible') ? '' + ticket.reasonNotEligible : 'Não elegível.';
    },
    reasonSurvey: function reasonSurvey(ticket) {
      var survey = this.surveyTicket(ticket);
      var text = '';
      if (survey && this.surveyInvalid(survey)) {
        if (survey.status !== 'FINISHED') {
          return '\nPesquisa não efetuada.';
        }
        if (survey.alert && survey.alert.toString() === 'true') {
          text += '\nCliente com alerta.';
        }
        if (survey.data.hasOwnProperty('absent') && survey.data.absent.toString() === 'true' && survey.data.reasonNotPresent && survey.data.reasonNotPresent !== null) {
          text += '\n' + survey.data.reasonNotPresent;
        }
        if (survey.data.hasOwnProperty('accepted') && survey.data.accepted.toString() === 'false' && survey.data.reasonNotAccepted && survey.data.reasonNotAccepted !== null) {
          text += '\n' + survey.data.reasonNotAccepted;
        }
      }
      return text;
    },
    reason: function reason(ticket) {
      var reason = '';

      if (ticket.error) {
        reason = ticket.reasonError;
      } else if (!ticket.eligible) {
        reason = ticket.reasonNotEligible;
      } else {
        reason = this.reasonSurvey(ticket);
      }

      return this.reasonTicket(ticket) + reason ? ' - ' + reason : '';
    },
    enableReplace: function enableReplace(ticket) {
      return !ticket.documentedAt && ticket.winner && this.scope !== 'customer';
    },
    handleChangeCheckInWinner: function handleChangeCheckInWinner(index, ticket) {
      var _this3 = this;

      ticket.checkIn = !ticket.checkIn;
      var classRemove = ticket.checkIn ? 'btn-success' : 'btn-info';
      var classAdd = !ticket.checkIn ? 'btn-success' : 'btn-info';
      document.getElementById(ticket._id + '-winner').disabled = true;
      __WEBPACK_IMPORTED_MODULE_11_src_services_Couchdb__["a" /* default */].collection('tickets').upsert(ticket._id, ticket).then(function () {
        _this3.$notify({
          message: 'Presença registrada com sucesso.',
          type: 'success'
        });
        document.getElementById(ticket._id + '-winner').classList.add(classAdd);
        document.getElementById(ticket._id + '-winner').classList.remove(classRemove);
        document.getElementById(ticket._id + '-winner').disabled = false;
      }).catch(function () {
        _this3.$notify({
          message: 'Ocorreu algum problema ao registrar a presença. Entre em contato com o suporte.',
          type: 'success'
        });
        document.getElementById(ticket._id + '-winner').disabled = false;
      });
    },
    handleSearch: function handleSearch(search) {
      this.search = search;
      this.setTicketsFiltered();
    },
    hasOwnDeepProperty: function hasOwnDeepProperty(obj, prop) {
      if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object' && obj !== null) {
        if (obj.hasOwnProperty(prop)) {
          return true;
        }
        for (var p in obj) {
          if (obj.hasOwnProperty(p) && this.hasOwnDeepProperty(obj[p], prop)) {
            return true;
          }
        }
      }
      return false;
    },
    handleTicketPrint: function handleTicketPrint(index, ticket) {
      var routeData = this.$router.resolve({
        name: 'tickets.print',
        params: { id: ticket._id }
      });
      window.open(routeData.href, 'ticketWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    },
    handleDocumentation: function handleDocumentation(row) {
      this.resetOne();
      this.$router.push({ name: 'tickets.details', params: { id: row._id } });
    },
    handleReplaceCustomer: function handleReplaceCustomer(index, row) {
      this.showReplacement = true;
      this.replacementCustomerSync = false;
      this.replacementCustomerSync = true;
      this.winner = row;
    },
    setFilters: function setFilters() {
      this.filters.selected = [];
      if (this.event && this.event.drawn) {
        this.filters.selected.push('winner');
      }
    },
    isTicketSurveyed: function isTicketSurveyed(ticket) {
      var survey = this.surveyTicket(ticket);
      return survey && ['FINISHED', 'SYNCED'].indexOf(survey.status) !== -1;
    },
    isTicketNotSurveyed: function isTicketNotSurveyed(ticket) {
      var survey = this.surveyTicket(ticket);
      return survey && ['TODO', 'CONFLICT'].indexOf(survey.status) !== -1;
    },
    surveyTicket: function surveyTicket(ticket) {
      return this.isEventRanking ? this.surveys[ticket._id] : undefined;
    },
    surveyValid: function surveyValid(survey) {
      if (!survey) {
        return false;
      }

      return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && survey.data.accepted && survey.data.accepted !== 'false';
    },
    surveyInvalid: function surveyInvalid(survey) {
      if (!survey) {
        return true;
      }

      return survey.status !== 'FINISHED' || survey.alert && survey.alert.toString() === 'true' || !survey.hasOwnProperty('data') || survey.data.hasOwnProperty('absent') && survey.data.absent.toString() === 'true' || survey.data.hasOwnProperty('accepted') && survey.data.accepted.toString() === 'false';
    }
  }),

  created: function created() {}
});

/***/ }),

/***/ "C/fn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingEventsCount),expression:"isLoadingEventsCount"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-success',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-location-pin"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.eventsCount.length)+"\n          "),_c('p',[_vm._v(_vm._s(_vm.config.hasOwnProperty('eventLabel') ? _vm.config.eventLabel : 'Eventos'))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingCustomersCount),expression:"isLoadingCustomersCount"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-warning',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-user"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.participantsCount)+"\n          "),_c('p',[_vm._v("Participantes")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingTicketsCount),expression:"isLoadingTicketsCount"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-default',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-ticket"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.ticketsCount)+"\n          "),_c('p',[_vm._v("Tickets")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingWinnersCount),expression:"isLoadingWinnersCount"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-danger',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-layout-media-overlay-alt-2"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.winnersCount)+"\n          "),_c('p',[_vm._v("Geladeiras")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingLampsCount),expression:"isLoadingLampsCount"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-info',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-light-bulb"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.lampsCount)+"\n          "),_c('p',[_vm._v("Lâmpadas")])])])],1),_vm._v(" "),(this.config.haveSurveys)?_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingSurveys),expression:"loadingSurveys"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-info',attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-notepad"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.surveysFinishedCount)+"\n          "),_c('p',[_vm._v("Pesquisas")])])])],1):_vm._e()]),_vm._v(" "),(_vm.projectOnline && _vm.config.dashboardEduCards)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.edu.loading),expression:"edu.loading"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-info',attrs:{"slot":"header"},slot:"header"},[_c('p',[_vm._v("Educacional")]),_vm._v(" "),_c('i',{staticClass:"ti-location-pin"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.edu.eventsCount)+"\n          "),_c('p',[_vm._v("Eventos")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-sm-6"},[_c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.edu.loading),expression:"edu.loading"}]},[_c('div',{staticClass:"icon-big text-center",class:'icon-info',attrs:{"slot":"header"},slot:"header"},[_c('p',[_vm._v("Educacional")]),_vm._v(" "),_c('i',{staticClass:"ti-book"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.edu.speechesCount)+"\n          "),_c('p',[_vm._v("Palestras")])])])],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C14H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.reporting),expression:"reporting"}],staticClass:"btn btn-wd btn-fill btn-tertiary",on:{"click":_vm.loadingReport}},[_vm._v("\n  Gerar relatório geral: "+_vm._s(_vm.eventLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C4ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((Object.keys(_vm.databases)),function(db){return _c('div',{staticClass:"col-xs-3"},[_c('CardStatusReplication',{attrs:{"database":db,"label":_vm.databases[db]}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C8v6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"name","label":"Nome","sortable":"custom","min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Categoria","sortable":"custom","min-width":200},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.categorieId && _vm.categories.hasOwnProperty(scope.row.categorieId) ? _vm.categories[scope.row.categorieId].name : '')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Criado Em","sortable":"custom","min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm._f("moment")(new Date(scope.row.createdAt),'DD/MM/YYYY HH:mm:ss'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":100,"fixed":"right","label":"Ações"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('actions-table-tags',{attrs:{"tag":props.row,"handleRemove":_vm.handleRemove}})]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando de "+_vm._s(_vm.from + 1)+" até "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" no total.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C9WT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip__ = __webpack_require__("WgY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampsList',
  props: {
    customer: {
      required: true,
      type: Object
    },
    eventId: {
      default: false
    }
  },
  data: function data() {
    return {
      isRunningActions: false
    };
  },

  methods: {
    handleTermsDownload: function handleTermsDownload() {
      this.zipperTerms().then(function () {}).catch(function (err) {
        console.log(err);
      });
    },
    zipperTerms: function zipperTerms() {
      var _this = this;

      this.isRunningActions = true;
      var zip = new __WEBPACK_IMPORTED_MODULE_4_jszip___default.a();
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').collection('lamps').select(['_id']).where('customer.id', this.customer._id).all().then(function (lamps) {
        var promises = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var lamp = _step.value;

            promises.push(__WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').where('referenceId', lamp._id).all());
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function (lampDocs) {
          var promises2 = [];
          var fileNames = [];
          var countLamps = 1;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(lampDocs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var doc = _step2.value;

              var file = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, doc[0]);
              if (!file.hasOwnProperty('_attachments')) {
                continue;
              }
              for (var index in file._attachments) {
                fileNames.push(index);
                promises2.push(__WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').getAttachment(file._id, index));
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises2).then(function (attachments) {
            for (var indexAttach in attachments) {
              var attachment = attachments[indexAttach];
              zip.file(countLamps + '_' + fileNames[indexAttach], attachment, attachment.type);
              countLamps++;
            }

            var data = _this.$moment().format('DD_MM_YYYY');
            var zipName = _this.customer.uc + '_' + data + '.zip';
            zip.generateAsync({ type: 'blob' }).then(function (blob) {
              __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, zipName);
            }).catch(function (err) {
              console.log('zip error', err);
            });
          }).catch(function (err) {
            console.log('#4 -> err', err);
          });
        }).catch(function (err) {
          console.log('#2 -> err', err);
        });
      }).catch(function (err) {
        console.log('#1 -> err', err);
      }).finally(function () {
        _this.isRunningActions = false;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('lamps', {
    allLamps: 'lampsAll',
    loading: 'loading'
  }), {

    lamps: function lamps() {
      if (this.allLamps.length <= 0) {
        return [];
      }
      var lampadas = [];
      this.allLamps.forEach(function (item) {
        for (var i = 0; i < item.items.length; i++) {
          item.items[i].userId = item.userId;
          if (item.hasOwnProperty('event')) {
            item.items[i].event = item.event;
          }
          lampadas.push(item.items[i]);
        }
      });
      return lampadas;
    },

    users: {
      get: function get() {
        return this.$store.state.users.all && this.$store.state.users.all.length > 0 ? this.$store.state.users.all.filter(function (item) {
          return item.role !== 'superadmin';
        }).reduce(function (obj, item) {
          obj[item._id] = item.name;
          return obj;
        }, {}) : {};
      }
    },

    countLamps: function countLamps() {
      return this.lamps.length;
    },

    hasEvent: function hasEvent() {
      return this.lamps.find(function (item) {
        return item.hasOwnProperty('event');
      });
    }
  })
});

/***/ }),

/***/ "CIYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CN5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CP+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Print_vue__ = __webpack_require__("H6kO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068c492e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Print_vue__ = __webpack_require__("5X45");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Print_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068c492e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Print_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CRWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CUgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"all","label":"Todos"}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2),_vm._v(" "),_c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.handleGenerate()}}},[_vm._v("Gerar tickets para o evento")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CWA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-check-in',
  props: {
    ticket: {
      required: true,
      type: Object
    },
    icon: {
      default: false
    },
    eventId: {
      default: false
    }
  },
  watch: {
    ticket: function ticket() {
      this.checked = this.ticket.checkIn;
    }
  },
  data: function data() {
    return {
      saving: false,
      checked: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tickets', ['setCheckIn', 'getTicketsByCustomer']), {
    handleChangeCheckInWinner: function handleChangeCheckInWinner() {
      var _this = this;

      this.saving = true;

      var _ticket = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ticket);
      _ticket.checkIn = !_ticket.checkIn;

      delete _ticket.customer;
      delete _ticket.event;
      delete _ticket.stock;

      __WEBPACK_IMPORTED_MODULE_2_src_services_Couchdb__["a" /* default */].connection('default').collection('tickets').updateWithView({ ddoc: 'tickets-by-id', view: 'tickets-by-id', payload: _ticket, database: 'default' }).then(function () {
        _this.$notify({
          message: 'Presença registrada com sucesso.',
          type: 'success'
        });
        _this.checked = _ticket.checkIn;
        _this.saving = false;
        _this.setCheckIn({
          id: _ticket._id,
          check: _ticket.checkIn
        });

        if (_this.customerId) {
          _this.getTicketsByCustomer(_this.customerId);
        }
      }).catch(function (err) {
        console.log(err);
        _this.$notify({
          message: 'Ocorreu algum problema ao registrar a presença. Entre em contato com o suporte.',
          type: 'danger'
        });
        _this.saving = false;
      });
    }
  }),
  computed: {
    unabled: function unabled() {
      return this.saving || !this.ticket.winner || !this.$can('tickets.checkin');
    }
  },
  mounted: function mounted() {
    this.checked = this.ticket.checkIn;
  }
});

/***/ }),

/***/ "CXtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTags_vue__ = __webpack_require__("ahWd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2427b66a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTags_vue__ = __webpack_require__("xmc8");
function injectStyle (ssrContext) {
  __webpack_require__("sSe4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2427b66a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CY2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTerm_vue__ = __webpack_require__("2uJI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315cc918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTerm_vue__ = __webpack_require__("Wex7");
function injectStyle (ssrContext) {
  __webpack_require__("Kf9e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-315cc918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTerm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315cc918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTerm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CfFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__ = __webpack_require__("TXVO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4295b5cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__ = __webpack_require__("tP8b");
function injectStyle (ssrContext) {
  __webpack_require__("Ay5H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4295b5cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4295b5cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cj6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingActions_vue__ = __webpack_require__("L7Um");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e4d40c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingActions_vue__ = __webpack_require__("qpED");
function injectStyle (ssrContext) {
  __webpack_require__("yyPk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e4d40c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e4d40c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ClD0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyListFilters_vue__ = __webpack_require__("Egb3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6554efcd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyListFilters_vue__ = __webpack_require__("TywH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyListFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6554efcd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyListFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cmd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CqfF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "CtiB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event && !_vm.event.drawn && !_vm.ticket.winner && !_vm.ticket.error && (typeof _vm.ticket.valid !== 'undefined'))?_c('button',{staticClass:"btn btn-fill btn-icon",class:!_vm.ticket.valid ? 'btn-info' : 'btn-error',attrs:{"title":!_vm.ticket.valid ? 'Validar ticket' : 'Invalidar ticket'},on:{"click":function($event){return _vm.onClick()}}},[_c('i',{class:!_vm.ticket.valid ? 'ti-check' : 'ti-close'})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cvn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-celpa-jurunas',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return 'Pará';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PA'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "Cydx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputCategoriesTags_vue__ = __webpack_require__("FQHW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e1a88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputCategoriesTags_vue__ = __webpack_require__("qePx");
function injectStyle (ssrContext) {
  __webpack_require__("eaj/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-005e1a88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputCategoriesTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e1a88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputCategoriesTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cyqh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocLocalDate',
  props: {
    city: {
      required: true
    }
  },
  data: function data() {
    return {
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      today: new Date()
    };
  },


  computed: {
    day: function day() {
      return this.today.getDay();
    },
    month: function month() {
      return this.monthNames[this.today.getMonth()];
    },
    year: function year() {
      return this.today.getFullYear();
    }
  }
});

/***/ }),

/***/ "D/ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":_vm.placeholder},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleQuery($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"input-group-addon",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.handleQuery($event)}}},[_c('i',{class:_vm.iconClass})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D1tU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnelGo_vue__ = __webpack_require__("8ecr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57caddb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnelGo_vue__ = __webpack_require__("T1Lb");
function injectStyle (ssrContext) {
  __webpack_require__("zG9H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57caddb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnelGo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57caddb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnelGo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D5dz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D9Mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip__ = __webpack_require__("WgY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_ImageSuport__ = __webpack_require__("HKKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_services_LGPD__ = __webpack_require__("rdXj");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnDownloadOldPresenter',

  data: function data() {
    return {
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tickets', {
    ticketsWinners: 'winners'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['changeExecution']), {
    handlePresentationFile: function handlePresentationFile() {
      var _this = this;

      this.loading = true;
      this.zipper().then(function (res) {
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    zipper: function zipper() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var xmlText, zip, attachmentsPhotos, resizedPhotos, id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.changeExecution(true);
                xmlText = _this2.makeXML();
                zip = new __WEBPACK_IMPORTED_MODULE_5_jszip___default.a();

                zip.file('sorteio.xml', xmlText, 'application/xml');

                _context.next = 6;
                return _this2.getAttachmentPhotos();

              case 6:
                attachmentsPhotos = _context.sent;
                _context.next = 9;
                return _this2.getResizedImages(attachmentsPhotos);

              case 9:
                resizedPhotos = _context.sent;


                for (id in resizedPhotos) {
                  zip.file('fotos/' + _this2.customers[_this2.ticketsWinners[id].customerId].uc + '.jpg', resizedPhotos[id].blob);
                }
                zip.generateAsync({ type: 'blob' }).then(function (blob) {
                  __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(blob, 'presentation.zip');
                });
                _this2.changeExecution(false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getAttachmentPhotos: function getAttachmentPhotos() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var attachmentsPhotos, id, anexo;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                attachmentsPhotos = [];
                _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this3.ticketsWinners);

              case 2:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 19;
                  break;
                }

                id = _context2.t1.value;
                anexo = false;
                _context2.prev = 5;

                if (!(typeof _this3.customers[_this3.ticketsWinners[id].customerId] === 'undefined')) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('continue', 2);

              case 8:
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].getAttachment(_this3.customers[_this3.ticketsWinners[id].customerId]._id, 'image.jpg');

              case 10:
                anexo = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t2 = _context2['catch'](5);

                console.log('error', _context2.t2);

              case 16:
                attachmentsPhotos.push(anexo);
                _context2.next = 2;
                break;

              case 19:
                return _context2.abrupt('return', attachmentsPhotos);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 13]]);
      }))();
    },
    getResizedImages: function getResizedImages(attachmentsPhotos) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resizedPhotos, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, image;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                resizedPhotos = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(attachmentsPhotos);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 16;
                  break;
                }

                file = _step.value;

                if (!file) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_7_src_services_ImageSuport__["a" /* imageSuportService */].resizeImage(file, {
                  canvasId: 'canvasPlace',
                  maxWidth: 320,
                  maxHeight: 240,
                  maxQuality: 100
                });

              case 11:
                image = _context3.sent;

                resizedPhotos.push(image);

              case 13:
                _iteratorNormalCompletion = true;
                _context3.next = 6;
                break;

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 22:
                _context3.prev = 22;
                _context3.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context3.prev = 25;

                if (!_didIteratorError) {
                  _context3.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context3.finish(25);

              case 29:
                return _context3.finish(22);

              case 30:
                return _context3.abrupt('return', resizedPhotos);

              case 31:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    makeXML: function makeXML() {
      var xml = '<sorteio>' + this.ticketsWinners.length + '</sorteio>';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.ticketsWinners), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var t = _step2.value;

          var customer = this.customers[t.customerId];

          if (!customer || customer.hasOwnProperty('_deleted')) {
            continue;
          }

          var holder = customer.holder;

          var nome = this.config.useLGPD ? __WEBPACK_IMPORTED_MODULE_9_src_services_LGPD__["a" /* default */].obfuscateString(holder) : holder;

          xml += '<sorteado>';
          xml += '<nome>' + nome.toUpperCase() + '</nome>';
          xml += '<uc>' + customer.uc + '</uc>';
          xml += '<imagem>' + customer.uc + '.jpg</imagem>';
          xml += '</sorteado>';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return xml;
    }
  })
});

/***/ }),

/***/ "DAJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsConfigForm_vue__ = __webpack_require__("ivmY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfde6a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsConfigForm_vue__ = __webpack_require__("jDxo");
function injectStyle (ssrContext) {
  __webpack_require__("qcMG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cfde6a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsConfigForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfde6a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsConfigForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.handleCustomersContemplado()}}},[_vm._v("\n    Colocar contemplated=true nos Clientes ganhadores\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DF1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DFXt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.ticket.error)?_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.reason}}):_vm._e(),_vm._v(" "),(!_vm.ticket.error && _vm.notEligible)?_c('i',{staticClass:"ti-alert text-danger",attrs:{"title":_vm.reason}}):_vm._e(),_vm._v(" "),(_vm.hasStock)?_c('i',{staticClass:"ti-truck text-success",attrs:{"title":"Associado ao estoque."}}):_vm._e(),_vm._v(" "),(_vm.oldWinner)?_c('i',{staticClass:"ti-medall-alt text-danger",attrs:{"title":"Cliente já contemplado anteriormente."}}):_vm._e(),_vm._v(" "),(_vm.winner)?_c('i',{staticClass:"ti-medall-alt text-warning",attrs:{"title":"Ganhador"}}):_vm._e(),_vm._v(" "),(_vm.wasDocumented)?_c('i',{staticClass:"ti-files text-primary",attrs:{"title":"Documentado"}}):_vm._e(),_vm._v(" "),(_vm.checkIn)?_c('i',{staticClass:"ti-check text-success",attrs:{"title":"Presença registrada"}}):_vm._e(),_vm._v(" "),(_vm.ticket.valid)?_c('i',{staticClass:"ti-check-box text-success",attrs:{"title":"Cadastro online válido"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DN+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DSuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text logo-mini",attrs:{"href":""}},[_c('div',[_c('img',{staticClass:"img-logo",attrs:{"src":_vm.logo}})])]),_vm._v(" "),_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":""}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return (_vm.showPage(subLink))?_c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}}):_vm._e()}),1)}))],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Da5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-detail"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p-search',{staticClass:"input-group input-group-lg",attrs:{"placeholder":"Buscar cliente por UC ..."},on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('customer-card',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.customer._id),expression:"!customer._id"}],attrs:{"customer":_vm.customer,"showEditButton":false}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('customer-image-card',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.customer._id),expression:"!customer._id"}],attrs:{"timestampImage":_vm.currentDate,"has-image":true,"customer":_vm.customer,"showEditButton":false}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.customer),expression:"!customer"}],staticStyle:{"min-height":"50px"}},_vm._l((_vm.tickets),function(ticket){return _c('div',{key:ticket._id,staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-xs-12"},[_c('ticket-card',{directives:[{name:"loading",rawName:"v-loading",value:(ticket.customer && ticket.event),expression:"ticket.customer && ticket.event"}],attrs:{"ticket":ticket,"event":ticket.event,"stock":ticket.stock},on:{"loadTicket":function($event){return _vm.redirectToTicket(ticket)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xs-12"},[_c('event-card',{attrs:{"event":ticket.event,"show-edit-button":false}})],1)])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('lamps-list',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"customer":_vm.customer,"lamps":_vm.lamps}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DfKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__ = __webpack_require__("+m/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__ = __webpack_require__("lS3b");
function injectStyle (ssrContext) {
  __webpack_require__("psw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dlhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignatureCustomerTicket_vue__ = __webpack_require__("+qzf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740658e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignatureCustomerTicket_vue__ = __webpack_require__("eRNp");
function injectStyle (ssrContext) {
  __webpack_require__("LwYb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-740658e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignatureCustomerTicket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740658e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignatureCustomerTicket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DpVz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dske":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{ref:"gmap",staticStyle:{"width":"100%","height":"500px","margin-top":"10px"},attrs:{"center":_vm.center,"zoom":_vm.defaultZoom,"zoomControl":"","options":{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
              gestureHandling: 'cooperative'
            }}},[_c('InfoContentGmap',{attrs:{"infoWinOpen":_vm.infoWinOpen,"infoWindowPos":_vm.infoWindowPos,"infoContent":_vm.infoContent,"bgcolor":_vm.infoContent.type === 'EDU' ? '#45bcf3' : '#f3bb45',"title":_vm.infoContent.type === 'TRG' ? 'Informações do Evento' : 'Informações da Palestra'},on:{"close":function($event){_vm.infoWinOpen = false}}}),_vm._v(" "),_vm._l((_vm.eventsSpecifications),function(marker,i){return _c('Gmap-Marker',{key:i,attrs:{"position":marker.gps,"clickable":true,"icon":_vm.getPinUrl(marker)},on:{"click":function($event){return _vm.toggleInfoWindow(marker,marker._id, _vm.setContentTRG)}}})}),_vm._v(" "),_vm._l((_vm.eduMarkerCoodinates),function(marker){return _c('Gmap-Marker',{key:marker._id,attrs:{"position":marker.gps,"clickable":true,"icon":_vm.imageEdu},on:{"click":function($event){return _vm.toggleInfoWindow(marker,marker._id, _vm.setContentEDU)}}})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Durk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agile",class:{'agile--auto-play': _vm.settings.autoplay, 'agile--disabled': _vm.settings.unagile, 'agile--fade': _vm.settings.fade && !_vm.settings.unagile, 'agile--rtl': _vm.settings.rtl}},[_c('div',{ref:"list",staticClass:"agile__list"},[_c('div',{ref:"track",staticClass:"agile__track",style:({transform: ("translate(" + (_vm.translateX + _vm.marginX) + "px)"), transition: ("transform " + (_vm.settings.timing) + " " + _vm.transitionDelay + "ms")}),on:{"mouseover":function($event){return _vm.handleMouseOver('track')},"mouseout":function($event){return _vm.handleMouseOut('track')}}},[(_vm.clonedSlides)?_c('div',{ref:"slidesClonedBefore",staticClass:"agile__slides agile__slides--cloned"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('div',{ref:"slides",staticClass:"agile__slides agile__slides--regular"},[_vm._t("default")],2),_vm._v(" "),(_vm.clonedSlides)?_c('div',{ref:"slidesClonedAfter",staticClass:"agile__slides agile__slides--cloned"},[_vm._t("default")],2):_vm._e()])]),_vm._v(" "),(!_vm.settings.unagile && (_vm.settings.navButtons || _vm.settings.dots))?_c('div',{staticClass:"agile__actions"},[(_vm.settings.navButtons && !_vm.settings.unagile)?_c('button',{ref:"prevButton",staticClass:"agile__nav-button agile__nav-button--prev",attrs:{"disabled":!_vm.canGoToPrev,"type":"button"},on:{"click":function($event){_vm.goToPrev(), _vm.restartAutoPlay()}}},[_vm._t("prevButton",[_vm._v("←")])],2):_vm._e(),_vm._v(" "),(_vm.settings.dots && !_vm.settings.unagile)?_c('ul',{ref:"dots",staticClass:"agile__dots"},_vm._l((_vm.slidesCount),function(n){return _c('li',{key:n,staticClass:"agile__dot",class:{'agile__dot--current': n - 1 === _vm.currentSlide},on:{"mouseover":function($event){return _vm.handleMouseOver('dot')},"mouseout":function($event){return _vm.handleMouseOut('dot')}}},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.goTo(n - 1), _vm.restartAutoPlay()}}},[_vm._v(_vm._s(n))])])}),0):_vm._e(),_vm._v(" "),(_vm.settings.navButtons && !_vm.settings.unagile)?_c('button',{ref:"nextButton",staticClass:"agile__nav-button agile__nav-button--next",attrs:{"disabled":!_vm.canGoToNext,"type":"button"},on:{"click":function($event){_vm.goToNext(), _vm.restartAutoPlay()}}},[_vm._t("nextButton",[_vm._v("→")])],2):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dwjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__ = __webpack_require__("Peng");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__ = __webpack_require__("EQjs");
function injectStyle (ssrContext) {
  __webpack_require__("zmm5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DxtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersIndex_vue__ = __webpack_require__("j4l9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e88446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersIndex_vue__ = __webpack_require__("l7bH");
function injectStyle (ssrContext) {
  __webpack_require__("RAVI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e88446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dxwg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DzKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.view.presenter'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-pptx btn-block btn-router",on:{"click":function($event){return _vm.download()}}},[_vm._v("\n  PPT Clientes Reservas\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DzSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.currentTerms),function(company,index){return _c('p-radio',{key:index,attrs:{"label":company},on:{"input":function($event){return _vm.emitEvent(company)}},model:{value:(_vm.companyTerms),callback:function ($$v) {_vm.companyTerms=$$v},expression:"companyTerms"}},[_vm._v("\n    "+_vm._s(company.toUpperCase())+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E0D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
    }
  }
});

/***/ }),

/***/ "E0Qc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_Helper__ = __webpack_require__("leRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'events-report',

  props: { eventSelected: {}, csvSeparator: {}, allEvents: {} },

  data: function data() {
    return {
      loading: false,
      event: '',
      tickets: [],
      csvHeaders: {
        customer: {
          'uc': 'UC',
          'cpf': 'CPF',
          'nationalId': 'RG',
          'holder': 'Nome',
          'aka': 'Apelido',
          'phone1': 'Telefones',
          'address.street': 'Logradouro',
          'address.number': 'Numero',
          'address.neighborhood': 'Bairro',
          'address.city': 'Município',
          'address.zip': 'CEP',
          'address.complement': 'Complemento',
          'observartion': 'Observação',
          'nis': 'NIS',
          'createdBy': 'Cliente cadastrado por'
        },
        ticket: {
          'winner': 'Sorteado',
          'documentedAt': 'Data documentação',
          'barcode': 'Código de barra',
          'checkIn': 'Presente',
          'createdBy': 'Ticket gerado por'
        },
        event: {
          'city': 'Município',
          'reference': 'Referência',
          'place': 'Local',
          'startDate': 'Data início',
          'endDate': 'Data fim',
          'dateTimeCeremony': 'Data da cerimônia',
          'numberOfRefigerators': 'Qtd. refrigeradores',
          'drawn': 'Houve sorteio?',
          'createdBy': 'Evento criado por'
        },
        stock: {
          'invoice': 'Nota fiscal',
          'dateInvoice': 'Data de emissão da nota fiscal',
          'invoicePowerCompany': 'Nota fiscal da concessionária',
          'dateInvoicePowerCompany': 'Data de emissão da nota fiscal da concessionária',
          'numberOfRefigerators': 'Quantidade de geladeiras',
          'description': 'Descrição do produto',
          'createdBy': 'Estoque criado por'
        },
        manufacturer: { 'name': 'Fabricante', 'createdBy': 'Criado por' }
      }
    };
  },

  methods: {
    runReport: function runReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('progress', { current: 0, total: 0 });
                _this.loading = true;
                _this.resetValues();
                _context.prev = 3;
                _context.next = 6;
                return _this.getEvent();

              case 6:
                _this.event = _context.sent;

                _this.event.createdBy = _this.usersIdName[_this.event.userId];
                _context.next = 10;
                return _this.getTickets();

              case 10:
                _this.tickets = _context.sent;

                _this.getReportEvent();
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.$notify({
                  message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
                  type: 'danger'
                });

              case 18:
                _context.prev = 18;

                _this.loading = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 14, 18, 21]]);
      }))();
    },
    getEvent: function getEvent() {
      var select = ['_id', 'city', 'reference', 'place', 'startDate', 'endDate', 'dateTimeCeremony', 'numberOfRefigerators', 'drawn', 'createdAt', 'userId'];
      return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('events').select(select).find(this.eventSelected);
    },
    getTickets: function getTickets() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tickets, customers, stocks, manufacturers;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('tickets').where('eventId', _this2.event._id).get();

              case 2:
                tickets = _context2.sent;
                _context2.next = 5;
                return _this2.getCustomersIn(tickets);

              case 5:
                customers = _context2.sent;
                _context2.next = 8;
                return _this2.getStocksIn(tickets);

              case 8:
                stocks = _context2.sent;
                _context2.next = 11;
                return _this2.getManufacturersIn(stocks);

              case 11:
                manufacturers = _context2.sent;
                return _context2.abrupt('return', _this2.mappingTickets(tickets, customers, stocks, manufacturers));

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCustomersIn: function getCustomersIn(tickets) {
      var select = ['_id', 'uc', 'cpf', 'nationalId', 'holder', 'aka', 'phone1', 'address.street', 'address.number', 'address.neighborhood', 'address.city', 'address.zip', 'address.complement', 'observartion', 'nis', 'userId'];
      var ticketsCustomersId = tickets.map(function (item) {
        return item.customerId;
      });
      return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('customers').select(select).whereIn('_id', ticketsCustomersId).get();
    },
    getStocksIn: function getStocksIn(tickets) {
      var select = ['_id', 'invoice', 'dateInvoice', 'invoicePowerCompany', 'dateInvoicePowerCompany', 'numberOfRefigerators', 'description', 'manufacturerId', 'userId'];
      var ticketsSotkcId = tickets.filter(function (item) {
        return item.stockId !== null;
      }).map(function (item) {
        return item.stockId;
      });
      return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('stocks').select(select).whereIn('_id', ticketsSotkcId).get();
    },
    getManufacturersIn: function getManufacturersIn(stocks) {
      var select = ['_id', 'name', 'userId'];
      var manufacturersId = stocks.map(function (item) {
        return item.manufacturerId;
      });
      return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('manufacturers').select(select).whereIn('_id', manufacturersId).get();
    },
    mappingTickets: function mappingTickets(tickets, customers, stocks, manufacturers) {
      var _this3 = this;

      tickets.map(function (item) {
        item.createdBy = _this3.usersIdName[item.userId];
        item.customer = customers.find(function (customer) {
          return customer._id === item.customerId;
        });
        if (item.customer) item.customer.createdBy = _this3.usersIdName[item.customer.userId];
        item.stock = stocks.find(function (stock) {
          return stock._id === item.stockId;
        });
        if (item.stock) item.stock.createdBy = _this3.usersIdName[item.stock.userId];
        item.manufacturer = manufacturers.find(function (manufacturer) {
          return item.hasOwnProperty('stock') && item.stock && item.stock.hasOwnProperty('manufacturerId') && manufacturer._id === item.stock.manufacturerId;
        });
        if (item.manufacturer) item.manufacturer.createdBy = _this3.usersIdName[item.manufacturer.userId];
      });
      return tickets;
    },
    resetValues: function resetValues() {
      this.event = '';
      this.tickets = [];
    },
    addHeaders: function addHeaders() {
      var csv = '';
      csv += this.addHeader(this.csvHeaders.customer);
      csv += this.addHeader(this.csvHeaders.ticket);
      csv += this.addHeader(this.csvHeaders.event);
      csv += this.addHeader(this.csvHeaders.stock);
      csv += this.addHeader(this.csvHeaders.manufacturer);
      csv += '\n';
      return csv;
    },
    addHeader: function addHeader(headers) {
      var csv = '';
      for (var h in headers) {
        csv += '' + headers[h] + this.csvSeparator;
      }
      return csv;
    },
    addBodies: function addBodies() {
      var csv = '';
      if (this.tickets.length < 1) {
        this.loading = false;
        this.$notify({
          message: 'Não há tickets para este evento.',
          type: 'warning'
        });
      } else {
        for (var t in this.tickets) {
          csv += this.addBody(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.customer), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_Helper__["c" /* flattenObject */])(this.tickets[t].customer));
          csv += this.addBody(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.ticket), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_Helper__["c" /* flattenObject */])(this.tickets[t]));
          csv += this.addBody(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.event), this.event);
          csv += this.addBody(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.stock), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_Helper__["c" /* flattenObject */])(this.tickets[t].stock));
          csv += this.addBody(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.manufacturer), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_Helper__["c" /* flattenObject */])(this.tickets[t].manufacturer));
          csv += '\n';
          var current = parseInt(t) + 1;
          this.$emit('progress', { current: current, total: this.tickets.length });
        }
      }
      return csv;
    },
    addBody: function addBody(keys, obj) {
      var csv = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (!obj || !obj.hasOwnProperty(key) || key !== 'drawn' && typeof obj[key] === 'undefined') {
            csv += '"-"' + this.csvSeparator;
            continue;
          }

          if (['endDate', 'startDate', 'createdAt', 'dateTimeCeremony', 'documentedAt', 'dateInvoice', 'dateInvoicePowerCompany', 'updatedAt'].indexOf(key) >= 0) {
            csv += obj[key] ? '"' + this.$moment(obj[key]).format('L') + ' ' + this.$moment(obj[key]).format('LTS') + '"' + this.csvSeparator : '-' + this.csvSeparator;
            continue;
          }

          if (obj[key].toString() === 'true' || obj[key].toString() === 'false' || obj[key] === null || key === 'drawn') {
            csv += obj[key] ? '"Sim"' + this.csvSeparator : '"N\xE3o"' + this.csvSeparator;
            continue;
          }

          switch (key) {
            case 'checkIn':
              csv += obj[key] ? '"Sim"' + this.csvSeparator : '"N\xE3o"' + this.csvSeparator;
              break;
            case 'phone1':
              csv += '"' + obj[key] + ' / ' + (obj['phone2'] ? obj['phone2'] : '-') + '"' + this.csvSeparator;
              break;
            default:
              csv += '"' + obj[key] + '"' + this.csvSeparator;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return csv;
    },
    getReportEvent: function getReportEvent() {
      var csv = '';
      csv += this.addHeaders();
      csv += this.addBodies();
      var blob = __WEBPACK_IMPORTED_MODULE_5_blob_util___default.a.createBlob([csv], { type: 'text/plain' });
      var start = this.$moment(this.event.startDate).format('DD-MM-YYYY');
      var end = this.$moment(this.event.endDate).format('DD-MM-YYYY');
      __WEBPACK_IMPORTED_MODULE_6_downloadjs___default()(blob, 'Relat\xF3rio_Evento_' + this.event.city + '_' + start + '_' + end + '.csv');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('users', ['usersIdName']))
});

/***/ }),

/***/ "E7++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_PptPresenter__ = __webpack_require__("iMuy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnDownloadPptxSubstituteCustomers',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tickets', {
    elegibleNotWinner: 'elegibleNotWinner'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', { urlImages: 'urlImages' })),
  methods: {
    download: function download() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Confirmação',
                  html: 'Confirmar download da apresentação.',
                  type: 'info',
                  confirmButtonText: 'Iniciar',
                  showCloseButton: true,
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                      var customersElelibleNotWinner;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              customersElelibleNotWinner = _this.elegibleNotWinner.slice(0, 20);
                              _context.next = 3;
                              return __WEBPACK_IMPORTED_MODULE_4_src_services_PptPresenter__["a" /* default */].make(customersElelibleNotWinner, _this.customers, 'Reservas', _this.urlImages);

                            case 3:
                              return _context.abrupt('return', 'ok');

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function preConfirm() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "E7lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'customers.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E93u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.regularity),expression:"modelValidations.additionalData.regularity"}],staticClass:"form-control",attrs:{"name":"city"},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)},"input":function($event){return _vm.$emit('input', $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione ...\n  ")]),_vm._v(" "),_c('option',{attrs:{"value":"paidAccount"}},[_vm._v("Conta paga")]),_vm._v(" "),_c('option',{attrs:{"value":"installmentOfAccount"}},[_vm._v("Parcelamento de conta")]),_vm._v(" "),_c('option',{attrs:{"value":"secondWayAccount"}},[_vm._v("2ª via de conta")]),_vm._v(" "),_c('option',{attrs:{"value":"changeOfTitularity"}},[_vm._v("Troca de titularidade")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ECZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5cm"}},[_vm._v("\n    "+_vm._s(_vm.payload.customer.address.city)+", "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new
    Date(),'YYYY'))+"\n  ")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    ________________________________________________________________________\n    "),_c('br'),_vm._v("\n    Assinatura do(a) cliente beneficiado\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Satellite Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map map-big",attrs:{"id":"satelliteMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Regular Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"regularMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Custom Skin & Settings Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"customSkinMap"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EXKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EXfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reactivate-user-action',

  props: {
    user: {}
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['loading'])),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', ['upsert']), {
    handleInactivate: function handleInactivate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        text: 'Deseja reativar ' + this.user.name + '?',
        title: 'Atenção',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        type: 'info'
      }).then(function () {
        _this.upsert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.user, { inactivate: false })).then(function () {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('Desativado!', 'Usuário reativado com sucesso', 'success');
          _this.$emit('fetch');
        });
      });
    }
  })
});

/***/ }),

/***/ "EYrD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyCustomerContent_vue__ = __webpack_require__("gdYT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b3ad9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyCustomerContent_vue__ = __webpack_require__("lfQW");
function injectStyle (ssrContext) {
  __webpack_require__("rFJE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31b3ad9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyCustomerContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b3ad9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyCustomerContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EdOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "Eg3L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Egb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-list-filters',

  props: ['tickets', 'customers'],

  data: function data() {
    return {
      filters: {
        status: [],
        neighborhood: [],
        users: []
      },
      statusFilter: {
        options: [{ label: 'Associados', value: 'associated' }, { label: 'Não associados', value: 'notAssociated' }, { label: 'Pesquisados', value: 'surveyed' }, { label: 'Não pesquisados', value: 'notSurveyed' }]
      },
      userActivate: this.showInactivate || false
    };
  },


  watch: {
    setShowInactivate: function setShowInactivate() {
      var _this = this;

      this.$nextTick(function () {
        _this.userActivate = _this.setShowInactivate;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', {
    users: 'usersIdName',
    showInactivate: 'showInactivate'
  }), {
    usersOptinos: function usersOptinos() {
      var options = [];
      for (var index in this.users) {
        options.push({ label: this.users[index], value: index });
      }
      return options;
    },
    neigborhoodOptions: function neigborhoodOptions() {
      var _this2 = this;

      var neigh = this.tickets.filter(function (item) {
        return _this2.customers[item.customerId];
      }).map(function (item) {
        return _this2.customers[item.customerId].address.neighborhood.toUpperCase();
      }).reduce(function (accum, current, index) {
        if (index === 0) {
          accum = {};
        }
        accum[current] = null;
        return accum;
      }, {});

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(neigh).sort(function (a, b) {
        return a.localeCompare(b);
      }).map(function (item) {
        return { name: item, value: item };
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', {
    setShowInactivate: 'setShowInactivate'
  }), {
    emitChangeFilter: function emitChangeFilter() {
      this.$emit('changeFilter', this.filters);
    }
  }),

  mounted: function mounted() {
    this.setShowInactivate(false);
  }
});

/***/ }),

/***/ "Ekgi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "El0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));

/***/ }),

/***/ "Em9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.event.status === 0)?_c('i',{staticClass:"text-success ti-control-pause",attrs:{"title":"Programado"}}):_vm._e(),_vm._v(" "),(_vm.event.status === 1)?_c('i',{staticClass:"text-success ti-control-play",attrs:{"title":"Iniciado"}}):_vm._e(),_vm._v(" "),(_vm.event.status === 2)?_c('i',{staticClass:"text-danter ti-control-stop",attrs:{"title":"Finalizado"}}):_vm._e(),_vm._v(" "),(_vm.event.directList === true)?_c('i',{staticClass:"text-info ti-list-ol",attrs:{"title":"Lista direta"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EmQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'stock.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ewv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnelCe_vue__ = __webpack_require__("We3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acd12a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnelCe_vue__ = __webpack_require__("J3uq");
function injectStyle (ssrContext) {
  __webpack_require__("Dxwg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6acd12a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnelCe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acd12a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnelCe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ExTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-term-cemar"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('p',{staticStyle:{"color":"#aaaaaa","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.payload.eventId) + "-" + (_vm.payload.customer._id)))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row margin-top"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A COMPANHIA ENERGÉTICA DO MARANHÃO – CEMAR, empresa privada, concessionária de serviços públicos, com sede na cidade de São Luís, Estado do Maranhão, na Alameda A, Quadra SQS, nº. 100, Loteamento Quitandinha – Altos do Calhau, devidamente inscrita no CNPJ 06.272.793/0001-84, e o(a) Sr.(a). "+_vm._s(_vm.payload.customer.holder)+", RG "+_vm._s(_vm.payload.customer.nationalId)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+" "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado(a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" CDN n.º "+_vm._s(_vm.payload.customer.uc)+" firmam o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A CEMAR realizará a troca de até "+_vm._s(_vm.payload.config.lamps.max)+" lâmpadas fluorescente ou incandescentes, por lâmpadas de LED de "+_vm._s(_vm.powerLampDeliveryLabel)+"W devendo estas ser entregues à CEMAR no ato da substituição;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à CEMAR  para substituição.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a CEMAR.\n        ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5cm"}},[_vm._v("\n        Fortaleza, "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new Date(),'YYYY'))+"\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('span',{staticStyle:{"display":"inline-block","border-bottom":"1px solid #000","min-width":"500px","width":"70%"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"uppercase"},[_vm._v(" "+_vm._s(_vm.payload.customer.holder)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.payload.customer.cpf)?_c('span',[_vm._v(" CPF: "+_vm._s(_vm.payload.customer.cpf)+" ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.payload.customer.nationalId)?_c('span',[_vm._v(" RG: "+_vm._s(_vm.payload.customer.nationalId)+" ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"/static/img/cema-logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 text-center"},[_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          A CEMAR está desenvolvendo o “Projeto Comunidade Eficiente - + Economia” que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às praticas relacionadas ao uso racional de energia elétrica, enquadra-se como tal, o uso de lâmpadas econômicas;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A CEMAR buscando viabilizar essa prática nas comunidades atendidas pelo “Projeto Comunidade Eficiente - + Economia”, entre outras ações, disponibilizará lâmpadas econômicas para serem substituídas nas unidades consumidoras atendidas, nas condições seguintes:\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia” suspensos;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário, desde já, autoriza a inspeção pelos funcionários da CEMAR, para verificação da quantidade/estado das lâmpadas substituídas, em caso de irregularidade terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia”  suspensos.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficam ligadas no horário das 17:30 às 20:30? _____________\n        ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EyBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'migrate-events-specifications-to-new-database',
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      events: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('tags', ['tagsByCategories']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('categories', ['categories']), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('events', { fetchEvents: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tags', { fetchTags: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('categories', { fetchCategories: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('eventsSpecifications', { fetchSpecifications: 'fetchAll', upsertSpecifications: 'upsert' }), {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var events;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _this.total = 0;
                _this.progress = 0;
                _context.prev = 3;
                _context.next = 6;
                return _this.fetchEvents({ select: ['_id', 'reference', 'city', 'tags', 'gps'], limit: 9999 });

              case 6:
                events = _context.sent;

                _this.total = events.length;

                _this.isLoading = false;
                if (_this.total === 0) {
                  _this.notifyFinish();
                } else {
                  _this.notifyAmount().then(function () {
                    try {
                      _this.initExec(events);
                    } catch (e) {
                      console.log('Falha no processo', e);
                    }
                  });
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.isLoading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 12]]);
      }))();
    },
    initExec: function initExec(events) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Atenção',
        text: 'Todos os Eventos v\xE3o ser migrados agora.',
        type: 'warning',
        confirmButtonText: 'Iniciar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this2.exec(events);

                  case 2:
                    return _context2.abrupt('return', 'ok');

                  case 3:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function () {
        setTimeout(function () {
          location.reload();
        }, 3000);
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        });
      });
    },
    exec: function exec(events) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _loop = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop(event) {
                  var tagsSpecifications, _loop2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, tag;

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          tagsSpecifications = {};

                          if (!event.hasOwnProperty('tags')) {
                            _context3.next = 22;
                            break;
                          }

                          _loop2 = function _loop2(tag) {
                            for (var categorie in _this3.tagsByCategories) {
                              if (_this3.tagsByCategories[categorie].find(function (item) {
                                return item._id === tag;
                              })) {
                                tagsSpecifications[categorie] = tag;
                                break;
                              }
                            }
                          };

                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context3.prev = 6;

                          for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(event.tags); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            tag = _step2.value;

                            _loop2(tag);
                          }
                          _context3.next = 14;
                          break;

                        case 10:
                          _context3.prev = 10;
                          _context3.t0 = _context3['catch'](6);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context3.t0;

                        case 14:
                          _context3.prev = 14;
                          _context3.prev = 15;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 17:
                          _context3.prev = 17;

                          if (!_didIteratorError2) {
                            _context3.next = 20;
                            break;
                          }

                          throw _iteratorError2;

                        case 20:
                          return _context3.finish(17);

                        case 21:
                          return _context3.finish(14);

                        case 22:
                          _context3.next = 24;
                          return _this3.fetchSpecifications({ where: { eventId: event._id } }).then(function (spec) {
                            var eventSpec = {};
                            if (spec.length > 0) {
                              return;
                            }

                            eventSpec = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(eventSpec, {
                              sourceDb: "trg_eqpi_notiasc_admin",
                              eventId: event._id,
                              event: {
                                city: event.city,
                                reference: event.reference
                              },
                              gps: {
                                lat: event.hasOwnProperty('gps') ? event.gps.lat : 0,
                                lng: event.hasOwnProperty('gps') ? event.gps.lng : 0
                              },
                              tags: tagsSpecifications,
                              tagsIds: event.tags
                            });
                            _this3.upsertSpecifications(eventSpec);
                          });

                        case 24:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this3, [[6, 10, 14, 22], [15,, 17, 21]]);
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(events);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 12;
                  break;
                }

                event = _step.value;
                return _context4.delegateYield(_loop(event), 't0', 9);

              case 9:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t1 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 18:
                _context4.prev = 18;
                _context4.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context4.prev = 21;

                if (!_didIteratorError) {
                  _context4.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context4.finish(21);

              case 25:
                return _context4.finish(18);

              case 26:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee3, _this3, [[4, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },
    notifyAmount: function notifyAmount() {
      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Eventos',
        html: 'Deseja migrar dados dos ' + this.total + ' eventos?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, migrar os dados!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      this.total = 1;
      this.progress = 1;
      this.eventLamps = 1;
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todas as l\xE2mpadas foram atualizadas com seus respectivos ID dos eventos',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }),

  mounted: function mounted() {
    this.fetchTags({ limit: 999 });
    this.fetchCategories({ limit: 999 });
  }
});

/***/ }),

/***/ "F/hw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F/pk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("SY3H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e7e3ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("lI0u");
function injectStyle (ssrContext) {
  __webpack_require__("7NG8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e7e3ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F0oW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Reports_Reports__ = __webpack_require__("1Uua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Reports_ReportsIndex__ = __webpack_require__("pq1s");



var path = 'reports';
var title = 'Relatórios';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Reports_Reports__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Reports_ReportsIndex__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "F1m7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"1em","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s((_vm.eventId + "-" + _vm.ticketId))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticStyle:{"max-height":"60px"},attrs:{"src":_vm.imgsrc}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FBJP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FFYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Trg_YesNoRadio__ = __webpack_require__("bkdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Trg_Tags_ListTags__ = __webpack_require__("CXtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Trg_CompanyTermsRadios__ = __webpack_require__("H5GJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trg_Event_DocumentsEventFormComponents__ = __webpack_require__("xeBW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trg_Event_LampEventConfigFormConmponent__ = __webpack_require__("6lLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_services_LGPD__ = __webpack_require__("rdXj");






















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TagList: __WEBPACK_IMPORTED_MODULE_10__components_Trg_Tags_ListTags__["a" /* default */],
    CompanyTermsRadios: __WEBPACK_IMPORTED_MODULE_11_src_components_Trg_CompanyTermsRadios__["a" /* default */],
    DocumentsEventFormComponents: __WEBPACK_IMPORTED_MODULE_12__components_Trg_Event_DocumentsEventFormComponents__["a" /* default */],
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_9__components_Trg_YesNoRadio__["a" /* default */],
    LampEventConfigFormConmponent: __WEBPACK_IMPORTED_MODULE_13__components_Trg_Event_LampEventConfigFormConmponent__["a" /* default */]
  },

  data: function data() {
    return {
      saving: false,
      indexPath: { name: 'events.index' },
      entityName: 'Evento',
      formatted_address: '',
      defaultZoom: 15,
      mapPlace: null,
      marker: null,
      isLoading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['city', 'reference', 'place', 'startDate', 'endDate', 'dateTimeCeremony', 'dateTimeDelivery', 'numberOfRefigerators', 'numberOfLamps', 'status', 'directList', 'registerCustomerByCsv', 'confirmCustomerByCsv', 'downloadWinnersCsv', 'downloadWinnersPpt']), {
    model: {
      get: function get() {
        return this.$store.state.events.one;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('events', {
    modelValidations: 'validations',
    loading: 'loading',
    statusOptions: 'statusOptions',
    surveysOptions: 'surveysOptions'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('project', {
    citiesOptions: 'citiesOptions',
    config: 'project',
    termsOfState: 'termsOfState'
  }), {

    couchdbCustomers: function couchdbCustomers() {
      return new __WEBPACK_IMPORTED_MODULE_15_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },

    couchdbTickets: function couchdbTickets() {
      return new __WEBPACK_IMPORTED_MODULE_15_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },

    couchdbLamps: function couchdbLamps() {
      return new __WEBPACK_IMPORTED_MODULE_15_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },

    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    },
    title: function title() {
      return this.editing ? 'Editar ' + this.entityName : 'Novo ' + this.entityName;
    },


    haveSurveys: {
      get: function get() {
        return this.config.haveSurveys;
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('events', ['fetchOne', 'fetchViewOne', 'resetOne', 'insert', 'upsertWithView', 'upsert']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('customers', { upsertCustomer: 'upsert' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('eventsSpecifications', { upsertSpecifications: 'upsert', findSpecification: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.validSave();
        }
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        _this.saving = false;
      });
    },
    validSave: function validSave() {
      var _this2 = this;

      var lastStatus = this.model.lastStatus;
      var status = this.model.status;

      delete this.model.lastStatus;

      if (this.model.status === 2) {
        this.model.status = lastStatus || 0;
      }

      this.upsert(this.model).then(function (result) {
        if (_this2.editing) {
          _this2.$notify({
            message: 'Registro editado com sucesso.',
            type: 'success'
          });
        } else {
          _this2.model._id = result.id;
          _this2.model._rev = result.rev;

          _this2.$notify({
            message: 'Registro criado com sucesso.',
            type: 'success'
          });
        }

        if (status === 2 && status !== lastStatus && _this2.config.useLGPD) {
          _this2.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
            title: 'Finalizar Evento?',
            text: 'Ao finalizar o evento, o processo poder\xE1 demorar alguns minutos',
            type: 'warning',
            cancelButtonText: 'Cancelar',
            confirmButtonClass: 'btn btn-warning btn-fill mr',
            cancelButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            focusCancel: true
          }).then(function (result) {
            if (result) {
              _this2.model.status = status;
              _this2.removeSensitiveData().then(function () {
                _this2.updateEvent();
              }).catch(function (err) {
                return console.log(err);
              }).finally(function () {
                _this2.isLoading = false;
              });
            }
          }).catch(function () {
            _this2.saveSpecification(result, _this2.model);
          });
        } else {
          if (status === 2 && !_this2.config.useLGPD) {
            _this2.model.status = status;

            _this2.updateEvent();
          } else {
            _this2.saveSpecification(result, _this2.model);
          }
        }
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        _this2.saving = false;
      });
    },
    removeSensitiveData: function removeSensitiveData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var customers, tickets, lampdas, lamps, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ticket, i, _customer, customerLamps, novosDadosDoContemplado, index, _i, lampda, customerLamp, _novosDadosDoContemplado;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                customers = [];
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('tickets').where('eventId', _this3.id).limit(99999999).get();

              case 3:
                tickets = _context2.sent;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('lamps').where('eventId', _this3.id).limit(99999999).get();

              case 6:
                lampdas = _context2.sent;
                lamps = [];
                _loop = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop(ticket) {
                  var customersByTicket, customer, _novosDadosDoContemplado2;

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('customers').where('_id', ticket.customerId).get();

                        case 2:
                          customersByTicket = _context.sent;
                          customer = customersByTicket[0];

                          if (customer && customers.filter(function (c) {
                            return customer._id === c._id;
                          }).length === 0) {
                            if (ticket.winner) {
                              customer.contemplated = true;
                              _novosDadosDoContemplado2 = _this3.hideCustomerData(customer);

                              customers.push(_novosDadosDoContemplado2);
                            } else {
                              customers.push(customer);
                              ticket.deletedAt = new Date();
                            }
                          }

                        case 5:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _loop, _this3);
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 12;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(tickets);

              case 14:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 20;
                  break;
                }

                ticket = _step.value;
                return _context2.delegateYield(_loop(ticket), 't0', 17);

              case 17:
                _iteratorNormalCompletion = true;
                _context2.next = 14;
                break;

              case 20:
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t1 = _context2['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 26:
                _context2.prev = 26;
                _context2.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context2.prev = 29;

                if (!_didIteratorError) {
                  _context2.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context2.finish(29);

              case 33:
                return _context2.finish(26);

              case 34:
                i = 0;

              case 35:
                if (!(i < customers.length)) {
                  _context2.next = 50;
                  break;
                }

                _customer = customers[i];
                _context2.next = 39;
                return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('lamps').where('customer.id', _customer._id).limit(99999999).get();

              case 39:
                customerLamps = _context2.sent;

                if (!(customerLamps.length === 0 && !_customer.contemplated)) {
                  _context2.next = 43;
                  break;
                }

                _customer._deleted = true;
                return _context2.abrupt('continue', 47);

              case 43:
                novosDadosDoContemplado = _this3.hideCustomerData(_customer);


                for (index in customerLamps) {
                  customerLamps[index].customer.holder = novosDadosDoContemplado.holder;
                  delete customerLamps[index].customer.cpf;
                }

                lamps = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(lamps), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(customerLamps));

                customers[i] = novosDadosDoContemplado;

              case 47:
                ++i;
                _context2.next = 35;
                break;

              case 50:
                _i = 0;

              case 51:
                if (!(_i < lampdas.length)) {
                  _context2.next = 67;
                  break;
                }

                lampda = lampdas[_i];
                _context2.next = 55;
                return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('customers').where('_id', lampda.customer.id).first();

              case 55:
                customerLamp = _context2.sent;

                if (!customerLamp.contemplated) {
                  _context2.next = 58;
                  break;
                }

                return _context2.abrupt('continue', 64);

              case 58:
                _novosDadosDoContemplado = _this3.hideCustomerData(customerLamp);


                lampda.customer.holder = _novosDadosDoContemplado.holder;
                delete lampda.customer.cpf;

                lamps = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(lamps), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(lampda));

                customerLamp = _novosDadosDoContemplado;
                customers.push(customerLamp);

              case 64:
                ++_i;
                _context2.next = 51;
                break;

              case 67:
                _context2.next = 69;
                return _this3.couchdbLamps._updateBulkDocs(lamps);

              case 69:
                _context2.next = 71;
                return _this3.couchdbTickets._updateBulkDocs(tickets);

              case 71:
                _context2.next = 73;
                return _this3.couchdbCustomers._updateBulkDocs(customers);

              case 73:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this3, [[12, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    getCustomersIn: function getCustomersIn(tickets) {
      var select = ['_id', 'uc', 'cpf', 'nationalId', 'holder', 'aka', 'phones.0', 'address.street', 'address.number', 'address.neighborhood', 'address.city', 'address.zip', 'address.complement', 'observartion', 'nis', 'userId'];
      var ticketsCustomersId = tickets.map(function (item) {
        return item.customerId;
      });
      return __WEBPACK_IMPORTED_MODULE_14__services_Couchdb__["a" /* default */].connection('default').collection('customers').select(select).whereIn('_id', ticketsCustomersId).get();
    },
    updateEvent: function updateEvent() {
      var _this4 = this;

      this.upsert(this.model).then(function () {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
          title: 'Sucesso',
          text: 'Evento foi finalizado com sucesso',
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(function (result) {
          if (result) {
            _this4.saveSpecification(result, _this4.model);
          }
        });
      });
    },
    saveSpecification: function saveSpecification(result, doc) {
      var _this5 = this;

      this.findSpecification({ where: { eventId: result.id } }).then(function (spec) {
        var eventSpec = {};
        if (spec.length > 0) {
          eventSpec = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, spec[0]);
        }

        eventSpec = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(eventSpec, {
          sourceDb: "trg_eqpi_notiasc_admin",
          eventId: doc._id,
          event: {
            city: doc.city,
            reference: doc.reference
          },
          gps: {
            latitude: '',
            longitude: ''
          },
          tags: {}
        });

        console.log(eventSpec);
        _this5.upsertSpecifications(eventSpec).then(function () {
          _this5.$router.push(_this5.indexPath);
        });
      });
    },
    hideCustomerData: function hideCustomerData(customer) {
      var novosDadosDoContemplado = __WEBPACK_IMPORTED_MODULE_16_src_services_LGPD__["a" /* default */].removeCustomerSensitiveData(customer);
      return novosDadosDoContemplado;
    }
  }),

  mounted: function mounted() {
    var _this6 = this;

    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config');
    }

    if (this.$route.params.id) {
      this.fetchOne(this.$route.params.id).then(function () {
        _this6.model.lastStatus = _this6.model.status;
      });
    } else {
      this.resetOne();
    }
  }
});

/***/ }),

/***/ "FMHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketCheckIn_vue__ = __webpack_require__("CWA6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036d90f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketCheckIn_vue__ = __webpack_require__("JFkH");
function injectStyle (ssrContext) {
  __webpack_require__("sDpG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-036d90f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketCheckIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036d90f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketCheckIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FMOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.meta.title)+" "),_c('ProjectName')],1)]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('drop-down',{attrs:{"tag":"li","title":_vm.user.name,"icon":"ti-user"}},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout()}}},[_c('i',{staticClass:"ti-shift-right"}),_vm._v(" Sair")])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FPZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",attrs:{"title":"Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham."},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Migrar tags e GPS para novo banco de especificações dos eventos\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FQHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-categories-tags',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('tags', ['tagsByCategories']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('categories', ['categories', 'filtersTags']))
});

/***/ }),

/***/ "FQVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Chet Faker\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@chetfaker")])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FQz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEventsSpecifications_vue__ = __webpack_require__("z6dB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fbcbcb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEventsSpecifications_vue__ = __webpack_require__("f4lU");
function injectStyle (ssrContext) {
  __webpack_require__("ciIM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fbcbcb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEventsSpecifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fbcbcb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEventsSpecifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FYce":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FZmt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseModule__ = __webpack_require__("tv5d");




var collection = 'manufacturers';
var singleName = 'manufacturer';
var pluralName = 'manufacturers';
var connection = 'config';

var model = {
  name: '',
  informativeText: ''
};

var validations = {
  name: {
    required: true,
    min: 5
  },
  informativeText: {
    required: true,
    min: 5,
    max: 600
  }
};

var getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["c" /* mapActions */])(collection, model, connection)),
  getters: getters
});

/***/ }),

/***/ "FcXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEligibleTrue_vue__ = __webpack_require__("a7Pg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abcf2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEligibleTrue_vue__ = __webpack_require__("3C6X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEligibleTrue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abcf2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEligibleTrue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fck+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fcq6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FiFg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FiZY":
/***/ (function(module, exports) {



/***/ }),

/***/ "Fihx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TicketDocument__ = __webpack_require__("MuVr");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-tickets-document',

  components: {
    TicketDocument: __WEBPACK_IMPORTED_MODULE_4__TicketDocument__["a" /* default */]
  },

  data: function data() {
    return {
      ticketsCustomer: [],
      loading: true
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tickets', {
    tickets: 'tickets'
  }), {
    eligibleNotWinners: function eligibleNotWinners() {
      return this.$route.params.eligibleNotWinners;
    },
    eventId: function eventId() {
      return this.$route.params.id;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('events', {
    fetchEvent: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tickets', {
    fetchTickets: 'fetchAll',
    fetchTicket: 'fetchOne',
    setTickets: 'setStateAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', {
    fetchCustomersById: 'fetchIds'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), {
    fetchData: function fetchData() {
      var _this = this;

      var where = null;
      if (this.eligibleNotWinners === 'true') {
        where = {
          where: {
            eventId: this.eventId,
            winner: false,
            eligible: true
          },
          limit: 20
        };
      } else {
        where = {
          where: {
            eventId: this.eventId,
            winner: true
          },
          limit: 99999
        };
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.fetchEvent(this.eventId), this.fetchTickets(where)]).then(function (results) {
        _this.fetchCustomersById({
          connection: 'default',
          ids: _this.tickets.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { id: item.customerId });
          })
        }).then(function (customers) {
          _this.tickets.forEach(function (ticket) {
            ticket.event = _this.event;
            ticket.customer = customers.find(function (customer) {
              return customer._id === ticket.customerId;
            });
            _this.ticketsCustomer.push(ticket);
          });
          _this.loading = false;
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),

  mounted: function mounted() {
    this.fetchProject('config');
    this.fetchData();
  }
});

/***/ }),

/***/ "Fm2f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FmSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loadingAll)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('project-images')],1)]),_vm._v(" "),_c('RemoteConfigProject'),_vm._v(" "),_c('GeneralConfigProject'),_vm._v(" "),_c('CompanyInfoForm'),_vm._v(" "),_c('EventsConfigForm'),_vm._v(" "),_c('RegisterConfigForm'),_vm._v(" "),_c('lamps-config-form'),_vm._v(" "),_c('TicketsConfigForm'),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-bottom":"30px"}},[(_vm.$can('project.edit|projectCreate'))?_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.saving,"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.handleSave($event)}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n      ")]):_vm._e()])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_vm._v("Configurações do servidor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fn6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReplacementCustomer_vue__ = __webpack_require__("/ijB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb0123e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReplacementCustomer_vue__ = __webpack_require__("1I2K");
function injectStyle (ssrContext) {
  __webpack_require__("5jPH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bb0123e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReplacementCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb0123e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReplacementCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FzU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G1jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectRegularizationMethod',
  props: ['value'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('customers', { modelValidations: 'validations' }))
});

/***/ }),

/***/ "G5/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLamps_vue__ = __webpack_require__("ml9m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f674cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLamps_vue__ = __webpack_require__("soD8");
function injectStyle (ssrContext) {
  __webpack_require__("0iWr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f674cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G5bo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G8lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-list-reserves card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Reservas ("+_vm._s(_vm.tickets.length)+")")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tickets}},[_c('el-table-column',{attrs:{"label":"Nome","property":"customer"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.customer.holder)+"\n          "),(scope.row.energyMetering)?_c('i',{staticClass:"ti-bolt"}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","label":"UC"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.customer.uc)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":"nota"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.survey && scope.row.survey.data)?[_vm._v(" "+_vm._s(scope.row.survey.data.refrigerator.score)+" ")]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":"Posição"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.rankingNow ? scope.row.rankingNow : scope.row.rankingOriginal)+" ")]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GBSZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GBrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GIE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventLocalMap_vue__ = __webpack_require__("rchf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae74b01_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventLocalMap_vue__ = __webpack_require__("ycPt");
function injectStyle (ssrContext) {
  __webpack_require__("1nM0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae74b01"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventLocalMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae74b01_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventLocalMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GJfy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GKuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",attrs:{"title":"Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham."},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Adicionar ID do eventos as lâmpadas trocadas\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GXjO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GY//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));

/***/ }),

/***/ "GYO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sync_vue__ = __webpack_require__("Iyiz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d7a58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sync_vue__ = __webpack_require__("fRXj");
function injectStyle (ssrContext) {
  __webpack_require__("FzU9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4d7a58a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sync_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d7a58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sync_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GdNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");


var VectorMap = function VectorMap() {
  return {
    component: __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "jrBO")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 200
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VectorMap: VectorMap
  }
});

/***/ }),

/***/ "GfDk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-primary btn-fill btn-wd ",attrs:{"title":"Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham."},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Alterar tags dos eventos, de STRING para _ID\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Go7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_googleMaps_vue__ = __webpack_require__("6ZAB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f86dd00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_googleMaps_vue__ = __webpack_require__("Dske");
function injectStyle (ssrContext) {
  __webpack_require__("Pa4K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f86dd00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_googleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f86dd00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_googleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GpCx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H0v/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H1iK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Documents_SignatureCustomerTicket__ = __webpack_require__("Dlhx");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-cemar',

  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1_src_pages_Documents_SignatureCustomerTicket__["a" /* default */] },

  props: {
    payload: {},

    powerLampDeliveryLabel: {
      required: true,
      type: String
    },
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({});
      }
    }
  }
});

/***/ }),

/***/ "H1tB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-download-term-lamps',

  props: {
    eventId: { required: true, type: String },
    customer: { required: true },
    lamps: { required: true },
    event: { required: true }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project'])),

  methods: {
    handlePrintTerm: function handlePrintTerm() {
      var payload = {
        customer: this.customer,
        lamps: this.lamps,
        eventId: this.eventId,
        companyTerms: this.event.companyTerms || this.project.companyTerms
      };
      localStorage.removeItem('LampsTmpTemp');
      localStorage.setItem('LampsTmpTemp', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      var routeData = this.$router.resolve({ name: 'lamps.print' });
      window.open(routeData.href, 'ticketWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    }
  }
});

/***/ }),

/***/ "H2oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sweet Alert 2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-sweet-alerts"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Basic example")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('basic')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A title with a text under")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('title-and-text')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A success message")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('success-message')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Custom HTML description")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('custom-html')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A warning message, with a function attached to the \"Confirm\" Button...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('warning-message-and-confirmation')}}},[_vm._v("\n              Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("...and by passing a parameter, you can execute something else for \"Cancel\"")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('warning-message-and-cancel')}}},[_vm._v("Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A message with auto close timer set to 2 seconds")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('auto-close')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Modal window with input field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){return _vm.showSwal('input-field')}}},[_vm._v("Try me!")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("A beautiful plugin, that replace the classic alert, Handcrafted by our friend "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/t4t5"}},[_vm._v("Tristan Edwards")]),_vm._v(". Please check out the "),_c('a',{attrs:{"href":"http://limonte.github.io/sweetalert2/","target":"_blank"}},[_vm._v("full documentation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H3Rb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnAssociateStock_vue__ = __webpack_require__("KODb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed441bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnAssociateStock_vue__ = __webpack_require__("LHHQ");
function injectStyle (ssrContext) {
  __webpack_require__("mOFO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ed441bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnAssociateStock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed441bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnAssociateStock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H5BX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5GJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyTermsRadios_vue__ = __webpack_require__("PgX8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0afee739_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyTermsRadios_vue__ = __webpack_require__("DzSL");
function injectStyle (ssrContext) {
  __webpack_require__("ewFZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0afee739"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyTermsRadios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0afee739_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyTermsRadios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H6kO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Print',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HJZ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("NIS")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.nis),expression:"modelValidations.additionalData.nis"}],staticClass:"form-control",attrs:{"required":_vm.project.requiredNIS,"maxlength":"11","autocomplete":"off","type":"text","name":"nis"},domProps:{"value":_vm._f("onlyNumbersMask")(_vm.value)},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),(!_vm.nisValidation.validate(_vm.value))?_c('small',{staticClass:"text-danger"},[_vm._v(" O NIS informado não é válido\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HKKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageSuportService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_blob_util__);





var _resizeImage = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(imgSrc, _ref3) {
    var canvasId = _ref3.canvasId,
        maxWidth = _ref3.maxWidth,
        maxHeight = _ref3.maxHeight,
        maxQuality = _ref3.maxQuality;
    var id, can, MAX_WIDTH, MAX_HEIGHT, QUALITY_IMG, imageObj, getBlob, blob;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = createCanvas(canvasId);
            can = document.getElementById(id);
            MAX_WIDTH = maxWidth > 0 ? maxWidth : 0;
            MAX_HEIGHT = maxHeight > 0 ? maxHeight : 0;
            QUALITY_IMG = maxQuality > 0 ? maxQuality / 100 : 0.8;
            imageObj = new Image();
            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5_blob_util___default.a.blobToDataURL(imgSrc);

          case 8:
            imageObj.src = _context.sent;

            getBlob = function getBlob() {
              return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                imageObj.onload = function () {
                  if (this.width === 0 || this.height === 0) {
                    console.log('Image is empty');
                  } else {
                    var scaleWidth = MAX_WIDTH;
                    var scaleHeight = MAX_WIDTH * this.height / this.width;
                    can.width = scaleWidth;
                    can.height = scaleHeight;
                    var ctx = can.getContext('2d');
                    ctx.clearRect(0, 0, MAX_WIDTH, MAX_HEIGHT);
                    ctx.drawImage(imageObj, 0, 0, this.width, this.height, 0, 0, scaleWidth, scaleHeight);
                    var canvasUrl = can.toDataURL(imgSrc.type, QUALITY_IMG);
                    var BASE64_MARKER = 'base64,';
                    var base64Index = canvasUrl.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                    var base64 = canvasUrl.substring(base64Index);
                    var data = canvasUrl.split(',')[1];
                    var mimeType = canvasUrl.split(',')[0].split(':')[1].split(';')[0];

                    var sliceSize = 512;
                    var byteCharacters = atob(data);
                    var byteArrays = [];
                    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                      var slice = byteCharacters.slice(offset, offset + sliceSize);
                      var byteNumbers = new Array(slice.length);
                      for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                      }
                      var byteArray = new Uint8Array(byteNumbers);
                      byteArrays.push(byteArray);
                    }
                    var _blob = new Blob(byteArrays, { type: mimeType });
                    resolve([{
                      blob: _blob,
                      base64: base64,
                      canvasUrl: canvasUrl,
                      scale: {
                        width: scaleWidth,
                        height: scaleHeight
                      }
                    }]);
                  }
                };
              });
            };

            _context.next = 12;
            return getBlob();

          case 12:
            blob = _context.sent;
            return _context.abrupt('return', blob[0]);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function _resizeImage(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();




var bus = new __WEBPACK_IMPORTED_MODULE_4_vue___default.a();

function onFileChange(e, _ref) {
  var canvasId = _ref.canvasId,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      maxQuality = _ref.maxQuality;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    var files = e.target.filesService || e.dataTransfer.files;
    if (files.length <= 0) {
      bus.$emit('resizedImage', false);
      resolve(false);
    } else {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          document.getElementById('canvasPlace').innerHTML = '';
          var reader = new FileReader();
          reader.onabort = function () {
            console.log('The upload was aborted.');
          };
          reader.onerror = function () {
            console.log('An error occured while reading the file.');
          };
          reader.onload = function (e) {
            var blob = resizeImage(e.target.result, {
              canvasId: canvasId,
              maxWidth: maxWidth,
              maxHeight: maxHeight,
              maxQuality: maxQuality
            });
            bus.$emit('imageResized', blob);
            resolve(blob);
          };
          reader.readAsDataURL(file);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  });
}

function resizeImage(imgSrc, _ref4) {
  var canvasId = _ref4.canvasId,
      maxWidth = _ref4.maxWidth,
      maxHeight = _ref4.maxHeight,
      maxQuality = _ref4.maxQuality;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _resizeImage(imgSrc, {
      canvasId: canvasId,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      maxQuality: maxQuality
    }).then(function (res) {
      return resolve(res);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function createCanvas(canvasId) {
  var canvasDiv = document.getElementById(canvasId);
  var canvas = document.createElement('canvas');
  canvas.id = Math.random().toString(36).slice(2);

  canvasDiv.appendChild(canvas);
  return canvas.id;
}

var imageSuportService = {
  resizeImage: resizeImage,
  onFileChange: onFileChange
};

/***/ }),

/***/ "HLGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.saving || _vm.loading),expression:"saving || loading"}],staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Logradouro")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.street),expression:"modelValidations.additionalData.street"},{name:"model",rawName:"v-model.trim",value:(_vm.addressStreet),expression:"addressStreet",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"street","autofocus":"","autocomplete":"off"},domProps:{"value":(_vm.addressStreet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addressStreet=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.street.invalid),expression:"street.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('street'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.number),expression:"modelValidations.additionalData.number"},{name:"model",rawName:"v-model.trim",value:(_vm.addressNumber),expression:"addressNumber",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('000000000'),expression:"'000000000'"}],staticClass:"form-control",attrs:{"type":"text","name":"number","autocomplete":"off"},domProps:{"value":(_vm.addressNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addressNumber=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('number'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.neighborhood),expression:"modelValidations.additionalData.neighborhood"},{name:"model",rawName:"v-model.trim",value:(_vm.addressNeighborhood),expression:"addressNeighborhood",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"neighborhood","autocomplete":"off"},domProps:{"value":(_vm.addressNeighborhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addressNeighborhood=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.neighborhood.invalid),expression:"neighborhood.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('neighborhood'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Município")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.city),expression:"modelValidations.additionalData.city"},{name:"model",rawName:"v-model",value:(_vm.addressCity),expression:"addressCity"}],staticClass:"form-control",attrs:{"name":"city"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.addressCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selecione ...\n            ")]),_vm._v(" "),_vm._l((_vm.citiesOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n            ")])})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('city'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.zip),expression:"modelValidations.additionalData.zip"},{name:"model",rawName:"v-model.trim",value:(_vm.addressZip),expression:"addressZip",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('00000-000'),expression:"'00000-000'"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","autocomplete":"off"},domProps:{"value":(_vm.addressZip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addressZip=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('zip'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.complement),expression:"modelValidations.additionalData.complement"},{name:"model",rawName:"v-model.trim",value:(_vm.addressComplement),expression:"addressComplement",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"complement","autocomplete":"off"},domProps:{"value":(_vm.addressComplement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addressComplement=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.complement.invalid),expression:"complement.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('complement'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("NIS")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.nis),expression:"modelValidations.additionalData.nis"},{name:"model",rawName:"v-model.trim",value:(_vm.nis),expression:"nis",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"nis","autocomplete":"off","required":_vm.nisRequired,"maxlength":_vm.maxLengthNIS},domProps:{"value":(_vm.nis)},on:{"keyup":function($event){this.nis = this.nis.replace(/\D/g, '')},"input":function($event){if($event.target.composing){ return; }_vm.nis=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errorNIS)?_c('small',{staticClass:"text-danger"},[_vm._v(" O NIS informado não é "),_c('valido')],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Método de regularização ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.regularity),expression:"modelValidations.additionalData.regularity"},{name:"model",rawName:"v-model",value:(_vm.regularity),expression:"regularity"}],staticClass:"form-control",attrs:{"name":"city"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.regularity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione ...\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"paidAccount"}},[_vm._v("Conta paga")]),_vm._v(" "),_c('option',{attrs:{"value":"installmentOfAccount"}},[_vm._v("Parcelamento de conta")]),_vm._v(" "),_c('option',{attrs:{"value":"secondWayAccount"}},[_vm._v("2ª via de conta")]),_vm._v(" "),_c('option',{attrs:{"value":"changeOfTitularity"}},[_vm._v("Troca de titularidade")])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.handleSave()}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dados Adicionais")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HQt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAllAboutAnEvent_vue__ = __webpack_require__("Xuv0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b3d0df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAllAboutAnEvent_vue__ = __webpack_require__("xH3n");
function injectStyle (ssrContext) {
  __webpack_require__("idS3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05b3d0df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAllAboutAnEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b3d0df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAllAboutAnEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0998b84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("xHTj");
function injectStyle (ssrContext) {
  __webpack_require__("7K95")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0998b84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showMap_vue__ = __webpack_require__("Zgsd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903602a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showMap_vue__ = __webpack_require__("60fs");
function injectStyle (ssrContext) {
  __webpack_require__("wjQF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903602a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HVzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContent_vue__ = __webpack_require__("fV7z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db569e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContent_vue__ = __webpack_require__("Mpj5");
function injectStyle (ssrContext) {
  __webpack_require__("+IUu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5db569e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db569e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HXOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAttachmentFromLamps_vue__ = __webpack_require__("QQx6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c106db2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAttachmentFromLamps_vue__ = __webpack_require__("dLys");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveAttachmentFromLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c106db2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveAttachmentFromLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZ2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReplicationView_vue__ = __webpack_require__("7138");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c90d71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReplicationView_vue__ = __webpack_require__("/DEa");
function injectStyle (ssrContext) {
  __webpack_require__("N3ja")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21c90d71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReplicationView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c90d71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReplicationView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HcAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Customers_CustomerCard__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerImageCard__ = __webpack_require__("uSbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Surveys_SurveyViewDetail__ = __webpack_require__("msp9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Surveys_SurveyViewGeneral__ = __webpack_require__("/rxw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Surveys_SurveyViewImages__ = __webpack_require__("yaHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-view',

  components: {
    CustomerCard: __WEBPACK_IMPORTED_MODULE_1_src_pages_Customers_CustomerCard__["a" /* default */],
    CustomerImageCard: __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerImageCard__["a" /* default */],
    SurveyViewDetail: __WEBPACK_IMPORTED_MODULE_3_src_pages_Surveys_SurveyViewDetail__["a" /* default */],
    SurveyViewGeneral: __WEBPACK_IMPORTED_MODULE_4_src_pages_Surveys_SurveyViewGeneral__["a" /* default */],
    SurveyViewImages: __WEBPACK_IMPORTED_MODULE_5_src_pages_Surveys_SurveyViewImages__["a" /* default */]
  },

  computed: {
    eventId: function eventId() {
      return this.$route.params.id;
    },
    customerId: function customerId() {
      return this.$route.params.customerId;
    },


    customerLoading: {
      get: function get() {
        return this.$store.state.customers.loading;
      }
    },

    surveyLoading: {
      get: function get() {
        return this.$store.state.surveys.loading;
      }
    },

    survey: {
      get: function get() {
        var _this = this;

        var survey = this.$store.state.surveys.all.find(function (item) {
          return item.customer._id === _this.customerId;
        });

        return !survey ? {} : survey;
      }
    },

    customer: {
      get: function get() {
        return this.$store.state.customers.one;
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('customers', {
    fetchCustomer: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('surveys', {
    fetchSurveys: 'fetchAll'
  })),

  mounted: function mounted() {
    this.fetchCustomer({ docId: this.customerId });
    this.fetchSurveys({ where: [{ 'event._id': this.eventId }] });
  }
});

/***/ }),

/***/ "Hcdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsReport_vue__ = __webpack_require__("E0Qc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ca3638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsReport_vue__ = __webpack_require__("ZYFR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ca3638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hfay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('p',[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('el-select',{staticClass:"select-primary el-select",attrs:{"filterable":"","size":"large","placeholder":"Selecione um usuário"},on:{"change":function($event){return _vm.setUser()}},model:{value:(_vm.userId),callback:function ($$v) {_vm.userId=$$v},expression:"userId"}},_vm._l((_vm.users),function(val,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"value":index,"label":val}})}),1)],1),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userActivate),expression:"userActivate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.userActivate)?_vm._i(_vm.userActivate,null)>-1:(_vm.userActivate)},on:{"change":[function($event){var $$a=_vm.userActivate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.userActivate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.userActivate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.userActivate=$$c}},function($event){return _vm.setShowInactivate(_vm.userActivate)}]}}),_vm._v(" Exibir usuários inativos?\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HkT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__ = __webpack_require__("fd3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-cemar',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */],
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      company: 'Companhia Energética do Maranhão - CEMAR',
      shortname: 'CEMAR',
      address: 'Alameda A, Quadra SQS, no. 100, Loteamento Quitandinha – Altos do Calhau',
      cpnj: '06.272.793/0001-84',
      stateRegistration: '06.105.848-3'
    };
  },

  computed: {
    manufacturerInformative: function manufacturerInformative() {
      return this.manufacturer.informativeText ? this.manufacturer.informativeText : '-';
    },
    manufacturerName: function manufacturerName() {
      return this.manufacturer.name ? this.manufacturer.name : '-';
    }
  }
});

/***/ }),

/***/ "Hkge":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hpci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-warning btn-fill btn-wd",attrs:{"title":"Essa rotina copia os attachments dos tickets para o banco trg_docs."},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Copiar Attachments dos Tickets\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HsA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCelpaJurunas_vue__ = __webpack_require__("Cvn6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8783a7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCelpaJurunas_vue__ = __webpack_require__("Nk+v");
function injectStyle (ssrContext) {
  __webpack_require__("6AyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8783a7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCelpaJurunas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8783a7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCelpaJurunas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HvmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectRegularizationMethod_vue__ = __webpack_require__("G1jz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19303855_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectRegularizationMethod_vue__ = __webpack_require__("E93u");
function injectStyle (ssrContext) {
  __webpack_require__("FYce")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19303855"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectRegularizationMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19303855_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectRegularizationMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HwJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseModule__ = __webpack_require__("tv5d");




var collection = 'apis';
var singleName = 'api';
var pluralName = 'apis';
var connection = 'config';

var model = {
  url: '',
  token: ''
};
var validations = {
  url: {
    min: 3,
    required: true
  },
  token: {
    min: 5,
    required: true
  }
};

var getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model, state.one);
};

getters[pluralName] = function (state) {
  return state.all;
};

getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["c" /* mapActions */])(collection, model, connection)),
  getters: getters
});

/***/ }),

/***/ "Hyh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('vue-tabs',{staticClass:"row",attrs:{"direction":"vertical","value":"Description"}},[_c('v-tab',{attrs:{"title":"Info"}},[_c('p',[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")]),_vm._v(" "),_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Description"}},[_c('p',[_vm._v("\n                The first thing you notice when you hold the phone is how great it feels in your hand. The cover glass curves down around the sides to meet the anodized aluminum enclosure in a remarkable, simplified design.")]),_vm._v(" "),_c('p',[_vm._v("\n                There are no distinct edges. No gaps. Just a smooth, seamless bond of metal and glass that feels like one continuous surface.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")]),_vm._v(" "),_c('p',[_vm._v("\n                Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Support"}},[_c('p',[_vm._v("\n                From the seamless transition of glass and metal to the streamlined profile, every detail was carefully considered to enhance your experience. So while its display is larger, the phone feels just right.")]),_vm._v("\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Extra"}},[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('vue-tabs',{staticClass:"card-content"},[_c('v-tab',{attrs:{"title":"Home"}},[_vm._v("\n            Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n          ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Profile"}},[_vm._v("Here is your profile.")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_vm._v("Here are your messages.")])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion on Plain Card")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Vertical tabs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plain text tabs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'api-router',

  computed: {}
});

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I7Fr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ICmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket)?_c('span',{staticClass:"tickets-documentation"},[_c('input',{ref:"filesContainer",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/pdf","readonly":_vm.unabled,"multiple":""},on:{"change":function($event){return _vm.handleFiles($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-block",attrs:{"disabled":_vm.unabled},on:{"click":function($event){$event.preventDefault();return _vm.handleSelectFiles()}}},[_vm._v("Enviar Documentação")]),_vm._v(" "),_vm._l((_vm.selectedFiles),function(selectedFile){return _c('p',{key:selectedFile},[_vm._v(_vm._s(selectedFile))])}),_vm._v(" "),(this.selectedFiles.length !== 0)?_c('button',{staticClass:"btn btn-fill btn-block btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.unabled},on:{"click":function($event){$event.preventDefault();return _vm.handleSave()}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n    ")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ICub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manufacturers_vue__ = __webpack_require__("pqsA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ce50d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manufacturers_vue__ = __webpack_require__("J+MW");
function injectStyle (ssrContext) {
  __webpack_require__("hUPS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manufacturers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ce50d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manufacturers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IQ/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockForm_vue__ = __webpack_require__("h/lR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a2ef616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockForm_vue__ = __webpack_require__("k9mR");
function injectStyle (ssrContext) {
  __webpack_require__("uvZG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a2ef616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IVAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventActions_vue__ = __webpack_require__("v4Cf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1b3b58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventActions_vue__ = __webpack_require__("T7Aj");
function injectStyle (ssrContext) {
  __webpack_require__("T3Ru")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f1b3b58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1b3b58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IVmL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IgVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-fill btn-block btn-warning",on:{"click":_vm.migrate}},[_vm._v("\n  Migrar todas as configurações para o novo banco de configurações\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iomc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('form',[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('name'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Categoria")]),_vm._v(" "),_c('div',{staticClass:"row-radio"},_vm._l((_vm.categories),function(categorie){return _c('div',{staticClass:"col-radio"},[_c('div',{staticClass:"row-radio"},[_c('div',{staticClass:"col-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.categorieId),expression:"model.categorieId"}],attrs:{"type":"radio","name":"categorieId"},domProps:{"value":categorie._id,"checked":_vm._q(_vm.model.categorieId,categorie._id)},on:{"change":function($event){return _vm.$set(_vm.model, "categorieId", categorie._id)}}})]),_vm._v(" "),_c('div',{staticClass:"col-radio"},[_c('span',[_vm._v("\n                    "+_vm._s(categorie.name)+"\n                  ")])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.handleSave()}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IpJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IqoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTicketsListToAssociate_vue__ = __webpack_require__("2lXn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef6e6c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTicketsListToAssociate_vue__ = __webpack_require__("QSN/");
function injectStyle (ssrContext) {
  __webpack_require__("BYZs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eef6e6c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTicketsListToAssociate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef6e6c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTicketsListToAssociate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IsOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ith7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index-categories'
});

/***/ }),

/***/ "IvGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iyiz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sync'
});

/***/ }),

/***/ "J+MW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'manufacturers.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J0I9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J2zJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__ = __webpack_require__("ZMT2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f84ed7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__ = __webpack_require__("LCxw");
function injectStyle (ssrContext) {
  __webpack_require__("60Pv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f84ed7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f84ed7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J3uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-term-enel",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(("" + (_vm.payload.eventId)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A Companhia Energética do Ceará - ENEL com sede na rua Padre Valdevino, nº 150 – Centro, Fortaleza/CE inscrita no\n    CNPJ/MF sob o nº. 07.047.251/0001-70 e Inscrição Estadual nº. 06.105.848-3, e o(a) Sr(a).\n    ___________________________________________________________________________________________________________, C.P.F.: ________________________________, e N.I.S./N.I.T./N.B.\n    ________________________________ "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e\n    domiciliado (a) na ________________________________ nº ________________________________ UC n.º\n    ________________________________ firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados\n    encontram-se descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A Companhia Energética do Ceará está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A Companhia Energética do Ceará busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A Companhia Energética do Ceará fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n        "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n      ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n        "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n      ")]):_vm._e(),_vm._v(", devendo estas ser entregues à ENEL no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à ENEL para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a Companhia Energética do Ceará.\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a  não comercializar (vender, trocar, empresta r, dar, ou qualquer outra ação) as lâmpadas recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O  usuário,  desd e  já,  autoriza  a  inspeção  pelos  funcionários  da Companhia  Energética  do  Ceará para  verificação  da  quantidade/estado  das  lâmpadas  substituídas, e em  caso  de  irregularidade , terá  todos  os  benefícios  oriundos  do “ENEL COMPARTILHA  EFICIÊNCIA  DE  GELADEIRA  DO  PROJETO  DE EFICIÊNCIA ENERGÉTICA” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5cm"}},[_vm._v("\n    Fortaleza, "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new Date(),'YYYY'))+"\n  ")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    ________________________________________________________________________\n    "),_c('br'),_vm._v("\n    Assinatura do(a) cliente beneficiado\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J4xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'salary': '35978.00',
  'age': 26
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'id',
  'email': 'little.myrna@example.net',
  'salary': '26278.00',
  'age': 48
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'salary': '25537.00',
  'age': 27
}, {
  'id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "J9Kr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.manufacturer)?_c('div',{staticClass:"lending-term-cemar",staticStyle:{"margin":"0.5cm"}},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":"/static/img/cema-logo.png","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.company)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.address)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cpnj)+" e Inscrição Estadual doravante denominada "+_vm._s(_vm.shortname)+", e o(a) "),_c('span',{staticClass:"captalize"},[_c('strong',[_vm._v(" "+_vm._s(_vm.customer.holder)+" ")])]),_vm._v(" , residente e domiciliado(a) na "),_c('strong',[_vm._v(_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip))]),_vm._v(", na cidade de "),_c('strong',[_vm._v(_vm._s(_vm.customer.address.city))]),_vm._v(", Maranhão, C/C n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',{attrs:{"id":"ol-first"}},[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.config.name)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.config.name)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',{attrs:{"id":"ol-second"}},[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',{attrs:{"id":"ol-third"}},[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato em referência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia” cancelados.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA QUARTA ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA QUINTA")]),_vm._v(" "),_c('ol',{attrs:{"id":"ol-fifth"}},[_c('li',[_vm._v("\n          O equipamento doado tem garantia de 12 (doze) meses dada pelo fabricante "+_vm._s(_vm.manufacturerName)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEXTA")]),_vm._v(" "),_c('ol',{attrs:{"id":"ol-sixth"}},[_c('li',[_vm._v(" "+_vm._s(_vm.manufacturerInformative)+" ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city))]),_vm._v(" , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('SignatureCustomerTicket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{attrs:{"id":"ol-fourth"}},[_c('li',[_vm._v("\n          O donatário(a) declara ter recebido um refrigerator, com as especificações acima citadas, e se compromete a não vender, trocar ou negociar de qualquer forma o refrigerador recebido, sobe pena de reversão do bem doado\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JElF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var API_KEY = 'YOUR_KEY_HERE';

/***/ }),

/***/ "JFkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon && !_vm.unabled)?_c('button',{staticClass:"btn btn-fill btn-icon",class:_vm.checked ? 'btn-success' : 'btn-info',attrs:{"title":_vm.checked ? 'Registrar ausência' : 'Registrar presença'},on:{"click":function($event){return _vm.handleChangeCheckInWinner()}}},[_c('i',{staticClass:"ti-check"})]):(!_vm.icon && !_vm.unabled)?_c('button',{staticClass:"btn btn-fill btn-block",class:_vm.checked ? 'btn-warning' : 'btn-success',on:{"click":function($event){return _vm.handleChangeCheckInWinner()}}},[_vm._v("\n  "+_vm._s(_vm.checked ? 'Registrar ' + 'ausência ' + 'no ' + 'sorteio' : 'Registrar ' + 'presença ' + 'no ' + 'sorteio')+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JFzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCelpaJurunas_vue__ = __webpack_require__("S97J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a885fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCelpaJurunas_vue__ = __webpack_require__("4twv");
function injectStyle (ssrContext) {
  __webpack_require__("9fQc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a885fd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCelpaJurunas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a885fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCelpaJurunas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JG9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UsersOptions__ = __webpack_require__("qYwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-actions',

  components: {
    UsersOptions: __WEBPACK_IMPORTED_MODULE_1_src_components_UsersOptions__["a" /* default */]
  },

  props: {
    enableAssociate: {
      default: false
    },

    event: {
      default: ''
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', ['surveysOptions']), {
    eventId: function eventId() {
      return this.event._id;
    }
  }),

  methods: {
    printList: function printList() {
      var routeData = this.$router.resolve({
        name: 'surveys.associated.tickets.print',
        params: { id: this.eventId }
      });
      window.open(routeData.href, 'associated-tickets-print', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    }
  }
});

/***/ }),

/***/ "JPrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_DashboardCounter_js__ = __webpack_require__("fzNA");








var moment = __webpack_require__("PJh5");
var collection = 'lamps';
var singleName = 'lamp';
var pluralName = 'lamps';

var Couchdb = new __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: collection });
var CouchdbConfig = new __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'projects' });

var model = {
  type: '',
  room: '',
  usageHoursPerDay: 8,
  power: 0,
  rushHour: false
};
var validations = {
  type: { required: true },
  room: { required: true },
  usageHoursPerDay: {
    required: true,
    min: 1,
    max: 24
  },
  power: { required: true }
};
var options = {
  power: [{
    value: 11,
    label: '11W'
  }, {
    value: 14,
    label: '14W'
  }, {
    value: 15,
    label: '15W'
  }, {
    value: 18,
    label: '18W'
  }, {
    value: 20,
    label: '20W'
  }, {
    value: 25,
    label: '25W'
  }, {
    value: 30,
    label: '30W'
  }, {
    value: 34,
    label: '34W'
  }, {
    value: 40,
    label: '40W'
  }, {
    value: 60,
    label: '60W'
  }, {
    value: 70,
    label: '70W'
  }, {
    value: 80,
    label: '80W'
  }, {
    value: 100,
    label: '100W'
  }, {
    value: 160,
    label: '160W'
  }],
  type: [{
    value: 'Incandescente',
    label: 'Incandescente'
  }, {
    value: 'Fluorescente',
    label: 'Fluorescente'
  }],
  room: [{
    value: 'Banheiro',
    label: 'Banheiro'
  }, {
    value: 'Cozinha',
    label: 'Cozinha'
  }, {
    value: 'Lavanderia',
    label: 'Lavanderia'
  }, {
    value: 'Quarto',
    label: 'Quarto'
  }, {
    value: 'Sala',
    label: 'Sala'
  }, {
    value: 'Outros',
    label: 'Outros'
  }]
};
var getters = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  var lamps = [];
  state.all.map(function (one) {
    for (var i in one['items']) {
      var o = one['items'][i];
      o.userId = one['userId'];
      lamps.push(o);
    }
  });
  return lamps;
};
getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },

  count: function count(state) {
    return state.all.length;
  },
  countLamps: function countLamps(state) {
    return state.all.reduce(function (accumulate, current) {
      accumulate += current.hasOwnProperty('items') ? current.items.length : 0;
      return accumulate;
    }, 0);
  },

  countOperations: function countOperations(state) {
    return state.all.length;
  },
  lampsAll: function lampsAll(state) {
    return state.all;
  },
  options: function options(state) {
    return state.options;
  },
  lampsTmp: function lampsTmp(state) {
    return state.lampsTmp;
  },
  allLamps: function allLamps(state) {
    return state.allLamps;
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0,
    options: options,
    lampsTmp: [],
    allLamps: []
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["b" /* mapMutations */])(), {
    setLampsTmp: function setLampsTmp(state, payload) {
      state.lampsTmp = payload;
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["c" /* mapActions */])(collection, model), {
    setCurrentLampsTmp: function setCurrentLampsTmp(_ref, payload) {
      var commit = _ref.commit;

      commit('setLampsTmp', payload);
    },
    fetchLampsByCustomerId: function fetchLampsByCustomerId(context, payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var configProject, lampsStartOfValidPeriod, dateStart;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CouchdbConfig.get();

              case 2:
                configProject = _context.sent;

                configProject = configProject[0];
                lampsStartOfValidPeriod = null;

                if (configProject.lamps.hasSeason && configProject.lamps.seasonRange > 0) {
                  lampsStartOfValidPeriod = moment().subtract(configProject.lamps.seasonRange, 'months').toISOString();
                } else if (configProject.lamps.hasSeason && configProject.lamps.seasonRange === '0') {
                  dateStart = new Date();

                  dateStart.setDate(1);
                  dateStart.setMonth(0);
                  dateStart.setHours(0);
                  dateStart.setMinutes(0);
                  dateStart.setSeconds(0);
                  lampsStartOfValidPeriod = dateStart;
                }
                context.commit('changeLoading', true);
                return _context.abrupt('return', Couchdb.select(['_id', 'customer', 'items', 'userId', 'eventId', 'createdAt']).where('customer.id', payload).whereGreatThen('createdAt', lampsStartOfValidPeriod).get().then(function (res) {
                  context.commit('setAll', res);
                  context.commit('changeLoading', false);
                  return res;
                }).catch(function (err) {
                  context.commit('changeLoading', false);
                  return err;
                }));

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    dashboardLampsByFilter: function dashboardLampsByFilter(context, _ref2) {
      var eventsId = _ref2.eventsId;

      context.commit('changeLoading', true);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_services_DashboardCounter_js__["d" /* dashboardCounter */])('lamps', eventsId).then(function (result) {
        context.commit('SET_DASHBOARD_COUNTER', result);
        context.commit('changeLoading', false);
        return result;
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
        return err;
      });
    },
    uploadFileLamp: function uploadFileLamp(context, _ref3) {
      var _this2 = this;

      var id = _ref3.id,
          mimeType = _ref3.mimeType,
          name = _ref3.name,
          attachment = _ref3.attachment;

      return Couchdb.connection('docs').where('referenceId', id).get().then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          var doc;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  doc = false;

                  if (!(res.length === 0)) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 4;
                  return Couchdb.connection('docs').insert({ referenceId: id, collection: 'lamps', database: 'trg_admin' });

                case 4:
                  doc = _context2.sent;

                case 5:
                  _context2.next = 7;
                  return Couchdb.connection('docs').insertAttachment(doc.id, {
                    mimeType: mimeType,
                    attachmentName: name,
                    attachment: attachment
                  });

                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    countLampsByEvent: function countLampsByEvent(context, eventId) {
      return Couchdb.view('count-lamps-by-event', 'count-lamps-by-event', eventId, { group: true, reduce: true }).then(function (result) {
        return result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0;
      });
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, getters, {
    lampsByUser: function lampsByUser(state) {
      return state.one.hasOwnProperty('items') ? state.one.items.length : 0;
    }
  })
});

/***/ }),

/***/ "JShI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputRadioIconRefrigeratoMap_vue__ = __webpack_require__("fN0m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303f723a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputRadioIconRefrigeratoMap_vue__ = __webpack_require__("fxw2");
function injectStyle (ssrContext) {
  __webpack_require__("65IR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-303f723a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputRadioIconRefrigeratoMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303f723a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputRadioIconRefrigeratoMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JU1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_mixins_can__ = __webpack_require__("exox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_vuex_store__ = __webpack_require__("YtJ0");







var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */],
  linkActiveClass: 'active'
});

var projectCouchdb = new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'projects' });

function hasConfig(store) {
  return store.hasOwnProperty('state') && store.state.hasOwnProperty('config') && store.state.config.hasOwnProperty('_id') && store.state.config.hasOwnProperty('state');
}

router.beforeEach(function (to, from, next) {
  if (!hasConfig(__WEBPACK_IMPORTED_MODULE_5_src_vuex_store__["a" /* default */])) {
    projectCouchdb.find('config').then(function (result) {
      __WEBPACK_IMPORTED_MODULE_5_src_vuex_store__["a" /* default */].commit('changeConfig', result);
      __WEBPACK_IMPORTED_MODULE_5_src_vuex_store__["a" /* default */].dispatch('project/setStateOne', result, { root: true });
    }).catch(function (err) {
      return console.log('can not store config', err);
    });
  }
  var permissionPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_mixins_can__["a" /* $can */])(to.name, JSON.parse(localStorage.getItem('user')));
  var isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  var requireAuth = to.meta.requireAuth;
  if (requireAuth === undefined) {
    requireAuth = false;
  }

  if (to.path === '/login') {
    next();
    return;
  }

  if (requireAuth && !isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
      title: 'Você não está logado!',
      text: 'Primeiro você deve logar-se no sistema.',
      buttonsStyling: false,
      confirmButtonClass: 'btn btn-success btn-fill',
      type: 'error'
    });
    next('/login');
    return;
  }

  if (requireAuth && isLoggedIn) {
    if (!permissionPage && to.fullPath !== '/admin/dashboard') {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Sem permissão!',
        text: 'Você não tem permissão para ver está página.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'error'
      });
      next('/admin/dashboard');
    } else {
      next();
    }
    return;
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "JbT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnergisaPb_vue__ = __webpack_require__("+PwU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7f6494c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnergisaPb_vue__ = __webpack_require__("Smwr");
function injectStyle (ssrContext) {
  __webpack_require__("H5BX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7f6494c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnergisaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7f6494c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnergisaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JcrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saving: false,
      indexPath: { name: 'tags.index' },
      entityName: 'Tag',
      colorStatic: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['name']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('categories', ['categories']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tags', {
    model: 'InputTag.vue',
    modelValidations: 'validations',
    loading: 'loading'
  }), {
    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    },
    title: function title() {
      return this.editing ? 'Editar ' + this.entityName : 'Nova ' + this.entityName;
    }
  }),
  mounted: function mounted() {
    this.fetchCategories({ limit: 999 });
    if (this.editing) {
      this.fetchOne(this.id);
    } else {
      this.resetOne();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('categories', {
    fetchCategories: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tags', ['fetchOne', 'resetOne', 'insert', 'update']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.model);
          doc.collection = 'tags';
          if (_this.editing) {
            _this.update(doc).then(function (result) {
              _this.saving = false;
              _this.$notify({
                message: 'Registro editado com sucesso.',
                type: 'success'
              });
              _this.$router.push(_this.indexPath);
            }).catch(function (err) {
              _this.saving = false;
              console.log(err);
            });
          } else {
            _this.insert(doc).then(function (result) {
              _this.saving = false;
              _this.$notify({
                message: 'Registro criado com sucesso.',
                type: 'success'
              });
              _this.$router.push(_this.indexPath);
            }).catch(function (err) {
              _this.saving = false;
              console.log(err);
            });
          }
        }
      }).catch(function (err) {
        _this.saving = false;
        console.log(err);
      });
    }
  })
});

/***/ }),

/***/ "JeQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEquatorialPi_vue__ = __webpack_require__("jxvg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c148190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEquatorialPi_vue__ = __webpack_require__("IpJG");
function injectStyle (ssrContext) {
  __webpack_require__("GfDk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c148190"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEquatorialPi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c148190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEquatorialPi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("3MeN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("i/rH");
function injectStyle (ssrContext) {
  __webpack_require__("sk1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jir4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jktz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JsSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_csv_import__ = __webpack_require__("Txdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_csv_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_csv_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_services_ValidationRules_js__ = __webpack_require__("ulVI");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-customers-import',
  components: {
    VueCsvImport: __WEBPACK_IMPORTED_MODULE_8_vue_csv_import__["VueCsvImport"]
  },
  data: function data() {
    return {
      loading: false,
      mapFields: ['UC', 'CPF', 'Nome do Titular da conta', 'Também conhecido como', 'Nome da mãe', 'Registro Geral (RG)', 'Data de nascimento', 'Telefone 1', 'Telefone 2', 'Logradouro', 'Número', 'Bairro', 'Município', 'CEP', 'Complemento', 'NIS'],
      customers: [],
      importedCustomersDocs: [],
      customersTickets: [],
      queryCustomersDuplicated: {
        '$or': []
      },
      queryTicketsWinner: {
        '$or': []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['config', 'user']), {
    eventId: function eventId() {
      return this.$route.params.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('customers', { fetchOne: 'fetchOne', fetchCustomers: 'fetchAll', upsertCustomers: 'insertMany' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('winners', { winnerByConfig: 'winnerByConfig', fetchWinners: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('tickets', {
    fetchTickets: 'fetchAll',
    createTicket: 'createTicket',
    getTicketBarcode: 'getTicketBarcode',
    checkWinnerOld: 'checkWinnerOld',
    isWinnerTrgNewer: 'isWinnerTrgNewer',
    upsertTickets: 'insertMany'
  }), {
    handleImport: function handleImport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.createImportedDocuments();
                _this.fetchCustomers({ limit: 99999999 }).then(function (results) {
                  if (_this.config.validationCustomer.uc || _this.config.validationCustomer.ucOrCpf) {
                    _this.importedCustomersDocs = _this.importedCustomersDocs.map(function (doc) {
                      var oldDoc = results.find(function (item) {
                        return item.uc === doc.uc;
                      });
                      if (oldDoc) {
                        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(oldDoc, doc, { _id: oldDoc._id });
                      }
                      return doc;
                    });
                  } else if (_this.config.validationCustomer.cpf || _this.config.validationCustomer.ucOrCpf) {
                    _this.importedCustomersDocs = _this.importedCustomersDocs.filter(function (doc) {
                      var oldCpfDoc = results.find(function (item) {
                        return item.cpf && item.cpf.replace(/[^\d]+/g, '') === doc.cpf;
                      });
                      console.log('teste');
                      if (oldCpfDoc) {
                        return false;
                      }
                      return true;
                    });
                  }

                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.upsertCustomers(_this.importedCustomersDocs), _this.execCreateTickets()]).then(function (results) {
                    window.location.reload(true);
                  });
                }).finally(function () {
                  _this.loading = true;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    execCreateTickets: function execCreateTickets() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this2.fetchWinners(_this2.queryTicketsWinner), _this2.fetchTickets({
                  where: {
                    '$or': _this2.importedCustomersDocs.map(function (item) {
                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
                        customerId: item._id
                      });
                    })
                  }
                })]).then(function (results) {
                  _this2.createTicketCustomers({ winners: results[0], oldTickets: results[1] });
                  return _this2.upsertTickets(_this2.customersTickets);
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createImportedDocuments: function createImportedDocuments() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.customers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var customer = _step.value;

          if (!__WEBPACK_IMPORTED_MODULE_9_src_services_ValidationRules_js__["a" /* cpfIsValidRule */].validate(customer.CPF)) {
            continue;
          }
          this.createQueryDuplications(customer);
          this.importedCustomersDocs.push({
            _id: this.createHashId(),
            'uc': customer.UC,
            'cpf': customer.CPF.replace(/[^\d]+/g, ''),
            'nationalId': customer.RG,
            'birthdate': customer['Data de nascimento'],
            'holder': customer['Nome do Titular da conta'],
            'aka': customer['Também conhecido como'],
            'motherName': customer['Nome da mãe'],
            'phone1': customer['Telefone 1'],
            'phone2': customer['Telefone 2'],
            'address': {
              'street': customer['Logradouro'],
              'number': customer['Número'],
              'neighborhood': customer['Bairro'],
              'city': customer['Município'],
              'zip': customer['CEP'],
              'complement': customer['Complemento']
            },
            'observartion': '',
            'nis': customer['NIS'],
            'contemplated': null,
            'phones': [customer['Telefone 1'], customer['Telefone 2']],
            'collection': 'customers',
            'userId': this.user._id,
            'createdAt': new Date()
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    createTicketCustomers: function createTicketCustomers(_ref) {
      var winners = _ref.winners,
          oldTickets = _ref.oldTickets;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.importedCustomersDocs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var customer = _step2.value;

          var eligible = this.verifyElegible({ winners: winners, oldTickets: oldTickets, customer: customer });

          var doc = {
            collection: 'tickets',
            winner: false,
            eligible: eligible,
            reasonNotEligible: !eligible ? 'Já foi contemplado anteriormente.' : '',
            customerId: customer._id,
            eventId: this.eventId,
            barcode: '' + customer.uc + __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.random(10000000, 99999999),
            createdAt: new Date()
          };

          this.customersTickets.push(doc);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    verifyElegible: function verifyElegible(_ref2) {
      var _this3 = this;

      var winners = _ref2.winners,
          oldTickets = _ref2.oldTickets,
          customer = _ref2.customer;

      var oldEventsWinner = winners.find(function (winner) {
        if (_this3.config.validationCustomer.uc && _this3.config.validationCustomer.cpf) {
          return winner.uc === customer.uc && winner.cpf === customer.cpf.replace(/\D/g, '');
        }

        if (_this3.config.validationCustomer.uc && !_this3.config.validationCustomer.cpf) {
          return winner.uc === customer.uc;
        }

        if (_this3.config.validationCustomer.cpf && !_this3.config.validationCustomer.uc) {
          return winner.cpf === customer.cpf.replace(/\D/g, '');
        }

        if (_this3.config.validationCustomer.ucOrCpf) {
          return winner.uc === customer.uc || winner.cpf === customer.cpf.replace(/\D/g, '');
        }
      });

      if (oldEventsWinner) {
        return false;
      }

      var ticketWinner = oldTickets.find(function (ticket) {
        return ticket.customerId === customer._id && ticket.winner;
      });
      if (ticketWinner) {
        return false;
      }

      return true;
    },
    createQueryDuplications: function createQueryDuplications(customer) {
      var query = [];
      var queryWinner = [];
      if (this.config.validationCustomer.uc && this.config.validationCustomer.cpf) {
        query = { '$and': [] };
        query['$and'].push({ uc: customer.UC });
        query['$and'].push({ cpf: customer.CPF });

        queryWinner = { '$and': [] };
        queryWinner['$and'].push({ uc: customer.UC });
        queryWinner['$and'].push({ cpf: customer.CPF.replace(/\D/g, '') });
      }

      if (this.config.validationCustomer.uc && !this.config.validationCustomer.cpf) {
        query = { '$and': [] };
        query['$and'].push({ uc: customer.UC });

        queryWinner = { '$and': [] };
        queryWinner['$and'].push({ uc: customer.UC });
      }

      if (this.config.validationCustomer.cpf && !this.config.validationCustomer.uc) {
        query = { '$and': [] };
        query['$and'].push({ cpf: customer.CPF });
        queryWinner = { '$and': [] };
        queryWinner['$and'].push({ cpf: customer.CPF.replace(/\D/g, '') });
      }

      if (this.config.validationCustomer.ucOrCpf) {
        query = { '$or': [] };
        query['$or'].push({ uc: customer.UC });
        query['$or'].push({ cpf: customer.CPF });

        queryWinner = { '$or': [] };
        queryWinner['$or'].push({ uc: customer.UC });
        queryWinner['$or'].push({ cpf: customer.CPF.replace(/\D/g, '') });
      }

      this.queryCustomersDuplicated['$or'].push(query);
      this.queryTicketsWinner['$or'].push(queryWinner);
    },
    createHashId: function createHashId() {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 23; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result + '-imported';
    }
  })
});

/***/ }),

/***/ "Jxjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDetail_vue__ = __webpack_require__("PkuA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f61ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventDetail_vue__ = __webpack_require__("ajk5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f61ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K03o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filesService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageSuport__ = __webpack_require__("HKKL");






var filesService = {
  handle: handle,
  handleBlob: handleBlob,
  handleImage: handleImage,
  loadFile: loadFile
};

function handle(data) {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
      var files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              files = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 4;
              _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.target.files);

            case 6:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 16;
                break;
              }

              file = _step.value;
              _context.t0 = files;
              _context.next = 11;
              return loadFile(file);

            case 11:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

            case 13:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t2 = _context['catch'](4);
              _didIteratorError = true;
              _iteratorError = _context.t2;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError) {
                _context.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
              resolve(files);

            case 31:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 18, 22, 30], [23,, 25, 29]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

function handleBlob(data, mymeType) {
  var _this2 = this;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
      var file, blob;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadFile(data.target.files[0]);

            case 2:
              file = _context2.sent;
              blob = new Blob([file], { type: mymeType });

              resolve(blob);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}

function handleImage(event) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    var files = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(event.target.files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var file = _step2.value;

        files.push(__WEBPACK_IMPORTED_MODULE_4__ImageSuport__["a" /* imageSuportService */].resizeImage(file, {
          canvasId: 'canvasPlace',
          maxWidth: 1366,
          maxHeight: 768,
          maxQuality: ''
        }));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    resolve(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(files));
  });
}

function loadFile(file) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function (e) {
      resolve(e.target.result);
    };
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsArrayBuffer(file);
  });
}

/***/ }),

/***/ "K4vv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KDIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading || _vm.loadingProject),expression:"loading || loadingProject"}],staticClass:"ticket-form"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Evento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.eventId),expression:"model.eventId"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.eventId),expression:"modelValidations.eventId"}],staticClass:"form-control",attrs:{"id":"id-event","name":"eventId"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "eventId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.handleSelectEvent()}]}},[_c('option',{attrs:{"value":""}},[_vm._v(" Selecione ...")]),_vm._v(" "),_vm._l((_vm.eventsOptions),function(events){return _c('option',{key:events.value,domProps:{"value":events.value}},[_vm._v(" "+_vm._s(events.label)+"\n            ")])})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.eventId.invalid),expression:"eventId.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('eventId'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"barcode"}},[_vm._v("Código do Ticket")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.barcode),expression:"modelValidations.barcode"},{name:"model",rawName:"v-model",value:(_vm.model.barcode),expression:"model.barcode"}],staticClass:"form-control",attrs:{"readonly":_vm.config.ticket.automaticBarcode,"id":"barcode","name":"barcode"},domProps:{"value":(_vm.model.barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "barcode", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.barcode.invalid),expression:"barcode.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('barcode'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-wd btn-fill btn-success btn-sm",attrs:{"type":"button","disabled":_vm.saving || !_vm.model.eventId || _vm.model.eventId === ''},on:{"click":function($event){return _vm.handleCreateTicket()}}},[_vm._v(" Gerar Ticket\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-ticket"}),_vm._v(" Novo Ticket ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KDiF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KEGj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KHLO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KIE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket)?_c('div',{staticClass:"ticket-card"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ticket._id),expression:"!ticket._id"}],staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Evento")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event ? ((_vm.event.reference) + " - " + (_vm.event.place)) : '-'))]),_vm._v(" "),_c('dt',[_vm._v("Estoque")]),_vm._v(" "),_c('dd',[_c('span',{staticClass:"label",class:_vm.hasStock ? 'label-success' : 'label-danger'},[_vm._v("\n              "+_vm._s(_vm.hasStock ? _vm.stock.description : 'Sem estoque')+"\n              ")])]),_vm._v(" "),_c('dt',[_vm._v("Ticket sorteado?")]),_vm._v(" "),_c('dd',[_c('span',{staticClass:"label",class:_vm.winner ? 'label-success' : 'label-danger'},[_vm._v("\n                "+_vm._s(_vm.winner ? 'Sim' : 'Não')+"\n              ")])]),_vm._v(" "),_c('dt',[_vm._v("Esteve presente?")]),_vm._v(" "),_c('dd',[_c('span',{staticClass:"label",class:_vm.checkin ? 'label-success' : 'label-danger'},[_vm._v("\n                "+_vm._s(_vm.checkin ? 'Sim' : 'Não')+"\n              ")])]),_vm._v(" "),_c('dt',[_vm._v("Código de barra")]),_vm._v(" "),_c('dd',{on:{"click":_vm.loadTicket}},[_c('a',[_vm._v(_vm._s(_vm.ticket.barcode))])]),_vm._v(" "),_c('dt',[_vm._v("Documentado?")]),_vm._v(" "),_c('dd',[_c('span',{staticClass:"label",class:_vm.documentedAt ? 'label-success' : 'label-danger'},[_vm._v("\n              "+_vm._s(_vm.documentedAt ? _vm.documentedAt : 'Não')+"\n              ")])]),_vm._v(" "),_c('dt',[_vm._v("Criado em")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("moment")(_vm.ticket.createdAt,'LLL')))]),_vm._v(" "),_c('dt',[_vm._v("Ultima Atualização")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.updatedAt))]),_vm._v(" "),_c('dt',[_vm._v("Criado por:")]),_vm._v(" "),_c('dd',[_c('strong',[_vm._v(_vm._s(_vm.users[_vm.ticket.userId]))])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-ticket"}),_vm._v("Dados do Ticket")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KMHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Webcam_vue__ = __webpack_require__("OkIP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbb671a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Webcam_vue__ = __webpack_require__("iywj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Webcam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbb671a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Webcam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KODb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnAssociateStock',
  data: function data() {
    return {
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('stocks', {
    stocks: 'stocks'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tickets', {
    ticketsWinners: 'winners'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('events', ['event']), {
    countAvailableRefrigeratorsOnStock: function countAvailableRefrigeratorsOnStock() {
      return this.availableStocks.reduce(function (sum, stock) {
        return sum + stock.left;
      }, 0);
    },
    countRefrigeratorsOnStock: function countRefrigeratorsOnStock() {
      return this.availableStocks.reduce(function (sum, stock) {
        return sum + stock.total;
      }, 0);
    },
    usedStocks: function usedStocks() {
      return this.ticketsWinners.reduce(function (allTickets, ticket) {
        if (ticket.stockId !== null) {
          if (ticket.stockId in allTickets) {
            allTickets[ticket.stockId]++;
          } else {
            allTickets[ticket.stockId] = 1;
          }
        }
        return allTickets;
      }, {});
    },
    availableStocks: function availableStocks() {
      var _this = this;

      return this.stocks.map(function (item) {
        var used = item._id in _this.usedStocks ? _this.usedStocks[item._id] : 0;
        return {
          _id: item._id,
          left: parseInt(item.numberOfRefigerators) - used,
          total: parseInt(item.numberOfRefigerators)
        };
      });
    },
    ticketsWinnersWithoutStock: function ticketsWinnersWithoutStock() {
      return this.ticketsWinners.filter(function (item) {
        return !item.stockId;
      });
    },
    countTicketsWinnersWithoutStock: function countTicketsWinnersWithoutStock() {
      return this.ticketsWinnersWithoutStock.length;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['changeExecution']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tickets', ['associateStock']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('stocks', { fetchStocks: 'fetchAll' }), {
    handleAssociateStock: function handleAssociateStock() {
      var _this2 = this;

      console.log('1');
      var swalOptions = {
        title: this.countTicketsWinnersWithoutStock + ' ticket(s)</b> sem estoque',
        html: 'H\xE1 ' + this.stocks.length + ' nota(s) fiscai(s) cadastrada(s) com <b class="text-success">' + this.countAvailableRefrigeratorsOnStock + ' refrigeradores</b> dispon\xEDveis de um total de <b class="text-warning">' + this.countRefrigeratorsOnStock + ' em estoque</b>.'
      };

      if (this.countTicketsWinnersWithoutStock === 0) {
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          title: swalOptions.title,
          text: 'Todos os tickets ganhadores j\xE1 est\xE3o associados com estoque.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
      }

      if (this.countAvailableRefrigeratorsOnStock === 0) {
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          title: swalOptions.title,
          html: 'N\xE3o h\xE1 estoque dispon\xEDvel.<br /><br />' + swalOptions.html,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
      }

      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: swalOptions.title,
        html: swalOptions.html + '<br /><br /> Voc\xEA deseja associar o estoque dispon\xEDvel?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, desejo associar!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          _this2.execAssociateStock();
        }
      });
    },
    execAssociateStock: function execAssociateStock() {
      var _this3 = this;

      this.loading = true;
      this.changeExecution(true);
      var index = 0;
      var tickets = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.ticketsWinnersWithoutStock);
      var stockLeft = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.availableStocks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stock = _step.value;

          if (stock.left <= 0) {
            continue;
          }

          stockLeft.push(stock.left);

          for (var i = 0; i < stock.left; i++) {
            if (!tickets[index]) {
              break;
            }
            tickets[index].stockId = stock._id;
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.unset(tickets[index], 'customer');
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.unset(tickets[index], 'stock');
            ++index;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var totalStockLeft = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sum(stockLeft);
      tickets = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.slice(tickets, 0, totalStockLeft);
      console.log(tickets);
      this.associateStock({ tickets: tickets }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Sucessso', 'Estoque associado com sucesso.', 'success');
        _this3.$emit('fetchTickets');
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          width: 1000,
          title: 'Ocorreu um erro ao associar estoque.',
          text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
          type: 'error',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        });
      }).finally(function () {
        _this3.loading = false;
        _this3.changeExecution(false);
      });
    }
  }),

  mounted: function mounted() {
    this.fetchStocks({ where: { eventId: this.event._id }, limit: 99 });
  }
});

/***/ }),

/***/ "KULE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.$can('all.tickets.documents.print') && this.event.status !== 2))?_c('button',{staticClass:"btn btn-fill btn-wd btn-default btn-block btn-router",on:{"click":function($event){return _vm.handleClick()}}},[(_vm.eligibleNotWinners)?_c('span',[_vm._v("\n    Download Tickets Reservas\n  ")]):_c('span',[_vm._v("\n    Download Tickets Ganhadores\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('form',[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('name'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Texto informartivo")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.informativeText),expression:"modelValidations.informativeText"},{name:"model",rawName:"v-model",value:(_vm.model.informativeText),expression:"model.informativeText"}],staticClass:"form-control",attrs:{"rows":"3","name":"informativeText"},domProps:{"value":(_vm.model.informativeText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "informativeText", $event.target.value)}}}),_vm._v(" "),_c('p',{staticClass:"text-right help-block"},[_c('small',[_vm._v(" "+_vm._s(((_vm.model.informativeText.length) + " / 600")))])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.informativeText.invalid),expression:"informativeText.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('informativeText'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.handleSave()}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__ = __webpack_require__("atjs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__ = __webpack_require__("bxZR");
function injectStyle (ssrContext) {
  __webpack_require__("J4xn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__ = __webpack_require__("KWr6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Charts_vue__ = __webpack_require__("uwQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Components_Buttons_vue__ = __webpack_require__("fP9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Components_GridSystem_vue__ = __webpack_require__("671N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Components_Icons_vue__ = __webpack_require__("RM11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Components_Notifications_vue__ = __webpack_require__("+VxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Components_Panels_vue__ = __webpack_require__("i0bx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Components_SweetAlert_vue__ = __webpack_require__("ribu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Components_Typography_vue__ = __webpack_require__("f6/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Forms_ExtendedForms_vue__ = __webpack_require__("5xQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Forms_RegularForms_vue__ = __webpack_require__("PAWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Forms_ValidationForms_vue__ = __webpack_require__("5Bu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Forms_Wizard_vue__ = __webpack_require__("eSiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Maps_FullScreenMap_vue__ = __webpack_require__("mj6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Maps_GoogleMaps_vue__ = __webpack_require__("Dwjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__ = __webpack_require__("ZZNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Pages_Lock_vue__ = __webpack_require__("duHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Pages_TimeLinePage_vue__ = __webpack_require__("4d5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Pages_UserProfile_vue__ = __webpack_require__("9gNx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_ExtendedTables_vue__ = __webpack_require__("jJHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Tables_PaginatedTables_vue__ = __webpack_require__("Kakj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Tables_RegularTables_vue__ = __webpack_require__("yg6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_pages_Commands_Commands__ = __webpack_require__("c+12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_pages_Commands_CommandsIndex__ = __webpack_require__("PsIb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_pages_Commands_ListAttachments__ = __webpack_require__("dHdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_pages_Dashboard_Dashboard_vue__ = __webpack_require__("vpir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_pages_Documents_DocumentTicket__ = __webpack_require__("jK9W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_pages_Documents_Terms_LampsDocument__ = __webpack_require__("39SL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_pages_Login_Login_vue__ = __webpack_require__("F/pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_pages_Documents_DocumentsPrint__ = __webpack_require__("3LcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_pages_Documents_AllTicketsDocument__ = __webpack_require__("43Tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Documents_DocumentTicketEquatorial__ = __webpack_require__("NELa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Trg_Documents_TicketsRegister_DocTicketRegister__ = __webpack_require__("tP3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_pages_Tickets_Print__ = __webpack_require__("CP+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_pages_Ranking_RankingPrintWinners__ = __webpack_require__("SEW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__routes_customers__ = __webpack_require__("2+nh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__routes_events__ = __webpack_require__("tyLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__routes_eventsSpecifications__ = __webpack_require__("XkR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__routes_statusReplication__ = __webpack_require__("QKg7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__routes_manufacturers__ = __webpack_require__("2fI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__routes_project__ = __webpack_require__("SyeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__routes_reports__ = __webpack_require__("F0oW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__routes_roles__ = __webpack_require__("SkYo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__routes_stock__ = __webpack_require__("2Yyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__routes_users__ = __webpack_require__("ypVq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__routes_sync__ = __webpack_require__("xDzV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__routes_tag__ = __webpack_require__("bQRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__routes_api__ = __webpack_require__("1AW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__routes_surveys__ = __webpack_require__("ilmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__routes_categories__ = __webpack_require__("X/xm");





































































var configurationsMenu = {
  path: '/configurations',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/configurations/users',
  children: [__WEBPACK_IMPORTED_MODULE_49__routes_users__["a" /* default */], __WEBPACK_IMPORTED_MODULE_45__routes_project__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__routes_manufacturers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_47__routes_roles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_51__routes_tag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_52__routes_api__["a" /* default */], __WEBPACK_IMPORTED_MODULE_54__routes_categories__["a" /* default */]]
};

var manageMenu = {
  path: '/manage',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/manage/events',
  children: [__WEBPACK_IMPORTED_MODULE_41__routes_events__["a" /* default */], __WEBPACK_IMPORTED_MODULE_42__routes_eventsSpecifications__["a" /* default */], __WEBPACK_IMPORTED_MODULE_40__routes_customers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_48__routes_stock__["a" /* default */], __WEBPACK_IMPORTED_MODULE_46__routes_reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_50__routes_sync__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__routes_statusReplication__["a" /* default */]]
};

var a = __WEBPACK_IMPORTED_MODULE_53__routes_surveys__["a" /* default */];

var documentsRoutes = {
  path: '/print',
  component: __WEBPACK_IMPORTED_MODULE_36_src_pages_Tickets_Print__["a" /* default */],
  children: [{
    path: 'ticket/register/print/:id',
    name: 'tickets.register.print',
    component: __WEBPACK_IMPORTED_MODULE_35__components_Trg_Documents_TicketsRegister_DocTicketRegister__["a" /* default */],
    meta: {
      title: 'Ticket',
      requireAuth: true
    }
  }, {
    path: 'ticket/:id',
    name: 'tickets.print',
    component: __WEBPACK_IMPORTED_MODULE_29_src_pages_Documents_DocumentTicket__["a" /* default */],
    meta: {
      title: 'Ticket',
      requireAuth: true
    }
  }, {
    path: 'documents/:eventId/:ticketId',
    name: 'documents.print',
    component: __WEBPACK_IMPORTED_MODULE_32_src_pages_Documents_DocumentsPrint__["a" /* default */],
    meta: {
      title: 'Documentos',
      requireAuth: true
    }
  }, {
    path: 'lamps/term',
    name: 'lamps.print',
    component: __WEBPACK_IMPORTED_MODULE_30_src_pages_Documents_Terms_LampsDocument__["a" /* default */],
    meta: {
      title: 'Lâmpadas',
      requireAuth: true
    }
  }, {
    path: 'event/:id/ranking/winners/print',
    name: 'ranking.print.winners',
    component: __WEBPACK_IMPORTED_MODULE_37_src_pages_Ranking_RankingPrintWinners__["a" /* default */],
    meta: {
      title: {
        requireAuth: true
      }
    }
  }, {
    path: 'tickets/event/:id/:eligibleNotWinners',
    name: 'all.tickets.documents.print',
    component: __WEBPACK_IMPORTED_MODULE_33_src_pages_Documents_AllTicketsDocument__["a" /* default */],
    meta: {
      title: {
        requireAuth: true
      }
    }
  }, {
    path: 'tickets/equatorial/:eventId/:ticketId',
    name: 'document.ticket.equatorial',
    component: __WEBPACK_IMPORTED_MODULE_34__pages_Documents_DocumentTicketEquatorial__["a" /* default */],
    meta: {
      title: {
        requireAuth: true
      }
    }
  }]
};

var commandsRoutes = {
  path: '/commands',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_25_src_pages_Commands_Commands__["a" /* default */],
    children: [{
      path: '',
      name: 'commands.index',
      component: __WEBPACK_IMPORTED_MODULE_26_src_pages_Commands_CommandsIndex__["a" /* default */],
      meta: {
        title: 'Commands',
        requireAuth: true
      }
    }, {
      path: 'list-attachments/:connection',
      name: 'commands.listAttachments',
      component: __WEBPACK_IMPORTED_MODULE_27_src_pages_Commands_ListAttachments__["a" /* default */],
      meta: {
        title: 'Listar Attachments',
        requireAuth: true
      }
    }]
  }]
};

var componentsMenu = {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/components/buttons',
  children: [{
    path: 'buttons',
    name: 'Buttons',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Components_Buttons_vue__["a" /* default */]
  }, {
    path: 'grid-system',
    name: 'Grid System',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Components_GridSystem_vue__["a" /* default */]
  }, {
    path: 'panels',
    name: 'Panels',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Components_Panels_vue__["a" /* default */]
  }, {
    path: 'sweet-alert',
    name: 'Sweet Alert',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Components_SweetAlert_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Components_Notifications_vue__["a" /* default */]
  }, {
    path: 'icons',
    name: 'Icons',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Components_Icons_vue__["a" /* default */]
  }, {
    path: 'typography',
    name: 'Typography',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Components_Typography_vue__["a" /* default */]
  }]
};
var formsMenu = {
  path: '/forms',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/forms/regular',
  children: [{
    path: 'regular',
    name: 'Regular Forms',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Forms_RegularForms_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Forms',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Forms_ExtendedForms_vue__["a" /* default */]
  }, {
    path: 'validation',
    name: 'Validation Forms',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Forms_ValidationForms_vue__["a" /* default */]
  }, {
    path: 'wizard',
    name: 'Wizard',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Forms_Wizard_vue__["a" /* default */]
  }]
};
var tablesMenu = {
  path: '/table-list',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/table-list/regular',
  children: [{
    path: 'regular',
    name: 'Regular Tables',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Tables_RegularTables_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Tables',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_ExtendedTables_vue__["a" /* default */]
  }, {
    path: 'paginated',
    name: 'Paginated Tables',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Tables_PaginatedTables_vue__["a" /* default */]
  }]
};
var mapsMenu = {
  path: '/maps',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/maps/google',
  children: [{
    path: 'google',
    name: 'Google Maps',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Maps_GoogleMaps_vue__["a" /* default */]
  }, {
    path: 'full-screen',
    name: 'Full Screen Map',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Maps_FullScreenMap_vue__["a" /* default */]
  }, {
    path: 'vector-map',
    name: 'Vector Map',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__["a" /* default */]
  }]
};
var pagesMenu = {
  path: '/pages',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/pages/user',
  children: [{
    path: 'user',
    name: 'User Page',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Pages_UserProfile_vue__["a" /* default */]
  }, {
    path: 'timeline',
    name: 'Timeline Page',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Pages_TimeLinePage_vue__["a" /* default */]
  }]
};
var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_31_src_pages_Login_Login_vue__["a" /* default */]
};
var registerPage = {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Pages_Register_vue__["a" /* default */]
};
var lockPage = {
  path: '/lock',
  name: 'Lock',
  component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Pages_Lock_vue__["a" /* default */]
};

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/login',
  children: [{
    path: 'calendar',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__["a" /* default */]
  }, {
    path: 'charts',
    name: 'Charts',
    component: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Charts_vue__["a" /* default */]
  }]
}, a, documentsRoutes, commandsRoutes, configurationsMenu, manageMenu, componentsMenu, formsMenu, tablesMenu, mapsMenu, pagesMenu, loginPage, registerPage, lockPage, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/dashboard',
  children: [{
    path: 'dashboard',
    name: 'dashboard.overview',
    component: __WEBPACK_IMPORTED_MODULE_28_src_pages_Dashboard_Dashboard_vue__["a" /* default */],
    meta: {
      title: 'Dashboard',
      requireAuth: true
    }
  }]
}, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_38__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/theme',
  children: [{
    path: 'theme',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */],
    meta: {
      requireAuth: true
    }
  }, {
    path: 'stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Dashboard_Stats_vue__["a" /* default */]
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_39__components_GeneralViews_NotFoundPage_vue__["a" /* default */]
}];


/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.0","/home/macedo/trg-admin"]],"_development":true,"_from":"elliptic@6.5.0","_id":"elliptic@6.5.0","_inBundle":false,"_integrity":"sha512-eFOJTMyCYb7xtE/caJ6JJu+bhi67WCYNbkGSknu20pmM8Ke/bqOfdnZWxyoGN26JgfxTbXrsCkEw4KheCT/KGg==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.0","saveSpec":null,"fetchSpec":"6.5.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.0.tgz","_spec":"6.5.0","_where":"/home/macedo/trg-admin","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.0"}

/***/ }),

/***/ "KaKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPrintTerms_vue__ = __webpack_require__("NRui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e195e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPrintTerms_vue__ = __webpack_require__("uB1t");
function injectStyle (ssrContext) {
  __webpack_require__("oI26")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54e195e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnPrintTerms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e195e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnPrintTerms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kakj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__ = __webpack_require__("77+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__ = __webpack_require__("3TKg");
function injectStyle (ssrContext) {
  __webpack_require__("VEgf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kf9e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KtLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('edit-profile-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kudb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-buttons"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('top', 'left')}}},[_vm._v("Top Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('top', 'center')}}},[_vm._v("Top Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('top', 'right')}}},[_vm._v("Top Right")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('bottom', 'left')}}},[_vm._v("Bottom Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('bottom', 'center')}}},[_vm._v("Bottom Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.notifyVue('bottom', 'right')}}},[_vm._v("Bottom Right")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Notifications")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Custom Vue notifications plugin")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notifications Style")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a plain notification")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a notification with close button.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-bell",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-pie-chart",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon and have many lines.\n            You can see that the icon and the close button are always vertically aligned.\n            This is a beautiful notification. So you don't have to worry about the style.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notification states")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Info - ")]),_vm._v(" This is a regular notification made with \".alert-info\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Success - ")]),_vm._v(" This is a regular notification made with \".alert-success\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Warning - ")]),_vm._v(" This is a regular notification made with \".alert-warning\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Danger - ")]),_vm._v(" This is a regular notification made with \".alert-danger\"")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h5',[_vm._v("Notifications Places\n            "),_c('p',{staticClass:"category"},[_vm._v("Click to view notifications")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [{
        id: 1,
        name: 'Dakota Rice',
        salary: '$36.738',
        country: 'Niger',
        city: 'Oud-Turnhout'
      }, {
        id: 2,
        name: 'Minerva Hooper',
        salary: '$23,789',
        country: 'Curaçao',
        city: 'Sinaai-Waas'
      }, {
        id: 3,
        name: 'Sage Rodriguez',
        salary: '$56,142',
        country: 'Netherlands',
        city: 'Baileux'
      }, {
        id: 4,
        name: 'Philip Chaney',
        salary: '$38,735',
        country: 'Korea, South',
        city: 'Overland Park'
      }, {
        id: 5,
        name: 'Doris Greene',
        salary: '$63,542',
        country: 'Malawi',
        city: 'Feldkirchen in Kärnten'
      }]
    };
  },

  methods: {
    tableRowClassName: function tableRowClassName(row, index) {
      if (index === 0) {
        return 'success';
      } else if (index === 2) {
        return 'info';
      } else if (index === 4) {
        return 'danger';
      } else if (index === 6) {
        return 'warning';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "L1yC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerDetail_vue__ = __webpack_require__("3Ira");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbafd54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerDetail_vue__ = __webpack_require__("Da5l");
function injectStyle (ssrContext) {
  __webpack_require__("Ygtx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fbafd54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbafd54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L7Um":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-actions',

  props: {
    tickets: {
      required: true
    },
    event: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('surveys', {
    surveys: 'surveyValid'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('ranking', {
    rankingLoading: 'loading'
  }), {
    minimumSurveys: function minimumSurveys() {
      return this.surveys.length < Number(this.event.numberOfRefigerators);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tickets', ['makeRanking']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ranking', { setRankingLoading: 'changeLoading' }), {
    runMakeRanking: function runMakeRanking() {
      var _this = this;

      this.setRankingLoading(true);
      var tickets = this.generateTicketsSortRanking();
      this.makeRanking(tickets).then(function () {
        _this.$notify({
          message: 'Ranking gerado com sucesso',
          type: 'success'
        });
      }).catch(function () {
        _this.$notify({
          message: 'Houve um problema para gerar o ranking',
          type: 'error'
        });
      }).finally(function () {
        _this.setRankingLoading(false);
        _this.$emit('runMakeRanking');
      });
    },
    generateTicketsSortRanking: function generateTicketsSortRanking() {
      var _this2 = this;

      var tickets = this.tickets.map(function (ticketMap) {
        var survey = _this2.surveys.find(function (survey) {
          return survey.ticketId === ticketMap._id;
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ticketMap, {
          survey: survey
        });
      }).sort(function (a, b) {
        return _this2.sortRanking(a, b);
      }).map(function (ticketMapRankingOriginal, index) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ticketMapRankingOriginal, {
          rankingOriginal: Number(index) + 1,
          rankingNow: Number(index) + 1
        });
      });

      return tickets;
    },
    sortRanking: function sortRanking(a, b) {
      var scoreA = a.survey && a.survey.data && a.survey.data.refrigerator && a.survey.data.refrigerator.score ? a.survey.data.refrigerator.score : 0;
      var scoreB = b.survey && b.survey.data && b.survey.data.refrigerator && b.survey.data.refrigerator.score ? b.survey.data.refrigerator.score : 0;

      var refrigeratorAgeA = a.survey && a.survey.data && a.survey.data.refrigerator && a.survey.data.refrigerator.yearsUse ? a.survey.data.refrigerator.yearsUse : 0;
      var refrigeratorAgeB = b.survey && b.survey.data && b.survey.data.refrigerator && b.survey.data.refrigerator.yearsUse ? b.survey.data.refrigerator.yearsUse : 0;

      var ageCustomerA = new Date(a.createdAt);
      var complementaryAgeCustomerA = '' + (10000 - ageCustomerA.getYear()) + (100 - ageCustomerA.getMonth()) + (100 - ageCustomerA.getDay());
      var ageCustomerB = new Date(b.createdAt);
      var complementaryAgeCustomerB = '' + (10000 - ageCustomerB.getYear()) + (100 - ageCustomerB.getMonth()) + (100 - ageCustomerB.getDay());

      var totalScoreA = '' + scoreA + refrigeratorAgeA + complementaryAgeCustomerA;
      var totalScoreB = '' + scoreB + refrigeratorAgeB + complementaryAgeCustomerB;

      if (a.hasOwnProperty('absentAt') || b.hasOwnProperty('absentAt')) {
        totalScoreA = Number(a.absentAt ? 1 : 0) + totalScoreA;
        totalScoreB = Number(b.absentAt ? 1 : 0) + totalScoreB;

        return totalScoreB.localeCompare(totalScoreA);
      }

      if (a.energyMetering || b.energyMetering) {
        totalScoreA = Number(a.energyMetering ? 1 : 0) + totalScoreA;
        totalScoreB = Number(b.energyMetering ? 1 : 0) + totalScoreB;

        return totalScoreB.localeCompare(totalScoreA);
      }

      return totalScoreB.localeCompare(totalScoreA);
    },
    printWinnerList: function printWinnerList() {
      var routeData = this.$router.resolve({
        name: 'ranking.print.winners',
        params: { id: this.event._id }
      });
      window.open(routeData.href, 'ticketWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
      return true;
    }
  })
});

/***/ }),

/***/ "LAwX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LCxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LHHQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.link.stock'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-warning btn-block btn-router",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.handleAssociateStock()}}},[_vm._v("\n  Associar Estoque\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LIdw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-view"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-8"},[_c('customer-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.customerLoading),expression:"customerLoading"}],attrs:{"customer":_vm.customer,"show-edit-button":false}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-4"},[_c('customer-image-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.customerLoading),expression:"customerLoading"}],attrs:{"has-image":true,"customer":_vm.customer,"show-edit-button":false}})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.surveyLoading),expression:"surveyLoading"}],staticClass:"card-content row"},[_c('div',{staticClass:"col-lg-6 col-xs-12"},[_c('survey-view-general',{attrs:{"survey":_vm.survey}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xs-12"},[_c('survey-view-detail',{attrs:{"survey":_vm.survey}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('survey-view-images',{attrs:{"survey":_vm.survey}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Pesquisa")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LL4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-iasc-energisa-borborema-pb',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', { config: 'project' }), {

    customer: {
      get: function get() {
        return this.payload.customer;
      }
    },

    customerFullAddress: function customerFullAddress() {
      return this.customer.address.street + ', n\xBA ' + this.customer.address.number + ', ' + this.customer.address.neighborhood + ', ' + this.customer.address.city + ', CEP ' + this.customer.address.zip;
    },

    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Borborema';
    },
    abbreviation: function abbreviation() {
      return '';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 158',
        neighborhood: 'Bairro 3 Irmãs',
        city: 'Campina Grande',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '08.826.596/0001-95';
    },
    numberState: function numberState() {
      return '16.003.839/1';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }),

  mounted: function mounted() {
    this.setValues();
  }
});

/***/ }),

/***/ "LPfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalContent__ = __webpack_require__("HVzr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GalleryComponent',
  components: { ModalContent: __WEBPACK_IMPORTED_MODULE_0__ModalContent__["a" /* default */] },
  props: {
    images: {
      default: function _default() {
        return [];
      }
    },
    index: {
      default: 0
    }
  },

  data: function data() {
    return {
      currentIndex: 0
    };
  },


  watch: {
    index: function index() {
      var _this = this;

      this.$nextTick(function () {
        _this.currentIndex = _this.index;
      });
    }
  },

  computed: {
    currentImg: function currentImg() {
      return this.images[this.currentIndex];
    }
  },

  methods: {
    closeModal: function closeModal() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "LPmA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButtonClick_vue__ = __webpack_require__("kjFA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83ecd80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButtonClick_vue__ = __webpack_require__("uzjw");
function injectStyle (ssrContext) {
  __webpack_require__("LrjL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83ecd80c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButtonClick_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83ecd80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButtonClick_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LQk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lcgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_downloadjs__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampsUsersReport',
  props: {
    csvSeparator: {
      required: true,
      default: ';'
    }
  },
  data: function data() {
    return {
      allUsers: false,
      csv: '',
      rangeDate: [],
      reporting: false,
      lampsData: {},
      headers: {
        'name': 'Nome',
        'dates': []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('users', ['users']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', ['events']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lamps', { lamps: 'lampsAll' }), {
    queryDateRange: function queryDateRange() {
      return this.rangeDate.length === 2 ? [this.rangeDate[0], new Date(this.rangeDate[1].setDate(this.rangeDate[1].getDate() + 1))] : [];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('users', { fetchUsers: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('lamps', { fetchLamps: 'fetchAll' }), {
    loadingReport: function loadingReport() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Informações',
        text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        onOpen: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.showLoading();
                    _context.next = 3;
                    return _this.runReport();

                  case 3:
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.hideLoading();
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.close();

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function onOpen() {
            return _ref.apply(this, arguments);
          };
        }()
      }).catch(function (err) {
        console.log(err);
      });
    },
    runReport: function runReport() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getLamps();

              case 2:
                _context2.next = 4;
                return _this2.buildReport();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getLamps: function getLamps() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var query;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                query = {};

                if (_this3.queryDateRange.length === 2) {
                  query['createdAt'] = {
                    '$gte': _this3.queryDateRange[0],
                    '$lt': _this3.queryDateRange[1]
                  };
                }
                return _context3.abrupt('return', _this3.fetchLamps({ where: query, limit: 9999999, select: ['userId', 'items', 'createdAt'] }).then(function () {
                  var _loop = function _loop(lamp) {
                    if (!lamp.hasOwnProperty('userId') || !lamp.hasOwnProperty('items')) {
                      return 'continue';
                    }
                    if (!_this3.lampsData.hasOwnProperty(lamp.userId)) {
                      _this3.lampsData[lamp.userId] = {};
                    }
                    var date = new Date(lamp.createdAt).getFullYear() + '-' + (new Date(lamp.createdAt).getMonth() + 1);
                    if (!_this3.headers.dates.find(function (item) {
                      return item === date;
                    })) {
                      _this3.headers.dates.push(date);
                    }
                    if (!_this3.lampsData[lamp.userId].hasOwnProperty(date)) {
                      _this3.lampsData[lamp.userId][date] = 0;
                    }
                    _this3.lampsData[lamp.userId][date] += lamp.items.length;
                  };

                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var lamp = _step.value;

                      var _ret = _loop(lamp);

                      if (_ret === 'continue') continue;
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                }));

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    buildReport: function buildReport() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.insertHeaders();
                _this4.insertBody();
                _this4.download(_this4.csv);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    insertBody: function insertBody() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.users), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var user = _step2.value;

          if (user.name === 'Codeseven') {
            continue;
          }

          if (!this.lampsData.hasOwnProperty(user._id)) {
            if (this.allUsers) {
              this.insertUserWithoutLamps(user);
            }
            continue;
          }

          this.csv += '"' + user.name + '"';
          this.csv += this.csvSeparator;

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.headers.dates), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _date = _step3.value;

              if (!this.lampsData[user._id].hasOwnProperty(_date)) {
                this.csv += '0';
                this.csv += this.csvSeparator;
                continue;
              }

              this.csv += '"' + this.lampsData[user._id][_date] + '"';
              this.csv += this.csvSeparator;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          this.csv += '\n';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    insertUserWithoutLamps: function insertUserWithoutLamps(user) {
      this.csv += '"' + user.name + '"';
      this.csv += this.csvSeparator;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.headers.dates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _date2 = _step4.value;

          _date2 = _date2[0];
          this.csv += '0';
          this.csv += this.csvSeparator;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.csv += '\n';
    },
    insertHeaders: function insertHeaders() {
      this.headers.dates = this.headers.dates.sort(function (a, b) {
        var dateA = a.split('-');
        var dateB = b.split('-');
        dateA = [parseInt(dateA[1]) < 10 ? '0' + dateA[1] : dateA[1], dateA[0]].join();
        dateB = [parseInt(dateB[1]) < 10 ? '0' + dateB[1] : dateB[1], dateA[0]].join();
        return dateA.localeCompare(dateB);
      });
      this.csv += '"' + this.headers.name + '"';
      this.csv += this.csvSeparator;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.headers.dates), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _date3 = _step5.value;

          this.csv += '"' + _date3 + '"';
          this.csv += this.csvSeparator;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.csv += '\n';
    },
    download: function download(report) {
      var blob = __WEBPACK_IMPORTED_MODULE_6_blob_util___default.a.createBlob([report], { type: 'text/plain' });
      var now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss');
      var filename = 'Relat\xF3rio de lampadas por usu\xE1rio_' + now;
      __WEBPACK_IMPORTED_MODULE_7_downloadjs___default()(blob, filename + '.csv', 'text/csv');
    }
  }),
  mounted: function mounted() {
    this.fetchUsers({ select: ['_id', 'name'], limit: 9999 });
  }
});

/***/ }),

/***/ "LdiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Login")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Login Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LfTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocLocalDate_vue__ = __webpack_require__("D+Lu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a131fea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocLocalDate_vue__ = __webpack_require__("9O9U");
function injectStyle (ssrContext) {
  __webpack_require__("Sv46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a131fea0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocLocalDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a131fea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocLocalDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LfTo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.download.documents') && _vm.event.status !== 1 && this.event.status !== 2)?_c('button',{staticClass:"btn btn-fill btn-wd btn-default btn-block btn-router",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.handleDocumentsDownload()}}},[_vm._v("\n  Download Documentação\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lfch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyInfoForm_vue__ = __webpack_require__("t+Cn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8b44f46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyInfoForm_vue__ = __webpack_require__("7huo");
function injectStyle (ssrContext) {
  __webpack_require__("74I8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8b44f46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8b44f46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LiVc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LpN4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lqpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCustomersImport_vue__ = __webpack_require__("JsSo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea0d0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCustomersImport_vue__ = __webpack_require__("0D/4");
function injectStyle (ssrContext) {
  __webpack_require__("Fm2f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ea0d0d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCustomersImport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea0d0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCustomersImport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LrjL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ls6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LuYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 box"},[_c('span',[_vm._v("Evento:")]),_vm._v(" "),_c('el-select',{staticClass:"select-primary el-select item",attrs:{"name":"eventId","size":"large","placeholder":"Selecione um evento"},on:{"change":function($event){return _vm.$emit('eventSelected', _vm.eventId)}},model:{value:(_vm.eventId),callback:function ($$v) {_vm.eventId=$$v},expression:"eventId"}},_vm._l((_vm.events),function(event,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"label":event.label,"value":event.value}})}),1),_vm._v(" "),_c('span',[_vm._v("Pesquisador: ")]),_vm._v(" "),_c('el-select',{staticClass:"select-primary el-select item",attrs:{"filterable":"","size":"large","placeholder":"Selecione um usuário"},on:{"change":function($event){return _vm.$emit('userSelected', _vm.userId)}},model:{value:(_vm.userId),callback:function ($$v) {_vm.userId=$$v},expression:"userId"}},[_c('el-option',{attrs:{"value":""}},[_vm._v(" Todos...")]),_vm._v(" "),_vm._l((_vm.usersList),function(val,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"value":val._id,"label":val.name}})})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lusp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LvnI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LwYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M/tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("XS Grid\n      "),_c('small',[_vm._v("Always Horizontal")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("SM Grid\n      "),_c('small',[_vm._v("Collapsed at 768px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("MD Grid\n      "),_c('small',[_vm._v("Collapsed at 992px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("LG Grid\n      "),_c('small',[_vm._v("Collapsed at 1200px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Mixed Grid\n      "),_c('small',[_vm._v("Showing different sizes on different screens")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Offset Grid\n      "),_c('small',[_vm._v("Adding some space when needed")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-md-offset-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3 col-md-offset-6")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-1")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-2")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-6 col-md-offset-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Paragraphs")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M0iJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M7ZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v(" Por favor preencha os dados iniciais do cliente. ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" UC ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.initialData.uc),expression:"modelValidations.initialData.uc"},{name:"model",rawName:"v-model.trim",value:(_vm.model.uc),expression:"model.uc",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('00000000000000000000000000000000'),expression:"'00000000000000000000000000000000'"}],ref:"uc",staticClass:"form-control",attrs:{"id":"uc","type":"text","name":"uc","autofocus":"","autocomplete":"off"},domProps:{"value":(_vm.model.uc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "uc", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.uc.invalid),expression:"uc.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('uc'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" CPF ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.initialData.cpf),expression:"modelValidations.initialData.cpf"},{name:"model",rawName:"v-model.trim",value:(_vm.model.cpf),expression:"model.cpf",modifiers:{"trim":true}},{name:"mask-cpf",rawName:"v-mask-cpf"}],staticClass:"form-control",attrs:{"type":"text","name":"cpf","autocomplete":"off"},domProps:{"value":(_vm.model.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cpf", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.cpf.invalid),expression:"cpf.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('cpf'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632a616f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MUxS");
function injectStyle (ssrContext) {
  __webpack_require__("CN5T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632a616f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MRUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCsvWinners_vue__ = __webpack_require__("tXqf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28285b50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCsvWinners_vue__ = __webpack_require__("ww74");
function injectStyle (ssrContext) {
  __webpack_require__("olec")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28285b50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCsvWinners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28285b50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCsvWinners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Trg_YesNoRadio__ = __webpack_require__("bkdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Trg_Customer_SelectRegularizationMethod__ = __webpack_require__("HvmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Trg_Customer_InputNis__ = __webpack_require__("Mth3");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PersonalDataForm',
  components: {
    SelectRegularizationMethod: __WEBPACK_IMPORTED_MODULE_4__components_Trg_Customer_SelectRegularizationMethod__["a" /* default */],
    InputNis: __WEBPACK_IMPORTED_MODULE_5__components_Trg_Customer_InputNis__["a" /* default */],
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_3__components_Trg_YesNoRadio__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['holder', 'aka', 'phone1', 'phone2', 'nationalId', 'birthdate', 'motherName', 'nis', 'regularity', 'carrer', 'politician']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', {
    model: 'customer',
    modelValidations: 'validations',
    loading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', {
    config: 'project',
    loading: 'loading'
  })),
  mounted: function mounted() {
    if (this.editing) {
      this.fetchOne(this.id);
    } else {
      this.resetOne();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('customers', ['fetchOne', 'resetOne', 'insert', 'update']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    onlyNumber: function onlyNumber(text) {
      this.model[text] = this.model[text].replace(/\D/g, '');
    }
  })
});

/***/ }),

/***/ "MUxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showGallery)?_c('GalleryComponent',{attrs:{"images":_vm.imagesGallery,"index":_vm.galleryIndex,"open":_vm.showGallery},on:{"close":function($event){return _vm.defineGallery({show: false, images: [], index: 0})}}}):_vm._e(),_vm._v(" "),_c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v("\n      "+_vm._s(_vm.config)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEventidLamps_vue__ = __webpack_require__("z4QI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0c87ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEventidLamps_vue__ = __webpack_require__("YGCQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEventidLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0c87ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEventidLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7afeda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("yJ3N");
function injectStyle (ssrContext) {
  __webpack_require__("uAJ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7afeda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mbg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEquatorialPi_vue__ = __webpack_require__("vqHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_142ecd7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEquatorialPi_vue__ = __webpack_require__("eZE/");
function injectStyle (ssrContext) {
  __webpack_require__("2Wue")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-142ecd7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEquatorialPi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_142ecd7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEquatorialPi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'TRG Admin'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'warning',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/trg-logo.svg'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', { sidebarLinks: 'sidebarLinks' }), {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  }),
  methods: {
    showPage: function showPage(link) {
      var page = '';
      if (link && link.hasOwnProperty('InputTag')) {
        page = link.InputTag.toLowerCase();
      }
      if (link && link.hasOwnProperty('tag')) {
        page = link.tag.toLowerCase();
      }

      if (page !== 'dashboard') {
        return this.$can(page, this.user);
      } else {
        return true;
      }
    },
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "MfaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnergisaBorboremaPb_vue__ = __webpack_require__("LNO3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4888c3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnergisaBorboremaPb_vue__ = __webpack_require__("UwO7");
function injectStyle (ssrContext) {
  __webpack_require__("Cmd2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4888c3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnergisaBorboremaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4888c3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnergisaBorboremaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mfxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter-map',
  props: {
    event: {
      default: ''
    },
    surveysList: {
      default: []
    },
    eventIdDefault: ''
  },
  data: function data() {
    return {
      eventId: '',
      userId: ''
    };
  },
  mounted: function mounted() {
    this.eventId = this.eventIdDefault;
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', {
    events: 'optionsById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', {
    users: 'usersIdName'
  }), {
    usersList: function name() {
      var usersList = this.surveysList.reduce(function (acc, curr) {
        if (!acc.hasOwnProperty(curr.user._id)) {
          acc[curr.user._id] = curr.user;
        }
        return acc;
      }, {});
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(usersList);
    }
  }),
  watch: {
    event: function event() {}
  }
});

/***/ }),

/***/ "Mi7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Miey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eventIdSelected: '',
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    events: {
      get: function get() {
        return this.$store.state.events.all;
      }
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), {
    handleCommand: function handleCommand() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      var query = __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].collection('tickets');
      if (this.eventIdSelected !== 'all') {
        query.where('eventId', this.eventIdSelected);
      }

      query.get().then(function (docs) {
        _this.isLoading = false;
        var docsFiltered = docs.filter(function (doc) {
          if (doc.documentedAt !== null) {
            return true;
          }
          return false;
        });

        _this.total = docsFiltered.length;
        var swalOptions = {
          title: 'Existem ' + docsFiltered.length + ' documentedAt!=null.'
        };
        if (docsFiltered.length === 0) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todos os tickets est\xE3o com documentedAt=null.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA quer setar documentedAt=null e apagar os documentos em todos os tickets?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, faça isso!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docsFiltered);

                  case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context.next = 12;
                      break;
                    }

                    item = _step.value;
                    _context.next = 9;
                    return _this.exec(item).then(function (result) {
                      if (_this.progress === _this.total) {
                        _this.notifyFinish();
                      }
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 9:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                  case 12:
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 18:
                    _context.prev = 18;
                    _context.prev = 19;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 21:
                    _context.prev = 21;

                    if (!_didIteratorError) {
                      _context.next = 24;
                      break;
                    }

                    throw _iteratorError;

                  case 24:
                    return _context.finish(21);

                  case 25:
                    return _context.finish(18);

                  case 26:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var doc, deleteDoc, update;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('docs').where('database', 'trg_admin').where('referenceId', item._id).first();

              case 2:
                doc = _context2.sent;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('docs').delete(doc._id);

              case 5:
                deleteDoc = _context2.sent;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].update(item._id, {
                  documentedAt: null
                });

              case 8:
                update = _context2.sent;

                _this2.progress++;
                return _context2.abrupt('return', [doc, deleteDoc, update]);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "MnEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "MotM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadPptx_vue__ = __webpack_require__("a1X1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74fa218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadPptx_vue__ = __webpack_require__("cQIt");
function injectStyle (ssrContext) {
  __webpack_require__("ZMB5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d74fa218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadPptx_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74fa218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadPptx_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mpj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MqVy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MsL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Company","disabled":true,"placeholder":"Paper dashboard"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"email","label":"Username","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"First Name","placeholder":"First Name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Last Name","placeholder":"Last Name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Address","placeholder":"Home Address"},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"City","placeholder":"City"},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Country","placeholder":"Country"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","label":"Postal Code","placeholder":"ZIP Code"},model:{value:(_vm.user.postalCode),callback:function ($$v) {_vm.$set(_vm.user, "postalCode", $$v)},expression:"user.postalCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("About Me")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.aboutMe),expression:"user.aboutMe"}],staticClass:"form-control border-input",attrs:{"rows":"5","placeholder":"Here can be your description"},domProps:{"value":(_vm.user.aboutMe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "aboutMe", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._v("\n          Update Profile\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Edit Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mth3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputNis_vue__ = __webpack_require__("Aaf5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfbcd80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputNis_vue__ = __webpack_require__("HJZ3");
function injectStyle (ssrContext) {
  __webpack_require__("1OnC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bfbcd80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputNis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfbcd80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputNis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MuVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDocument_vue__ = __webpack_require__("w/O6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba42f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDocument_vue__ = __webpack_require__("wEwH");
function injectStyle (ssrContext) {
  __webpack_require__("LAwX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ba42f2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba42f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mz90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__ = __webpack_require__("Vz2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15022d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__ = __webpack_require__("BQAr");
function injectStyle (ssrContext) {
  __webpack_require__("Q8+/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15022d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15022d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N/TY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N3ja":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NAtx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NELa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTicketEquatorial_vue__ = __webpack_require__("NorY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6badcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTicketEquatorial_vue__ = __webpack_require__("q5CK");
function injectStyle (ssrContext) {
  __webpack_require__("hRAx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f6badcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTicketEquatorial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6badcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTicketEquatorial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NFr3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_commands_AddEventIdOnLamps_vue__ = __webpack_require__("lXy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_commands_CopyAttachments_vue__ = __webpack_require__("ssah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_DeleteLosers_vue__ = __webpack_require__("yW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_commands_GenerateNewTickets_vue__ = __webpack_require__("v+6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_commands_RemoveAttachmentFromLamps_vue__ = __webpack_require__("HXOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_commands_RemoveDocsFromContemplados_vue__ = __webpack_require__("q2Pq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_commands_RemoveDuplicatedFiles__ = __webpack_require__("PAnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_commands_RemoveEventRanking__ = __webpack_require__("kKpG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_commands_RemoveDuplicatedLamps__ = __webpack_require__("gW1S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_commands_SetCustomerContemplado_vue__ = __webpack_require__("zpVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_commands_SetDocumentedAtNullDeleteDoc_vue__ = __webpack_require__("udAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_commands_SetEligibleTrue_vue__ = __webpack_require__("FcXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_commands_SetEventidLamps_vue__ = __webpack_require__("MZ/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_commands_SetStockNull_vue__ = __webpack_require__("w1iA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_commands_SetWinnerFalse_vue__ = __webpack_require__("rSI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_commands_MigrateConfigurationsToNewDatabase_vue__ = __webpack_require__("3aj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_commands_ChangeEventsTagNameToTagId_vue__ = __webpack_require__("yMmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_commands_RemoveConfigurationsDuplicated_vue__ = __webpack_require__("rY/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_commands_RemoveAllAboutAnEvent_vue__ = __webpack_require__("HQt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_commands_RemoveAllAboutAnEventWithoutCustomer_vue__ = __webpack_require__("9m1v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commands_MigrateEventsSpecificationsToNewDatabase__ = __webpack_require__("zX7X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commands_MigrateTicketsWinnersToWinnersDb__ = __webpack_require__("XaJ9");



























/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MigrateTicketsWinnersToWinnersDb: __WEBPACK_IMPORTED_MODULE_23__commands_MigrateTicketsWinnersToWinnersDb__["a" /* default */],
    AddEventIdOnLamps: __WEBPACK_IMPORTED_MODULE_2_src_commands_AddEventIdOnLamps_vue__["a" /* default */],
    CopyAttachments: __WEBPACK_IMPORTED_MODULE_3_src_commands_CopyAttachments_vue__["a" /* default */],
    GenerateNewTickets: __WEBPACK_IMPORTED_MODULE_5_src_commands_GenerateNewTickets_vue__["a" /* default */],
    RemoveAttachmentFromLamps: __WEBPACK_IMPORTED_MODULE_6_src_commands_RemoveAttachmentFromLamps_vue__["a" /* default */],
    RemoveDocsFromContemplados: __WEBPACK_IMPORTED_MODULE_7_src_commands_RemoveDocsFromContemplados_vue__["a" /* default */],
    RemoveDuplicatedFiles: __WEBPACK_IMPORTED_MODULE_8_src_commands_RemoveDuplicatedFiles__["a" /* default */],
    RemoveEventRanking: __WEBPACK_IMPORTED_MODULE_9_src_commands_RemoveEventRanking__["a" /* default */],
    RemoveDuplicatedLamps: __WEBPACK_IMPORTED_MODULE_10_src_commands_RemoveDuplicatedLamps__["a" /* default */],
    SetCustomerContemplado: __WEBPACK_IMPORTED_MODULE_11_src_commands_SetCustomerContemplado_vue__["a" /* default */],
    SetDocumentedAtNullDeleteDoc: __WEBPACK_IMPORTED_MODULE_12_src_commands_SetDocumentedAtNullDeleteDoc_vue__["a" /* default */],
    SetEligibleTrue: __WEBPACK_IMPORTED_MODULE_13_src_commands_SetEligibleTrue_vue__["a" /* default */],
    SetEventidLamps: __WEBPACK_IMPORTED_MODULE_14_src_commands_SetEventidLamps_vue__["a" /* default */],
    SetStockNull: __WEBPACK_IMPORTED_MODULE_15_src_commands_SetStockNull_vue__["a" /* default */],
    SetWinnerFalse: __WEBPACK_IMPORTED_MODULE_16_src_commands_SetWinnerFalse_vue__["a" /* default */],
    MigrateConfigurationsToNewDatabase: __WEBPACK_IMPORTED_MODULE_17_src_commands_MigrateConfigurationsToNewDatabase_vue__["a" /* default */],
    ChangeEventsTagNameToTagId: __WEBPACK_IMPORTED_MODULE_18_src_commands_ChangeEventsTagNameToTagId_vue__["a" /* default */],
    RemoveConfigurationsDuplicated: __WEBPACK_IMPORTED_MODULE_19_src_commands_RemoveConfigurationsDuplicated_vue__["a" /* default */],
    RemoveAllAboutAnEvent: __WEBPACK_IMPORTED_MODULE_20_src_commands_RemoveAllAboutAnEvent_vue__["a" /* default */],
    RemoveAllAboutAnEventWithoutCustomer: __WEBPACK_IMPORTED_MODULE_21_src_commands_RemoveAllAboutAnEventWithoutCustomer_vue__["a" /* default */],
    MigrateEventsSpecificationsToNewDatabase: __WEBPACK_IMPORTED_MODULE_22__commands_MigrateEventsSpecificationsToNewDatabase__["a" /* default */],
    DeleteLosers: __WEBPACK_IMPORTED_MODULE_4__commands_DeleteLosers_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('events', ['fetchAll'])),
  mounted: function mounted() {
    this.fetchAll({ trash: true, limit: 999999 });
  }
});

/***/ }),

/***/ "NHWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Trg_Project_TicketsConfigForm__ = __webpack_require__("DAJ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Trg_Project_LampsConfigForm__ = __webpack_require__("sW+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Trg_Project_EventsConfigForm__ = __webpack_require__("1ERB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Trg_Project_CompanyInfoForm__ = __webpack_require__("Lfch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Trg_Project_GeneralConfigProject__ = __webpack_require__("POoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Trg_Project_RegisterConfigForm__ = __webpack_require__("r9Gp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Trg_Project_RemoteConfigProject__ = __webpack_require__("bjCo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProjectImages__ = __webpack_require__("ujRx");



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-form',

  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */],
    TicketsConfigForm: __WEBPACK_IMPORTED_MODULE_5__components_Trg_Project_TicketsConfigForm__["a" /* default */],
    ProjectImages: __WEBPACK_IMPORTED_MODULE_15__ProjectImages__["a" /* default */],
    RemoteConfigProject: __WEBPACK_IMPORTED_MODULE_11__components_Trg_Project_RemoteConfigProject__["a" /* default */],
    RegisterConfigForm: __WEBPACK_IMPORTED_MODULE_10__components_Trg_Project_RegisterConfigForm__["a" /* default */],
    GeneralConfigProject: __WEBPACK_IMPORTED_MODULE_9__components_Trg_Project_GeneralConfigProject__["a" /* default */],
    CompanyInfoForm: __WEBPACK_IMPORTED_MODULE_8__components_Trg_Project_CompanyInfoForm__["a" /* default */],
    EventsConfigForm: __WEBPACK_IMPORTED_MODULE_7__components_Trg_Project_EventsConfigForm__["a" /* default */],
    LampsConfigForm: __WEBPACK_IMPORTED_MODULE_6__components_Trg_Project_LampsConfigForm__["a" /* default */]
  },

  data: function data() {
    return {
      loadingAll: true,
      indexPath: { name: 'project.index' },
      saving: false,
      model: {},

      company: {
        abbreviation: '',
        longname: '',
        cnpj: '',
        numberState: '',
        address: {
          type: '',
          street: '',
          number: '',
          neighborhood: '',
          city: '',
          state: ''
        }
      },

      servername: '',
      name: '',
      eventLabel: '',
      requiredNIS: false,
      requiredTermLamp: false,
      defaultWinnerChoiceMode: 'lottery',
      haveSurveys: false,
      viewGoogleMap: false,
      eventHasCeremony: false,
      eventAutomaticReplacement: false,
      eventCustomersCanBeRecontemplated: false,
      eventContemplatedPeriod: 5,
      eventAutoDateOnDeliveryTerm: true,
      eventHasPhotos: false,
      eventManagedCsv: false,
      ticketAutomaticBarcode: true,
      lampsMax: 0,
      lampsNumLedLamps: 0,
      lampsHasSeason: false,
      lampsSeasonRange: 12,
      powerLampDeliveryLabel: '8,5W',
      validationCustomerUc: false,
      validationCustomerCpf: false,
      validationCustomerUcOrCpf: false,
      validationContemplatedCustomerUc: false,
      validationContemplatedCustomerCpf: false,
      currentState: '',
      cities: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapGetters */])('project', {
    modelValidations: 'validations',
    loading: 'loading',
    defaultWinnerChoiceModeOptions: 'defaultWinnerChoiceModeOptions'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapGetters */])('states', {
    statesOptions: 'statesOptions'
  }), {

    stateCouchdb: function stateCouchdb() {
      return new __WEBPACK_IMPORTED_MODULE_12_src_services_CouchdbClass__["a" /* default */]({ connection: 'states' });
    },

    activeStateOptions: function activeStateOptions() {
      var _this = this;

      return this.statesOptions.filter(function (item) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this.termsByState).indexOf(item.value) >= 0;
      });
    },

    termsByState: {
      get: function get() {
        return this.$store.state.project.termsByState;
      }
    },

    currentTerms: function currentTerms() {
      return this.project.state && this.termsByState.hasOwnProperty(this.currentState) ? this.termsByState[this.currentState] : [];
    },

    id: function id() {
      return 'config';
    },
    editing: function editing() {
      return this.id !== undefined;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapActions */])('project', ['fetchOne', 'resetOne', 'upsert']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapActions */])('states', {
    fetchStates: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapActions */])(['setConfig']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this2 = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.runSave();
        }
      }).catch(function (err) {
        console.log(err);
        _this2.saving = false;
      });
    },
    runSave: function runSave() {
      var _this3 = this;

      this.upsert(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ _id: 'config' }, this.project)).then(function () {
        _this3.$notify({
          message: 'Registro atualizado com sucesso.',
          type: 'success'
        });
        _this3.setConfig();
        _this3.fetchOne(_this3.id);
        _this3.$router.push(_this3.indexPath);
        _this3.saving = false;
      }).catch(function (err) {
        console.log(err);
        _this3.saving = false;
      });
    },
    getState: function getState() {
      return this.stateCouchdb.where('sigla', this.currentState).first();
    },
    changeStateName: function changeStateName() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var state;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.getState();

              case 2:
                state = _context.sent;

                _this4.cities = state ? state.cidades : [];
                _this4.company.address.state = state ? state.nome : '';

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  }),
  filters: {
    number: function number(value) {
      return value.replace(/\D+/g, '');
    }
  },

  mounted: function mounted() {
    this.loadingAll = true;

    this.fetchStates({ limit: 999 });
    this.changeStateName();
    this.loadingAll = false;
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_pt_br__ = __webpack_require__("LVWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_di_vue_mask__ = __webpack_require__("YaCj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_mixins_can__ = __webpack_require__("exox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_style_scss__ = __webpack_require__("s6Sl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sass_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sidebarLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__sidebarLinks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_moment__);



























var moment = __webpack_require__("PJh5");
__webpack_require__("AoDM");

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCFy6ClNJe5tM8-s2UnDz8psFRe1XCm3T8',
    libraries: 'places' }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11__globalComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_19__sidebarLinks___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */], { events: 'change|keyup|blur' });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_di_vue_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_pt_br___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_moment___default.a, {
  moment: moment
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.mixin({
  methods: {
    $can: __WEBPACK_IMPORTED_MODULE_10_src_mixins_can__["a" /* $can */]
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('onlyNumbersMask', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.replace(/[a-zA-Z]|\s/, '');
});

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__App_vue__["a" /* default */]);
  },
  store: __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_14__router_router__["a" /* default */]
});

window.vm = vm;

/***/ }),

/***/ "NQku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sync-index',
  data: function data() {
    return {
      intervalCheckJob: null,
      isRunningAdmin: false,
      isRunningDocs: false,
      payload: {
        admin: {
          db: 'dev_trg_efce_admin',
          source: '',
          target: '',
          create_target: false,
          continuous: false
        },
        docs: {
          db: 'dev_trg_efce_docs',
          source: '',
          target: '',
          create_target: false,
          continuous: false
        }
      },
      jobs: []
    };
  },

  methods: {
    startReplication: function startReplication(db) {
      var _this = this;

      if (db === 'admin') {
        this.isRunningAdmin = true;
      }
      if (db === 'docs') {
        this.isRunningDocs = true;
      }
      __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].getHttpInstance().post('_replicator/', this.payload[db]).then(function (responseCreate) {
        _this.getJobs();
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Sincronia Iniciada.',
          text: 'Você deve manter a conexão com a internet. Porém pode sair desta página ou fechar o navegador',
          type: 'info'
        });
        _this.startCheckJobs();
      }).catch(function (errCreate) {
        return console.log(errCreate);
      });
    },
    getJobs: function getJobs() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].getHttpInstance().get('_scheduler/jobs/').then(function (response) {
        _this2.isRunningAdmin = false;
        _this2.isRunningDocs = false;
        _this2.jobs = response.data.jobs;
        if (response.data.total_rows > 0) {
          response.data.jobs.forEach(function (job) {
            var testAdmin = new RegExp(_this2.payload.admin.db);
            var testDocs = new RegExp(_this2.payload.docs.db);
            if (testAdmin.test(job.source)) {
              _this2.isRunningAdmin = true;
            }
            if (testDocs.test(job.source)) {
              _this2.isRunningDocs = true;
            }
            _this2.checkStateReplication(job.doc_id);
          });
        } else {
          clearInterval(_this2.intervalCheckJob);
          _this2.intervalCheckJob = 0;
          _this2.isRunningAdmin = false;
          _this2.isRunningDocs = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    checkStateReplication: function checkStateReplication(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].getHttpInstance().get('_scheduler/docs/_replicator/' + id).then(function (response) {
        if (response.data.state === 'crashing') {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            title: 'Falha na Sincronia.',
            text: 'Houve um erro na sincronia.',
            type: 'error'
          });
          _this3.deleteReplication(id);
        }
      }).catch(function (err) {
        return console.log('errCheckStateReplication', err);
      });
    },
    deleteReplication: function deleteReplication(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].getHttpInstance().post('_replicator/_find', {
        selector: {
          _id: id
        }
      }).then(function (response) {
        if (response.data.docs.length > 0) {
          var rev = response.data.docs[0]._rev;
          _this4._deleteReplication(id, rev);
        } else {
          clearInterval(_this4.intervalCheckJob);
          _this4.intervalCheckJob = 0;
        }
      }).catch(function (err) {
        return console.log('errGetRevReplication', err);
      });
    },
    _deleteReplication: function _deleteReplication(id, rev) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_src_services_Couchdb__["a" /* default */].getHttpInstance().delete('_replicator/' + id, {
        params: {
          'rev': rev
        }
      }).then(function (responseDelete) {
        clearInterval(_this5.intervalCheckJob);
        _this5.intervalCheckJob = 0;
        _this5.getJobs();
      }).catch(function (errDelete) {
        console.log('errDelete', errDelete);
      });
    },
    startCheckJobs: function startCheckJobs() {
      var _this6 = this;

      this.intervalCheckJob = setInterval(function () {
        return _this6.getJobs();
      }, 10000);
    }
  },
  computed: {},
  created: function created() {
    this.payload.admin.source = "https://couch-trg.3e.eng.br".replace('http://', 'http://' + "admin" + ':' + "admin2435," + '@') + '/' + "trg_eqpi_notiasc_admin";
    this.payload.admin.target = "https://couch-trg.3e.eng.br".replace('http://', 'http://' + "admin" + ':' + "admin2435," + '@') + '/' + "trg_eqpi_notiasc_sync";
    this.payload.docs.source = "https://couch-trg.3e.eng.br".replace('http://', 'http://' + "admin" + ':' + "admin2435," + '@') + '/' + "trg_eqpi_notiasc_docs";
    this.payload.docs.target = "https://couch-trg.3e.eng.br".replace('http://', 'http://' + "admin" + ':' + "admin2435," + '@') + '/' + "trg_eqpi_notiasc_sync_docs";
    this.getJobs();
  }
});

/***/ }),

/***/ "NRui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnPrintTerms',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('tickets', {
    tickets: 'winnersWithoutStock'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), {
    countTicketsWinnersWithoutStock: function countTicketsWinnersWithoutStock() {
      return this.tickets.length;
    }
  }),

  methods: {
    handleDocumentsPrint: function handleDocumentsPrint() {
      if (this.countTicketsWinnersWithoutStock !== 0) {
        this.swalNotifyTicketWithoutStock();
      } else {
        var routeData = this.$router.resolve({
          name: 'documents.print',
          params: {
            eventId: this.event._id,
            ticketId: 'none'
          }
        });
        window.open(routeData.href, 'documentsWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
      }
    },
    swalNotifyTicketWithoutStock: function swalNotifyTicketWithoutStock() {
      return __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: '',
        text: 'Para imprimir os documentos, todos os tickets devem ter estoque.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "NfkB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerCard_vue__ = __webpack_require__("/0ZQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b395f4b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerCard_vue__ = __webpack_require__("wVKW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b395f4b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nipe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['description', 'invoice', 'invoicePowerCompany']
      }
    };
  },


  watch: {
    currentPage: function currentPage(_currentPage) {
      this.fetch();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('stocks', {
    tableData: 'stocks',
    loading: 'loading',
    count: 'count'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('users', { users: 'usersIdName' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('events', {
    events: 'modelById'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.count;
      return this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('stocks', ['fetchAll', 'delete', 'countAllReduce']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('events', {
    fetchEventsByIds: 'fetchIds'
  }), {
    fetch: function fetch() {
      var _this = this;

      var query = {};
      if (this.pagination.perPage) {
        query['limit'] = this.pagination.perPage;
      }
      if (this.from) {
        query['skip'] = this.from;
      }
      if (this.sort.field && this.sort.direction) {
        query['sort'] = this.sort;
      }
      if (this.search) {
        query['search'] = this.search;
      }
      this.fetchAll(query).then(function (response) {
        _this.fetchEventsByIds({
          connection: 'default',
          ids: response.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: item.eventId });
          })
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetch();
    },
    handleSort: function handleSort(sort) {
      this.sort = { field: sort.prop, direction: sort.order };
      this.fetch();
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this2.delete(row._id).then(function (result) {
          _this2.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this2.fetch();
        }).catch(function (err) {
          return console.log(err);
        });
      });
    },
    getUserStock: function getUserStock(id) {
      return this.users.hasOwnProperty(id) ? this.users[id] : '-';
    }
  }),

  mounted: function mounted() {
    this.fetch();
    this.countAllReduce();
  }
});

/***/ }),

/***/ "Nk+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NmlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "NorY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocumentTicketEquatorial'
});

/***/ }),

/***/ "NrOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-wd btn-fill btn-info",on:{"click":_vm.handleReport}},[_vm._v("\n    Gerar relatório de dados: "+_vm._s(_vm.eventLabel)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nrso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please give us more details about your platform.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Your Website")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.website),expression:"modelValidations.website"},{name:"model",rawName:"v-model",value:(_vm.model.website),expression:"model.website"}],staticClass:"form-control",attrs:{"type":"text","name":"website","url":"true","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "website", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.website.invalid),expression:"website.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('website'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Framework Type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.framework),expression:"model.framework"}],staticClass:"form-control",attrs:{"type":"text","name":"framework","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.framework)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "framework", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.language),expression:"modelValidations.language"},{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- language -")]),_vm._v(" "),_c('option',{attrs:{"value":"ms"}},[_vm._v("Bahasa Melayu")]),_vm._v(" "),_c('option',{attrs:{"value":"ca"}},[_vm._v("Català")]),_vm._v(" "),_c('option',{attrs:{"value":"da"}},[_vm._v("Dansk")]),_vm._v(" "),_c('option',{attrs:{"value":"de"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"es"}},[_vm._v("Español")]),_vm._v(" "),_c('option',{attrs:{"value":"el"}},[_vm._v("Eλληνικά")]),_vm._v(" "),_c('option',{attrs:{"value":"fr"}},[_vm._v("Français")]),_vm._v(" "),_c('option',{attrs:{"value":"it"}},[_vm._v("Italiano")]),_vm._v(" "),_c('option',{attrs:{"value":"hu"}},[_vm._v("Magyar")]),_vm._v(" "),_c('option',{attrs:{"value":"nl"}},[_vm._v("Nederlands")]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v("Norsk")]),_vm._v(" "),_c('option',{attrs:{"value":"pl"}},[_vm._v("Polski")]),_vm._v(" "),_c('option',{attrs:{"value":"pt"}},[_vm._v("Português")]),_vm._v(" "),_c('option',{attrs:{"value":"fi"}},[_vm._v("Suomi")]),_vm._v(" "),_c('option',{attrs:{"value":"sv"}},[_vm._v("Svenska")]),_vm._v(" "),_c('option',{attrs:{"value":"tr"}},[_vm._v("Türkçe")]),_vm._v(" "),_c('option',{attrs:{"value":"is"}},[_vm._v("Íslenska")]),_vm._v(" "),_c('option',{attrs:{"value":"cs"}},[_vm._v("Čeština")]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v("Русский")]),_vm._v(" "),_c('option',{attrs:{"value":"th"}},[_vm._v("ภาษาไทย")]),_vm._v(" "),_c('option',{attrs:{"value":"zh"}},[_vm._v("中文 (简体)")]),_vm._v(" "),_c('option',{attrs:{"value":"zh-TW"}},[_vm._v("中文 (繁體)")]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v("日本語")]),_vm._v(" "),_c('option',{attrs:{"value":"ko"}},[_vm._v("한국어")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.language.invalid),expression:"language.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('language'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Bootstrap Version\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.bootstrapVersion),expression:"modelValidations.bootstrapVersion"},{name:"model",rawName:"v-model",value:(_vm.model.bootstrapVersion),expression:"model.bootstrapVersion"}],staticClass:"form-control",attrs:{"name":"cities"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bootstrapVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- version -")]),_vm._v(" "),_c('option',{attrs:{"value":"1.1"}},[_vm._v("Bootstrap 1.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("Bootstrap 2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("Bootstrap 3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("Bootstrap 4.0(alpha)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","placeholder":"ex: 19.00"},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NtKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralCounterReport_vue__ = __webpack_require__("dATB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8b4973a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralCounterReport_vue__ = __webpack_require__("NrOX");
function injectStyle (ssrContext) {
  __webpack_require__("qnkm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8b4973a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralCounterReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8b4973a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralCounterReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NuQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O39M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O3OW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCelpaJurunas_vue__ = __webpack_require__("UJA5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e2ced0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCelpaJurunas_vue__ = __webpack_require__("ECZC");
function injectStyle (ssrContext) {
  __webpack_require__("9/Ay")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53e2ced0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCelpaJurunas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e2ced0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCelpaJurunas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OAMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBu8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OEJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketPrint_vue__ = __webpack_require__("3n+y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4db5ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketPrint_vue__ = __webpack_require__("hbU3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4db5ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OFfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadioCompaniesDocuments',
  props: ['currentTerms', 'value']
});

/***/ }),

/***/ "OJEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YesNoRadio__ = __webpack_require__("bkdN");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventsConfigForm',

  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Switch_vue__["a" /* default */],
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_3__YesNoRadio__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['validations']), {
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  }),

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
});

/***/ }),

/***/ "OQ7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validationsService */
var validationsService = {
  validaNis: validaNis
};

function validaNis(nis) {
  if (nis.length === 0 && nis.length < 11) {
    return false;
  }
  var multiplicador = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var soma = 0;
  var resto = void 0;
  for (var i = 0; i < 10; i++) {
    soma += parseInt(nis[i]) * multiplicador[i];
  }

  resto = soma % 11;

  resto = 11 - resto;

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto === parseInt(nis[10])) {
    this.errorNIS = false;
    return true;
  } else {
    this.errorNIS = true;
    return false;
  }
}

/***/ }),

/***/ "OR7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Por favor preencha os dados pessoais do cliente.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome do Titular da Conta")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.holder),expression:"modelValidations.personalData.holder"},{name:"model",rawName:"v-model.trim",value:(_vm.model.holder),expression:"model.holder",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"holder"},domProps:{"value":(_vm.model.holder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "holder", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.holder.invalid),expression:"holder.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('holder'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Também conhecido como")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.aka),expression:"modelValidations.personalData.aka"},{name:"model",rawName:"v-model.trim",value:(_vm.model.aka),expression:"model.aka",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"aka"},domProps:{"value":(_vm.model.aka)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aka", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.aka.invalid),expression:"aka.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('aka'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome da mãe")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.motherName),expression:"modelValidations.personalData.motherName"},{name:"model",rawName:"v-model.trim",value:(_vm.model.motherName),expression:"model.motherName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"aka"},domProps:{"value":(_vm.model.motherName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "motherName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelValidations.personalData.motherName.invalid),expression:"modelValidations.personalData.motherName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('modelValidations.personalData.motherName'))+"\n        ")])])]),_vm._v(" "),(_vm.config.register.carrer)?_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Profissão")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.model.carrer),expression:"model.carrer",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"carrer"},domProps:{"value":(_vm.model.carrer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "carrer", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Possui cargo político?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.politician),callback:function ($$v) {_vm.$set(_vm.model, "politician", $$v)},expression:"model.politician"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Registro Geral (RG)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.nationalId),expression:"modelValidations.personalData.nationalId"},{name:"model",rawName:"v-model.trim",value:(_vm.model.nationalId),expression:"model.nationalId",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"nationalId"},domProps:{"value":(_vm.model.nationalId)},on:{"keyup":function($event){return _vm.onlyNumber('nationalId')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nationalId", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.nationalId.invalid),expression:"nationalId.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('nationalId'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Data de nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.birthdate),expression:"modelValidations.personalData.birthdate"},{name:"model",rawName:"v-model.trim",value:(_vm.model.birthdate),expression:"model.birthdate",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('00/00/0000'),expression:"'00/00/0000'"}],staticClass:"form-control",attrs:{"type":"text","name":"birthdate"},domProps:{"value":(_vm.model.birthdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "birthdate", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthdate.invalid),expression:"birthdate.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('birthdate'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Telefone 1")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.phone1),expression:"modelValidations.personalData.phone1"},{name:"model",rawName:"v-model.trim",value:(_vm.model.phone1),expression:"model.phone1",modifiers:{"trim":true}},{name:"mask-phone",rawName:"v-mask-phone.br",modifiers:{"br":true}}],staticClass:"form-control",attrs:{"type":"text","name":"phone1"},domProps:{"value":(_vm.model.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "phone1", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.phone1.invalid),expression:"phone1.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('phone1'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Telefone 2")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.personalData.phone2),expression:"modelValidations.personalData.phone2"},{name:"model",rawName:"v-model.trim",value:(_vm.model.phone2),expression:"model.phone2",modifiers:{"trim":true}},{name:"mask-phone",rawName:"v-mask-phone.br",modifiers:{"br":true}}],staticClass:"form-control",attrs:{"type":"text","name":"phone2"},domProps:{"value":(_vm.model.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "phone2", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.phone2.invalid),expression:"phone2.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('phone2'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Método de Regularização\n        ")]),_vm._v(" "),_c('SelectRegularizationMethod',{model:{value:(_vm.model.regularity),callback:function ($$v) {_vm.$set(_vm.model, "regularity", $$v)},expression:"model.regularity"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('InputNis',{model:{value:(_vm.model.nis),callback:function ($$v) {_vm.$set(_vm.model, "nis", $$v)},expression:"model.nis"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OWjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIconTags_vue__ = __webpack_require__("lieO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3507bf8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIconTags_vue__ = __webpack_require__("0nFs");
function injectStyle (ssrContext) {
  __webpack_require__("v/xQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3507bf8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIconTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3507bf8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIconTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "OeQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"checkbox"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ofbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'roles-form',
  data: function data() {
    return {
      saving: false,
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('roles', {
    permissions: 'permissions',
    role: 'role',
    allPermissions: 'roles'
  }), {
    isNewRole: function isNewRole() {
      return this.$route.name !== 'roles.edit';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('roles', ['insert', 'update', 'fetchOne', 'resetOne', 'fetchAll']), {
    checkAll: function checkAll(permissions, event) {
      var _this = this;

      permissions.forEach(function (permission) {
        if (event.target.checked) {
          _this.role.permissions.push(permission);
        } else {
          _this.role.permissions.splice(_this.role.permissions.indexOf(permission), 1);
        }
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;

      this.saving = true;
      this.role.name = this.role.label.replace(/ /g, '').toLowerCase();
      this.role.collection = 'roles';
      if (this.isNewRole && typeof this.role._id === 'undefined') {
        this.insert(this.role).then(function (result) {
          _this2.saving = false;
          _this2.$notify({
            message: 'Registro criado com sucesso.',
            type: 'success'
          });
          _this2.$router.push({ name: 'roles.index' });
        }).catch(function (err) {
          _this2.saving = false;
          console.log(err);
        });
      } else if (!this.isNewRole && typeof this.role._id !== 'undefined') {
        this.update(this.role).then(function (result) {
          _this2.saving = false;
          _this2.$notify({
            message: 'Registro editado com sucesso.',
            type: 'success'
          });
          _this2.$router.push({ name: 'roles.index' });
        }).catch(function (err) {
          _this2.saving = false;
          console.log(err);
        });
      }
    }
  }),
  mounted: function mounted() {
    this.saving = false;
    if (!this.allPermissions || this.allPermissions.length <= 0) {
      this.fetchAll();
    }
    this.resetOne();
    if (!this.isNewRole) {
      this.fetchOne(this.$route.params.id);
    }
  }
});

/***/ }),

/***/ "OgYX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OkIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      stream: '',
      source: '',
      canvas: null
    };
  },

  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    screenshotFormat: {
      type: String,
      default: 'image/jpeg'
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.hasMedia()) {
      this.$emit('notsupported');
      return;
    }

    this.requestMedia();

    if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
        var video = window.document.getElementById('webCamVideo');
        video.srcObject = stream;
        _this.stream = stream;
        _this.$emit('started', stream);
      }, function (error) {
        _this.$emit('error', error);
      });
    }
  },

  methods: {
    hasMedia: function hasMedia() {
      return !!this.getMedia();
    },
    getMedia: function getMedia() {
      return navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mediaDevices.getUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
    },
    requestMedia: function requestMedia() {
      navigator.getUserMedia = this.getMedia();
    },
    capture: function capture() {
      if (!this.hasMedia()) {
        this.$emit('notsupported');
        return null;
      }
      return this.getCanvas().toDataURL(this.screenshotFormat);
    },
    getCanvas: function getCanvas() {
      var video = this.$refs.video;
      if (!this.ctx) {
        var _canvas = document.createElement('canvas');
        _canvas.height = video.clientHeight;
        _canvas.width = video.clientWidth;
        this.canvas = _canvas;

        this.ctx = _canvas.getContext('2d');
      }

      var ctx = this.ctx,
          canvas = this.canvas;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      return canvas;
    }
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("AuCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Opun":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-invalidate-error',

  props: {
    ticket: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    event: {}
  },

  data: function data() {
    return {};
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', ['upsertWithView', 'getTicketsByEvent', 'getTicketsByCustomer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', { fetchTickets: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('customers', { fetchCustomer: 'fetchOne' }), {
    onClick: function onClick() {
      var _this = this;

      console.log(this.ticket);
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Informe o erro no cadastro',
        input: 'textarea',
        type: '',
        confirmButtonClass: 'btn btn-info btn-fill',
        confirmButtonText: 'Informar'
      }).then(function (reason) {
        if (reason) {
          _this.invalidateTicket(reason);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
            title: '',
            text: 'Necess\xE1rio informar uma raz\xE3o para invalidar ticket.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            timer: 3000
          }).then(function (result) {}, function (dismiss) {});
        }
      }, function () {});
    },
    invalidateTicket: function invalidateTicket(reason) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var validate, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validate = {
                  valid: false,
                  eligible: false,
                  error: true
                };
                doc = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.ticket, validate);

                doc.reasonNotEligible = 'Invalidado por um atendente.';
                doc.reasonError = reason;

                return _context.abrupt('return', _this2.upsertWithView({
                  find: {
                    ddoc: 'tickets-by-id',
                    view: 'tickets-by-id',
                    key: doc._id
                  },
                  payload: doc
                }).then(function () {
                  var options = {
                    message: 'Informado erro no ticket, ticket invalidado.',
                    type: 'success'
                  };

                  _this2.getTickets().then(function () {
                    _this2.$notify(options);
                  });
                }).catch(function (err) {
                  console.log(err);
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                    title: '',
                    text: 'Ocorreu um problema ao informar erro no ticket.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getTickets: function getTickets() {
      if (this.type === 'customer') {
        return this.getTicketsByCustomer(this.ticket.customerId);
      } else if (this.type === 'event') {
        return this.getTicketsByEvent(this.ticket.eventId);
      }
    }
  })
});

/***/ }),

/***/ "OqyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_filesService__ = __webpack_require__("K03o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-images',

  data: function data() {
    return {
      loadingImages: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['config']), {

    urlImages: {
      get: function get() {
        return this.$store.state.project.urlImages;
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('project', ['uploadFileProject', 'fetchOne', 'getImagesProject']), {
    getFiles: function getFiles(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var imgName, type, file;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loadingImages = true;
                imgName = event.target.id;
                type = event.target.files[0].type;
                _context.next = 6;
                return _this.handleFile(event, type);

              case 6:
                file = _context.sent;
                _context.next = 9;
                return _this.uploadFileProject({ id: 'config', mimeType: type, name: '' + imgName, file: file });

              case 9:
                _this.loadingImages = false;
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  titleText: 'Imagem salva com sucesso',
                  confirmButtonText: 'OK'
                });
                _this.fetchOne('config');
                document.getElementById('img_' + imgName).src = document.getElementById('img_' + imgName).src + '?' + new Date().getMilliseconds();
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                console.log('err', _context.t0);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    },
    handleFile: function handleFile(event, type) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (type === 'image/svg+xml') {
          resolve(__WEBPACK_IMPORTED_MODULE_4__services_filesService__["a" /* filesService */].handleBlob(event, type));
          return;
        }
        resolve(__WEBPACK_IMPORTED_MODULE_4__services_filesService__["a" /* filesService */].handleImage(event).then(function (result) {
          return result[0].blob;
        }));
      });
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "Ov/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLamps_vue__ = __webpack_require__("C9WT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c8a8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLamps_vue__ = __webpack_require__("y5T7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c8a8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OwkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allDataAlready)?_c('div',{staticClass:"lamps-document"},[(_vm.event.doc.companyTerms === 'generic')?_c('LampTermGeneric',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'CE' && _vm.event.doc.companyTerms === 'enel')?_c('lamp-term-enel-ce',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'GO' && _vm.event.doc.companyTerms === 'enel')?_c('lamp-term-enel-go',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'MA' && _vm.event.doc.companyTerms === 'cemar')?_c('lamp-term-cemar',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'MA' && _vm.event.doc.companyTerms === 'iasc')?_c('lamp-term-iasc-ma',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'AL' && _vm.event.doc.companyTerms === 'iasc')?_c('lamp-term-iasc-al',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PI' && _vm.event.doc.companyTerms === 'iasc')?_c('lamp-term-iasc-pi',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PI' && _vm.event.doc.companyTerms === 'equatorial')?_c('LampTermEquatorialPi',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PB' && _vm.event.doc.companyTerms === 'energisa-paraiba')?_c('lamp-term-energisa-pb',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PB' && _vm.event.doc.companyTerms === 'energisa-borborema')?_c('lamp-term-energisa-borborema-pb',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PA' && _vm.event.doc.companyTerms === 'celpa')?_c('LampTermCelpa',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e(),_vm._v(" "),(("" + (_vm.config.state)) === 'PA' && _vm.event.doc.companyTerms === 'celpa-jurunas')?_c('LampTermCelpaJurunas',{attrs:{"power-lamp-delivery-label":_vm.event.lamp.powerLampDeliveryLabel,"payload":_vm.payload}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OzZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P0Nf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1NZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagIndex_vue__ = __webpack_require__("3bm0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69dd7b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagIndex_vue__ = __webpack_require__("C8v6");
function injectStyle (ssrContext) {
  __webpack_require__("e7iL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69dd7b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9dB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Ith7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf4b58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("xi0Q");
function injectStyle (ssrContext) {
  __webpack_require__("nRLR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bf4b58a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf4b58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__ = __webpack_require__("pfXf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__ = __webpack_require__("r2+i");
function injectStyle (ssrContext) {
  __webpack_require__("eFVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDuplicatedFiles_vue__ = __webpack_require__("PT4p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766fd35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDuplicatedFiles_vue__ = __webpack_require__("31Jg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDuplicatedFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766fd35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDuplicatedFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PGBT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PGgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-run-lottery',

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tickets', {
    tickets: 'tickets'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), {
    canRunLottery: function canRunLottery() {
      var validNumRefrigerators = this.tickets.length >= this.event.numberOfRefigerators;
      var validDrawn = this.event.drawn === false || this.event.drawn === undefined;
      return validNumRefrigerators && validDrawn;
    },
    isLottery: function isLottery() {
      return this.event.winnerChoiceMode === 'lottery' || this.event.winnerChoiceMode === '';
    },
    insufficientTickets: function insufficientTickets() {
      return !this.tickets || this.tickets.length <= 0 || this.tickets.filter(function (item) {
        return item.eligible;
      }) < this.event.numberOfRefigerators;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['changeExecution']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', {
    runLottery: 'runLottery',
    fetchTickets: 'fetchAll'
  }), {
    handleRunLottery: function handleRunLottery() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var where, tickets;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                where = [{
                  eventId: _this.event._id
                }];

                if (!_this.config.customersCanBeRecontemplated) {
                  where.push({ eligible: true });
                }
                _context.next = 4;
                return _this.fetchTickets({
                  where: where,
                  limit: 99999
                });

              case 4:
                tickets = _context.sent;


                if (_this.verifyIfCanRun(tickets)) {
                  _this.notifyProgress(tickets);
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    notifyProgress: function notifyProgress(tickets) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Confirmação',
        html: 'O sorteio est\xE1 preste a ser realizado. Por favor, confirme sua execu\xE7\xE3o.',
        type: 'info',
        confirmButtonText: 'Sortear!',
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this2.runLottery({ tickets: tickets, event: _this2.event }).then(function (res) {
                      if (res.hasOwnProperty('error')) {
                        return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Erro', res.error, 'error');
                      }

                      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Sucessso', 'Sorteio realizado com sucesso. Em alguns instantes a página será recarregada.', 'success');
                      _this2.$emit('fetchTicktes');
                    }).catch(function (err) {
                      console.log(err);
                      _this2.swalLotteryFails(err);
                    });

                  case 2:
                    return _context2.abrupt('return', 'ok');

                  case 3:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function () {
        setTimeout(function () {
          location.reload();
        }, 3000);

        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        });
      });
    },
    verifyIfCanRun: function verifyIfCanRun(tickets) {
      if (tickets.length < this.event.numberOfRefigerators) {
        this.swalLowCustomersNumber();
        return false;
      } else if (this.event.drawn === true) {
        this.swalLotteryAlreadyRan();
        return false;
      } else if (tickets.length <= 0) {
        this.swalLotteryUnable();
        return false;
      }
      return this.canRunLottery;
    },
    swalLowCustomersNumber: function swalLowCustomersNumber() {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: '',
        text: 'Para efetuar o sorteio \xE9 preciso de pelo menos ' + this.event.numberOfRefigerators + ' ticket(s) apto(s) a participar(em).',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    swalLotteryAlreadyRan: function swalLotteryAlreadyRan() {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: '',
        text: 'Sorteio j\xE1 realizado para esse evento.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    swalLotteryUnable: function swalLotteryUnable() {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Impossível fazer sorteio.',
        text: 'Não há clientes aptos a participar do sorteio',
        type: 'info'
      });
    },
    swalLotteryFails: function swalLotteryFails(err) {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        width: 1000,
        title: 'Ocorreu um erro ao realizar sorteio.',
        text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "POBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFormFilters_vue__ = __webpack_require__("hHcy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_482c28d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFormFilters_vue__ = __webpack_require__("vTRh");
function injectStyle (ssrContext) {
  __webpack_require__("pxkv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-482c28d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFormFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_482c28d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFormFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "POoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralConfigProject_vue__ = __webpack_require__("5pax");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9b8fa3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralConfigProject_vue__ = __webpack_require__("TKGb");
function injectStyle (ssrContext) {
  __webpack_require__("9dWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e9b8fa3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralConfigProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9b8fa3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralConfigProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PT4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },


  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress * 100 / this.total);
    }
  },

  methods: {
    handleExec: function handleExec() {
      var _this = this;

      this.isLoading = true;
      this.progress = 0;
      this.exec(function (response) {
        console.log('end', response);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function (response) {
        _this.isLoading = false;
        _this.progress = 100;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tickets;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].collection('tickets').select(['_id', 'customerId', 'eventId', 'documentedAt', 'stockId', 'winner', 'createdAt']).all();

              case 2:
                tickets = _context.sent;

                tickets = _this2.getDuplicated(tickets);
                if (tickets.length === 0) {
                  _this2.notifyFinish();
                } else {
                  tickets = _this2.getTicketsBeDeleted(tickets);
                  _this2.total = tickets.length;
                  _this2.progress = 100;
                  _this2.notifyTotal().then(function () {
                    _this2.deleteTickets(tickets);
                  });
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getDuplicated: function getDuplicated(tickets) {
      var duplicated = [];
      var counter = {};
      for (var i = 0; i < tickets.length; i++) {
        if (!counter.hasOwnProperty(tickets[i].eventId)) {
          counter[tickets[i].eventId] = {};
        }
        if (!counter[tickets[i].eventId].hasOwnProperty(tickets[i].customerId)) {
          counter[tickets[i].eventId][tickets[i].customerId] = {
            tickets: [tickets[i]]
          };
        } else {
          counter[tickets[i].eventId][tickets[i].customerId]['tickets'].push(tickets[i]);
        }
      }
      for (var eventId in counter) {
        for (var customerId in counter[eventId]) {
          if (counter[eventId][customerId]['tickets'].length > 1) {
            duplicated.push(counter[eventId][customerId]['tickets']);
          }
        }
      }
      return duplicated;
    },
    getTicketsBeDeleted: function getTicketsBeDeleted(tickets) {
      var _this3 = this;

      var deleted = [];
      for (var i = 0; i < tickets.length; i++) {
        var notWinners = tickets[i].filter(function (item) {
          return !item.winner;
        });
        if (notWinners.length === tickets[i].length) {
          var notDocumentedAt = notWinners.filter(function (item) {
            return !item.documentedAt;
          });
          if (notDocumentedAt.length === tickets[i].length) {
            (function () {
              var minor = notDocumentedAt[0];
              var idMin = 0;
              for (var _i = 1; _i < notDocumentedAt.length; _i++) {
                if (minor.createdAt >= notDocumentedAt[_i].createdAt) {
                  minor = notDocumentedAt[_i];
                  idMin = _i;
                }
              }

              var byCreatedAt = notDocumentedAt.filter(function (item, index) {
                return index !== idMin;
              });
              deleted = _this3.concatArray(deleted, byCreatedAt);
            })();
          } else {
            deleted = this.concatArray(deleted, notDocumentedAt);
          }
        } else {
          deleted = this.concatArray(deleted, notWinners);
        }
      }
      return deleted;
    },
    deleteTickets: function deleteTickets(tickets) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var deletedPromises, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deletedPromises = [];
                i = 0;

              case 2:
                if (!(i < tickets.length)) {
                  _context2.next = 12;
                  break;
                }

                _this4.progress = i + 1;
                deletedPromises.push(__WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].collection('tickets').delete(tickets[i]._id));

                if (!((i + 1) % 5 === 0)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(deletedPromises);

              case 8:
                deletedPromises = [];

              case 9:
                i++;
                _context2.next = 2;
                break;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    concatArray: function concatArray(to, from) {
      for (var i = 0; i < from.length; i++) {
        to.push(from[i]);
      }
      return to;
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todos os tickets duplicados foram removidos.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifyTotal: function notifyTotal() {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Informativo',
        text: 'Existem ' + this.total + ' tickets a duplicados. Eles ser\xE3o removidos',
        type: 'info',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "Pa4K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PatY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Peng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API_KEY__ = __webpack_require__("JElF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps__);




__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_0__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initSattelliteMap: function initSattelliteMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 3,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: window.google.maps.MapTypeId.SATELLITE
      };

      var map = new window.google.maps.Map(document.getElementById('satelliteMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Satellite Map!'
      });
      marker.setMap(map);
    },
    initRegularMap: function initRegularMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('regularMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    },
    initCustomSkinMap: function initCustomSkinMap(google) {
      var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 13,
        center: myLatlng,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]
      };

      var map = new google.maps.Map(document.getElementById('customSkinMap'), mapOptions);

      var marker = new google.maps.Marker({
        position: myLatlng,
        title: 'Custom Skin & Settings Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.load(function (google) {
      _this.initSattelliteMap(google);
      _this.initRegularMap(google);
      _this.initCustomSkinMap(google);
    });
  }
});

/***/ }),

/***/ "Pfw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("bJ0t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("LdiV");
function injectStyle (ssrContext) {
  __webpack_require__("DjVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PgX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CompanyTermsRadios',

  props: {
    model: {
      required: true
    }
  },

  data: function data() {
    return {
      companyTerms: ''
    };
  },

  watch: {
    model: function model() {
      var _this = this;

      this.$nextTick(function () {
        _this.companyTerms = _this.model.companyTerms;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', ['event']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['currentTerms', 'project'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['fetchOne']), {
    emitEvent: function emitEvent(company) {
      this.$emit('input', company);
    }
  }),

  mounted: function mounted() {
    if (!this.project.hasOwnProperty('_id')) {
      this.fetchOne('config');
    }
  }
});

/***/ }),

/***/ "PiTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCemar_vue__ = __webpack_require__("c9xE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052e4cf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCemar_vue__ = __webpack_require__("bdc2");
function injectStyle (ssrContext) {
  __webpack_require__("aVfg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-052e4cf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCemar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052e4cf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCemar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PkbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCemar_vue__ = __webpack_require__("/bpn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd84495c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCemar_vue__ = __webpack_require__("cksC");
function injectStyle (ssrContext) {
  __webpack_require__("Lusp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd84495c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermCemar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd84495c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermCemar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PkuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Events_EventCard__ = __webpack_require__("ee0G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_TicketsList__ = __webpack_require__("/pma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Events_EventActions__ = __webpack_require__("IVAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Actions_BtnCustomersImport__ = __webpack_require__("Lqpr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Actions_BtnTicketsConfirm__ = __webpack_require__("2ic5");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-details',
  components: {
    EventCard: __WEBPACK_IMPORTED_MODULE_3_src_pages_Events_EventCard__["a" /* default */],
    EventActions: __WEBPACK_IMPORTED_MODULE_5_src_pages_Events_EventActions__["a" /* default */],
    TicketsList: __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_TicketsList__["a" /* default */],
    BtnCustomersImport: __WEBPACK_IMPORTED_MODULE_6__Actions_BtnCustomersImport__["a" /* default */],
    BtnTicketsConfirm: __WEBPACK_IMPORTED_MODULE_7__Actions_BtnTicketsConfirm__["a" /* default */]
  },

  data: function data() {
    return {
      isRunningActions: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', {
    event: 'event',
    loadingEvent: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('tickets', {
    ticketsCount: 'count',
    loadingTicket: 'loading',
    tickets: 'tickets',
    ticketsWinners: 'winners'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('stocks', {
    stocksOption: 'stocksOption',
    loadingStocks: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', {
    loadingCustomers: 'loading',
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['config']), {
    customerIsObject: function customerIsObject() {
      return {}.toString.apply(this.customers) === '[object Object]';
    },
    eventId: function eventId() {
      return this.$route.params.id;
    },
    loading: function loading() {
      return this.loadingStocks && this.loadingEvent && this.loadingStocks && this.loadingCustomers;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('surveys', {
    fetchSurveys: 'fetchViewAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('tickets', {
    runLottery: 'runLottery',
    fetchTickets: 'fetchAll',
    fetchAllDataFromTicketsByEvent: 'fetchAllDataFromTicketsByEvent',
    fetchTicketsWinners: 'fetchAllWinners',
    associateStock: 'associateStock',
    resetTickets: 'resetAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('stocks', {
    fetchStocks: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('events', {
    resetEvent: 'resetOne',
    fetchEvent: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('customers', {
    fetchCustomersByIds: 'fetchIds',
    fetchCustomer: 'fetchOne'
  }), {
    fetch: function fetch() {
      var _this = this;

      this.fetchStocks({
        where: { eventId: this.eventId },
        limit: 999
      });
      this.fetchEvent(this.eventId);
      this.fetchTickets({
        where: { eventId: this.eventId },
        limit: 99999
      }).then(function (res) {
        _this.fetchCustomersByIds({
          connection: 'default',
          ids: res.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: item.customerId });
          })
        });
      });
    }
  }),

  mounted: function mounted() {
    this.resetTickets();
    this.resetEvent();
    this.fetch();
    this.fetchUsers({ limit: 999 });
  }
});

/***/ }),

/***/ "Pq02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-delivery-term',

  props: {
    imgsrc: {
      required: true
    },
    eventId: {
      required: true
    },
    ticketId: {
      required: true
    },
    title: {
      default: 'Protocolo de Entrega'
    }
  }
});

/***/ }),

/***/ "PsIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommandsIndex_vue__ = __webpack_require__("NFr3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471ebbbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommandsIndex_vue__ = __webpack_require__("mCG2");
function injectStyle (ssrContext) {
  __webpack_require__("ecAH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-471ebbbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommandsIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471ebbbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommandsIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PzXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableData: [{
        name: 'Andrew Mike',
        job: 'Develop',
        salary: '€ 99,225',
        active: false
      }, {
        name: 'John Doe',
        job: 'Design',
        salary: '€ 89,241',
        active: false
      }, {
        name: 'Alex Mike',
        job: 'Design',
        salary: '€ 92,144',
        active: false
      }, {
        name: 'Mike Monday',
        job: 'Marketing',
        salary: '€ 49,990',
        active: true
      }, {
        name: 'Paul dickens',
        job: 'Communication',
        salary: '€ 69,201',
        active: true
      }],
      productsTable: [{
        image: 'static/img/tables/agenda.png',
        title: 'Notebook',
        subTitle: 'Most beautiful agenda for the office.',
        price: 49,
        quantity: 1
      }, {
        image: 'static/img/tables/stylus.jpg',
        title: 'Stylus',
        subTitle: 'Design is not just what it looks like and feels like. Design is how it works.',
        price: 499,
        quantity: 2
      }, {
        image: 'static/img/tables/evernote.png',
        title: 'Evernote iPad Stander',
        subTitle: 'A groundbreaking Retina display. All-flash architecture. Fourth-generation Intel processors.',
        price: 799,
        quantity: 1
      }]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  }
});

/***/ }),

/***/ "Q0ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnelGo_vue__ = __webpack_require__("YJUN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5cbffe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnelGo_vue__ = __webpack_require__("e5Ce");
function injectStyle (ssrContext) {
  __webpack_require__("S0Yd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed5cbffe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnelGo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5cbffe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnelGo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q8+/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q8IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Q8dN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Documents_SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermEquatorialPi',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__pages_Documents_SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
    this.fetchOne('config');
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject', 'fetchOne']))
});

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QHxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.$can('events.audit'))?_c('router-link',{attrs:{"to":{name: 'events.audit', params: {id: _vm.event._id}}}},[(_vm.$can('events.audit'))?_c('a',{staticClass:"btn btn-default btn-fill btn-icon edit btn-sm",attrs:{"title":"Auditoria do evento"}},[_c('i',{staticClass:"ti-eye"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.config.hasOwnProperty('event') && _vm.config.event.hasOwnProperty('hasPhotos') && _vm.config.event.hasPhotos && _vm.$can('events.photos.upload'))?_c('BtnUploadPhotosEvent',{attrs:{"btn-class":"btn btn-primary btn-fill btn-icon edit btn-sm","event":_vm.event}}):_vm._e(),_vm._v(" "),(_vm.showRanking(_vm.event.winnerChoiceMode))?_c('span',[(_vm.$can('ranking.index'))?_c('router-link',{attrs:{"to":{name: 'ranking.index', params: {id: _vm.event._id}}}},[(_vm.$can('ranking.index'))?_c('a',{staticClass:"btn btn-success btn-fill btn-icon edit btn-sm",attrs:{"title":"Gerenciar Ranking"}},[_c('i',{staticClass:"ti-list-ol"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$can('surveys.index'))?_c('router-link',{attrs:{"to":{name: 'surveys.index', params: {id: _vm.event._id}}}},[(_vm.$can('surveys.index'))?_c('a',{staticClass:"btn btn-default btn-fill btn-icon edit btn-sm",attrs:{"title":"Associar pesquisas"}},[_c('i',{staticClass:"ti-notepad"})]):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.$can('events.edit'))?_c('router-link',{attrs:{"to":{name: 'events.edit', params: {id: _vm.event._id}}}},[(_vm.$can('events.index'))?_c('a',{staticClass:"btn btn-warning btn-fill btn-icon edit btn-sm",attrs:{"title":"Editar"}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$can('events.details'))?_c('router-link',{attrs:{"to":{name: 'events.details', params: {id: _vm.event._id}}}},[(_vm.$can('events.details'))?_c('a',{staticClass:"btn btn-info btn-fill btn-icon edit btn-sm",attrs:{"title":"Gerenciar Evento"}},[_c('i',{staticClass:"ti-settings"})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-icon edit btn-sm",attrs:{"title":"Cadastro Online","type":"button"},on:{"click":function($event){return _vm.getOnlineRegisterLink(_vm.event._id)}}},[_c('i',{staticClass:"ti-share-alt"})]),_vm._v(" "),(_vm.$can('events.remove'))?_c('button',{staticClass:"btn btn-danger btn-fill btn-icon edit btn-sm",attrs:{"title":"Remover","type":"button"},on:{"click":function($event){return _vm.handleDelete({id: _vm.event._id})}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QKg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_StatusReplication_StatusReplication__ = __webpack_require__("Upq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_StatusReplication_IndexStatusReplication__ = __webpack_require__("xMTJ");



var path = 'status-replications';
var title = 'Especificações dos Eventos';
/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0__pages_StatusReplication_StatusReplication__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_StatusReplication_IndexStatusReplication__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "QPLj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QQx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleRemoveAttachmentFromLamps: function handleRemoveAttachmentFromLamps() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('lamps').all().then(function (docs) {
        _this.isLoading = false;
        var docsWithEmptyAttachment = docs.filter(function (doc) {
          if (doc._attachments && doc._attachments['documents.pdf'].length === 0) {
            return true;
          }
          return false;
        });
        _this.total = docsWithEmptyAttachment.length;
        var swalOptions = {
          title: 'Existem ' + docsWithEmptyAttachment.length + ' documento(s)</b> com attachment vazio.'
        };
        if (docsWithEmptyAttachment.length === 0) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todos os documentos vazios j\xE1 foram removidos.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA deseja remover os attachments?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, desejo remover!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docsWithEmptyAttachment);

                  case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context.next = 12;
                      break;
                    }

                    item = _step.value;
                    _context.next = 9;
                    return _this.exec(item).then(function (result) {
                      if (_this.progress === _this.total) {
                        _this.notifyFinish();
                      }
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 9:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                  case 12:
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 18:
                    _context.prev = 18;
                    _context.prev = 19;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 21:
                    _context.prev = 21;

                    if (!_didIteratorError) {
                      _context.next = 24;
                      break;
                    }

                    throw _iteratorError;

                  case 24:
                    return _context.finish(21);

                  case 25:
                    return _context.finish(18);

                  case 26:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var deleted;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].deleteAttachment(item._id, {
                  attachmentName: 'documents.pdf'
                });

              case 2:
                deleted = _context2.sent;

                _this2.progress++;
                return _context2.abrupt('return', deleted);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todos os documentos vazios foram removidos.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "QSN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Clientes ("+_vm._s(this.ticketsFiltered.length)+")")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-xs-1"},[(_vm.$can('survey.associate'))?_c('input',{ref:"checkAllTicket",staticClass:"btn-large",staticStyle:{"margin":"0px 10px 0px 15px"},attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.clickCheckAllTickets()}}}):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._l((_vm.ticketsFiltered),function(ticket,index){return _c('div',{key:index,staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-xs-1",staticStyle:{"float":"left"}},[(!_vm.surveysFound(ticket))?_c('input',{ref:("ref-" + (ticket._id)),refInFor:true,staticStyle:{"float":"left","margin":"15px"},attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.clickCheckTicket(ticket._id)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-xs-11"},[(_vm.customers[ticket.customerId])?_c('survey-customer-content',{attrs:{"customer":_vm.customers[ticket.customerId]}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-xs-12"},[(_vm.surveysFound(ticket))?_c('survey-status-icons',{attrs:{"ticket":ticket,"survey":_vm.surveys[ticket._id]}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-xs-12"},[_vm._v(_vm._s(_vm.getUserAssociated(ticket._id)))]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-xs-12"},[_c('survey-customer-actions',{attrs:{"ticket":ticket,"survey":_vm.surveys[ticket._id]}})],1)])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-8 col-xs-11"},[_c('strong',[_vm._v("Selecionar todos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-xs-12"},[_c('strong',[_vm._v("Usuário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-1 col-xs-12"},[_c('strong',[_vm._v("Ações")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QUfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-card"},[_c('div',{staticClass:"item1"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"item2"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"Sim","off-text":"Não"},model:{value:(_vm.project.event.hasCeremony),callback:function ($$v) {_vm.$set(_vm.project.event, "hasCeremony", $$v)},expression:"project.event.hasCeremony"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"true"},model:{value:(_vm.project.event.automaticReplacement),callback:function ($$v) {_vm.$set(_vm.project.event, "automaticReplacement", $$v)},expression:"project.event.automaticReplacement"}},[_vm._v("Automática\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"false"},model:{value:(_vm.project.event.automaticReplacement),callback:function ($$v) {_vm.$set(_vm.project.event, "automaticReplacement", $$v)},expression:"project.event.automaticReplacement"}},[_vm._v("Manual\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"true"},model:{value:(_vm.project.event.autoDateOnDeliveryTerm),callback:function ($$v) {_vm.$set(_vm.project.event, "autoDateOnDeliveryTerm", $$v)},expression:"project.event.autoDateOnDeliveryTerm"}},[_vm._v("Automática\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"false"},model:{value:(_vm.project.event.autoDateOnDeliveryTerm),callback:function ($$v) {_vm.$set(_vm.project.event, "autoDateOnDeliveryTerm", $$v)},expression:"project.event.autoDateOnDeliveryTerm"}},[_vm._v("Manual\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","name":"eventCustomersCanBeRecontemplated","label":"true"},model:{value:(_vm.project.event.customersCanBeRecontemplated),callback:function ($$v) {_vm.$set(_vm.project.event, "customersCanBeRecontemplated", $$v)},expression:"project.event.customersCanBeRecontemplated"}},[_vm._v("Sim\n        ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","name":"eventCustomersCanBeRecontemplated","label":"false"},model:{value:(_vm.project.event.customersCanBeRecontemplated),callback:function ($$v) {_vm.$set(_vm.project.event, "customersCanBeRecontemplated", $$v)},expression:"project.event.customersCanBeRecontemplated"}},[_vm._v("Não\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validations.event.contemplatedPeriod),expression:"validations.event.contemplatedPeriod"},{name:"model",rawName:"v-model.number",value:(_vm.project.event.contemplatedPeriod),expression:"project.event.contemplatedPeriod",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","name":"contemplatedPeriod"},domProps:{"value":(_vm.project.event.contemplatedPeriod)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.event, "contemplatedPeriod", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validations.event.contemplatedPeriod.invalid),expression:"validations.event.contemplatedPeriod.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('contemplatedPeriod'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.event.hasPhotos),callback:function ($$v) {_vm.$set(_vm.project.event, "hasPhotos", $$v)},expression:"project.event.hasPhotos"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","name":"eventManagedCsv","label":"true"},model:{value:(_vm.project.event.managedCsv),callback:function ($$v) {_vm.$set(_vm.project.event, "managedCsv", $$v)},expression:"project.event.managedCsv"}},[_vm._v("Sim\n        ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","name":"eventManagedCsv","label":"false"},model:{value:(_vm.project.event.managedCsv),callback:function ($$v) {_vm.$set(_vm.project.event, "managedCsv", $$v)},expression:"project.event.managedCsv"}},[_vm._v("Não\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Configurações de Eventos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              Os eventos terão "),_c('strong',[_vm._v("cerimônia?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              A "),_c('strong',[_vm._v("substituição")]),_vm._v(" do cliente sorteado será:\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              A "),_c('strong',[_vm._v("data")]),_vm._v("\n              de recebimento no "),_c('strong',[_vm._v("protocolo de entrega")]),_vm._v("\n              (termo de entrega) será manual ou automática?\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n          Será permitido "),_c('strong',[_vm._v("sortear cliente já contemplados")]),_vm._v("\n          anteriormente?\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_c('strong',[_vm._v("Por quantos anos")]),_vm._v(" os clientes\n          "),_c('strong',[_vm._v("serão")]),_vm._v(" considerados como\n          "),_c('strong',[_vm._v("contemplados?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n          Haverá "),_c('strong',[_vm._v("envio de fotos")]),_vm._v(" no evento?\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n          Haverá "),_c('strong',[_vm._v("cadastro de clientes via planilha")]),_vm._v("?\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QbEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Consultar na API do Educacional")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiEdu),expression:"apiEdu"}],staticClass:"form-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.apiEdu)?_vm._i(_vm.apiEdu,null)>-1:(_vm.apiEdu)},on:{"change":function($event){var $$a=_vm.apiEdu,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.apiEdu=$$a.concat([$$v]))}else{$$i>-1&&(_vm.apiEdu=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.apiEdu=$$c}}}})])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-success btn-wd btn-fill",on:{"click":_vm.handleSave}},[_vm._v("Salvar\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QbX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tag_vue__ = __webpack_require__("wrmY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303036ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tag_vue__ = __webpack_require__("yWR7");
function injectStyle (ssrContext) {
  __webpack_require__("SLOr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303036ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QgmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QpYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_GalleryComponent__ = __webpack_require__("Z1yA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerCard_vue__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Customers_CustomerImageCard_vue__ = __webpack_require__("uSbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TicketActions__ = __webpack_require__("j9ym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketCard__ = __webpack_require__("VnXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Trg_Tickets_DocumentsTicketCard__ = __webpack_require__("0CkY");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tickets-details',

  components: {
    GalleryComponent: __WEBPACK_IMPORTED_MODULE_1_src_components_GalleryComponent__["a" /* default */],
    CustomerCard: __WEBPACK_IMPORTED_MODULE_2_src_pages_Customers_CustomerCard_vue__["a" /* default */],
    CustomerImageCard: __WEBPACK_IMPORTED_MODULE_3_src_pages_Customers_CustomerImageCard_vue__["a" /* default */],
    TicketCard: __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketCard__["a" /* default */],
    TicketActions: __WEBPACK_IMPORTED_MODULE_4__TicketActions__["a" /* default */],
    DocumentsTicketCard: __WEBPACK_IMPORTED_MODULE_7__components_Trg_Tickets_DocumentsTicketCard__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('tickets', ['ticket', 'ticketSearching', 'loading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('customers', {
    customer: 'customer',
    loadingCustomer: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('stocks', {
    stock: 'stock'
  }), {

    imgs: function imgs() {
      var baseUrl = 'http://127.0.0.1:5984/trg_docs/0e72963680950920add238ed65006194/';
      var attachments = ['imagem_evento_1562187132613.jpg', 'imagem_evento_1562187132501.jpg', 'imagem_evento_1562187132375.jpg'];
      return attachments.map(function (item) {
        return '' + baseUrl + item;
      });
    },

    ticketId: function ticketId() {
      return this.$route.params.id;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('customers', { fetchCustomer: 'fetchOne', getUrlImg: 'getUrlImg' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('stocks', { fetchStock: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('events', { fetchEvent: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tickets', {
    fetchTicket: 'fetchOne',
    fetchTicketCustomerEvent: 'fetchTicketCustomerEvent',
    resetTicket: 'resetOne',
    getTicketByBarCode: 'fetchViewOne'
  }), {
    handleSearch: function handleSearch(event) {
      var _this = this;

      if (this.ticketSearching) {
        this.$notify({
          message: 'Aguarde o termino da busca do cliente.',
          type: 'info'
        });
      } else {
        this.getTicketByBarCode({ ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: event, notCommit: true }).then(function (response) {
          _this.fetchTicketCustomerEvent({ ticketId: response._id });
          _this.$router.push({ name: 'tickets.details', params: { id: response._id } });
        }).catch(function (err) {
          return console.log(err);
        });
      }
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    if (this.ticketId) {
      this.fetchTicket(this.ticketId).then(function (result) {
        _this2.getUrlImg({ id: result.customerId });
        _this2.fetchCustomer(result.customerId);
        _this2.fetchEvent(result.eventId);
        _this2.fetchStock(result.stockId);
      });
    }
  }
});

/***/ }),

/***/ "QrWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseModule__ = __webpack_require__("tv5d");





var collection = 'stocks';
var singleName = 'stock';
var pluralName = 'stocks';

var model = {
  eventId: '',
  manufacturerId: '',
  invoice: Number(),
  dateInvoice: Date(),
  invoicePowerCompany: Number(),
  dateInvoicePowerCompany: Date(),
  numberOfRefigerators: Number(),
  description: ''
};

var validations = {
  eventId: {
    required: true
  },
  manufacturerId: {
    required: true
  },
  invoice: {
    required: true
  },
  dateInvoice: {
    required: true
  },
  invoicePowerCompany: {
    required: true
  },
  dateInvoicePowerCompany: {
    required: true
  },
  numberOfRefigerators: {
    required: true
  },
  description: {
    required: true
  }
};

var getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  },
  stocksOption: function stocksOption(state) {
    var op = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.all), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var s = _step.value;

        op.push({
          value: s._id,
          label: s.description + ' (' + s.numberOfRefigerators + ')'
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return op;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["c" /* mapActions */])(collection, model)),
  getters: getters
});

/***/ }),

/***/ "QtJQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnergisaPb_vue__ = __webpack_require__("lDIT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e5d3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnergisaPb_vue__ = __webpack_require__("hQ4Q");
function injectStyle (ssrContext) {
  __webpack_require__("tBif")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3e5d3ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnergisaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e5d3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnergisaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d68a4b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("DSuK");
function injectStyle (ssrContext) {
  __webpack_require__("OgYX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d68a4b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_Search_vue__ = __webpack_require__("yntV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__("NYxO");

















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'permissions-index',
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */], PSearch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_Search_vue__["a" /* default */]
  },
  data: function data() {
    return {
      pagination: {
        perPage: 1000,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['name', 'label']
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapGetters */])(['user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapGetters */])('roles', {
    loading: 'loading',
    roles: 'roles',
    role: 'role'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.count;
      return this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])('roles', ['fetchAll', 'fetchOne', 'delete']), {
    fetch: function fetch() {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search
      });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetch();
    },
    handleSort: function handleSort(sort) {
      this.sort = { field: sort.prop, direction: sort.order };
      this.fetch();
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this.delete(row._id).then(function (result) {
          _this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this.fetchAll();
        }).catch(function (err) {
          return console.log(err);
        });
      });
    },
    canBeDeleted: function canBeDeleted(name) {
      return ['atendente', 'administrador', 'supervisor'].indexOf(name) < 0 || this.user.role === 'superadmin';
    }
  }),

  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ "R6cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc-ma',
  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética do Maranhão';
    },
    abbreviation: function abbreviation() {
      return 'CEMAR';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      };
    },
    cnpj: function cnpj() {
      return '06.272.793/0001-84';
    },
    numberState: function numberState() {
      return '06.105.848-3';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "R9H5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersIndex_vue__ = __webpack_require__("Zfab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292e3610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersIndex_vue__ = __webpack_require__("eiqP");
function injectStyle (ssrContext) {
  __webpack_require__("66Fv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292e3610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RAVI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "REaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventCard',

  props: {
    event: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('users', { users: 'usersIdName' }), {
    label: function label() {
      return localStorage.getItem('eventLabel');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll'
  })),
  mounted: function mounted() {
    this.fetchUsers({ limit: 999 });
  }
});

/***/ }),

/***/ "RM11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("S8VE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d860fa0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("Z0wx");
function injectStyle (ssrContext) {
  __webpack_require__("LvnI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d860fa0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RT7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsUploadImages_vue__ = __webpack_require__("VK8X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71cb6431_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsUploadImages_vue__ = __webpack_require__("9NRq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsUploadImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71cb6431_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsUploadImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RUAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vector-map')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RV4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RV5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7 col-xs-12"},[_c('event-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.eventLoading),expression:"eventLoading"}],attrs:{"event":_vm.event,"show-edit-button":false}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-xs-12"},[_c('circle-chart-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"percentage":_vm.percentage,"title":"","description":("Pesquisas realizadas " + _vm.countTicketsSurveyed + " de " + _vm.countTotalTickets + "."),"color":"blue"}})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"col-lg-6 col-xs-12"},[_c('survey-list-filters',{attrs:{"tickets":_vm.tickets,"customers":_vm.customers},on:{"changeFilter":function($event){return _vm.onChangeFilter($event)}}})],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.savingLoading),expression:"savingLoading"}],staticClass:"col-lg-6 col-xs-12"},[_c('survey-actions',{attrs:{"event":_vm.event,"enableAssociate":_vm.enableAssociate},on:{"runAssociateAll":function($event){return _vm.runAssociateAll()},"setUser":function($event){return _vm.onUsersSelected($event)}}})],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"col-xs-12"},[_c('survey-tickets-list-to-associate',{attrs:{"tickets":_vm.tickets,"customers":_vm.customers,"surveys-prop":_vm.surveys,"clean":_vm.cleanBox,"filters":_vm.filters},on:{"surveyDocuments":function($event){return _vm.onSurveyDocuments($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RWP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "RcaJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBtn)?_c('button',{staticClass:"btn btn-fill btn-icon btn-success",attrs:{"title":"Imprimir documentação de cadastro do ticket."},on:{"click":function($event){return _vm.handleDocumentsPrint()}}},[_c('i',{staticClass:"ti-envelope"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RcoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('el-select',{staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"all","label":"Todos"}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Colocar documentedAt=null nos Tickets e remover documentos\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rj96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("All Docs With Attachments ("+_vm._s(_vm.tableData.length)+") "+_vm._s(_vm.allAttachmentsSize))])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'id'}}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"filesService","sortable":"","label":"Arquivos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"lengths","sortable":"","label":"Tamanhos"}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rjzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableLayout_vue__ = __webpack_require__("++bs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2aee98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableLayout_vue__ = __webpack_require__("Udxs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2aee98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rmzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagForm_vue__ = __webpack_require__("JcrZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c93dd85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagForm_vue__ = __webpack_require__("Iomc");
function injectStyle (ssrContext) {
  __webpack_require__("K4vv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c93dd85e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c93dd85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rrpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  data: function data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: ''
      },
      modelValidations: {
        firstName: {
          min: 5
        },
        lastName: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "Rug+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RyB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseModule__ = __webpack_require__("tv5d");





var collection = { $exists: false };
var singleName = 'state';
var pluralName = 'states';

var model = {
  cidades: [],
  nome: '',
  sigla: ''
};

var validations = {
  nome: {
    required: true
  },
  informativeText: {
    sigla: true
  }
};

var getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  },
  statesOptions: function statesOptions(state) {
    var statesOptions = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.all), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        statesOptions.push({
          value: item.sigla,
          label: item.nome
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return statesOptions;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0,
    cities: []
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["b" /* mapMutations */])(), {
    SET_CITIES: function SET_CITIES(state, payload) {
      state.cities = payload;
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["c" /* mapActions */])(collection, model, 'states'), {
    setCities: function setCities(context, payload) {
      context.commit('SET_CITIES', payload);
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, getters, {
    cities: function cities(state) {
      return state.cities;
    }
  })
});

/***/ }),

/***/ "Rz4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-iasc',

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', ['urlImages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      this.payload = JSON.parse(localStorage.getItem('LampsTmpTemp'));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "S0Yd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S2QK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S8VE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "S97J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermCelpaJurunas',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {

    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },


    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PA'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "SAFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-list-absent',

  props: ['tickets']
});

/***/ }),

/***/ "SEW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingPrintWinners_vue__ = __webpack_require__("brqv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96db03fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingPrintWinners_vue__ = __webpack_require__("YHGj");
function injectStyle (ssrContext) {
  __webpack_require__("b2e4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96db03fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingPrintWinners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96db03fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingPrintWinners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SGRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_password_hash_and_salt__ = __webpack_require__("I9c0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_password_hash_and_salt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_password_hash_and_salt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__("YtJ0");





var Couchdb = new __WEBPACK_IMPORTED_MODULE_1__CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'users' });

/* harmony default export */ __webpack_exports__["a"] = ({
  checkCredentials: function checkCredentials(_ref) {
    var login = _ref.login,
        password = _ref.password;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Couchdb.where('login', login).first().then(function (user) {
        if (user === null) {
          resolve(false);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_password_hash_and_salt___default()(password).verifyAgainst(user.password, function (error, verified) {
            if (error) throw new Error('Something went wrong!');
            if (!verified) {
              resolve(false);
            } else {
              delete user.password;
              resolve(user);
            }
          });
        }
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  logout: function logout() {
    localStorage.setItem('isLoggedIn', false);
    __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('unsetUser', {});
  },
  hash: function hash(password) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_password_hash_and_salt___default()(password).hash(function (error, hash) {
        if (error) reject(error);
        resolve(hash);
      });
    });
  }
});

/***/ }),

/***/ "SLOr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SPf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyStatusIcons_vue__ = __webpack_require__("Ygzm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328902dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyStatusIcons_vue__ = __webpack_require__("bN9Z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyStatusIcons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328902dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyStatusIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SUPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__API_KEY__ = __webpack_require__("JElF");




__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_1__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initMap: function initMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('map'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.load(function (google) {
      _this.initMap(google);
    });
  }
});

/***/ }),

/***/ "SXWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cemar_ParticipationTermCemar__ = __webpack_require__("PiTS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnelGo_ParticipationTermEnelGo__ = __webpack_require__("ty5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnelCe_ParticipationTermEnelCe__ = __webpack_require__("6bR1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IascPi_ParticipationTermIasc__ = __webpack_require__("CfFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IascMa_ParticipationTermIasc__ = __webpack_require__("Mz90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IascAl_ParticipationTermIasc__ = __webpack_require__("k4qY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EnergisaPb_ParticipationTermEnergisaPb__ = __webpack_require__("JbT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EnergisaBorboremaPb_ParticipationTermEnergisaBorboremaPb__ = __webpack_require__("nRj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Celpa_ParticipationTermCelpa__ = __webpack_require__("h49K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EquatorialPi_ParticipationTermEquatorialPi__ = __webpack_require__("JeQ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CelpaJurunas_ParticipationTermCelpaJurunas__ = __webpack_require__("JFzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trg_Terms_ParticipationTermGeneric__ = __webpack_require__("vlUX");

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTerm',

  components: {
    ParticipationTermGeneric: __WEBPACK_IMPORTED_MODULE_13__components_Trg_Terms_ParticipationTermGeneric__["a" /* default */],
    ParticipationTermCelpaJurunas: __WEBPACK_IMPORTED_MODULE_12__CelpaJurunas_ParticipationTermCelpaJurunas__["a" /* default */],
    ParticipationTermEquatorialPi: __WEBPACK_IMPORTED_MODULE_11__EquatorialPi_ParticipationTermEquatorialPi__["a" /* default */],
    ParticipationTermCemar: __WEBPACK_IMPORTED_MODULE_2__Cemar_ParticipationTermCemar__["a" /* default */],
    ParticipationTermEnelGo: __WEBPACK_IMPORTED_MODULE_3__EnelGo_ParticipationTermEnelGo__["a" /* default */],
    PartitipationTermEnel: __WEBPACK_IMPORTED_MODULE_4__EnelCe_ParticipationTermEnelCe__["a" /* default */],
    ParticipationTermIascMa: __WEBPACK_IMPORTED_MODULE_6__IascMa_ParticipationTermIasc__["a" /* default */],
    ParticipationTermIascAl: __WEBPACK_IMPORTED_MODULE_7__IascAl_ParticipationTermIasc__["a" /* default */],
    ParticipationTermIascPi: __WEBPACK_IMPORTED_MODULE_5__IascPi_ParticipationTermIasc__["a" /* default */],
    ParticipationTermEnergisaPb: __WEBPACK_IMPORTED_MODULE_8__EnergisaPb_ParticipationTermEnergisaPb__["a" /* default */],
    ParticipationTermEnergisaBorboremaPb: __WEBPACK_IMPORTED_MODULE_9__EnergisaBorboremaPb_ParticipationTermEnergisaBorboremaPb__["a" /* default */],
    ParticipationTermCelpa: __WEBPACK_IMPORTED_MODULE_10__Celpa_ParticipationTermCelpa__["a" /* default */]
  },

  props: {
    ticket: {
      required: true
    },
    loading: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', {
    project: 'project'
  }), {
    state: function state() {
      return this.project.state;
    },
    companyTerms: function companyTerms() {
      return this.ticket.event.doc.companyTerms;
    }
  })
});

/***/ }),

/***/ "SY3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_SetupService__ = __webpack_require__("9B/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LoginForm__ = __webpack_require__("oOdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Layout_ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_ProjectName__ = __webpack_require__("nsE0");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LoginForm: __WEBPACK_IMPORTED_MODULE_6__LoginForm__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Layout_ContentFooter_vue__["a" /* default */],
    ProjectName: __WEBPACK_IMPORTED_MODULE_8_src_components_ProjectName__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project'])),
  mounted: function mounted() {
    var _this = this;

    this.fetchOne('config').then(function () {
      localStorage.setItem('eventLabel', _this.project.hasOwnProperty('eventLabel') ? _this.project.eventLabel : 'evento');
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5__services_SetupService__["a" /* default */].createAdminUser(), __WEBPACK_IMPORTED_MODULE_5__services_SetupService__["a" /* default */].createConfigDoc(), __WEBPACK_IMPORTED_MODULE_5__services_SetupService__["a" /* default */].createIndexes(), __WEBPACK_IMPORTED_MODULE_5__services_SetupService__["a" /* default */].createViews(), __WEBPACK_IMPORTED_MODULE_5__services_SetupService__["a" /* default */].createDefaultRoles()]).then(function (result) {
      _this.$notify({
        message: 'Setup OK',
        type: 'success',
        timeout: 2000,
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      });
      _this.loading = false;
    }).catch(function (err) {
      _this.$notify({
        message: 'Setup Error',
        type: 'danger',
        timeout: 2000,
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      });
      _this.loading = false;
      console.log(err);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['fetchOne']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setUser', 'setConfig']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', { getUsers: 'fetchAll' }), {
    onLoginSubmit: function onLoginSubmit(model, isValid) {
      var _this2 = this;

      if (isValid) {
        __WEBPACK_IMPORTED_MODULE_4__services_AuthService__["a" /* default */].checkCredentials(model).then(function (user) {
          if (user === false) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
              title: '',
              text: 'Usuário não encontrado ou senha incorreta.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'error'
            });
          } else {
            _this2.setUser(user);
            _this2.setConfig();
            _this2.getUsers({ select: ['_id', 'createdAt', 'login', 'name', 'role', 'updatedAt', 'userId', 'inactivated'] });
            localStorage.setItem('isLoggedIn', true);
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
              title: 'Bem vindo ao ' + _this2.project.name + ' / ' + _this2.project.state,
              text: 'Bom trabalho!',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            }).then(function () {
              _this2.$router.push('/admin/dashboard');
            });
          }
        }).catch(function (err) {
          if (err) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
              title: '',
              text: 'Ocorreu um erro e não foi possível efetuar o login.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'error'
            });
            console.log(err);
          }
        });
      }
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "Scpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.categories,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){}}},[_c('el-table-column',{attrs:{"prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{on:{"click":function($event){return _vm.handleEdit(scope.row._id)}}},[_vm._v("\n      "+_vm._s(scope.row.name)+"\n    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"apiEdu","label":"Consultar API Edu"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(scope.row.apiEdu ? 'Sim' : 'Não')+"\n    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":100,"fixed":"right","label":"Ações"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('actions-table-categories',{attrs:{"categorie":props.row,"handleRemove":_vm.handleRemove}})],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SdWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermGeneric_vue__ = __webpack_require__("qCRR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09226396_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermGeneric_vue__ = __webpack_require__("CIYU");
function injectStyle (ssrContext) {
  __webpack_require__("FiFg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09226396"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermGeneric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09226396_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermGeneric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Roles_Roles__ = __webpack_require__("dEu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Roles_RolesIndex__ = __webpack_require__("15zP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Roles_RolesForm__ = __webpack_require__("xSky");




var path = 'roles';
var title = 'Perfis';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Roles_Roles__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Roles_RolesIndex__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Roles_RolesForm__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Roles_RolesForm__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "Smwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqJ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sv46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SyeV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Project_ProjectForm_vue__ = __webpack_require__("m56S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Project_ProjectIndex_vue__ = __webpack_require__("mXMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Project_Index_vue__ = __webpack_require__("b7lu");




/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'project',
  component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Project_Index_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'project.index',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Project_ProjectIndex_vue__["a" /* default */],
    meta: {
      title: 'Projeto',
      requireAuth: true
    }
  }, {
    path: 'edit',
    name: 'project.edit',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Project_ProjectForm_vue__["a" /* default */],
    meta: {
      title: 'Projeto',
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "T+Bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'users.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1Lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-term-go",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"40px","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(("" + (_vm.payload.eventId)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A Companhia Energética do Ceará - ENEL com sede na rua Padre Valdevino, nº\n    150 – Centro, Fortaleza/CE inscrita no\n    CNPJ/MF sob o nº. 07.047.251/0001-70 e Inscrição Estadual nº.\n    06.105.848-3, e o(a) Sr(a).\n    ___________________________________________________________________________________________________________,\n    R.G.: ________________________________, C.P.F.:\n    ________________________________ e N.I.S./N.I.T./N.B.\n    ________________________________ residente e\n    domiciliado (a) na ________________________________ nº\n    ________________________________ UC n.º\n    ________________________________ firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e\n    compromissos assumidos e acordados\n    encontram-se descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A Companhia Energética do Ceará fornecerá à unidade consumidora atendida\n      pelo projeto a quantidade de\n      ____ lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por ____ incandescentes de potência\n      ____, e ____ lâmpadas fluorescentes de potência\n      ____, devendo estas ser entregues à ENEL no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade\n      entregue à ENEL para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se\n      compromete a manter-se em dia com o\n      parcelamento firmado com a Companhia Energética do Ceará.\n    ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"1cm"}},[_vm._v("\n    Fortaleza, "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new Date(),'YYYY'))+"\n  ")]),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n      A Companhia Energética do Ceará está desenvolvendo o\n      "),_c('i',[_vm._v("“ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA\n         ENERGÉTICA”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as\n      comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas\n      ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas\n      comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica,\n      enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A Companhia Energética do Ceará busca viabilizar essa prática nas\n      comunidades atendidas pelo\n      "),_c('i',[_vm._v("“ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA\n         ENERGÉTICA”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem\n      substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":"1cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30?\n        _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência?\n        _____________\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    ________________________________________________________________________\n    "),_c('br'),_vm._v("\n    Assinatura do(a) cliente beneficiado\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T3Ru":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("wR4F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T7Aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.event.drawn)?_c('div',[_c('btn-run-lottery',{on:{"fetchTickets":function($event){return _vm.$emit('fetchTickets')}}}),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'ranking.index', params: {id: _vm.event._id}}}},[(_vm.isRanking && _vm.$can('ranking.index'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block"},[_vm._v("\n      Gerenciar Ranking\n    ")]):_vm._e()])],1):_c('div',[_c('router-link',{attrs:{"to":{name: 'ranking.index', params: {id: _vm.event._id}}}},[(_vm.isRanking && !_vm.$can('ranking.index'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-info btn-block btn-router"},[_vm._v("\n      Vizualizar ranking\n    ")]):_vm._e()]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'tickets.details'}}},[(_vm.isLottery && _vm.$can('tickets.details'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-info btn-block btn-router"},[_vm._v("\n      Registrar presenças\n    ")]):_vm._e()]),_vm._v(" "),_c('btn-open-new-presenter'),_vm._v(" "),(_vm.event.downloadWinnersPpt)?_c('btn-download-pptx'):_vm._e(),_vm._v(" "),(_vm.event.downloadWinnersPpt)?_c('btn-download-pptx-substitute-customers'):_vm._e(),_vm._v(" "),_c('btn-download-old-presenter'),_vm._v(" "),_c('btn-associate-stock',{on:{"fetchTickets":function($event){return _vm.$emit('fetchTickets')}}}),_vm._v(" "),_c('btn-print-terms'),_vm._v(" "),_c('btn-download-documentation'),_vm._v(" "),_c('btn-print-all-tickets'),_vm._v(" "),_c('btn-print-all-tickets',{attrs:{"eligibleNotWinners":true}}),_vm._v(" "),(_vm.event.downloadWinnersCsv)?_c('btn-csv-winners'):_vm._e(),_vm._v(" "),(_vm.event.downloadWinnersCsv)?_c('btn-csv-winners',{attrs:{"eligibleNotWinners":true}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TCD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'customers.index' && this.$can('customers.create');
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "TKGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.project.name),expression:"project.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.project.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelValidations.name.invalid),expression:"modelValidations.name.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('name'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.projectOnlineRegister),expression:"project.projectOnlineRegister"}],staticClass:"form-control",attrs:{"type":"text","name":"projectOnlineRegister"},domProps:{"value":(_vm.project.projectOnlineRegister)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "projectOnlineRegister", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"category"},[_vm._v("Como será o rótulos na qual os eventos deverão ser chamados dentro do sistema?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.eventLabel),expression:"project.eventLabel"}],attrs:{"type":"radio","name":"eventLabel","value":"Eventos","required":""},domProps:{"checked":_vm._q(_vm.project.eventLabel,"Eventos")},on:{"change":function($event){return _vm.$set(_vm.project, "eventLabel", "Eventos")}}}),_vm._v("Eventos\n      "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.eventLabel),expression:"project.eventLabel"}],attrs:{"type":"radio","name":"eventLabel","value":"Ações","required":""},domProps:{"checked":_vm._q(_vm.project.eventLabel,"Ações")},on:{"change":function($event){return _vm.$set(_vm.project, "eventLabel", "Ações")}}}),_vm._v("Ações\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"category"},[_vm._v("Será exibido o card com os contadores do educacional na Dashboard?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.dashboardEduCards),callback:function ($$v) {_vm.$set(_vm.project, "dashboardEduCards", $$v)},expression:"project.dashboardEduCards"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.state),expression:"project.state"}],staticClass:"form-control",attrs:{"name":"project-state","id":"form-select-proejct-state"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.project, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.changeStateName]}},[_c('option',{attrs:{"value":""}},[_vm._v("Selectione um estado...")]),_vm._v(" "),_vm._l((_vm.activeStateOptions),function(item){return _c('option',{domProps:{"value":item.value}},[_vm._v(_vm._s(item.label)+"\n        ")])})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelValidations.state.invalid),expression:"modelValidations.state.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('state'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.haveSurveys),callback:function ($$v) {_vm.$set(_vm.project, "haveSurveys", $$v)},expression:"project.haveSurveys"}})],1),_vm._v(" "),(_vm.project.haveSurveys)?_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_vm._l((Object.keys(_vm.defaultWinnerChoiceModeOptions)),function(value,iterator){return _c('div',{attrs:{"keys":iterator}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.defaultWinnerChoiceMode),expression:"project.defaultWinnerChoiceMode"}],attrs:{"type":"radio","name":"default-winner-event-choice"},domProps:{"value":value,"checked":_vm._q(_vm.project.defaultWinnerChoiceMode,value)},on:{"change":function($event){return _vm.$set(_vm.project, "defaultWinnerChoiceMode", value)}}}),_vm._v("\n        "+_vm._s(_vm.defaultWinnerChoiceModeOptions[value])+"\n      ")])})],2):_vm._e(),_vm._v(" "),(_vm.project.haveSurveys)?_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.viewGoogleMap),callback:function ($$v) {_vm.$set(_vm.project, "viewGoogleMap", $$v)},expression:"project.viewGoogleMap"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('p-checkbox',{attrs:{"name":"validationCustomer","checked":_vm.modelValidations.validationCustomer.uc},model:{value:(_vm.project.validationCustomer.uc),callback:function ($$v) {_vm.$set(_vm.project.validationCustomer, "uc", $$v)},expression:"project.validationCustomer.uc"}},[_vm._v("UC\n      ")]),_vm._v(" "),_c('p-checkbox',{attrs:{"name":"validationCustomer","checked":_vm.modelValidations.validationCustomer.cpf},model:{value:(_vm.project.validationCustomer.cpf),callback:function ($$v) {_vm.$set(_vm.project.validationCustomer, "cpf", $$v)},expression:"project.validationCustomer.cpf"}},[_vm._v("CPF\n      ")]),_vm._v(" "),_c('p-checkbox',{attrs:{"name":"validationCustomer","checked":_vm.modelValidations.validationCustomer.ucOrCpf},model:{value:(_vm.project.validationCustomer.ucOrCpf),callback:function ($$v) {_vm.$set(_vm.project.validationCustomer, "ucOrCpf", $$v)},expression:"project.validationCustomer.ucOrCpf"}},[_vm._v("UC ou CPF\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('p-checkbox',{attrs:{"name":"validationContemplatedCustomer","checked":_vm.modelValidations.validationContemplatedCustomer.uc},model:{value:(_vm.project.validationContemplatedCustomer.uc),callback:function ($$v) {_vm.$set(_vm.project.validationContemplatedCustomer, "uc", $$v)},expression:"project.validationContemplatedCustomer.uc"}},[_vm._v("UC\n      ")]),_vm._v(" "),_c('p-checkbox',{attrs:{"name":"validationContemplatedCustomer","checked":_vm.modelValidations.validationContemplatedCustomer.cpf},model:{value:(_vm.project.validationContemplatedCustomer.cpf),callback:function ($$v) {_vm.$set(_vm.project.validationContemplatedCustomer, "cpf", $$v)},expression:"project.validationContemplatedCustomer.cpf"}},[_vm._v("CPF\n      ")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelValidations.name.invalid),expression:"modelValidations.name.invalid"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('validationContemplatedCustomer'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.requiredNIS),callback:function ($$v) {_vm.$set(_vm.project, "requiredNIS", $$v)},expression:"project.requiredNIS"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.project.useLGPD),callback:function ($$v) {_vm.$set(_vm.project, "useLGPD", $$v)},expression:"project.useLGPD"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Configurações Gerais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_c('strong',[_vm._v("Nome")]),_vm._v(" do Projeto")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("Endereço do "),_c('strong',[_vm._v("Cadastro Online")]),_vm._v(" do Projeto")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v(" Qual o "),_c('strong',[_vm._v("estado onde")]),_vm._v(" o projeto ocorrerá? Por padrão. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("Neste projeto "),_c('strong',[_vm._v("poderá haver pesquisa")]),_vm._v("?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("Qual a "),_c('strong',[_vm._v("opção padrão de escolha dos vencedores ")]),_vm._v(" do evento?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("Neste projeto "),_c('strong',[_vm._v("exibirá mapa ")]),_vm._v("?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n        A "),_c('strong',[_vm._v("verificação se o cliente é duplicado")]),_vm._v(" será através de:\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n        A verificação de "),_c('strong',[_vm._v("clientes contemplados")]),_vm._v("\n        será através de:\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n            Será obrigatório o "),_c('strong',[_vm._v("NIS no cadastro")]),_vm._v("\n            do cliente?\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n            Usar processo da "),_c('strong',[_vm._v("LGPD")]),_vm._v("?\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "TU94":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TUlP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermGeneric_vue__ = __webpack_require__("aF1k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3401b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermGeneric_vue__ = __webpack_require__("vxZ1");
function injectStyle (ssrContext) {
  __webpack_require__("YCtc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df3401b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermGeneric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3401b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermGeneric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TXVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermIasc',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return 'Piauí';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética Do Piaui';
    },
    abbreviation: function abbreviation() {
      return 'CEPISA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Av.',
        street: 'Maranhão',
        number: '759',
        neighborhood: 'Centro',
        city: 'Teresina',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '068.407.480/0001-89';
    },
    numberState: function numberState() {
      return '193013835';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "TY2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_DashboardCounter__ = __webpack_require__("fzNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_config_connections__ = __webpack_require__("ZKT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);













var collection = 'events';
var singleName = 'event';
var pluralName = 'events';

var _statusOptions = {
  programado: { 'value': 0, 'label': 'Programado' },
  iniciado: { 'value': 1, 'label': 'Iniciado' },
  finalizado: { 'value': 2, 'label': 'Finalizado' }
};

var model = {
  city: '',
  reference: '',
  prizeLink: '',
  place: '',
  startDate: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(Date()).format(),
  endDate: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(Date()).format(),
  dateTimeCeremony: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(Date()).format(),
  dateTimeDelivery: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(Date()).format(),
  timeEndDelivery: '',
  numberOfRefigerators: Number(),
  numberOfLamps: Number(),
  status: 1,
  drawn: false,
  present: {},
  surveysType: ['refrigerator'],
  winnerChoiceMode: '',
  directList: false,
  energyDefaultWinner: true,
  registerCustomerByCsv: false,
  confirmCustomerByCsv: false,
  downloadWinnersCsv: false,
  downloadWinnersPpt: false,
  hasSortTRG_889: false,
  doc: {
    companyTerms: 'generic',
    deliveryAddress: '',
    daysToVisit: '04',
    registerCustomerTicketDocument: false
  },
  lamp: {
    powerLampDeliveryLabel: '8,5',
    requiredTermLamp: false
  }
};

var validations = {
  city: {
    required: true,
    min: 5
  },
  reference: {
    required: true,
    min: 5
  },
  place: {
    required: true,
    min: 5
  },
  startDate: {
    required: true
  },
  endDate: {
    required: true
  },
  dateTimeCeremony: {
    required: true
  },
  dateTimeDelivery: {
    required: true
  },
  numberOfRefigerators: {
    required: true,
    numeric: true
  },
  numberOfLamps: {
    numeric: true,
    required: true
  },
  status: {
    required: true
  },
  surveyTypes: { required: true },
  directList: { required: true }
};

var present = function present(one) {
  var present = {};
  var status = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(_statusOptions, function (obj) {
    return obj.value === one.status;
  });
  present.status = status === undefined ? '' : status.label;
  return present;
};

var getters = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__baseModule__["d" /* mapGetters */])(), {
  surveysOptions: function surveysOptions() {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
      refrigerator: 'Refrigerador',
      diagnostic: 'Diagnóstico'
    });
  },
  statusOptions: function statusOptions(state) {
    return _statusOptions;
  },
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  },
  startedOptions: function startedOptions(state) {
    return state.all.filter(function (item) {
      return item.status && item.status === 1;
    }).map(function (item) {
      return {
        value: item._id,
        label: item.reference + ' - ' + item.place + ' - ' + item.city
      };
    });
  },
  optionsById: function optionsById(state) {
    var options = [{ value: '', label: 'Selecione um evento' }];

    if (!state.all) {
      return options;
    }

    state.all.map(function (item) {
      options.push({
        value: item._id,
        label: item.reference + ' - ' + item.city + ' - ' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.startDate).format('LLL'),
        place: item.place,
        status: item.status
      });
    });

    return options;
  },
  allFiltered: function allFiltered(state) {
    return state.allFiltered;
  },
  ticketsCounter: function ticketsCounter(state) {
    return state.ticketsCounter;
  },
  lampsCounter: function lampsCounter(state) {
    return state.lampsCounter;
  },
  sortedByReference: function sortedByReference(state) {
    return state.all.sort(function (a, b) {
      return b.hasOwnProperty('reference') && a.hasOwnProperty('reference') ? b.reference.localeCompare(a.reference) : 0;
    });
  }
});
getters[singleName] = function (state) {
  var one = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, model, state.one);
  one.startDate = new Date(one.startDate);
  one.endDate = new Date(one.endDate);
  one.dateTimeCeremony = new Date(one.dateTimeCeremony);
  one.dateTimeDelivery = one.dateTimeDelivery ? new Date(one.dateTimeDelivery) : one.dateTimeDelivery;
  one.present = present(one);
  return one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters[pluralName + 'Active'] = function (state) {
  return state.allActive;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__baseModule__["a" /* mapStates */])(), {
    model: model,
    loading: true,
    all: [],
    allActive: [],
    allFiltered: [],
    statusOptions: _statusOptions,
    one: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0,
    startedOptions: [{ label: 'Selecione um evento', value: '' }],
    ticketsCounter: {},
    lampsCounter: {}
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__baseModule__["b" /* mapMutations */])(), {
    UPDATE_DEFAULT_MODEL: function UPDATE_DEFAULT_MODEL(state, payload) {
      for (var field in payload) {
        if (state.model.hasOwnProperty(field)) {
          state.model[field] = payload[field];
        }
      }
    },
    setAllActive: function setAllActive(state, payload) {
      state.allActive = payload;
    },
    setAllFiltered: function setAllFiltered(state, payload) {
      state.allFiltered = payload;
    },
    setEventsStartedOptions: function setEventsStartedOptions(state, payload) {
      state.startedOptions = payload;
    },
    setTiketsCount: function setTiketsCount(state, payload) {
      state.ticketsCounter = payload.reduce(function (acc, curr, index) {
        if (index === 0) {
          acc = {};
        }
        var key = curr.key;
        if (!acc.hasOwnProperty(key)) {
          acc[key] = curr.value;
        }
        return acc;
      }, {});
    },
    SET_LAMPS_COUNT: function SET_LAMPS_COUNT(state, payload) {
      state.lampsCounter = payload.reduce(function (acc, curr, index) {
        if (index === 0) {
          acc = {};
        }
        var key = curr.key;
        if (!acc.hasOwnProperty(key)) {
          acc[key] = curr.value;
        }
        return acc;
      }, {});
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__baseModule__["c" /* mapActions */])(collection, model, 'default'), {
    fetchAllActive: function fetchAllActive(context, payload) {
      context.commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].collection(collection).where('status', _statusOptions.iniciado.value).all().then(function (result) {
        context.commit('setAllActive', result);
        context.commit('changeLoading', false);
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
      });
    },
    getStartedEvents: function getStartedEvents(_ref) {
      var commit = _ref.commit;

      commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].collection(collection).where('status', 1).where('drawn', false).all().then(function (result) {
        commit('changeLoading', false);
        if (result) {
          var op = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(result), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var r = _step.value;

              if (r.drawn) {
                continue;
              }
              op.push({
                value: r._id,
                label: r.reference
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          commit('setEventsStartedOptions', op);
        }
      }).catch(function (err) {
        console.log('err', err);
        commit('changeLoading', false);
      });
    },

    setEventDrawn: function setEventDrawn(_ref2, event) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').collection('events').upsert(event._id, event).then(function (res) {
          dispatch('fetchOne', event._id);
          dispatch('tickets/fetchTicketsWithCustomersByEvent', {
            where: { surveyAssociated: true },
            eventId: event._id
          }, { root: true });
          resolve(true);
        }).catch(function (err) {
          console.log('set draw error', err);
          resolve(false);
        });
      });
    },
    setEvent: function setEvent(_ref3, event) {
      var commit = _ref3.commit;

      commit('setOne', event);
    },
    filterEventsByTags: function filterEventsByTags(_ref4, tags) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var allEvents = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.allFiltered));
      var events = allEvents.filter(function (event) {
        if (tags.length !== 0) {
          if (event.tags) {
            for (var i = 0, len = tags.length; i < len; i++) {
              if (event.tags.indexOf(tags[i]) === -1) return false;
            }
            return true;
          }
          return false;
        }
        return event;
      });
      commit('setAllFiltered', events);
      return events;
    },
    filterEventsByDate: function filterEventsByDate(_ref5, _ref6) {
      var commit = _ref5.commit,
          state = _ref5.state,
          dispatch = _ref5.dispatch;
      var dateRange = _ref6.dateRange,
          tags = _ref6.tags;

      commit('changeLoading', true);
      if (dateRange.length === 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_DashboardCounter__["a" /* verifyEmptyTags */])(tags)) {
        return dispatch('fetchAll', { limit: 9999 }).then(function (res) {
          commit('setAllFiltered', res);
          commit('changeLoading', false);
          return dispatch('filterEventsByTags', tags);
        }).catch(function (err) {
          return console.log('fail to fetchAll events', err);
        });
      }

      var where = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_DashboardCounter__["b" /* defineWhereObject */])(dateRange, tags);
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].where('$and', where['$and']).limit(9999999).all().then(function (result) {
        commit('setAllFiltered', result);
        commit('changeLoading', false);
        return dispatch('filterEventsByTags', tags);
      }).catch(function (err) {
        console.log(err);
        commit('changeLoading', false);
        return err;
      });
    },
    fetchTicketsCount: function fetchTicketsCount(_ref7) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._viewReduce('events-count-tickets', 'events-count-tickets').then(function (res) {
        commit('setTiketsCount', res.rows);
        return res;
      });
    },
    fetchLampsCount: function fetchLampsCount(_ref8) {
      var commit = _ref8.commit;

      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._viewReduce('count-lamps-by-event', 'count-lamps-by-event').then(function (res) {
        commit('SET_LAMPS_COUNT', res.rows);
      });
    },
    fetchEventsWithSurveys: function fetchEventsWithSurveys(_ref9) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].collection(collection).where('winnerChoiceMode', 'ranking').all().catch(function (err) {
        return console.log(err);
      }).then(function (result) {
        commit('setAll', result);
      });
    },
    uploadPhotosEvent: function uploadPhotosEvent(context, _ref10) {
      var id = _ref10.id,
          mimeType = _ref10.mimeType,
          name = _ref10.name,
          file = _ref10.file;

      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(id, {
        mimeType: mimeType,
        attachmentName: name,
        attachment: file
      });
    },
    getInsertDocEvent: function getInsertDocEvent(context, payload) {
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').where('referenceId', payload._id).get().then(function (res) {
        if (res.length > 0) {
          return res[0]._id;
        }
        return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').insert({
          'database': 'trg_admin',
          'referenceId': payload._id,
          'collection': 'events'
        }).then(function (res) {
          return res.id;
        });
      });
    },
    getURLPhotosEvent: function getURLPhotosEvent(context, payload) {
      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').where('referenceId', payload._id).get().then(function (res) {
        if (res.length > 0) {
          var baseURL = __WEBPACK_IMPORTED_MODULE_9_src_config_connections__["a" /* default */].docs.host + '/' + __WEBPACK_IMPORTED_MODULE_9_src_config_connections__["a" /* default */].docs.db + '/' + res[0]._id + '/';
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res[0]._attachments).filter(function (res) {
            return res.split('.').pop() === 'jpg';
          }).map(function (item) {
            return baseURL + item;
          });
        }
      });
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, getters, {
    eventPrintLending: function eventPrintLending(state) {
      return state.one.companyTerms === 'cemar' || state.one.companyTerms === 'iasc';
    }
  })
});

/***/ }),

/***/ "TZlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__ = __webpack_require__("wISe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef9724b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__ = __webpack_require__("xBgS");
function injectStyle (ssrContext) {
  __webpack_require__("z33l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef9724b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef9724b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TbQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tsxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Forms_InitialDataForm_vue__ = __webpack_require__("umJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Forms_PersonalDataForm_vue__ = __webpack_require__("ctsD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Trg_Customer_AddressForm__ = __webpack_require__("TZlB");
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard__["TabContent"],
    InitialDataForm: __WEBPACK_IMPORTED_MODULE_10__Forms_InitialDataForm_vue__["a" /* default */],
    PersonalDataForm: __WEBPACK_IMPORTED_MODULE_11__Forms_PersonalDataForm_vue__["a" /* default */],
    AddressForm: __WEBPACK_IMPORTED_MODULE_12_src_components_Trg_Customer_AddressForm__["a" /* default */]
  },
  data: function data() {
    return {
      customerId: '',
      saving: false,
      model: {},
      docId: '',
      entityName: 'Cliente',
      verfiryingCustomer: false,
      enableActionButtons: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])(['user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('winners', ['winner']), {
    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    },
    title: function title() {
      return this.editing ? 'Editar ' + this.entityName : 'Novo ' + this.entityName;
    },
    lampsRoute: function lampsRoute() {
      if (this.editing) {
        return {
          name: 'customers.lamps',
          params: { id: this.id }
        };
      } else if (this.docId) {
        return {
          name: 'customers.lamps',
          params: { id: this.docId }
        };
      } else {
        return { name: 'customers.index' };
      }
    },
    ticketsRoute: function ticketsRoute() {
      if (this.editing) {
        return {
          name: 'customers.tickets',
          params: { id: this.id }
        };
      } else if (this.docId) {
        return { name: 'customers.tickets', params: { id: this.docId } };
      } else {
        return { name: 'customers.index' };
      }
    },

    customer: {
      get: function get() {
        return this.$store.state.customers.one;
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('customers', ['fetchOne', 'fetchAll', 'resetOne', 'insert', 'update', 'upsert']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('winners', { winnerReset: 'resetOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('tickets', { resetTickets: 'resetAll', resetTicket: 'resetOne' }), {
    validateInitialDataForm: function validateInitialDataForm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var validate, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.initialData.validate();

              case 2:
                validate = _context.sent;

                if (!_this.editing) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', validate);

              case 5:
                _context.next = 7;
                return _this.verifyCustomerExistence().catch(function (err) {
                  return console.log(err);
                });

              case 7:
                result = _context.sent;

                if (!result) {
                  _context.next = 12;
                  break;
                }

                _this.notifyCustomerExists(result[1]);
                _context.next = 13;
                break;

              case 12:
                return _context.abrupt('return', validate);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    verifyCustomerExistence: function verifyCustomerExistence() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.customerDuplicateCheck(_this2.$refs.initialData.model.uc, _this2.$refs.initialData.model.cpf);

              case 2:
                result = _context2.sent;
                return _context2.abrupt('return', result);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    customerDuplicateCheck: function customerDuplicateCheck(customerUc, customerCpf) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var willVerify;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.verfiryingCustomer = true;
                willVerify = _this3.config.validationCustomer.cpf || _this3.config.validationCustomer.uc || _this3.config.validationCustomer.ucOrCpf;

                console.log(customerUc, customerCpf);
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('default').where('uc', customerUc).limit(1).get(), __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('default').where('cpf', customerCpf).limit(1).get()]).then(function (result) {
                  console.log(result);
                  if (!willVerify) {
                    return false;
                  }

                  if (result[0].length === 0 && result[1].length === 0) {
                    return false;
                  }

                  var customer = {
                    idUc: false,
                    idCpf: false
                  };

                  if (result[0].length > 0 && result[0][0].uc === customerUc) {
                    customer.idUc = result[0][0]._id;
                  }

                  if (result[1].length > 0 && result[1][0].cpf === customerCpf) {
                    customer.idCpf = result[1][0]._id;
                  }

                  if (_this3.validToUcAndCpf(customer)) {
                    _this3.customerId = customer.idUc;
                    return true;
                  }

                  if (_this3.validToCpfOrUc(customer)) {
                    _this3.customerId = customer.idUc ? customer.idUc : customer.idCpf;
                    return true;
                  }

                  if (_this3.validToUc(customer)) {
                    _this3.customerId = customer.idUc;
                    return true;
                  }

                  if (_this3.validToCpf) {
                    _this3.customerId = customer.idCpf;
                    return true;
                  }
                }).finally(function () {
                  _this3.verfiryingCustomer = false;
                }));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    validToUcAndCpf: function validToUcAndCpf(customer) {
      return this.config.validationCustomer.uc && this.config.validationCustomer.cpf && customer.idUc && customer.idCpf;
    },
    validToUc: function validToUc(customer) {
      return this.config.validationCustomer.uc && !this.config.validationCustomer.cpf && customer.idUc;
    },
    validToCpf: function validToCpf(customer) {
      return !this.config.validationCustomer.uc && this.config.validationCustomer.cpf && customer.idCpf;
    },
    validToCpfOrUc: function validToCpfOrUc(customer) {
      console.log(customer);
      return this.config.validationCustomer.ucOrCpf && (customer.idCpf || customer.idUc);
    },
    notifyCustomerExists: function notifyCustomerExists(result) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Cliente já cadastrado',
        text: 'Deseja editá-lo?',
        type: 'warning',
        showCancelButton: true
      }).then(function (res) {
        if (res) {
          _this4.$router.push({
            name: 'customers.edit',
            params: { id: _this4.customerId }
          });
          _this4.$router.go(0);
        } else {
          _this4.$router.push({ name: 'customers.index' });
        }
      }).catch(function (err) {
        console.log('erro', err);
        _this4.$router.push({ name: 'customers.index' });
      });
    },
    validatePersonalDataForm: function validatePersonalDataForm() {
      return this.$refs.personalData.validate();
    },
    handleValidation: function handleValidation(isValid, tabIndex) {
      var _this5 = this;

      if (isValid && tabIndex === 2) {
        this.saving = true;
        this.model = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.$refs.initialData.model, this.$refs.personalData.model, this.$refs.addressData.customer);
        var doc = this.id ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.customer, this.model);
        doc.phones = [doc.phone1, doc.phone2];
        doc.collection = 'customers';
        doc.userId = !doc.hasOwnProperty('_id') ? this.user._id : doc.userId;
        delete doc.tickets;
        delete doc.lamps;
        this.upsert(doc).then(function (result) {
          _this5.docId = result.id;
          _this5.$notify({
            message: 'Cliente atualizado com sucesso.',
            type: 'success'
          });
          _this5.enableActionButtons = true;
          _this5.saving = false;
        }).catch(function () {
          _this5.saving = false;
        });
      }
    },
    wizardComplete: function wizardComplete() {
      this.$router.push({ name: 'customers.index' });
    },
    resetAll: function resetAll() {
      this.resetTicket();
      this.resetTickets();
      this.resetOne();
      this.winnerReset();
    }
  }),

  mounted: function mounted() {
    this.resetAll();

    if (!this.config._id) {
      this.fetchProject('config');
    }

    if (this.id) {
      this.fetchOne(this.id);
    }

    this.verfiryingCustomer = false;
  }
});

/***/ }),

/***/ "TtUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyView_vue__ = __webpack_require__("HcAv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3f30f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyView_vue__ = __webpack_require__("LIdw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3f30f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TywH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Tipos:\n          "),_c('el-select',{staticClass:"select-primary el-select",attrs:{"multiple":"","filterable":"","size":"large","placeholder":"Filtros de clientes"},on:{"change":function($event){return _vm.emitChangeFilter()}},model:{value:(_vm.filters.status),callback:function ($$v) {_vm.$set(_vm.filters, "status", $$v)},expression:"filters.status"}},_vm._l((_vm.statusFilter.options),function(option,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Bairro:\n          "),_c('el-select',{staticClass:"select-primary el-select",attrs:{"multiple":"","filterable":"","size":"large","placeholder":"Todos os bairros"},on:{"change":function($event){return _vm.emitChangeFilter()}},model:{value:(_vm.filters.neighborhood),callback:function ($$v) {_vm.$set(_vm.filters, "neighborhood", $$v)},expression:"filters.neighborhood"}},_vm._l((_vm.neigborhoodOptions),function(option,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Usuário:\n          "),_c('el-select',{staticClass:"select-primary el-select",attrs:{"multiple":"","filterable":"","size":"large","placeholder":"Todos os usuários"},on:{"change":function($event){return _vm.emitChangeFilter()}},model:{value:(_vm.filters.users),callback:function ($$v) {_vm.$set(_vm.filters, "users", $$v)},expression:"filters.users"}},_vm._l((_vm.usersOptinos),function(option,index){return _c('el-option',{key:index,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userActivate),expression:"userActivate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.userActivate)?_vm._i(_vm.userActivate,null)>-1:(_vm.userActivate)},on:{"change":[function($event){var $$a=_vm.userActivate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.userActivate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.userActivate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.userActivate=$$c}},function($event){return _vm.setShowInactivate(_vm.userActivate)}]}}),_vm._v(" Exibir usuários inativos?\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-filter"}),_vm._v("Filtros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/ZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("fYtj");
function injectStyle (ssrContext) {
  __webpack_require__("pZL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UAe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term-enel",staticStyle:{"margin":"0.1cm"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.company)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.address)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cpnj)+" e Inscrição Estadual no. "+_vm._s(_vm.stateRegistration)+", doravante denominada "+_vm._s(_vm.shortname)+", e o(a) "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", Ceará, UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \"Projeto ENEL Comunidades\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela ENEL;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da ENEL, para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \"ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(3)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"/static/img/enel-compartilha-logo.gif"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 text-center"},[_c('h3',[_vm._v("Termo Comodato")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto Enel Compartilha Eficiência. O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL está desenvolvendo o \"Enel Compartilha Eficiência\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL buscando viabilizar essa prática nas comunidades atendidas pelo \"Enel Compartilha Eficiência\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A ENEL substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da ENEL;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela ENEL ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela ENEL, o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela ENEL em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a ENEL;\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UGIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.handlePrintTerm()}}},[_vm._v("\n  Download Termo\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UI3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadTermLamps_vue__ = __webpack_require__("gLAj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_883c7aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadTermLamps_vue__ = __webpack_require__("aExq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadTermLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_883c7aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadTermLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UJA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-celpa-jurunas',

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'As Centrais Elétricas do Pará S.A';
    },
    abbreviation: function abbreviation() {
      return 'CELPA';
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PA'
      };
    },
    cnpj: function cnpj() {
      return '04.895.728/0001-80';
    },
    numberState: function numberState() {
      return '0144046';
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      this.payload = JSON.parse(localStorage.getItem('LampsTmpTemp'));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "UQPL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "USbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"date"},[_c('label',{staticClass:"demonstration"},[_vm._v("Intevalo de tempo para o relatório de lâmpadas por usuário:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"dd/MM/yyyy","start-placeholder":"Data início","end-placeholder":"Data término"},model:{value:(_vm.rangeDate),callback:function ($$v) {_vm.rangeDate=$$v},expression:"rangeDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allUsers),expression:"allUsers"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.allUsers)?_vm._i(_vm.allUsers,null)>-1:(_vm.allUsers)},on:{"change":function($event){var $$a=_vm.allUsers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allUsers=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allUsers=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allUsers=$$c}}}}),_vm._v(" Inserir todos os usuários, inclusive os que nunca realizaram uma troca se quer, no relatório?\n    ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.reporting),expression:"reporting"}],staticClass:"btn btn-wd btn-fill btn-tertiary",on:{"click":_vm.loadingReport}},[_vm._v("\n        Relatório de Lâmpadas por usuários\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UbXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc-pi',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética Do Piaui';
    },
    abbreviation: function abbreviation() {
      return 'CEPISA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Av.',
        street: 'Maranhão',
        number: '759',
        neighborhood: 'Centro',
        city: 'Teresina',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '068.407.480/0001-89';
    },
    numberState: function numberState() {
      return '193013835';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "Udxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dropdown',[_c('span',{staticClass:"el-dropdown-link"},[_c('button',{class:_vm.classBtnAction,attrs:{"title":"Ações"}},[_c('i',{staticClass:"ti-more-alt"}),_vm._v(" "),(_vm.showLabel)?_c('span',[_vm._v("\n          Ações\n        ")]):_vm._e()])]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('dropdown-item-children',{attrs:{"children":_vm.children}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgDi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ul8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadPptxSubstituteCustomers_vue__ = __webpack_require__("E7++");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa4acac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadPptxSubstituteCustomers_vue__ = __webpack_require__("DzKl");
function injectStyle (ssrContext) {
  __webpack_require__("GBrW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faa4acac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadPptxSubstituteCustomers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa4acac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadPptxSubstituteCustomers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Upq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReplication_vue__ = __webpack_require__("6wwC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446eeaab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReplication_vue__ = __webpack_require__("RWP9");
function injectStyle (ssrContext) {
  __webpack_require__("EXKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReplication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446eeaab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReplication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UwO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-term-enel",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v("\n    "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("TERMO DE RECEBIMENTO DE LÂMPADAS")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.type)+" "+_vm._s(_vm.address.street)+", "+_vm._s(_vm.address.number)+" - "+_vm._s(_vm.address.neighborhood)+" - "+_vm._s(_vm.address.city)+" - "+_vm._s(_vm.address.state)+" , inscrita no CNPJ sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual nº "+_vm._s(_vm.numberState)+", e o(a) Sr.(a) "+_vm._s(_vm.customer.holder)+", R.G: "+_vm._s(_vm.customer.nationalId)+", C.P.F.: "+_vm._s(_vm.customer.cpf)+" e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.customer.nis)+", residente e domiciliado (a) na "+_vm._s(_vm.customerFullAddress)+", UC n.º "+_vm._s(_vm.customer.uc)+", firmam o presente Termo de Recebimento de lâmpadas, cujas condições, declarações e compromissos\n    assumidos e acordados encontram - se descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.longname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n        "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n        e\n      ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n        "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n      ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.longname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.longname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade, terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficam ligadas no horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocLocalDate__ = __webpack_require__("LfTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StagesTableTicket__ = __webpack_require__("YjAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Documents_SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocTicketRegister',
  components: {
    DocLocalDate: __WEBPACK_IMPORTED_MODULE_1__DocLocalDate__["a" /* default */],
    StagesTableTicket: __WEBPACK_IMPORTED_MODULE_2__StagesTableTicket__["a" /* default */],
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_3__pages_Documents_SignatureCustomerTicket__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchProject('config');
    this.fetchTicket(this.$route.params.id).then(function () {
      _this.fetchCustomer(_this.ticket.customerId);
      _this.fetchEvent(_this.ticket.eventId);
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('project', { project: 'project', loadingProject: 'loading' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', { event: 'event', loadingEvent: 'loading' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('customers', {
    customer: 'customer',
    addressCustomer: 'addressCustomer',
    loadingCustomer: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tickets', { ticket: 'ticket', loadingTicket: 'loading' })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tickets', { fetchTicket: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('customers', { fetchCustomer: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('events', { fetchEvent: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }))
});

/***/ }),

/***/ "V+Sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");



















var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      enabledRadio: '2',
      disabledRadio: '2',
      switches: {
        defaultOn: true,
        defaultOff: false,
        plainOn: true,
        plainOff: false,
        withIconsOn: true,
        withIconsOff: false
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 50]
      },
      selects: {
        simple: '',
        countries: [{ value: 'Bahasa Indonesia', label: 'Bahasa Indonesia' }, { value: 'Bahasa Melayu', label: 'Bahasa Melayu' }, { value: 'Català', label: 'Català' }, { value: 'Dansk', label: 'Dansk' }, { value: 'Deutsch', label: 'Deutsch' }, { value: 'English', label: 'English' }, { value: 'Español', label: 'Español' }, { value: 'Eλληνικά', label: 'Eλληνικά' }, { value: 'Français', label: 'Français' }, { value: 'Italiano', label: 'Italiano' }, { value: 'Magyar', label: 'Magyar' }, { value: 'Nederlands', label: 'Nederlands' }, { value: 'Norsk', label: 'Norsk' }, { value: 'Polski', label: 'Polski' }, { value: 'Português', label: 'Português' }, { value: 'Suomi', label: 'Suomi' }, { value: 'Svenska', label: 'Svenska' }, { value: 'Türkçe', label: 'Türkçe' }, { value: 'Íslenska', label: 'Íslenska' }, { value: 'Čeština', label: 'Čeština' }, { value: 'Русский', label: 'Русский' }, { value: 'ภาษาไทย', label: 'ภาษาไทย' }, { value: '中文 (简体)', label: '中文 (简体)' }, { value: 'W">中文 (繁體)', label: 'W">中文 (繁體)' }, { value: '日本語', label: '日本語' }, { value: '한국어', label: '한국어' }],
        multiple: 'ARS'
      },
      tags: {
        dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
        inputVisible: false,
        inputValue: ''
      },
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      datePicker: '',
      dateTimePicker: '',
      timePicker: ''
    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  }
});

/***/ }),

/***/ "V20K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCemar_vue__ = __webpack_require__("HkT3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bf4199_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCemar_vue__ = __webpack_require__("J9Kr");
function injectStyle (ssrContext) {
  __webpack_require__("c3u+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42bf4199"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCemar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bf4199_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCemar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V2VC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__events__ = __webpack_require__("TY2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_services_DashboardCounter_js__ = __webpack_require__("fzNA");















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_notifyjs___default.a);
var collection = 'tickets';
var singleName = 'ticket';
var pluralName = 'tickets';
var model = {
  eventId: null,
  customerId: null,
  stockId: null,
  winner: false,
  documentedAt: null,
  barcode: null,
  eligible: true,
  reasonNotEligible: '',
  checkIn: false,
  error: false,
  reasonError: ''
};
var validations = {
  eventId: { required: true },
  customerId: { required: true },
  winner: { required: true },
  eligible: { required: true },
  barcode: { required: true },
  stockId: { required: false },
  documentedAt: { required: false }
};
var getters = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters[pluralName + 'Winners'] = function (state) {
  return state.allWinners;
};
getters = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(getters, {
  winners: function winners(state) {
    return state.all.filter(function (item) {
      return item.winner;
    });
  },
  elegibleNotWinner: function elegibleNotWinner(state) {
    return state.all.filter(function (item) {
      return !item.winner && item.eligible;
    });
  },
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  },
  countWinners: function countWinners(state) {
    return state.countWinners;
  },
  winningTickets: function winningTickets(state) {
    return state.winningTickets;
  },
  winningLoading: function winningLoading(state) {
    return state.winningloading;
  },
  winnersWithoutStock: function winnersWithoutStock(state) {
    return state.all.filter(function (item) {
      return item.winner && item.stockId === null;
    });
  },
  ticketSearching: function ticketSearching(state) {
    return state.ticketSearching;
  }
});

var deleteExtraData = function deleteExtraData(ticket) {
  delete ticket.canceledAt;
  delete ticket.absentAt;
  delete ticket.survey;
  delete ticket.customer;
  delete ticket.event;
  delete ticket.stock;
  return ticket;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__baseModule__["a" /* mapStates */])(), {
    loading: true,
    one: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    all: [],
    allWinners: [],
    count: 0,
    countWinners: 0,
    ticketSearching: false,
    winningTickets: 0,
    winningloading: true
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__baseModule__["b" /* mapMutations */])(), {
    setAllWinners: function setAllWinners(state, payload) {
      state.allWinners = payload;
    },
    setCountWinners: function setCountWinners(state, payload) {
      state.countWinners = payload;
    },
    SET_WINNING_TICKETS: function SET_WINNING_TICKETS(state, payload) {
      state.winningTickets = payload;
    },
    CHANGE_WINNING_LOADING: function CHANGE_WINNING_LOADING(state, payload) {
      state.winningloading = payload;
    },

    setCheckIn: function setCheckIn(state, _ref) {
      var _id = _ref._id,
          check = _ref.check;

      if (state.all && state.all.length > 0) {
        for (var i in state.all) {
          if (state.all[i]._id === _id) {
            state.all[i].checkIn = check;
            break;
          }
        }
      }

      if (state.one._id && state.one._id === _id) {
        state.one.checkIn = check;
      }
    },
    setTicketSearching: function setTicketSearching(state, payload) {
      state.ticketSearching = payload;
    },
    updateTickets: function updateTickets(state, tickets) {
      tickets.forEach(function (ticket) {
        var indexState = state.all.reduce(function (acc, curr, index) {
          if (curr._id === ticket._id) {
            return index;
          }
        }, false);
        if (indexState) {
          state.all[indexState] = ticket;
        }
      });
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__baseModule__["c" /* mapActions */])(collection, model, 'default'), {
    fetchAllWinners: function fetchAllWinners(context, payload) {
      payload = !payload ? {} : payload;
      payload.stateMutations = {
        all: 'setAllWinners',
        count: 'setCountWinners'
      };
      context.dispatch('_all', payload);
    },

    createTicket: function createTicket(_ref2, payload) {
      var _this = this;

      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var couchdbAdmin, ticketCheck, barcodeCheck;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('changeLoading', true);
                couchdbAdmin = new __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
                _context.next = 4;
                return couchdbAdmin.where('customerId', payload.customerId).where('eventId', payload.eventId).get();

              case 4:
                ticketCheck = _context.sent;
                _context.next = 7;
                return dispatch('fetchViewOne', { ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: payload.barcode, notCommit: true });

              case 7:
                barcodeCheck = _context.sent;

                if (!(ticketCheck.length === 0 && !barcodeCheck.hasOwnProperty('_id'))) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', dispatch('insert', payload).then(function () {
                  dispatch('customers/fetchAllData', { id: payload.customerId }, { root: true });
                  commit('changeLoading', false);
                  return {
                    ticketCreated: true,
                    message: 'Ticket gerado com sucesso.'
                  };
                }).catch(function (err) {
                  return console.log(err);
                }));

              case 10:
                if (!(ticketCheck.length > 0)) {
                  _context.next = 13;
                  break;
                }

                commit('changeLoading', false);
                return _context.abrupt('return', {
                  ticketCreated: false,
                  message: 'Já existe um ticket gerado para essa evento.'
                });

              case 13:
                if (!barcodeCheck.hasOwnProperty('_id')) {
                  _context.next = 16;
                  break;
                }

                commit('changeLoading', false);
                return _context.abrupt('return', {
                  ticketCreated: false,
                  message: 'Já existe outro ticket com o mesmo código.'
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    runLottery: function runLottery(_ref3, _ref4) {
      var _this2 = this;

      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var event = _ref4.event,
          tickets = _ref4.tickets;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var alreadyWinners, amountToWin, ticketsNotWinner, pickedIndexes, _loop, _ret, ticketsToWin, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _index, oldEvent, eventUpdated;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('changeLoading', true);

                if (!(event.numberOfRefigerators > tickets.filter(function (item) {
                  return item.eligible;
                }).reduce(function (a, c) {
                  a += 1;
                  return a;
                }, 0))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', { error: 'Quantidades insuficientes de tickets' });

              case 3:
                alreadyWinners = tickets.filter(function (item) {
                  return item.winner;
                }).reduce(function (a) {
                  a += 1;
                  return a;
                }, 0);
                amountToWin = event.numberOfRefigerators - alreadyWinners;
                ticketsNotWinner = tickets.filter(function (item) {
                  return !item.winner;
                });

                if (!(amountToWin > ticketsNotWinner.length)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', { error: 'Quantidade de tickets insuficientes para o sorteio' });

              case 8:
                pickedIndexes = [];

              case 9:
                if (!(pickedIndexes.length < amountToWin)) {
                  _context2.next = 19;
                  break;
                }

                _loop = function _loop() {
                  var index = Math.floor(Math.random() * ticketsNotWinner.length);
                  if (!pickedIndexes.find(function (item) {
                    return item === index;
                  }) && ticketsNotWinner[index]) {
                    pickedIndexes.push(index);
                    return 'break';
                  }
                };

              case 11:
                if (false) {
                  _context2.next = 17;
                  break;
                }

                _ret = _loop();

                if (!(_ret === 'break')) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt('break', 17);

              case 15:
                _context2.next = 11;
                break;

              case 17:
                _context2.next = 9;
                break;

              case 19:
                ticketsToWin = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 23;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(pickedIndexes); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _index = _step.value;

                  ticketsToWin.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(ticketsNotWinner[_index], { winner: true }));
                }

                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](23);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 31:
                _context2.prev = 31;
                _context2.prev = 32;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 34:
                _context2.prev = 34;

                if (!_didIteratorError) {
                  _context2.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context2.finish(34);

              case 38:
                return _context2.finish(31);

              case 39:
                _context2.next = 41;
                return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].find(event._id);

              case 41:
                oldEvent = _context2.sent;
                eventUpdated = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(oldEvent, event, { drawn: true });
                _context2.next = 45;
                return __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */]._updateBulkDocs(ticketsToWin.concat(eventUpdated));

              case 45:
                return _context2.abrupt('return', { ok: 'Sorteio realizado com sucesso.' });

              case 46:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[23, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    associateStock: function associateStock(_ref5, _ref6) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;
      var tickets = _ref6.tickets;

      tickets = tickets.map(function (item) {
        delete item.customer;
        delete item.event;
        delete item.stock;
        return item;
      }).reduce(function (acc, curr) {
        if (!acc.hasOwnProperty(curr._id)) acc[curr._id] = curr;
        return acc;
      }, {});

      console.log(tickets, 'reduced');

      return dispatch('fetchAll', { where: { '_id': { '$in': __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tickets).map(function (item) {
              return item._id;
            }) } }, limit: 99999 }).then(function (docs) {
        docs = docs.map(function (doc) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(doc, tickets[doc._id], { _rev: doc._rev });
        });
        dispatch('updateMany', docs).then(function (res) {
          dispatch('fetchTicketsWithCustomersByEvent', { eventId: tickets[0].eventId });
        });
      });
    },
    replaceTicketWinner: function replaceTicketWinner(_ref7, _ref8) {
      var dispatch = _ref7.dispatch;
      var oldWinner = _ref8.oldWinner,
          newWinner = _ref8.newWinner;

      newWinner.winner = true;
      newWinner.stockId = oldWinner.stockId;
      newWinner.checkIn = false;
      oldWinner.winner = false;
      oldWinner.stockId = null;
      oldWinner.checkIn = false;

      newWinner = deleteExtraData(newWinner);
      oldWinner = deleteExtraData(oldWinner);

      var newDdoc = {
        find: { database: 'default', ddoc: 'tickets-by-id', view: 'tickets-by-id', key: newWinner._id },
        payload: newWinner
      };
      var oldDdoc = {
        find: { database: 'default', ddoc: 'tickets-by-id', view: 'tickets-by-id', key: oldWinner._id },
        payload: oldWinner
      };

      var promises = [dispatch('upsertWithView', newDdoc), dispatch('upsertWithView', oldDdoc)];

      console.log('ganhadores', newWinner, oldWinner);
      console.log('docs', newDdoc, oldDdoc);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        dispatch('fetchTicketsWithCustomersByEvent', { eventId: newWinner.eventId });
        return true;
      }).catch(function () {
        return false;
      });
    },
    setCheckIn: function setCheckIn(_ref9, _ref10) {
      var commit = _ref9.commit;
      var _id = _ref10._id,
          check = _ref10.check;

      commit('setCheckIn', {
        _id: _id,
        check: check
      });
    },
    getTicketByBarCode: function getTicketByBarCode(_ref11, _ref12) {
      var commit = _ref11.commit;
      var code = _ref12.code;

      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].collection('tickets').where('barcode', code).first().then(function (ticket) {
        if (!ticket) {
          commit('setTicketSearching', false);
          return false;
        }
        commit('setTicketSearching', false);
        commit('setOne', ticket);
      }).catch(function (e) {
        console.log('error', e);
        commit('setTicketSearching', false);
      });
    },
    getFullTicketsByCustomerId: function getFullTicketsByCustomerId(_ref13, customerId) {
      var dispatch = _ref13.dispatch;

      dispatch('fetchAll', {
        sort: {
          field: 'createdAt',
          direction: 'descending'
        },
        where: [{ 'customerId': customerId }],
        with: {
          event: {
            collection: 'events',
            localKey: 'eventId',
            foreignKey: '_id'
          },
          stock: {
            collection: 'stocks',
            localKey: 'stockId',
            foreignKey: '_id'
          }
        }
      });
    },
    setTicketSearching: function setTicketSearching(_ref14, found) {
      var commit = _ref14.commit;

      commit('setTicketSearching', found);
    },
    setSurveyAssociated: function setSurveyAssociated(_ref15, _ref16) {
      var dispatch = _ref15.dispatch;
      var tickets = _ref16.tickets;

      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').collection('tickets')._updateBulkDocs(tickets.map(function (item) {
        item.updatedAt = new Date();
        return item;
      })).then(function (res) {
        dispatch('fetchTicketsWithCustomersByEvent', {
          eventId: tickets[0].eventId
        });
      });
    },
    makeRanking: function makeRanking(_ref17, tickets) {
      var dispatch = _ref17.dispatch,
          commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('changeLoading', true);
        if (tickets.length <= 0) {
          resolve(false);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').view({
          database: 'default',
          ddoc: 'tickets-by-id',
          view: 'tickets-by-id',
          keys: tickets.map(function (item) {
            return item._id;
          })
        }).then(function (docs) {
          var event = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_12__events__["a" /* default */].state.one);

          tickets = tickets.reduce(function (acc, curr, index) {
            if (index === 0) {
              acc = {};
            }
            delete curr._rev;
            acc[curr._id] = curr;
            return acc;
          }, {});

          docs = docs.rows.map(function (item) {
            return item.value;
          });

          docs = docs.map(function (ticket, index) {
            ticket = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, ticket, tickets[ticket._id]);
            if (index < event.numberOfRefigerators) {
              ticket.winner = true;
              ticket.eligible = true;
            } else {
              ticket.winner = false;
              ticket.eligible = true;
            }

            delete ticket.canceledAt;
            delete ticket.absentAt;
            delete ticket.survey;
            delete ticket.customer;
            delete ticket.event;
            delete ticket.stock;

            return ticket;
          });

          __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').collection('tickets')._updateBulkDocs(docs).then(function (response) {
            event.hasSortTRG_889 = true;
            event.drawn = true;
            dispatch('events/setEventDrawn', event, { root: true });
            resolve(true);
          }).catch(function (err) {
            console.log('err', err);
            resolve(false);
          });
        }).catch(function (err) {
          console.log('err', err);
          resolve(false);
        }).finally(function () {
          return commit('changeLoading', false);
        });
      });
    },
    ticketCancel: function ticketCancel(_ref18, _ref19) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;
      var tickets = _ref19.tickets,
          logs = _ref19.logs;

      commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').collection('tickets')._updateBulkDocs(tickets).then(function () {
        dispatch('resetAll');
        dispatch('fetchTicketsWithCustomersByEvent', {
          where: { surveyAssociated: true },
          eventId: tickets[0].eventId
        });
        dispatch('insertLogs', logs);
      }).catch(function (err) {
        return console.log('err updatetickets', err);
      }).finally(function () {
        commit('changeLoading', false);
      });
    },
    fetchAllDataFromTicketsByEvent: function fetchAllDataFromTicketsByEvent(_ref20, _ref21) {
      var commit = _ref20.commit,
          dispatch = _ref20.dispatch;
      var eventId = _ref21.eventId,
          options = _ref21.options;

      commit('changeLoading', true);
      var keys = { startKey: eventId, startIndex: 0, endKey: eventId, endIndex: 5 };
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('event-datas', 'event-datas', keys, {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0
      }).then(function (docs) {
        var tickets = [];
        var customers = [];
        var stocks = [];
        var lamps = [];

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs.rows), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var row = _step2.value;

            var doc = row.doc;
            if (!doc) {
              console.log(row);
              continue;
            }

            var key = row.key[1];
            if (key === 0) {
              dispatch('events/setEvent', doc, { root: true });
            } else if (key === 1) {
              tickets.push(doc);
            } else if (key === 2) {
              customers.push(doc);
            } else if (key === 3) {
              stocks.push(doc);
            } else if (key === 4) {
              lamps.push(doc);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (!options || options.lamps !== false) {
          dispatch('lamps/setStateAll', lamps, { root: true });
        }
        if (!options || options.customers !== false) {
          dispatch('customers/setStateAll', customers, { root: true });
        }
        if (!options || options.stocks !== false) {
          dispatch('stocks/setStateAll', stocks, { root: true });
        }

        commit('setAll', tickets);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        return commit('changeLoading', false);
      });
    },
    fetchTicketsWithCustomersByEvent: function fetchTicketsWithCustomersByEvent(_ref22, _ref23) {
      var commit = _ref22.commit,
          dispatch = _ref22.dispatch;
      var eventId = _ref23.eventId,
          where = _ref23.where;

      commit('changeLoading', true);
      var keys = { startKey: eventId, startIndex: 0, endKey: eventId, endIndex: 5 };
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('event-datas', 'event-datas', keys, {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0
      }).then(function (docs) {
        var event = {};
        var tickets = [];
        var customers = {};
        var customersList = [];
        var stocks = {};
        var stocksList = [];
        var lamps = [];

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs.rows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var row = _step3.value;

            var doc = row.doc;
            if (!doc) {
              console.log(row);
              continue;
            }
            var key = row.key[1];
            if (key === 0) {
              event = doc;
              dispatch('events/setEvent', event, { root: true });
            } else if (key === 1) {
              var valid = true;
              for (var field in where) {
                valid = valid && doc.hasOwnProperty(field) && doc[field] === where[field];
              }
              if (valid) {
                tickets.push(doc);
              }
            } else if (key === 2) {
              if (doc._id) {
                customers[doc._id] = doc;
                customersList.push(doc);
              }
            } else if (key === 3) {
              if (doc._id) {
                stocks[doc._id] = doc;
                stocksList.push(doc);
              }
            } else if (key === 4) {
              lamps.push(doc);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        dispatch('stocks/setStateAll', stocksList, { root: true });
        dispatch('customers/setStateAll', customersList, { root: true });

        tickets = tickets.map(function (ticket) {
          ticket.event = event;
          ticket.customer = customers[ticket.customerId];
          ticket.stock = ticket.stockId ? stocks[ticket.stockId] : ticket.stockId;
          return ticket;
        });

        commit('setAll', tickets);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        return commit('changeLoading', false);
      });
    },
    fetchTicketCustomerEvent: function fetchTicketCustomerEvent(_ref24, _ref25) {
      var commit = _ref24.commit,
          dispatch = _ref24.dispatch;
      var ticketId = _ref25.ticketId,
          where = _ref25.where;

      commit('changeLoading', true);
      var keys = { startKey: ticketId, startIndex: 0, endKey: ticketId, endIndex: 3 };
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].connection('default')._viewBetween('join-ticket-event-customer', 'join-ticket-event-customer', keys, {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0
      }).then(function (docs) {
        if (!docs.rows) {
          return;
        }

        var customers = [];
        var tickets = [];
        var stocks = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs.rows), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var data = _step4.value;

            if (data.key[1] === 0) {
              tickets.push(data.doc);
            } else if (data.key[1] === 1) {
              dispatch('events/setStateOne', data.doc, { root: true });
            } else if (data.key[1] === 2) {
              customers.push(data.doc);
            } else if (data.key[1] === 3) {
              stocks.push(data.doc);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (customers.length > 0) {
          dispatch('customers/setStateAll', customers, { root: true });
        }
        if (stocks.length > 0) {
          dispatch('stocks/setStateAll', stocks, { root: true });
        }

        commit('setOne', tickets[0]);
        commit('setAll', tickets);
        commit('changeLoading', false);
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getTicketsByEvent: function getTicketsByEvent(_ref26, payload) {
      var commit = _ref26.commit;

      commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].viewQueries({
        database: 'default',
        ddoc: 'tickets-by-eventId',
        view: 'tickets-by-eventId',
        queries: [{
          key: payload
        }]
      }).then(function (res) {
        var tickets = res[0].rows.map(function (item) {
          return item.value;
        });
        commit('setAll', tickets);
      }).catch(function (err) {
        console.log('getticketbyeventserror', err);
      }).finally(function () {
        commit('changeLoading', false);
      });
    },
    getTicketsByCustomer: function getTicketsByCustomer(_ref27, payload) {
      var commit = _ref27.commit;

      commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_8_src_services_Couchdb__["a" /* default */].viewQueries({
        database: 'default',
        ddoc: 'tickets-customer-id',
        view: 'tickets-customer-id',
        queries: [{
          key: payload
        }]
      }).then(function (res) {
        var tickets = res[0].rows.map(function (item) {
          return item.value;
        });
        commit('setAll', tickets);
      }).catch(function (err) {
        console.log('getticketbyeventserror', err);
      }).finally(function () {
        commit('changeLoading', false);
      });
    },
    dashboardTicketsByFilter: function dashboardTicketsByFilter(context, _ref28) {
      var eventsId = _ref28.eventsId,
          dateRange = _ref28.dateRange;

      context.commit('changeLoading', true);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_services_DashboardCounter_js__["d" /* dashboardCounter */])('tickets', eventsId, dateRange).then(function (result) {
        context.commit('SET_DASHBOARD_COUNTER', result);
        context.commit('changeLoading', false);
        return result;
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
        return err;
      });
    },
    dashboardWinnerTicketsByFilter: function dashboardWinnerTicketsByFilter(context, _ref29) {
      var eventsId = _ref29.eventsId,
          dateRange = _ref29.dateRange;

      context.commit('CHANGE_WINNING_LOADING', true);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_services_DashboardCounter_js__["d" /* dashboardCounter */])('winning-tickets', eventsId, dateRange).then(function (result) {
        context.commit('SET_WINNING_TICKETS', result);
        context.commit('CHANGE_WINNING_LOADING', false);
        return result;
      }).catch(function (err) {
        console.log(err);
        context.commit('CHANGE_WINNING_LOADING', false);
        return err;
      });
    },
    isWinnerTrgNewer: function isWinnerTrgNewer(context, _ref30) {
      var customer = _ref30.customer;

      return context.dispatch('fetchAll', {
        where: [{ customerId: customer.id }],
        limit: 10
      }).then(function (result) {
        var winner = result.find(function (ticket) {
          return ticket.winner;
        });

        return winner;
      });
    },
    checkWinnerOld: function checkWinnerOld(context, _ref31) {
      var config = _ref31.config,
          customer = _ref31.customer,
          winner = _ref31.winner;

      var uc = config.validationContemplatedCustomer.uc && winner ? customer.uc === winner.uc : false;

      var cpf = config.validationContemplatedCustomer.cpf && winner ? customer.cpf.replace(/\D/g, '') === winner.cpf : false;

      var validPeriod = false;
      if (winner && winner.exchangeDate !== '') {
        var period = parseInt(config.event.contemplatedPeriod);
        var currentYear = parseInt(new Date().getFullYear());
        var exchangedAt = parseInt(new Date(winner.exchangeDate).getFullYear());

        validPeriod = exchangedAt + period < currentYear;
      }

      return config.validationContemplatedCustomer.uc && config.validationContemplatedCustomer.cpf ? uc && cpf && !validPeriod : (uc || cpf) && !validPeriod;
    }
  }),
  getters: getters
});

/***/ }),

/***/ "V5Z/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V67u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){return _vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V9P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.currentTerms),function(company,index){return _c('div',{key:index},[_c('input',{attrs:{"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.value === company},on:{"input":function($event){return _vm.$emit('input', company)}}}),_vm._v(" "+_vm._s(company.toUpperCase())+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VEgf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VHO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRankingReport2_vue__ = __webpack_require__("ZgoG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da37904e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRankingReport2_vue__ = __webpack_require__("C14H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRankingReport2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da37904e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRankingReport2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VK8X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BtnUploadFileInput__ = __webpack_require__("ZCy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BtnTakePhotos__ = __webpack_require__("bjfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BtnTakePhotos: __WEBPACK_IMPORTED_MODULE_2__BtnTakePhotos__["a" /* default */],
    BtnUploadFileInput: __WEBPACK_IMPORTED_MODULE_1__BtnUploadFileInput__["a" /* default */]
  },

  data: function data() {
    return {
      showImageCapture: false,
      isLoadingFile: false,
      saving: false,
      selectedFiles: [],
      typeFiles: [],
      binaryFiles: [],
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tickets', { ticket: 'ticket' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('events', { event: 'event' }), {
    unableToSend: function unableToSend() {
      var blockByWinnerRanking = !this.ticket.winner && this.ticket.event.winnerChoiceMode === 'ranking';
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking;
    }
  })
});

/***/ }),

/***/ "VV8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('router-button',{attrs:{"title":"Novo","to":{name: 'categories.create'},"icon-class":"ti-plus","classStyle":{ btn: true, 'btn-flat': true, 'btn-icon': false, 'btn-info': true }}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('table-categories',{on:{"refresh":_vm.fetch}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketCard_vue__ = __webpack_require__("kKT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff63b86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketCard_vue__ = __webpack_require__("KIE3");
function injectStyle (ssrContext) {
  __webpack_require__("bK5Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fff63b86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff63b86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VsXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-actions"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[(_vm.$can('tickets.checkin'))?_c('div',{staticClass:"col-xs-12"},[_c('ticket-check-in',{attrs:{"ticket":_vm.ticket}})],1):_vm._e(),_vm._v(" "),(_vm.$can('tickets.uploadDoc'))?_c('div',{staticClass:"col-xs-12"},[_c('tickets-documentation')],1):_vm._e(),_vm._v(" "),(_vm.$can('tickets.uploadImg'))?_c('div',{staticClass:"col-xs-12"},[_c('tickets-upload-images')],1):_vm._e(),_vm._v(" "),(_vm.$can('tickets.downloadDoc'))?_c('div',{staticClass:"col-xs-12"},[_c('ticket-download-documents')],1):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-angle-double-right"}),_vm._v(" Ações")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vz2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermIasc',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return 'Maranhão';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética do Maranhão';
    },
    abbreviation: function abbreviation() {
      return 'CEMAR';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      };
    },
    cnpj: function cnpj() {
      return '06.272.793/0001-84';
    },
    numberState: function numberState() {
      return '06.105.848-3';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "W+ZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerImageCapture_vue__ = __webpack_require__("Z2d3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184340d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerImageCapture_vue__ = __webpack_require__("yeqe");
function injectStyle (ssrContext) {
  __webpack_require__("xCNv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerImageCapture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184340d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerImageCapture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W48Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc-energisa-pb',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {

    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Paraíba';
    },
    abbreviation: function abbreviation() {
      return 'Energisa';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 25',
        neighborhood: 'Cristo Redentor',
        city: 'João Pessoa',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '09.095.183/0001-40';
    },
    numberState: function numberState() {
      return '16.015.823-0';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "W5W7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_pages_Customers_CustomerImageCapture_vue__ = __webpack_require__("W+ZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_services_File__ = __webpack_require__("9N2k");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnTakePhotos',

  components: {
    CustomerImageCapture: __WEBPACK_IMPORTED_MODULE_7_src_pages_Customers_CustomerImageCapture_vue__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },

    event: {
      required: true,
      type: Object
    }
  },

  data: function data() {
    return {
      isLoadingFile: false,
      loading: false,
      showImageCapture: false,
      canTakeAnotherPhoto: true
    };
  },


  computed: {
    unableToSend: function unableToSend() {
      var blockByWinnerRanking = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking';
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tickets', ['setStateOne']), {
    showImage: function showImage() {
      this.showImageCapture = true;
    },
    handleSave: function handleSave(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, docId, date, newTicket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.unableToSend) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', _this.notifyUnable());

              case 2:

                _this.loading = true;
                _this.isLoadingFile = true;

                file = __WEBPACK_IMPORTED_MODULE_8_src_services_File__["a" /* default */].base64ToBinary(data.image);
                _context.next = 7;
                return _this.getIdDocument();

              case 7:
                docId = _context.sent;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(docId, {
                  mimeType: 'image/jpeg',
                  attachmentName: 'image-' + _this.generateNumber() + '.jpg',
                  attachment: file
                });

              case 10:
                date = new Date();
                newTicket = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.ticket, { documentedAt: date });


                delete newTicket.event;
                delete newTicket.stock;
                delete newTicket.customer;

                _context.prev = 15;
                _context.next = 18;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').updateWithView({
                  ddoc: 'tickets-by-id',
                  view: 'tickets-by-id',
                  payload: newTicket,
                  database: 'default'
                });

              case 18:

                _this.setStateOne(newTicket);
                _this.isLoadingFile = false;
                _this.showImageCapture = false;
                _this.notifySuccess();
                _this.showImageCapture = false;
                _this.canTakeAnotherPhoto = false;
                _this.$nextTick(function () {
                  _this.canTakeAnotherPhoto = true;
                });
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](15);

                console.log(_context.t0);

              case 30:

                _this.loading = false;

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[15, 27]]);
      }))();
    },
    getIdDocument: function getIdDocument() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var referenceDoc, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').view('docs-by-reference-id', 'docs-by-reference-id', _this2.ticket._id);

              case 2:
                referenceDoc = _context2.sent;


                referenceDoc = referenceDoc.rows[0] && referenceDoc.rows[0].value ? referenceDoc.rows[0].value : undefined;

                if (!referenceDoc) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', referenceDoc._id);

              case 6:
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('docs').insert({
                  'database': "trg_eqpi_notiasc_admin",
                  'referenceId': _this2.ticket._id,
                  'collection': 'docs'
                });

              case 8:
                doc = _context2.sent;
                return _context2.abrupt('return', doc.id);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    generateNumber: function generateNumber() {
      return Math.floor(Math.random() * 90000) + 10000;
    },
    notifyUnable: function notifyUnable() {
      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        text: 'N\xE3o \xE9 poss\xEDvel enviar documenta\xE7\xE3o para este cliente.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifySuccess: function notifySuccess() {
      this.$notify({
        message: 'Documentação salva com sucesso.',
        type: 'success'
      });
    }
  })
});

/***/ }),

/***/ "W5WU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("qAvE");
function injectStyle (ssrContext) {
  __webpack_require__("PGBT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WKyr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WPSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    'showGallery': false,
    'imagesGallery': [],
    'galleryIndex': 0
  },
  mutations: {
    SET_SHOW_GALLERY: function SET_SHOW_GALLERY(state, show) {
      state.showGallery = show;
    },
    SET_IMAGES_GALLERY: function SET_IMAGES_GALLERY(state, images) {
      state.imagesGallery = images;
    },
    SET_GALLERY_INDEX: function SET_GALLERY_INDEX(state, indx) {
      state.galleryIndex = indx;
    }
  },
  actions: {
    defineGallery: function defineGallery(context, _ref) {
      var show = _ref.show,
          images = _ref.images,
          index = _ref.index;

      context.commit('SET_SHOW_GALLERY', show);
      context.commit('SET_IMAGES_GALLERY', images);
      context.commit('SET_GALLERY_INDEX', index);
    }
  },
  getters: {
    'showGallery': function showGallery(state) {
      return state.showGallery;
    },
    'imagesGallery': function imagesGallery(state) {
      return state.imagesGallery;
    },
    'galleryIndex': function galleryIndex(state) {
      return state.galleryIndex;
    }
  }
});

/***/ }),

/***/ "WPqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountCards_vue__ = __webpack_require__("tokM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ccb3fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountCards_vue__ = __webpack_require__("C/fn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ccb3fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WSlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RemoveConfigurationsDuplicated',
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 10000,
      usersByName: {},
      usersById: {},
      rolesById: {},
      rolesByName: {}
    };
  },

  computed: {
    couchdbUsers: function couchdbUsers() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'users' });
    },
    couchdbases: function couchdbases() {
      return {
        customers: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' }),
        api: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'apis' }),
        categories: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'categories' }),
        manufacturers: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'manufacturers' }),
        project: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'project' }),
        roles: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'roles' }),
        tags: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'tags' }),
        docs: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'docs', collection: 'docs' }),
        states: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'states', collection: 'states' }),
        surveys: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'surveys', collection: 'surveys' }),
        surveys_docs: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'surveys_docs', collection: 'surveys' }),
        events: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' }),
        lamps: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' }),
        ranking: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'ranking' }),
        stocks: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'stocks' }),
        tickets: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' })
      };
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.isLoading = true;
                _this.total = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this.couchdbases).length * 10 + 1;
                _this.progress = 0;

                _context2.prev = 3;
                _context2.next = 6;
                return _this.getUsers();

              case 6:
                _context2.next = 8;
                return _this.getRoles();

              case 8:
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](3);

                console.log('could not get the users', _context2.t0);
                _this.finish();

              case 14:
                try {
                  __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                    title: 'Atenção',
                    text: 'Todos os documentos est\xE3o sendo processados nesse momento. Continuar?.',
                    type: 'warning',
                    confirmButtonText: 'Iniciar',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showCloseButton: true,
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return _this.exec();

                              case 2:
                                return _context.abrupt('return', 'ok');

                              case 3:
                              case 'end':
                                return _context.stop();
                            }
                          }
                        }, _callee, _this);
                      }));

                      return function preConfirm() {
                        return _ref.apply(this, arguments);
                      };
                    }()
                  }).then(function () {
                    setTimeout(function () {
                      location.reload();
                    }, 5000);
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                      title: 'Quase finalizando',
                      text: 'O processo está quase finalizando, aguarde o fim.',
                      type: 'info',
                      showConfirmButton: false
                    });
                  });
                } catch (e) {
                  console.log(e);
                }

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[3, 10]]);
      }))();
    },
    exec: function exec() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(resolve) {
                    var collection;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this2.changeRoleUsers();

                          case 2:
                            _context3.t0 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.keys(_this2.couchdbases);

                          case 3:
                            if ((_context3.t1 = _context3.t0()).done) {
                              _context3.next = 12;
                              break;
                            }

                            collection = _context3.t1.value;

                            console.log(collection);
                            _context3.next = 8;
                            return _this2.changingProcess(_this2.couchdbases[collection]);

                          case 8:
                            if (!(collection === 'customer')) {
                              _context3.next = 10;
                              break;
                            }

                            return _context3.abrupt('break', 12);

                          case 10:
                            _context3.next = 3;
                            break;

                          case 12:
                            _context3.next = 14;
                            return _this2.removeUsersAndRoles();

                          case 14:
                            console.log('end');
                            resolve(true);

                          case 16:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 2:
                a = _context4.sent;
                return _context4.abrupt('return', a);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    changingProcess: function changingProcess(couchdb) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(resolve) {
                    var results, datas, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, name;

                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return couchdb.limit(999999).get();

                          case 2:
                            results = _context5.sent;

                            if (results.length === 0) {
                              resolve(false);
                            }

                            datas = [];
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context5.prev = 8;
                            _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(results);

                          case 10:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                              _context5.next = 22;
                              break;
                            }

                            result = _step.value;

                            if (result.hasOwnProperty('userId')) {
                              _context5.next = 14;
                              break;
                            }

                            return _context5.abrupt('continue', 19);

                          case 14:
                            if (_this3.usersById.hasOwnProperty(result.userId)) {
                              _context5.next = 16;
                              break;
                            }

                            return _context5.abrupt('continue', 19);

                          case 16:
                            name = _this3.usersById[result.userId].name;

                            result.userId = _this3.usersByName[name][0]._id;
                            datas.push(result);

                          case 19:
                            _iteratorNormalCompletion = true;
                            _context5.next = 10;
                            break;

                          case 22:
                            _context5.next = 28;
                            break;

                          case 24:
                            _context5.prev = 24;
                            _context5.t0 = _context5['catch'](8);
                            _didIteratorError = true;
                            _iteratorError = _context5.t0;

                          case 28:
                            _context5.prev = 28;
                            _context5.prev = 29;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }

                          case 31:
                            _context5.prev = 31;

                            if (!_didIteratorError) {
                              _context5.next = 34;
                              break;
                            }

                            throw _iteratorError;

                          case 34:
                            return _context5.finish(31);

                          case 35:
                            return _context5.finish(28);

                          case 36:
                            _context5.next = 38;
                            return couchdb._postBulkDocs(datas);

                          case 38:
                            resolve(true);

                          case 39:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3, [[8, 24, 28, 36], [29,, 31, 35]]);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
                a = _context6.sent;
                return _context6.abrupt('return', a);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3);
      }))();
    },
    changeRoleUsers: function changeRoleUsers() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(resolve) {
          var datas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, user, name;

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  datas = [];
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context7.prev = 4;
                  _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this4.usersById));

                case 6:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context7.next = 20;
                    break;
                  }

                  user = _step2.value;

                  if (!(user.role === 'superadmin')) {
                    _context7.next = 10;
                    break;
                  }

                  return _context7.abrupt('continue', 17);

                case 10:
                  if (user.hasOwnProperty('role')) {
                    _context7.next = 12;
                    break;
                  }

                  return _context7.abrupt('continue', 17);

                case 12:
                  if (_this4.rolesById.hasOwnProperty(user.role)) {
                    _context7.next = 14;
                    break;
                  }

                  return _context7.abrupt('continue', 17);

                case 14:
                  name = _this4.usersById[user.userId].name;

                  user.userId = _this4.usersByName[name][0]._id;
                  datas.push(user);

                case 17:
                  _iteratorNormalCompletion2 = true;
                  _context7.next = 6;
                  break;

                case 20:
                  _context7.next = 26;
                  break;

                case 22:
                  _context7.prev = 22;
                  _context7.t0 = _context7['catch'](4);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context7.t0;

                case 26:
                  _context7.prev = 26;
                  _context7.prev = 27;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 29:
                  _context7.prev = 29;

                  if (!_didIteratorError2) {
                    _context7.next = 32;
                    break;
                  }

                  throw _iteratorError2;

                case 32:
                  return _context7.finish(29);

                case 33:
                  return _context7.finish(26);

                case 34:

                  _this4.couchdbUsers._postBulkDocs(datas);
                  resolve(true);

                case 36:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this4, [[4, 22, 26, 34], [27,, 29, 33]]);
        }));

        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    removeUsersAndRoles: function removeUsersAndRoles() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            console.log('users removing');
                            _context8.next = 3;
                            return _this5.remove(_this5.usersByName, _this5.couchdbUsers);

                          case 3:
                            console.log('roles removing');
                            _context8.next = 6;
                            return _this5.remove(_this5.rolesByName, _this5.couchdbases.roles);

                          case 6:
                            resolve(true);

                          case 7:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this5);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 2:
                a = _context9.sent;
                return _context9.abrupt('return', a);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this5);
      }))();
    },
    remove: function remove(obj, couch) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10(resolve) {
                    var name, i;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.t0 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.keys(obj);

                          case 1:
                            if ((_context10.t1 = _context10.t0()).done) {
                              _context10.next = 14;
                              break;
                            }

                            name = _context10.t1.value;

                            if (!(obj[name].length <= 1)) {
                              _context10.next = 5;
                              break;
                            }

                            return _context10.abrupt('continue', 1);

                          case 5:
                            i = 1;

                          case 6:
                            if (!(i < obj[name].length)) {
                              _context10.next = 12;
                              break;
                            }

                            _context10.next = 9;
                            return couch._delete(obj[name][i]._id);

                          case 9:
                            i++;
                            _context10.next = 6;
                            break;

                          case 12:
                            _context10.next = 1;
                            break;

                          case 14:
                            resolve(true);

                          case 15:
                          case 'end':
                            return _context10.stop();
                        }
                      }
                    }, _callee10, _this6);
                  }));

                  return function (_x5) {
                    return _ref6.apply(this, arguments);
                  };
                }());

              case 2:
                a = _context11.sent;
                return _context11.abrupt('return', a);

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this6);
      }))();
    },
    getUsers: function getUsers() {
      var _this7 = this;

      return this.couchdbUsers.limit(9999).get().then(function (result) {
        _this7.usersByName = result.reduce(function (accumulated, current) {
          if (!accumulated.hasOwnProperty(current.name)) {
            accumulated[current.name] = [];
          }
          accumulated[current.name].push(current);
          return accumulated;
        }, {});

        _this7.usersById = result.reduce(function (accumulated, current) {
          accumulated[current._id] = current;
          return accumulated;
        }, {});
      });
    },
    getRoles: function getRoles() {
      var _this8 = this;

      return this.couchdbases.roles.limit(9999).get().then(function (result) {
        _this8.rolesByName = result.reduce(function (accumulated, current) {
          if (!accumulated.hasOwnProperty(current.name)) {
            accumulated[current.name] = [];
          }
          accumulated[current.name].push(current);
          return accumulated;
        }, {});

        _this8.rolesById = result.reduce(function (accumulated, current) {
          accumulated[current._id] = current;
          return accumulated;
        }, {});
      });
    },
    notifyFinish: function notifyFinish() {
      this.total = 1;
      this.progress = 1;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todas as l\xE2mpadas foram atualizadas com seus respectivos ID dos eventos',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    finish: function finish() {
      this.isLoading = false;
      this.progress = this.total;
    }
  }
});

/***/ }),

/***/ "WV3u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WXMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('form',[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Status do evento")]),_vm._v(" "),_c('div',[_c('el-select',{staticClass:"select-primary",attrs:{"size":"xlarge","filterable":"","placeholder":"Selecione um status"},model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}},_vm._l((_vm.statusOptions),function(option){return _c('el-option',{key:option.value,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Município")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-primary",attrs:{"name":"city","filterable":"","size":"large","placeholder":"Selecione..."},model:{value:(_vm.model.city),callback:function ($$v) {_vm.$set(_vm.model, "city", $$v)},expression:"model.city"}},_vm._l((_vm.citiesOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('city'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Link do sorteio online")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.prizeLink),expression:"model.prizeLink"}],staticClass:"form-control",attrs:{"type":"text","name":"prizeLink"},domProps:{"value":(_vm.model.prizeLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "prizeLink", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Referência")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.reference),expression:"model.reference"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.reference),expression:"modelValidations.reference"}],staticClass:"form-control",attrs:{"type":"text","name":"reference","placeholder":"Ex: Praia de Iracema - Março/2018"},domProps:{"value":(_vm.model.reference)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "reference", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.reference.invalid),expression:"reference.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('reference'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data de Início")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.startDate),expression:"modelValidations.startDate"}],attrs:{"type":"date","placeholder":"Escolha uma data","format":"dd/MM/yyyy","clearable":false,"editable":false},model:{value:(_vm.model.startDate),callback:function ($$v) {_vm.$set(_vm.model, "startDate", $$v)},expression:"model.startDate"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.startDate.invalid),expression:"startDate.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('startDate'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data Fim")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.endDate),expression:"modelValidations.endDate"}],attrs:{"name":"endDate","type":"datetime","placeholder":"Escolha uma data","format":"dd/MM/yyyy HH:mm","clearable":false,"editable":false},model:{value:(_vm.model.endDate),callback:function ($$v) {_vm.$set(_vm.model, "endDate", $$v)},expression:"model.endDate"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.endDate.invalid),expression:"endDate.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('endDate'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data e hora da cerimônia")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.dateTimeCeremony),expression:"modelValidations.dateTimeCeremony"}],attrs:{"name":"dateTimeCeremony","type":"datetime","placeholder":"Escolha uma data","format":"dd/MM/yyyy HH:mm","clearable":false,"editable":false},model:{value:(_vm.model.dateTimeCeremony),callback:function ($$v) {_vm.$set(_vm.model, "dateTimeCeremony", $$v)},expression:"model.dateTimeCeremony"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateTimeCeremony.invalid),expression:"dateTimeCeremony.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('dateTimeCeremony'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data e hora da entrega das geladeiras")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.dateTimeDelivery),expression:"modelValidations.dateTimeDelivery"}],attrs:{"name":"dateTimeDelivery","type":"datetime","placeholder":"Escolha uma data","format":"dd/MM/yyyy HH:mm","clearable":false,"editable":false},model:{value:(_vm.model.dateTimeDelivery),callback:function ($$v) {_vm.$set(_vm.model, "dateTimeDelivery", $$v)},expression:"model.dateTimeDelivery"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"1em","margin-right":"1em"}},[_vm._v("às")]),_vm._v(" "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.timeEndDelivery),expression:"modelValidations.timeEndDelivery"}],attrs:{"name":"timeEndDelivery","picker-options":{ start: '06:00', step: '00:30', end: '23:59' },"placeholder":"Selecione a hóra de término da entrega","clearable":false,"editable":false},model:{value:(_vm.model.timeEndDelivery),callback:function ($$v) {_vm.$set(_vm.model, "timeEndDelivery", $$v)},expression:"model.timeEndDelivery"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateTimeDelivery.invalid),expression:"dateTimeDelivery.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('dateTimeDelivery'))+"\n            ")])])]),_vm._v(" "),(_vm.config.registerCustomerTicketDocument)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"form-deliveryAddress"}},[_vm._v("Endereço de entrega da geladeira")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.deliveryAddress),expression:"model.deliveryAddress"}],staticClass:"form-control",attrs:{"id":"form-deliveryAddress","type":"text"},domProps:{"value":(_vm.model.deliveryAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "deliveryAddress", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Este endereço será exibido no documento de cadastro do cliente.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"form-numberOfRefigerators"}},[_vm._v("Quantidade de geladeiras")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.numberOfRefigerators),expression:"modelValidations.numberOfRefigerators"},{name:"model",rawName:"v-model",value:(_vm.model.numberOfRefigerators),expression:"model.numberOfRefigerators"}],staticClass:"form-control",attrs:{"id":"form-numberOfRefigerators","type":"number","min":"0","name":"numberOfRefigerators","readonly":_vm.model.drawn},domProps:{"value":(_vm.model.numberOfRefigerators)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numberOfRefigerators", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfRefigerators.invalid),expression:"numberOfRefigerators.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('numberOfRefigerators'))+"\n          ")]),_vm._v(" "),(_vm.model.drawn)?_c('small',{staticClass:"text-info"},[_vm._v("\n            Sorteio já realizado, não é possível alterar a quantidade de geladeiras.\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.directList),callback:function ($$v) {_vm.$set(_vm.model, "directList", $$v)},expression:"model.directList"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.energyDefaultWinner),callback:function ($$v) {_vm.$set(_vm.model, "energyDefaultWinner", $$v)},expression:"model.energyDefaultWinner"}})],1),_vm._v(" "),(_vm.haveSurveys)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Como será efetuada a escolha do cliente ganhador?")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.winnerChoiceMode),expression:"model.winnerChoiceMode"}],attrs:{"type":"radio","id":"event-radio-winner-lottery","value":"lottery"},domProps:{"checked":_vm._q(_vm.model.winnerChoiceMode,"lottery")},on:{"change":function($event){return _vm.$set(_vm.model, "winnerChoiceMode", "lottery")}}}),_vm._v(" "),_c('label',{attrs:{"for":"event-radio-winner-lottery"}},[_vm._v("Sorteio")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.winnerChoiceMode),expression:"model.winnerChoiceMode"}],attrs:{"type":"radio","id":"event-radio-winner-ranking","value":"ranking"},domProps:{"checked":_vm._q(_vm.model.winnerChoiceMode,"ranking")},on:{"change":function($event){return _vm.$set(_vm.model, "winnerChoiceMode", "ranking")}}}),_vm._v(" "),_c('label',{attrs:{"for":"event-radio-winner-ranking"}},[_vm._v("Ranking")])])]):_vm._e(),_vm._v(" "),(_vm.model.winnerChoiceMode === 'ranking')?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_vm._l((Object.keys(_vm.surveysOptions)),function(value,iterator){return _c('div',{key:iterator,staticClass:"col-xs-12 col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.surveysType),expression:"model.surveysType"}],attrs:{"type":"checkbox","id":("su-" + value),"disabled":value === 'refrigerator'},domProps:{"value":value,"checked":Array.isArray(_vm.model.surveysType)?_vm._i(_vm.model.surveysType,value)>-1:(_vm.model.surveysType)},on:{"change":function($event){var $$a=_vm.model.surveysType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "surveysType", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "surveysType", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "surveysType", $$c)}}}}),_vm._v("\n            "+_vm._s(_vm.surveysOptions[value])+"\n          ")])}),_vm._v(" "),_vm._m(3)],2):_vm._e(),_vm._v(" "),(_vm.config.event.managedCsv)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Os clientes serão registrados através de um CSV?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.registerCustomerByCsv),callback:function ($$v) {_vm.$set(_vm.model, "registerCustomerByCsv", $$v)},expression:"model.registerCustomerByCsv"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Habilitar confirmar ganhadores através de um CSV?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.confirmCustomerByCsv),callback:function ($$v) {_vm.$set(_vm.model, "confirmCustomerByCsv", $$v)},expression:"model.confirmCustomerByCsv"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Habilitar download do CSV dos ganhadores?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.downloadWinnersCsv),callback:function ($$v) {_vm.$set(_vm.model, "downloadWinnersCsv", $$v)},expression:"model.downloadWinnersCsv"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Habilitar download do PPT dos ganhadores?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.model.downloadWinnersPpt),callback:function ($$v) {_vm.$set(_vm.model, "downloadWinnersPpt", $$v)},expression:"model.downloadWinnersPpt"}})],1)])]):_vm._e()]),_vm._v(" "),_c('LampEventConfigFormConmponent'),_vm._v(" "),_c('DocumentsEventFormComponents',{attrs:{"current-terms":_vm.termsOfState,"current-state":_vm.config.state}}),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[(_vm.$can('events.create|events.edit'))?_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.saving,"type":"button"},on:{"click":function($event){return _vm.handleSave()}}},[_vm._v("Salvar\n        ")]):_vm._e()])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n            Os\n            "),_c('strong',[_vm._v("ganhadores")]),_vm._v(" são definidos através de uma\n            "),_c('strong',[_vm._v("lista")]),_vm._v("?\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n            Os clientes marcados para "),_c('strong',[_vm._v("medição ganharão geladeira")]),_vm._v(" automaticamente?\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("\n              Que tipo de pesquisas serão efetuadas neste projeto?\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('small',{staticClass:"help-block"},[_vm._v("\n              Observação: Refrigerador é obrigatória.\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "We3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-enel',

  props: {
    payload: {
      required: true,
      type: Object
    },
    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: '',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    }
  }),

  mounted: function mounted() {
    this.resetOne();
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      this.payload = JSON.parse(localStorage.getItem('LampsTmpTemp'));
      console.log(this.payload.customer);
      console.log(this.payload.customer.address);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "Wex7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-term"},[(_vm.companyTerms === 'generic')?_c('DeliveryTermGeneric',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'CE' && _vm.companyTerms === 'enel')?_c('DeliveryTermEnelCe',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'GO' && _vm.companyTerms === 'enel')?_c('DeliveryTermEnelGo',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'MA' && _vm.companyTerms === 'cemar')?_c('DeliveryTermCemar',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'MA' && _vm.companyTerms === 'iasc')?_c('DeliveryTermIascMa',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PI' && _vm.companyTerms === 'iasc')?_c('DeliveryTermIascPi',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PI' && _vm.companyTerms === 'equatorial')?_c('DeliveryTermEquatorialPi',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PB' && _vm.companyTerms === 'energisa-paraiba')?_c('delivery-term-energisa-pb',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PB' && _vm.companyTerms === 'energisa-borborema')?_c('DeliveryTermEnergisaBorboremaPb',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PA' && _vm.companyTerms === 'celpa')?_c('DeliveryTermCelpa',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):(("" + _vm.state) === 'PA' && _vm.companyTerms === 'celpa-jurunas')?_c('DeliveryTermCelpaJurunas',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}}):_c('DeliveryTermIascAl',{attrs:{"customer":_vm.customer,"stock":_vm.stock,"ticket":_vm.ticket,"config":_vm.config,"dateTimeDelivery":_vm.dateTimeDelivery,"manufacturer":_vm.manufacturer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WrSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnergisaBorboremaPb_vue__ = __webpack_require__("4Jf+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed07d1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnergisaBorboremaPb_vue__ = __webpack_require__("DF1m");
function injectStyle (ssrContext) {
  __webpack_require__("DpVz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ed07d1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnergisaBorboremaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed07d1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnergisaBorboremaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ws9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"row-class-name":_vm.tableRowClassName,"data":_vm.tableData}},[_c('el-table-column',{staticClass:"success",attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{staticClass:"danger",attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{staticClass:"info",attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Striped table")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Table on Plain Background")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Regular Table with Colors")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WsnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Imagens do sistema")]),_vm._v(" "),_c('div',{staticClass:"row text-center",staticStyle:{"padding":"20px 30px 20px 30px"}},[_c('p',[_vm._v("Imagens devem ter fundo transparente. Formatos: .png ou .svg")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Logotipo no termo de lâmpada")]),_vm._v(" "),(_vm.config.hasOwnProperty('_attachments') && _vm.config._attachments.hasOwnProperty('imgTermLamp'))?_c('img',{attrs:{"id":"img_imgTermLamp","src":_vm.urlImages.imgTermLamp}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill",attrs:{"disabled":_vm.loadingImages},on:{"click":function($event){return _vm.$refs['imgTermLamp'].click()}}},[_vm._v("Selecionar imagem\n      ")]),_vm._v(" "),_c('input',{ref:"imgTermLamp",staticStyle:{"display":"none"},attrs:{"id":"imgTermLamp","type":"file","accept":"image/*"},on:{"change":_vm.getFiles}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Logotipo no termo de comodato")]),_vm._v(" "),(_vm.config.hasOwnProperty('_attachments') && _vm.config._attachments.hasOwnProperty('imgTermLending'))?_c('img',{attrs:{"id":"img_imgTermLending","src":_vm.urlImages.imgTermLending}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill",attrs:{"disabled":_vm.loadingImages},on:{"click":function($event){return _vm.$refs['imgTermLending'].click()}}},[_vm._v("Selecionar imagem\n      ")]),_vm._v(" "),_c('input',{ref:"imgTermLending",staticStyle:{"display":"none"},attrs:{"id":"imgTermLending","type":"file","accept":"image/*"},on:{"change":_vm.getFiles}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Logotipo no protocolo de entrega")]),_vm._v(" "),(_vm.config.hasOwnProperty('_attachments') && _vm.config._attachments.hasOwnProperty('imgTermDelivery'))?_c('img',{attrs:{"id":"img_imgTermDelivery","src":_vm.urlImages.imgTermDelivery}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill",attrs:{"disabled":_vm.loadingImages},on:{"click":function($event){return _vm.$refs['imgTermDelivery'].click()}}},[_vm._v("Selecionar imagem\n      ")]),_vm._v(" "),_c('input',{ref:"imgTermDelivery",staticStyle:{"display":"none"},attrs:{"id":"imgTermDelivery","type":"file","accept":"image/*"},on:{"change":_vm.getFiles}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"50px"}},[_c('p',{staticClass:"category"},[_vm._v("Logotipos no apresentador")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":"/static/img/project-form/presenter-orientation-img.svg","alt":"Image left"}}),_vm._v(" "),(_vm.config.hasOwnProperty('_attachments') && _vm.config._attachments.hasOwnProperty('imgPresenterLeft'))?_c('img',{attrs:{"id":"img_imgPresenterLeft","src":_vm.urlImages.imgPresenterLeft}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill",attrs:{"disabled":_vm.loadingImages},on:{"click":function($event){return _vm.$refs['imgPresenterLeft'].click()}}},[_vm._v("Selecionar imagem\n          ")]),_vm._v(" "),_c('input',{ref:"imgPresenterLeft",staticStyle:{"display":"none"},attrs:{"id":"imgPresenterLeft","type":"file","accept":"image/*"},on:{"change":_vm.getFiles}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.config.hasOwnProperty('_attachments') && _vm.config._attachments.hasOwnProperty('imgPresenterRight'))?_c('img',{attrs:{"id":"img_imgPresenterRight","src":_vm.urlImages.imgPresenterRight}}):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"transform":"rotateY(180deg)"},attrs:{"src":"/static/img/project-form/presenter-orientation-img.svg","alt":"Image left"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill",attrs:{"disabled":_vm.loadingImages},on:{"click":function($event){return _vm.$refs['imgPresenterRight'].click()}}},[_vm._v("\n            Selecionar imagem\n          ")]),_vm._v(" "),_c('input',{ref:"imgPresenterRight",staticStyle:{"display":"none"},attrs:{"id":"imgPresenterRight","type":"file","accept":"image/*"},on:{"change":_vm.getFiles}})])])])]),_vm._v(" "),_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":"canvasPlace"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WuZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_connections__ = __webpack_require__("ZKT5");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocumentsTicketCard',
  props: ['ticketId'],
  mounted: function mounted() {
    var _this = this;

    this.fetchDocs({ where: { referenceId: this.ticketId, collection: { $exists: true } }, limit: 9999 }).then(function (res) {
      _this.docs = res;
    });
  },
  data: function data() {
    return {
      docs: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('docs', ['loading'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('docs', { fetchDocs: 'fetchAll' }), {
    getHref: function getHref(id, att) {
      return __WEBPACK_IMPORTED_MODULE_2__config_connections__["a" /* default */]['docs'].host + '/' + __WEBPACK_IMPORTED_MODULE_2__config_connections__["a" /* default */]['docs'].db + '/' + id + '/' + att;
    }
  })
});

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X/gF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X/xm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Categories_FormCategories_vue__ = __webpack_require__("AGjN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_ConfigurationsPages_Categories_ShowCategories_vue__ = __webpack_require__("xoRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_ConfigurationsPages_Categories_Index_vue__ = __webpack_require__("P9dB");




var path = 'categories';
var meta = {
  title: 'Categorias',
  requireAuth: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/' + path,
  component: __WEBPACK_IMPORTED_MODULE_2_src_pages_ConfigurationsPages_Categories_Index_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_ConfigurationsPages_Categories_ShowCategories_vue__["a" /* default */],
    meta: meta
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Categories_FormCategories_vue__["a" /* default */],
    meta: meta
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Categories_FormCategories_vue__["a" /* default */],
    meta: meta
  }, {
    path: 'remove/:id',
    name: path + '.remove',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Categories_FormCategories_vue__["a" /* default */],
    meta: meta
  }]
});

/***/ }),

/***/ "X4HA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('vue-csv-import',{attrs:{"map-fields":_vm.mapFields},scopedSlots:_vm._u([{key:"hasHeaders",fn:function(ref){
var headers = ref.headers;
var toggle = ref.toggle;
return [_c('label',[_c('input',{attrs:{"type":"checkbox","id":"hasHeaders"},domProps:{"value":headers},on:{"change":toggle}}),_vm._v("\n        O arquivo tem cabeçalhos?\n      ")])]}},{key:"next",fn:function(ref){
var load = ref.load;
return [_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",on:{"click":function($event){$event.preventDefault();return load($event)}}},[_vm._v("\n        Carregar arquivo\n      ")])]}}]),model:{value:(_vm.customers),callback:function ($$v) {_vm.customers=$$v},expression:"customers"}},[_vm._v(" "),_c('template',{slot:"thead"},[_c('tr',[_c('th',[_vm._v("Campo")]),_vm._v(" "),_c('th',[_vm._v("Referência no arquivo")])])])],2),_vm._v(" "),(_vm.customers.length)?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",on:{"click":function($event){return _vm.handleImport()}}},[_vm._v("\n    Confirmar Tickets\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YesNoRadio__ = __webpack_require__("bkdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Project_RadioCompaniesDocuments__ = __webpack_require__("nw7T");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocumentsEventFormComponents',
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_2_components_UIComponents_Switch_vue__["a" /* default */],
    YesNoRadio: __WEBPACK_IMPORTED_MODULE_3__YesNoRadio__["a" /* default */],
    RadioCompaniesDocuments: __WEBPACK_IMPORTED_MODULE_4__Project_RadioCompaniesDocuments__["a" /* default */]
  },
  props: {
    currentState: {
      type: String,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['currentTerms', 'project']), {
    event: {
      get: function get() {
        return this.$store.state.events.one;
      }
    }
  })
});

/***/ }),

/***/ "XIFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XK9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete,"on-validate":_vm.handleValidation}},[_c('h4',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Dados Iniciais","before-change":_vm.validateInitialDataForm,"icon":"ti-clipboard"}},[_c('initial-data-form',{ref:"initialData"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Dados Pessoais","before-change":_vm.validatePersonalDataForm,"icon":"ti-settings"}},[_c('personal-data-form',{ref:"personalData"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Dados de Endereço","before-change":_vm.validatePersonalDataForm,"icon":"ti-map-alt"}},[_c('AddressForm',{ref:"addressData"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Conclusão","icon":"ti-check"}},[_c('h5',{staticClass:"text-center"},[_vm._v("Cliente cadastrado com sucesso! Escolha uma das opções abaixo.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('router-link',{attrs:{"to":_vm.ticketsRoute}},[(_vm.$can('customers.tickets'))?_c('button',{staticClass:"btn btn-lg btn-fill btn-primary",attrs:{"disabled":!_vm.enableActionButtons}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v(" Gerar Ticket\n                  ")]):_vm._e()]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.lampsRoute}},[(_vm.$can('customers.lamps'))?_c('button',{staticClass:"btn btn-lg btn-fill btn-success",attrs:{"disabled":!_vm.enableActionButtons}},[_c('i',{staticClass:"fa fa-lightbulb-o"}),_vm._v(" Trocar Lâmpadas\n                  ")]):_vm._e()])],1)])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Anterior\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next","disabled":_vm.saving},slot:"next"},[_vm._v("Próximo\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finalizar\n          ")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XLuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lending-term-go",staticStyle:{"margin":"0.5cm"}},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":"/static/img/enel-compartilha-logo.gif","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.company)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.address)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cpnj)+" e Inscrição Estadual no. "+_vm._s(_vm.stateRegistration)+", doravante denominada "+_vm._s(_vm.shortname)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", Ceará, UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.config.name)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.config.name)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XSiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__ = __webpack_require__("enEw");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChangeEventsTagNameToTagId',
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      events: [],
      tags: {}
    };
  },

  computed: {
    couchdbEvents: function couchdbEvents() {
      return new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
    },
    couchdbTags: function couchdbTags() {
      return new __WEBPACK_IMPORTED_MODULE_4_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'tags' });
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _this.total = 0;
                _this.progress = 0;
                _context.prev = 3;
                _context.next = 6;
                return _this.getEvents();

              case 6:
                _this.events = _context.sent;
                _context.next = 9;
                return _this.getTags();

              case 9:
                _this.tags = _context.sent;

                _this.total = _this.events.length;
                _this.isLoading = false;

                if (!(_this.total === 0)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt('return', _this.notifyFinish());

              case 14:
                _this.notifyAmount().then(function () {
                  return _this.exec().then(function () {
                    _this.notifyFinish();
                  }).catch(function (e) {
                    return console.log('Falha no processo', e);
                  });
                });
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.isLoading = false;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 17]]);
      }))();
    },
    exec: function exec() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var eventIterator, event;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this2.events);

              case 1:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 10;
                  break;
                }

                eventIterator = _context2.t1.value;
                event = _this2.events[eventIterator];

                event.tags = _this2.setTagIds(event.tags);
                _this2.events[eventIterator] = event;
                _this2.progress++;
                return _context2.abrupt('break', 10);

              case 10:
                _this2.couchdbEvents._postBulkDocs(_this2.events);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    notifyAmount: function notifyAmount() {
      return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Eventos',
        html: 'As tags ser\xE3o modificadas em ' + this.total + ' eventos. Deseja continuar?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, pode modificar!',
        cancelButtonText: 'Não, cancele isso!',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      this.total = 1;
      this.progress = 1;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todas os eventos foram modificados',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    getEvents: function getEvents() {
      return this.couchdbEvents.where('tags', { '$exists': true }).get();
    },
    getTags: function getTags() {
      return this.couchdbTags.select(['_id', 'name']).get().then(function (result) {
        return result.reduce(function (accumulated, currentValue) {
          if (!accumulated.hasOwnProperty(currentValue.name)) {
            accumulated[currentValue.name.toLowerCase()] = currentValue._id;
          }
          return accumulated;
        }, {});
      });
    },
    setTagIds: function setTagIds(tags) {
      var idTags = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          if (!this.tags.hasOwnProperty(tag.toLowerCase())) {
            continue;
          }
          idTags.push(this.tags[tag.toLowerCase()]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return idTags.length > 0 ? idTags : tags;
    }
  }
});

/***/ }),

/***/ "XVkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permissions-index"},[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.roles,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"label","label":"Perfil","sortable":"","min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":{name: 'roles.edit', params: {id: props.row._id}}}},[(_vm.$can('roles.edit'))?_c('a',{staticClass:"btn btn-primary btn-fill btn-icon edit",attrs:{"title":"Editar permissão"}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e()]),_vm._v(" "),(_vm.canBeDeleted(props.row.name) && _vm.$can('roles.remove'))?_c('a',{staticClass:"btn btn-danger btn-fill btn-icon remove",attrs:{"title":"Remover permissão"},on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    }
  }
});

/***/ }),

/***/ "XaJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateTicketsWinnersToWinnersDb_vue__ = __webpack_require__("mj2F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3b0faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateTicketsWinnersToWinnersDb_vue__ = __webpack_require__("4Aiz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateTicketsWinnersToWinnersDb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3b0faa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateTicketsWinnersToWinnersDb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XkR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_EventsSpecifications_EventsSpecifications__ = __webpack_require__("hjzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_EventsSpecifications_IndexEventsSpecifications__ = __webpack_require__("lPRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_EventsSpecifications_FormEventsSpecifications__ = __webpack_require__("FQz8");




var path = 'eventsSpecifications';
var title = 'Especificações dos Eventos';
/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0__pages_EventsSpecifications_EventsSpecifications__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_EventsSpecifications_IndexEventsSpecifications__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_EventsSpecifications_FormEventsSpecifications__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_EventsSpecifications_FormEventsSpecifications__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "XknI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('span',[_c('strong',[_vm._v("Atenção!")]),_vm._v(" "+_vm._s(_vm.alertText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XuXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-view-general"},[(_vm.hasEvent)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Evento")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.event && _vm.survey.event.name ? _vm.survey.event.name : '-'))]),_vm._v(" "),_c('dt',[_vm._v("Pesquisador")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.user && _vm.survey.user.name ? _vm.survey.user.name : '-'))]),_vm._v(" "),_c('dt',[_vm._v("Duração da pesquisa")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.duration ? _vm.survey.duration : '-'))]),_vm._v(" "),_c('dt',[_vm._v("GPS")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.gps && _vm.survey.gps.latitude ? _vm.survey.gps.latitude : '-')+", "+_vm._s(_vm.survey.gps && _vm.survey.gps.longitude ? _vm.survey.gps.longitude : '-'))]),_vm._v(" "),_c('dt',[_vm._v("Alerta")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.alert && _vm.survey.alert.toString() === "true" ? 'Sim' : 'Não'))]),_vm._v(" "),_c('dt',[_vm._v("Observação")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.observation ? _vm.survey.observation : '-'))]),_vm._v(" "),_c('dt',[_vm._v("Aceitou participar?")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data && _vm.survey.data.accepted && _vm.survey.data.accepted.toString() === 'true' ? 'Sim' : 'Não'))]),_vm._v(" "),(_vm.survey.data && _vm.survey.data.accepted && _vm.survey.data.accepted.toString() === 'false')?_c('dt',[_vm._v(" Motivo não participar ")]):_vm._e(),_vm._v(" "),(_vm.survey.data && _vm.survey.data.accepted && _vm.survey.data.accepted.toString() === 'false')?_c('dd',[_vm._v(_vm._s(_vm.survey.data.reasonNotAccepted ? _vm.survey.data.reasonNotAccepted : '-'))]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v("Ausente?")]),_vm._v(" "),_c('dd',[_vm._v(" "+_vm._s(_vm.survey.data && _vm.survey.data.absent && _vm.survey.data.absent.toString() === 'true' ? 'Sim' : 'Não')+" ")]),_vm._v(" "),(_vm.survey.data && _vm.survey.data.absent && _vm.survey.data.absent.toString() === 'false')?_c('dt',[_vm._v(" Motivo ausente ")]):_vm._e(),_vm._v(" "),(_vm.survey.data && _vm.survey.data.absent && _vm.survey.data.absent.toString() === 'false')?_c('dd',[_vm._v(" "+_vm._s(_vm.survey.data.reasonNotPresent ? _vm.survey.data.reasonNotPresent : '-')+" ")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xuv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_EventsOptions_vue__ = __webpack_require__("oVfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RemoveAllAboutAnEvent',
  components: {
    EventsOptions: __WEBPACK_IMPORTED_MODULE_5_src_components_EventsOptions_vue__["a" /* default */]
  },

  data: function data() {
    return {
      eventSelectedId: '',
      forceDelete: false,
      isLoading: false
    };
  },

  computed: {
    eventDb: function eventDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
    },
    customerDb: function customerDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },
    ticketDb: function ticketDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },
    lampDb: function lampDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },
    stockDb: function stockDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'stocks' });
    },
    docDb: function docDb() {
      return new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'docs', collection: 'docs' });
    }
  },

  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Removendo Tickets',
                  message: 'Aguarde',
                  type: 'info',
                  confirmButtonText: 'Remover',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  showCloseButton: true,
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this.deleteTickets();

                            case 2:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function preConfirm() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                            title: 'Removendo Docs',
                            message: 'Aguarde',
                            type: 'info',
                            confirmButtonText: 'Remover',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showCloseButton: true,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true,
                            preConfirm: function () {
                              var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.next = 2;
                                        return _this.deleteDocs();

                                      case 2:
                                      case 'end':
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, _this);
                              }));

                              return function preConfirm() {
                                return _ref3.apply(this, arguments);
                              };
                            }()
                          }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
                            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    _context8.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                      title: 'Removendo lamps',
                                      message: 'Aguarde',
                                      type: 'info',
                                      confirmButtonText: 'Remover',
                                      allowOutsideClick: false,
                                      allowEscapeKey: false,
                                      allowEnterKey: false,
                                      showCloseButton: true,
                                      showConfirmButton: true,
                                      showLoaderOnConfirm: true,
                                      preConfirm: function () {
                                        var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                                          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                                            while (1) {
                                              switch (_context3.prev = _context3.next) {
                                                case 0:
                                                  _context3.next = 2;
                                                  return _this.deleteLamps();

                                                case 2:
                                                case 'end':
                                                  return _context3.stop();
                                              }
                                            }
                                          }, _callee3, _this);
                                        }));

                                        return function preConfirm() {
                                          return _ref5.apply(this, arguments);
                                        };
                                      }()
                                    }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
                                      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                                        while (1) {
                                          switch (_context7.prev = _context7.next) {
                                            case 0:
                                              _context7.next = 2;
                                              return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                                title: 'Removendo stocks',
                                                message: 'Aguarde',
                                                type: 'info',
                                                confirmButtonText: 'Remover',
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                                allowEnterKey: false,
                                                showCloseButton: true,
                                                showConfirmButton: true,
                                                showLoaderOnConfirm: true,
                                                preConfirm: function () {
                                                  var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                                                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                                      while (1) {
                                                        switch (_context4.prev = _context4.next) {
                                                          case 0:
                                                            _context4.next = 2;
                                                            return _this.deleteStocks();

                                                          case 2:
                                                          case 'end':
                                                            return _context4.stop();
                                                        }
                                                      }
                                                    }, _callee4, _this);
                                                  }));

                                                  return function preConfirm() {
                                                    return _ref7.apply(this, arguments);
                                                  };
                                                }()
                                              }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
                                                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                                  while (1) {
                                                    switch (_context6.prev = _context6.next) {
                                                      case 0:
                                                        _context6.next = 2;
                                                        return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                                                          title: 'Removendo Evento',
                                                          message: 'Aguarde',
                                                          type: 'info',
                                                          confirmButtonText: 'Remover',
                                                          allowOutsideClick: false,
                                                          allowEscapeKey: false,
                                                          allowEnterKey: false,
                                                          showCloseButton: true,
                                                          showConfirmButton: true,
                                                          showLoaderOnConfirm: true,
                                                          preConfirm: function () {
                                                            var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
                                                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                                                while (1) {
                                                                  switch (_context5.prev = _context5.next) {
                                                                    case 0:
                                                                      _context5.next = 2;
                                                                      return _this.deleteEvents();

                                                                    case 2:
                                                                    case 'end':
                                                                      return _context5.stop();
                                                                  }
                                                                }
                                                              }, _callee5, _this);
                                                            }));

                                                            return function preConfirm() {
                                                              return _ref9.apply(this, arguments);
                                                            };
                                                          }()
                                                        });

                                                      case 2:
                                                      case 'end':
                                                        return _context6.stop();
                                                    }
                                                  }
                                                }, _callee6, _this);
                                              })));

                                            case 2:
                                            case 'end':
                                              return _context7.stop();
                                          }
                                        }
                                      }, _callee7, _this);
                                    })));

                                  case 2:
                                  case 'end':
                                    return _context8.stop();
                                }
                              }
                            }, _callee8, _this);
                          })));

                        case 2:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this);
                })));

              case 2:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this);
      }))();
    },
    deleteEvents: function deleteEvents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this2.eventDb.find(_this2.eventSelectedId);

              case 2:
                event = _context11.sent;

                event.deletedAt = new Date();

                if (!_this2.forceDelete) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 7;
                return _this2.eventDb.delete(event._id, true);

              case 7:
                return _context11.abrupt('return');

              case 8:
                _context11.next = 10;
                return _this2.eventDb.upsert(event._id, event);

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this2);
      }))();
    },
    deleteData: function deleteData(couchdb) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var data, deleteData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!_this3.forceDelete) {
                  _context12.next = 6;
                  break;
                }

                _context12.next = 3;
                return couchdb.where('eventId', _this3.eventSelectedId).withTrash().get();

              case 3:
                _context12.t0 = _context12.sent;
                _context12.next = 9;
                break;

              case 6:
                _context12.next = 8;
                return couchdb.where('eventId', _this3.eventSelectedId).get();

              case 8:
                _context12.t0 = _context12.sent;

              case 9:
                data = _context12.t0;

                if (!_this3.forceDelete) {
                  _context12.next = 15;
                  break;
                }

                deleteData = data.map(function (item) {
                  return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    _id: item._id,
                    _rev: item._rev,
                    _deleted: true
                  }));
                });
                _context12.next = 14;
                return couchdb._updateBulkDocs(deleteData);

              case 14:
                return _context12.abrupt('return', data);

              case 15:

                couchdb._updateBulkDocs(data.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { deletedAt: new Date() });
                }));
                return _context12.abrupt('return', data);

              case 17:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this3);
      }))();
    },
    deleteTickets: function deleteTickets() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var tickets;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this4.deleteData(_this4.ticketDb);

              case 2:
                tickets = _context13.sent;
                _context13.next = 5;
                return _this4.deleteCustomers(tickets.map(function (item) {
                  return item.customerId;
                }));

              case 5:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this4);
      }))();
    },
    deleteLamps: function deleteLamps() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var lamps;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this5.deleteData(_this5.lampDb);

              case 2:
                lamps = _context14.sent;
                _context14.next = 5;
                return _this5.deleteCustomers(lamps.map(function (item) {
                  return item.customer.id;
                }));

              case 5:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this5);
      }))();
    },
    deleteCustomers: function deleteCustomers(customersId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var customers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, customer;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this6.customerDb._bulkGet(customersId);

              case 2:
                customers = _context15.sent;

                if (!_this6.forceDelete) {
                  _context15.next = 31;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context15.prev = 7;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(customers);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context15.next = 16;
                  break;
                }

                customer = _step.value;
                _context15.next = 13;
                return _this6.customerDb.delete(customer._id, true);

              case 13:
                _iteratorNormalCompletion = true;
                _context15.next = 9;
                break;

              case 16:
                _context15.next = 22;
                break;

              case 18:
                _context15.prev = 18;
                _context15.t0 = _context15['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context15.t0;

              case 22:
                _context15.prev = 22;
                _context15.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context15.prev = 25;

                if (!_didIteratorError) {
                  _context15.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context15.finish(25);

              case 29:
                return _context15.finish(22);

              case 30:
                return _context15.abrupt('return', true);

              case 31:
                return _context15.abrupt('return', _this6.customerDb._updateBulkDocs(customers.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item, { deletedAt: new Date() });
                })));

              case 32:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this6, [[7, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    deleteStocks: function deleteStocks() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee16() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return _this7.deleteData(_this7.stockDb);

              case 2:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this7);
      }))();
    },
    deleteDocs: function deleteDocs() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var docs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, doc;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return _this8.docDb.where('referenceId', _this8.eventSelectedId).get();

              case 2:
                docs = _context17.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context17.prev = 6;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(docs); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  doc = _step2.value;

                  _this8.docDb.delete(doc._id, true);
                }
                _context17.next = 14;
                break;

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context17.t0;

              case 14:
                _context17.prev = 14;
                _context17.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 17:
                _context17.prev = 17;

                if (!_didIteratorError2) {
                  _context17.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context17.finish(17);

              case 21:
                return _context17.finish(14);

              case 22:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this8, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    }
  }
});

/***/ }),

/***/ "YCtc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",on:{"click":function($event){return _vm.handleAddEventIdFromLamps()}}},[_vm._v("\n    Adicionar o EventId nas trocas de lâmpadas\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YHGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-print-winners"},[_c('small',[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.tickets),function(ticket,index){return _c('tr',{key:index},[_c('td',[_vm._v(" "+_vm._s(ticket.rankingNow)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(ticket.customer.holder)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(ticket.customer.uc)+" ")]),_vm._v(" "),(_vm.scope.row.survey && _vm.scope.row.survey.data)?_c('td',[_vm._v(" "+_vm._s(ticket.survey.data.refrigerator.score)+" ")]):_vm._e()])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticStyle:{"max-width":"35px"}},[_vm._v("Posi.")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("UC")]),_vm._v(" "),_c('th',{staticStyle:{"max-width":"40px"}},[_vm._v("Nota")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YJ3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalContent',{attrs:{"background-color":"none"},on:{"close":function($event){return _vm.$emit('close', false)}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-icon navegation-button",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"ti-close"})])])])]},proxy:true},{key:"body",fn:function(){return [_c('div',{staticClass:"row",staticStyle:{"display":"flex","height":"60vh"}},[_c('div',{staticClass:"col-xs-1 self-center"},[_c('button',{staticClass:"btn btn-fill btn-icon btn-primary btn-lg",on:{"click":function($event){_vm.currentIndex = (((_vm.currentIndex - 1) + _vm.images.length) % _vm.images.length)}}},[_c('i',{staticClass:"ti-angle-left"})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-10 text-center items-center justify-center"},[_c('a',{attrs:{"href":_vm.currentImg,"target":"_blank"}},[_c('img',{staticClass:"img-body",attrs:{"src":_vm.currentImg}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-1 self-center"},[_c('button',{staticClass:"btn btn-fill btn-icon btn-primary btn-lg",on:{"click":function($event){_vm.currentIndex = ((_vm.currentIndex + 1) % _vm.images.length)}}},[_c('i',{staticClass:" ti-angle-right"})])])])]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},_vm._l((_vm.images),function(src,index){return _c('img',{key:index,class:("image-footer " + (_vm.currentIndex === index ? 'current-footer' : '')),attrs:{"src":src,"alt":"1"}})}),0)]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YJUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'devilery-term-go',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },
  data: function data() {
    return {
      company: 'ENEL'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['config'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('manufacturers', {
    manufacturesAll: 'fetchAll'
  }))
});

/***/ }),

/***/ "YKxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('user.inactivate') && !_vm.loading)?_c('button',{staticClass:"btn btn-danger btn-fill btn-icon",attrs:{"type":"button","title":"Desativar"},on:{"click":function($event){return _vm.handleInactivate()}}},[_c('i',{staticClass:"ti-unlink"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YMOK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNtA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ygtx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ygzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-status-icons',

  props: {
    ticket: { required: true },
    survey: { required: true }
  },

  computed: {
    alert: function alert() {
      return this.survey ? this.survey.hasOwnProperty('data') && this.survey.data.alert : false;
    },
    surveyed: function surveyed() {
      return this.survey ? this.survey.hasOwnProperty('data') && this.survey.status === 'SYNCED' : false;
    },
    score: function score() {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.hasOwnProperty('refrigerator') ? this.survey.data.refrigerator.score : 0;
    },
    absent: function absent() {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.hasOwnProperty('absent') ? this.survey.data.absent && this.survey.data.absent !== 'false' : false;
    },
    accepted: function accepted() {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.accepted && this.survey.data.accepted !== 'false';
    },
    reason: function reason() {
      return this.absent ? this.survey.data.reasonNotPresent : !this.accepted ? this.survey.data.reasonNotAccepted : '-';
    }
  }
});

/***/ }),

/***/ "YjAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StagesTableTicket_vue__ = __webpack_require__("1EED");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb92555c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StagesTableTicket_vue__ = __webpack_require__("rtMb");
function injectStyle (ssrContext) {
  __webpack_require__("GpCx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb92555c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StagesTableTicket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb92555c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StagesTableTicket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_vuex_modules_users__ = __webpack_require__("oUP6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_vuex_modules_events__ = __webpack_require__("TY2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_vuex_modules_customers__ = __webpack_require__("k8eK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_vuex_modules_project__ = __webpack_require__("qh8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_vuex_modules_manufacturers__ = __webpack_require__("FZmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_vuex_modules_stocks__ = __webpack_require__("QrWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_vuex_modules_lamps__ = __webpack_require__("JPrU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_vuex_modules_tickets__ = __webpack_require__("V2VC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_vuex_modules_states__ = __webpack_require__("RyB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_vuex_modules_roles__ = __webpack_require__("6w/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_vuex_modules_winners__ = __webpack_require__("pxe0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_vuex_modules_surveys__ = __webpack_require__("ua4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_vuex_modules_ranking__ = __webpack_require__("cLmq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_vuex_modules_tags__ = __webpack_require__("s6O8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_vuex_modules_api__ = __webpack_require__("HwJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_vuex_modules_categories__ = __webpack_require__("j1v1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_vuex_modules_docs__ = __webpack_require__("yKq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_eventsSpecifications__ = __webpack_require__("mHPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_gallery__ = __webpack_require__("WPSa");





var _this = this;
























__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* default */].Store({
  state: {
    executing: false,
    user: {},
    config: {},
    eventSelected: {},
    rangeDate: '',
    apis: {
      edu: {
        events: [],
        speeches: [],
        eventsCount: 0,
        speechesCount: 0,
        loading: false
      }
    }
  },
  mutations: {
    SET_EVENTS_EDU_COUNT: function SET_EVENTS_EDU_COUNT(state, payload) {
      state.apis.edu.eventsCount = payload;
    },
    SET_EVENTS_EDU_API: function SET_EVENTS_EDU_API(state, payload) {
      state.apis.edu.events = payload;
    },
    SET_SPEECHES_EDU_API: function SET_SPEECHES_EDU_API(state, payload) {
      state.apis.edu.speeches = payload;
    },
    SET_SPEECHES_EDU_COUNT: function SET_SPEECHES_EDU_COUNT(state, payload) {
      state.apis.edu.speechesCount = payload;
    },
    SET_EDU_COUNT_LOADING: function SET_EDU_COUNT_LOADING(state, payload) {
      state.apis.edu.loading = payload;
    },
    changeStateExecution: function changeStateExecution(state, payload) {
      state.executing = payload;
    },
    changeUser: function changeUser(state, payload) {
      state.user = payload;
    },
    changeConfig: function changeConfig(state, payload) {
      state.config = payload;
    },
    changeEventSelected: function changeEventSelected(state, payload) {
      state.eventSelected = payload;
    },
    changeRangeDate: function changeRangeDate(state, payload) {
      state.rangeDate = payload;
    }
  },
  actions: {
    setDatasApiEdu: function setDatasApiEdu(context, _ref) {
      var events = _ref.events,
          speeches = _ref.speeches,
          loading = _ref.loading;

      if (loading !== undefined) context.commit('SET_EDU_COUNT_LOADING', loading);
      if (events !== undefined) {
        context.commit('SET_EVENTS_EDU_API', events);
        context.commit('SET_EVENTS_EDU_COUNT', events.length);
      }
      if (speeches !== undefined) {
        context.commit('SET_SPEECHES_EDU_API', speeches);
        context.commit('SET_SPEECHES_EDU_COUNT', speeches.length);
      }
    },
    changeExecution: function changeExecution(context, payload) {
      return context.commit('changeStateExecution', payload);
    },
    changeRange: function changeRange(context, payload) {
      if (!payload) payload = [];
      if (payload.length > 0 && payload[0] instanceof Date && payload[1] instanceof Date) {
        payload[0] = payload[0].toString();
        payload[1] = payload[1].toString();
      }
      context.commit('changeRangeDate', payload);
    },
    setUser: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(context, payload) {
        var couchRoles, p;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(payload && payload.role && payload.role !== '')) {
                  _context.next = 6;
                  break;
                }

                couchRoles = new __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'roles' });
                _context.next = 4;
                return couchRoles.where('name', payload.role).first();

              case 4:
                p = _context.sent;

                payload.permissions = p ? p.permissions : p;

              case 6:
                localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload));
                context.commit('changeUser', payload);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function setUser(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    unsetUser: function unsetUser(context, payload) {
      localStorage.removeItem('user');
      context.commit('changeUser', {});
    },
    setConfig: function setConfig(context, payload) {
      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].collection('projects').find('config').then(function (result) {
        localStorage.setItem('config', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result));
        context.commit('changeConfig', result);
      }).catch(function (err) {
        return console.log(err);
      });
    },
    setEventSelected: function setEventSelected(context, eventId) {
      if (eventId === '') {
        localStorage.setItem('eventSelected', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({}));
        context.commit('changeEventSelected', {});
      } else {
        __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].collection('events').find(eventId).then(function (result) {
          localStorage.setItem('eventSelected', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result));
          context.commit('changeEventSelected', result);
        }).catch(function (err) {
          return console.log(err);
        });
      }
    }
  },
  getters: {
    user: function user(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.user, JSON.parse(localStorage.getItem('user')));
    },
    config: function config(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.config, JSON.parse(localStorage.getItem('config')));
    },
    eventSelected: function eventSelected(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.eventSelected, JSON.parse(localStorage.getItem('eventSelected')));
    },
    rangeDate: function rangeDate(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.rangeDate, JSON.parse(localStorage.getItem('rangeDate')));
    },
    formatedDate: function formatedDate(state) {
      var formatedDate = [];
      if (state.rangeDate && state.rangeDate.length > 0) {
        formatedDate.push(new Date(state.rangeDate[0]).toISOString().replace('03:00:00', '00:00:00'));
        formatedDate.push(new Date(state.rangeDate[1]).toISOString().replace('03:00:00', '23:59:59'));
      }
      return formatedDate;
    },
    apiEdu: function apiEdu(state) {
      return state.apis.edu;
    }
  },
  modules: {
    users: __WEBPACK_IMPORTED_MODULE_8_src_vuex_modules_users__["a" /* default */],
    events: __WEBPACK_IMPORTED_MODULE_9_src_vuex_modules_events__["a" /* default */],
    customers: __WEBPACK_IMPORTED_MODULE_10_src_vuex_modules_customers__["a" /* default */],
    project: __WEBPACK_IMPORTED_MODULE_11_src_vuex_modules_project__["a" /* default */],
    manufacturers: __WEBPACK_IMPORTED_MODULE_12_src_vuex_modules_manufacturers__["a" /* default */],
    stocks: __WEBPACK_IMPORTED_MODULE_13_src_vuex_modules_stocks__["a" /* default */],
    lamps: __WEBPACK_IMPORTED_MODULE_14_src_vuex_modules_lamps__["a" /* default */],
    tickets: __WEBPACK_IMPORTED_MODULE_15_src_vuex_modules_tickets__["a" /* default */],
    states: __WEBPACK_IMPORTED_MODULE_16_src_vuex_modules_states__["a" /* default */],
    roles: __WEBPACK_IMPORTED_MODULE_17_src_vuex_modules_roles__["a" /* default */],
    winners: __WEBPACK_IMPORTED_MODULE_18_src_vuex_modules_winners__["a" /* default */],
    surveys: __WEBPACK_IMPORTED_MODULE_19_src_vuex_modules_surveys__["a" /* default */],
    ranking: __WEBPACK_IMPORTED_MODULE_20_src_vuex_modules_ranking__["a" /* default */],
    tags: __WEBPACK_IMPORTED_MODULE_21_src_vuex_modules_tags__["a" /* default */],
    api: __WEBPACK_IMPORTED_MODULE_22_src_vuex_modules_api__["a" /* default */],
    docs: __WEBPACK_IMPORTED_MODULE_24_src_vuex_modules_docs__["a" /* default */],
    categories: __WEBPACK_IMPORTED_MODULE_23_src_vuex_modules_categories__["a" /* default */],
    eventsSpecifications: __WEBPACK_IMPORTED_MODULE_25__modules_eventsSpecifications__["a" /* default */],
    gallery: __WEBPACK_IMPORTED_MODULE_26__modules_gallery__["a" /* default */]
  }
}));

/***/ }),

/***/ "Z+/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUploadPhotosEvent_vue__ = __webpack_require__("wlRp");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("n36L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93b25618"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUploadPhotosEvent_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0wx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("320+ Themify Icons")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Handcrafted by our friends from\n          "),_c('a',{attrs:{"target":"_blank","href":"https://themify.me/"}},[_vm._v("Themify")]),_vm._v(".")])]),_vm._v(" "),_c('div',{staticClass:"card-content all-icons"},[_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Arrows & Direction Icons ")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-vertical")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-horizontal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-horizontal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-move"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-move")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-fullscreen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-fullscreen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-corner"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-corner")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-h"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-h")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-exchange-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-exchange-vertical")])])]),_vm._v(" "),_c('h3',[_vm._v("Web App Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wand"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wand")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-user"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-user")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-link"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-link")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlink"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlink")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trash"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trash")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-target"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-target")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-desktop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-desktop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tablet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tablet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mobile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mobile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-email"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-email")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-star"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-star")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-spray"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-spray")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-signal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-signal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-settings")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-search"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-search")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-in"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-in")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-out"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-out")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cut"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cut")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-minus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-minus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-close"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-close")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-roller"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-roller")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-bucket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-bucket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-na"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-na")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-lock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-lock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-arrow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-arrow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-key"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-key")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart-broken"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart-broken")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-open"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-open")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-drag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-drag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eye"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eye")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-import"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-import")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-export"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-export")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cup"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cup")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-crown"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-crown")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thought"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thought")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check-box"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check-box")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-announcement"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-announcement")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-palette"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-palette")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-briefcase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-briefcase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-blackboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-blackboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-world"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-world")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wheelchair"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wheelchair")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-car"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-car")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-truck"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-truck")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-timer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-timer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ticket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ticket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shine"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shine")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shield"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shield")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-notepad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-notepad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-server"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-server")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pulse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pulse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-printer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-printer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-power-off"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-power-off")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plug"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plug")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pie-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pie-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-panel"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-panel")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-package"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-package")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-money"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-money")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-light-bulb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-light-bulb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-infinite"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-infinite")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-id-badge"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-id-badge")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hummer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hummer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-home")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrives"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrives")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gift"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gift")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-game"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-game")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-filter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-filter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-files"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-filesService")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-file"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-file")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-folder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-folder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-envelope"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-envelope")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dashboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dashboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clipboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clipboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-calendar"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-calendar")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-book"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-book")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bell")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-basketball"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-basketball")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-archive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-archive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-anchor"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-anchor")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alert"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alert")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alarm-clock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alarm-clock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-agenda"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-agenda")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-write"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-write")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wallet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wallet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-clapper"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-clapper")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vector"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vector")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-support"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-support")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stamp"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stamp")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-slice"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-slice")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shortcode"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shortcode")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-receipt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-receipt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eraser"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eraser")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-magnet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-magnet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-double"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-double")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dotted"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dotted")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dashed"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dashed")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ink-pen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ink-pen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gallery"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gallery")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-smile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-smile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-sad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-sad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-credit-card"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-credit-card")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments-smiley"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments-smiley")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-time"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-time")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rocket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rocket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-new-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-new-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Control Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-shuffle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-shuffle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-play"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-play")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-pause"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-pause")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-volume"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-volume")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-record"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-record")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-eject"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-eject")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Text Editor")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paragraph"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paragraph")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-uppercase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-uppercase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-underline"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-underline")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-text"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-text")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-Italic"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-Italic")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-smallcap"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-smallcap")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list-ol"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list-ol")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-justify"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-justify")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-left")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Layout Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-min"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-min")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-none"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-none")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-placeholder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-placeholder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-post"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-post")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-large-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-large-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-line-solid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-line-solid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-merged"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-merged")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widgetized"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widgetized")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-grid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-grid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-upload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-upload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-download"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-download")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-loop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-loop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Brand Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-instagram"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-instagram")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-google"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-google")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-github"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-github")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-facebook"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-facebook")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dribbble"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dribbble")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-apple"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-apple")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-android"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-android")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-yahoo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-yahoo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trello"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trello")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stack-overflow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stack-overflow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-soundcloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-soundcloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reddit"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reddit")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linux"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linux")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-jsfiddle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-jsfiddle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-joomla"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-joomla")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-html5"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-html5")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-css3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-css3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-drupal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-drupal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wordpress"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wordpress")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-skype"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-skype")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-youtube"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-youtube")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linkedin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linkedin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-logo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-logo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon-alt")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1yA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryComponent_vue__ = __webpack_require__("LPfi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31378bb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryComponent_vue__ = __webpack_require__("YJ3/");
function injectStyle (ssrContext) {
  __webpack_require__("9wTj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31378bb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31378bb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z2d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Webcam__ = __webpack_require__("KMHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_filesService__ = __webpack_require__("K03o");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomerImageCapture',
  components: {
    Webcam: __WEBPACK_IMPORTED_MODULE_3_components_Webcam__["a" /* default */]
  },
  props: {
    screenshotFormat: {
      type: String,
      default: 'image/jpeg'
    }
  },
  data: function data() {
    return {
      img: null,
      unabled: false,
      capture: true
    };
  },


  methods: {
    handleImageCapture: function handleImageCapture() {
      this.unabled = false;
      this.img = this.$refs.webcam.capture();
    },
    selectImage: function selectImage(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var type, file, reader;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                type = event.target.files[0].type;
                _context.next = 4;
                return _this.handleFile(event, type);

              case 4:
                file = _context.sent;
                reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onloadend = function () {
                  _this.img = reader.result;
                  _this.capture = false;
                };
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log('err', _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    handleFile: function handleFile(event, type) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve(__WEBPACK_IMPORTED_MODULE_4__services_filesService__["a" /* filesService */].handleBlob(event, type));
      });
    },
    uploadImage: function uploadImage() {
      this.unabled = false;
    },
    handleAcceptImage: function handleAcceptImage() {
      this.unabled = true;
      this.$emit('on-image-captured', { image: this.img });
    },
    handleRefuseImage: function handleRefuseImage() {
      this.img = null;
    }
  }
});

/***/ }),

/***/ "Z450":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-progress',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "Z4om":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9M6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZAhD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZCy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadFileInput_vue__ = __webpack_require__("y2vS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9456a45e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadFileInput_vue__ = __webpack_require__("/0KN");
function injectStyle (ssrContext) {
  __webpack_require__("BlIv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9456a45e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnUploadFileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9456a45e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnUploadFileInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  default: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_admin",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedadmin"
  },
  states: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_municipios"
  },
  specifications: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_specifications",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedspecifications"
  },
  winners: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_contemplados",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedcontemplados"
  },
  docs: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_docs",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefineddocs"
  },
  logs: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_logs",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedlogs"
  },
  surveys: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_surveys",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedsurveys"
  },
  surveys_docs: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_surveys_docs",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedsurveys_docs"
  },
  config: {
    host: "https://couch-trg.3e.eng.br",
    user: "admin",
    pass: "admin2435,",
    db: "trg_eqpi_notiasc_configurations",
    remote_host: "https://couch-trg.3e.eng.br",
    remote_user: "admin",
    remote_pass: "admin2435,",
    remote_db: "trg_undefinedconfigurations"
  }
});

/***/ }),

/***/ "ZLYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnelCe_LampTermEnelCe__ = __webpack_require__("Ewv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnelGo_LampTermEnelGo__ = __webpack_require__("D1tU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cemar_LampTermCemar__ = __webpack_require__("paHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IascPi_LampTermIasc__ = __webpack_require__("hJwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IascMa_LampTermIasc__ = __webpack_require__("3Be+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IascAl_LampTermIasc__ = __webpack_require__("J2zJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EnergisaBorboremaPb_LampTermEnergisaBorboremaPb__ = __webpack_require__("MfaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EnergisaPb_LampTermEnergisaPb__ = __webpack_require__("hN15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Celpa_LampTermCelpa__ = __webpack_require__("ZWbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EquatorialPi_LampTermEquatorialPi__ = __webpack_require__("8XB3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CelpaJurunas_LampTermCelpaJurunas__ = __webpack_require__("O3OW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trg_Terms_LampTermGeneric__ = __webpack_require__("TUlP");

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamps-doccument',

  components: {
    LampTermGeneric: __WEBPACK_IMPORTED_MODULE_13__components_Trg_Terms_LampTermGeneric__["a" /* default */],
    LampTermCelpaJurunas: __WEBPACK_IMPORTED_MODULE_12__CelpaJurunas_LampTermCelpaJurunas__["a" /* default */],
    LampTermEnelCe: __WEBPACK_IMPORTED_MODULE_2__EnelCe_LampTermEnelCe__["a" /* default */],
    LampTermCemar: __WEBPACK_IMPORTED_MODULE_4__Cemar_LampTermCemar__["a" /* default */],
    LampTermEnelGo: __WEBPACK_IMPORTED_MODULE_3__EnelGo_LampTermEnelGo__["a" /* default */],
    LampTermIascPi: __WEBPACK_IMPORTED_MODULE_5__IascPi_LampTermIasc__["a" /* default */],
    LampTermEnergisaPb: __WEBPACK_IMPORTED_MODULE_9__EnergisaPb_LampTermEnergisaPb__["a" /* default */],
    LampTermIascMa: __WEBPACK_IMPORTED_MODULE_6__IascMa_LampTermIasc__["a" /* default */],
    LampTermIascAl: __WEBPACK_IMPORTED_MODULE_7__IascAl_LampTermIasc__["a" /* default */],
    LampTermEnergisaBorboremaPb: __WEBPACK_IMPORTED_MODULE_8__EnergisaBorboremaPb_LampTermEnergisaBorboremaPb__["a" /* default */],
    LampTermCelpa: __WEBPACK_IMPORTED_MODULE_10__Celpa_LampTermCelpa__["a" /* default */],
    LampTermEquatorialPi: __WEBPACK_IMPORTED_MODULE_11__EquatorialPi_LampTermEquatorialPi__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchEvent(this.storageData.eventId, true).then(function (res) {
      _this.event = res;
    });

    if (!this.config.hasOwnProperty('_id') || !this.config.hasOwnProperty('_rev')) {
      this.fetchProject('config');
    }
  },
  data: function data() {
    return {
      event: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', { loadingEvent: 'loading' }), {

    allDataAlready: function allDataAlready() {
      return this.eventId && this.customer && this.config && this.lamps && this.lampByTypeData && !this.loadingEvent;
    },

    payload: function payload() {
      return {
        eventId: this.eventId,
        config: this.config,
        customer: this.customer,
        lamps: this.lamps,
        lamp: this.lampByTypeData,
        event: {}
      };
    },
    storageData: function storageData() {
      return JSON.parse(localStorage.getItem('LampsTmpTemp'));
    },
    eventId: function eventId() {
      return this.storageData.eventId;
    },
    lamps: function lamps() {
      return this.storageData.lamps;
    },
    customer: function customer() {
      return this.storageData.customer;
    },
    lampByTypeData: function lampByTypeData() {
      return this.storageData.lamps.reduce(function (acc, curr, indx) {
        if (indx === 0) {
          acc = {
            fluorescent: { count: 0, text: '' },
            incandescent: { count: 0, text: '' }
          };
        }
        if (curr.type === 'Fluorescente') {
          acc.fluorescent.count++;
          acc.fluorescent.text += acc.fluorescent.count === 1 ? curr.power + 'W' : ', ' + curr.power + 'W';
        } else if (curr.type === 'Incandescente') {
          acc.incandescent.count++;
          acc.incandescent.text += acc.incandescent.count === 1 ? curr.power + 'W' : ', ' + curr.power + 'W';
        }
        return acc;
      }, {});
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('events', { fetchEvent: 'fetchOne' }))
});

/***/ }),

/***/ "ZMB5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZMT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampTermIascAl',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },
    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), {

    customer: {
      get: function get() {
        return this.payload.customer;
      }
    },

    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },

    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Equatorial Alagoas Distribuidora De Energia S.A.';
    },
    abbreviation: function abbreviation() {
      return 'CEAL';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rua',
        street: 'Fernandes Lima',
        number: '3349',
        neighborhood: 'Farol',
        city: 'Maceió',
        state: 'AL'
      };
    },
    cnpj: function cnpj() {
      return '12.272.084/0001-00';
    },
    numberState: function numberState() {
      return '24007177-8';
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "ZOKc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d73aa76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("PatY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d73aa76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZRZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.companyTerms === 'generic')?_c('ParticipationTermGeneric',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'CE' && _vm.companyTerms === 'enel')?_c('partitipation-term-enel',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'GO'&& _vm.companyTerms === 'enel')?_c('participation-term-enel-go',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'MA'&& _vm.companyTerms === 'cemar')?_c('participation-term-cemar',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'MA' && _vm.companyTerms === 'iasc')?_c('participation-term-iasc-ma',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PI' && _vm.companyTerms === 'iasc')?_c('participation-term-iasc-pi',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PI' && _vm.companyTerms === 'equatorial')?_c('participation-term-equatorial-pi',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'AL' && _vm.companyTerms === 'iasc')?_c('participation-term-iasc-al',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PB' && _vm.companyTerms === 'energisa-paraiba')?_c('participation-term-energisa-pb',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PB' && _vm.companyTerms === 'energisa-borborema')?_c('participation-term-energisa-borborema-pb',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PA' && _vm.companyTerms === 'celpa')?_c('ParticipationTermCelpa',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.state === 'PA' && _vm.companyTerms === 'celpa-jurunas')?_c('ParticipationTermCelpaJurunas',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZWbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCelpa_vue__ = __webpack_require__("Rz4R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d3dc46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCelpa_vue__ = __webpack_require__("/Nqp");
function injectStyle (ssrContext) {
  __webpack_require__("b8iA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d3dc46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCelpa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d3dc46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCelpa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZYFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wd btn-fill btn-success",attrs:{"disabled":!_vm.eventSelected || _vm.loading},on:{"click":_vm.runReport}},[_vm._v("\n  Gerar relatório do evento\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZYN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZZ2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-open-tickets-documentations-print',

  props: {
    ticket: {
      required: true,
      type: Object
    }
  },

  methods: {
    handleDocumentsPrint: function handleDocumentsPrint() {
      var routeData = this.$router.resolve({
        name: 'documents.print',
        params: { eventId: this.ticket.eventId, ticketId: this.ticket._id }
      });
      window.open(routeData.href, 'documentsWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    }
  }
});

/***/ }),

/***/ "ZZNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__ = __webpack_require__("GdNa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__ = __webpack_require__("RUAa");
function injectStyle (ssrContext) {
  __webpack_require__("5uDj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zfab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_Search_vue__ = __webpack_require__("yntV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__("NYxO");


















__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSearch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_Search_vue__["a" /* default */]
  },

  data: function data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      },
      sort: {},
      searched: false,
      search: {
        query: '',
        fields: ['uc', 'holder', 'cpf', 'createdAt', '_id']
      },
      count: 0,
      page: 1
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["a" /* mapGetters */])('customers', {
    tableData: 'customers',
    loading: 'loading'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.searched ? this.tableData.length : this.count;
      return this.searched ? this.tableData.length : this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),

  watch: {
    currentPage: function currentPage() {
      if (this.search.query && this.search.query !== '') {
        this.handleSearch(this.search.query);
      } else {
        this.fetch();
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapActions */])('customers', ['fetchAll', 'fetchViewAll', 'delete', 'fetchOne', 'resetOne', 'searchCustomer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapActions */])('tickets', {
    resetTickets: 'resetAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapActions */])('lamps', {
    resetLamps: 'resetAll'
  }), {
    fetch: function fetch() {
      this.searched = false;
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'select': this.search.fields
      });
      this.counter();
    },
    handleSearch: function handleSearch(query) {
      var _this = this;

      if (query.trim() === '') {
        this.searched = false;
        this.$nextTick(function () {
          _this.fetch();
        });
      }
      this.search.query = query;
      var limit = Math.floor(this.pagination.perPage / 3);
      var skip = limit * (this.pagination.currentPage - 1);
      this.searched = true;
      this.searchCustomer({
        query: query,
        options: { limit: limit, skip: skip }
      });
    },
    handleSort: function handleSort(sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      };
      this.fetch();
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this2.delete(row._id).then(function () {
          _this2.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this2.fetch();
        }).catch(function (err) {
          return console.log(err);
        });
      });
    },
    handleCustomerDetail: function handleCustomerDetail(customerId) {
      this.resetOne();
      this.resetTickets();
      this.resetLamps();
      this.$router.push({ name: 'customer.detail', params: { id: customerId } });
    },
    counter: function counter() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10_src_services_Couchdb__["a" /* default */].view('count-customers-all', 'count-customers-all').then(function (result) {
        _this3.count = result.rows[0].value;
      });
    }
  }),

  mounted: function mounted() {
    this.searched = false;
  }
});

/***/ }),

/***/ "ZgoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_services_Helper__ = __webpack_require__("leRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'global-ranking-report-2',

  props: {
    events: {
      required: true
    },
    csvSeparator: {
      required: true,
      default: ';'
    },
    enablePartial: {
      default: false
    }
  },

  data: function data() {
    return {
      eventsData: {},
      event: {},
      options: {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0
      },
      reporting: false,
      loadingTickets: true,
      loadingLamps: true,
      loadingSurveys: true,
      customersIds: [],
      reported: false,
      reportData: {},
      moreThanOneTicket: [],
      lampsCounterCustomer: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('users', ['usersIdName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('project', ['project']), {
    eventLabel: function eventLabel() {
      return localStorage.getItem('eventLabel') || 'Ações';
    },


    customersCouch: function customersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },

    eventsCouch: function eventsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
    },

    ticketsCouch: function ticketsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },

    lampsCouch: function lampsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },

    stocksCouch: function stocksCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'stocks' });
    },

    surveysCouch: function surveysCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'surveys', collection: 'surveys' });
    },

    manufacturersCouch: function manufacturersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'manufacturers' });
    },

    usersCouch: function usersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_9_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'users' });
    },

    csvHeaders: function csvHeaders() {
      return {
        customer: {
          'uc': 'UC',
          'cpf': 'CPF',
          'nationalId': 'RG',
          'holder': 'Nome',
          'aka': 'Apelido',
          'birthdate': 'Data de nascimento',
          'phone1': 'Telefone 1',
          'phone2': 'Telefone 2',
          'motherName': 'Nome da mãe',
          'street': 'Logradouro',
          'number': 'Numero',
          'neighborhood': 'Bairro',
          'city': 'Município',
          'zip': 'CEP',
          'complement': 'Complemento',
          'observartion': 'Observação',
          'nis': 'NIS',
          'userId': 'Cliente cadastrado por'
        },
        event: {
          'status': 'Status do evento',
          'city': 'Município do evento',
          'reference': 'Referência do evento',
          'place': 'Local do evento',
          'startDate': 'Data início do evento',
          'endDate': 'Data fim do evento',
          'dateTimeCeremony': 'Data da cerimônia',
          'numberOfRefigerators': 'Qtd. refrigeradores',
          'drawn': 'Houve sorteio?',
          'userId': 'Evento criado por'
        },
        ticket: {
          'eligible': 'Elegível',
          'winner': 'Ticket Sorteado',
          'documentedAt': 'Data documentação',
          'barcode': 'Código de barra',
          'checkIn': 'Presente',
          'userId': 'Ticket gerado por'
        },
        survey: {
          'status': 'Estado da pesquisa',
          'rankingNow': 'Rank',
          'data.absent': 'Pesquisado ausente',
          'data.reasonNotPresent': 'Razão para não estar presente',
          'data.accepted': 'Aceitou participar da pesquisa',
          'data.reasonNotAccepted': 'Motivo não participar',
          'data.refrigerator.body': 'Carcaça',
          'data.refrigerator.doors': 'Portas',
          'data.refrigerator.coil': 'Serpentina',
          'data.refrigerator.rubber': 'Borrachas',
          'data.refrigerator.compartments': 'Compartimentos',
          'data.refrigerator.engine': 'Motor',
          'data.refrigerator.yearsUse': 'Idade da geladeira',
          'data.refrigerator.score': 'Pontuação',
          'observation': 'Observações',
          'user.name': 'Pesquisado por'
        },
        stock: {
          'invoice': 'Nota fiscal',
          'dateInvoice': 'Data de emissão da nota fiscal',
          'invoicePowerCompany': 'Nota fiscal da concessionária',
          'dateInvoicePowerCompany': 'Data de emissão da nota fiscal da concessionária',
          'numberOfRefigerators': 'Quantidade de geladeiras',
          'description': 'Descrição do produto',
          'userId': 'Estoque criado por'
        },
        manufacturer: {
          'name': 'Fabricante',
          'userId': 'Criado por'
        },
        lamps: {
          'customer.holder': 'Nome do cliente da troca',
          'customer.uc': 'UC do cliente da troca',
          'customer.cpf': 'CPF do cliente da troca',
          'userId': 'Atendente da troca',
          'createdAt': 'Data da troca',
          'count': 'Quantidade de lâmpadas por transação'
        }
      };
    },
    loading: function loading() {
      return this.loadingLamps && this.loadingTickets && this.loadingSurveys;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), {
    mapKeyArrayToObject: function mapKeyArrayToObject(_ref) {
      var _this = this;

      var dataArray = _ref.dataArray,
          keyObject = _ref.keyObject,
          reportField = _ref.reportField;

      var _loop = function _loop(currentValue) {
        var keyObj = '';
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(keyObject.split('.')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            keyObj = keyObj === '' ? currentValue[key] : keyObj[key];
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (!_this.reportData[_this.event._id][reportField].hasOwnProperty(keyObj)) {
          _this.reportData[_this.event._id][reportField][keyObj] = [];
        }

        if (_this.reportData[_this.event._id][reportField][keyObj].find(function (item) {
          return item._id === currentValue._id;
        })) {
          return 'continue';
        }

        _this.reportData[_this.event._id][reportField][keyObj].push(currentValue);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(dataArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var currentValue = _step.value;

          var _ret = _loop(currentValue);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    loadingReport: function loadingReport() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Informações',
        text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        onOpen: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.showLoading();
                    _context.next = 3;
                    return _this2.runReport();

                  case 3:
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.hideLoading();
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function onOpen() {
            return _ref2.apply(this, arguments);
          };
        }()
      }).catch(function (err) {
        console.log(err);
      });
    },
    runReport: function runReport() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var report, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, e;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.reporting = true;
                _this3.$emit('progress', { current: 0, total: 0 });
                _this3.resetValues();
                report = '';
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 7;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this3.events);

              case 9:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context2.next = 21;
                  break;
                }

                e = _step3.value;

                _this3.event = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(e));
                if (!_this3.reportData.hasOwnProperty(e._id)) {
                  _this3.defineReportDataObject(e);
                }
                _context2.next = 15;
                return _this3.fetchData();

              case 15:
                _context2.next = 17;
                return _this3.handleReport();

              case 17:
                report += _context2.sent;

              case 18:
                _iteratorNormalCompletion3 = true;
                _context2.next = 9;
                break;

              case 21:
                _context2.next = 27;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t0;

              case 27:
                _context2.prev = 27;
                _context2.prev = 28;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 30:
                _context2.prev = 30;

                if (!_didIteratorError3) {
                  _context2.next = 33;
                  break;
                }

                throw _iteratorError3;

              case 33:
                return _context2.finish(30);

              case 34:
                return _context2.finish(27);

              case 35:

                _this3.download(_this3.addHeaders() + report + _this3.addFooter());
                _this3.reporting = false;

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[7, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    fetchData: function fetchData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.fetchTickets();

              case 3:
                _context3.next = 5;
                return _this4.fetchLamps();

              case 5:
                _context3.next = 7;
                return _this4.fetchCustomers();

              case 7:
                _context3.next = 9;
                return _this4.fetchSurveys();

              case 9:
                _context3.next = 11;
                return _this4.fetchStocks();

              case 11:
                _context3.next = 13;
                return _this4.fetchManufacturers();

              case 13:
                _context3.next = 15;
                return _this4.fetchLamps();

              case 15:
                _context3.next = 17;
                return _this4.fetchUsers();

              case 17:
                _context3.next = 22;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 22:
                return _context3.abrupt('return', true);

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 19]]);
      }))();
    },
    fetchUsers: function fetchUsers() {
      var _this5 = this;

      return this.usersCouch.limit(999999).get().then(function (result) {
        return _this5.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'users' });
      });
    },
    fetchTickets: function fetchTickets() {
      var _this6 = this;

      return this.ticketsCouch.where('eventId', this.event._id).limit(99999999).get().then(function (result) {
        return _this6.mapKeyArrayToObject({ dataArray: result, keyObject: 'customerId', reportField: 'tickets' });
      });
    },
    fetchLamps: function fetchLamps() {
      var _this7 = this;

      return this.lampsCouch.where('eventId', this.event._id).limit(99999999).get().then(function (result) {
        return _this7.mapKeyArrayToObject({ dataArray: result, keyObject: 'customer.id', reportField: 'lamps' });
      });
    },
    fetchSurveys: function fetchSurveys() {
      var _this8 = this;

      return this.surveysCouch.where('event._id', this.event._id).limit(99999999).get().then(function (result) {
        return _this8.mapKeyArrayToObject({ dataArray: result, keyObject: 'customer._id', reportField: 'surveys' });
      });
    },
    fetchStocks: function fetchStocks() {
      var _this9 = this;

      return this.stocksCouch.where('eventId', this.event._id).limit(99999999).get().then(function (result) {
        return _this9.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'stocks' });
      });
    },
    fetchManufacturers: function fetchManufacturers() {
      var _this10 = this;

      return this.manufacturersCouch.limit(99999999).get().then(function (result) {
        return _this10.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'manufacturers' });
      });
    },
    fetchCustomers: function fetchCustomers() {
      var _this11 = this;

      var idsCustomers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].tickets).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { id: item });
      }).concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].lamps).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { id: item });
      }));
      return this.customersCouch._bulkGet(idsCustomers).then(function (result) {
        return _this11.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'customers' });
      });
    },
    resetValues: function resetValues() {
      this.reporting = false;
      this.loadingTickets = true;
      this.loadingLamps = true;
      this.loadingSurveys = true;
      this.customersIds = [];
      this.reported = false;
      this.reportData = {};
      this.moreThanOneTicket = [];
      this.lampsCounterCustomer = {};
    },
    handleReport: function handleReport() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this12.moreThanOneTicket.length > 0)) {
                  _context4.next = 3;
                  break;
                }

                _this12.$notify({
                  message: '[ERROR: 409] Ocorreu um erro ao gerar o relatório. Entre em contato com o suporte e informe o código de erro 409.',
                  type: 'danger',
                  timeout: 10000
                });
                return _context4.abrupt('return', false);

              case 3:
                _context4.prev = 3;

                if (_this12.reporting) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return', _this12.makeReport());

              case 6:
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](3);

                _this12.$notify({
                  message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
                  type: 'danger',
                  timeout: 10000
                });
                console.log(_context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this12, [[3, 8]]);
      }))();
    },
    addFooter: function addFooter() {
      return '\n"Arquivo gerado em: "' + this.csvSeparator + '"' + this.$moment(new Date()).format('DD-MM-YYYY HH:mm:ss') + '"';
    },
    makeReport: function makeReport() {
      var bodies = this.addBodies();

      if (!bodies) {
        this.$notify({ message: 'Dados insuficientes para gerar o relatório.', type: 'info' });
        return false;
      }

      return bodies;
    },
    download: function download(report) {
      var blob = __WEBPACK_IMPORTED_MODULE_7_blob_util___default.a.createBlob([report], { type: 'text/plain' });
      var now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss');
      var reportType = this.event.status === 2 ? 'Relatório_Geral' : 'Relatório_Parcial';
      var filename = reportType + '_' + now;
      this.reported = true;
      __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(blob, filename + '.csv');
    },
    addHeaders: function addHeaders() {
      var csv = '';
      csv += this.addHeader(this.csvHeaders.customer);
      csv += this.addHeader(this.csvHeaders.event);
      csv += this.addHeader(this.csvHeaders.ticket);

      if (this.project.haveSurveys) {
        csv += this.addHeader(this.csvHeaders.survey);
      }

      csv += this.addHeader(this.csvHeaders.stock);
      csv += this.addHeader(this.csvHeaders.manufacturer);

      csv += 'Quantidade total de lâmpadas trocadas' + this.csvSeparator;

      for (var i = 0; i < this.project.lamps.max; i++) {
        csv += this.addHeader(this.csvHeaders.lamps);
      }

      csv += '\n';
      return csv;
    },
    addHeader: function addHeader(headers) {
      var csv = '';
      for (var h in headers) {
        csv += '"' + headers[h] + '"' + this.csvSeparator;
      }
      return csv;
    },
    addBodies: function addBodies() {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].customers).length < 1) {
        this.reporting = false;
        this.$notify({ message: 'Não há clientes para este evento.', type: 'warning' });
        return '';
      }

      var csv = '';
      var current = 0;
      for (var customerId in this.reportData[this.event._id].customers) {
        if (this.reportData[this.event._id].customers.hasOwnProperty(customerId)) {
          csv += this.addCustomerReport(this.reportData[this.event._id].customers[customerId][0]);
        } else {
          csv += this.addCustomerReport(undefined);
        }

        csv += this.addEventReport(this.event);

        if (this.reportData[this.event._id].tickets.hasOwnProperty(customerId)) {
          csv += this.addTicketReport(this.reportData[this.event._id].tickets[customerId][0]);
        } else {
          csv += this.addTicketReport(undefined);
        }

        if (this.eventRanking) {
          if (this.reportData[this.event._id].tickets.hasOwnProperty(customerId)) {
            csv += this.addSurveysReport(this.reportData[this.event._id].surveys[customerId]);
          } else {
            csv += this.addSurveysReport(undefined);
          }
        }

        if (this.reportData[this.event._id].tickets.hasOwnProperty(customerId) && this.reportData[this.event._id].tickets[customerId][0].stockId && this.reportData[this.event._id].stocks.hasOwnProperty(this.reportData[this.event._id].tickets[customerId][0].stockId)) {
          csv += this.addStockReport(this.reportData[this.event._id].stocks[this.reportData[this.event._id].tickets[customerId][0].stockId][0]);
        } else {
          csv += this.addStockReport(undefined);
        }

        if (this.reportData[this.event._id].tickets.hasOwnProperty(customerId) && this.reportData[this.event._id].manufacturers.length > 0 && this.reportData[this.event._id].tickets[customerId][0].stockId && this.reportData[this.event._id].stocks.hasOwnProperty(this.reportData[this.event._id].tickets[customerId][0].stockId)) {
          csv += this.addManufacturerReport(this.reportData[this.event._id].manufacturers[this.reportData[this.event._id].stocks[this.reportData[this.event._id].tickets[customerId][0].stockId][0].manufacturerId][0]);
        } else {
          csv += this.addManufacturerReport(undefined);
        }

        if (this.reportData[this.event._id].lamps.hasOwnProperty(customerId)) {
          csv += this.addLampsReport(this.reportData[this.event._id].lamps[customerId]);
        } else {
          csv += this.addLampsReport(undefined);
        }

        csv += this.csvSeparator + '\n';

        ++current;
        this.$emit('progress', { current: current, total: this.reportData[this.event._id].customers.length });
      }

      return csv;
    },
    addCustomerReport: function addCustomerReport(obj) {
      var csv = '';
      for (var field in this.csvHeaders.customer) {
        if (['street', 'number', 'neighborhood', 'city', 'zip', 'complement'].indexOf(field) !== -1 && obj.hasOwnProperty('address') && obj.address.hasOwnProperty(field)) {
          csv += '"' + obj['address'][field] + '"' + this.csvSeparator;
          continue;
        }
        csv += this.addDefaultCsv(field, obj);
      }
      return csv;
    },
    addEventReport: function addEventReport(obj) {
      var csv = '';
      for (var field in this.csvHeaders.event) {
        if (field === 'status') {
          csv += '"' + (obj[field] === 0 ? 'Iniciado' : 'Finalizado') + '"' + this.csvSeparator;
          continue;
        }
        csv += this.addDefaultCsv(field, obj);
      }
      return csv;
    },
    addTicketReport: function addTicketReport(obj) {
      return this.addDefaultReport(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.ticket), obj);
    },
    addSurveysReport: function addSurveysReport(obj) {
      var csv = '';
      var headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.survey);
      if (this.maxSurveysCount === 0 || !obj) {
        for (var iterator = 0; iterator < this.maxSurveysCount; iterator++) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(headers), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var field = _step4.value;

              csv += this.addDefaultCsv(field, undefined);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
        return csv;
      }

      for (var _iterator5 = 0; _iterator5 < this.maxSurveysCount; _iterator5++) {
        var survey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_src_services_Helper__["c" /* flattenObject */])(obj[_iterator5]);
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(headers), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator6.next()).done); _iteratorNormalCompletion5 = true) {
            var _field = _step5.value;

            if (_field === 'status') {
              csv += survey[_field] === 'TODO' ? '"A FAZER" ' + this.csvSeparator : survey[_field] === 'FINISHED' ? '"FINALIZADO" ' + this.csvSeparator : '"-" ' + this.csvSeparator;
              continue;
            }

            if (_field === 'rankingNow') {
              if (this.reportData[this.event._id].tickets.hasOwnProperty(survey['customer._id'])) {
                console.log('ticket', this.reportData[this.event._id].tickets[survey['customer._id']][0]);
                csv += this.addDefaultCsv('rankingNow', this.reportData[this.event._id].tickets[survey['customer._id']][0]);
                console.log('default', this.addDefaultCsv('rankingNow', this.reportData[this.event._id].tickets[survey['customer._id']][0]));
              } else {
                csv += this.addDefaultCsv('rankingNow', undefined);
              }

              continue;
            }

            csv += this.addDefaultCsv(_field, survey);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      console.log('end surveys', csv);
      return csv;
    },
    addStockReport: function addStockReport(obj) {
      return this.addDefaultReport(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.stock), obj);
    },
    addManufacturerReport: function addManufacturerReport(obj) {
      return this.addDefaultReport(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.manufacturer), obj);
    },
    addLampsReport: function addLampsReport(lamps) {
      if (this.maxLampsCount === 0 || !lamps) {
        return '-' + this.csvSeparator + this.addDefaultReport(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.lamps), lamps);
      }

      var csv = '';
      csv += '' + lamps.reduce(function (sum, curr) {
        sum += curr.items.length;
        return sum;
      }, 0) + this.csvSeparator;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(lamps), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator7.next()).done); _iteratorNormalCompletion6 = true) {
          var lamp = _step6.value;

          var item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_src_services_Helper__["c" /* flattenObject */])(lamp);
          item.count = lamp.items.length;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.csvHeaders.lamps)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator8.next()).done); _iteratorNormalCompletion7 = true) {
              var field = _step7.value;

              csv += this.addDefaultCsv(field, item);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return csv;
    },
    addDefaultReport: function addDefaultReport(fields, obj) {
      var csv = '';
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(fields), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator9.next()).done); _iteratorNormalCompletion8 = true) {
          var field = _step8.value;

          csv += '' + this.addDefaultCsv(field, obj);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return csv;
    },
    addDefaultCsv: function addDefaultCsv(key, obj) {
      if (this.fieldInvalid(key, obj)) {
        return '"-"' + this.csvSeparator;
      }

      if (key === 'userId' && this.reportData[this.event._id].users.hasOwnProperty(obj[key])) {
        return '"' + this.reportData[this.event._id].users[obj[key]][0].name + '"' + this.csvSeparator;
      }

      if (this.fieldDate(key)) {
        return this.addDate(key, obj);
      }

      if (this.fieldBoolean(key, obj)) {
        return this.addBoolean(key, obj);
      }

      if (this.fieldNumber(key)) {
        return this.addNumber(key, obj);
      }

      return '"' + obj[key] + '"' + this.csvSeparator;
    },
    addDate: function addDate(key, obj) {
      if (!obj[key]) return '"-"' + this.csvSeparator;
      return '"' + this.$moment(obj[key]).format('L') + ' ' + this.$moment(obj[key]).format('LTS') + '"' + this.csvSeparator;
    },
    addBoolean: function addBoolean(key, obj) {
      if (obj[key] && obj[key].toString() === 'true') {
        return '"Sim"' + this.csvSeparator;
      }
      return '"Não"' + this.csvSeparator;
    },
    addNumber: function addNumber(key, obj) {
      return '"' + obj[key].replace('.', ',') + '"' + this.csvSeparator;
    },
    fieldDate: function fieldDate(key) {
      var fields = ['endDate', 'startDate', 'createdAt', 'dateTimeCeremony', 'documentedAt', 'dateInvoice', 'dateInvoicePowerCompany', 'updatedAt'];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(fields), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator10.next()).done); _iteratorNormalCompletion9 = true) {
          var field = _step9.value;

          if (key.includes(field)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return false;
    },
    fieldInvalid: function fieldInvalid(key, obj) {
      return !obj || !obj.hasOwnProperty(key) || typeof obj[key] === 'undefined';
    },
    fieldBoolean: function fieldBoolean(key, obj) {
      return obj[key] === null || obj[key].toString() === 'true' || obj[key].toString() === 'false' || key.includes('drawn') || key.includes('checkIn');
    },
    fieldNumber: function fieldNumber(key) {
      return key.includes('score');
    },
    getUserIdName: function getUserIdName(id) {
      return this.usersIdName.hasOwnProperty(id) ? this.usersIdName[id] : 'deletado';
    },
    defineReportDataObject: function defineReportDataObject(event) {
      if (this.reportData.hasOwnProperty(event._id)) return;

      this.reportData[event._id] = {
        customers: {},
        tickets: {},
        surveys: {},
        lamps: {},
        manufacturers: {},
        stocks: {},
        users: {}
      };
    }
  }),

  mounted: function mounted() {
    this.fetchProject('config');
  }
});

/***/ }),

/***/ "Zgsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_googleMaps_vue__ = __webpack_require__("Go7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_FiltersMap_vue__ = __webpack_require__("B4cI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_ApiEducacional_js__ = __webpack_require__("20hU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show-map',
  components: {
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_3_src_components_googleMaps_vue__["a" /* default */],
    FiltersMap: __WEBPACK_IMPORTED_MODULE_4_src_components_FiltersMap_vue__["a" /* default */]
  },
  data: function data() {
    return {
      load: false,
      eventId: '',
      eventsList: [],
      listSpeeches: [],
      userId: '',
      showMode: 'true',
      showGoogleMap: false
    };
  },

  props: {
    allTags: Array
  },
  watch: {
    dateRange: function dateRange(current) {
      this.getAllSpeeches(this.dateRange, this.tags);
    },
    tags: function tags(current) {
      this.getAllSpeeches(this.dateRange, this.tags);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchAll({
      'where': [{ role: { '$ne': 'superadmin' } }] });
    this.getAllSpeeches(this.dateRange);
    __WEBPACK_IMPORTED_MODULE_6_axios___default()({
      method: 'get',
      url: 'https://couch-trg.3e.eng.br/'
    }).then(function () {
      return _this.showGoogleMap = true;
    }).catch(function (e) {
      return _this.showGoogleMap = false;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('users', {
    user: 'selected'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    dateRange: 'rangeDate'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('tags', {
    tags: 'selecteds'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('events', {
    events: 'events',
    eventsOptions: 'optionsById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('eventsSpecifications', {
    eventsSpecifications: 'withGpsEventsSpecifications'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('surveys', {
    surveys: 'surveys'
  }), {
    listTags: function listTags() {
      return this.allTags;
    },
    speeches: function speeches() {
      if (this.listSpeeches.length > 0) {
        return this.listSpeeches.filter(function (item) {
          if (item.gps.lat && item.gps.lng) {
            return true;
          }
          return false;
        });
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('events', {
    fetchEventsWithSurveys: 'fetchEventsWithSurveys',
    fetchEvent: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('users', {
    fetchAll: 'fetchAll'
  }), {
    getAllSpeeches: function getAllSpeeches(dateRange, tags) {
      var _this2 = this;

      dateRange = this.formatDate(dateRange);
      if (tags) {
        tags = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tags).reduce(function (accumulate, current) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(current), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var c = _step.value;

              if (accumulate.indexOf(c) === -1) accumulate.push(c);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return accumulate;
        }, []);
      }
      __WEBPACK_IMPORTED_MODULE_5_src_services_ApiEducacional_js__["a" /* apiEduService */].getAll(dateRange, tags).then(function (res) {
        _this2.listSpeeches = res;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    formatDate: function formatDate(arr) {
      if (arr.length !== 0) {
        return arr.map(function (item) {
          return item.substr(0, 10);
        });
      }
    }
  })
});

/***/ }),

/***/ "ZzHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a+Fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row",staticStyle:{"justify-content":"center","margin-bottom":"50px"}},[_c('div',{staticClass:"col-xs-12"},[_c('FormIconTags')],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.eventsSpecifications,"default-sort":{prop: 'createdAt', order: 'descending'}}},[_c('el-table-column',{attrs:{"prop":"event.reference","label":"Referência","min-width":150}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"event.city","label":"Município","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tags","label":"Tags"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((Object.keys(scope.row.tags)),function(categorie){return _c('p',{staticClass:"tag-icon text-center"},[_vm._v("\n                "+_vm._s(_vm.tagsByCategories[categorie].find(function (item) { return item._id === scope.row.tags[categorie]; }).name)+"\n              ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gps","label":"GPS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              Latitude: "+_vm._s(scope.row.gps.lat)+" "),_c('br'),_vm._v("\n              Longitude: "+_vm._s(scope.row.gps.lng)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ações"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('router-link',{attrs:{"to":{name: 'eventsSpecifications.edit', params: {id: scope.row._id}}}},[_c('button',{staticClass:"btn btn-fill dropdown-toggle btn-icon"},[_vm._v("Modificar")])])],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v(" Mostrando de "+_vm._s(_vm.from + 1)+" até "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" no total.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a1X1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_PptPresenter__ = __webpack_require__("iMuy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnDownloadPptx',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tickets', {
    ticketsWinners: 'winners'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', { urlImages: 'urlImages' })),
  methods: {
    download: function download() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Confirmação',
                  html: 'Confirmar download da apresentação.',
                  type: 'info',
                  confirmButtonText: 'Iniciar',
                  showCloseButton: true,
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return __WEBPACK_IMPORTED_MODULE_4_src_services_PptPresenter__["a" /* default */].make(_this.ticketsWinners, _this.customers, 'Ganhadores', _this.urlImages);

                            case 2:
                              return _context.abrupt('return', 'ok');

                            case 3:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function preConfirm() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "a3Ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableActionsEvents_vue__ = __webpack_require__("7Iex");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d688cd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableActionsEvents_vue__ = __webpack_require__("QHxG");
function injectStyle (ssrContext) {
  __webpack_require__("DFXt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d688cd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableActionsEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d688cd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableActionsEvents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a7Pg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleRemoveAttachmentFromLamps: function handleRemoveAttachmentFromLamps() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('tickets').all().then(function (docs) {
        _this.isLoading = false;
        var docsFiltered = docs.filter(function (doc) {
          if (doc.eligible === undefined) {
            return true;
          }
          return false;
        });
        _this.total = docsFiltered.length;
        var swalOptions = {
          title: 'Existem ' + docsFiltered.length + ' tickets sem o campo eligible.'
        };
        if (docsFiltered.length === 0) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todos os tickets tem o campo eligigle.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA adicionar eligible=true em todos os tickets?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, faça isso!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docsFiltered);

                  case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context.next = 12;
                      break;
                    }

                    item = _step.value;
                    _context.next = 9;
                    return _this.exec(item).then(function (result) {
                      if (_this.progress === _this.total) {
                        _this.notifyFinish();
                      }
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 9:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                  case 12:
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 18:
                    _context.prev = 18;
                    _context.prev = 19;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 21:
                    _context.prev = 21;

                    if (!_didIteratorError) {
                      _context.next = 24;
                      break;
                    }

                    throw _iteratorError;

                  case 24:
                    return _context.finish(21);

                  case 25:
                    return _context.finish(18);

                  case 26:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var update;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].update(item._id, {
                  eligible: true
                });

              case 2:
                update = _context2.sent;

                _this2.progress++;
                return _context2.abrupt('return', update);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todos os tickets foram alterados.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "a8eF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      defaultPagination: 3,
      infoPagination: 5
    };
  }
});

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aExq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingFile),expression:"isLoadingFile"}]},[_c('input',{ref:"filesContainer",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/pdf, image/*, .zip","multiple":""},on:{"change":_vm.handleFiles}}),_vm._v(" "),_c('a',{staticClass:"btn btn-fill",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$refs.filesContainer.click()}}},[_vm._v("Selecionar Arquivos")]),_vm._v(" "),_vm._l((_vm.selectedFiles),function(selectedFile){return _c('span',{key:selectedFile},[_vm._v("\n    "+_vm._s(selectedFile)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aF1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampTermGeneric',

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },
    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', ['customer']), {
    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "aSi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadOldPresenter_vue__ = __webpack_require__("D9Mi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47265ef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadOldPresenter_vue__ = __webpack_require__("7uvx");
function injectStyle (ssrContext) {
  __webpack_require__("6CxW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47265ef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadOldPresenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47265ef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadOldPresenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aVfg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aX02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-iasc-pi',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', ['customer']), {

    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },

    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética Do Piaui';
    },
    abbreviation: function abbreviation() {
      return 'CEPISA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Av.',
        street: 'Maranhão',
        number: '759',
        neighborhood: 'Centro',
        city: 'Teresina',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '068.407.480/0001-89';
    },
    numberState: function numberState() {
      return '193013835';
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "ahWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputTag__ = __webpack_require__("shfF");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-list',
  props: {
    checkeds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  model: {
    prop: 'checkeds',
    event: 'change'
  },
  data: function data() {
    return {
      selecteds: []
    };
  },

  components: {
    Tag: __WEBPACK_IMPORTED_MODULE_2__InputTag__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tags', ['fetchAll'])),
  watch: {
    checkeds: function checkeds() {
      this.selecteds = this.checkeds;
    }
  },
  computed: {
    tags: {
      get: function get() {
        return this.$store.state.tags.all;
      }
    }
  },
  mounted: function mounted() {
    this.fetchAll();
    this.selecteds = [];
  }
});

/***/ }),

/***/ "ajk5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EventTickets"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-8"},[_c('div',{},[_c('event-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingTicket),expression:"loadingTicket"}],attrs:{"event":_vm.event}}),_vm._v(" "),(_vm.event.registerCustomerByCsv)?_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('btn-customers-import')],1)]):_vm._e()],1),_vm._v(" "),(_vm.event.confirmCustomerByCsv)?_c('div',{},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('btn-tickets-confirm')],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingTicket),expression:"loadingTicket"}],staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingTicket),expression:"loadingTicket"}],staticClass:"card-content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-12"},[_c('event-actions',{attrs:{"event":_vm.event},on:{"fetchTickets":function($event){return _vm.fetch()},"documentsDownload":function($event){return _vm.handleDocumentsDownload()}}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(_vm.customerIsObject)?_c('tickets-list',{attrs:{"tickets":_vm.tickets,"customers":_vm.customers,"event":_vm.event,"scope":"event"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"canvasPlace"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Importar Clientes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-ticket"}),_vm._v(" Confirmar Tickets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-list"}),_vm._v(" Ações")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "alEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.confirmPassword),expression:"modelValidations.confirmPassword"},{name:"model",rawName:"v-model",value:(_vm.model.confirmPassword),expression:"model.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","name":"confirm"},domProps:{"value":(_vm.model.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirm.invalid),expression:"confirm.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('confirm'))+"\n        ")])]),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")])],1),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Register")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "atjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");



var Calendar = function Calendar() {
  return {
    component: __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "dYRv")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 100
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Calendar: Calendar
  }
});

/***/ }),

/***/ "b/ob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingList_vue__ = __webpack_require__("tGkH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea183b8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingList_vue__ = __webpack_require__("xyxi");
function injectStyle (ssrContext) {
  __webpack_require__("F/hw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea183b8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea183b8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b2e4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b7lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("3sUy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6dda36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("DN+u");
function injectStyle (ssrContext) {
  __webpack_require__("LiVc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b6dda36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6dda36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b8iA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGFk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bJ0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "bK5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bMjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket.stockId)?_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Imprimir documentação"},on:{"click":function($event){return _vm.handleDocumentsPrint()}}},[_c('i',{staticClass:"ti-files"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bN9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.survey.status === 'FINISHED')?_c('div',{staticClass:"survey-status-icons"},[(_vm.alert)?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v("Cliente com alerta")]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"ti-alert text-danger"})])]):_vm._e(),_vm._v(" "),(!_vm.absent && _vm.accepted)?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v("Nota: "+_vm._s(_vm.score))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"ti-check text-success"})])]):_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v("Motivo: "+_vm._s(_vm.reason))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"ti-close text-danger"})])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bODI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_handlers__ = __webpack_require__("4H+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__("m/Dq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__ = __webpack_require__("GI50");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_props__ = __webpack_require__("Ep3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_watchers__ = __webpack_require__("NFS3");










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agile',

	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_handlers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_watchers__["a" /* default */]],

	data: function data() {
		return {
			slides: [],
			slidesClonedBefore: [],
			slidesClonedAfter: [],
			autoplayInterval: null,
			autoplayTimeout: null,
			pauseAutoPlay: false,
			autoplayStart: null,
			autoplayRemaining: null,

			currentSlide: null,
			mouseDown: false,
			dragStartX: 0,
			dragStartY: 0,
			dragDistance: 0,
			swipeDistance: 50,
			translateX: 0,
			transitionDelay: 0,
			widthWindow: 0,
			widthContainer: 0,
			widthSlide: 0,
			settings: {}
		};
	},


	computed: {
		canGoToPrev: function canGoToPrev() {
			return this.settings.infinite || this.currentSlide > 0;
		},

		canGoToNext: function canGoToNext() {
			return this.settings.infinite || this.currentSlide < this.slidesCount - 1;
		},

		clonedSlides: function clonedSlides() {
			return !this.settings.unagile && !this.settings.fade && this.settings.infinite;
		},

		breakpoints: function breakpoints() {
			return !this.initialSettings.responsive ? [] : this.initialSettings.responsive.map(function (item) {
				return item.breakpoint;
			});
		},

		currentBreakpoint: function currentBreakpoint() {
			var _this = this;

			var breakpoints = this.breakpoints.map(function (item) {
				return item;
			}).reverse();
			return this.initialSettings.mobileFirst ? breakpoints.find(function (item) {
				return item < _this.widthWindow;
			}) || 0 : breakpoints.find(function (item) {
				return item > _this.widthWindow;
			}) || null;
		},

		allSlides: function allSlides() {
			return this.clonedSlides ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedBefore), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slides), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedAfter)) : this.slides;
		},

		slidesCount: function slidesCount() {
			return this.slides.length;
		},

		allSlidesCount: function allSlidesCount() {
			return this.allSlides.length;
		},

		marginX: function marginX() {
			var marginX = this.clonedSlides ? this.slidesCount * this.widthSlide : 0;

			if (this.settings.centerMode) {
				marginX -= (Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0)) * this.widthSlide;
			}

			return this.settings.rtl ? marginX : -1 * marginX;
		}
	},

	created: function created() {
		if (this.options) {
			for (var key in this.options) {
				this.initialSettings[key] = this.options[key];
			}
		}

		if (this.initialSettings.responsive) {
			this.initialSettings.responsive.sort(this.compare);
		}

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.settings, this.initialSettings);
	},
	mounted: function mounted() {
		window.addEventListener('resize', this.getWidth);

		if ('ontouchstart' in window) {
			this.$refs.track.addEventListener('touchstart', this.handleMouseDown);
			this.$refs.track.addEventListener('touchend', this.handleMouseUp);
			this.$refs.track.addEventListener('touchmove', this.handleMouseMove);
		} else {
			this.$refs.track.addEventListener('mousedown', this.handleMouseDown);
			this.$refs.track.addEventListener('mouseup', this.handleMouseUp);
			this.$refs.track.addEventListener('mousemove', this.handleMouseMove);
		}

		this.reload();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.getWidth);

		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchstart' : 'mousedown', this.handleMouseDown);
		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchend' : 'mouseup', this.handleMouseUp);
		this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchmove' : 'mousemove', this.handleMouseMove);

		this.disableAutoPlay();
	},


	methods: {
		reload: function reload() {
			this.getWidth();
			this.prepareSettings();
			this.prepareSlides();
			this.prepareCarousel();
			this.toggleFade();
		},
		toggleFade: function toggleFade() {
			var enabled = !this.settings.unagile && this.settings.fade;

			for (var i = 0; i < this.slidesCount; i++) {
				this.slides[i].style.transition = enabled ? 'opacity ' + this.settings.timing + ' ' + this.settings.speed + 'ms' : 'none';
				this.slides[i].style.transform = enabled ? 'translate(-' + i * this.widthSlide + 'px)' : 'none';
			}
		},
		toggleAutoPlay: function toggleAutoPlay() {
			var _this2 = this;

			var enabled = !this.settings.unagile && this.settings.autoplay;

			if (!this.autoplayInterval && enabled) {
				this.autoplayInterval = setInterval(function () {
					if (!document.hidden) {
						if (!_this2.canGoToNext) {
							_this2.disableAutoPlay();
						} else {
							_this2.goToNext();
						}
					}
				}, this.settings.autoplaySpeed);
			} else {
				this.disableAutoPlay();
			}
		},
		restartAutoPlay: function restartAutoPlay() {
			this.disableAutoPlay();
			this.toggleAutoPlay();
		},
		disableAutoPlay: function disableAutoPlay() {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		},
		clearAutoPlayPause: function clearAutoPlayPause() {
			clearTimeout(this.autoplayTimeout);
			this.autoplayRemaining = null;
		},
		disableScroll: function disableScroll() {
			document.ontouchmove = function (e) {
				return e.preventDefault();
			};
		},
		enableScroll: function enableScroll() {
			document.ontouchmove = function () {
				return true;
			};
		},
		getCurrentSlide: function getCurrentSlide() {
			return this.currentSlide;
		},
		getCurrentBreakpoint: function getCurrentBreakpoint() {
			return this.currentBreakpoint;
		},
		getCurrentSettings: function getCurrentSettings() {
			return this.settings;
		},
		getInitialSettings: function getInitialSettings() {
			return this.initialSettings;
		},
		goToNext: function goToNext() {
			if (this.canGoToNext) {
				this.goTo(this.currentSlide + 1);
			}
		},
		goToPrev: function goToPrev() {
			if (this.canGoToPrev) {
				this.goTo(this.currentSlide - 1);
			}
		},
		goTo: function goTo(n) {
			var _this3 = this;

			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var asNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (this.settings.unagile) {
				return false;
			}

			if (!asNav) {
				this.settings.asNavFor.forEach(function (carousel) {
					if (carousel) {
						carousel.goTo(n, transition, true);
					}
				});
			}

			var realNextSlide = n;

			if (transition) {
				if (this.settings.infinite && n < 0) {
					realNextSlide = this.slidesCount - 1;
				} else if (n >= this.slidesCount) {
					realNextSlide = 0;
				}

				this.$emit('beforeChange', { currentSlide: this.currentSlide, nextSlide: realNextSlide });

				this.currentSlide = realNextSlide;

				if (n !== realNextSlide) {
					setTimeout(function () {
						_this3.goTo(realNextSlide, false);
					}, this.settings.speed);
				}
			}

			var translateX = !this.settings.fade ? n * this.widthSlide * this.settings.slidesToScroll : 0;
			this.transitionDelay = transition ? this.speed : 0;
			this.translateX = this.settings.rtl ? translateX : -1 * translateX;
		}
	}
});

/***/ }),

/***/ "bQRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Tag_Tag_vue__ = __webpack_require__("QbX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_ConfigurationsPages_Tag_TagForm_vue__ = __webpack_require__("Rmzk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_ConfigurationsPages_Tag_TagIndex_vue__ = __webpack_require__("P1NZ");




var path = 'tags';
var title = 'Tags';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_ConfigurationsPages_Tag_Tag_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_ConfigurationsPages_Tag_TagIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_ConfigurationsPages_Tag_TagForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_ConfigurationsPages_Tag_TagForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "bTbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bUeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bVnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadioColors',
  model: {
    prop: 'colorSelected',
    event: 'setColor'
  },
  props: {
    colorSelected: String
  },
  data: function data() {
    return {
      colors: ['Primary', 'Success', 'Warning', 'Danger', 'Info']
    };
  },

  computed: {
    color: function color() {
      return this.colorSelected;
    }
  },
  methods: {
    setColor: function setColor(cor) {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('setColor', cor);
      });
    }
  }
});

/***/ }),

/***/ "bZk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services_ValidationRules__ = __webpack_require__("ulVI");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'initial-data-form',

  data: function data() {
    return {};
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['uc', 'cpf']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', {
    model: 'customer',
    modelValidations: 'validations',
    loading: 'loading'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('customers', ['fetchOne', 'resetOne', 'insert', 'update']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }),

  created: function created() {
    this.$validator.extend('cpf', __WEBPACK_IMPORTED_MODULE_3_src_services_ValidationRules__["a" /* cpfIsValidRule */]);
  },
  mounted: function mounted() {
    if (this.editing) {
      this.fetchOne(this.id);
    } else {
      this.resetOne();
    }
  }
});

/***/ }),

/***/ "bdc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term-cemar",staticStyle:{"margin":"0.5cm"}},[_c('p',[_vm._v(_vm._s(_vm.ticket.event.city)+", "+_vm._s(_vm._f("moment")(new Date(),'LL')))]),_vm._v(" "),_c('p',[_vm._v("\n    É com grande satisfação que comunicamos que o Sr(a) "+_vm._s(_vm.ticket.customer.holder)+", C/C "+_vm._s(_vm.ticket.customer.uc)+",\n    CPF "+_vm._s(_vm.ticket.customer.cpf)+", foi contemplado no "+_vm._s(_vm.projectName)+", que prevê a substituição da sua geladeira\n    antiga, com maior consumo de energia, por uma geladeira nova, mais eficiente e com selo Procel classe A em\n    economia de energia. Assim como você, entre agosto/2018 e agosto/2019 também serão beneficiadas mais de 8.000\n    famílias de comunidades baixa em municípios Maranhenses e bairros da grande São Luís.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Essas ações confirmam, mais uma vez, o compromisso da "+_vm._s(_vm.shortName)+" em entender as necessidades dos seus clientes, através\n    de campanhas de eficientização energética. O "+_vm._s(_vm.projectName)+", regulamentado pela Agência Nacional de Energia\n    Elétrica ANEEL, tem como objetivo reduzir o consumo, disseminar a cultura do uso racional da\n    energia elétrica, além de proteger o meio ambiente, descartando as geladeiras antigas de forma ecologicamente\n    correta. Tudo de acordo com a legislação do Conselho Nacional de Meio Ambiente (CONAMA)  proporcionando qualidade\n    na distribuição de energia elétrica que é essencial para o conforto dos maranhenses e para o desenvolvimento do\n    nosso Estado.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Traga sua geladeira do dia "+_vm._s(_vm.dateTimeDelivery)+", juntamente com a última conta de energia, documento de\n    identidade e CPF. A "+_vm._s(_vm.shortName)+" conta com sua presença.\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O benefício da geladeira está condicionada a autorização do titular da conta para realização de medições nas\n      geladeiras após a troca, com o objetivo de determinar o percentual de economia.\n    ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n        Caso você não compareça no dia e hora marcados ("+_vm._s(_vm.dateTimeDelivery)+") perderá o benefício.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Não é possível retirar a geladeira nova em outro dia ou horário diferente do estabelecido ("+_vm._s(_vm.dateTimeDelivery)+").\n      ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}})],1),_vm._v(" "),_vm._m(1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("PONTOS IMPORTANTES:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bjCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoteConfigProject_vue__ = __webpack_require__("9W3/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d74271_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoteConfigProject_vue__ = __webpack_require__("lr+1");
function injectStyle (ssrContext) {
  __webpack_require__("ef8Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62d74271"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoteConfigProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d74271_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoteConfigProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bjfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnTakePhotos_vue__ = __webpack_require__("W5W7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79fc08a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnTakePhotos_vue__ = __webpack_require__("civ+");
function injectStyle (ssrContext) {
  __webpack_require__("Eg3L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79fc08a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnTakePhotos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79fc08a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnTakePhotos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bkdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YesNoRadio_vue__ = __webpack_require__("qNyY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1c2b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YesNoRadio_vue__ = __webpack_require__("+Igr");
function injectStyle (ssrContext) {
  __webpack_require__("goSf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c1c2b74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YesNoRadio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1c2b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YesNoRadio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bplT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "brqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-print-winners',

  computed: {
    eventId: function eventId() {
      return this.$route.params.id;
    },


    tickets: {
      get: function get() {
        var _this = this;

        return this.$store.state.tickets.all.filter(function (ticket) {
          return _this.surveys.find(function (survey) {
            return survey.ticketId === ticket._id;
          }) && ticket.eligible && ticket.winner;
        }).sort(function (a, b) {
          return a.rankingNow - b.rankingNow;
        }).map(function (ticket) {
          ticket.survey = _this.surveys.find(function (survey) {
            return survey.ticketId === ticket._id;
          });
          return ticket;
        });
      }
    },

    surveys: {
      get: function get() {
        return this.$store.state.surveys.all.filter(function (survey) {
          return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && survey.data.accepted && survey.data.accepted !== 'false';
        });
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tickets', ['fetchTicketsWithCustomersByEvent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('surveys', {
    fetchSurveys: 'fetchAll'
  }), {
    getPhones: function getPhones(customer) {
      return customer.phones.join(' / ');
    }
  }),

  mounted: function mounted() {
    this.fetchTicketsWithCustomersByEvent({
      where: {
        eligible: true,
        surveyAssociated: true
      },
      eventId: this.eventId
    });

    this.fetchSurveys({
      where: [{ 'event._id': this.eventId }]
    });
  }
});

/***/ }),

/***/ "buCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__("q62M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498a8fcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__("2dMR");
function injectStyle (ssrContext) {
  __webpack_require__("o5KC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498a8fcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bvnp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RouterButton',
  functional: true,
  props: {
    title: {
      required: true
    },
    to: {
      required: true
    },
    classStyle: {
      default: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        btn: true,
        'btn-block': true,
        'btn-flat': true,
        'btn-icon': false
      }, 'btn-default', true)
    },
    iconClass: {
      default: ''
    }
  },

  render: function render(createElement, context) {
    var h = arguments[0];

    return h(
      'router-link',
      {
        attrs: { to: context.props.to }
      },
      [h(
        'button',
        { 'class': context.props.classStyle, attrs: { title: context.props.title }
        },
        [h('i', { 'class': context.props.iconClass }), context.props.title]
      )]
    );
  }
});

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("9nxM");
function injectStyle (ssrContext) {
  __webpack_require__("idYH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "bxZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendar')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c+12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commands_vue__ = __webpack_require__("duz3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236b6562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commands_vue__ = __webpack_require__("XLuJ");
function injectStyle (ssrContext) {
  __webpack_require__("p6+/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236b6562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/JZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManufacturersForm_vue__ = __webpack_require__("qzb1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a18d05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManufacturersForm_vue__ = __webpack_require__("KWQy");
function injectStyle (ssrContext) {
  __webpack_require__("LpN4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManufacturersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a18d05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManufacturersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c3u+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c4e9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9xE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Documents_SignatureCustomerTicket__ = __webpack_require__("Dlhx");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'participation-term-cemar',

  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_0_src_pages_Documents_SignatureCustomerTicket__["a" /* default */] },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  data: function data() {
    return {
      projectName: 'Programa de Eficiência Energética da CEMAR',
      shortName: 'CEMAR',
      numCities: 4,
      numFamilies: '600 mil',
      finance: '7 milhões',
      birthplace: 'maranhense',
      deliverDate: 'Amanhã é o grande dia'
    };
  },


  computed: {
    dateTimeDelivery: function dateTimeDelivery() {
      return this.ticket.event.dateTimeDelivery && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(new Date(this.ticket.event.dateTimeDelivery)).format('LLL') : 'definido pelos membros da equipe';
    }
  },

  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  }
});

/***/ }),

/***/ "cBRn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cLmq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_vuex_baseModule__ = __webpack_require__("tv5d");




var collection = 'ranking';

var model = {
  winners: [],
  reserves: [],
  canceled: []
};

var getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_vuex_baseModule__["d" /* mapGetters */])()), {
  loading: function loading(state) {
    return state.loading;
  }
});

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_vuex_baseModule__["b" /* mapMutations */])(), {
  setWinners: function setWinners(state, payload) {
    state.winners = payload;
  },
  setReserves: function setReserves(state, payload) {
    state.reserve = payload;
  },
  setCanceled: function setCanceled(state, payload) {
    state.canceled = payload;
  }
}));

var actions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_vuex_baseModule__["c" /* mapActions */])(collection, model), {
  setRanking: function setRanking(_ref, _ref2) {
    var commit = _ref.commit;
    var winners = _ref2.winners,
        reserves = _ref2.reserves,
        canceled = _ref2.canceled;

    if (winners) {
      commit('setWinners', winners);
    }
    if (reserves) {
      commit('setReserves', reserves);
    }
    if (canceled) {
      commit('setCanceled', canceled);
    }
  }
}));

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_vuex_baseModule__["a" /* mapStates */])(), {
    loading: false,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    count: 0
  }),
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ "cOy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticketsCustomer.length > 0)?_c('div',{staticClass:"all-tickets-document-class"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},_vm._l((_vm.tickets),function(value,index){return _c('div',{key:index},[_c('ticket-document',{attrs:{"loading":_vm.loading,"ticket":value}}),_vm._v(" "),_c('div',{staticClass:"page-break"})],1)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cP1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"associated-tickets-print col-xs-12"},_vm._l((_vm.surveyTakenIds),function(surveyTaken,indx){return (_vm.loaded)?_c('div',{key:indx},[_c('h5',[_vm._v("Pesquisador: "+_vm._s(_vm.surveys[surveyTaken][0].user.name))]),_vm._v(" "),_c('table',[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((_vm.surveys[surveyTaken]),function(survey,index){return _c('tr',{key:index,class:index % 2 === 0 ? 'bg-line' : ''},[_c('td',{attrs:{"width":"5%"}},[_vm._v(_vm._s(indx + 1)+"-"+_vm._s(index + 1))]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.customers[survey.customer._id].uc ? _vm.customers[survey.customer._id].uc : ' '))]),_vm._v(" "),_c('td',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.customers[survey.customer._id].holder ? _vm.customers[survey.customer._id].holder : ' '))]),_vm._v(" "),_c('td',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.getAddress(_vm.customers[survey.customer._id])))]),_vm._v(" "),_c('td',{attrs:{"width":"25%"}},[_vm._v(_vm._s(_vm.customers[survey.customer._id].address.complement ? _vm.customers[survey.customer._id].address.complement : ' '))]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.customers[survey.customer._id].phone1 ? _vm.customers[survey.customer._id].phone1 : ' ')+" - "+_vm._s(_vm.customers[survey.customer._id].phone2 ? _vm.customers[survey.customer._id].phone2 : ' '))]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.customers[survey.customer._id].aka ? _vm.customers[survey.customer._id].aka : ' '))])])}),0)]),_vm._v(" "),(indx < _vm.surveyTakenIds.length)?_c('div',{staticClass:"page-break"}):_vm._e()]):_vm._e()}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v(" Ord.")]),_vm._v(" "),_c('th',[_vm._v(" UC")]),_vm._v(" "),_c('th',[_vm._v(" Nome")]),_vm._v(" "),_c('th',[_vm._v(" Endereço Completo")]),_vm._v(" "),_c('th',[_vm._v(" Ponto de referência")]),_vm._v(" "),_c('th',[_vm._v(" Contatos")]),_vm._v(" "),_c('th',[_vm._v(" Apelido")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cQIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.view.presenter'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-pptx btn-block btn-router",on:{"click":function($event){return _vm.download()}}},[_vm._v("\n  PPT Ganhadores\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cQlH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc-pi',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética Do Piaui';
    },
    abbreviation: function abbreviation() {
      return 'CEPISA';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Av.',
        street: 'Maranhão',
        number: '759',
        neighborhood: 'Centro',
        city: 'Teresina',
        state: 'PI'
      };
    },
    cnpj: function cnpj() {
      return '068.407.480/0001-89';
    },
    numberState: function numberState() {
      return '193013835';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "cWPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wd btn-fill btn-info",attrs:{"disabled":(_vm.loading || !_vm.eventSelected)},on:{"click":function($event){return _vm.runReport()}}},[_vm._v("\n  Gerar relatório de lâmpadas\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cbLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InactivateUserAction_vue__ = __webpack_require__("AXOe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a7236e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InactivateUserAction_vue__ = __webpack_require__("YKxY");
function injectStyle (ssrContext) {
  __webpack_require__("cc2/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a7236e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InactivateUserAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a7236e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InactivateUserAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cc2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ciIM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "civ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-fill btn-block",attrs:{"disabled":_vm.loading || _vm.unableToSend,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showImage()}}},[_vm._v("\n    Tirar Foto\n  ")]),_vm._v(" "),(_vm.canTakeAnotherPhoto)?_c('el-dialog',{attrs:{"title":"Tirar fotos dos documentos","visible":_vm.showImageCapture,"modal-append-to-body":false,"width":"50%","modal":true},on:{"update:visible":function($event){_vm.showImageCapture=$event}}},[_c('customer-image-capture',{on:{"on-image-captured":function($event){return _vm.handleSave($event)}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cjJV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveysIndex_vue__ = __webpack_require__("fX7d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db388ec4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveysIndex_vue__ = __webpack_require__("RV5+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveysIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db388ec4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveysIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cksC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-enel"},[_c('HeaderTerm',{attrs:{"imgsrc":"/static/img/cema-logo.png","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.company))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n            ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v(" "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('h6',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('h6',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cl5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLottery && _vm.$can('events.lottery'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block",attrs:{"disabled":_vm.insufficientTickets},on:{"click":function($event){return _vm.handleRunLottery()}}},[_vm._v("\n  Realizar Sorteio\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ctSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableCategories__ = __webpack_require__("53aJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show-categories',

  components: {
    TableCategories: __WEBPACK_IMPORTED_MODULE_1__TableCategories__["a" /* default */]
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('categories', {
    fetchCategories: 'fetchAll'
  }), {
    fetch: function fetch() {
      this.fetchCategories({
        limit: 99999,
        sort: {
          field: 'createdAt',
          direction: 'desc'
        }
      });
    }
  }),

  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ "ctsD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalDataForm_vue__ = __webpack_require__("MUnC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479fe4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalDataForm_vue__ = __webpack_require__("OR7l");
function injectStyle (ssrContext) {
  __webpack_require__("TbQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalDataForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479fe4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalDataForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cxw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term-enel"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":"/static/img/enel-compartilha-logo.gif","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.company)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.address)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cpnj)+" e Inscrição Estadual no. "+_vm._s(_vm.stateRegistration)+", doravante denominada "+_vm._s(_vm.shortname)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", Ceará, UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.config.name)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.config.name)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3"},[_c('img',{staticClass:"img-responsive",attrs:{"src":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d8qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dATB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'general-counter-report',

  data: function data() {
    return {
      csv: '',
      limitator: ',',
      events: {},
      lamps: {},
      tickets: {},
      refrigerators: {},
      tags: [],
      headers: ['"Evento"', '"Local do evento"', '"Munic\xEDpio"', '"Estado do evento"', '"Data do in\xEDcio do vento"', '"Data do fim do evento"', '"Quantidade de geladeira"', '"Tickets gerados"', '"L\xE2mpadas trocadas"']
    };
  },


  computed: {
    eventLabel: function eventLabel() {
      return localStorage.getItem('eventLabel') || 'Ações';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('tags', {
    fetchTags: 'fetchAll'
  }), {
    handleReport: function handleReport() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Informações',
        text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        onOpen: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.showLoading();

                    _this.resetValues();
                    _context.next = 4;
                    return _this.fetchData();

                  case 4:
                    _this.createReport();
                    _this.download();

                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.hideLoading();
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.close();

                  case 8:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function onOpen() {
            return _ref.apply(this, arguments);
          };
        }()
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.fetchEvents();

                case 2:
                  _context2.next = 4;
                  return _this2.fetchAmmounts();

                case 4:
                  _context2.next = 6;
                  return _this2.fetchTags({ limit: 999 }).then(function (res) {
                    return _this2.tags = res.map(function (item) {
                      return item.name.toUpperCase();
                    }).sort(function (a, b) {
                      return a.localeCompare(b);
                    });
                  });

                case 6:
                  resolve(true);

                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    fetchEvents: function fetchEvents() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.fetchPromiseView('events-by-id').then(function (res) {
          _this3.events = res.map(function (item) {
            return item.value;
          }).reduce(function (accum, curr) {
            return _this3.reduceObjectById(accum, curr);
          }, {});

          resolve(true);
        }).catch(function (err) {
          console.log('Não foi possível consultar os eventos');
          err = null;
          resolve(false);
        });
      });
    },
    fetchAmmounts: function fetchAmmounts() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.fetchTicketsCount();

              case 2:
                _context3.next = 4;
                return _this4.fetchLamps();

              case 4:
                _context3.next = 6;
                return _this4.fetchRefrigerators();

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    fetchTicketsCount: function fetchTicketsCount() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this5.fetchPromiseView('counter-events-tickets', true).then(function (res) {
          _this5.tickets = res.reduce(function (acc, curr) {
            return _this5.reduceObjectByKey(acc, curr);
          }, {});
          resolve(true);
        }).catch(function (err) {
          console.log('Ocorreu um erro ao coletar os tickets');
          console.log(err);
          resolve(false);
        });
      });
    },
    fetchLamps: function fetchLamps() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this6.fetchPromiseView('counter-events-lamps', true).then(function (res) {
          _this6.lamps = res.reduce(function (acc, curr) {
            return _this6.reduceObjectByKey(acc, curr);
          }, {});
          resolve(true);
        }).catch(function (err) {
          console.log('Ocorreu um erro ao coletar os tickets');
          console.log(err);
          resolve(false);
        });
      });
    },
    fetchRefrigerators: function fetchRefrigerators() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this7.fetchPromiseView('counter-events-refrigerators', true).then(function (res) {
          _this7.refrigerators = res.reduce(function (acc, curr) {
            return _this7.reduceObjectByKey(acc, curr);
          }, {});
          resolve(true);
        }).catch(function (err) {
          console.log('Ocorreu um erro ao coletar os tickets');
          console.log(err);
          resolve(false);
        });
      });
    },
    fetchPromiseView: function fetchPromiseView(ddocView) {
      var reduce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].viewQueries({
          connection: 'default',
          ddoc: ddocView,
          view: ddocView,
          queries: [{ reduce: reduce, group: reduce }]
        }).then(function (res) {
          if (res[0].rows) resolve(res[0].rows);
          resolve(false);
        }).catch(function (err) {
          console.log(ddocView, err);
          resolve(false);
        });
      });
    },
    resetValues: function resetValues() {
      this.events = {};
    },
    reduceObjectById: function reduceObjectById(accum, curr) {
      accum[curr._id] = curr;
      return accum;
    },
    reduceObjectByKey: function reduceObjectByKey(accum, curr) {
      var key = curr.key;
      accum[key] = curr.value;
      return accum;
    },
    createReport: function createReport() {
      this.setHeaders();
      this.setRows();
      this.setGeneratedTime();
    },
    setHeaders: function setHeaders() {
      this.csv = this.headers.concat(this.tags).join(this.limitator);
      this.csv += '\n';
    },
    setRows: function setRows() {
      for (var idEvent in this.events) {
        this.setRow(this.events[idEvent]);
      }
    },
    setRow: function setRow(event) {
      var _this8 = this;

      this.csv += '"' + event.reference + '"' + this.limitator;
      this.csv += '"' + event.place + '"' + this.limitator;
      this.csv += '"' + event.city + '"' + this.limitator;
      this.csv += '"' + (event.status === 2 ? 'Finalizado' : 'Iniciado') + '"' + this.limitator;
      this.csv += '"' + this.$moment(event.startDate).format('L') + ' ' + this.$moment(event.startDate).format('LTS') + '"' + this.limitator;
      this.csv += '"' + this.$moment(event.endDate).format('L') + ' ' + this.$moment(event.endDate).format('LTS') + '"' + this.limitator;
      this.csv += '' + (this.refrigerators[event._id] ? this.refrigerators[event._id] : 0) + this.limitator;
      this.csv += '' + (this.tickets[event._id] ? this.tickets[event._id] : 0) + this.limitator;
      this.csv += '' + (this.lamps[event._id] ? this.lamps[event._id] : 0) + this.limitator;

      var _loop = function _loop(tag) {
        if (!event.hasOwnProperty('tags') || !event.tags.find(function (item) {
          return item.toUpperCase() === tag.toUpperCase();
        })) {
          _this8.csv += ' ' + _this8.limitator;
          return 'continue';
        }
        console.log(event.tags, tag);
        _this8.csv += 'X ' + _this8.limitator;
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          var _ret = _loop(tag);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.csv += '\n';
      return true;
    },
    setGeneratedTime: function setGeneratedTime() {
      this.csv += '\n';
      this.csv += '"Relat\xF3rio solicitado em", ' + this.$moment(new Date()).format('LLL');
    },
    download: function download() {
      var blob = __WEBPACK_IMPORTED_MODULE_7_blob_util___default.a.createBlob([this.csv], { type: 'text/plain' });
      var now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss');
      var filename = 'Relat\xF3rio_Contagens_Por_Eventos_' + now;
      __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(blob, filename + '.csv');
    }
  })
});

/***/ }),

/***/ "dEu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__ = __webpack_require__("+L3V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca09ee0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__ = __webpack_require__("miz5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca09ee0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dHdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAttachments_vue__ = __webpack_require__("knXx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98eb540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAttachments_vue__ = __webpack_require__("Rj96");
function injectStyle (ssrContext) {
  __webpack_require__("on/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAttachments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98eb540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAttachments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dLys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"title":"Essa rotina remove todos os attachments vazios de lâmpadas."},on:{"click":function($event){return _vm.handleRemoveAttachmentFromLamps()}}},[_vm._v("\n    Remover Attachments Vazios de Lâmpadas\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dM8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_showMap_vue__ = __webpack_require__("HUXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Dashboard_CountCards__ = __webpack_require__("WPqJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Dashboard_DashboardFilter__ = __webpack_require__("o1ms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_ApiEducacional_js__ = __webpack_require__("20hU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_services_DashboardCounter__ = __webpack_require__("fzNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GalleryComponent__ = __webpack_require__("Z1yA");














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CountCards: __WEBPACK_IMPORTED_MODULE_4_src_pages_Dashboard_CountCards__["a" /* default */],
    ShowMap: __WEBPACK_IMPORTED_MODULE_3_src_components_showMap_vue__["a" /* default */],
    DashboardFilter: __WEBPACK_IMPORTED_MODULE_5_src_pages_Dashboard_DashboardFilter__["a" /* default */],
    GalleryComponent: __WEBPACK_IMPORTED_MODULE_9__components_GalleryComponent__["a" /* default */]
  },

  data: function data() {
    return {
      inputDate: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('gallery', ['showGallery', 'imagesGallery', 'galleryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('eventsSpecifications', ['eventsSpecifications']), {
    projectOnline: function projectOnline() {
      return true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('tags', {
    tagsSelected: 'selecteds',
    tags: 'tags'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('categories', {
    categoriesApi: 'categoriesApi'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['rangeDate', 'user'])),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    openModal: function openModal(event) {
      console.log('abre modal caralho', event);
      this.indexGallery = event.index;
      this.infoContent = event.infoContent;
      this.showModal = true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['changeRange', 'setDatasApiEdu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('categories', { fetchCategories: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('customers', {
    fetchParticipantCount: 'fetchParticipantCount'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('events', {
    setAllFiltered: 'setAllFiltered',
    fetchEvents: 'fetchAll',
    fetchEventsIds: 'fetchIds'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('surveys', ['dashboardSurveysByFilter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('lamps', ['dashboardLampsByFilter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('users', ['dashboardUsersByFilter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tickets', ['dashboardTicketsByFilter', 'dashboardWinnerTicketsByFilter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tags', {
    setTags: 'setTagsDashboard'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('events', ['filterEventsByTags', 'filterEventsByDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('eventsSpecifications', { fetchSpecifications: 'fetchAll' }), {
    inputListeners: function inputListeners(val) {
      this.inputDate = val;
      this.fetch();
    },
    fetch: function fetch() {
      var _this = this;

      var formatedDate = [];
      if (this.rangeDate && this.rangeDate.length > 0) {
        formatedDate.push(new Date(this.rangeDate[0]).toISOString().replace('03:00:00', '00:00:00'));
        formatedDate.push(new Date(this.rangeDate[1]).toISOString().replace('03:00:00', '23:59:59'));
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_services_DashboardCounter__["a" /* verifyEmptyTags */])(this.tagsSelected)) {
        return this.fetchSpecifications({ limit: 99999 }).then(function () {
          return _this.getEventsBySpecificationsEventsIds(formatedDate).then(function (events) {
            return [_this.fetchCounters(events)];
          });
        });
      }

      this.changeRange(formatedDate);
      this.setTags({
        payload: this.tagsSelected,
        tags: this.tags
      });

      this.getEventsSpecifications().then(function () {
        _this.getEventsBySpecificationsEventsIds(formatedDate).then(function (events) {
          return [_this.fetchCounters(events)];
        });
      }).catch(function (err) {
        console.log('erro na busca do filtro', err);
      });

      this.fetchCounterByDate(formatedDate).catch(function (err) {
        return console.log(err);
      });
    },
    getEventsSpecifications: function getEventsSpecifications() {
      var whereTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_services_DashboardCounter__["b" /* defineWhereObject */])(undefined, this.tagsSelected, 'tagsIds');
      return this.fetchSpecifications({
        where: {
          '$and': whereTags['$and']
        },
        limit: 99999
      });
    },
    getEventsBySpecificationsEventsIds: function getEventsBySpecificationsEventsIds(formatedDate) {
      var whereQuery = [];
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_services_DashboardCounter__["a" /* verifyEmptyTags */])(this.tagsSelected)) {
        whereQuery.push({
          '$or': this.eventsSpecifications.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
              _id: item.eventId
            });
          })
        });
      }
      if (formatedDate && formatedDate.length === 2) {
        whereQuery.push({
          'startDate': {
            '$gte': formatedDate[0]
          }
        });
        whereQuery.push({
          'endDate': {
            '$lte': formatedDate[1]
          }
        });
      }

      return whereQuery.length > 0 ? this.fetchEvents({
        where: {
          '$and': whereQuery
        },
        limit: 99999999
      }) : this.fetchEvents({
        limit: 99999999
      });
    },
    fetchCounterByDate: function fetchCounterByDate(formatedDate) {
      var promises = [this.dashboardUsersByFilter({ dateRange: formatedDate })];
      if (true) {
        promises.push(this.getEventsEDUCount(formatedDate, this.tagsSelected));
        promises.push(this.getSpeechesEDUCount(formatedDate, this.tagsSelected));
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).catch(function (err) {
        console.log(err);
        return err;
      });
    },
    getTagsThroughCategories: function getTagsThroughCategories() {
      var _this2 = this;

      var tags = {};

      var _loop = function _loop(categorieId) {
        if (_this2.categoriesApi.find(function (item) {
          return item._id === categorieId;
        })) {
          tags[categorieId] = _this2.tagsSelected[categorieId];
        }
      };

      for (var categorieId in this.tagsSelected) {
        _loop(categorieId);
      }
      return tags;
    },
    getSpeechesEDUCount: function getSpeechesEDUCount(dateRange) {
      var _this3 = this;

      this.setDatasApiEdu({ loading: true });
      return __WEBPACK_IMPORTED_MODULE_7_src_services_ApiEducacional_js__["a" /* apiEduService */].getCountSpeeches({
        dateRange: this.formatDate(dateRange),
        tags: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_ApiEducacional_js__["b" /* defineApiEduPost */])(this.getTagsThroughCategories(), this.tags)
      }).then(function (res) {
        _this3.setDatasApiEdu({
          speeches: res,
          loading: false
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getEventsEDUCount: function getEventsEDUCount(dateRange) {
      var _this4 = this;

      this.setDatasApiEdu({ loading: true });
      return __WEBPACK_IMPORTED_MODULE_7_src_services_ApiEducacional_js__["a" /* apiEduService */].getCountEvents({
        dateRange: this.formatDate(dateRange),
        tags: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_ApiEducacional_js__["b" /* defineApiEduPost */])(this.getTagsThroughCategories(), this.tags)
      }).then(function (res) {
        _this4.setDatasApiEdu({
          events: res,
          loading: false
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchCounters: function fetchCounters(events) {
      var eventsId = events.map(function (event) {
        return event._id;
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.dashboardLampsByFilter({ eventsId: eventsId }), this.dashboardTicketsByFilter({ eventsId: eventsId }), this.dashboardWinnerTicketsByFilter({ eventsId: eventsId }), this.dashboardSurveysByFilter({ eventsId: eventsId }), this.fetchParticipantCount({ eventsId: eventsId })]).catch(function (err) {
        console.log(err);
        return err;
      });
    },
    formatDate: function formatDate(arr) {
      if (arr.length !== 0) {
        return arr.map(function (item) {
          return item.substr(0, 10);
        });
      }
    }
  }),

  mounted: function mounted() {
    if (!this.user) {
      this.$router.push({ name: 'login' });
    }
    this.fetch();
    this.fetchCategories({ limit: 9999 });
  }
});

/***/ }),

/***/ "dREt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report'
});

/***/ }),

/***/ "dc9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketForm_vue__ = __webpack_require__("ykHX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79839653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketForm_vue__ = __webpack_require__("KDIo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79839653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("XIFX");
function injectStyle (ssrContext) {
  __webpack_require__("YNHp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "djyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampsConfigForm',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', { modelValidations: 'validations' }), {
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  })
});

/***/ }),

/***/ "duHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__ = __webpack_require__("RXFM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__ = __webpack_require__("qQLU");
function injectStyle (ssrContext) {
  __webpack_require__("Mi7u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "duY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-customers-actions',

  props: {
    ticket: { required: true },
    survey: { required: true }
  },

  computed: {
    areThereSurvey: function areThereSurvey() {
      return this.survey && this.survey.status === 'FINISHED';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('surveys', { cleanSurvey: 'cleanSurvey' }), {
    eraseSurvey: function eraseSurvey() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode cancelar!',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          _this.cleanSurvey(_this.survey).then(function (ress) {
            if (ress) {
              _this.swalConfirm();
            } else {
              _this.swalError();
            }
          });
        }
      });
    },
    swalConfirm: function swalConfirm() {
      return __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Cancelado!',
        text: 'A pesquisa foi cancelada com sucesso. Voc\xEA agora pode associar novamente.',
        type: 'success',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Ok!',
        buttonsStyling: false
      });
    },
    swalError: function swalError() {
      return __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Falhou?',
        text: 'Ocorreu um problema no cancelar a pesquisa.',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Ok!',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "duz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {},
  created: function created() {}
});

/***/ }),

/***/ "e2au":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"documents-print"},_vm._l((_vm.tickets),function(ticket){return _c('div',{key:ticket._id},[(_vm.config.state === 'MA' && _vm.eventPrintLending)?_c('lending-term',{attrs:{"companyTerms":_vm.event.doc.companyTerms,"state":_vm.config.state,"ticket":ticket,"customer":_vm.customers[ticket.customerId],"config":_vm.config,"manufacturer":_vm.getManufacturer(ticket.stockId)}}):_vm._e(),_vm._v(" "),(_vm.config.state === 'MA' && _vm.eventPrintLending)?_c('div',{staticClass:"page-break"}):_vm._e(),_vm._v(" "),_c('delivery-term',{attrs:{"companyTerms":_vm.event.doc.companyTerms,"ticket":ticket,"manufacturer":_vm.getManufacturer(ticket.stockId),"stock":_vm.stocks[ticket.stockId],"customer":_vm.customers[ticket.customerId],"config":_vm.config,"dateTimeDelivery":_vm.event.dateTimeDelivery}}),_vm._v(" "),_c('div',{staticClass:"page-break"})],1)}),0):_c('div',[_c('h3',[_vm._v("Carregando dados...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e5Ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-go"},[_c('HeaderTerm',{attrs:{"imgsrc":"/static/img/enel-compartilha-logo.gif","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","margin-left":"5px","margin-right":"5px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e7iL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e8bN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManufacturersIndex_vue__ = __webpack_require__("t0aP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57233e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManufacturersIndex_vue__ = __webpack_require__("ohLt");
function injectStyle (ssrContext) {
  __webpack_require__("4jCY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManufacturersIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57233e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManufacturersIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7744861a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("4GTh");
function injectStyle (ssrContext) {
  __webpack_require__("Ls6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7744861a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eKfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampTermEnergisaPb',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), {

    customer: {
      get: function get() {
        return this.payload.customer;
      }
    },

    customerFullAddress: function customerFullAddress() {
      return this.customer.address.street + ', n\xBA ' + this.customer.address.number + ', ' + this.customer.address.neighborhood + ', ' + this.customer.address.city + ', CEP ' + this.customer.address.zip;
    },

    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Paraíba';
    },
    abbreviation: function abbreviation() {
      return 'Energisa';
    },
    projectName: function projectName() {
      return 'Projeto "Nossa Energia"';
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 25',
        neighborhood: 'Cristo Redentor',
        city: 'João Pessoa',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '09.095.183/0001-40';
    },
    numberState: function numberState() {
      return '16.015.823-0';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }),

  mounted: function mounted() {
    this.setValues();
  }
});

/***/ }),

/***/ "eLih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('tickets').where('winner', true).all().then(function (docs) {
        _this.isLoading = false;
        var filteredDocs = docs.filter(function (doc) {
          if (doc._attachments && doc._attachments['documents.pdf'].length > 0) {
            return true;
          }
          return false;
        });
        _this.total = filteredDocs.length;
        var swalOptions = {
          title: 'Existem ' + filteredDocs.length + ' tickets com documento(s) anexados.'
        };
        if (filteredDocs.length === 0) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todos os documentos j\xE1 foram copiados.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA deseja copiar os attachments para trg_docs?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, desejo copiar!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filteredDocs);

                  case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context.next = 12;
                      break;
                    }

                    item = _step.value;
                    _context.next = 9;
                    return _this.exec(item).then(function (result) {
                      if (_this.progress === _this.total) {
                        _this.notifyFinish();
                      }
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 9:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                  case 12:
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 18:
                    _context.prev = 18;
                    _context.prev = 19;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 21:
                    _context.prev = 21;

                    if (!_didIteratorError) {
                      _context.next = 24;
                      break;
                    }

                    throw _iteratorError;

                  case 24:
                    return _context.finish(21);

                  case 25:
                    return _context.finish(18);

                  case 26:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var blob, newDoc, insertedAttachment, deletedAttachment;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').getAttachment(item._id, 'documents.pdf');

              case 2:
                blob = _context2.sent;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('docs').insert({
                  'database': 'trg_admin',
                  'referenceId': item._id
                });

              case 5:
                newDoc = _context2.sent;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(newDoc.id, {
                  mimeType: 'application/pdf',
                  attachmentName: 'documents.pdf',
                  attachment: blob
                });

              case 8:
                insertedAttachment = _context2.sent;
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').deleteAttachment(item._id, {
                  mimeType: 'application/pdf',
                  attachmentName: 'documents.pdf'
                });

              case 11:
                deletedAttachment = _context2.sent;

                _this2.progress++;
                return _context2.abrupt('return', [blob, newDoc, insertedAttachment, deletedAttachment]);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todos os documentos foram copiados. Por favor, rode /compact no banco trg_admin.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }
});

/***/ }),

/***/ "eN3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonDownloadTermLamps_vue__ = __webpack_require__("H1tB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a808965_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonDownloadTermLamps_vue__ = __webpack_require__("UGIv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonDownloadTermLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a808965_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonDownloadTermLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eRNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-8 el-col-offset-4",staticStyle:{"border-bottom":"2px solid #000","margin-bottom":"1em","margin-top":"2.2em"}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"uppercase"},[_vm._v("NOME: "),_c('strong',[_vm._v(_vm._s(_vm.customer.holder))])]),_vm._v(" "),(_vm.customer.cpf)?_c('span',[_vm._v(" CPF: "),_c('strong',[_vm._v(_vm._s(_vm.customer.cpf))])]):_vm._e(),_vm._v(" "),(_vm.customer.nationalId)?_c('span',[_vm._v(" RG: "),_c('strong',[_vm._v(_vm._s(_vm.customer.nationalId))])]):_vm._e(),_vm._v(" "),(_vm.customer.nis)?_c('span',[_vm._v(" NIS: "),_c('strong',[_vm._v(_vm._s(_vm.customer.nis))])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eSiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__ = __webpack_require__("gww+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__ = __webpack_require__("3KWc");
function injectStyle (ssrContext) {
  __webpack_require__("6bl1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "eZE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eaj/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ecAH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ee0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__ = __webpack_require__("REaw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42833c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__ = __webpack_require__("zDTK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42833c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ef8Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eiqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('customers.manage'))?_c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"uc","label":"UC"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{on:{"click":function($event){return _vm.handleCustomerDetail(scope.row._id)}}},[_vm._v("\n                "+_vm._s(scope.row.uc)+"\n              ")])]}}],null,false,2303273909)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"holder","label":"Nome","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpf","label":"CPF"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Criado Em","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm._f("moment")(new Date(scope.row.createdAt),'DD/MM/YYYY HH:mm:ss'))+"\n            ")]}}],null,false,3161541860)}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[(_vm.$can('customer.detail'))?_c('a',{staticClass:"btn btn-icon btn-fill btn-primary remove",attrs:{"title":"Detalhes do cliente"},on:{"click":function($event){return _vm.handleCustomerDetail(props.row._id)}}},[_c('i',{staticClass:"ti-user"})]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'customers.tickets', params: {id: props.row._id}}}},[(_vm.$can('customers.tickets'))?_c('a',{staticClass:"btn btn-icon btn-fill btn-primary remove",attrs:{"title":"Gerenciar Tickets"}},[_c('i',{staticClass:"ti-ticket"})]):_vm._e()]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'customers.lamps', params: {id: props.row._id}}}},[(_vm.$can('customers.lamps'))?_c('a',{staticClass:"btn btn-icon btn-fill btn-success",attrs:{"title":"Trocar lâmpadas"}},[_c('i',{staticClass:"ti-light-bulb"})]):_vm._e()]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'customers.edit', params: {id: props.row._id}}}},[(_vm.$can('customers.edit'))?_c('a',{staticClass:"btn btn-primary btn-fill btn-icon edit",attrs:{"title":"Editar cliente"}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e()]),_vm._v(" "),(_vm.$can('customers.remove'))?_c('a',{staticClass:"btn btn-danger btn-fill btn-icon remove",attrs:{"title":"Deletar cliente"},on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()],1)]}}],null,false,4041639571)})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[(!_vm.searched)?_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v(" Mostrando de "+_vm._s(_vm.from + 1)+" até "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" no total. ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "enEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_config_connections__ = __webpack_require__("ZKT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Helper__ = __webpack_require__("leRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_services_couchdb__ = __webpack_require__("sv1M");



















var CouchdbClass = function () {
  function CouchdbClass(_ref) {
    var connection = _ref.connection,
        collection = _ref.collection,
        selector = _ref.selector,
        fields = _ref.fields,
        limit = _ref.limit,
        skip = _ref.skip,
        sort = _ref.sort,
        trash = _ref.trash;

    __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default()(this, CouchdbClass);

    this.config = {
      connection: connection || 'default',
      db: __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][connection || 'default'].db,
      collection: collection || null,
      selector: selector || {},
      fields: fields || [],
      limit: limit || 1000000,
      skip: skip || 0,
      sort: sort || [],
      trash: trash || false
    };

    this.transformResponse = {
      toOnlyOneDoc: function toOnlyOneDoc(data) {
        var result = JSON.parse(data);
        return result.docs.length === 0 ? null : result.docs[0];
      },
      toAllDocs: function toAllDocs(data) {
        var result = JSON.parse(data);
        return result.docs && result.docs.length > 0 ? result.docs : [];
      },
      toCount: function toCount(data) {
        var result = JSON.parse(data);
        return result.docs.length;
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass___default()(CouchdbClass, [{
    key: 'runPromise',
    value: function runPromise(promise) {
      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        promise.then(function (res) {
          return resolve(res);
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: 'withTrash',
    value: function withTrash() {
      this.config.trash = true;
      return this;
    }
  }, {
    key: 'noTrash',
    value: function noTrash() {
      this.config.trash = false;
      return this;
    }
  }, {
    key: 'find',
    value: function find(docId) {
      return this.runPromise(this.getHttpInstance().get('/' + this.getDb() + '/' + docId).then(function (response) {
        return response.data;
      }));
    }
  }, {
    key: 'first',
    value: function first() {
      this.config.limit = 1;
      return this._find(this.transformResponse.toOnlyOneDoc);
    }
  }, {
    key: 'get',
    value: function get() {
      return this._find(this.transformResponse.toAllDocs);
    }
  }, {
    key: 'findMany',
    value: function findMany(keys) {
      return this.runPromise(this.getHttpInstance().post('/' + this.getDb() + '/_all_docs?include_docs=true', { keys: keys }).then(function (response) {
        return response.data.rows.map(function (item) {
          return item.doc;
        });
      }));
    }
  }, {
    key: 'count',
    value: function count() {
      this.select(['_id']);
      return this._find(this.transformResponse.toCount);
    }
  }, {
    key: 'all',
    value: function all() {
      return this.get();
    }
  }, {
    key: 'insert',
    value: function insert(payload) {
      return this._insert(payload);
    }
  }, {
    key: 'update',
    value: function update(docId, payload) {
      return this._update(docId, payload);
    }
  }, {
    key: 'upset',
    value: function upset(docId, payload) {
      return this._upsert(docId, payload);
    }
  }, {
    key: 'upsert',
    value: function upsert(docId, payload) {
      return this._upsert(docId, payload);
    }
  }, {
    key: 'delete',
    value: function _delete(docId, force) {
      console.log('delete', docId, force);
      return this._delete(docId, force);
    }
  }, {
    key: 'viewReduce',
    value: function viewReduce(ddoc, view) {
      return this._viewReduce(ddoc, view);
    }
  }, {
    key: 'view',
    value: function view(ddoc, _view, key, options, keys, database) {
      if ((typeof ddoc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(ddoc)) === 'object') {
        database = ddoc.hasOwnProperty('database') ? ddoc.database : '';
        _view = ddoc.hasOwnProperty('view') ? ddoc.view : '';
        options = ddoc.hasOwnProperty('options') ? ddoc.options : false;
        key = ddoc.hasOwnProperty('key') ? ddoc.key : false;
        keys = ddoc.hasOwnProperty('keys') ? ddoc.keys : false;
        ddoc = ddoc.hasOwnProperty('ddoc') ? ddoc.ddoc : '';
      }

      var params = {
        queries: []
      };

      if (key || keys) {
        var query = {
          keys: key ? [key] : keys
        };
        for (var index in options) {
          if (index === 'group') {
            query[index] = options[index];
          }
        }
        params.queries.push(query);
      }


      return this._view({
        database: database,
        ddoc: ddoc,
        view: _view,
        params: params
      });
    }
  }, {
    key: 'viewQueries',
    value: function viewQueries(_ref2) {
      var connection = _ref2.connection,
          ddoc = _ref2.ddoc,
          view = _ref2.view,
          queries = _ref2.queries;

      var conn = connection !== undefined ? connection : 'default';
      var quer = queries !== undefined ? queries : [{ limit: 1 }];
      return this._viewQueries(conn, ddoc, view, { queries: quer });
    }
  }, {
    key: '_viewQueries',
    value: function _viewQueries(connection, ddoc, view, queries) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve) {
        _this.connection(connection);
        _this.getHttpInstance().post('/' + _this.getDb() + '/_design/' + ddoc + '/_view/' + view, queries).then(function (res) {
          if (!res || !res.data || !res.data.results) {
            resolve([]);
          }
          resolve(res.data.results);
        }).catch(function () {
          resolve([]);
        });
      });
    }
  }, {
    key: 'createView',
    value: function createView(ddocName, viewName, view) {
      return this._createView(ddocName, viewName, view);
    }
  }, {
    key: 'createFilter',
    value: function createFilter(ddocName, viewName, filter) {
      return this._createFilter(ddocName, viewName, filter);
    }
  }, {
    key: 'getAttachmentUrl',
    value: function getAttachmentUrl(docId, payload) {
      return this._getAttachmentUrl(docId, payload);
    }
  }, {
    key: 'getAttachmentUrlByReference',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(referenceId, attachmentName) {
        var url;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._getAttachmentUrlByReference(referenceId, attachmentName);

              case 2:
                url = _context.sent;
                return _context.abrupt('return', url);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAttachmentUrlByReference(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return getAttachmentUrlByReference;
    }()
  }, {
    key: 'getAttachment',
    value: function getAttachment(docId, payload) {
      var _this2 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this2._getAttachment(docId, payload).then(function (result) {
          resolve(result);
          _this2.reset();
        }).catch(function (err) {
          reject(err);
          _this2.reset();
        });
      });
      return promise;
    }
  }, {
    key: 'insertAttachment',
    value: function insertAttachment(docId, payload) {
      var _this3 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this3._insertAttachment(docId, payload).then(function (result) {
          resolve(result);
          _this3.reset();
        }).catch(function (err) {
          reject(err);
          _this3.reset();
        });
      });
      return promise;
    }
  }, {
    key: 'deleteAttachment',
    value: function deleteAttachment(docId, payload) {
      var _this4 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this4._deleteAttachment(docId, payload).then(function (result) {
          resolve(result);
          _this4.reset();
        }).catch(function (err) {
          reject(err);
          _this4.reset();
        });
      });
      return promise;
    }
  }, {
    key: 'getFullConnection',
    value: function getFullConnection() {
      var conn = __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][this.config.connection];
      return conn.host + '/' + conn.db;
    }
  }, {
    key: 'connection',
    value: function connection(_connection) {
      this.config.connection = _connection;
      if (__WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][this.config.connection] === undefined) {
        throw new Error('Connection dont exists.');
      } else {
        this.config.db = __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][this.config.connection].db;
      }
      return this;
    }
  }, {
    key: 'db',
    value: function db(_db) {
      this.config.db = _db;
      return this;
    }
  }, {
    key: 'collection',
    value: function collection(_collection) {
      this.config.collection = _collection;
      return this;
    }
  }, {
    key: 'where',
    value: function where(field, value) {
      this.config.selector[field] = value;
      return this;
    }
  }, {
    key: 'whereGreatThen',
    value: function whereGreatThen(field, value) {
      this.config.selector[field] = {
        $gt: value
      };
      return this;
    }
  }, {
    key: 'whereOr',
    value: function whereOr(field, value) {
      if (!this.config.selector.hasOwnProperty('$or')) {
        this.config.selector['$or'] = [];
      }

      this.config.selector['$or'] = value.map(function (item) {
        var a = {};
        a[field] = item;
        return a;
      });
      return this;
    }
  }, {
    key: 'select',
    value: function select(fields) {
      this.config.fields = fields;
      return this;
    }
  }, {
    key: 'limit',
    value: function limit(_limit) {
      this.config.limit = _limit;
      return this;
    }
  }, {
    key: 'skip',
    value: function skip(_skip) {
      this.config.skip = _skip;
      return this;
    }
  }, {
    key: 'sort',
    value: function sort(_sort) {
      if (_sort.field !== null) {
        var sortObject = {};
        var mapDirections = {
          ascending: 'asc',
          asc: 'asc',
          descending: 'desc',
          desc: 'desc'
        };
        sortObject[_sort.field] = mapDirections[_sort.direction];
        this.config.sort = [sortObject];
      }
      return this;
    }
  }, {
    key: 'search',
    value: function search(_search) {
      if (_search.query) {
        var conditions = [];
        _search.fields.map(function (item) {
          var condition = {};
          condition[item] = { '$regex': '(?i)' + _search.query };
          conditions.push(condition);
        });
        this.config.selector['$or'] = conditions;
      }
      return this;
    }
  }, {
    key: 'whereIn',
    value: function whereIn(field, inArray) {
      this.config.selector[field] = { '$in': inArray };
      return this;
    }
  }, {
    key: 'createIndex',
    value: function createIndex(fields, indexName) {
      return this._createIndex(fields, indexName);
    }
  }, {
    key: '_find',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(transformResponse) {
        var _this5 = this;

        var query, db, promises, selector;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = this.getQuery();
                db = this.getDb();

                if (!(query.hasOwnProperty('sort') || query.hasOwnProperty('selector'))) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"].all(__WEBPACK_IMPORTED_MODULE_17_src_services_couchdb__["a" /* couchdbIndexManager */].create(query).filter(function (item) {
                  return item.fields.length > 0 && item.name.length > 0;
                }).map(function (item) {
                  return _this5.createIndex(item.fields, item.name);
                }));

              case 5:
                promises = [];

                if (!query.hasOwnProperty('sort')) {
                  _context2.next = 11;
                  break;
                }

                selector = query.sort.reduce(function (accumulated, current) {
                  for (var sortField in current) {
                    accumulated[sortField] = sortField;
                  }
                  return accumulated;
                }, {});

                if (!(selector.hasOwnProperty('selector') || selector.hasOwnProperty('sort'))) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"].all(__WEBPACK_IMPORTED_MODULE_17_src_services_couchdb__["a" /* couchdbIndexManager */].create(selector).filter(function (item) {
                  return item.fields.length > 0 && item.name.length > 0;
                }).map(function (item) {
                  return _this5.createIndex(item.fields, item.name);
                }));

              case 11:
                _context2.prev = 11;
                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"].all(promises);

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](11);

                console.log(_context2.t0);

              case 19:
                return _context2.abrupt('return', this.getHttpInstance().post('/' + db + '/_find', query, { transformResponse: [transformResponse] }).then(function (response) {
                  _this5.reset();
                  return response.data;
                }).catch(function (err) {
                  console.log(err);
                }));

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 16]]);
      }));

      function _find(_x3) {
        return _ref4.apply(this, arguments);
      }

      return _find;
    }()
  }, {
    key: '_insert',
    value: function _insert(payload, database) {
      var _this6 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        payload.collection = payload.collection || _this6.config.collection;
        payload.createdAt = new Date();
        payload.updatedAt = new Date();
        if (database) {
          _this6.connection(database);
        }
        _this6.getHttpInstance().post('/' + _this6.getDb() + '/', payload).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: '_postBulkDocs',
    value: function _postBulkDocs(docs) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this7.getHttpInstance().post('/' + _this7.getDb() + '/' + '_bulk_docs', { docs: docs }).then(function (response) {
          _this7.reset();
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: '_updateBulkDocs',
    value: function _updateBulkDocs(docs) {
      return this._postBulkDocs(docs.filter(function (item) {
        return item.hasOwnProperty('_id') && item.hasOwnProperty('_rev');
      }));
    }
  }, {
    key: '_insertBulk',
    value: function _insertBulk(docs) {
      return this._postBulkDocs(docs);
    }
  }, {
    key: '_insertBuckLogs',
    value: function _insertBuckLogs(logs) {
      var CouchLogs = new CouchdbClass({ connection: 'logs', collection: 'logs' });
      return CouchLogs._insertBulk(CouchLogs._getDocsLogs(logs));
    }
  }, {
    key: '_getDocsLogs',
    value: function _getDocsLogs(logs) {
      return logs.map(function (item) {
        var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__Helper__["a" /* getDiff */])(item.new, item.old);
        var typeOfChange = ['updated'];
        var ignoreFields = ['updatedAt', '_id', '_rev'];
        var docLogs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__Helper__["b" /* getLogDeeply */])(diff, typeOfChange, ignoreFields).map(function (itemLog) {
          itemLog.user = __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.user._id;
          itemLog.userName = __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.user.name;
          itemLog.referenceId = item.old._id;
          itemLog.collection = item.old.collection;
          itemLog.createdAt = new Date();
          return itemLog;
        });
        return docLogs;
      }).reduce(function (accum, current, index, complete) {
        if (complete.length > 0) {
          if (index === 0) {
            accum = [];
          }
          return [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(accum), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(current));
        }
      }, []);
    }
  }, {
    key: '_update',
    value: function _update(docId, payload, database) {
      var _this8 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        if (database) {
          _this8.connection(database);
        }

        _this8.find(docId).then(function (oldDoc) {
          if (oldDoc === null) {
            reject(new Error('Document not found.'));
            return;
          }
          payload.updatedAt = new Date();
          payload._rev = oldDoc._rev;

          if (database) {
            _this8.connection(database);
          }

          _this8.getHttpInstance().put('/' + _this8.getDb() + '/' + docId, payload).then(function (response) {
            if (database) {
              _this8.connection(database);
            }
            _this8._insertBuckLogs([{
              new: payload,
              old: oldDoc
            }]);
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: 'upsertManyWithView',
    value: function upsertManyWithView(_ref5) {
      var _this9 = this;

      var database = _ref5.database,
          ddoc = _ref5.ddoc,
          view = _ref5.view,
          payload = _ref5.payload;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve) {
        var keys = payload.filter(function (item) {
          return item._id;
        }).map(function (item) {
          return item._id;
        });
        if (keys.length <= 0) {
          resolve(false);
        }

        _this9.view({ database: database, ddoc: ddoc, view: view, keys: keys }).then(function (res) {
          if (!res.rows) {
            return;
          }

          var currentDocsOnDb = res.rows.map(function (item) {
            return item.value;
          }).reduce(function (acc, curr, indx) {
            if (indx === 0) {
              acc = {};
            }
            acc[curr._id] = curr;
            return acc;
          }, {});

          var logs = [];
          var bulkDocs = payload.map(function (item) {
            var doc = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this9.addDefaultData(item));
            if (currentDocsOnDb.hasOwnProperty(item._id)) {
              doc = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, currentDocsOnDb[item._id], item);
              doc._rev = currentDocsOnDb[item._id]._rev;
              doc.updatedAt = new Date();
              logs.push({
                old: currentDocsOnDb[item._id],
                new: doc
              });
            }
            return doc;
          });

          __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"].all([_this9._insertBulk(bulkDocs), _this9._insertBuckLogs(logs)]).then(function (res) {
            resolve(res);
          });
        }).catch(function (err) {
          resolve(false);
          console.log(err);
        });
      });
    }
  }, {
    key: 'upsertWithView',
    value: function upsertWithView(_ref6) {
      var _this10 = this;

      var database = _ref6.database,
          ddoc = _ref6.ddoc,
          view = _ref6.view,
          payload = _ref6.payload;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        if (database) {
          _this10.connection(database);
        }
        payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this10.addDefaultData(payload));

        if (!payload.hasOwnProperty('_id') || !payload._id) {
          _this10.getHttpInstance().post('/' + _this10.getDb() + '/' + '_bulk_docs', { docs: [payload] }).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
          return;
        }

        _this10.view({ ddoc: ddoc, view: view, key: payload._id }).then(function (response) {
          var oldDoc = response.rows[0].value;
          payload.updatedAt = new Date();
          payload._rev = oldDoc._rev;
          if (database) {
            _this10.connection(database);
          }

          _this10.getHttpInstance().put('/' + _this10.getDb() + '/' + payload._id, payload).then(function (response) {
            if (database) {
              _this10.connection(database);
            }

            _this10._insertBuckLogs([{
              new: payload,
              old: oldDoc
            }]);
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        });
      });

      this.reset();
      return promise;
    }
  }, {
    key: 'updateWithView',
    value: function updateWithView(_ref7) {
      var _this11 = this;

      var database = _ref7.database,
          ddoc = _ref7.ddoc,
          view = _ref7.view,
          payload = _ref7.payload;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        if (database) {
          _this11.connection(database);
        }

        payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this11.addDefaultData(payload));

        _this11.view({ ddoc: ddoc, view: view, key: payload._id }).then(function (response) {
          if (!response.rows[0] && !response.rows[0].value) {
            resolve(null);
          }

          var oldDoc = response.rows[0].value;
          payload.updatedAt = new Date();
          payload._rev = oldDoc._rev;
          if (database) {
            _this11.connection(database);
          }

          _this11.getHttpInstance().put('/' + _this11.getDb() + '/' + payload._id, payload).then(function (response) {
            if (database) {
              _this11.connection(database);
            }

            _this11._insertBuckLogs([{
              new: payload,
              old: oldDoc
            }]);
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: '_upsert',
    value: function _upsert(docId, payload) {
      var _this12 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
          var result;
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!docId) {
                    _context3.next = 12;
                    break;
                  }

                  _context3.prev = 1;
                  _context3.next = 4;
                  return _this12._head(docId);

                case 4:
                  result = _context3.sent;

                  if (!result) {
                    _context3.next = 7;
                    break;
                  }

                  return _context3.abrupt('return', _this12._update(docId, payload).then(function (result) {
                    return resolve(result);
                  }).catch(function (err) {
                    return reject(err);
                  }));

                case 7:
                  _context3.next = 12;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t0 = _context3['catch'](1);

                  console.log(_context3.t0);

                case 12:
                  return _context3.abrupt('return', _this12._insert(payload).then(function (result) {
                    return resolve(result);
                  }).catch(function (err) {
                    return reject(err);
                  }));

                case 13:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this12, [[1, 9]]);
        }));

        return function (_x4, _x5) {
          return _ref8.apply(this, arguments);
        };
      }());
      return promise;
    }
  }, {
    key: '_delete',
    value: function _delete(docId, force) {
      var _this13 = this;

      console.log('_delete', docId, force);
      if (!force) {
        return this.find(docId).then(function (doc) {
          doc.deletedAt = new Date();
          _this13.upsert(docId, doc);
        });
      }
      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this13._head(docId).then(function (result) {
          var rev = result.headers.etag.replace(/"/g, '');
          _this13.getHttpInstance().delete('/' + _this13.getDb() + '/' + docId, { params: { 'rev': rev } }).then(function (response) {
            _this13.reset();
            resolve(response.data);
          }).catch(function (err) {
            _this13.reset();
            reject(err);
          });
        }).catch(function (err) {
          _this13.reset();
          reject(err);
        });
      });
    }
  }, {
    key: '_head',
    value: function _head(docId) {
      return this.getHttpInstance().head('/' + this.config.db + '/' + docId);
    }
  }, {
    key: '_getRev',
    value: function _getRev(docId, DB) {
      var _this14 = this;

      if (!DB) {
        DB = this.getDb();
      }

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this14._head(docId, DB).then(function (result) {
          resolve(result.headers.etag.replace(/"/g, ''));
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: '_view',
    value: function _view(_ref9) {
      var database = _ref9.database,
          ddoc = _ref9.ddoc,
          view = _ref9.view,
          params = _ref9.params;

      if (database && database !== '') {
        this.connection(database);
      }

      var query = params.queries.length > 0 ? this.getHttpInstance().post('/' + this.getDb() + '/_design/' + ddoc + '/_view/' + view, params) : this.getHttpInstance().get('/' + this.getDb() + '/_design/' + ddoc + '/_view/' + view);

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        query.then(function (response) {
          if (params.queries.length > 0) {
            resolve(response.data.results[0]);
          } else {
            resolve(response.data);
          }
        }).catch(function (err, response) {
          reject(err);
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: 'viewBetween',
    value: function viewBetween(ddoc, view, keys, options) {
      if ((typeof ddoc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(ddoc)) === 'object') {
        view = ddoc.hasOwnProperty('view') ? ddoc.view : '';
        keys = ddoc.hasOwnProperty('keys') ? ddoc.keys : '';
        options = ddoc.hasOwnProperty('options') ? ddoc.options : {};
        ddoc = ddoc.hasOwnProperty('ddoc') ? ddoc.ddoc : '';
      }
      return this._viewBetween(ddoc, view, keys, options);
    }
  }, {
    key: '_viewBetween',
    value: function _viewBetween(ddoc, view, keys, options) {
      var _this15 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var getparams = '';
        if (options && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(options).length > 0) {
          for (var param in options) {
            getparams += getparams === '' ? '?' + param + '=' + options[param] : '&' + param + '=' + options[param];
          }
        }
        if (typeof keys !== 'undefined' && keys.hasOwnProperty('startKey') && keys.hasOwnProperty('endKey')) {
          getparams += getparams === '' ? '?' : '&';

          if (keys.startIndex !== undefined && keys.startIndex >= 0 && keys.startIndex < keys.endIndex) {
            getparams += 'start_key=["' + keys.startKey + '", ' + keys.startIndex + ']&end_key=["' + keys.endKey + '", ' + keys.endIndex + ']';
          } else {
            getparams += 'start_key="' + keys.startKey + '"';
          }

          if (keys.hasOwnProperty('endIndex') && keys.endIndex !== undefined) {
            getparams += '&end_key=["' + keys.endKey + '", ' + keys.endIndex + ']';
          } else {
            getparams += '&end_key="' + keys.endKey + '"';
          }
        }
        _this15.getHttpInstance().get('/' + _this15.getDb() + '/_design/' + ddoc + '/_view/' + view + getparams).then(function (response) {
          resolve(response.data);
        }).catch(function (err, response) {
          reject(err);
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: '_viewReduce',
    value: function _viewReduce(ddoc, view) {
      var _this16 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this16.getHttpInstance().get('/' + _this16.getDb() + '/_design/' + ddoc + '/_view/' + view + '?group=true&reduce=true&skip=0').then(function (response) {
          resolve(response.data);
        }).catch(function (err, response) {
          reject(err);
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: '_createView',
    value: function _createView(ddocName, viewName, view) {
      var _this17 = this;

      var ddocUri = '/' + this.getDb() + '/_design/' + ddocName;
      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this17._getDesignDocument(ddocName).then(function (ddoc) {
          var oldDdoc = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(ddoc);
          var newDdoc = void 0;
          var views = { views: {} };
          views['views'][viewName] = view;
          if (ddoc === undefined) {
            newDdoc = views;
          } else {
            newDdoc = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.merge(ddoc, views);
            newDdoc._rev = ddoc._rev;
          }
          if (!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEqual(oldDdoc, newDdoc)) {
            _this17.getHttpInstance().put(ddocUri, newDdoc).then(function (response) {
              resolve(response.data);
            }).catch(function (err) {
              return reject(err);
            });
          } else {
            resolve(true);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
      return promise;
    }
  }, {
    key: '_createFilter',
    value: function _createFilter(ddocName, filterName, filter) {
      var _this18 = this;

      var ddocUri = '/' + this.getDb() + '/_design/' + ddocName;
      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this18._getDesignDocument(ddocName).then(function (ddoc) {
          var oldDdoc = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(ddoc);
          var newDdoc = void 0;
          var filters = { filters: {} };
          filters['filters'][filterName] = filter;
          if (ddoc === undefined) {
            newDdoc = filters;
          } else {
            newDdoc = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.merge(ddoc, filters);
          }

          if (!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEqual(oldDdoc, newDdoc)) {
            _this18.getHttpInstance().put(ddocUri, newDdoc).then(function (response) {
              resolve(response.data);
            }).catch(function (err) {
              return reject(err);
            });
          } else {
            resolve(true);
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
      return promise;
    }
  }, {
    key: 'createFilters',
    value: function createFilters(designName, filters) {
      var _this19 = this;

      var ddocUri = '/' + this.getDb() + '/_design/' + designName;
      return this._getDesignDocument(designName).then(function (old) {
        var document = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({ filters: [] }, old);
        document['filters'] = filters;

        if (old && old.hasOwnProperty('_rev')) {
          _this19.getHttpInstance().put(ddocUri, document).then(function (response) {
            return response.data;
          });
        } else {
          _this19.getHttpInstance().post('/' + _this19.getDb(), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({ _id: '_design/' + designName }, document)).then(function (response) {
            return response.data;
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    }
  }, {
    key: '_getDesignDocument',
    value: function _getDesignDocument(ddocName) {
      var _this20 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var ddocUri = '/' + _this20.getDb() + '/_design/' + ddocName;
        _this20.getHttpInstance().get(ddocUri).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          if (err.response.status === 404) {
            resolve(undefined);
          } else {
            reject(err);
          }
        });
      });
    }
  }, {
    key: '_createIndex',
    value: function _createIndex(fields, indexName) {
      var _this21 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this21.getHttpInstance().post('/' + _this21.getDb() + '/_index', { index: { fields: fields }, name: indexName, type: 'json' }).then(function (response) {
          resolve(response);
        }).catch(function (err, response) {
          reject(err);
        }).finally(function () {
          _this21.reset();
        });
      });
      return promise;
    }
  }, {
    key: '_bulkGet',
    value: function _bulkGet(docIds) {
      var _this22 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var DB = _this22.getDb();
        _this22.getHttpInstance().post('/' + DB + '/_bulk_get/', { docs: docIds }).then(function (response) {
          resolve(response.data.results.filter(function (item) {
            return item.docs[0].hasOwnProperty('ok');
          }).map(function (item) {
            return item.docs[0].ok;
          }));
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: '_insertAttachment',
    value: function _insertAttachment(docId, payload) {
      var _this23 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var DB = _this23.getDb();
        _this23._getRev(docId, DB).then(function (rev) {
          _this23.getHttpInstance().put('/' + DB + '/' + docId + '/' + payload.attachmentName, payload.attachment, {
            headers: { 'Content-Type': payload.mimeType },
            params: { rev: rev }
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: '_deleteAttachment',
    value: function _deleteAttachment(docId, payload) {
      var _this24 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var DB = _this24.getDb();
        _this24._getRev(docId).then(function (rev) {
          var attachmentName = encodeURI(payload.attachmentName);
          _this24.getHttpInstance().delete('/' + DB + '/' + docId + '/' + attachmentName, { params: { rev: rev } }).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: '_getAttachment',
    value: function _getAttachment(docId, attachmentName) {
      var _this25 = this;

      var attachmentUrl = this._getAttachmentUrl(docId, attachmentName);
      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this25.getHttpInstance().get(attachmentUrl, { responseType: 'blob' }).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: '_getAttachmentUrl',
    value: function _getAttachmentUrl(docId, attachmentName) {
      var connection = __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][this.config.connection];
      this.config.db = connection.db;
      var url = connection.host + '/' + this.getDb() + '/' + docId + '/' + attachmentName;
      this.reset();
      return url;
    }
  }, {
    key: '_getAttachmentUrlByReference',
    value: function _getAttachmentUrlByReference(referenceId, attachmentName) {
      var _this26 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        var connection = __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][_this26.config.connection];
        _this26.config.db = connection.db;
        _this26.where('referenceId', referenceId);
        _this26.getHttpInstance().post('/' + _this26.getDb() + '/_find', _this26.getQuery(), { transformResponse: _this26.transformResponse.toOnlyOneDoc }).then(function (response) {
          var doc = response.data;
          resolve(connection.host + '/' + connection.db + '/' + doc._id + '/' + attachmentName);
        }).catch(function (err) {
          return reject(err);
        });
      });
      this.reset();
      return promise;
    }
  }, {
    key: 'getDb',
    value: function getDb() {
      return this.config.db;
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      if (this.config.collection !== null && (!this.config.selector.collection || this.config.selector.collection === '')) {
        this.config.selector.collection = this.config.collection;
      }
      var query = {
        'selector': {}
      };
      if (this.config.selector && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.config.selector).length > 0) {
        query['selector'] = this.config.selector;
      }

      if (this.config.limit) {
        query['limit'] = this.config.limit;
      } else {
        delete query['limit'];
      }

      if (this.config.skip) {
        query['skip'] = this.config.skip;
      } else {
        delete query['skip'];
      }

      if (this.config.fields.length > 0) {
        query['fields'] = this.config.fields;
      }

      if (this.config.sort && this.config.sort.length > 0) {
        query['sort'] = this.config.sort;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(query['sort']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var sort = _step.value;

            for (var field in sort) {
              if (!query['selector'].hasOwnProperty(field)) {
                query['selector'][field] = { $exists: true };
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        delete query['sort'];
      }

      if (!query.hasOwnProperty('fields') || query['fields'].length === 0) {
        delete query['fields'];
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(query.selector).length === 0) {
        query.selector = {
          _id: {
            '$gt': 0
          }
        };
      }

      if (!this.config.trash) {
        query.selector['deletedAt'] = {
          '$exists': false
        };
      }

      return query;
    }
  }, {
    key: 'getHttpInstance',
    value: function getHttpInstance() {
      var connection = __WEBPACK_IMPORTED_MODULE_14_src_config_connections__["a" /* default */][this.config.connection];
      if (connection === undefined) {
        throw new Error('Connection dont exists.');
      }
      this.connection(this.config.connection);

      return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.create({
        baseURL: connection.host,
        timeout: 9999999,
        auth: {
          username: connection.user,
          password: connection.pass
        }
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.config = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.config, {
        selector: {},
        fields: [],
        limit: 25,
        skip: 0,
        sort: [],
        trash: false
      });
      this.config.fields = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
      this.config.sort = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
    }
  }, {
    key: 'addDefaultData',
    value: function addDefaultData(obj) {
      if (!obj.hasOwnProperty('collection')) {
        obj.collection = this.config.collection;
      }

      if (!obj.hasOwnProperty('createdAt')) {
        obj.createdAt = new Date();
      }

      if (!obj.hasOwnProperty('updatedAt')) {
        obj.updatedAt = new Date();
      }

      if (!obj.hasOwnProperty('userId') && __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.hasOwnProperty('user')) {
        obj.userId = __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.user._id;
      }

      if (!obj.hasOwnProperty('servername') && __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.hasOwnProperty('config')) {
        obj.servername = __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.config.hasOwnProperty('servername') ? __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].state.config.servername : '3EENG-unamed';
      }
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, obj);
    }
  }, {
    key: 'deleteDesignView',
    value: function deleteDesignView(designDoc) {
      var _this27 = this;

      return new __WEBPACK_IMPORTED_MODULE_12_es6_promise__["Promise"](function (resolve, reject) {
        _this27._getDesignDocument(designDoc).then(function (ddoc) {
          _this27.getHttpInstance().delete('/' + _this27.getDb() + '/_design/' + designDoc + '?rev=' + ddoc._rev).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        });
      });
    }
  }]);

  return CouchdbClass;
}();

/* harmony default export */ __webpack_exports__["a"] = (CouchdbClass);

/***/ }),

/***/ "eqmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-view-detail',

  props: ['survey'],

  computed: {
    hasData: function hasData() {
      return this.survey.hasOwnProperty('data');
    },
    hasRefrigerator: function hasRefrigerator() {
      return this.hasData && this.survey.data.hasOwnProperty('refrigerator');
    }
  }
});

/***/ }),

/***/ "etPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('actions-table-layout',{attrs:{"children":_vm.childrenMenu}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eubD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_Helper__ = __webpack_require__("leRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_services_Couchdb__ = __webpack_require__("pk/q");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamps-report',
  props: ['eventSelected', 'allEvents', 'csvSeparator'],
  data: function data() {
    return {
      lamps: [],
      event: {},
      csvHeaders: {
        lamps: {
          'customer.uc': 'UC',
          'customer.cpf': 'CPF',
          'customer.holder': 'Nome',
          'user': 'Atendente da troca',
          'createdAt': 'Data da troca',
          'event.reference': 'Referência',
          'event.city': 'Município',
          'items.0.power': 'Quantidade de Lâmpadas'
        }
      },
      loading: false
    };
  },

  methods: {
    resetValues: function resetValues() {
      this.lamps = [];
    },
    runReport: function runReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('progress', { current: 0, total: 0 });
                _this.loading = true;
                _this.resetValues();
                _context.prev = 3;
                _context.next = 6;
                return _this.getEvent();

              case 6:
                _this.event = _context.sent;
                _context.next = 9;
                return _this.getLamps();

              case 9:
                _this.lamps = _context.sent;

                if (_this.lamps.length > 0) {
                  _this.lamps = _this.lamps.map(function (item) {
                    item.user = _this.usersIdName[item.userId];
                    item.event = { reference: _this.event.reference, city: _this.event.city };
                    return item;
                  });
                  _this.getReportLamps();
                } else {
                  _this.$notify('Não há lâmpadas para este evento');
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.$notify({
                  message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
                  type: 'danger'
                });

              case 17:
                _context.prev = 17;

                _this.loading = false;
                return _context.finish(17);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 13, 17, 20]]);
      }))();
    },
    getEvent: function getEvent() {
      return __WEBPACK_IMPORTED_MODULE_9_src_services_Couchdb__["a" /* default */].collection('events').find(this.eventSelected);
    },
    getLamps: function getLamps() {
      return __WEBPACK_IMPORTED_MODULE_9_src_services_Couchdb__["a" /* default */].collection('lamps').where('eventId', this.eventSelected[0]).get();
    },
    getReportLamps: function getReportLamps() {
      var csv = '';
      csv += this.addHeader(this.csvHeaders.lamps);
      csv += '\n';
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.lamps);
      for (var l in this.lamps) {
        var lamp = this.lamps[l];
        var numItems = lamp.items.length;
        var obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_services_Helper__["c" /* flattenObject */])(lamp);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (!obj) {
              csv += '-' + this.csvSeparator;
              continue;
            }
            if (obj && obj.hasOwnProperty(key)) {
              if (key === 'items.0.power') {
                csv += '' + lamp.items.length + this.csvSeparator;
              } else if (key === 'event.reference') {
                csv += '' + this.event.reference + this.csvSeparator;
              } else if (key === 'event.city') {
                csv += '' + this.event.city + this.csvSeparator;
              } else if (key === 'createdAt') {
                csv += '' + this.$moment(new Date(obj[key]).toISOString()).format('DD-MM-YYYY HH:mm:ss') + this.csvSeparator;
              } else {
                csv += '' + obj[key] + this.csvSeparator;
              }
              continue;
            } else {
              csv += '-' + this.csvSeparator;
              continue;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (numItems > 0) {
          for (var i in lamp.items) {
            for (var j in lamp.items[i]) {
              var head = j;
              if (j === 'type') {
                head = 'Tipo';
              } else if (j === 'room') {
                head = 'Local';
              } else if (j === 'usageHoursPerDay') {
                head = 'Horas de uso por dia';
              } else if (j === 'power') {
                head = 'Potência';
              }
              csv += head + ': ' + lamp.items[i][j] + this.csvSeparator;
            }
          }
        }
        csv += '\n';
        var current = parseInt(l) + 1;
        this.$emit('progress', { current: current, total: this.lamps.length });
      }
      this.download(csv);
    },
    addHeader: function addHeader(headers) {
      var csv = '';
      for (var h in headers) {
        csv += '' + headers[h] + this.csvSeparator;
      }
      return csv;
    },
    download: function download(csv) {
      var blob = __WEBPACK_IMPORTED_MODULE_5_blob_util___default.a.createBlob([csv], { type: 'text/plain' });
      var date = this.$moment(new Date()).format('DD-MM-YYYY');
      __WEBPACK_IMPORTED_MODULE_6_downloadjs___default()(blob, 'Relat\xF3rio_Geral_Lampadas_' + date + '.csv');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('users', ['usersIdName']))
});

/***/ }),

/***/ "eul6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"true"},model:{value:(_vm.project.register.carrer),callback:function ($$v) {_vm.$set(_vm.project.register, "carrer", $$v)},expression:"project.register.carrer"}},[_vm._v("Sim\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"false"},model:{value:(_vm.project.register.carrer),callback:function ($$v) {_vm.$set(_vm.project.register, "carrer", $$v)},expression:"project.register.carrer"}},[_vm._v("Não\n            ")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Configurações de Registro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              Exibir campo de "),_c('strong',[_vm._v("profissão")]),_vm._v("?\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ewFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "exox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $can;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

function $can(perms, user) {
  user = !user && window.localStorage.user ? JSON.parse(window.localStorage.user) : user;
  if (!user) return false;
  if (user.role === 'superadmin') return true;
  var permissions = perms.split('|').map(function (item) {
    return item.toLowerCase();
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(permissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      if (user.permissions && user.permissions.map(function (item) {
        return item.toLowerCase();
      }).indexOf(p) >= 0) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

/***/ }),

/***/ "ez44":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f0zf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f4B7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f4lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Especificalções do evento: "+_vm._s(_vm.eventSpecifications.event.reference))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('h4',[_vm._v("Categorias")]),_vm._v(" "),_vm._l((_vm.categories),function(categorie){return _c('div',{key:categorie._id,staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(categorie.name))]),_vm._v(" "),_vm._l((_vm.tagsByCategories[categorie._id]),function(tag){return _c('p',{key:tag._id,staticClass:"radio-input"},[_c('input',{attrs:{"type":"radio","name":categorie._id},domProps:{"checked":_vm.checkedTag(categorie._id, tag._id),"value":tag._id},on:{"change":_vm.handlInputTag}}),_vm._v(" "+_vm._s(tag.name)+"\n          ")])})],2)}),_vm._v(" "),_c('h4',[_vm._v("Icone no mapa")]),_vm._v(" "),_c('InputRadioIconRefrigeratoMap',{model:{value:(_vm.eventSpecifications.refrigeratorIcon),callback:function ($$v) {_vm.$set(_vm.eventSpecifications, "refrigeratorIcon", $$v)},expression:"eventSpecifications.refrigeratorIcon"}}),_vm._v(" "),_c('h4',[_vm._v("GPS")]),_vm._v(" "),_c('EventLocalMap',{attrs:{"specGps":_vm.eventSpecifications.gps},on:{"changeGps":function (event) { return Object.assign(_vm.eventSpecifications.gps, {lat: event.lat, lng: event.lng}); }}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Latidude")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventSpecifications.gps.lat),expression:"eventSpecifications.gps.lat"}],staticClass:"form-control",attrs:{"readonly":"","type":"number","name":"latitude"},domProps:{"value":(_vm.eventSpecifications.gps.lat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventSpecifications.gps, "lat", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Defina LATITUDE utilizando o mapa.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Longitude")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventSpecifications.gps.lng),expression:"eventSpecifications.gps.lng"}],staticClass:"form-control",attrs:{"readonly":"","type":"number","name":"latitude"},domProps:{"value":(_vm.eventSpecifications.gps.lng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventSpecifications.gps, "lng", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Defina LONGITUDE utilizando o mapa.")])])],2)]),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-bottom":"30px"}},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.handleSave($event)}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f6/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("0Bz4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("+mNl");
function injectStyle (ssrContext) {
  __webpack_require__("LRfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fN0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InputRadioIconRefrigeratoMap',
  props: ['value'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('eventsSpecifications', ['imagesMap']))
});

/***/ }),

/***/ "fP9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__ = __webpack_require__("a8eF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__ = __webpack_require__("BYD1");
function injectStyle (ssrContext) {
  __webpack_require__("bTbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fRXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fUFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'actions-table-categories',
  props: {
    categorie: {
      required: true
    },
    handleRemove: {
      required: true,
      type: Function
    }
  },

  computed: {
    can: function can() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.actions);
    },

    actions: function actions() {
      return {
        'categorie.edit': {
          name: 'categories.edit',
          title: 'Editar categoria',
          color: 'warning',
          icon: 'ti-pencil-alt',
          component: 'router-button'
        },
        'categorie.remove': {
          name: 'categories.remove',
          title: 'Remover categoria',
          color: 'danger',
          icon: 'ti-trash',
          component: 'action-button-click-stateless',
          props: {
            params: {
              id: this.categorie._id
            },
            handleEvent: {
              click: this.handleRemove
            }
          }
        }
      };
    },

    childrenMenu: function childrenMenu() {
      var _this = this;

      return this.can.filter(function (item) {
        return _this.$can(item);
      }).map(function (item) {
        return {
          component: _this.actions[item].component,
          data: {
            props: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              to: {
                name: _this.actions[item].name,
                params: { id: _this.categorie._id }
              },
              title: _this.actions[item].title,
              classStyle: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                btn: true,
                'btn-block': true,
                'btn-flat': true,
                'btn-icon': false
              }, 'btn-' + _this.actions[item].color, true),
              iconClass: _this.actions[item].icon
            }, _this.actions[item].props)
          }
        };
      });
    }
  }
});

/***/ }),

/***/ "fV7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalContent'
});

/***/ }),

/***/ "fX7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Events_EventCard__ = __webpack_require__("ee0G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SurveyActions__ = __webpack_require__("ktiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyListFilters__ = __webpack_require__("ClD0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SurveyTicketsListToAssociate__ = __webpack_require__("IqoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UsersOptions__ = __webpack_require__("qYwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-index',

  components: {
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    EventCard: __WEBPACK_IMPORTED_MODULE_5_src_pages_Events_EventCard__["a" /* default */],
    SurveyActions: __WEBPACK_IMPORTED_MODULE_6__SurveyActions__["a" /* default */],
    SurveyListFilters: __WEBPACK_IMPORTED_MODULE_7__SurveyListFilters__["a" /* default */],
    SurveyTicketsListToAssociate: __WEBPACK_IMPORTED_MODULE_8__SurveyTicketsListToAssociate__["a" /* default */],
    UsersOptions: __WEBPACK_IMPORTED_MODULE_9_src_components_UsersOptions__["a" /* default */]
  },

  data: function data() {
    return {
      userSelected: {},
      customersSelected: [],
      eventSelected: {},
      surveysDocuments: [],
      filters: {
        status: [],
        neighborhood: [],
        users: []
      },
      cleanBox: 1
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])({
    userLogged: 'user'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('users', {
    users: 'usersIdName'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('events', {
    event: 'event',
    eventLoading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('tickets', {
    tickets: 'tickets',
    ticketsLoading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById',
    customersLoading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('surveys', {
    surveys: 'surveys',
    savingLoading: 'loading'
  }), {
    loading: function loading() {
      return this.savingLoading || this.ticketsLoading || this.customersLoading;
    },
    eventId: function eventId() {
      return this.$route.params.id;
    },
    enableAssociate: function enableAssociate() {
      return this.userSelected.hasOwnProperty('_id') && this.userSelected._id !== '' && this.surveysDocuments.length > 0;
    },
    countTicketsSurveyed: function countTicketsSurveyed() {
      return this.surveys.filter(function (item) {
        return item.status === 'FINISHED';
      }).length;
    },
    countTotalTickets: function countTotalTickets() {
      return this.tickets.length;
    },
    percentage: function percentage() {
      return this.countTotalTickets > 0 ? Math.floor(this.countTicketsSurveyed / this.countTotalTickets * 100) : 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('events', {
    fetchEvent: 'fetchOne',
    resetEvent: 'resetOne',
    changeEventLoading: 'changeLoading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('tickets', {
    fetchTickets: 'fetchAll',
    resetTickets: 'resetAll',
    changeTicketLoading: 'changeLoading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('surveys', {
    associateSurveys: 'associateSurveys',
    fetchSurveys: 'fetchAll',
    resetSurveys: 'resetAll',
    changeSurveyLoading: 'changeLoading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll',
    changeSurveyLoading: 'changeLoading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('customers', {
    changeCustomerLoading: 'changeLoading',
    fetchCustomersById: 'fetchIds'
  }), {
    runAssociateAll: function runAssociateAll() {
      var _this = this;

      return this.associateSurveys(this.surveysDocuments.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(item, {
          user: {
            _id: _this.userSelected._id,
            name: _this.userSelected.name
          }
        });
      })).then(function (response) {
        if (response) {
          _this.$notify({
            message: 'Cliente associado com sucesso. Aguarde atualização da tela.',
            type: 'success'
          });
        } else {
          _this.$notify({
            message: 'Ocorreu um erro ao associar o cliente. Contate o suporte.',
            type: 'danger'
          });
        }
        _this.cleanBox++;
        _this.surveysDocuments = [];
        _this.userSelected = {};
      });
    },
    onUsersSelected: function onUsersSelected(user) {
      this.userSelected = user;
    },
    onSurveyDocuments: function onSurveyDocuments(surveys) {
      var _this2 = this;

      var surveyTypes = this.event.surveysType && this.event.surveysType.length > 0 ? this.event.surveysType : ['refrigerator'];
      this.surveysDocuments = surveys.map(function (newSurvey) {
        newSurvey.user = _this2.userSelected;
        newSurvey.event = {
          _id: _this2.eventId,
          name: _this2.event.reference + ' - ' + _this2.event.city + ' - ' + _this2.event.place
        };
        newSurvey.userId = _this2.userLogged._id;
        return newSurvey;
      }).reduce(function (accum, current) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(surveyTypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var type = _step.value;

            current.surveyType = type;
            accum.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, current));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return accum;
      }, []);
      console.log('onSurveyDocuments', this.surveysDocuments);
    },
    onChangeFilter: function onChangeFilter(filters) {
      var _this3 = this;

      this.filters = false;
      this.$nextTick(function () {
        _this3.filters = filters;
      });
    },
    reset: function reset() {
      this.userSelected = {};
      this.resetEvent();
      this.resetTickets();
      this.resetSurveys();
    },
    fetch: function fetch() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.fetchSurveys({
        where: {
          'event._id': this.eventId
        },
        limit: 9999999999
      }), this.fetchTickets({
        where: {
          'eventId': this.eventId
        },
        limit: 9999999999
      }), this.fetchEvent(this.eventId), this.fetchUsers({
        where: { role: { '$ne': 'superadmin' } },
        limit: 999999
      })]).then(function (results) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this4.fetchCustomersById({ ids: results[1].map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { id: item.customerId });
          }) })]);
      });
    },
    generateTest: function generateTest() {
      var axios = __webpack_require__("mtWM");
      var surveys = this.surveys.map(function (survey) {
        survey.status = 'FINISHED';
        survey.data = {
          absent: false,
          accepted: true,
          reasonNotPresent: null,
          reasonNotAccepted: null,
          refrigerator: {
            yearsUse: Math.floor(Math.random() * Math.floor(2) + 5),
            body: Math.floor(Math.random() * Math.floor(4)),
            doors: Math.floor(Math.random() * Math.floor(4)),
            coil: Math.floor(Math.random() * Math.floor(4)),
            rubber: Math.floor(Math.random() * Math.floor(4)),
            compartments: Math.floor(Math.random() * Math.floor(4)),
            engine: Math.floor(Math.random() * Math.floor(4)),
            manufacturer: 'Brastemp',
            sealingNumber: '558658',
            score: (Math.random() * 3 + 5).toFixed(3)
          }
        };
        return survey;
      });
      axios({
        baseURL: "https://couch-trg.3e.eng.br" + '/trg_surveys',
        url: '_bulk_docs',
        method: 'post',
        withCredentials: true,
        auth: {
          username: "admin",
          password: "admin2435,"
        },
        data: { docs: surveys }
      });
    }
  }),

  mounted: function mounted() {
    this.reset();
    this.fetch();
  }
});

/***/ }),

/***/ "fYtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "favu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extended-forms"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Datetime Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select date and time","picker-options":_vm.pickerOptions1},model:{value:(_vm.dateTimePicker),callback:function ($$v) {_vm.dateTimePicker=$$v},expression:"dateTimePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Date Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Pick a day","picker-options":_vm.pickerOptions1},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Time Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '23:59'
              },"placeholder":"Select time"},model:{value:(_vm.timePicker),callback:function ($$v) {_vm.timePicker=$$v},expression:"timePicker"}})],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Switches")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Default")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOn),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOn", $$v)},expression:"switches.defaultOn"}}),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOff),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOff", $$v)},expression:"switches.defaultOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Plain")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOn),callback:function ($$v) {_vm.$set(_vm.switches, "plainOn", $$v)},expression:"switches.plainOn"}}),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOff),callback:function ($$v) {_vm.$set(_vm.switches, "plainOff", $$v)},expression:"switches.plainOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("With Icons")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOn),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOn", $$v)},expression:"switches.withIconsOn"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOff),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOff", $$v)},expression:"switches.withIconsOff"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Checkboxes")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":false}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":true}},[_vm._v("Checked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":false}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":true}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"1"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"2"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is on")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tags")]),_vm._v(" "),_vm._l((_vm.tags.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"type":"primary","closable":true,"close-transition":false},on:{"close":function($event){return _vm.handleClose(tag)}}},[_vm._v("\n            "+_vm._s(tag)+"\n          ")])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tags.inputValue),expression:"tags.inputValue"}],ref:"saveTagInput",staticClass:"form-control input-new-tag",attrs:{"type":"text","placeholder":"Add new tag","size":"mini"},domProps:{"value":(_vm.tags.inputValue)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm($event)},"blur":_vm.handleInputConfirm,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tags, "inputValue", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Progress Bars")]),_vm._v(" "),_c('p-progress',{attrs:{"value":30}}),_vm._v(" "),_c('p-progress',{attrs:{"value":60,"type":"info"}}),_vm._v(" "),_c('p-progress',{attrs:{"values":[{type:'success', value:35},{type:'warning', value:20}, {type:'danger', value: 10}]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Sliders")]),_vm._v(" "),_c('el-slider',{staticClass:"slider-success",model:{value:(_vm.sliders.simple),callback:function ($$v) {_vm.$set(_vm.sliders, "simple", $$v)},expression:"sliders.simple"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-slider',{staticClass:"slider-info",attrs:{"max":100,"range":""},model:{value:(_vm.sliders.rangeSlider),callback:function ($$v) {_vm.$set(_vm.sliders, "rangeSlider", $$v)},expression:"sliders.rangeSlider"}})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Customisable Select")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-danger",attrs:{"size":"large","placeholder":"Single Select"},model:{value:(_vm.selects.simple),callback:function ($$v) {_vm.$set(_vm.selects, "simple", $$v)},expression:"selects.simple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-danger",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-primary",attrs:{"multiple":"","size":"large","placeholder":"Multiple Select"},model:{value:(_vm.selects.multiple),callback:function ($$v) {_vm.$set(_vm.selects, "multiple", $$v)},expression:"selects.multiple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropdown")]),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropup")]),_vm._v(" "),_c('drop-down',{attrs:{"slide":"up"}},[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1)])])]),_vm._v(" "),_c('br'),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fd3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTerm_vue__ = __webpack_require__("Pq02");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ac4753_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTerm_vue__ = __webpack_require__("F1m7");
function injectStyle (ssrContext) {
  __webpack_require__("bGFk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59ac4753"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTerm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ac4753_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTerm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fkB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_LGPD__ = __webpack_require__("rdXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");












/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: {
    couchdbCustomers: function couchdbCustomers() {
      return new __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },
    couchdbLamps: function couchdbLamps() {
      return new __WEBPACK_IMPORTED_MODULE_5_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('customers', {
    fetchCustomers: 'fetchAll',
    upsertCustomer: 'upsert'
  }), {
    deleteCustomers: function deleteCustomers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contemplados, customers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, customer, lamps, index, holder, novosDadosDoContemplado;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                contemplados = [];
                _context.next = 4;
                return _this.fetchCustomers({
                  limit: 99999999
                });

              case 4:
                customers = _context.sent;


                _this.total = customers.length;

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(customers);

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 28;
                  break;
                }

                customer = _step.value;
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').collection('lamps').limit(99999999).where('customer.id', customer._id).get();

              case 15:
                lamps = _context.sent;


                for (index in lamps) {
                  holder = lamps[index].customer.holder;


                  lamps[index].customer.holder = holder.substring(0, 3) + '**********' + holder.substring(holder.length - 3, holder.length);

                  delete lamps[index].customer.cpf;
                }

                _context.next = 19;
                return _this.couchdbLamps._updateBulkDocs(lamps);

              case 19:
                if (!customer.contemplated) {
                  _context.next = 23;
                  break;
                }

                novosDadosDoContemplado = __WEBPACK_IMPORTED_MODULE_6_src_services_LGPD__["a" /* default */].removeCustomerSensitiveData(customer);


                contemplados.push(novosDadosDoContemplado);
                return _context.abrupt('continue', 25);

              case 23:
                _context.next = 25;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').delete(customer._id);

              case 25:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 34:
                _context.prev = 34;
                _context.prev = 35;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 37:
                _context.prev = 37;

                if (!_didIteratorError) {
                  _context.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context.finish(37);

              case 41:
                return _context.finish(34);

              case 42:
                _context.next = 44;
                return _this.couchdbCustomers._updateBulkDocs(contemplados);

              case 44:
                _this.isLoading = false;

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 30, 34, 42], [35,, 37, 41]]);
      }))();
    }
  })
});

/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("CRWE");
function injectStyle (ssrContext) {
  __webpack_require__("IWrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fnNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__ = __webpack_require__("R6cd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2929dbce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__ = __webpack_require__("Fck+");
function injectStyle (ssrContext) {
  __webpack_require__("11YL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2929dbce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2929dbce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fry3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Couchdb__ = __webpack_require__("pk/q");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'remove-duplicated-lamps',

  data: function data() {
    return {
      lamps: {},
      originalLamps: [],
      lampsByCustomerId: {},
      idToRemoved: [],
      loading: false,
      progressPercentage: 0,
      fullLamps: []
    };
  },


  computed: {
    countLamps: function countLamps() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.lamps).length;
    },


    events: {
      get: function get() {
        return this.$store.state.events.all.reduce(function (acc, curr, indx) {
          if (indx === 0) {
            acc = {};
          }
          var id = curr._id;
          acc[id] = curr.reference + '_' + curr.place + '}';
          return acc;
        }, {});
      }
    },

    countOriginalLamps: function countOriginalLamps() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.originalLamps).length;
    },
    countLampsItemsToRemove: function countLampsItemsToRemove() {
      var _this = this;

      return this.idToRemoved.map(function (item) {
        return _this.originalLamps[item];
      }).reduce(function (acc, curr, indx) {
        acc = indx === 0 ? 0 : acc;
        return acc + curr.items.length;
      }, 0);
    },


    config: {
      get: function get() {
        return this.$store.state.config;
      }
    }
  },

  methods: {
    handleExec: function handleExec() {
      this.loading = true;
      this.resetValues();
      this.fetchLamps();
    },
    fetchLamps: function fetchLamps() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_Couchdb__["a" /* default */].connection('default').view('lamps-by-createdAt', 'lamps-by-createdAt').then(function (response) {
        return _this2.verify(response);
      }).catch(function (err) {
        return _this2.handleError(err);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    verify: function verify(response) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.filterLamps(response);

              case 2:
                _this3.verifyLamps();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    filterLamps: function filterLamps(response) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve(_this4.filterLampsTwoMoreExchanges(_this4.getObjectLamps(response.rows.map(function (item) {
          return item.value;
        }))));
      });
    },
    filterLampsTwoMoreExchanges: function filterLampsTwoMoreExchanges(lampsObj) {
      for (var id in lampsObj) {
        if (lampsObj[id].length > 1) {
          this.lamps[id] = lampsObj[id];
        }
      }
    },
    getObjectLamps: function getObjectLamps(lamps) {
      var _this5 = this;

      this.setOriginalLampsById(lamps);
      return lamps.reduce(function (acc, curr, indx) {
        if (indx === 0) {
          acc = {};
        }
        var customerId = curr.customer.id;
        curr.createdAt = _this5.$moment(curr.createdAt).format('YYYY/MM/DD hh:mm:ss');
        if (!acc.hasOwnProperty(customerId)) {
          acc[customerId] = [curr];
        } else {
          acc[customerId].push(curr);
        }
        return acc;
      }, {});
    },
    setOriginalLampsById: function setOriginalLampsById(lamps) {
      this.originalLamps = lamps.reduce(function (acc, curr, indx) {
        if (indx === 0) {
          acc = {};
        }
        var customerId = curr.customer.id;
        if (!acc.hasOwnProperty(customerId)) {
          acc[curr._id] = curr;
        }
        return acc;
      }, {});
    },
    verifyLamps: function verifyLamps() {
      for (var id in this.lamps) {
        this.verifySame(this.lamps[id]);
      }
    },
    verifySame: function verifySame(lamps) {
      var same = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {});
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          same = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, same);
          if (this.compareData(lamp, same)) {
            if (!same.hasOwnProperty(lamp._id)) {
              same[lamp._id] = { id: lamp.customer.id, uc: lamp.customer.uc, date: lamp.createdAt, event: lamp.eventId };
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    compareData: function compareData(lamp, same) {
      for (var key in same) {
        if (this.compareVerifyData(same[key], lamp)) {
          this.addIdToRemove(lamp._id);
          return false;
        }
      }
      return true;
    },
    compareVerifyData: function compareVerifyData(compare, lamp) {
      return lamp.customer.uc === compare.uc && lamp.createdAt === compare.date;
    },
    addIdToRemove: function addIdToRemove(id) {
      if (this.idToRemoved.indexOf(id) === -1) {
        this.idToRemoved.push(id);

        console.log('idLampada,' + this.originalLamps[id]._id + ',quantidade-lamapdas,' + this.originalLamps[id].items.length + ',data-troca,' + this.originalLamps[id].createdAt + ',uc-cliente,' + this.originalLamps[id].customer.uc + ',id-cliente,' + this.originalLamps[id].customer.id + ',event-id,' + this.originalLamps[id].eventId + ',event,' + this.events[this.originalLamps[id].eventId]);
      }
    },
    handleError: function handleError(err) {
      console.log('error', err);
    },
    resetValues: function resetValues() {
      this.idToRemoved = [];
      this.lamps = {};
    }
  }
});

/***/ }),

/***/ "fw4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TicketForm__ = __webpack_require__("dc9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TicketsList__ = __webpack_require__("/pma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_pages_Customers_CustomerCard_vue__ = __webpack_require__("NfkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_pages_Customers_CustomerImageCard_vue__ = __webpack_require__("uSbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_pages_Customers_CustomerImageCapture_vue__ = __webpack_require__("W+ZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_pages_Customers_Forms_AdditionalDataForm_vue__ = __webpack_require__("rSFS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomerCard: __WEBPACK_IMPORTED_MODULE_7_src_pages_Customers_CustomerCard_vue__["a" /* default */],
    CustomerImageCard: __WEBPACK_IMPORTED_MODULE_8_src_pages_Customers_CustomerImageCard_vue__["a" /* default */],
    AdditionalDataForm: __WEBPACK_IMPORTED_MODULE_10_src_pages_Customers_Forms_AdditionalDataForm_vue__["a" /* default */],
    CustomerImageCapture: __WEBPACK_IMPORTED_MODULE_9_src_pages_Customers_CustomerImageCapture_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    TicketForm: __WEBPACK_IMPORTED_MODULE_3__TicketForm__["a" /* default */],
    TicketsList: __WEBPACK_IMPORTED_MODULE_4__TicketsList__["a" /* default */]
  },
  data: function data() {
    return {
      currentTimestamp: new Date().getTime(),
      model: {},
      entityName: 'Tickets',
      isEditingAdditionalDataForm: false,
      isEditingImage: false,
      winnerLoaded: false,
      tireiFoto: false,
      hasImage: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['config']), {

    loading: {
      get: function get() {
        return this.$store.state.customers.loading;
      }
    },

    customer: {
      get: function get() {
        return this.$store.state.customers.one;
      }
    },

    customers: function customers() {
      var id = this.customer._id;
      return id ? {
        id: this.customer
      } : {};
    },
    tickets: function tickets() {
      return this.$store.state.tickets.all;
    },
    ticketsCount: function ticketsCount() {
      return this.tickets.length;
    },
    id: function id() {
      return this.$route.params.id;
    },
    customerImageClass: function customerImageClass() {
      return {
        'img-responsive': true,
        'center-block': true,
        'img-customer-placeholder': !this.hasImage,
        'img-thumbnail': this.hasImage
      };
    },
    hasAdditionalData: function hasAdditionalData() {
      return this.customer.address && this.customer.address.complement !== '' && this.customer.address.complement.length > 0;
    },
    showAdditionalDataForm: function showAdditionalDataForm() {
      return !this.hasAdditionalData || this.isEditingAdditionalDataForm;
    },
    showImageCapture: function showImageCapture() {
      return !this.hasImage || this.isEditingImage;
    },
    lampsRoute: function lampsRoute() {
      if (this.customer._id) {
        return {
          name: 'customers.lamps',
          params: { id: this.customer._id }
        };
      } else {
        return { name: 'customers.index' };
      }
    },
    enableForm: function enableForm() {
      return !this.loading && this.winnerLoaded;
    }
  }),

  watch: {
    customer: function customer() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.customer && _this.customer._id) {
          _this.handleFetchWinner();
        }
        _this.hasImage = _this.customer.hasOwnProperty('_attachments') && _this.customer._attachments.hasOwnProperty('image.jpg');
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('customers', {
    resetCustomer: 'resetOne',
    fetchCustomer: 'fetchOne',
    getUrlImg: 'getUrlImg',
    resetUrlImg: 'resetUrlImg',
    uploadCustomerImage: 'uploadCustomerImage'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('winners', {
    fetchWinner: 'fetchAll',
    resetWinner: 'resetOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', {
    fetchTickets: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('users', {
    fetchUsers: 'fetchAll'
  }), {
    handleFetchWinner: function handleFetchWinner() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var where;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.winnerLoaded = false;
                _this2.resetWinner();
                where = [];

                if (_this2.config.validationContemplatedCustomer.uc) {
                  where.push({ uc: _this2.customer.uc });
                }
                if (_this2.config.validationContemplatedCustomer.cpf) {
                  where.push({ cpf: _this2.customer.cpf.replace(/\D/g, '') });
                }
                if (_this2.config.validationContemplatedCustomer.ucOrCpf) {
                  where = [{ '$or': where }];
                }
                if (where.length > 0) {
                  _this2.fetchWinner({ where: where });
                }
                _this2.winnerLoaded = true;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getCustomer: function getCustomer() {
      var _this3 = this;

      return this.fetchCustomer(this.id).then(function (response) {
        _this3.hasImage = _this3.customer.hasOwnProperty('_attachments') && _this3.customer._attachments.hasOwnProperty('image.jpg');
        _this3.getUrlImg({ id: _this3.id });
        _this3.currentTimestamp = new Date().getTime();
        _this3.handleFetchWinner();
        return response;
      });
    },
    handleFetchTickets: function handleFetchTickets() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.getCustomer();
                location.reload();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    handleImageSave: function handleImageSave(data) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_blob_util___default.a.imgSrcToBlob(data.image).then(function (blobFile) {
        _this5.uploadCustomerImage({
          id: _this5.customer._id,
          mimeType: 'image/jpeg',
          name: 'image.jpg',
          attachment: blobFile
        }).then(function () {
          _this5.getCustomer().then(function (res) {
            _this5.currentTimestamp = new Date().getTime();
            _this5.isEditingImage = false;
          });
        });
      });
    },
    additionalDataSaved: function additionalDataSaved() {
      this.getCustomer();
      this.isEditingAdditionalDataForm = false;
    },
    enableEditAdditionalData: function enableEditAdditionalData() {
      this.isEditingAdditionalDataForm = true;
    },
    enableEditImage: function enableEditImage() {
      this.tireiFoto = false;
      this.isEditingImage = true;
    }
  }),

  mounted: function mounted() {
    this.resetCustomer();
    this.resetWinner();
    this.resetUrlImg();
    this.hasImage = false;
    this.fetchUsers({ limit: 99 });
    this.getCustomer();
    this.fetchEvents({ select: ['status', '_id', 'reference', 'place', 'city'], limit: 99999 });
    this.fetchTickets({ where: [{ customerId: this.id }], limit: 9999 });
  }
});

/***/ }),

/***/ "fxw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Troca de Geladeiras")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.imagesMap.refrigerators),function(image,index){return _c('span',{key:image},[_c('input',{attrs:{"type":"radio","name":"refrigerator_icon"},domProps:{"value":_vm.value,"checked":image === _vm.value},on:{"input":function($event){return _vm.$emit('input', image)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagesMap.basePath + image,"alt":'refrigerator icon' + index}})])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Caminhões")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.imagesMap.trucks),function(image,index){return _c('span',{key:image},[_c('input',{attrs:{"type":"radio","name":"refrigerator_icon"},domProps:{"value":_vm.value,"checked":image === _vm.value},on:{"input":function($event){return _vm.$emit('input', image)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagesMap.basePath + image,"alt":'refrigerator icon' + index}})])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Agentes")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.imagesMap.personas),function(image,index){return _c('span',{key:image},[_c('input',{attrs:{"type":"radio","name":"refrigerator_icon"},domProps:{"value":_vm.value,"checked":image === _vm.value},on:{"input":function($event){return _vm.$emit('input', image)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagesMap.basePath + image,"alt":'refrigerator icon' + index}})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fzNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dashboardCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dashboardCustomersCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dashboardSurveysCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return verifyEmptyTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defineWhereObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__ = __webpack_require__("pk/q");



var dashboardCounter = function dashboardCounter(model, eventsId, dateRange) {
  var query = {
    connection: 'default',
    ddoc: 'dashboard-counter-model-event-date',
    view: 'dashboard-counter-model-event-date',
    queries: []
  };
  if (eventsId) {
    eventsId.forEach(function (element) {
      var queryBuilder = {
        reduce: true,
        group_level: 1,
        inclusive_end: true,
        start_key: defineKeys(model, element, dateRange).start_key,
        end_key: defineKeys(model, element, dateRange).end_key
      };
      query.queries.push(queryBuilder);
    });
  }
  return reduceResult(query);
};

var dashboardCustomersCounter = function dashboardCustomersCounter(dateRange) {
  var query = {
    connection: 'default',
    ddoc: 'count-customers-all',
    view: 'count-customers-all',
    queries: [{
      start_key: dateRange[0],
      end_key: dateRange[1]
    }]
  };
  return reduceResult(query);
};

var dashboardSurveysCounter = function dashboardSurveysCounter(eventsId, dateRange) {
  var query = {
    connection: 'surveys',
    ddoc: 'counters',
    view: 'surveys-by-status',
    queries: [{
      reduce: true
    }]
  };

  return reduceResult(query);
};

var defineKeys = function defineKeys(model, eventsId, dateRange) {
  if (dateRange && dateRange.length !== 0) {
    var query = {
      start_key: [model, eventsId],
      end_key: [model, eventsId]
    };
    if (dateRange[0] && !dateRange[1]) {
      query.start_key.push(dateRange[0]);
      query.end_key.push({});
      return query;
    }
    if (!dateRange[0] && dateRange[1]) {
      query.end_key.push(dateRange[1]);
      return query;
    }
    query.start_key.push(dateRange[0]);
    query.end_key.push(dateRange[1]);
    return query;
  }
  if (eventsId) {
    var _query = {
      start_key: [model, eventsId],
      end_key: [model, eventsId, {}]
    };
    return _query;
  }
  return {
    start_key: [model],
    end_key: [model, {}]
  };
};

var reduceResult = function reduceResult(query) {
  return __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__["a" /* default */].viewQueries(query).then(function (result) {
    return result.reduce(function (acc, curr) {
      if (curr.rows.length > 0) {
        return Number(acc) + Number(curr.rows[0].value);
      }
      return acc;
    }, 0);
  });
};

var verifyEmptyTags = function verifyEmptyTags(tags) {
  var emptyTags = true;
  for (var categorie in tags) {
    emptyTags = emptyTags && tags[categorie].length === 0;
  }
  return emptyTags;
};

var defineWhereObject = function defineWhereObject(dateRange, tags, fieldTags) {
  var labelTag = !fieldTags ? 'tags' : fieldTags;
  var where = { '$and': [] };
  if (dateRange && dateRange.length > 0) {
    where['$and'].push({
      'startDate': {
        '$gte': dateRange[0]
      }
    });
    where['$and'].push({
      'startDate': {
        '$lte': dateRange[1]
      }
    });
  }

  if (verifyEmptyTags(tags)) {
    return where;
  }
  for (var categorie in tags) {
    if (tags[categorie].length === 0) continue;

    var orWhere = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tags[categorie]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var tag = _step.value;

        var fieldWhere = {};
        fieldWhere[labelTag] = {
          '$elemMatch': {
            '$eq': tag
          }
        };
        orWhere.push(fieldWhere);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (orWhere.length === 0) {
      continue;
    }

    where['$and'].push({
      '$or': orWhere
    });
  }
  return where;
};



/***/ }),

/***/ "g4+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('el-select',{staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"all","label":"Todos"}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd",on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Colocar stockId=null nos Tickets\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g70d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");












/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      couchdbTickets: new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' }),
      eventIdSelected: '',
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('events', {
    events: 'events'
  }), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), {
    handleCommand: function handleCommand() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      var query = this.couchdbTickets;
      if (this.eventIdSelected !== 'all') {
        query.where('eventId', this.eventIdSelected);
      }
      query.get().then(function (docs) {
        _this.isLoading = false;

        var docsFiltered = docs.filter(function (doc) {
          return doc.stockId;
        });

        _this.total = docsFiltered.length;
        var swalOptions = {
          title: 'Existem ' + docsFiltered.length + ' stockId!=null.'
        };
        if (docsFiltered.length === 0) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todos os tickets est\xE3o com stockId=null.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA quer definir stockId=null em todos os tickets?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, faça isso!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.total++;
                    promises = [];
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 5;

                    for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(docsFiltered); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      item = _step.value;

                      promises.push(_this.exec(item));
                      _this.progress++;
                    }
                    _context.next = 13;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](5);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 13:
                    _context.prev = 13;
                    _context.prev = 14;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 16:
                    _context.prev = 16;

                    if (!_didIteratorError) {
                      _context.next = 19;
                      break;
                    }

                    throw _iteratorError;

                  case 19:
                    return _context.finish(16);

                  case 20:
                    return _context.finish(13);

                  case 21:
                    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function (result) {
                      _this.progress = _this.total;
                      _this.notifyFinish();
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 22:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[5, 9, 13, 21], [14,, 16, 20]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(item) {
      delete item.stockId;
      item.stockId = null;
      return this.couchdbTickets.update(item._id, item);
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "g73q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTerm_vue__ = __webpack_require__("y4Zp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7861c864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTerm_vue__ = __webpack_require__("37JD");
function injectStyle (ssrContext) {
  __webpack_require__("+nA3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTerm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7861c864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTerm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gBnQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Documents_SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Documents_Terms_HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-equatorial-pi',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__pages_Documents_SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__pages_Documents_Terms_HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gLAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-term-lamps',

  data: function data() {
    return {
      selectedFiles: [],
      isLoadingFile: false
    };
  },


  methods: {
    handleFiles: function handleFiles(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var files;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = data.target.files;

                Array.prototype.forEach.call(files, function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file) {
                    var loadedFile, blob;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.selectedFiles.push(file.name);

                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* filesService */].loadFile(file);

                          case 3:
                            loadedFile = _context.sent;
                            blob = new Blob([loadedFile], { type: file.type });

                            _this.$emit('update-file', {
                              name: file.name,
                              blob: blob
                            });

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "gP6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gQ9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsUsersReport_vue__ = __webpack_require__("Lcgs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96331ad4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsUsersReport_vue__ = __webpack_require__("USbD");
function injectStyle (ssrContext) {
  __webpack_require__("ofHV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96331ad4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsUsersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96331ad4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsUsersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gVel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatusReplication_vue__ = __webpack_require__("5/5T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef74b5a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatusReplication_vue__ = __webpack_require__("9HaS");
function injectStyle (ssrContext) {
  __webpack_require__("m9PM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef74b5a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatusReplication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef74b5a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatusReplication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gW1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDuplicatedLamps_vue__ = __webpack_require__("fry3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2bda638_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDuplicatedLamps_vue__ = __webpack_require__("ADji");
function injectStyle (ssrContext) {
  __webpack_require__("hDsX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2bda638"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDuplicatedLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2bda638_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDuplicatedLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gdYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-customer-content',
  props: {
    customer: {
      required: true
    }
  },

  computed: {
    hasCustomer: function hasCustomer() {
      return this.customer.hasOwnProperty('_id');
    },
    phoneNumbers: function phoneNumbers() {
      return this.customer.phones.length > 0 ? this.customer.phones.join(' / ') : ' - ';
    }
  }
});

/***/ }),

/***/ "gkTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));

/***/ }),

/***/ "gkr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventIcons_vue__ = __webpack_require__("89uX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a305174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventIcons_vue__ = __webpack_require__("Em9G");
function injectStyle (ssrContext) {
  __webpack_require__("mSF+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a305174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventIcons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a305174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "goSf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",on:{"click":function($event){return _vm.deleteCustomers()}}},[_vm._v("\n    Deletar dados sensíveis de clientes\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gww+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__ = __webpack_require__("jPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__ = __webpack_require__("oE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Good job!', 'You clicked the finish button!', 'success');
    }
  }
});

/***/ }),

/***/ "h/lR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a),
  data: function data() {
    return {
      indexPath: { name: 'stock.index' },
      entityName: 'Estoque',
      saving: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['eventId', 'manufacturerId', 'invoice', 'dateInvoice', 'invoicePowerCompany', 'dateInvoicePowerCompany', 'numberOfRefigerators', 'description']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('stocks', {
    model: 'stock',
    modelValidations: 'validations',
    loading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('manufacturers', {
    manufacturers: 'manufacturers'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('events', {
    events: 'events'
  }), {
    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    },
    title: function title() {
      return this.editing ? 'Editar ' + this.entityName : 'Novo ' + this.entityName;
    }
  }),
  created: function created() {
    if (this.editing) {
      this.fetchOne(this.id);
    } else {
      this.resetOne();
    }
    this.fetchAllManufecturers();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('stocks', ['fetchOne', 'resetOne', 'insert', 'update']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('manufacturers', {
    fetchAllManufecturers: 'fetchAll'
  }), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.model);
          doc.collection = 'stocks';
          if (_this.editing) {
            return _this.update(doc).then(function (result) {
              _this.$notify({
                message: 'Registro editado com sucesso.',
                type: 'success'
              });
              _this.$router.push({ name: 'stock.index' });
            }).catch(function (err) {
              return console.log(err);
            });
          }
          return _this.insert(doc).then(function (result) {
            _this.$notify({
              message: 'Registro criado com sucesso.',
              type: 'success'
            });
            _this.$router.push({ name: 'stock.index' });
          }).catch(function (err) {
            return console.log(err);
          });
        }
        _this.saving = false;
      }).catch(function (err) {
        console.log(err);
        _this.saving = false;
      });
    }
  }),
  mounted: function mounted() {
    this.fetchEvents({
      where: [{ status: 1 }]
    });
  }
});

/***/ }),

/***/ "h2pr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-index"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Defina o marcador para separa as colunas do arquivo CSV")]),_vm._v(":\n          "),_c('p-radio',{attrs:{"inline":"","label":";"},model:{value:(_vm.csvSeparator),callback:function ($$v) {_vm.csvSeparator=$$v},expression:"csvSeparator"}},[_vm._v("; (ponto e vírgula)\n          ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":","},model:{value:(_vm.csvSeparator),callback:function ($$v) {_vm.csvSeparator=$$v},expression:"csvSeparator"}},[_vm._v(", (vírgula)\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Relatório de lâmpadas por usuário:")]),_vm._v(" "),_c('LampsUsersReport',{attrs:{"csv-separator":_vm.csvSeparator}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Relatórios gerais ")]),_vm._v(" "),_c('general-counter-report')],1)]),_vm._v(" "),_c('h4',[_vm._v("\n        Filtrar: "+_vm._s(_vm.eventLabel)+"\n      ")]),_vm._v(" "),_c('dashboard-form-filters',{attrs:{"showTimeRange":true,"buttom-label":("Filtrar " + _vm.eventLabel)},on:{"filter":_vm.handleFilter}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v(" Selecionar "+_vm._s(_vm.eventLabel))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('EventsOptions',{attrs:{"multiple":_vm.eventChoice === 'many'},on:{"eventSelected":function($event){return _vm.onEventSelected($event)}}}),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enablePartial),expression:"enablePartial"}],attrs:{"type":"checkbox","id":"enable-partial-report"},domProps:{"checked":Array.isArray(_vm.enablePartial)?_vm._i(_vm.enablePartial,null)>-1:(_vm.enablePartial)},on:{"change":function($event){var $$a=_vm.enablePartial,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enablePartial=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enablePartial=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enablePartial=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"enable-partial-report"}},[_vm._v("Gerar relatório parcial")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('lamps-report',{attrs:{"event-selected":_vm.eventSelected,"all-events":_vm.allEvents,"csv-separator":_vm.csvSeparator},on:{"progress":function($event){return _vm.setProgress($event)}}}),_vm._v(" "),_c('global-ranking-report',{attrs:{"events":_vm.eventsChosen,"enable-partial":_vm.enablePartial,"csv-separator":_vm.csvSeparator}})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h4',[_vm._v("\n        Filtrar: "+_vm._s(_vm.eventLabel)+"\n      ")]),_vm._v(" "),_c('dashboard-form-filters',{attrs:{"showTimeRange":true,"buttom-label":("Filtrar " + _vm.eventLabel)},on:{"filter":_vm.handleSimplifiedFilter}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v(" Selecionar "+_vm._s(_vm.eventLabel))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('EventsOptions',{attrs:{"multiple":_vm.eventChoice === 'many'},on:{"eventSelected":function($event){return _vm.onEventSelected($event)}}}),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enableLGPD),expression:"enableLGPD"}],attrs:{"type":"checkbox","id":"enable-lgpd"},domProps:{"checked":Array.isArray(_vm.enableLGPD)?_vm._i(_vm.enableLGPD,null)>-1:(_vm.enableLGPD)},on:{"change":function($event){var $$a=_vm.enableLGPD,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enableLGPD=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enableLGPD=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enableLGPD=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"enable-lgpd"}},[_vm._v("Ofuscar nomes dos clientes")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('el-progress',{attrs:{"percentage":_vm.progressPercentageSimplified}})],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('lamps-report-simplified',{attrs:{"event-selected":_vm.eventSelected,"all-events":_vm.allEvents,"csv-separator":_vm.csvSeparator,"enableLGPD":_vm.enableLGPD},on:{"progress":function($event){return _vm.setProgressSimplified($event)}}}),_vm._v(" "),_c('global-ranking-report-simplified',{attrs:{"events":_vm.eventsChosen,"csv-separator":_vm.csvSeparator,"enableLGPD":_vm.enableLGPD}})],1)])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-align-left"}),_vm._v(" Definições do Relatório\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Relatórios Simplificados ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h49K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCelpa_vue__ = __webpack_require__("9NTb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301a4ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCelpa_vue__ = __webpack_require__("i9Vu");
function injectStyle (ssrContext) {
  __webpack_require__("Jktz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-301a4ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermCelpa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301a4ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermCelpa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hBAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionsTableCategories__ = __webpack_require__("kT/0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-categories',

  components: {
    ActionsTableCategories: __WEBPACK_IMPORTED_MODULE_1__ActionsTableCategories__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('categories', {
    categories: 'categories',
    loading: 'loading'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('categories', {
    deleteCategorie: 'delete'
  }), {
    handleEdit: function handleEdit(id) {
      this.$router.push({
        name: 'categories.edit',
        params: { id: id }
      });
    },
    handleRemove: function handleRemove(params) {
      var _this = this;

      var swal = __webpack_require__("PBfN");
      swal({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function (res) {
        if (res) {
          _this.deleteCategorie(params.id).then(function (res) {
            return _this.$emit('refresh');
          }).catch(function (er) {
            return console.log(er);
          });
        }
      });
    }
  })
});

/***/ }),

/***/ "hBAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-ticket-documentation',

  props: {
    ticket: {
      required: true,
      type: Object
    },

    event: {
      required: true,
      type: Object
    }
  },

  computed: {
    disableSendingDocumentation: function disableSendingDocumentation() {
      if (!this.event) {
        return true;
      } else if (this.event.winnerChoiceMode === 'ranking') {
        return !this.ticket.checkIn || !this.ticket.stockId || !this.ticket.winner;
      } else {
        return this.ticket.winner && this.ticket.stockId;
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tickets', ['resetOne']), {
    handleDocumentation: function handleDocumentation() {
      this.resetOne();
      this.$router.push({ name: 'tickets.details', params: { id: this.ticket._id } });
    }
  })
});

/***/ }),

/***/ "hCuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Ranking_RankingList__ = __webpack_require__("b/ob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Ranking_RankingActions__ = __webpack_require__("Cj6U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Events_EventCard__ = __webpack_require__("ee0G");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-index',

  components: {
    RankingList: __WEBPACK_IMPORTED_MODULE_2_src_pages_Ranking_RankingList__["a" /* default */],
    RankingActions: __WEBPACK_IMPORTED_MODULE_3_src_pages_Ranking_RankingActions__["a" /* default */],
    EventCard: __WEBPACK_IMPORTED_MODULE_4_src_pages_Events_EventCard__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', {
    event: 'event',
    eventLoading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('surveys', {
    surveysLoading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('tickets', {
    ticketsLoading: 'loading'
  }), {
    eventId: function eventId() {
      return this.$route.params.id;
    },


    tickets: {
      get: function get() {
        var _this = this;

        var tickets = this.$store.state.tickets.all.filter(function (ticket) {
          return ticket.eventId === _this.event._id;
        }).filter(function (ticket) {
          return ticket.rankingNow;
        }).sort(function (a, b) {
          return a.rankingNow - b.rankingNow;
        }).map(function (ticket) {
          ticket.survey = _this.surveys.find(function (survey) {
            return survey.ticketId === ticket._id;
          });
          return ticket;
        }).filter(function (ticket) {
          return ticket.customer;
        });

        if (this.event.hasSortTRG_889) {
          tickets = tickets.filter(function (ticket) {
            return ticket.survey || ticket.energyMetering;
          });
        }

        return tickets;
      }
    },

    surveys: {
      get: function get() {
        return this.$store.state.surveys.all.filter(function (survey) {
          return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && survey.data.accepted && survey.data.accepted !== 'false';
        });
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('events', {
    fetchEvent: 'fetchOne',
    resetEvent: 'resetOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tickets', {
    fetchTicketsWithCustomersByEvent: 'fetchTicketsWithCustomersByEvent',
    resetTickets: 'resetAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('surveys', {
    associateSurveys: 'associateSurveys',
    fetchSurveys: 'fetchViewAll',
    resetSurveys: 'resetAll'
  }), {
    reset: function reset() {
      this.resetEvent();
      this.resetTickets();
      this.resetSurveys();
    },
    fetch: function fetch() {
      this.fetchEvent(this.eventId);

      this.fetchTicketsWithCustomersByEvent({
        where: {
          eligible: true,
          surveyAssociated: true
        },
        eventId: this.eventId
      });

      this.fetchSurveys({
        database: 'surveys',
        ddoc: 'surveys-by-event',
        view: 'surveys-by-event',
        key: this.eventId
      });
    }
  }),

  mounted: function mounted() {
    this.reset();
    this.fetch();
  }
});

/***/ }),

/***/ "hDsX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hHcy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Trg_Tags_ListTags_vue__ = __webpack_require__("CXtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Trg_Tags_InputCategoriesTags_vue__ = __webpack_require__("Cydx");






var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard-form-filters',

  props: {
    showTimeRange: {
      default: true,
      type: Boolean
    },
    buttomLabel: {
      default: 'Filtrar',
      type: String
    }
  },

  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TagList', __WEBPACK_IMPORTED_MODULE_6_src_components_Trg_Tags_ListTags_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'InputCategoriesTags', __WEBPACK_IMPORTED_MODULE_7_src_components_Trg_Tags_InputCategoriesTags_vue__["a" /* default */]), _components),

  data: function data() {
    return {
      tagsSelected: {},
      rangeDate: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tags', ['tags'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    setRangeDate: 'changeRange'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tags', {
    setTags: 'setTagsDashboard',
    fetchTags: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('categories', {
    fetchCategories: 'fetchAll'
  }), {
    onChangeFilters: function onChangeFilters(event) {
      if (!this.tagsSelected.hasOwnProperty(event.categorie)) {
        this.tagsSelected[event.categorie] = [];
      }
      this.setFilters(event);
      this.setTags({ payload: this.tagsSelected, tags: this.tags });
    },
    setFilters: function setFilters(input) {
      if (this.tagsSelected[input.categorie].indexOf(input.tag) !== -1) {
        return this.tagsSelected[input.categorie].splice(this.tagsSelected[input.categorie].indexOf(input.tag), 1);
      }

      return this.tagsSelected[input.categorie].push(input.tag);
    }
  }),

  mounted: function mounted() {
    this.fetchTags({ limit: 999 });
    this.fetchCategories({ limit: 999 });
  }
});

/***/ }),

/***/ "hJwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__ = __webpack_require__("aX02");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f544fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__ = __webpack_require__("kCHr");
function injectStyle (ssrContext) {
  __webpack_require__("q+Kt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34f544fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f544fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hMmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCelpaJurunas_vue__ = __webpack_require__("+VkM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc121d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCelpaJurunas_vue__ = __webpack_require__("0vcz");
function injectStyle (ssrContext) {
  __webpack_require__("Z4om")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc121d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermCelpaJurunas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc121d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermCelpaJurunas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hN15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnergisaPb_vue__ = __webpack_require__("eKfm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6933d1f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnergisaPb_vue__ = __webpack_require__("3D6+");
function injectStyle (ssrContext) {
  __webpack_require__("J0I9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6933d1f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermEnergisaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6933d1f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermEnergisaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hPou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'users.index';
    }
  }
});

/***/ }),

/***/ "hQ4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hQ4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));

/***/ }),

/***/ "hRAx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hUPS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hYB6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hbU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('tickets.print'))?_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Imprimir ticket"},on:{"click":function($event){return _vm.handleTicketPrint()}}},[_c('i',{staticClass:"ti-receipt"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hiwl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hjzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsSpecifications_vue__ = __webpack_require__("p5eg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19296060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsSpecifications_vue__ = __webpack_require__("7pbB");
function injectStyle (ssrContext) {
  __webpack_require__("Cyqh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsSpecifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19296060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsSpecifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hmYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoadingFile: false,
      selectedFiles: [],
      binaryFiles: [],
      saving: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('tickets', {
    ticket: 'ticket'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), {

    unabled: function unabled() {
      var blockByWinner = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking';
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinner;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('tickets', ['updateState']), {
    loadFile: function loadFile(file) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          resolve(e.target.result);
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    handleSelectFiles: function handleSelectFiles() {
      this.$refs.filesContainer.click();
    },
    handleSelectFile: function handleSelectFile() {
      this.$refs.filesContainer.click();
    },
    handleFiles: function handleFiles(data) {
      var _this = this;

      this.isLoadingFile = true;
      var files = data.target.files;
      Array.prototype.forEach.call(files, function (file) {
        _this.selectedFiles.push(file.name);
        _this.loadFile(file).then(function (binaryFile) {
          _this.isLoadingFile = false;
          _this.binaryFiles.push(binaryFile);
        });
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var index, binaryFile, docId, referenceDoc, _doc, date, doc;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.saving = true;

                if (!(_this2.binaryFiles === null && Array.isArray(_this2.binaryFiles) && _this2.binaryFiles.length === 0)) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  text: 'Nenhum arquivo foi selecionado.',
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                });
                _context.next = 35;
                break;

              case 5:
                _this2.isLoadingFile = true;

                _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(_this2.binaryFiles);

              case 7:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 28;
                  break;
                }

                index = _context.t1.value;
                binaryFile = _this2.binaryFiles[index];
                docId = void 0;
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('docs').view('docs-by-reference-id', 'docs-by-reference-id', _this2.ticket._id);

              case 13:
                referenceDoc = _context.sent;

                referenceDoc = referenceDoc.rows[0] && referenceDoc.rows[0].value ? referenceDoc.rows[0].value : false;

                if (!referenceDoc) {
                  _context.next = 19;
                  break;
                }

                docId = referenceDoc._id;
                _context.next = 23;
                break;

              case 19:
                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('docs').insert({
                  database: 'trg_admin',
                  referenceId: _this2.ticket._id
                });

              case 21:
                _doc = _context.sent;

                docId = _doc.id;

              case 23:
                _context.next = 25;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(docId, {
                  mimeType: 'application/pdf',
                  attachmentName: _this2.selectedFiles[index],
                  attachment: binaryFile
                });

              case 25:
                console.log(referenceDoc);
                _context.next = 7;
                break;

              case 28:
                date = new Date();
                doc = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.ticket, { documentedAt: date });


                delete doc.customer;
                delete doc.event;
                delete doc.stock;

                _context.next = 35;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('default').updateWithView({
                  ddoc: 'tickets-by-id',
                  view: 'tickets-by-id',
                  payload: doc,
                  database: 'default'
                }).then(function (result) {
                  _this2.updateState({ documentedAt: date });
                  _this2.resetFile();
                  _this2.isLoadingFile = false;
                  _this2.$notify({
                    message: 'Documentação salva com sucesso.',
                    type: 'success'
                  });
                  window.location.reload();
                }).catch(function (err) {
                  return console.log(err);
                });

              case 35:

                _this2.saving = false;

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    resetFile: function resetFile() {
      this.selectedFiles = [];
      this.binaryFiles = [];
    }
  })
});

/***/ }),

/***/ "hrJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketRegisterDocPrint_vue__ = __webpack_require__("A82D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217a90f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketRegisterDocPrint_vue__ = __webpack_require__("RcaJ");
function injectStyle (ssrContext) {
  __webpack_require__("GXjO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-217a90f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketRegisterDocPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217a90f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketRegisterDocPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hzu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-info btn-xs btn-icon like",on:{"click":function($event){return _vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-warning btn-xs btn-icon edit",on:{"click":function($event){return _vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-danger btn-xs btn-icon remove",on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row table-full-width"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-shopping",staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":"","data":_vm.productsTable}},[_c('el-table-column',{attrs:{"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.image,"alt":"Agenda"}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(props.row.subTitle))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-price",attrs:{"min-width":"80","label":"Price"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.price)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"150","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.quantity)+"\n                "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity > 0 ? props.row.quantity-- : 0}}},[_c('i',{staticClass:"ti-minus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity++}}},[_c('i',{staticClass:"ti-plus"})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.quantity * props.row.price)+" ")])]}}])})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Links")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Switches")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With some subtitle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table Big Boy")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("A table for content management")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i+aZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Agile_vue__ = __webpack_require__("bODI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ee7bc02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Agile_vue__ = __webpack_require__("Durk");
function injectStyle (ssrContext) {
  __webpack_require__("Fcq6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Agile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ee7bc02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Agile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i/rH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0bx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__ = __webpack_require__("sTXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__ = __webpack_require__("Hyh/");
function injectStyle (ssrContext) {
  __webpack_require__("M0iJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i2QB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__ = __webpack_require__("cQlH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057f6606_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__ = __webpack_require__("ungQ");
function injectStyle (ssrContext) {
  __webpack_require__("mfY8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-057f6606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057f6606_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i6b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIascMa_vue__ = __webpack_require__("/NqG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca19dce8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIascMa_vue__ = __webpack_require__("OAMR");
function injectStyle (ssrContext) {
  __webpack_require__("YMOK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca19dce8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermIascMa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca19dce8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermIascMa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i9Vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iAbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-enel"},[_c('HeaderTerm',{attrs:{"imgsrc":"/static/img/enel-compartilha-logo.gif","event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.company))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n            ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iEtk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('router-link',{attrs:{"to":{name: 'surveys.view', params: {id: _vm.ticket.eventId, customerId: _vm.ticket.customerId}}}},[(_vm.areThereSurvey && _vm.$can('surveys.view'))?_c('button',{staticClass:"btn btn-info btn-fill btn-icon",attrs:{"title":"Visualizar pesquisas"}},[_c('i',{staticClass:"ti-eye"})]):_vm._e()]),_vm._v(" "),(_vm.areThereSurvey && _vm.$can('surveys.cancel'))?_c('button',{staticClass:"btn btn-danger btn-fill btn-icon",attrs:{"title":"Cancelar Pesquisa"},on:{"click":function($event){return _vm.eraseSurvey()}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iFH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersForm_vue__ = __webpack_require__("Tsxe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87286ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersForm_vue__ = __webpack_require__("XK9H");
function injectStyle (ssrContext) {
  __webpack_require__("UgDi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87286ed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iMuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pptxgenjs__ = __webpack_require__("/wT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pptxgenjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pptxgenjs__);





/* harmony default export */ __webpack_exports__["a"] = ({
  make: function make(tickets, customers, name, urlImages) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var pptx, firstSlide, id, uc, holder, cpf, slide;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pptx = new __WEBPACK_IMPORTED_MODULE_3_pptxgenjs___default.a();

              pptx.setLayout('LAYOUT_4x3');

              _context.t0 = pptx;
              _context.next = 5;
              return _this.getLayoutFirst(urlImages);

            case 5:
              _context.t1 = _context.sent;

              _context.t0.defineSlideMaster.call(_context.t0, _context.t1);

              _context.t2 = pptx;
              _context.next = 10;
              return _this.getLayoutMaster(urlImages);

            case 10:
              _context.t3 = _context.sent;

              _context.t2.defineSlideMaster.call(_context.t2, _context.t3);

              firstSlide = pptx.addNewSlide('FIRST_SLIDE');

              firstSlide.addText('CERIMÔNIA DE ENTREGA', { placeholder: 'title' });

              for (id in tickets) {
                uc = customers[tickets[id].customerId].uc;
                holder = customers[tickets[id].customerId].holder;
                cpf = customers[tickets[id].customerId].cpf;
                slide = pptx.addNewSlide('MASTER_SLIDE');

                slide.addText('UC: ' + uc, { placeholder: 'uc' });
                slide.addText(holder, { placeholder: 'holder' });
                slide.addText('CPF: ' + cpf, { placeholder: 'cpf' });
              }
              pptx.save(name);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getLayoutFirst: function getLayoutFirst(urlImages) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var logoTermDelivery, logoPresenter;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.convertImgToBase64URL(urlImages.imgTermDelivery);

            case 2:
              logoTermDelivery = _context2.sent;
              _context2.next = 5;
              return _this2.convertImgToBase64URL(urlImages.imgPresenterLeft);

            case 5:
              logoPresenter = _context2.sent;
              return _context2.abrupt('return', {
                title: 'FIRST_SLIDE',
                bkgd: 'ffffff',

                objects: [{ 'image': { x: 1, y: 0.2, data: logoTermDelivery } }, { 'image': { x: 8, y: 0.2, data: logoPresenter } }, {
                  'placeholder': {
                    options: { name: 'title', type: 'text', x: 0, y: 3.4, w: '100%', fontSize: 36, align: 'center', color: '000000' },
                    text: ''
                  }
                }]
              });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getLayoutMaster: function getLayoutMaster(urlImages) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var logoTermDelivery, logoPresenter;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.convertImgToBase64URL(urlImages.imgTermDelivery);

            case 2:
              logoTermDelivery = _context3.sent;
              _context3.next = 5;
              return _this3.convertImgToBase64URL(urlImages.imgPresenterLeft);

            case 5:
              logoPresenter = _context3.sent;
              return _context3.abrupt('return', {
                title: 'MASTER_SLIDE',
                bkgd: 'ffffff',

                objects: [{ 'rect': { x: 0, y: 1.4, w: '100%', h: 7, fill: 'eff3f6' } }, { 'rect': { x: 0.5, y: 3, w: '90%', h: 1, fill: '5abfa7' } }, { 'rect': { x: 2.5, y: 4, w: '50%', h: 1, fill: 'ffffff' } }, { 'image': { x: 1, y: 0.2, data: logoTermDelivery } }, { 'image': { x: 8, y: 0.2, data: logoPresenter } }, { 'image': { x: 8, y: 6, w: 1, h: 1.3, path: 'static/img/selo.png' } }, {
                  'placeholder': {
                    options: { name: 'holder', type: 'text', x: 0, y: 3.3, w: '100%', fontSize: 22, align: 'center', color: 'ffffff', bold: true },
                    text: ''
                  }
                }, {
                  'placeholder': {
                    options: { name: 'uc', type: 'text', x: 0, y: 4.2, w: '100%', fontSize: 18, align: 'center', color: '000000' },
                    text: ''
                  }
                }, {
                  'placeholder': {
                    options: { name: 'cpf', type: 'text', x: 0, y: 4.5, w: '100%', fontSize: 18, align: 'center', color: '000000' },
                    text: ''
                  }
                }]
              });

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  convertImgToBase64URL: function convertImgToBase64URL(url, outputFormat) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat);
        resolve(dataURL);
        canvas = null;
      };
      img.src = url;
    });
  }
});

/***/ }),

/***/ "iRF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnelCe_vue__ = __webpack_require__("vLBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe18af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnelCe_vue__ = __webpack_require__("cxw+");
function injectStyle (ssrContext) {
  __webpack_require__("I7Fr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbe18af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnelCe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe18af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnelCe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "idS3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "idYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b14763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("yFiE");
function injectStyle (ssrContext) {
  __webpack_require__("xJhi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b14763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ikOl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ilmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Surveys_Index__ = __webpack_require__("7eni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Surveys_AssociatedTicketsPrint__ = __webpack_require__("zT1H");



var path = 'surveys';
var title = 'Surveys';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/' + path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Surveys_Index__["a" /* default */],
  children: [{
    path: 'tickets-associated/:id/print',
    name: 'surveys.associated.tickets.print',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Surveys_AssociatedTicketsPrint__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivmY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TicketsConfigForm',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['validations']), {
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  })
});

/***/ }),

/***/ "iywj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"img-thumbnail",attrs:{"id":"webCamVideo","width":this.width,"height":this.height,"autoplay":this.autoplay}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j1v1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseModule__ = __webpack_require__("tv5d");




var collection = 'categories';
var singleName = 'categorie';
var pluralName = 'categories';
var connection = 'config';

var model = {
  name: '',
  apiEdu: false
};

var validations = {};

var getters = {};
getters[singleName] = function (state) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model, state.one);
};
getters[pluralName] = function (state) {
  return state.all;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["a" /* mapStates */])(), {
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["c" /* mapActions */])(collection, model, connection)),
  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["d" /* mapGetters */])(), getters, {
    loading: function loading(state) {
      return state.loading;
    },
    validations: function validations(state) {
      return state.validations;
    },
    filtersTags: function filtersTags(state) {
      return state.all.reduce(function (accumulate, current) {
        accumulate[current._id] = [];
        return accumulate;
      }, {});
    },
    categoriesApi: function categoriesApi(state) {
      return state.all.filter(function (item) {
        return item.hasOwnProperty('apiEdu') && item.apiEdu;
      });
    }
  })
});

/***/ }),

/***/ "j47L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropdown-item-children',
  functional: true,
  props: {
    children: {
      default: function _default() {
        return [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ component: '', data: '' })];
      }
    }
  },
  render: function render(h, context) {
    return h('div', [context.props.children.map(function (child) {
      return h('stateless-factory', {
        attrs: {
          componentProp: child.component,
          dataProp: child.data
        }
      });
    })]);
  }
});

/***/ }),

/***/ "j4l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InactivateUserAction__ = __webpack_require__("cbLC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReactivateUserAction__ = __webpack_require__("uClJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-index',

  components: {
    InactivateUserAction: __WEBPACK_IMPORTED_MODULE_2__InactivateUserAction__["a" /* default */],
    ReactivateUserAction: __WEBPACK_IMPORTED_MODULE_3__ReactivateUserAction__["a" /* default */]
  },
  data: function data() {
    return {
      pagination: {
        perPage: 99999,
        currentPage: 1,
        total: 0
      },
      sort: { field: 'createdAt', direction: 'desc' },
      search: {
        query: '',
        fields: ['name', 'login']
      }
    };
  },

  watch: {
    currentPage: function currentPage(_currentPage) {
      this.fetch();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('users', {
    count: 'count',
    loading: 'loading',
    user: 'user',
    tableData: 'noAdminAll'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.count;
      return this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('users', ['fetchAll', 'delete']), {
    fetch: function fetch() {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search,
        'where': [{ role: { '$ne': 'superadmin' } }] });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetch();
    },
    handleSort: function handleSort(sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      };
      this.fetch();
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this.delete(row._id).then(function (result) {
          _this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this.fetch();
        }).catch(function (err) {
          return console.log(err);
        });
      });
    }
  }),
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ "j9ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketActions_vue__ = __webpack_require__("nKY9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7397e72e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketActions_vue__ = __webpack_require__("VsXx");
function injectStyle (ssrContext) {
  __webpack_require__("ez44")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7397e72e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7397e72e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jCXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadDocumentation_vue__ = __webpack_require__("979U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d11d2a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadDocumentation_vue__ = __webpack_require__("LfTo");
function injectStyle (ssrContext) {
  __webpack_require__("O39M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d11d2a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnDownloadDocumentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d11d2a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnDownloadDocumentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jDdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-EquatorialPi',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "jDxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('div',[_vm._m(1),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"true"},model:{value:(_vm.project.ticket.automaticBarcode),callback:function ($$v) {_vm.$set(_vm.project.ticket, "automaticBarcode", $$v)},expression:"project.ticket.automaticBarcode"}},[_vm._v("Automático\n          ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"false"},model:{value:(_vm.project.ticket.automaticBarcode),callback:function ($$v) {_vm.$set(_vm.project.ticket, "automaticBarcode", $$v)},expression:"project.ticket.automaticBarcode"}},[_vm._v("Manual\n          ")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Configurações dos Tickets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n            O "),_c('strong',[_vm._v("código de barra")]),_vm._v(" será manual ou automático?\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jGXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertLamps_vue__ = __webpack_require__("vD7+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3181d40b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertLamps_vue__ = __webpack_require__("XknI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3181d40b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__ = __webpack_require__("PzXG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__ = __webpack_require__("hzu0");
function injectStyle (ssrContext) {
  __webpack_require__("LQk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jK9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTicket_vue__ = __webpack_require__("q/ei");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23865b5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTicket_vue__ = __webpack_require__("5aY9");
function injectStyle (ssrContext) {
  __webpack_require__("kCm7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23865b5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTicket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23865b5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTicket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jMRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Quantidade de lâmpadas")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.numberOfLamps),expression:"modelValidations.numberOfLamps"},{name:"model",rawName:"v-model",value:(_vm.event.numberOfLamps),expression:"event.numberOfLamps"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"numberOfLamps"},domProps:{"value":(_vm.event.numberOfLamps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event, "numberOfLamps", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfLamps.invalid),expression:"numberOfLamps.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('numberOfLamps'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"form-event-power-label"}},[_vm._v("Qual será a potência da lâmpada a ser entregue?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.lamp.powerLampDeliveryLabel),expression:"event.lamp.powerLampDeliveryLabel"}],staticClass:"form-control",attrs:{"type":"text","id":"form-event-power-label"},domProps:{"value":(_vm.event.lamp.powerLampDeliveryLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event.lamp, "powerLampDeliveryLabel", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"form-event-power-label"}},[_vm._v("Será obrigatório o tempo de lâmpadas no ato da troca?")]),_vm._v(" "),_c('YesNoRadio',{model:{value:(_vm.event.lamp.requiredTermLamp),callback:function ($$v) {_vm.$set(_vm.event.lamp, "requiredTermLamp", $$v)},expression:"event.lamp.requiredTermLamp"}}),_vm._v(" "),_c('small',[_vm._v("Somente será possível trocar lâmpada se enviar o termo")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h5',[_vm._v("Configurações de Lâmpadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("OBS: Não inserir o "),_c('strong',[_vm._v("W")]),_vm._v(" da potência")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("Rrpr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("uOOa");
function injectStyle (ssrContext) {
  __webpack_require__("UQPL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jTFk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jXUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jcvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
});

/***/ }),

/***/ "jk0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampsConfigForm',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', { modelValidations: 'validations' }), {
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  })
});

/***/ }),

/***/ "jtrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ApiForm',

  data: function data() {
    return {
      indexPath: { name: 'api.index' },
      saving: false,
      model: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])({
    url: 'url',
    token: 'token'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('api', {
    modelValidations: 'validations',
    loading: 'loading'
  })),

  mounted: function mounted() {
    var _this = this;

    this.fetchAll().then(function (apis) {
      if (apis.length > 0) {
        _this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, apis[0]);
      }
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('api', ['fetchAll', 'fetchOne', 'resetOne', 'upset']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setConfig']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this2 = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.runSave();
        }
      }).catch(function (err) {
        console.log(err);
        _this2.saving = false;
      });
    },
    runSave: function runSave() {
      var _this3 = this;

      var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model);
      this.upset(doc).then(function () {
        _this3.$notify({
          message: 'Registro atualizado com sucesso.',
          type: 'success'
        });
        _this3.$router.push(_this3.indexPath);
        _this3.saving = false;
      }).catch(function (err) {
        console.log(err);
        _this3.saving = false;
      });
    }
  })
});

/***/ }),

/***/ "jxWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jxvg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTermEquatorialPi',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {

    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "k0bX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyCustomerActions_vue__ = __webpack_require__("duY2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b729c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyCustomerActions_vue__ = __webpack_require__("iEtk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyCustomerActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b729c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyCustomerActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k4qY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__ = __webpack_require__("3juE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3548a641_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__ = __webpack_require__("qQ0T");
function injectStyle (ssrContext) {
  __webpack_require__("KEGj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3548a641"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3548a641_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k5IP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexLamps_vue__ = __webpack_require__("+EX8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75384404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexLamps_vue__ = __webpack_require__("qHWW");
function injectStyle (ssrContext) {
  __webpack_require__("CqfF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75384404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k6b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnergisaBorboremaPb_vue__ = __webpack_require__("yhrE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297b3f11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnergisaBorboremaPb_vue__ = __webpack_require__("3c90");
function injectStyle (ssrContext) {
  __webpack_require__("0Qzi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-297b3f11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LendingTermEnergisaBorboremaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297b3f11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LendingTermEnergisaBorboremaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k6dT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButtonClickStateless_vue__ = __webpack_require__("nZCM");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("FBJP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e29d116"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButtonClickStateless_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k6oI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'check-energy-metering-tickets',

  props: {
    ticket: {
      type: Object,
      required: true
    }
  },

  computed: {
    events: {
      get: function get() {
        return this.$store.state.events.all.reduce(function (acc, curr, indx) {
          if (indx === 0) {
            acc = {};
          }
          acc[curr._id] = curr;
          return acc;
        }, {});
      }
    },

    event: function event() {
      return this.events[this.ticket.eventId] ? this.events[this.ticket.eventId] : this.$store.state.events.one;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('tickets', ['upsertWithView']), {
    checkTicket: function checkTicket() {
      var _this = this;

      this.ticket.energyMetering = !this.ticket.energyMetering;
      var win = { energyMetering: this.ticket.energyMetering };

      win.winner = false;

      if (!this.ticket.winner) {
        win.winner = !this.event.hasOwnProperty('energyDefaultWinner') || this.event.energyDefaultWinner ? this.ticket.energyMetering : false;
      } else {
        win.winner = false;
      }

      if (!this.ticket.energyMetering) {
        win.checkIn = false;
      }

      var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ticket, win);
      this.upsertWithView({
        find: {
          ddoc: 'tickets-by-id',
          view: 'tickets-by-id',
          key: doc._id
        },
        payload: doc
      }).then(function () {
        var options = {
          message: 'Ticket desmarcado para medição.',
          type: 'warning'
        };

        if (_this.ticket.energyMetering) {
          options = {
            message: 'Ticket marcado para medição.',
            type: 'success'
          };
        }

        _this.$notify(options);
        _this.$emit('changeTickets', _this.ticket.customerId);
      }).catch(function (err) {
        console.log(err);
        _this.$notify({
          message: 'Ocorreu um problema ao definir o cliente para medição.',
          type: 'error'
        });
      });
    }
  })
});

/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("A+TP");
function injectStyle (ssrContext) {
  __webpack_require__("qAgR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8eK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_connections__ = __webpack_require__("ZKT5");









var collection = 'customers';
var singleName = 'customer';
var pluralName = 'customers';
var model = {
  uc: '',
  cpf: '',
  nationalId: '',
  birthdate: '',
  holder: '',
  aka: '',
  motherName: '',
  carrer: '',
  cadastroOnline: false,
  politician: false,
  phone1: '',
  phone2: '',
  address: {
    street: '',
    number: '',
    neighborhood: '',
    city: '',
    zip: '',
    complement: ''
  },
  observartion: '',
  nis: '',
  regularity: '',
  contemplated: false
};
var validations = {
  initialData: {
    uc: { required: true, min: 2 },
    cpf: { required: true, cpf: true }
  },
  personalData: {
    motherName: { min: 5 },
    birthdate: { min: 10, max: 10 },
    nationalId: { required: true, min: 3 },
    holder: { required: true, min: 3 },
    aka: { min: 2 },
    phone1: { required: true, min: 14, max: 16 },
    phone2: { min: 14, max: 16 }
  },
  additionalData: {
    street: { required: true },
    number: { required: true },
    neighborhood: { required: true },
    city: { required: true },
    zip: { required: true, min: 9 },
    complement: { required: true },
    nis: { required: false, min: 11, max: 11 },
    regularity: { required: false }
  }
};
var getters = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, model, state.one);
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["a" /* mapStates */])(), {
    loading: false,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0,
    urlImages: {}
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["b" /* mapMutations */])(), {

    SET_IMAGES_URL: function SET_IMAGES_URL(state, payload) {
      state.urlImages = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state.urlImages, payload);
    },

    setAllAppend: function setAllAppend(state, payload) {
      var byId = state.all.reduce(function (acc, curr, indx) {
        if (indx === 0) {
          acc = {};
        }
        acc[curr._id] = curr._id;
        return acc;
      }, {});

      var all = state.all;

      payload.filter(function (item) {
        return !byId.hasOwnProperty(item._id);
      }).map(function (item) {
        return all.push(item);
      });

      state.all = all;
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["c" /* mapActions */])(collection, model), {
    fetchAllData: function fetchAllData(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var id = _ref2.id,
          options = _ref2.options;

      commit('changeLoading', true);
      var keys = { startKey: id, startIndex: 0, endKey: id, endIndex: 6 };
      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._viewBetween('join-customer-datas', 'join-customer-datas', keys, {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0,
        limit: 50
      }).then(function (docs) {
        if (docs.rows.length <= 0) {
          return;
        }

        var tickets = [];
        var events = [];
        var stocks = [];
        var lamps = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs.rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var row = _step.value;

            var doc = row.doc;
            var key = row.key[1];
            if (key === 0) {
              commit('setOne', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, doc));
            }

            if (key === 1) {
              tickets.push(doc);
            } else if (key === 2 || key === 5) {
              events.push(doc);
            } else if (key === 3) {
              stocks.push(doc);
            } else if (key === 4) {
              lamps.push(doc);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (!options || options.tickets !== false) {
          dispatch('tickets/setStateAll', tickets, { root: true });
        }
        if (!options || options.events !== false) {
          dispatch('events/setStateAll', events, { root: true });
        }
        if (!options || options.stocks !== false) {
          dispatch('stocks/setStateAll', stocks, { root: true });
        }
        if (!options || options.lamps !== false) {
          dispatch('lamps/setStateAll', lamps, { root: true });
        }

        commit('changeLoading', false);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        return commit('changeLoading', false);
      });
    },
    fetchCustomerDatas: function fetchCustomerDatas(_ref3, _ref4) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var id = _ref4.id;

      commit('changeLoading', true);
      var keys = { startKey: id, startIndex: 0, endKey: id, endIndex: 6 };
      __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default')._viewBetween('join-customer-datas', 'join-customer-datas', keys, {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0,
        limit: 50
      }).then(function (docs) {
        var customer = { tickets: [], lamps: [] };
        if (docs.rows.length > 0) {
          var _loop = function _loop(row) {
            var doc = row.doc;
            var key = row.key[1];
            if (key === 0) {
              customer = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(customer, doc);
            }

            if ([1, 2, 3].indexOf(key) !== -1) {
              if (key === 1) {
                customer.tickets.push(doc);
              } else {
                customer.tickets = customer.tickets.map(function (item) {
                  if (item.eventId === doc._id) {
                    item.event = doc;
                  } else if (item.stockId === doc._id) {
                    item.stock = doc;
                  }
                  return item;
                });
              }
            }

            if ([4, 5].indexOf(key) !== -1) {
              if (key === 4) {
                customer.lamps.push(doc);
              }
              if (key === 5) {
                customer.lamps = customer.lamps.map(function (item) {
                  if (item.eventId === doc._id) {
                    item.event = doc;
                  }
                  return item;
                });
              }
            }
          };

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs.rows), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row = _step2.value;

              _loop(row);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
        commit('setOne', customer);
        commit('changeLoading', false);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        return commit('changeLoading', false);
      });
    },
    searchCustomer: function searchCustomer(_ref5, _ref6) {
      var _this = this;

      var commit = _ref5.commit;
      var query = _ref6.query,
          options = _ref6.options;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var queryTest;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setAll', []);
                queryTest = query.replace(/\W+/g, '');

                if (!(queryTest.replace(/\D+/g, '') !== '')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('customers-by-uc', 'customers-by-uc', {
                  startKey: query.replace(/\D+/g, ''),
                  endKey: query.replace(/\D+/g, ''),
                  endIndex: '{}'
                }, options).then(function (response) {
                  commit('setAllAppend', response.rows.map(function (item) {
                    return item.value;
                  }).filter(function (item) {
                    return item.uc.indexOf(query) === 0;
                  }));
                }).catch(function (err) {
                  return console.log(err);
                });

              case 5:
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('customers-by-uc', 'customers-by-uc', {
                  startKey: query.replace(/\D+/g, ''),
                  endKey: query.replace(/\D+/g, ''),
                  endIndex: '{}'
                }, options).then(function (response) {
                  commit('setAllAppend', response.rows.map(function (item) {
                    return item.value;
                  }).filter(function (item) {
                    return item.cpf.indexOf(query) === 0;
                  }));
                }).catch(function (err) {
                  return console.log(err);
                });

              case 7:
                if (!queryTest.replace(/\d+/g, '')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('customers-by-holder', 'customers-by-holder', {
                  startKey: query.toUpperCase(),
                  endKey: query.toUpperCase(),
                  endIndex: '{}'
                }, options).then(function (response) {
                  commit('setAllAppend', response.rows.map(function (item) {
                    return item.value;
                  }).filter(function (item) {
                    return item.holder.indexOf(query) === 0;
                  }));
                }).catch(function (err) {
                  return console.log(err);
                });

              case 10:
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').viewBetween('customers-by-holder', 'customers-by-holder', {
                  startKey: query,
                  endKey: query,
                  endIndex: '{}'
                }, options).then(function (response) {
                  commit('setAllAppend', response.rows.map(function (item) {
                    return item.value;
                  }).filter(function (item) {
                    return item.holder.indexOf(query) === 0;
                  }));
                }).catch(function (err) {
                  return console.log(err);
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getUrlImg: function getUrlImg(_ref7, _ref8) {
      var commit = _ref7.commit;
      var id = _ref8.id;

      var baseURL = __WEBPACK_IMPORTED_MODULE_7__config_connections__["a" /* default */].default.host + '/' + __WEBPACK_IMPORTED_MODULE_7__config_connections__["a" /* default */].default.db + '/' + id;
      commit('SET_IMAGES_URL', {
        image: baseURL + '/image.jpg'
      });
      return {
        image: baseURL + '/image.jpg'
      };
    },
    resetUrlImg: function resetUrlImg(_ref9) {
      var commit = _ref9.commit;

      commit('SET_IMAGES_URL', {});
    },
    uploadCustomerImage: function uploadCustomerImage(context, _ref10) {
      var id = _ref10.id,
          mimeType = _ref10.mimeType,
          name = _ref10.name,
          attachment = _ref10.attachment;

      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].connection('default').insertAttachment(id, {
        mimeType: mimeType,
        attachmentName: name,
        attachment: attachment
      });
    },
    fetchParticipantCount: function fetchParticipantCount(context, _ref11) {
      var eventsId = _ref11.eventsId;

      return __WEBPACK_IMPORTED_MODULE_6_src_services_Couchdb__["a" /* default */].viewQueries({
        connection: 'default',
        ddoc: 'count-participants-event',
        view: 'count-participants-event',
        queries: eventsId.map(function (id) {
          return {
            reduce: true,
            group_level: 2,
            inclusive_end: true,
            start_key: [id],
            end_key: [id, {}]
          };
        })
      }).then(function (result) {
        var count = result.reduce(function (acc, curr) {
          return acc + curr.rows.length;
        }, 0);
        context.commit('SET_DASHBOARD_COUNTER', count);
        return count;
      }).catch(function (a) {
        return console.log(a);
      });
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, getters, {
    urlImgs: function urlImgs(state) {
      return state.urlImages;
    },
    addressCustomer: function addressCustomer(state) {
      var addr = '';
      if (state.one.address.hasOwnProperty('street')) {
        addr += state.one.address.street;
      }
      if (state.one.address.hasOwnProperty('number')) {
        addr += addr !== '' ? ', ' + state.one.address.number : state.one.address.number;
      }
      if (state.one.address.hasOwnProperty('complement')) {
        addr += addr !== '' ? ', ' + state.one.address.complement : state.one.address.complement;
      }
      if (state.one.address.hasOwnProperty('neighborhood')) {
        addr += addr !== '' ? ', ' + state.one.address.neighborhood : state.one.address.neighborhood;
      }
      if (state.one.address.hasOwnProperty('city')) {
        addr += addr !== '' ? ', ' + state.one.address.city : state.one.address.city;
      }
      if (state.one.address.hasOwnProperty('zip')) {
        addr += addr !== '' ? ', ' + state.one.address.zip : state.one.address.zip;
      }
      return addr;
    }
  })
});

/***/ }),

/***/ "k9mR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 stock-form"},[_c('div',{staticClass:"card"},[_c('form',[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Evento")]),_vm._v(" "),_c('div',[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.eventId),expression:"modelValidations.eventId"}],staticClass:"select-primary",attrs:{"filterable":"","size":"xlarge","placeholder":"Selecione um evento","name":"eventId"},model:{value:(_vm.model.eventId),callback:function ($$v) {_vm.$set(_vm.model, "eventId", $$v)},expression:"model.eventId"}},_vm._l((_vm.events),function(option){return _c('el-option',{key:option._id,staticClass:"select-primary",attrs:{"value":option._id,"label":((option.city) + " - " + (option.reference))}})}),1)],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.eventId.invalid),expression:"eventId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('eventId'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Fabricante")]),_vm._v(" "),_c('div',[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.manufacturerId),expression:"modelValidations.manufacturerId"}],staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione um fabricante","name":"manufacturerId"},model:{value:(_vm.model.manufacturerId),callback:function ($$v) {_vm.$set(_vm.model, "manufacturerId", $$v)},expression:"model.manufacturerId"}},_vm._l((_vm.manufacturers),function(option){return _c('el-option',{key:option._id,staticClass:"select-primary",attrs:{"value":option._id,"label":option.name}})}),1)],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.manufacturerId.invalid),expression:"manufacturerId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('manufacturerId'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº referencia nota fiscal fabricante")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.invoice),expression:"modelValidations.invoice"},{name:"model",rawName:"v-model",value:(_vm.model.invoice),expression:"model.invoice"}],staticClass:"form-control",attrs:{"type":"number","name":"invoice"},domProps:{"value":(_vm.model.invoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "invoice", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoice.invalid),expression:"invoice.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('invoice'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data de emissão da nota fiscal do fabricante")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.dateInvoice),expression:"modelValidations.dateInvoice"}],attrs:{"name":"dateInvoice","type":"date","placeholder":"Escolha uma data","format":"dd/MM/yyyy","clearable":false,"editable":false},model:{value:(_vm.model.dateInvoice),callback:function ($$v) {_vm.$set(_vm.model, "dateInvoice", $$v)},expression:"model.dateInvoice"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateInvoice.invalid),expression:"dateInvoice.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('dateInvoice'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº referencia nota fiscal da concessionária")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.invoicePowerCompany),expression:"modelValidations.invoicePowerCompany"},{name:"model",rawName:"v-model",value:(_vm.model.invoicePowerCompany),expression:"model.invoicePowerCompany"}],staticClass:"form-control",attrs:{"type":"number","name":"invoicePowerCompany"},domProps:{"value":(_vm.model.invoicePowerCompany)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "invoicePowerCompany", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoicePowerCompany.invalid),expression:"invoicePowerCompany.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('invoicePowerCompany'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Data de Emissão da Nota Fiscal da Concessionaria")]),_vm._v(" "),_c('div',[_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.dateInvoicePowerCompany),expression:"modelValidations.dateInvoicePowerCompany"}],attrs:{"name":"dateInvoicePowerCompany","type":"date","placeholder":"Escolha uma data","format":"dd/MM/yyyy","clearable":false,"editable":false},model:{value:(_vm.model.dateInvoicePowerCompany),callback:function ($$v) {_vm.$set(_vm.model, "dateInvoicePowerCompany", $$v)},expression:"model.dateInvoicePowerCompany"}})],1),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateInvoicePowerCompany.invalid),expression:"dateInvoicePowerCompany.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('dateInvoicePowerCompany'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Quantidade de geladeiras")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.numberOfRefigerators),expression:"modelValidations.numberOfRefigerators"},{name:"model",rawName:"v-model",value:(_vm.model.numberOfRefigerators),expression:"model.numberOfRefigerators"}],staticClass:"form-control",attrs:{"type":"number","name":"numberOfRefigerators"},domProps:{"value":(_vm.model.numberOfRefigerators)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numberOfRefigerators", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfRefigerators.invalid),expression:"numberOfRefigerators.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('numberOfRefigerators'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descrição do produto")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"type":"text","name":"description"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.description.invalid),expression:"description.invalid"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('description'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[(_vm.$can('stock.create|stock.edit'))?_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.saving,"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Salvar\n        ")]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kAE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDocumentation_vue__ = __webpack_require__("hmYF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b07b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDocumentation_vue__ = __webpack_require__("ICmn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDocumentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b07b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDocumentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kCHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kCm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kEh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-index"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-xs-12"},[_c('event-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.eventLoading),expression:"eventLoading"}],attrs:{"event":_vm.event}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xs-12"},[_c('div',{staticClass:"ranking-actions card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-12"},[_c('ranking-actions',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.ticketsLoading || _vm.surveysLoading || _vm.eventLoading),expression:"ticketsLoading || surveysLoading || eventLoading"}],attrs:{"tickets":_vm.tickets,"event":_vm.event},on:{"runMakeRanking":function($event){return _vm.fetch()}}})],1)])])])])]),_vm._v(" "),(_vm.event.drawn)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('ranking-list',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.ticketsLoading || _vm.surveysLoading),expression:"ticketsLoading || surveysLoading"}],attrs:{"tickets":_vm.tickets,"event":_vm.event,"surveys":_vm.surveys,"ticketsLoading":_vm.ticketsLoading}})],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-list"}),_vm._v(" Ações ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kKT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-card',

  props: {
    ticket: {
      required: true
    },
    stock: {
      required: true
    },
    event: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('users', { users: 'usersIdName' }), {
    documentedAt: function documentedAt() {
      return this.ticket.documentedAt ? this.$moment(this.ticket.documentedAt).format('LLL') : false;
    },
    updatedAt: function updatedAt() {
      return this.ticket.updatedAt ? this.$moment(this.ticket.updatedAt).format('LLL') : '-';
    },
    checkin: function checkin() {
      return this.ticket.checkIn;
    },
    winner: function winner() {
      return this.ticket.winner;
    },
    hasStock: function hasStock() {
      return this.ticket.stockId && this.stock && this.stock.description !== '';
    }
  }),

  methods: {
    loadTicket: function loadTicket() {
      this.$emit('loadTicket', this.ticket);
    }
  }
});

/***/ }),

/***/ "kKpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveEventRanking_vue__ = __webpack_require__("sE9P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006b89de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveEventRanking_vue__ = __webpack_require__("6FTk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveEventRanking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006b89de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveEventRanking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kT/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableCategories_vue__ = __webpack_require__("fUFv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa4e038e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableCategories_vue__ = __webpack_require__("etPQ");
function injectStyle (ssrContext) {
  __webpack_require__("qTdh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa4e038e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionsTableCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa4e038e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionsTableCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("+2Xc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kcVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouterButton_vue__ = __webpack_require__("bvnp");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("GBSZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-012d9f34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouterButton_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kjFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActionButtonClick',
  props: {
    classStyle: {},
    title: {},
    iconClass: {},
    handleEvent: {},
    params: {}
  },

  methods: {
    onClick: function onClick() {
      this.handleEvent.click(this.params);
    }
  }
});

/***/ }),

/***/ "knXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      tableData: [],
      lengths: []
    };
  },

  computed: {
    loading: function loading() {
      return this.tableData <= 0;
    },
    allAttachmentsSize: function allAttachmentsSize() {
      return this.getReadableFileSizeString(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flattenDeep(this.lengths)));
    }
  },
  created: function created() {
    this.fetch(this.$route.params.connection);
  },

  watch: {},
  methods: {
    fetch: function fetch(connection) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection(connection).createView('commands', 'docsWithAttachment', {
        map: 'function (doc) {\n            if(doc._attachments !== undefined) {\n              emit(doc._id, doc._attachments);\n            }\n          }'
      }).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection(connection).view('commands', 'docsWithAttachment').then(function (result) {
          var lengths = [];
          _this.tableData = result.rows.map(function (item) {
            var lengthsForHumans = [];
            if (item.value === null || item.value === undefined) {} else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default()(item.value).sort()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var file = _step.value;

                  var length = item.value[file].length;
                  lengths.push(length);
                  lengthsForHumans.push(_this.getReadableFileSizeString(length));
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return {
                id: item.id,
                key: item.key,
                files: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default()(item.value).sort(),
                lengths: lengthsForHumans
              };
            }
          });
          _this.lengths = lengths;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
            width: 1000,
            title: 'Ocorreu um erro ao executar essa ação.',
            text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err),
            type: 'error',
            confirmButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          });
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getReadableFileSizeString: function getReadableFileSizeString(fileSizeInBytes) {
      var i = -1;
      var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);
      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    }
  }
});

/***/ }),

/***/ "ktiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyActions_vue__ = __webpack_require__("JG9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1970b2f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyActions_vue__ = __webpack_require__("sABW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1970b2f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l7bH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"name","label":"Nome","sortable":"","min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"login","label":"Login","sortable":"","min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"role","label":"Função","sortable":"","min-width":200},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(scope.row.role))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Criado Em","sortable":"","min-width":200},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm._f("moment")(scope.row.createdAt ? new Date(scope.row.createdAt) : new Date(),'DD/MM/YYYY HH:mm:ss'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":{name: 'users.edit', params: {id: props.row._id ? props.row._id : 'none'}}}},[_c('a',{staticClass:"btn btn-primary btn-fill btn-icon edit"},[_c('i',{staticClass:"ti-pencil-alt"})])]),_vm._v(" "),(!props.row.hasOwnProperty('inactivate') || props.row.inactivate !== true)?_c('inactivate-user-action',{attrs:{"user":props.row},on:{"fetch":_vm.fetch}}):_vm._e(),_vm._v(" "),(props.row.hasOwnProperty('inactivate') && props.row.inactivate === true)?_c('reactivate-user-action',{attrs:{"user":props.row,"fetch":"fetch"}}):_vm._e(),_vm._v(" "),(_vm.$can('user.remove'))?_c('a',{staticClass:"btn btn-danger btn-fill btn-icon remove",on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries "+_vm._s(_vm.count))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lAgc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lC0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{class:_vm.btnClass === '' ? 'btn btn-info btn-flat btn-block' : _vm.btnClass,attrs:{"type":"button","title":"Enviar Fotos"},on:{"click":function($event){return _vm.$refs.photosEvent.click()}}},[_c('i',{staticClass:"ti-camera"}),_vm._v(" "+_vm._s(_vm.btnClass === '' ? 'Enviar Fotos' : '')+"\n  ")]),_vm._v(" "),_c('input',{ref:"photosEvent",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","multiple":"","hidden":""},on:{"change":_vm.getFiles}}),_vm._v(" "),_c('dialog-upload-photos-event',{attrs:{"event-id":_vm.event._id,"show":_vm.dialog.show,"files":_vm.dialog.files},on:{"upload-photos":function($event){_vm.show = false}}}),_vm._v(" "),_c('canvas',{attrs:{"id":"canvasPlace","hidden":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lDIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__ = __webpack_require__("fd3O");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delivery-term-iasc-energisa-pb',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['urlImages']), {

    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Paraíba';
    },
    abbreviation: function abbreviation() {
      return 'Energisa';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 25',
        neighborhood: 'Cristo Redentor',
        city: 'João Pessoa',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '09.095.183/0001-40';
    },
    numberState: function numberState() {
      return '16.015.823-0';
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "lI0u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v("TRG Admin\n          "),_c('ProjectName')],1)])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":""}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1)])])]),_vm._v(" "),_c('ContentFooter')],1)]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lPRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexEventsSpecifications_vue__ = __webpack_require__("uPAp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f428534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexEventsSpecifications_vue__ = __webpack_require__("a+Fj");
function injectStyle (ssrContext) {
  __webpack_require__("p/Oq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f428534"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexEventsSpecifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f428534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexEventsSpecifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lPVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ParticipationTerm-iasc-energisa-borborema-pb',

  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  mounted: function mounted() {
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    config: function config() {
      return this.$store.state.config;
    },
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    },

    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Borborema';
    },
    abbreviation: function abbreviation() {
      return '';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 158',
        neighborhood: 'Bairro 3 Irmãs',
        city: 'Campina Grande',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '08.826.596/0001-95';
    },
    numberState: function numberState() {
      return '16.003.839/1';
    }
  }),
  filters: {
    uppercase: function uppercase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "lS3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Required text")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.requiredText),expression:"modelValidations.requiredText"},{name:"model",rawName:"v-model",value:(_vm.model.requiredText),expression:"model.requiredText"}],staticClass:"form-control",attrs:{"type":"text","name":"requiredText"},domProps:{"value":(_vm.model.requiredText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "requiredText", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredText.invalid),expression:"requiredText.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('requiredText'))+"\n            ")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n            ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.number),expression:"modelValidations.number"},{name:"model",rawName:"v-model",value:(_vm.model.number),expression:"model.number"}],staticClass:"form-control",attrs:{"type":"number","name":"number"},domProps:{"value":(_vm.model.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('number'))+"\n            ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Url")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.url),expression:"modelValidations.url"},{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"url","name":"url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.url.invalid),expression:"url.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('url'))+"\n            ")])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("\n            Equal to\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idSource),expression:"modelValidations.idSource"},{name:"model",rawName:"v-model",value:(_vm.model.idSource),expression:"model.idSource"}],staticClass:"form-control",attrs:{"name":"idSource","placeholder":"#idSource","type":"text"},domProps:{"value":(_vm.model.idSource)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idSource", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idSource.invalid),expression:"idSource.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idSource'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idDestination),expression:"modelValidations.idDestination"},{name:"model",rawName:"v-model",value:(_vm.model.idDestination),expression:"model.idDestination"}],staticClass:"form-control",attrs:{"name":"idDestination","placeholder":"#idDestination","type":"text"},domProps:{"value":(_vm.model.idDestination)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idDestination", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idDestination.invalid),expression:"idDestination.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idDestination'))+"\n            ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Validate inputs")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("required:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("email:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("decimal:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("url:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("confirmed : 'idSource'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lTQr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lXy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEventIdOnLamps_vue__ = __webpack_require__("zEvt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143cd4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEventIdOnLamps_vue__ = __webpack_require__("GKuA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEventIdOnLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143cd4fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEventIdOnLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ldPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export eventPhotos */
var eventPhotos = {
  uploadPhoto: uploadPhoto
};

function uploadPhoto() {
  return console.log('123');
}

/***/ }),

/***/ "leRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flattenObject; });
/* unused harmony export getWithPromises */
/* unused harmony export bindWiths */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFunction; });
/* unused harmony export isArray */
/* unused harmony export isDate */
/* unused harmony export isObject */
/* unused harmony export isValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDiff; });
/* unused harmony export compareValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLogDeeply; });
/* unused harmony export verifyDeeply */
/* unused harmony export VALUE_CREATED */
/* unused harmony export VALUE_UPDATED */
/* unused harmony export VALUE_DELETED */
/* unused harmony export VALUE_UNCHANGED */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Couchdb__ = __webpack_require__("pk/q");






var VALUE_CREATED = 'created';
var VALUE_UPDATED = 'updated';
var VALUE_DELETED = 'deleted';
var VALUE_UNCHANGED = 'unchanged';

var mergeDeeply = function mergeDeeply(target, source) {
  source = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(target, source);
  for (var i in source) {
    if (isObject(target[i])) {
      mergeDeeply(target[i], source[i]);
    }
    target[i] = source[i];
  }
};

var verifyDeeply = function verifyDeeply(field, diff, typeOfChange, ignoreFields) {
  if (diff.hasOwnProperty('type') && typeOfChange.indexOf(diff.type) !== -1) {
    return [{
      field: field,
      to: diff.to,
      from: diff.from
    }];
  } else if ((typeof diff === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(diff)) === 'object') {
    return getLogDeeply(diff, typeOfChange, ignoreFields);
  }
  return false;
};

var getLogDeeply = function getLogDeeply(diffs, typeOfChange, ignoreFields) {
  var docsLogs = [];

  var _loop = function _loop(diffIndex) {
    if (ignoreFields.indexOf(diffIndex) !== -1 || typeof diffs[diffIndex] !== 'boolean' && !diffs[diffIndex] || diffs[diffIndex] === null) {
      return 'continue';
    }
    var log = verifyDeeply(diffIndex, diffs[diffIndex], typeOfChange, ignoreFields);
    if (log) {
      if (!diffs[diffIndex].hasOwnProperty('type')) {
        log = log.map(function (item) {
          if (item.hasOwnProperty('field')) {
            item.field = diffIndex + '.' + item.field;
          }
          return item;
        });
      }
      docsLogs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(docsLogs), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(log));
    }
  };

  for (var diffIndex in diffs) {
    var _ret = _loop(diffIndex);

    if (_ret === 'continue') continue;
  }

  return docsLogs;
};

var getDiff = function getDiff(objNew, objOld) {
  if (isValue(objNew) || isValue(objOld)) {
    return {
      type: compareValues(objNew, objOld),
      data: typeof objNew === 'undefined' ? objOld : objNew,
      from: objOld,
      to: objNew
    };
  }

  var diff = {};

  for (var key in objNew) {
    if (isFunction(objNew[key]) || key === 'logs' || key === 'log') {
      continue;
    }

    var value2 = isFunction(objOld[key]) ? undefined : objOld[key];

    diff[key] = getDiff(objNew[key], value2);
  }

  for (var key2 in objOld) {
    if (isFunction(objOld[key2]) || typeof diff[key2] !== 'undefined' || key2 === 'logs' || key2 === 'log') {
      continue;
    }

    diff[key2] = getDiff(undefined, objOld[key2]);
  }

  return diff;
};

var compareValues = function compareValues(value1, value2) {
  if (value1 === value2) {
    return VALUE_UNCHANGED;
  }

  if (isDate(value1) && isDate(value2) && value1.getTime() === value2.getTime()) {
    return VALUE_UNCHANGED;
  }

  if (isDate(value1) && typeof value2 === 'string' && value1.toISOString() === value2) {
    return VALUE_UNCHANGED;
  }

  if (typeof value1 === 'undefined') {
    return VALUE_CREATED;
  }

  if (typeof value2 === 'undefined') {
    return VALUE_DELETED;
  }

  return VALUE_UPDATED;
};

var isFunction = function isFunction(obj) {
  return {}.toString.apply(obj) === '[object Function]';
};

var isArray = function isArray(obj) {
  return {}.toString.apply(obj) === '[object Array]';
};

var isDate = function isDate(obj) {
  return {}.toString.apply(obj) === '[object Date]';
};

var isObject = function isObject(obj) {
  return {}.toString.apply(obj) === '[object Object]';
};

var isValue = function isValue(obj) {
  return !isObject(obj) && !isArray(obj);
};

var flattenObject = function flattenObject(ob) {
  var toReturn = {};
  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) {
      continue;
    }

    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(ob[i]) === 'object') {
      var flatObject = flattenObject(ob[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};

var getWithPromises = function getWithPromises(result, payload) {
  var conn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

  var withPromises = [];
  for (var key in payload.with) {
    if (payload.with.hasOwnProperty(key)) {
      (function () {
        var item = payload.with[key];
        var keys = result.map(function (row) {
          return row[item.localKey];
        }).filter(function (key) {
          return key !== null && key !== undefined;
        });
        withPromises.push(__WEBPACK_IMPORTED_MODULE_4__Couchdb__["a" /* default */].collection(item.collection).whereIn(item.foreignKey, keys).all());
      })();
    }
  }
  return withPromises;
};

var bindWiths = function bindWiths(result, resultWiths, payload) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var i = 0;

    var _loop2 = function _loop2(key) {
      var item = payload.with[key];
      result.map(function (row) {
        row[key] = resultWiths[i].find(function (obj) {
          return obj[item.foreignKey] === row[item.localKey];
        });
      });
      i++;
    };

    for (var key in payload.with) {
      _loop2(key);
    }
    resolve(result);
  });
};


/***/ }),

/***/ "lfQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasCustomer)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('small',[_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+"\n      "),_c('span',{staticClass:"customer-content"},[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)+" ")]),_vm._v(" "),_c('span',{staticClass:"customer-content"},[_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Endereço:")]),_vm._v(" "+_vm._s(_vm.customer.address.street))]),_vm._v(" "),_c('span',{staticClass:"customer-content"},[_c('strong',[_vm._v("Número:")]),_vm._v(" "+_vm._s(_vm.customer.address.number))]),_vm._v(" "),_c('span',{staticClass:"customer-content"},[_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood))]),_vm._v(" "),_c('span',{staticClass:"customer-content"},[_c('strong',[_vm._v("Complemento:")]),_vm._v(" "+_vm._s(_vm.customer.address.complement))])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lfZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Trg_StatusReplications_CardStatusReplication__ = __webpack_require__("gVel");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexStatusReplication',
  components: {
    CardStatusReplication: __WEBPACK_IMPORTED_MODULE_0__components_Trg_StatusReplications_CardStatusReplication__["a" /* default */]
  },
  data: function data() {
    return {
      databases: {
        'default': 'Geral',
        'specifications': 'Especificações',
        'winners': 'Contemplados',
        'docs': 'Documentação',
        'logs': 'Logs',
        'surveys': 'Pesquisas',
        'surveys_docs': 'Documentação das pesquisas',
        'config': 'Configurações'
      },
      remote_database: {
        'remote_default': 'Remoto: Geral',
        'remote_specifications': 'Remoto: Especificações',
        'remote_winners': 'Remoto: Contemplados',
        'remote_docs': 'Remoto: Documentação',
        'remote_logs': 'Remoto: Logs',
        'remote_surveys': 'Remoto: Pesquisas',
        'remote_surveys_docs': 'Remoto: Documentação das pesquisas',
        'remote_config': 'Remoto: Configurações'
      }
    };
  }
});

/***/ }),

/***/ "lieO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Filters_DashboardFormFilters__ = __webpack_require__("POBv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputRadioIconRefrigeratoMap__ = __webpack_require__("JShI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_DashboardCounter__ = __webpack_require__("fzNA");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormIconTags',
  components: {
    DashboardFormFilters: __WEBPACK_IMPORTED_MODULE_7__Filters_DashboardFormFilters__["a" /* default */],
    InputRadioIconRefrigeratoMap: __WEBPACK_IMPORTED_MODULE_8__InputRadioIconRefrigeratoMap__["a" /* default */]
  },
  data: function data() {
    return {
      icon: 'troca_geladeira_0.png'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('eventsSpecifications', ['imagesMap']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tags', { tagsSelected: 'selecteds' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('categories', ['categories'])),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('eventsSpecifications', { updateManySpecifications: 'updateMany', fetchSpecifications: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('categories', { fetchCategories: 'fetchAll' }), {
    handleSave: function handleSave(event) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.tagsSelected).length !== 0 && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.tagsSelected).length < this.categories.length) {
        return this.notifyIncorrectCategorieSize();
      }
      return this.notifyProcess();
    },
    notifyProcess: function notifyProcess() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Confirmação',
        html: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.tagsSelected).length === 0 ? 'O icone <img src="' + this.imagesMap.basePath + this.icon + '"> ser\xE1 adicionado a todos os eventos.' : 'O icone <img src="' + this.imagesMap.basePath + this.icon + '"> ser\xE1 adicionado a todos os eventos marcados pelas tags.',
        type: 'info',
        confirmButtonText: 'Iniciar',
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.exec();

                  case 2:
                    return _context.abrupt('return', 'ok');

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function () {
        setTimeout(function () {
          location.reload();
        }, 3000);

        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        });
      });
    },
    exec: function exec() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.getEventsSpecifications().then(function (specifications) {
                  return _this2.updateManySpecifications(specifications.map(function (spec) {
                    spec.refrigeratorIcon = _this2.icon;
                    spec.tagsIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(spec.tags);
                    return spec;
                  }));
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getEventsSpecifications: function getEventsSpecifications() {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.tagsSelected).length === 0) {
        return this.fetchSpecifications({ limit: 99999 });
      }

      var whereTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_DashboardCounter__["b" /* defineWhereObject */])(undefined, this.tagsSelected, 'tagsIds');
      return this.fetchSpecifications({
        where: {
          '$and': whereTags['$and']
        },
        limit: 99999
      });
    },
    notifyIncorrectCategorieSize: function notifyIncorrectCategorieSize() {
      return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('Quantidade incorreta de tags', 'Escolha pelo menos 1 tag por categoria', 'error');
    }
  }),
  mounted: function mounted() {
    if (this.categories.length === 0) {
      this.fetchCategories({ limit: 999 });
    }
  }
});

/***/ }),

/***/ "lr+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Host do servidor remoto:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.project.remoteHost}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Prefixo do banco:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.projectName),expression:"project.projectName"}],staticClass:"form-control",attrs:{"name":"label-projeto","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.project, "projectName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.projectsNames),function(label){return _c('option',{domProps:{"value":label}},[_vm._v(_vm._s(label)+"\n        ")])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Configurações da replicação")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwkl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4I+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketDocumentation_vue__ = __webpack_require__("hBAo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce0c7cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketDocumentation_vue__ = __webpack_require__("+a/6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnOpenTicketDocumentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce0c7cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnOpenTicketDocumentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m56S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectForm_vue__ = __webpack_require__("NHWC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e70b350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectForm_vue__ = __webpack_require__("FmSj");
function injectStyle (ssrContext) {
  __webpack_require__("NAtx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e70b350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m5aZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lamps.max),expression:"modelValidations.lamps.max"},{name:"model",rawName:"v-model.number",value:(_vm.project.lamps.max),expression:"project.lamps.max",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","name":"lampsMax"},domProps:{"value":(_vm.project.lamps.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.lamps, "max", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelValidations.lamps.max.invalid),expression:"modelValidations.lamps.max.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('lampsMax'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"true"},model:{value:(_vm.project.lamps.hasSeason),callback:function ($$v) {_vm.$set(_vm.project.lamps, "hasSeason", $$v)},expression:"project.lamps.hasSeason"}},[_vm._v("Sim\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"inline":"","label":"false"},model:{value:(_vm.project.lamps.hasSeason),callback:function ($$v) {_vm.$set(_vm.project.lamps, "hasSeason", $$v)},expression:"project.lamps.hasSeason"}},[_vm._v("Não\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.lamps.seasonRange),expression:"project.lamps.seasonRange"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"120","name":"lampsMax"},domProps:{"value":(_vm.project.lamps.seasonRange)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.lamps, "seasonRange", $event.target.value)}}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Configurações de Lâmpadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_c('strong',[_vm._v("Quantidade máxima de lâmpadas por cliente que podem ser trocadas no projeto:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              Haverá "),_c('strong',[_vm._v("controle")]),_vm._v(" de lâmpadas por temporada?\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("\n              Período máximo "),_c('strong',[_vm._v("(em meses)")]),_vm._v(" que o cliente ficará sem poder trocar lâmpada\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m7R/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m9PM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mCG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('MigrateTicketsWinnersToWinnersDb',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('remove-duplicated-files',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('remove-duplicated-lamps',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('remove-attachment-from-lamps',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('copy-attachments',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-eligible-true',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-customer-contemplado')],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('delete-losers')],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-winner-false',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('generate-new-tickets',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-eventid-lamps',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"command"},[_c('router-link',{attrs:{"to":{name: 'commands.listAttachments', params: {connection: 'default'}}}},[_c('a',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Listar Attachments (trg_admin)")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'commands.listAttachments', params: {connection: 'docs'}}}},[_c('a',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Listar Attachments (trg_docs)")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-stock-null')],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('remove-event-ranking')],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('set-documented-at-null-delete-doc',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('remove-docs-from-contemplados',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('MigrateConfigurationsToNewDatabase',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('ChangeEventsTagNameToTagId',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('RemoveConfigurationsDuplicated',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('RemoveAllAboutAnEvent',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('RemoveAllAboutAnEventWithoutCustomer',{staticClass:"command"})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('MigrateEventsSpecificationsToNewDatabase',{staticClass:"command"})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h3',{staticClass:"card-title"},[_vm._v("Commands")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mEDQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseModule__ = __webpack_require__("tv5d");




var connection = 'specifications';
var collection = 'eventsSpecifications';

var model = {
  sourceDb: '',
  eventId: '',
  event: {
    city: '',
    reference: ''
  },
  gps: {
    lat: '',
    lng: ''
  },
  tags: {},
  tagsIds: [],
  refrigeratorIcon: '',
  educationalIcon: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model),
    count: 0,
    imagesMap: {
      basePath: '/static/img/icones_mapa/',
      personas: ['trg_person_0.png', 'trg_person_25.png', 'trg_person_50.png', 'trg_person_90.png', 'trg_person_150.png', 'trg_person_210.png', 'trg_person_270.png', 'trg_person_330.png'],
      trucks: ['truck_0.png', 'truck_25.png', 'truck_50.png', 'truck_90.png', 'truck_150.png', 'truck_210.png', 'truck_270.png', 'truck_330.png'],
      refrigerators: ['troca_geladeira_0.png', 'troca_geladeira_60.png', 'troca_geladeira_120.png', 'troca_geladeira_180.png', 'troca_geladeira_240.png', 'troca_geladeira_300.png'],
      educational: ['educacional_0.png', 'educacional_60.png', 'educacional_120.png', 'educacional_180.png', 'educacional_240.png', 'educacional_390.png']
    }
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["b" /* mapMutations */])(), {
    SET_TAG: function SET_TAG(state, payload) {
      state.one.tags[payload.categorie] = payload.tag;
      state.one.tagsIds = [];
      for (var categorie in state.one.tags) {
        state.one.tagsIds.push(state.one.tags[categorie]);
      }
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["c" /* mapActions */])(collection, model, connection), {
    setTags: function setTags(context, _ref) {
      var categorie = _ref.categorie,
          tag = _ref.tag;

      context.commit('SET_TAG', { categorie: categorie, tag: tag });
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseModule__["d" /* mapGetters */])(), {
    eventSpecifications: function eventSpecifications(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model, state.one);
    },
    eventsSpecifications: function eventsSpecifications(state) {
      return state.all.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model, item);
      });
    },
    withGpsEventsSpecifications: function withGpsEventsSpecifications(state) {
      return state.all.filter(function (item) {
        return item.hasOwnProperty('gps') && item.gps.hasOwnProperty('lat') && item.gps.lat !== '' && item.gps.hasOwnProperty('lng') && item.gps.lng !== '';
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, model, item);
      });
    },
    imagesMap: function imagesMap(state) {
      return state.imagesMap;
    }
  })
});

/***/ }),

/***/ "mOFO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mQr0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',{ref:"loginForm"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuário")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.login),expression:"modelValidations.login"},{name:"model",rawName:"v-model",value:(_vm.model.login),expression:"model.login"}],staticClass:"form-control",attrs:{"type":"text","name":"login"},domProps:{"value":(_vm.model.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.invalid),expression:"login.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('login'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Entrar\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Login\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mSF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'actions-table-tags',
  props: {
    tag: {
      required: true
    },
    handleRemove: {
      required: true,
      type: Function
    }
  },

  computed: {
    can: function can() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.actions);
    },

    actions: function actions() {
      return {
        'tags.edit': {
          name: 'tags.edit',
          title: 'Editar Tag',
          color: 'info',
          icon: 'ti-pencil-alt',
          component: 'router-button'
        },
        'tags.remove': {
          name: 'tags.remove',
          title: 'Remover Tag',
          color: 'danger',
          icon: 'ti-trash',
          component: 'action-button-click-stateless',
          props: {
            params: {
              id: this.tag._id
            },
            handleEvent: {
              click: this.handleRemove
            }
          }
        }
      };
    },

    childrenMenu: function childrenMenu() {
      var _this = this;

      return this.can.filter(function (item) {
        return _this.$can(item);
      }).map(function (item) {
        return {
          component: _this.actions[item].component,
          data: {
            props: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              to: {
                name: _this.actions[item].name,
                params: { id: _this.tag._id }
              },
              title: _this.actions[item].title,
              classStyle: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                btn: true,
                'btn-block': true,
                'btn-flat': true,
                'btn-icon': false
              }, 'btn-' + _this.actions[item].color, true),
              iconClass: _this.actions[item].icon
            }, _this.actions[item].props)
          }
        };
      });
    }
  }
});

/***/ }),

/***/ "mXMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectIndex_vue__ = __webpack_require__("wa7q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612bf491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectIndex_vue__ = __webpack_require__("Ba96");
function injectStyle (ssrContext) {
  __webpack_require__("mtMP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-612bf491"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612bf491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("V67u");
function injectStyle (ssrContext) {
  __webpack_require__("J0Sr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mfY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "miz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Permissions"},[(_vm.showNewButton && _vm.$can('roles.create'))?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'roles.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mj2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MigrateTicketsWinnersToWinnersDb',
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      eventIdSelected: '',
      customers: [],
      allEvents: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', { events: 'sortedByReference' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tickets', { tickets: 'tickets' }), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('events', { fetchEvents: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tickets', { fetchTickets: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('customers', { fetchCustomers: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('winners', { insertManyWinners: 'insertMany' }), {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var events;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _this.total = 0;
                _this.progress = 0;
                _context.prev = 3;
                events = [];

                if (_this.allEvents) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _this.fetchTickets({
                  where: { eventId: _this.eventIdSelected, winner: true },
                  select: ['customerId', 'updatedAt'],
                  limit: 88888
                });

              case 8:
                _context.next = 12;
                break;

              case 10:
                _context.next = 12;
                return _this.fetchTickets({
                  where: { winner: true },
                  select: ['customerId', 'updatedAt'],
                  limit: 88888
                });

              case 12:

                _this.total = _this.tickets.length;

                _this.isLoading = false;
                if (_this.total === 0) {
                  _this.notifyFinish();
                } else {
                  _this.notifyAmount().then(function () {
                    try {
                      _this.initExec(events);
                    } catch (e) {
                      console.log('Falha no processo', e);
                    }
                  });
                }
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.isLoading = false;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 17]]);
      }))();
    },
    initExec: function initExec(events) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Atenção',
        text: 'Todos os Tickets Contemplados v\xE3o ser migrados agora.',
        type: 'warning',
        confirmButtonText: 'Iniciar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this2.exec(events);

                  case 2:
                    return _context2.abrupt('return', 'ok');

                  case 3:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function () {
        setTimeout(function () {
          location.reload();
        }, 3000);
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        });
      });
    },
    exec: function exec() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.fetchCustomers({
                  where: {
                    $or: _this3.tickets.map(function (item) {
                      return {
                        _id: item.customerId
                      };
                    })
                  },
                  select: ['_id', 'uc', 'name', 'cpf'],
                  limit: 9999
                });

              case 2:
                _this3.customers = _context3.sent;

                _this3.customers = _this3.customers.map(function (customer) {
                  customer.exchangeDate = _this3.tickets.find(function (item) {
                    return item.customerId === customer._id;
                  }).updatedAt;
                  customer.cpf = customer.cpf.replace(/\D/g, '');
                  delete customer._id;
                  return customer;
                });
                _this3.insertManyWinners(_this3.customers);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    notifyAmount: function notifyAmount() {
      return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Eventos',
        html: 'Deseja migrar dados dos ' + this.total + ' tickets contemplados?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, migrar os dados!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      this.total = 1;
      this.progress = 1;
      this.eventLamps = 1;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todos os contemplados foram migrados com sucesso',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  }),

  mounted: function mounted() {
    this.fetchEvents({ limit: 9999 });
  }
});

/***/ }),

/***/ "mj6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__ = __webpack_require__("SUPC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__ = __webpack_require__("z48K");
function injectStyle (ssrContext) {
  __webpack_require__("ryiV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ml9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActionTermLamps__ = __webpack_require__("pd2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LampsForm',

  components: {
    ActionTermLamps: __WEBPACK_IMPORTED_MODULE_9__ActionTermLamps__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */]
  },

  props: {
    customer: {
      required: true,
      type: Object
    },
    lampsLeft: {
      required: true,
      type: Number
    },
    event: { required: true },
    stockLamps: {
      required: true,
      type: Number
    }
  },

  data: function data() {
    return {
      lamps: [],
      countEventLamps: 0,
      isLoadingFile: false,
      selectedFile: '',
      binaryFiles: [],
      saving: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('lamps', {
    insert: 'insert',
    setCurrentLampsTmp: 'setCurrentLampsTmp',
    uploadFileLamp: 'uploadFileLamp'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('events', {
    fetchStartedEvents: 'getStartedEvents',
    fetchOne: 'fetchOne',
    getEvents: 'fetchAll'
  }), {
    emitUploadFile: function emitUploadFile(file) {
      var _this = this;

      this.$nextTick(function () {
        _this.binaryFiles.push(file);
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleAdd: function handleAdd() {
      var _this2 = this;

      this.countEventLamps += 1;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.lamps.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this2.model));
        }
      });
    },
    handleRemove: function handleRemove(index, row) {
      this.countEventLamps -= 1;
      this.lamps.splice(index, 1);
      if (this.lamps.length <= 0) {
        this.resetFile();
      }
    },
    handleSave: function handleSave() {
      if (this.saving) {
        return false;
      }
      this.saving = true;
      if (!this.eventId || this.eventId === '') {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
          text: 'Nenhum evento foi selecionado.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        this.saving = false;
        return false;
      }
      if (this.event.lamp.requiredTermLamp && Array.isArray(this.binaryFiles) && this.binaryFiles === 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
          text: 'Nenhum arquivo foi selecionado.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        });
        this.saving = false;
        return false;
      }
      this.runSave();
    },
    runSave: function runSave() {
      var _this3 = this;

      var doc = {
        customer: {
          id: this.customer._id,
          uc: this.customer.uc,
          cpf: this.customer.cpf,
          holder: this.customer.holder
        },
        eventId: this.eventId,
        items: this.lamps,
        collection: 'lamps'
      };
      if (this.event.lamp.requiredTermLamp) {
        doc.hasAttachment = true;
      }
      this.save(doc).then(function () {
        _this3.saving = false;
        _this3.resetForm();
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
          title: 'Sucesso!',
          text: 'Aguarde o fim do processamento.',
          type: 'warning'
        });
        location.reload();
      }).catch(function (err) {
        return console.log('error saving', err);
      });
    },
    save: function save(doc) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
          var verification;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this4.verifyStock(doc);

                case 2:
                  verification = _context.sent;

                  if (!(verification.allowedDelived >= 0)) {
                    _context.next = 6;
                    break;
                  }

                  resolve(_this4.insertLamps(doc));
                  return _context.abrupt('return');

                case 6:
                  if (!(Math.abs(verification.allowedDelived) >= doc.items.length)) {
                    _context.next = 10;
                    break;
                  }

                  console.log('erro');
                  resolve(_this4.notAllowAlert());
                  return _context.abrupt('return');

                case 10:

                  resolve(_this4.moreThanAlert(verification));

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getCountEventLamps: function getCountEventLamps() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, deliveryLamps;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7_src_services_Couchdb__["a" /* default */].view('count-lamps-by-event', 'count-lamps-by-event', _this5.eventId, {
                  group: true,
                  reduce: true
                });

              case 2:
                result = _context2.sent;
                deliveryLamps = result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0;

                _this5.countEventLamps = deliveryLamps;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    verifyStock: function verifyStock(doc) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var currentStockAmount, allowedDelived;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.getCountEventLamps();

              case 2:
                currentStockAmount = _this6.event.numberOfLamps - _this6.countEventLamps;
                allowedDelived = currentStockAmount - doc.items.length;
                return _context3.abrupt('return', {
                  deliveryLamps: _this6.countEventLamps,
                  currentStockAmount: currentStockAmount,
                  allowedDelived: allowedDelived
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    insertLamps: function insertLamps(doc) {
      var _this7 = this;

      return this.insert(doc).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(_this7.event.hasOwnProperty('lamp') && _this7.event.lamp.requiredTermLamp)) {
                    _context4.next = 3;
                    break;
                  }

                  _context4.next = 3;
                  return _this7.handleSaveFile(result.id);

                case 3:

                  _this7.finishSave({ error: false });

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this7);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (err) {
        return console.log(err);
      });
    },
    notAllowAlert: function notAllowAlert() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        title: 'Estoque esgotado!',
        text: 'Não há mais lâmpadas no estoque do evento.',
        type: 'error'
      }).then(function () {
        _this8.finishSave({ error: true });
      });
      return false;
    },
    moreThanAlert: function moreThanAlert(verification) {
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        title: 'Estoque insuficiente!',
        text: 'Existem ' + verification.currentStockAmount + ' l\xE2mpadas no estoque.\n              Remova ' + Math.abs(verification.allowedDelived) + ' l\xE2mpadas e tente novamente',
        type: 'info'
      });
      return false;
    },
    handleSaveFile: function handleSaveFile(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var docId, referenceDoc, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.isLoadingFile = true;

                docId = void 0;
                _context6.next = 4;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  __WEBPACK_IMPORTED_MODULE_7_src_services_Couchdb__["a" /* default */].connection('docs').where('referenceId', id).get().then(function () {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(res) {
                      var doc;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              doc = res[0] || false;

                              if (!(res.length === 0)) {
                                _context5.next = 5;
                                break;
                              }

                              _context5.next = 4;
                              return __WEBPACK_IMPORTED_MODULE_7_src_services_Couchdb__["a" /* default */].connection('docs').insert({ referenceId: id, collection: 'lamps', database: 'trg_admin' });

                            case 4:
                              doc = _context5.sent;

                            case 5:

                              resolve(doc);

                            case 6:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this9);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                });

              case 4:
                referenceDoc = _context6.sent;

                if (!referenceDoc) {
                  _context6.next = 14;
                  break;
                }

                docId = referenceDoc.id;

                _context6.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(_this9.binaryFiles);

              case 8:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 14;
                  break;
                }

                i = _context6.t1.value;
                _context6.next = 12;
                return __WEBPACK_IMPORTED_MODULE_7_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(docId, {
                  attachmentName: _this9.binaryFiles[i].name,
                  mimeType: _this9.binaryFiles[i].blob.type,
                  attachment: _this9.binaryFiles[i].blob
                });

              case 12:
                _context6.next = 8;
                break;

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    finishSave: function finishSave(_ref4) {
      var error = _ref4.error;

      this.isLoadingFile = true;
      this.$emit('on-save', {});
      if (error) {
        this.$notify({
          message: 'Falha ao adicionar as l\xE2mpadas.',
          type: 'danger'
        });
      } else {
        this.$notify({
          message: this.lamps.length + ' l\xE2mpada(s) adicionadas com sucesso.',
          type: 'success'
        });
      }
      this.resetForm();
      this.lamps = [];
      this.saving = false;
    },
    resetFile: function resetFile() {
      this.isLoadingFile = false;
      this.selectedFile = '';
      this.binaryFiles = [];
    },
    resetForm: function resetForm() {

      this.lamps = [];
      this.isLoadingFile = false;
      this.selectedFile = '';
      this.$emit('fetchData');
      this.resetFile();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['type', 'room', 'usageHoursPerDay', 'power']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('lamps', {
    model: 'lamp',
    allLamps: 'allLamps',
    modelValidations: 'validations',
    loading: 'loading',
    options: 'options',
    countLamps: 'count'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('events', {
    events: 'events'
  }), {

    eventId: function eventId() {
      return this.event._id;
    },

    showResumeTable: function showResumeTable() {
      return this.lamps.length > 0;
    },


    stock: function stock() {
      this.getCountEventLamps();
      return this.stockLamps;
    }
  }),
  mounted: function mounted() {
    this.resetForm();
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config');
    }
  }
});

/***/ }),

/***/ "mmP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      $Chartist: null
    };
  },

  methods: {
    initPerformanceChart: function initPerformanceChart() {
      var dataPerformance = {
        labels: ['6pm', '9pm', '11pm', '2am', '4am', '8am', '2pm', '5pm', '8pm', '11pm', '4am'],
        series: [[1, 6, 8, 7, 4, 7, 8, 12, 16, 17, 14, 13]]
      };

      var optionsPerformance = {
        showPoint: false,
        lineSmooth: true,
        axisX: {
          showGrid: false,
          showLabel: true
        },
        axisY: {
          offset: 40

        },
        low: 0,
        high: 16,
        height: '250px'
      };

      this.$Chartist.Line('#chartPerformance', dataPerformance, optionsPerformance);
    },
    initActivityChart: function initActivityChart() {
      var data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895], [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]]
      };

      var options = {
        seriesBarDistance: 10,
        axisX: {
          showGrid: false
        },
        height: '250px'
      };

      var responsiveOptions = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];

      this.$Chartist.Bar('#chartActivity', data, options, responsiveOptions);
    },
    initStockChart: function initStockChart() {
      var dataStock = {
        labels: ['\'07', '\'08', '\'09', '\'10', '\'11', '\'12', '\'13', '\'14', '\'15'],
        series: [[22.20, 34.90, 42.28, 51.93, 62.21, 80.23, 62.21, 82.12, 102.50, 107.23]]
      };
      var optionsStock = {
        lineSmooth: false,
        axisY: {
          offset: 40,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '$' + value;
          }
        },
        low: 10,
        height: '250px',
        high: 110,
        classNames: {
          point: 'ct-point ct-green',
          line: 'ct-line ct-green'
        }
      };
      this.$Chartist.Line('#chartStock', dataStock, optionsStock);
    },
    initViewsChart: function initViewsChart() {
      var dataViews = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      };
      var optionsViews = {
        seriesBarDistance: 10,
        classNames: {
          bar: 'ct-bar'
        },
        axisX: {
          showGrid: false
        },
        height: '250px'
      };
      var responsiveOptionsViews = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];
      this.$Chartist.Bar('#chartViews', dataViews, optionsViews, responsiveOptionsViews);
    },
    initCharts: function initCharts() {
      this.initPerformanceChart();
      this.initStockChart();
      this.initViewsChart();
      this.initActivityChart();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "715g"));

            case 2:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initCharts();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "msp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewDetail_vue__ = __webpack_require__("eqmk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d021c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewDetail_vue__ = __webpack_require__("toKP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d021c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mtMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mxiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-select',{staticClass:"select-primary",attrs:{"filterable":"","size":"large","placeholder":"Selecione ...","name":"eventIdSelected"},model:{value:(_vm.eventIdSelected),callback:function ($$v) {_vm.eventIdSelected=$$v},expression:"eventIdSelected"}},[_c('el-option',{staticClass:"select-primary",attrs:{"value":"","label":""}}),_vm._v(" "),_vm._l((_vm.events),function(item){return _c('el-option',{key:item._id,staticClass:"select-primary",attrs:{"filterable":"","value":item._id,"label":((item.reference) + " - " + (item.city))}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd",on:{"click":function($event){return _vm.handleRemoveAttachmentFromLamps()}}},[_vm._v("\n    Colocar winner=false nos Tickets\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "my3Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n36L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n7La":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRankingReportSimplified_vue__ = __webpack_require__("xRT8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0e1b1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRankingReportSimplified_vue__ = __webpack_require__("wfNl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRankingReportSimplified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0e1b1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRankingReportSimplified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nEwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsIndex_vue__ = __webpack_require__("fw4F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8c47c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsIndex_vue__ = __webpack_require__("qr0m");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8c47c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actions_TicketCheckIn__ = __webpack_require__("FMHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actions_TicketDownloadDocuments__ = __webpack_require__("rHIH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Actions_TicketsDocumentation__ = __webpack_require__("kAE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Actions_TicketsUploadImages__ = __webpack_require__("RT7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-actions',
  components: {
    TicketsDocumentation: __WEBPACK_IMPORTED_MODULE_3__Actions_TicketsDocumentation__["a" /* default */],
    TicketCheckIn: __WEBPACK_IMPORTED_MODULE_1__Actions_TicketCheckIn__["a" /* default */],
    TicketDownloadDocuments: __WEBPACK_IMPORTED_MODULE_2__Actions_TicketDownloadDocuments__["a" /* default */],
    TicketsUploadImages: __WEBPACK_IMPORTED_MODULE_4__Actions_TicketsUploadImages__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tickets', ['ticket']))
});

/***/ }),

/***/ "nLkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    };
  },


  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      var percentageTotal = parseInt(this.progress / this.total * 100);
      if (percentageTotal > 100) {
        return 100;
      }
      return percentageTotal;
    }
  },

  methods: {
    handleExec: function handleExec() {
      var _this = this;

      this.isLoading = true;
      this.progress = 0;
      this.exec(function (response) {
        console.log('end', response);
      }).catch(function (err) {
        return console.log(err);
      }).finally(function (response) {
        _this.isLoading = false;
        _this.progress = 100;
      });
    },
    exec: function exec(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var docs, swalOptions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.progress = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('winners').select(['_id']).where('referenceId', { $exists: true }).get();

              case 3:
                docs = _context2.sent;


                _this2.total = docs.length;
                swalOptions = {
                  title: 'Existem ' + _this2.total + ' documentos no banco de contemplados.'
                };


                if (_this2.total === 0) {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                    title: swalOptions.title,
                    text: 'N\xE3o foi encontrados documentos no banco de contemplados.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                    title: swalOptions.title,
                    html: 'Voc\xEA quer os documentos do banco de contemplados para o de documentos?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, faça isso!',
                    cancelButtonText: 'Não',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                  }).then(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, docId, docWithAttachments, attachments, newDoc, attachment, blob;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this2.progress = 0;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 4;
                            _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(docs);

                          case 6:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                              _context.next = 36;
                              break;
                            }

                            doc = _step.value;
                            docId = doc._id;
                            _context.next = 11;
                            return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('winners').find(docId);

                          case 11:
                            docWithAttachments = _context.sent;
                            attachments = docWithAttachments._attachments;


                            delete docWithAttachments._id;
                            delete docWithAttachments._rev;
                            delete docWithAttachments._attachments;

                            _context.next = 18;
                            return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('docs').insert(docWithAttachments);

                          case 18:
                            newDoc = _context.sent;
                            _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(attachments);

                          case 20:
                            if ((_context.t1 = _context.t0()).done) {
                              _context.next = 30;
                              break;
                            }

                            attachment = _context.t1.value;
                            _context.next = 24;
                            return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('winners').getAttachment(docId, attachment);

                          case 24:
                            blob = _context.sent;
                            _context.next = 27;
                            return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('docs').insertAttachment(newDoc.id, {
                              mimeType: attachments[attachment].content_type,
                              attachmentName: attachment,
                              attachment: blob
                            });

                          case 27:
                            console.log('salvou o anexo no doc novo');
                            _context.next = 20;
                            break;

                          case 30:
                            _context.next = 32;
                            return __WEBPACK_IMPORTED_MODULE_3_src_services_Couchdb__["a" /* default */].connection('winners').delete(docId);

                          case 32:
                            _this2.progress++;

                          case 33:
                            _iteratorNormalCompletion = true;
                            _context.next = 6;
                            break;

                          case 36:
                            _context.next = 42;
                            break;

                          case 38:
                            _context.prev = 38;
                            _context.t2 = _context['catch'](4);
                            _didIteratorError = true;
                            _iteratorError = _context.t2;

                          case 42:
                            _context.prev = 42;
                            _context.prev = 43;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }

                          case 45:
                            _context.prev = 45;

                            if (!_didIteratorError) {
                              _context.next = 48;
                              break;
                            }

                            throw _iteratorError;

                          case 48:
                            return _context.finish(45);

                          case 49:
                            return _context.finish(42);

                          case 50:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2, [[4, 38, 42, 50], [43,, 45, 49]]);
                  })));
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "nRLR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nRj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnergisaBorboremaPb_vue__ = __webpack_require__("lPVL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507fc3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnergisaBorboremaPb_vue__ = __webpack_require__("ZAhD");
function injectStyle (ssrContext) {
  __webpack_require__("uS7Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-507fc3c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnergisaBorboremaPb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507fc3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnergisaBorboremaPb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nZCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActionButtonClickStateless',
  functional: true,
  props: {
    title: {
      default: 'ok'
    },
    classStyle: {
      default: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        btn: true,
        'btn-block': true,
        'btn-flat': true,
        'btn-icon': false
      }, 'btn-default', true)
    },
    iconClass: {
      default: ''
    },
    handleEvent: {},
    params: {}
  },

  render: function render(h, context) {
    return h('action-button-click', {
      attrs: {
        classStyle: context.props.classStyle,
        title: context.props.title,
        iconClass: context.props.iconClass,
        handleEvent: context.props.handleEvent,
        params: context.props.params
      }
    });
  }
});

/***/ }),

/***/ "ncsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saving: false,
      indexPath: { name: 'users.index' },
      roleValue: '',
      rolesOptions: [],
      oldPassword: '',
      confirmOldPassword: '',
      name: '',
      login: '',
      password: '',
      confirmPassword: '',
      role: '',
      inactivated: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['nameField', 'loginField', 'passwordField', 'confirmField', 'roleField']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('users', {
    user: 'user',
    modelValidations: 'validations',
    loading: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('roles', {
    roles: 'roles'
  }), {
    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('users', ['fetchOne', 'resetOne', 'insert', 'update', 'upsert']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('roles', { getRoles: 'fetchAll' }), {
    setOptions: function setOptions() {
      this.rolesOptions = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.roles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;

          this.rolesOptions.push({
            label: r.label,
            value: r.name
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this = this;

      this.saving = true;

      if (!this.validateForm()) {
        this.saving = false;
        return;
      }

      var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.user, {
        name: this.name,
        login: this.login,
        role: this.role,
        collection: 'users',
        password: this.defineUserPassword()
      });
      if (this.password.trim().length > 0) {
        return __WEBPACK_IMPORTED_MODULE_3_src_services_AuthService__["a" /* default */].hash(doc.password).then(function (result) {
          doc.password = result;
          return _this.saveUser(doc);
        }).catch(function (err) {
          console.log(err);
          _this.saving = false;
          return err;
        });
      }
      return this.saveUser(doc);
    },
    saveUser: function saveUser(doc) {
      var _this2 = this;

      return this.upsert(doc).then(function (res) {
        _this2.notifySaved();
        _this2.saving = false;
        _this2.$router.push(_this2.indexPath);
        return res;
      }).catch(function (err) {
        console.log(err);
        _this2.saving = false;
        return err;
      });
    },
    validateForm: function validateForm() {
      if (this.name.length === 0 || this.name.trim() === '') {
        this.$notify({
          message: 'Nome é obrigatório',
          type: 'danger'
        });
        return false;
      }

      if (this.login === '' || this.login.length < 5) {
        this.$notify({
          message: 'Login obrigatório e no mínimo 5 letras',
          type: 'danger'
        });
        return false;
      }

      if (!this.validPassword) {
        this.$notify({
          message: 'Senha é inválida. Senha obrigatório e no mínimo 5 letras. A senha deve ser igual a de confirmação',
          type: 'danger'
        });
        return false;
      }

      if (this.role === '') {
        this.$notify({
          message: 'Permissão é obrigatória',
          type: 'danger'
        });
        return false;
      }

      return true;
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    defineUserPassword: function defineUserPassword() {
      return this.password.trim().length > 0 && this.canChangePassword() ? this.password : this.user.password;
    },
    notifyPasswordWrong: function notifyPasswordWrong() {
      this.saving = false;
      this.$notify({
        message: 'Senha não estão iguais.',
        type: 'warning'
      });
      return false;
    },
    notifySaved: function notifySaved() {
      this.$notify({
        message: 'Usuário salvo com sucesso',
        type: 'success'
      });
    },
    changingRole: function changingRole() {
      this.role = this.roleValue;
    },
    setOldValues: function setOldValues() {
      this.name = this.user.name;
      this.login = this.user.login;
      this.role = this.user.role;
      this.inactivated = this.user.inactivated;
    },
    validPassword: function validPassword() {
      if (this.editing) {
        return this.validateEditPassword();
      }
      return this.canChangePassword();
    },
    validateEditPassword: function validateEditPassword() {
      if (this.password.trim().lenght === 0) {
        return true;
      }
      return this.canChangePassword();
    },
    canChangePassword: function canChangePassword() {
      var hasNewPass = this.password && this.password.length > 0;
      var hasConfirmNewPass = this.confirmPassword && this.confirmPassword.length > 0;
      var equalNewPass = this.password === this.confirmPassword;
      return hasNewPass && hasConfirmNewPass && equalNewPass;
    }
  }),

  mounted: function mounted() {
    var _this3 = this;

    this.resetOne();
    if (this.id) {
      this.fetchOne(this.id).then(function () {
        _this3.setOldValues();
        _this3.roleValue = _this3.user.role;
      });
    }
    this.roleValue = this.user.role;
    this.getRoles();
    this.setOptions();
  },


  watch: {
    model: function model() {
      this.getRoles();
    },
    roles: function roles() {
      this.setOptions();
    }
  }
});

/***/ }),

/***/ "negu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Team members',
      members: [{
        image: 'static/img/faces/face-0.jpg',
        name: 'Dj Khaled',
        status: 'Offline'
      }, {
        image: 'static/img/faces/face-1.jpg',
        name: 'Creative Tim',
        status: 'Available'
      }, {
        image: 'static/img/faces/face-3.jpg',
        name: 'Flume',
        status: 'Busy'
      }]
    };
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case 'Offline':
          return 'text-muted';
        case 'Available':
          return 'text-success';
        case 'Busy':
          return 'text-danger';
        default:
          return 'text-success';
      }
    }
  }
});

/***/ }),

/***/ "nsE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectName_vue__ = __webpack_require__("AOK3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40eb9694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectName_vue__ = __webpack_require__("oixv");
function injectStyle (ssrContext) {
  __webpack_require__("pNDi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40eb9694"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40eb9694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nw7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioCompaniesDocuments_vue__ = __webpack_require__("OFfW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176a81ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioCompaniesDocuments_vue__ = __webpack_require__("V9P6");
function injectStyle (ssrContext) {
  __webpack_require__("4llZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-176a81ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioCompaniesDocuments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176a81ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioCompaniesDocuments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o+wQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-12 text-right"},[(_vm.hasImage && _vm.showEditButton)?_c('a',{staticClass:"btn btn-fill btn-primary btn-sm btn",on:{"click":function($event){return _vm.editImage()}}},[_c('i',{staticClass:"ti-pencil"}),_vm._v(" Editar")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-content text-center"},[_c('img',{class:_vm.customerImageClass,attrs:{"src":_vm.customerImage}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-7 col-md-12"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-camera"}),_vm._v(" Foto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o1ms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFilter_vue__ = __webpack_require__("yWDq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d26d7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFilter_vue__ = __webpack_require__("80cc");
function injectStyle (ssrContext) {
  __webpack_require__("RV4/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d26d7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o5KC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oE/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("qeuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("Nrso");
function injectStyle (ssrContext) {
  __webpack_require__("f4B7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oGAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oHUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__ = __webpack_require__("fd3O");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-go',
  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_0__HeaderTerm__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      company: 'ENEL',
      shortname: 'ENEL-GO',
      address: 'Rua 2, Quadra A-37, 505 – Jardim Goiás, Goiânia/GO',
      cpnj: '01.543.032/0001-04',
      stateRegistration: '06.105.848-3',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    };
  },

  computed: {},
  filters: {
    uppercase: function uppercase(value) {
      if (!value) {
        return '';
      }
      value = value.toString();
      return value.toUpperCase();
    }
  }
});

/***/ }),

/***/ "oHZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oHle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oI26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oOdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("0/Bd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3315a546_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("mQr0");
function injectStyle (ssrContext) {
  __webpack_require__("rjFc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3315a546_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oUP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_DashboardCounter_js__ = __webpack_require__("fzNA");






var collection = 'users';
var singleName = 'user';
var connection = 'config';

var model = {
  name: '',
  login: '',
  password: '',
  confirmPassword: '',
  role: '',
  inactivate: false
};
var validations = {
  name: {
    required: true
  },
  login: {
    required: true,
    min: 5
  },
  password: {
    required: true,
    min: 5
  },
  confirm: {
    required: true
  },
  role: {
    required: true
  }
};
var getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model)), state.one);
};
getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(getters, {
  users: function users(state) {
    return state.all;
  },
  selected: function selected(state) {
    return state.userSelected;
  },
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  },
  noAdminAll: function noAdminAll(state) {
    return state.all.filter(function (item) {
      return item.role !== 'superadmin';
    });
  },
  showInactivate: function showInactivate(state) {
    return state.showInactivate;
  },
  usersIdName: function usersIdName(state) {
    return state.all && state.all.length > 0 ? state.all.filter(function (item) {
      return item.role !== 'superadmin' && (state.showInactivate || !item.inactivate);
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).reduce(function (obj, item) {
      obj[item._id] = item.name;
      return obj;
    }, {}) : {};
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["a" /* mapStates */])(), {
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    loading: true,
    editing: false,
    count: 0,
    userSelected: {},
    showInactivate: false
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["b" /* mapMutations */])(), {
    SET_SHOW_INACTIVATE: function SET_SHOW_INACTIVATE(state, payload) {
      state.showInactivate = payload;
    },
    setUserSelected: function setUserSelected(state, payload) {
      state.userSelected = payload;
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["c" /* mapActions */])(collection, model, connection), {
    setShowInactivate: function setShowInactivate(_ref, payload) {
      var commit = _ref.commit;

      commit('SET_SHOW_INACTIVATE', payload);
    },
    setUserSelected: function setUserSelected(_ref2, _ref3) {
      var commit = _ref2.commit;
      var user = _ref3.user;

      commit('setUserSelected', user);
    },
    dashboardUsersByFilter: function dashboardUsersByFilter(context, _ref4) {
      var dateRange = _ref4.dateRange;

      context.commit('changeLoading', true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_services_DashboardCounter_js__["e" /* dashboardCustomersCounter */])(dateRange).then(function (result) {
        context.commit('SET_DASHBOARD_COUNTER', result);
      }).finally(function () {
        return context.commit('changeLoading', false);
      });
    }
  }),
  getters: getters
});

/***/ }),

/***/ "oVfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsOptions_vue__ = __webpack_require__("8suC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3243bb0d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsOptions_vue__ = __webpack_require__("slvO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3243bb0d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ofHV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ohLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"name","label":"Nome","sortable":"custom","min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Criado Em","sortable":"custom","min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm._f("moment")(new Date(scope.row.createdAt),"DD/MM/YYYY HH:mm:ss"))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":{name: 'manufacturers.edit', params: {id: props.row._id}}}},[_c('a',{staticClass:"btn btn-primary btn-fill btn-icon edit"},[_c('i',{staticClass:"ti-pencil-alt"})])]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-fill btn-icon remove",on:{"click":function($event){return _vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-trash"})])],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v("Mostrando de "+_vm._s(_vm.from + 1)+" até "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" no total.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oixv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.project && _vm.project.hasOwnProperty('name') && _vm.project.hasOwnProperty('state') && _vm.project.name !== '' && _vm.project.state !== '' ? ("- " + (_vm.project.name) + " / " + (_vm.project.state)) : 'Projeto ainda não configurado')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oj1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return couchdbIndexManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var couchdbIndexManager = {
  create: create
};

function create(query) {
  return [generateSortIndex(query), getQueryIndex(query)];
}

var multipleKeys = ['$ne', '$lt', '$lte', '$gt', '$gte', '$or', '$in'];
var orientation = 'asc';
var fields = [];

function generateSortIndex(query) {
  if (!query.hasOwnProperty('sort')) {
    return { fields: [], name: '' };
  }
  var fieldsName = [];
  var fields = [];
  var orientation = 'asc';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(query['sort']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sort = _step.value;

      for (var field in sort) {
        fieldsName.push(field);
        if (sort[field] === 'desc') {
          orientation = 'desc';
          break;
        }
      }

      for (var _field in sort) {
        var obj = JSON.parse('{}');
        obj[_field] = orientation;
        fields.push(obj);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    fields: fields,
    name: fieldsName.join('-') + '-' + orientation + '-index'
  };
}

function getQueryIndex(finder) {
  if (!finder.hasOwnProperty('selector') || finder.selector.length === 0) return;
  fields = [];
  for (var index in finder['selector']) {
    if (multipleKeys.indexOf(index) === -1) {
      fields.push(index);
    }
  }

  if (finder.hasOwnProperty('sort')) {
    defineSortOrientation(finder.sort);
  }

  return {
    'fields': finder.hasOwnProperty('sort') ? defineFieldsOriented() : fields,
    'name': fields.join('-') + '-' + orientation + '-index'
  };
}

function defineFieldsOriented() {
  return fields.map(function (item) {
    var a = {};
    a[item] = orientation;
    return a;
  });
}

function defineSortOrientation(sort) {
  if (sort.length === 0) {
    return;
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sort), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var s = _step2.value;

      for (var field in s) {
        var orient = s[field];
        if (orient === 'desc') {
          orientation = 'desc';
        }
        if (!isNaN(field)) {
          updateIndexFieldsWithSortField(orient);
          continue;
        }
        updateIndexFieldsWithSortField(field);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function updateIndexFieldsWithSortField(field) {
  if (fields.indexOf(field) === -1) fields.push(field);
}

/***/ }),

/***/ "olec":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "on/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p/Oq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p5eg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventsSpecifications'
});

/***/ }),

/***/ "p6+/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pGH3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pH0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pJSd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_csv_import__ = __webpack_require__("Txdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_csv_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_csv_import__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-tickets-confirm',
  components: {
    VueCsvImport: __WEBPACK_IMPORTED_MODULE_6_vue_csv_import__["VueCsvImport"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['config', 'user']), {
    eventId: function eventId() {
      return this.$route.params.id;
    }
  }),
  data: function data() {
    return {
      loading: false,
      mapFields: ['uc', 'nome', 'cpf', 'confirmado'],
      customers: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('customers', ['fetchOne', 'fetchAll', 'resetOne', 'insert', 'update', 'upsert']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('winners', { winnerByConfig: 'winnerByConfig' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', { updateTicket: 'upsert', fetchTickts: 'fetchAll', createTicket: 'createTicket', getTicketBarcode: 'getTicketBarcode', checkWinnerOld: 'checkWinnerOld', isWinnerTrgNewer: 'isWinnerTrgNewer' }), {
    handleImport: function handleImport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.loading = true;
                _context2.next = 3;
                return _this.asyncForEach(_this.customers, function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(customer) {
                    var customerDB, status, tickets, ticket;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(customer.UC === 'uc')) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt('return');

                          case 2:
                            _context.next = 4;
                            return _this.getCustomer(customer);

                          case 4:
                            customerDB = _context.sent;
                            status = customer.confirmado.toLowerCase();
                            _context.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').collection('tickets').where('customerId', customerDB._id).where('eventId', _this.eventId).get();

                          case 8:
                            tickets = _context.sent;

                            if (!(tickets.length > 0)) {
                              _context.next = 24;
                              break;
                            }

                            ticket = tickets[0];
                            _context.t0 = status;
                            _context.next = _context.t0 === 'faltou' ? 14 : _context.t0 === 'reserva/ok' ? 17 : 20;
                            break;

                          case 14:
                            ticket.checkIn = false;
                            ticket.winner = false;
                            return _context.abrupt('break', 22);

                          case 17:
                            ticket.checkIn = true;
                            ticket.winner = true;
                            return _context.abrupt('break', 22);

                          case 20:
                            ticket.checkIn = true;
                            return _context.abrupt('break', 22);

                          case 22:
                            _context.next = 24;
                            return _this.updateTicket(ticket);

                          case 24:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 3:
                setTimeout(function () {
                  _this.loading = false;
                  window.location.reload(true);
                }, 2000);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getCustomer: function getCustomer(customer) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
          var constumerResolve, costumerUC, costumerCPF, customerIDs;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  constumerResolve = null;
                  _context3.next = 3;
                  return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').where('uc', customer.uc).limit(1).get();

                case 3:
                  costumerUC = _context3.sent;
                  _context3.next = 6;
                  return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].connection('default').where('uc', customer.cpf).limit(1).get();

                case 6:
                  costumerCPF = _context3.sent;

                  costumerUC = costumerUC.length > 0 ? costumerUC[0] : costumerUC;
                  costumerCPF = costumerCPF.length > 0 ? costumerCPF[0] : costumerCPF;
                  customerIDs = {
                    idUc: false,
                    idCpf: false
                  };


                  if (costumerUC && costumerUC.uc === customer.uc) {
                    constumerResolve = costumerUC;
                    customerIDs.idUc = costumerUC._id;
                  }

                  if (costumerCPF && costumerCPF.cpf === customer.cpf) {
                    constumerResolve = costumerCPF;
                    customerIDs.idCpf = costumerCPF._id;
                  }

                  if (_this2.config.validationCustomer.uc && _this2.config.validationCustomer.cpf && costumerUC && costumerCPF && customerIDs.idUc && customerIDs.idCpf) {
                    constumerResolve = costumerUC;
                  }

                  if (_this2.config.validationCustomer.uc && costumerUC > 0 && !_this2.config.validationCustomer.cpf && customerIDs.idUc) {
                    constumerResolve = costumerUC;
                  }

                  if (_this2.config.validationCustomer.cpf && costumerCPF > 0 && !_this2.config.validationCustomer.uc && customerIDs.idCpf) {
                    constumerResolve = costumerCPF;
                  }

                  if (_this2.config.validationCustomer.ucOrCpf && costumerCPF > 0 && (customerIDs.idUc || customerIDs.idCpf)) {
                    constumerResolve = costumerUC;
                    if (!costumerUC) {
                      constumerResolve = costumerCPF;
                    }
                  }
                  resolve(constumerResolve);

                case 17:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    asyncForEach: function asyncForEach(array, callback) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                index = 0;

              case 1:
                if (!(index < array.length)) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return callback(array[index], index, array);

              case 4:
                index++;
                _context4.next = 1;
                break;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    }
  })
});

/***/ }),

/***/ "pNDi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pZL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("whIq");
function injectStyle (ssrContext) {
  __webpack_require__("YcmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "paHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCemar_vue__ = __webpack_require__("H1iK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_806a81f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCemar_vue__ = __webpack_require__("ExTs");
function injectStyle (ssrContext) {
  __webpack_require__("/Ygr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-806a81f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampTermCemar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_806a81f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampTermCemar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pd2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionTermLamps_vue__ = __webpack_require__("5p9O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb8e41b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionTermLamps_vue__ = __webpack_require__("vJ5r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionTermLamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb8e41b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionTermLamps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radios: {
        radio1: '1',
        radio2: '2',
        radio3: '2'
      },
      checkboxes: {
        first: false,
        second: false,
        a: false,
        b: false,
        c: false,
        unchecked: false,
        checked: true,
        disabledUnchecked: false,
        disabledChecked: true
      }
    };
  }
});

/***/ }),

/***/ "phuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('SignatureCustomerTicket',{attrs:{"customer":_vm.payload.customer}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pk/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_config_connections__ = __webpack_require__("ZKT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Helper__ = __webpack_require__("leRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_services_couchdb__ = __webpack_require__("sv1M");















/* harmony default export */ __webpack_exports__["a"] = ({
  config: {
    connection: 'default',
    db: null,
    collection: null,
    selector: {},
    fields: [],
    limit: 1000000,
    skip: 0,
    sort: []
  },
  find: function find(docId) {
    return this.getHttpInstance().get('/' + this.getDb() + '/' + docId).then(function (response) {
      return response.data;
    });
  },
  first: function first() {
    this.config.limit = 1;
    return this._find(this.transformResponse.toOnlyOneDoc);
  },
  get: function get() {
    return this._find(this.transformResponse.toAllDocs);
  },
  count: function count() {
    this.select(['_id']);
    return this._find(this.transformResponse.toCount);
  },
  all: function all() {
    return this.get();
  },
  insert: function insert(payload) {
    return this._insert(payload);
  },
  update: function update(docId, payload) {
    return this._update(docId, payload);
  },
  upset: function upset(docId, payload) {
    return this._upsert(docId, payload);
  },
  upsert: function upsert(docId, payload, database) {
    return this._upsert(docId, payload, database);
  },
  delete: function _delete(docId) {
    return this._delete(docId);
  },
  viewReduce: function viewReduce(ddoc, view) {
    return this._viewReduce(ddoc, view);
  },
  view: function view(ddoc, _view, key, options, keys, database) {
    if ((typeof ddoc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(ddoc)) === 'object') {
      database = ddoc.hasOwnProperty('database') ? ddoc.database : '';
      _view = ddoc.hasOwnProperty('view') ? ddoc.view : '';
      options = ddoc.hasOwnProperty('options') ? ddoc.options : false;
      key = ddoc.hasOwnProperty('key') ? ddoc.key : false;
      keys = ddoc.hasOwnProperty('keys') ? ddoc.keys : false;
      ddoc = ddoc.hasOwnProperty('ddoc') ? ddoc.ddoc : '';
    }

    var params = {
      queries: []
    };

    if (key || keys) {
      var query = {
        keys: key ? [key] : keys
      };
      for (var index in options) {
        if (index === 'group') {
          query[index] = options[index];
        }
      }
      params.queries.push(query);
    }

    if (options) {
      params.queries.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options));
    }

    return this._view({ database: database, ddoc: ddoc, view: _view, params: params });
  },
  viewQueries: function viewQueries(_ref) {
    var connection = _ref.connection,
        ddoc = _ref.ddoc,
        view = _ref.view,
        queries = _ref.queries;

    var conn = connection !== undefined ? connection : 'default';
    var quer = queries !== undefined ? queries : [{ limit: 1 }];
    return this._viewQueries(conn, ddoc, view, { queries: quer });
  },
  _viewQueries: function _viewQueries(connection, ddoc, view, queries) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve) {
      _this.connection(connection);
      _this.getHttpInstance().post('/' + _this.getDb() + '/_design/' + ddoc + '/_view/' + view, queries).then(function (res) {
        if (!res || !res.data || !res.data.results) {
          resolve([]);
        }
        resolve(res.data.results);
      }).catch(function () {
        resolve([]);
      });
    });
  },
  createView: function createView(ddocName, viewName, view) {
    return this._createView(ddocName, viewName, view);
  },
  createFilter: function createFilter(ddocName, viewName, filter) {
    return this._createFilter(ddocName, viewName, filter);
  },
  getAttachmentUrl: function getAttachmentUrl(docId, payload) {
    return this._getAttachmentUrl(docId, payload);
  },
  getAttachmentUrlByReference: function getAttachmentUrlByReference(referenceId, attachmentName) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2._getAttachmentUrlByReference(referenceId, attachmentName);

            case 2:
              url = _context.sent;
              return _context.abrupt('return', url);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  getAttachment: function getAttachment(docId, payload) {
    var _this3 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this3._getAttachment(docId, payload).then(function (result) {
        resolve(result);
        _this3.reset();
      }).catch(function (err) {
        reject(err);
        _this3.reset();
      });
    });
    return promise;
  },
  insertAttachment: function insertAttachment(docId, payload) {
    var _this4 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this4._insertAttachment(docId, payload).then(function (result) {
        resolve(result);
        _this4.reset();
      }).catch(function (err) {
        reject(err);
        _this4.reset();
      });
    });
    return promise;
  },
  deleteAttachment: function deleteAttachment(docId, payload) {
    var _this5 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this5._deleteAttachment(docId, payload).then(function (result) {
        resolve(result);
        _this5.reset();
      }).catch(function (err) {
        reject(err);
        _this5.reset();
      });
    });
    return promise;
  },
  connection: function connection(_connection) {
    this.config.connection = _connection;
    if (__WEBPACK_IMPORTED_MODULE_10_src_config_connections__["a" /* default */][this.config.connection] === undefined) {
      throw new Error('Connection dont exists.');
    } else {
      this.config.db = __WEBPACK_IMPORTED_MODULE_10_src_config_connections__["a" /* default */][this.config.connection].db;
    }
    return this;
  },
  db: function db(_db) {
    this.config.db = _db;
    return this;
  },
  collection: function collection(_collection) {
    this.config.collection = _collection;
    return this;
  },
  where: function where(field, value) {
    this.config.selector[field] = value;
    return this;
  },
  whereOr: function whereOr(field, value) {
    if (!this.config.selector.hasOwnProperty('$or')) {
      this.config.selector['$or'] = [];
    }

    this.config.selector['$or'] = value.map(function (item) {
      var a = {};
      a[field] = item;
      return a;
    });
    return this;
  },
  select: function select(fields) {
    this.config.fields = fields;
    return this;
  },
  limit: function limit(_limit) {
    this.config.limit = _limit;
    return this;
  },
  skip: function skip(_skip) {
    this.config.skip = _skip;
    return this;
  },
  sort: function sort(_sort) {
    if (_sort.field !== null) {
      var sortObject = {};
      var mapDirections = {
        ascending: 'asc',
        asc: 'asc',
        descending: 'desc',
        desc: 'desc'
      };
      sortObject[_sort.field] = mapDirections[_sort.direction];
      this.config.sort = [sortObject];
    }
    return this;
  },
  search: function search(_search) {
    if (_search.query) {
      var conditions = [];
      _search.fields.map(function (item) {
        var condition = {};
        condition[item] = { '$regex': '(?i)' + _search.query };
        conditions.push(condition);
      });
      this.config.selector['$or'] = conditions;
    }
    return this;
  },
  whereIn: function whereIn(field, inArray) {
    this.config.selector[field] = { '$in': inArray };
    return this;
  },
  createIndex: function createIndex(fields, indexName) {
    return this._createIndex(fields, indexName);
  },
  _find: function _find(transformResponse) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var promise;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                  var query, db, promises;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          query = _this6.getQuery();
                          db = _this6.getDb();
                          promises = [__WEBPACK_IMPORTED_MODULE_13_src_services_couchdb__["a" /* couchdbIndexManager */].create(query)];

                          if (query.hasOwnProperty('sort')) {
                            promises.push(__WEBPACK_IMPORTED_MODULE_13_src_services_couchdb__["a" /* couchdbIndexManager */].create({
                              selector: query.sort.reduce(function (accumulated, current) {
                                for (var sortField in current) {
                                  accumulated[sortField] = sortField;
                                }
                                return accumulated;
                              }, {})
                            }));
                          }
                          _context2.next = 6;
                          return __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"].all(promises);

                        case 6:
                          _this6.getHttpInstance().post('/' + db + '/_find', query, {
                            transformResponse: [transformResponse]
                          }).then(function (response) {
                            resolve(response.data);
                          }).catch(function (err) {
                            console.log(err);
                            resolve(null);
                          });

                        case 7:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this6);
                }));

                return function (_x, _x2) {
                  return _ref2.apply(this, arguments);
                };
              }());


              _this6.reset();
              return _context3.abrupt('return', promise);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  },
  _insert: function _insert(payload, database) {
    var _this7 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      payload.collection = payload.collection || _this7.config.collection;
      payload.createdAt = new Date();
      payload.updatedAt = new Date();
      if (database) {
        _this7.connection(database);
      }
      _this7.getHttpInstance().post('/' + _this7.getDb() + '/', payload).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
    this.reset();
    return promise;
  },
  _postBulkDocs: function _postBulkDocs(docs, database) {
    var _this8 = this;

    docs = docs.map(function (item) {
      item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this8.addDefaultData(item));
      return item;
    });

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      if (database) {
        _this8.connection(database);
      }
      _this8.getHttpInstance().post('/' + _this8.getDb() + '/' + '_bulk_docs', { docs: docs }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
    this.reset();
    return promise;
  },
  _updateBulkDocs: function _updateBulkDocs(docs) {
    return this._postBulkDocs(docs.filter(function (item) {
      return item.hasOwnProperty('_id') && item.hasOwnProperty('_rev');
    }));
  },
  _insertBulk: function _insertBulk(docs) {
    return this._postBulkDocs(docs);
  },
  _insertBuckLogs: function _insertBuckLogs(logs) {
    this.config.connection = 'logs';
    this.config.collection = 'logs';
    return this._insertBulk(this._getDocsLogs(logs));
  },
  _getDocsLogs: function _getDocsLogs(logs) {
    return logs.map(function (item) {
      var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__Helper__["a" /* getDiff */])(item.new, item.old);
      var typeOfChange = ['updated'];
      var ignoreFields = ['updatedAt', '_id', '_rev'];
      var docLogs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__Helper__["b" /* getLogDeeply */])(diff, typeOfChange, ignoreFields).map(function (itemLog) {
        itemLog.user = __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.user._id;
        itemLog.userName = __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.user.name;
        itemLog.referenceId = item.old._id;
        itemLog.collection = item.old.collection;
        itemLog.createdAt = new Date();
        return itemLog;
      });
      return docLogs;
    }).reduce(function (accum, current, index, complete) {
      if (complete.length > 0) {
        if (index === 0) {
          accum = [];
        }
        return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(accum), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(current));
      }
    }, []);
  },
  _update: function _update(docId, payload, database) {
    var _this9 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      if (database) {
        _this9.connection(database);
      }

      _this9.find(docId).then(function (oldDoc) {
        if (oldDoc === null) {
          reject(new Error('Document not found.'));
          return;
        }
        payload.updatedAt = new Date();
        payload._rev = oldDoc._rev;

        if (database) {
          _this9.connection(database);
        }

        _this9.getHttpInstance().put('/' + _this9.getDb() + '/' + docId, payload).then(function (response) {
          if (database) {
            _this9.connection(database);
          }
          _this9._insertBuckLogs([{
            new: payload,
            old: oldDoc
          }]);
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    });
    this.reset();
    return promise;
  },
  upsertManyWithView: function upsertManyWithView(_ref3) {
    var _this10 = this;

    var database = _ref3.database,
        ddoc = _ref3.ddoc,
        view = _ref3.view,
        payload = _ref3.payload;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve) {
      var keys = payload.filter(function (item) {
        return item._id;
      }).map(function (item) {
        return item._id;
      });
      if (keys.length <= 0) {
        resolve(false);
      }

      _this10.view({ database: database, ddoc: ddoc, view: view, keys: keys }).then(function (res) {
        if (!res.rows) {
          return;
        }

        var currentDocsOnDb = res.rows.map(function (item) {
          return item.value;
        }).reduce(function (acc, curr, indx) {
          if (indx === 0) {
            acc = {};
          }
          acc[curr._id] = curr;
          return acc;
        }, {});

        var logs = [];
        var bulkDocs = payload.map(function (item) {
          var doc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this10.addDefaultData(item));
          if (currentDocsOnDb.hasOwnProperty(item._id)) {
            doc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, currentDocsOnDb[item._id], item);
            doc._rev = currentDocsOnDb[item._id]._rev;
            doc.updatedAt = new Date();
            logs.push({ old: currentDocsOnDb[item._id], new: doc });
          }
          return doc;
        });

        __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"].all([_this10._insertBulk(bulkDocs), _this10._insertBuckLogs(logs)]).then(function (res) {
          resolve(res);
        });
      }).catch(function (err) {
        resolve(false);
        console.log(err);
      });
    });
  },
  upsertWithView: function upsertWithView(_ref4) {
    var _this11 = this;

    var database = _ref4.database,
        ddoc = _ref4.ddoc,
        view = _ref4.view,
        payload = _ref4.payload;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      if (database) {
        _this11.connection(database);
      }
      payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this11.addDefaultData(payload));

      if (!payload.hasOwnProperty('_id') || !payload._id) {
        _this11.getHttpInstance().post('/' + _this11.getDb() + '/' + '_bulk_docs', { docs: [payload] }).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
        return;
      }

      _this11.view({ ddoc: ddoc, view: view, key: payload._id }).then(function (response) {
        var oldDoc = response.rows[0].value;
        payload.updatedAt = new Date();
        payload._rev = oldDoc._rev;
        if (database) {
          _this11.connection(database);
        }

        _this11.getHttpInstance().put('/' + _this11.getDb() + '/' + payload._id, payload).then(function (response) {
          if (database) {
            _this11.connection(database);
          }

          _this11._insertBuckLogs([{ new: payload, old: oldDoc }]);
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    });

    this.reset();
    return promise;
  },
  updateWithView: function updateWithView(_ref5) {
    var _this12 = this;

    var database = _ref5.database,
        ddoc = _ref5.ddoc,
        view = _ref5.view,
        payload = _ref5.payload;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      if (database) {
        _this12.connection(database);
      }

      payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this12.addDefaultData(payload));

      _this12.view({ ddoc: ddoc, view: view, key: payload._id }).then(function (response) {
        if (!response.rows[0] && !response.rows[0].value) {
          resolve(null);
        }

        var oldDoc = response.rows[0].value;
        payload.updatedAt = new Date();
        payload._rev = oldDoc._rev;
        if (database) {
          _this12.connection(database);
        }

        _this12.getHttpInstance().put('/' + _this12.getDb() + '/' + payload._id, payload).then(function (response) {
          if (database) {
            _this12.connection(database);
          }

          _this12._insertBuckLogs([{ new: payload, old: oldDoc }]);
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    });
    this.reset();
    return promise;
  },
  _upsert: function _upsert(docId, payload, database) {
    var _this13 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      if (database) {
        _this13.connection(database);
      }
      _this13._head(docId).then(function (result) {
        _this13._update(docId, payload).then(function (result) {
          return resolve(result);
        }).catch(function (err) {
          return reject(err);
        });
      }).catch(function (err) {
        if (err.response.status === 404) {
          return _this13._insert(payload).then(function (result) {
            return resolve(result);
          }).catch(function (err) {
            return reject(err);
          });
        } else {
          reject(err);
        }
      });
    });
    return promise;
  },
  _delete: function _delete(docId) {
    var _this14 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this14._head(docId).then(function (result) {
        var rev = result.headers.etag.replace(/"/g, '');
        _this14.getHttpInstance().delete('/' + _this14.getDb() + '/' + docId, {
          params: {
            'rev': rev
          }
        }).then(function (response) {
          _this14.reset();
          resolve(response.data);
        }).catch(function (err) {
          _this14.reset();
          reject(err);
        });
      }).catch(function (err) {
        _this14.reset();
        reject(err);
      });
    });
    return promise;
  },
  _head: function _head(docId, DB) {
    var _this15 = this;

    if (!DB) {
      DB = this.getDb();
    }
    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this15.getHttpInstance().head('/' + DB + '/' + docId).then(function (response) {
        resolve(response);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  _getRev: function _getRev(docId, DB) {
    var _this16 = this;

    if (!DB) {
      DB = this.getDb();
    }

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this16._head(docId, DB).then(function (result) {
        resolve(result.headers.etag.replace(/"/g, ''));
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  _view: function _view(_ref6) {
    var database = _ref6.database,
        ddoc = _ref6.ddoc,
        view = _ref6.view,
        params = _ref6.params;

    if (database && database !== '') {
      this.connection(database);
    }

    var query = params.queries.length > 0 ? this.getHttpInstance().post('/' + this.getDb() + '/_design/' + ddoc + '/_view/' + view, params) : this.getHttpInstance().get('/' + this.getDb() + '/_design/' + ddoc + '/_view/' + view);

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      query.then(function (response) {
        if (params.queries.length > 0) {
          resolve(response.data.results[0]);
        } else {
          resolve(response.data);
        }
      }).catch(function (err, response) {
        reject(err);
      });
    });
    this.reset();
    return promise;
  },
  viewBetween: function viewBetween(ddoc, view, keys, options) {
    if ((typeof ddoc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(ddoc)) === 'object') {
      view = ddoc.hasOwnProperty('view') ? ddoc.view : '';
      keys = ddoc.hasOwnProperty('keys') ? ddoc.keys : '';
      options = ddoc.hasOwnProperty('options') ? ddoc.options : {};
      ddoc = ddoc.hasOwnProperty('ddoc') ? ddoc.ddoc : '';
    }
    return this._viewBetween(ddoc, view, keys, options);
  },
  _viewBetween: function _viewBetween(ddoc, view, keys, options) {
    var _this17 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var getparams = '';
      if (options && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).length > 0) {
        for (var param in options) {
          getparams += getparams === '' ? '?' + param + '=' + options[param] : '&' + param + '=' + options[param];
        }
      }
      if (typeof keys !== 'undefined' && keys.hasOwnProperty('startKey') && keys.hasOwnProperty('endKey')) {
        getparams += getparams === '' ? '?' : '&';

        if (keys.startIndex !== undefined && keys.startIndex >= 0 && keys.startIndex < keys.endIndex) {
          getparams += 'start_key=["' + keys.startKey + '", ' + keys.startIndex + ']&end_key=["' + keys.endKey + '", ' + keys.endIndex + ']';
        } else {
          getparams += 'start_key="' + keys.startKey + '"';
        }

        if (keys.hasOwnProperty('endIndex') && keys.endIndex !== undefined) {
          getparams += '&end_key=["' + keys.endKey + '", ' + keys.endIndex + ']';
        } else {
          getparams += '&end_key="' + keys.endKey + '"';
        }
      }
      _this17.getHttpInstance().get('/' + _this17.getDb() + '/_design/' + ddoc + '/_view/' + view + getparams).then(function (response) {
        resolve(response.data);
      }).catch(function (err, response) {
        reject(err);
      });
    });
    this.reset();
    return promise;
  },
  _viewReduce: function _viewReduce(ddoc, view) {
    var _this18 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this18.getHttpInstance().get('/' + _this18.getDb() + '/_design/' + ddoc + '/_view/' + view + '?group=true&reduce=true&skip=0').then(function (response) {
        resolve(response.data);
      }).catch(function (err, response) {
        reject(err);
      });
    });
    this.reset();
    return promise;
  },
  _createView: function _createView(ddocName, viewName, view) {
    var _this19 = this;

    var ddocUri = '/' + this.getDb() + '/_design/' + ddocName;
    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this19._getDesignDocument(ddocName).then(function (ddoc) {
        var oldDdoc = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(ddoc);
        var newDdoc = void 0;
        var views = { views: {} };
        views['views'][viewName] = view;
        if (ddoc === undefined) {
          newDdoc = views;
        } else {
          newDdoc = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.merge(ddoc, views);
          newDdoc._rev = ddoc._rev;
        }
        if (!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEqual(oldDdoc, newDdoc)) {
          _this19.getHttpInstance().put(ddocUri, newDdoc).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        } else {
          resolve(true);
        }
      }).catch(function (err) {
        return reject(err);
      });
    });
    return promise;
  },
  _createFilter: function _createFilter(ddocName, filterName, filter) {
    var _this20 = this;

    var ddocUri = '/' + this.getDb() + '/_design/' + ddocName;
    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this20._getDesignDocument(ddocName).then(function (ddoc) {
        var oldDdoc = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(ddoc);
        var newDdoc = void 0;
        var filters = { filters: {} };
        filters['filters'][filterName] = filter;
        if (ddoc === undefined) {
          newDdoc = filters;
        } else {
          newDdoc = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.merge(ddoc, filters);
        }

        if (!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEqual(oldDdoc, newDdoc)) {
          _this20.getHttpInstance().put(ddocUri, newDdoc).then(function (response) {
            resolve(response.data);
          }).catch(function (err) {
            return reject(err);
          });
        } else {
          resolve(true);
        }
      }).catch(function (err) {
        return reject(err);
      });
    });
    return promise;
  },
  createFilters: function createFilters(designName, filters) {
    var _this21 = this;

    var ddocUri = '/' + this.getDb() + '/_design/' + designName;
    return this._getDesignDocument(designName).then(function (old) {
      var document = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ filters: [] }, old);
      document['filters'] = filters;

      if (old && old.hasOwnProperty('_rev')) {
        _this21.getHttpInstance().put(ddocUri, document).then(function (response) {
          return response.data;
        });
      } else {
        _this21.getHttpInstance().post('/' + _this21.getDb(), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ _id: '_design/' + designName }, document)).then(function (response) {
          return response.data;
        });
      }
    }).catch(function (err) {
      return console.log(err);
    });
  },
  _getDesignDocument: function _getDesignDocument(ddocName) {
    var _this22 = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var ddocUri = '/' + _this22.getDb() + '/_design/' + ddocName;
      _this22.getHttpInstance().get(ddocUri).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        if (err.response.status === 404) {
          resolve(undefined);
        } else {
          reject(err);
        }
      });
    });
  },
  _createIndex: function _createIndex(fields, indexName) {
    var _this23 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this23.getHttpInstance().post('/' + _this23.getDb() + '/_index', {
        index: {
          fields: fields
        },
        name: indexName,
        type: 'json'
      }).then(function (response) {
        resolve(response);
      }).catch(function (err, response) {
        reject(err);
      }).finally(function () {
        _this23.reset();
      });
    });
    return promise;
  },
  _bulk_get: function _bulk_get(docIds) {
    var _this24 = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var DB = _this24.getDb();
      _this24.getHttpInstance().post('/' + DB + '/_bulk_get/', { docs: docIds }).then(function (response) {
        resolve(response.data.results.filter(function (item) {
          return item.docs[0].hasOwnProperty('ok');
        }).map(function (item) {
          return item.docs[0].ok;
        }));
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  _insertAttachment: function _insertAttachment(docId, payload) {
    var _this25 = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var DB = _this25.getDb();
      _this25._getRev(docId, DB).then(function (rev) {
        var attachmentName = encodeURI(payload.attachmentName);
        _this25.getHttpInstance().put('/' + DB + '/' + docId + '/' + attachmentName, payload.attachment, {
          headers: {
            'Content-Type': payload.mimeType
          },
          params: {
            rev: rev
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  _deleteAttachment: function _deleteAttachment(docId, payload) {
    var _this26 = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var DB = _this26.getDb();
      _this26._getRev(docId).then(function (rev) {
        var attachmentName = encodeURI(payload.attachmentName);
        _this26.getHttpInstance().delete('/' + DB + '/' + docId + '/' + attachmentName, {
          params: {
            rev: rev
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  _getAttachment: function _getAttachment(docId, attachmentName) {
    var _this27 = this;

    var attachmentUrl = this._getAttachmentUrl(docId, attachmentName);
    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this27.getHttpInstance().get(attachmentUrl, {
        responseType: 'blob'
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  _getAttachmentUrl: function _getAttachmentUrl(docId, attachmentName) {
    var connection = __WEBPACK_IMPORTED_MODULE_10_src_config_connections__["a" /* default */][this.config.connection];
    this.config.db = connection.db;
    var url = connection.host + '/' + this.getDb() + '/' + docId + '/' + attachmentName;
    this.reset();
    return url;
  },
  _getAttachmentUrlByReference: function _getAttachmentUrlByReference(referenceId, attachmentName) {
    var _this28 = this;

    var promise = new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      var connection = __WEBPACK_IMPORTED_MODULE_10_src_config_connections__["a" /* default */][_this28.config.connection];
      _this28.config.db = connection.db;
      _this28.where('referenceId', referenceId);
      _this28.getHttpInstance().post('/' + _this28.getDb() + '/_find', _this28.getQuery(), {
        transformResponse: _this28.transformResponse.toOnlyOneDoc
      }).then(function (response) {
        var doc = response.data;
        resolve(connection.host + '/' + connection.db + '/' + doc._id + '/' + attachmentName);
      }).catch(function (err) {
        return reject(err);
      });
    });
    this.reset();
    return promise;
  },
  getDb: function getDb() {
    return this.config.db;
  },
  getQuery: function getQuery() {
    if (this.config.collection !== null) {
      this.config.selector.collection = this.config.collection;
    }
    var query = {
      'selector': {
        _id: {
          $gt: null
        }
      }
    };
    if (this.config.selector && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.config.selector).length > 0) {
      query['selector'] = this.config.selector;
    }

    if (this.config.limit) query['limit'] = this.config.limit;

    if (this.config.skip) query['skip'] = this.config.skip;

    if (this.config.sort && this.config.sort.length > 0) query['sort'] = this.config.sort;

    if (this.config.fields.length > 0) {
      query['fields'] = this.config.fields;
    }

    return query;
  },
  getHttpInstance: function getHttpInstance() {
    var connection = __WEBPACK_IMPORTED_MODULE_10_src_config_connections__["a" /* default */][this.config.connection];
    if (connection === undefined) {
      throw new Error('Connection dont exists.');
    }
    this.connection(this.config.connection);

    return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
      baseURL: connection.host,
      timeout: 9999999,
      auth: {
        username: connection.user,
        password: connection.pass
      }
    });
  },

  transformResponse: {
    toOnlyOneDoc: function toOnlyOneDoc(data) {
      var result = JSON.parse(data);
      return result.docs.length === 0 ? null : result.docs[0];
    },
    toAllDocs: function toAllDocs(data) {
      var result = JSON.parse(data);
      return result.docs && result.docs.length > 0 ? result.docs : [];
    },
    toCount: function toCount(data) {
      var result = JSON.parse(data);
      return result.docs.length;
    }
  },
  reset: function reset() {
    this.config = {
      connection: 'default',
      db: null,
      collection: null,
      selector: {},
      fields: [],
      limit: 25,
      skip: 0,
      sort: []
    };
  },
  addDefaultData: function addDefaultData(obj) {
    if (!obj.hasOwnProperty('collection')) {
      obj.collection = this.config.collection;
    }

    if (!obj.hasOwnProperty('createdAt')) {
      obj.createdAt = new Date();
    }

    if (!obj.hasOwnProperty('updatedAt')) {
      obj.updatedAt = new Date();
    }

    if (!obj.hasOwnProperty('userId') && __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.hasOwnProperty('user')) {
      obj.userId = __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.user._id;
    }

    if (!obj.hasOwnProperty('servername') && __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.hasOwnProperty('config')) {
      obj.servername = __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.config.hasOwnProperty('servername') ? __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */].state.config.servername : '3EENG-unamed';
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, obj);
  },
  deleteDesignView: function deleteDesignView(designDoc) {
    var _this29 = this;

    return new __WEBPACK_IMPORTED_MODULE_8_es6_promise__["Promise"](function (resolve, reject) {
      _this29._getDesignDocument(designDoc).then(function (ddoc) {
        _this29.getHttpInstance().delete('/' + _this29.getDb() + '/_design/' + designDoc + '?rev=' + ddoc._rev).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    });
  }
});

/***/ }),

/***/ "pq1s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsIndex_vue__ = __webpack_require__("zPiT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1ca272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsIndex_vue__ = __webpack_require__("h2pr");
function injectStyle (ssrContext) {
  __webpack_require__("3NeS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e1ca272"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1ca272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pqsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'manufacturers.index';
    }
  }
});

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__("hQ4h");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("5ANv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "psw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pxe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseModule__ = __webpack_require__("tv5d");





var collection = 'winners';
var singleName = 'winner';
var pluralName = 'winners';

var model = {
  uc: '',
  name: '',
  cpf: '',
  exchangeDate: '',
  eventPlace: ''
};

var validations = {
  uc: { required: false },
  name: { required: false },
  cpf: { required: false },
  exchangeDate: { required: false },
  eventPlace: { required: false }
};

var getters = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  count: function count(state) {
    return state.count;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["c" /* mapActions */])(collection, model, 'winners'), {
    winnerByConfig: function winnerByConfig(context, _ref) {
      var _this = this;

      var config = _ref.config,
          customer = _ref.customer;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var where, returnWinner;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context.commit('changeLoading', true);
                where = [];

                if (config.validationContemplatedCustomer.uc) {
                  where.push({ uc: customer.uc });
                }
                if (config.validationContemplatedCustomer.cpf) {
                  where.push({ cpf: customer.cpf.replace(/\D/g, '') });
                }
                if (config.validationContemplatedCustomer.ucOrCpf) {
                  where = [{ '$or': where }];
                }

                if (!(where.length > 0)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return context.dispatch('fetchAll', { where: where });

              case 8:
                returnWinner = _context.sent;

                context.commit('changeLoading', false);
                return _context.abrupt('return', returnWinner ? returnWinner[0] : false);

              case 11:
                return _context.abrupt('return', false);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  getters: getters
});

/***/ }),

/***/ "pxkv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q+Kt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q/ei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TicketDocument__ = __webpack_require__("MuVr");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TicketPrint',

  components: {
    TicketDocument: __WEBPACK_IMPORTED_MODULE_3__TicketDocument__["a" /* default */]
  },

  data: function data() {
    return {
      ticket: {},
      loading: true
    };
  },


  computed: {
    id: function id() {
      return this.$route.params.id;
    },


    printId: function printId() {
      return 'ticket-print-' + this.ticket.barcode;
    },

    config: {
      get: function get() {
        return this.$store.state.config;
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('tickets', { fetchTicket: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('events', { fetchEvent: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('customers', { fetchCustomer: 'fetchOne' }), {
    fetch: function fetch() {
      var _this = this;

      this.loading = true;
      this.fetchTicket(this.id).then(function (ticketData) {
        _this.fetchCustomer(ticketData.customerId).then(function (customer) {
          _this.fetchEvent(ticketData.eventId).then(function (event) {
            _this.ticket = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(ticketData, { customer: customer }, { event: event });
            _this.loading = false;
          });
        });
      }).catch(function (err) {
        console.log(err);
        _this.loading = false;
        return err;
      });
    }
  }),

  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ "q2Pq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDocsFromContemplados_vue__ = __webpack_require__("nLkI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2150d265_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDocsFromContemplados_vue__ = __webpack_require__("8P/w");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveDocsFromContemplados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2150d265_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveDocsFromContemplados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4VT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q5CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q62M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'events.index';
    }
  }
});

/***/ }),

/***/ "q66r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stateless-factory',
  functional: true,
  props: {
    componentProp: {
      required: true
    },
    dataProp: {
      required: true
    }
  },
  render: function render(createElement, context) {
    return createElement(context.props.componentProp, context.props.dataProp);
  }
});

/***/ }),

/***/ "qAgR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qCRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Documents_Terms_HeaderTerm__ = __webpack_require__("fd3O");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeliveryTermGeneric',

  components: {
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_2__pages_Documents_Terms_HeaderTerm__["a" /* default */]
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  mounted: function mounted() {
    this.getImagesProject();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['getImagesProject']))
});

/***/ }),

/***/ "qHWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.customer._id),expression:"!customer._id"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('customer-card',{attrs:{"customer":_vm.customer}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('circle-chart-card',{attrs:{"percentage":_vm.lampsPercentage,"title":"","description":("Trocas Realizadas" + (_vm.lampsHasSeason ? ' na Temporada' : '') + ": " + _vm.countLamps + "/" + _vm.lampsMaxProject),"color":"blue"}})],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-11 col-xs-12",staticStyle:{"margin-bottom":"30px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventId),expression:"eventId"}],staticClass:"form-control",attrs:{"name":"power"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eventId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getLampsStockOfEvent]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("\n                  Selecione ...\n                ")]),_vm._v(" "),_vm._l((_vm.eventsOptions),function(item){return _c('option',{key:item.value,domProps:{"value":item.value}},[_vm._v(_vm._s(item.label)+"\n                ")])})],2)])])])]),_vm._v(" "),(_vm.showNewLampForm)?_c('div',[_c('lamps-form',{attrs:{"customer":_vm.customer,"stock-lamps":_vm.currentEventStockLamps,"event":_vm.event,"lamps-left":_vm.lampsLeft},on:{"fetchData":_vm.fetchDatas,"on-save":function($event){return _vm.fetchCustomer()}}})],1):(_vm.showAlert)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('lamps-alert',{attrs:{"alert-text":_vm.alertText}})],1)]):_vm._e(),_vm._v(" "),_c('lamps-list',{attrs:{"customer":_vm.customer}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right",staticStyle:{"margin-bottom":"20px"}},[_c('router-link',{attrs:{"to":{name: 'customers.create'}}},[_c('button',{staticClass:"btn btn-lg btn-fill btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v("Novo Cliente")])]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.ticketsRoute}},[(_vm.$can('customers.tickets'))?_c('a',{staticClass:"btn btn-lg btn-fill btn-primary"},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v("Gerar Ticket")]):_vm._e()])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-direction"}),_vm._v(" Dados do evento\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-1 col-xs-12",staticStyle:{"line-height":"2.5em"}},[_c('label',[_vm._v("Evento:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qHx1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qNyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'YesNoRadio',
  props: ['value'],
  computed: {
    randomName: function randomName() {
      return Math.random() * Math.random() * 10000;
    }
  }
});

/***/ }),

/***/ "qQ0T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qQLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/admin"}},[_vm._v("Paper Dashboard PRO")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page lock-page",staticStyle:{"background-image":"url('static/img/background/background-5.png')"},attrs:{"data-color":"green","data-image":"static/img/background/background-5.png"}},[_c('div',{staticClass:"content"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-lock"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}})]),_vm._v(" "),_c('h4',[_vm._v("Chet Faker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter Password"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd",attrs:{"type":"button"}},[_vm._v("Unlock")])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qREe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qTdh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qXFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qYwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersOptions_vue__ = __webpack_require__("y+/Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d0de5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersOptions_vue__ = __webpack_require__("Hfay");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d0de5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qcMG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qePx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h5',[_vm._v("Tags")]),_vm._v(" "),_vm._l((_vm.categories),function(categorie,categorieIndex){return _c('div',{key:categorie._id,staticClass:"form-group",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"row-radio"},[_c('div',{staticClass:"col-radio"},[_c('label',[_vm._v(_vm._s(categorie.name)+": ")])]),_vm._v(" "),_c('div',{staticClass:"col-radio"},[_c('div',{staticClass:"row-radio"},_vm._l((_vm.tagsByCategories[categorie._id]),function(tag,index){return _c('div',{key:tag._id,staticClass:"col-radio"},[_c('div',{staticClass:"row-radio"},[_c('div',{staticClass:"col-radio"},[_c('div',{staticClass:"row-radio row-radio-border"},[_c('div',{staticClass:"col-radio"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":tag},on:{"input":function($event){return _vm.$emit('change', {tag: tag._id, categorie: categorie._id})}}})]),_vm._v(" "),_c('div',{staticClass:"col-radio"},[_vm._v("\n                      "+_vm._s(tag.name)+"\n                    ")])])])])])}),0)])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['website', 'language', 'bootstrapVersion'])),
  data: function data() {
    return {
      model: {
        website: '',
        frameworkType: '',
        language: '',
        bootstrapVersion: '',
        price: ''
      },
      modelValidations: {
        website: {
          url: true,
          required: true
        },
        language: {
          required: true
        },
        bootstrapVersion: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "qh8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_connections__ = __webpack_require__("ZKT5");








var collection = 'projects';
var singleName = 'project';
var pluralName = 'projects';
var connection = 'config';

var Couchdb = new __WEBPACK_IMPORTED_MODULE_5__services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'projects' });

var model = {
  projectName: '',
  projectOnlineRegister: '',
  remoteHost: 'https://couch-trg.3e.eng.br/',
  servername: '',
  name: '',
  eventLabel: '',
  requiredNIS: false,
  useLGPD: false,
  requiredTermLamp: false,
  defaultWinnerChoiceMode: 'lottery',
  haveSurveys: false,
  viewGoogleMap: false,
  companyTerms: '',
  registerCustomerTicketDocument: false,
  dashboardEduCards: false,
  doc: {
    daysToVisit: '04'
  },
  event: {
    hasCeremony: false,
    automaticReplacement: false,
    customersCanBeRecontemplated: false,
    contemplatedPeriod: 5,
    autoDateOnDeliveryTerm: true,
    hasPhotos: false,
    managedCsv: false
  },
  ticket: {
    automaticBarcode: true
  },
  lamps: {
    max: 0,
    numLedLamps: 0,
    hasSeason: false,
    seasonRange: 12,
    powerLampDeliveryLabel: '8,5'
  },
  register: {
    carrer: false
  },
  validationCustomer: {
    uc: false,
    cpf: false,
    ucOrCpf: false
  },
  validationContemplatedCustomer: {
    uc: false,
    cpf: false
  },
  state: '',
  cities: [],
  company: {
    abbreviation: '',
    longname: '',
    cnpj: '',
    numberState: '',
    address: {
      type: '',
      street: '',
      number: '',
      neighborhood: '',
      city: '',
      state: ''
    }
  }
};
var validations = {
  servername: {
    min: 3
  },
  name: {
    min: 5,
    required: true
  },
  requiredTermLamp: {
    required: true
  },
  requiredNIS: {
    required: true
  },
  event: {
    hasCeremony: { required: true },
    automaticReplacement: { required: true },
    customersCanBeRecontemplated: { required: true },
    contemplatedPeriod: { required: true }
  },
  lamps: {
    max: { required: true },
    numLedLamps: { required: true }
  },
  ticket: {
    automaticBarcode: { required: true }
  },
  state: { required: true },
  validationCustomer: {
    uc: { required: true },
    cpf: { required: true }
  },
  validationContemplatedCustomer: {
    uc: { required: true },
    cpf: { required: true }
  }
};
var getters = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["d" /* mapGetters */])(), {
  defaultWinnerChoiceModeOptions: function defaultWinnerChoiceModeOptions() {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
      lottery: 'Sorteio',
      ranking: 'Ranking'
    });
  }
});
getters[singleName] = function (state) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, model, state.one);
};
getters[pluralName] = function (state) {
  return state.all;
};
getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(getters, {
  loading: function loading(state) {
    return state.loading;
  },
  citiesOptions: function citiesOptions(state, getters, rootState) {
    var cities = [];
    var citiesConf = rootState && rootState.config && rootState.config.cities && rootState.config.cities.length > 0 ? rootState.config.cities : state.one && state.one.cities;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(citiesConf), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var city = _step.value;

        cities.push({
          value: city,
          label: city
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return cities;
  },
  validations: function validations(state) {
    return state.validations;
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["a" /* mapStates */])(), {
    model: model,
    loading: true,
    all: [],
    one: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model)),
    validations: validations,
    currentState: '',
    termsByState: {
      AL: ['generic', 'iasc', 'equatorial'],
      CE: ['generic', 'enel'],
      GO: ['generic', 'enel'],
      MA: ['generic', 'cemar', 'iasc'],
      PB: ['generic', 'energisa-borborema', 'energisa-paraiba'],
      PI: ['generic', 'iasc', 'equatorial'],
      PA: ['generic', 'celpa', 'celpa-jurunas']
    },
    urlImages: {
      imgTermLamp: '',
      imgTermLending: '',
      imgTermDelivery: '',
      imgPresenterLeft: '',
      imgPresenterRight: ''
    }
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["b" /* mapMutations */])(), {
    SET_IMAGES_URL: function SET_IMAGES_URL(state, payload) {
      state.urlImages = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(state.urlImages, payload);
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseModule__["c" /* mapActions */])(collection, model, connection), {
    uploadFileProject: function uploadFileProject(context, _ref) {
      var id = _ref.id,
          mimeType = _ref.mimeType,
          name = _ref.name,
          file = _ref.file;

      return Couchdb.insertAttachment(id, {
        mimeType: mimeType,
        attachmentName: name,
        attachment: file
      });
    },
    getImagesProject: function getImagesProject(_ref2) {
      var commit = _ref2.commit;

      var baseURL = __WEBPACK_IMPORTED_MODULE_6__config_connections__["a" /* default */].config.host + '/' + __WEBPACK_IMPORTED_MODULE_6__config_connections__["a" /* default */].config.db + '/config';
      var datetime = new Date().getTime();
      commit('SET_IMAGES_URL', {
        imgTermLamp: baseURL + '/imgTermLamp?' + datetime,
        imgTermLending: baseURL + '/imgTermLending?' + datetime,
        imgTermDelivery: baseURL + '/imgTermDelivery?' + datetime,
        imgPresenterLeft: baseURL + '/imgPresenterLeft?' + datetime,
        imgPresenterRight: baseURL + '/imgPresenterRight?' + datetime
      });

      return {
        imgTermLamp: baseURL + '/imgTermLamp?' + datetime,
        imgTermLending: baseURL + '/imgTermLending?' + datetime,
        imgTermDelivery: baseURL + '/imgTermDelivery?' + datetime,
        imgPresenterLeft: baseURL + '/imgPresenterLeft?' + datetime,
        imgPresenterRight: baseURL + '/imgPresenterRight?' + datetime
      };
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, getters, {
    projectsNames: function projectsNames() {
      return ['', 'efce_', 'efgo_', 'eqal2_', 'eqia_', 'eqma_', 'eqpa_', 'eqpi_', 'mema_', 'nepb_', 'eqal_notiasc_', 'eqma_notiasc_', 'eqpi_notiasc_', 'eqpa_notiasc_', 'celpa_jurunas_'];
    },
    remoteDatabasesNames: function remoteDatabasesNames(state) {
      return {
        'default': 'admin',
        'states': 'municipios',
        'specifications': 'specifications',
        'winners': 'contemplados',
        'docs': 'docs',
        'logs': 'logs',
        'surveys': 'surveys',
        'surveys_docs': 'surveys_docs',
        'config': 'config'
      };
    },
    termsByState: function termsByState(state) {
      return state.termsByState;
    },
    termsOfState: function termsOfState(state) {
      return state.termsByState.hasOwnProperty(state.one.state) ? state.termsByState[state] : state.termsByState;
    },
    currentState: function currentState(state) {
      return state.currentState;
    },
    currentTerms: function currentTerms(state) {
      if (state.one && state.one.state && state.one.state !== '') {
        return state.termsByState.hasOwnProperty(state.one.state) ? state.termsByState[state.one.state] : [];
      }
      return state.termsByState.hasOwnProperty(state.currentState) ? state.termsByState[state.currentState] : [];
    },

    urlImages: function urlImages(state) {
      var baseURL = __WEBPACK_IMPORTED_MODULE_6__config_connections__["a" /* default */].config.host + '/' + __WEBPACK_IMPORTED_MODULE_6__config_connections__["a" /* default */].config.db + '/config';
      return {
        imgTermLamp: baseURL + '/imgTermLamp',
        imgTermLending: baseURL + '/imgTermLending',
        imgTermDelivery: baseURL + '/imgTermDelivery',
        imgPresenterLeft: baseURL + '/imgPresenterLeft',
        imgPresenterRight: baseURL + '/imgPresenterRight'
      };
    },
    sidebarLinks: function sidebarLinks(state) {
      var appLinks = [{
        name: 'Dashboard',
        icon: 'ti-bar-chart',
        children: [{
          name: 'Dashboard',
          path: '/admin/dashboard',
          tag: 'dashboard.overview'
        }]
      }, {
        name: 'Gerenciar',
        icon: 'ti-view-list-alt',
        collapsed: false,
        children: [{
          name: state.one.eventLabel,
          path: '/manage/events',
          tag: 'events.index'
        }, {
          name: 'Especificações: ' + state.one.eventLabel,
          path: '/manage/eventsSpecifications',
          tag: 'eventsSpecifications.index'
        }, {
          name: 'Clientes',
          path: '/manage/customers',
          tag: 'customers.index'
        }, {
          name: 'Tickets',
          path: '/tickets/details',
          tag: 'tickets.details'
        }, {
          name: 'Estoque',
          path: '/manage/stock',
          tag: 'stock.index'
        }, {
          name: 'Relatórios',
          path: '/manage/reports',
          tag: 'reports.index'
        }]
      }, {
        name: 'Configurações',
        icon: 'ti-panel',
        collapsed: true,
        children: [{
          name: 'Usuários',
          path: '/configurations/users',
          tag: 'users.index'
        }, {
          name: 'Perfis',
          path: '/configurations/roles',
          tag: 'roles.index'
        }, {
          name: 'Projeto',
          path: '/configurations/project',
          tag: 'project.index'
        }, {
          name: 'Fabricantes',
          path: '/configurations/manufacturers',
          tag: 'manufacturers.index'
        }, {
          name: 'Categorias',
          path: '/categories',
          tag: 'categories.index'
        }, {
          name: 'Tags',
          path: '/configurations/tags',
          tag: 'tags.index'
        }, {
          name: 'API',
          path: '/configurations/api',
          tag: 'api.index'
        }]
      }];
      var themeLinks = [{
        name: 'Dashboard',
        icon: 'ti-panel',
        children: [{
          name: 'Overview',
          path: '/admin/overview'
        }, {
          name: 'Stats',
          path: '/admin/stats'
        }]
      }, {
        name: 'Components',
        icon: 'ti-package',
        children: [{
          name: 'Buttons',
          path: '/components/buttons'
        }, {
          name: 'Grid System',
          path: '/components/grid-system'
        }, {
          name: 'Panels',
          path: '/components/panels'
        }, {
          name: 'Sweet Alert',
          path: '/components/sweet-alert'
        }, {
          name: 'Notifications',
          path: '/components/notifications'
        }, {
          name: 'Icons',
          path: '/components/icons'
        }, {
          name: 'Typography',
          path: '/components/typography'
        }]
      }, {
        name: 'Forms',
        icon: 'ti-clipboard',
        children: [{
          name: 'Regular Forms',
          path: '/forms/regular'
        }, {
          name: 'Extended Forms',
          path: '/forms/extended'
        }, {
          name: 'Validation Forms',
          path: '/forms/validation'
        }, {
          name: 'Wizard',
          path: '/forms/wizard'
        }]
      }, {
        name: 'Table List',
        icon: 'ti-view-list-alt',
        collapsed: true,
        children: [{
          name: 'Regular Tables',
          path: '/table-list/regular'
        }, {
          name: 'Extended Tables',
          path: '/table-list/extended'
        }, {
          name: 'Paginated Tables',
          path: '/table-list/paginated'
        }]
      }, {
        name: 'Maps',
        icon: 'ti-map',
        children: [{
          name: 'Google Maps',
          path: '/maps/google'
        }, {
          name: 'Full Screen Maps',
          path: '/maps/full-screen'
        }, {
          name: 'Vector Maps',
          path: '/maps/vector-map'
        }]
      }, {
        name: 'Charts',
        icon: 'ti-gift',
        path: '/charts'
      }, {
        name: 'Calendar',
        icon: 'ti-calendar',
        path: '/calendar'
      }, {
        name: 'Pages',
        icon: 'ti-gift',
        children: [{
          name: 'User Page',
          path: '/pages/user'
        }, {
          name: 'Timeline Page',
          path: '/pages/timeline'
        }, {
          name: 'Login Page',
          path: '/login'
        }, {
          name: 'Register Page',
          path: '/register'
        }, {
          name: 'Lock Page',
          path: '/lock'
        }]
      }];
      var includeThemeLinks = false;
      if (includeThemeLinks) {
        appLinks = appLinks.concat(themeLinks);
      }
      return appLinks;
    },
    eventLabel: function eventLabel(state) {
      return state.one.eventLabel;
    }
  })
});

/***/ }),

/***/ "qjBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("24 Hours Performance")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartPerformance"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("NASDAQ: AAPL")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart with Points")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartStock"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Views")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bar Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartViews"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Activity")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Multiple Bars Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartActivity"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qnkm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qoDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.rankingLoading),expression:"rankingLoading"}]},[_c('router-link',{attrs:{"to":{name: 'events.details', params: {id: _vm.event._id}}}},[(_vm.$can('events.details'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-info btn-block btn-router"},[_vm._v("\n      Ver detalhes do evento\n    ")]):_vm._e()]),_vm._v(" "),(_vm.$can('ranking.create'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block btn-router",attrs:{"disabled":_vm.rankingLoading || _vm.event.drawn || _vm.minimumSurveys || _vm.event.status === 2 || !this.tickets.length},on:{"click":_vm.runMakeRanking}},[_vm._v("\n    Gerar Ranking\n  ")]):_vm._e(),_vm._v(" "),(_vm.event.drawn && _vm.$can('ranking.print.winners'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-default btn-block btn-router",on:{"click":function($event){return _vm.printWinnerList()}}},[_vm._v("\n    Imprimir lista de ganhadores\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qr0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tickets-index"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('customer-card',{attrs:{"customer":_vm.customer},on:{"editAdditionalData":function($event){return _vm.enableEditAdditionalData($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('customer-image-card',{attrs:{"timestamp-image":_vm.currentTimestamp,"customer":_vm.customer,"hasImage":_vm.hasImage},on:{"editImage":function($event){return _vm.enableEditImage()}}})],1)]),_vm._v(" "),(!_vm.hasAdditionalData)?_c('div',{staticClass:"col-md-12"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showAdditionalDataForm)?_c('additional-data-form',{attrs:{"customer":_vm.customer},on:{"on-save":function($event){return _vm.additionalDataSaved($event)}}}):_vm._e(),_vm._v(" "),(_vm.showImageCapture && !this.config.useLGPD)?_c('customer-image-capture',{on:{"on-image-captured":function($event){return _vm.handleImageSave($event)}}}):_vm._e(),_vm._v(" "),_c('ticket-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.enableForm),expression:"enableForm"}],attrs:{"tickets":_vm.tickets,"customer":_vm.customer,"winnerLoaded":_vm.winnerLoaded},on:{"on-ticket-create":function($event){return _vm.handleFetchTickets()}}}),_vm._v(" "),_c('tickets-list',{attrs:{"tickets":_vm.tickets,"customers":_vm.customers,"loading":_vm.loading,"scope":"customer"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right",staticStyle:{"margin-bottom":"20px"}},[_c('router-link',{attrs:{"to":{name: 'customers.create'}}},[_c('button',{staticClass:"btn btn-lg btn-fill btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v("\n          Novo Cliente\n        ")])]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.lampsRoute}},[(_vm.$can('customers.lamps'))?_c('a',{staticClass:"btn btn-lg btn-fill btn-success"},[_c('i',{staticClass:"fa fa-lightbulb-o"}),_vm._v(" Trocar Lâmpadas ")]):_vm._e()])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('span',[_c('b',[_vm._v("Atenção!")]),_vm._v(" Preencha os campos abaixo para gerar um novo ticket.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qsZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.view.presenter'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block btn-router",on:{"click":function($event){return _vm.clickOpenPresenter()}}},[_vm._v("\n  Abrir apresentador\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qzb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saving: false,
      indexPath: { name: 'manufacturers.index' },
      entityName: 'Fabricante'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['name', 'informativeText']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('manufacturers', {
    model: 'manufacturer',
    modelValidations: 'validations',
    loading: 'loading'
  }), {
    id: function id() {
      return this.$route.params.id;
    },
    editing: function editing() {
      return this.id !== undefined;
    },
    title: function title() {
      return this.editing ? 'Editar ' + this.entityName : 'Novo ' + this.entityName;
    }
  }),
  created: function created() {
    if (this.editing) {
      this.fetchOne(this.id);
    } else {
      this.resetOne();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('manufacturers', ['fetchOne', 'resetOne', 'insert', 'update']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.model);
          doc.collection = 'manufacturers';
          if (_this.editing) {
            _this.update(doc).then(function (result) {
              _this.saving = false;
              _this.$notify({
                message: 'Registro editado com sucesso.',
                type: 'success'
              });
              _this.$router.push(_this.indexPath);
            }).catch(function (err) {
              _this.saving = false;
              console.log(err);
            });
          } else {
            _this.insert(doc).then(function (result) {
              _this.saving = false;
              _this.$notify({
                message: 'Registro criado com sucesso.',
                type: 'success'
              });
              _this.$router.push(_this.indexPath);
            }).catch(function (err) {
              _this.saving = false;
              console.log(err);
            });
          }
        }
      }).catch(function (err) {
        _this.saving = false;
        console.log(err);
      });
    }
  })
});

/***/ }),

/***/ "r+uQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__ = __webpack_require__("Dlhx");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'participation-term-go',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      numCities: 4,
      numFamilies: '600 mil',
      finance: '7 milhões',
      birthplace: 'maranhense',
      deliverDate: 'Amanhã é o grande dia',

      company: 'ENEL',
      shortname: 'ENEL-GO',
      address: 'Rua 2, Quadra A-37, 505 – Jardim Goiás, Goiânia/GO',
      cpnj: '01.543.032/0001-04',
      stateRegistration: '06.105.848-3',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    };
  },

  computed: {
    datetimeDelivery: function datetimeDelivery() {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe';
    },
    timeEndDelivery: function timeEndDelivery() {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas';
    }
  },
  filters: {
    uppercase: function uppercase(value) {
      if (!value) {
        return '';
      }
      value = value.toString();
      return value.toUpperCase();
    }
  }
});

/***/ }),

/***/ "r1X7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__ = __webpack_require__("6ULa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d375938c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__ = __webpack_require__("bUeU");
function injectStyle (ssrContext) {
  __webpack_require__("+Y4W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d375938c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d375938c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermIasc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r2+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{attrs:{"method":"#","action":"#"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("Submit")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('p-checkbox',{staticClass:"col-md-9"},[_vm._v("Remember me")])],1)]),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Checkboxes and radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.first),callback:function ($$v) {_vm.$set(_vm.checkboxes, "first", $$v)},expression:"checkboxes.first"}},[_vm._v("First checkbox")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.second),callback:function ($$v) {_vm.$set(_vm.checkboxes, "second", $$v)},expression:"checkboxes.second"}},[_vm._v("Second checkbox")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("First Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("Second Radio")])],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Inline checkboxes")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.a),callback:function ($$v) {_vm.$set(_vm.checkboxes, "a", $$v)},expression:"checkboxes.a"}},[_vm._v("a")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.b),callback:function ($$v) {_vm.$set(_vm.checkboxes, "b", $$v)},expression:"checkboxes.b"}},[_vm._v("b")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.c),callback:function ($$v) {_vm.$set(_vm.checkboxes, "c", $$v)},expression:"checkboxes.c"}},[_vm._v("c")])],1)])]),_vm._v(" "),_c('fieldset',[_c('legend',[_vm._v("Input Variants")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Custom Checkboxes & radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-sm-offset-1"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.unchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "unchecked", $$v)},expression:"checkboxes.unchecked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.checked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "checked", $$v)},expression:"checkboxes.checked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledUnchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledUnchecked", $$v)},expression:"checkboxes.disabledUnchecked"}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledChecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledChecked", $$v)},expression:"checkboxes.disabledChecked"}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is on")])],1)])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Stacked Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Horizontal Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("\n                Sign in\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Form Elements")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("With help")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("A block of help text that breaks onto a new line.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","name":"password"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Placeholder")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"placeholder"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Disabled")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Disabled input here...","disabled":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Static control")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p',{staticClass:"form-control-static"},[_vm._v("hello@creative-tim.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-success"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with success")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Success"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-error"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with error")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Error"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Column sizing")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-3"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-4"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-5"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input groups")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("@")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Username"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Textarea")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Here can be your nice text","rows":"3"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r9Gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterConfigForm_vue__ = __webpack_require__("jk0e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c49b7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterConfigForm_vue__ = __webpack_require__("eul6");
function injectStyle (ssrContext) {
  __webpack_require__("zd6K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c49b7fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterConfigForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c49b7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterConfigForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rFJE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHIH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDownloadDocuments_vue__ = __webpack_require__("B3Om");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae50a8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDownloadDocuments_vue__ = __webpack_require__("yq1H");
function injectStyle (ssrContext) {
  __webpack_require__("9C0w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae50a8a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDownloadDocuments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae50a8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDownloadDocuments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rP9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("v98p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__ = __webpack_require__("4qt1");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "rSFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataForm_vue__ = __webpack_require__("zSxd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3df9fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataForm_vue__ = __webpack_require__("HLGp");
function injectStyle (ssrContext) {
  __webpack_require__("q4VT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalDataForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3df9fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalDataForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rSI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetWinnerFalse_vue__ = __webpack_require__("+oqb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b51f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetWinnerFalse_vue__ = __webpack_require__("mxiX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetWinnerFalse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b51f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetWinnerFalse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rY/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveConfigurationsDuplicated_vue__ = __webpack_require__("WSlu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40199026_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveConfigurationsDuplicated_vue__ = __webpack_require__("yTPC");
function injectStyle (ssrContext) {
  __webpack_require__("y5Wn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40199026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveConfigurationsDuplicated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40199026_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveConfigurationsDuplicated_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "raQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('EventsOptions',{on:{"eventSelected":function (event) { return (_vm.eventSelectedId = event); }}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"disabled":_vm.eventSelectedId === '',"title":"Este botão remove tudo relacionado a um evento"},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Remover tudo relacionado ao evento, menos os clientes.\n  ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceDelete),expression:"forceDelete"}],attrs:{"id":"checkbox-force-delete-event","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.forceDelete)?_vm._i(_vm.forceDelete,null)>-1:(_vm.forceDelete)},on:{"change":function($event){var $$a=_vm.forceDelete,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.forceDelete=$$a.concat([$$v]))}else{$$i>-1&&(_vm.forceDelete=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.forceDelete=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"checkbox-force-delete-event"}},[_vm._v("Forçar a remoção permanentemente")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rchf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventLocalMap',

  props: {
    specGps: {
      required: false
    }
  },

  watch: {
    specGps: function specGps() {
      if (this.specGps) {
        this.gps = {
          lat: this.specGps.lat,
          lng: this.specGps.lng
        };
        this.marker = this.gps;
      } else {
        this.getLocationState();
      }
    }
  },

  data: function data() {
    return {
      show: false,
      defaultZoom: 10,
      mapPlace: null,
      marker: {
        lat: 0,
        lng: 0
      },
      place: '',
      city: '',
      neighborhood: '',
      gps: {
        lat: 0,
        lng: 0
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', ['project'])),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), {
    myGoogle: function myGoogle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__["gmapApi"])();
    },
    center: function center() {
      if (this.myGoogle) {
        this.getLocationState();
        return this.marker;
      }
      return {
        lat: 1,
        lng: 1
      };
    },
    getLocationState: function getLocationState() {
      var _this = this;

      if (typeof window.google === 'undefined') {
        return this.waitToCall();
      }
      var geocoder = new window.google.maps.Geocoder();
      return geocoder.geocode({ 'address': this.project.state + ', Brasil' }, function (result, status) {
        if (status === 'OK') {
          _this.marker = {
            lat: result[0].geometry.location.lat(),
            lng: result[0].geometry.location.lng()
          };
          _this.gps = _this.marker;
        }
      }, function (err) {
        return console.log('err, geocode', err);
      });
    },
    setPlace: function setPlace(place) {
      console.log('place');
      this.place = place.formatted_address;
      this.defineAddressComponents();
      this.marker.lat = place.geometry.location.lat();
      this.marker.lng = place.geometry.location.lng();
      this.gps = this.marker;
      this.defaultZoom = 10;
      this.$emit('changeGps', this.gps);
    },
    setMarkerByClick: function setMarkerByClick(marker) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var geocoder, location;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('setmarkerbyclick');

                if (!(typeof window.google === 'undefined')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', _this2.waitToCall());

              case 3:
                geocoder = new window.google.maps.Geocoder();
                location = marker.latLng;
                _context.next = 7;
                return geocoder.geocode({ location: location }, function (result, status) {
                  if (status === 'OK') {
                    _this2.marker.lat = result[0].geometry.location.lat();
                    _this2.marker.lng = result[0].geometry.location.lng();
                    _this2.gps = _this2.marker;
                    _this2.$emit('changeGps', _this2.gps);
                    _this2.place = result[0].formatted_address;
                  }
                }, function (err) {
                  return console.log(err);
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    defineAddressComponents: function defineAddressComponents() {
      if (!this.place.hasOwnProperty('address_components')) {
        return;
      }
      this.neighborhood = '-';
      this.city = '-';
      for (var placeI in this.place.address_components) {
        if (this.place.address_components[placeI].types[0] === 'sublocality_level_1') {
          this.neighborhood = this.place.address_components[placeI].long_name;
        }
        if (this.place.address_components[placeI].types[0] === 'administrative_area_level_2') {
          this.city = this.place.address_components[placeI].long_name;
        }
      }
    },
    waitToCall: function waitToCall() {
      var _this3 = this;

      setTimeout(function () {
        _this3.getLocationState();
      }, 1000);
    }
  }),
  mounted: function mounted() {
    this.fetchProject('config');
  }
});

/***/ }),

/***/ "rcmJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rdXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  obfuscateString: function obfuscateString(str) {
    if (typeof str === 'string') {
      var strObfuscado = str.substring(0, 3) + '***********' + str.substring(str.length - 3, str.length);

      return strObfuscado;
    }

    return '';
  },
  hideCustomerData: function hideCustomerData(customer) {
    var holder = customer.holder;

    var holderOfuscado = this.obfuscateString(holder);

    var customerObfuscated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customer, {
      holder: holderOfuscado
    });

    return customerObfuscated;
  },
  removeCustomerSensitiveData: function removeCustomerSensitiveData(customer) {
    var customerLGPD = this.hideCustomerData(customer);
    var _id = customerLGPD._id,
        _rev = customerLGPD._rev,
        holder = customerLGPD.holder,
        uc = customerLGPD.uc,
        contemplated = customerLGPD.contemplated,
        collection = customerLGPD.collection,
        createdAt = customerLGPD.createdAt,
        cadastroOnline = customerLGPD.cadastroOnline;

    var customerObfuscated = {
      _id: _id,
      _rev: _rev,
      uc: uc,
      holder: holder,
      contemplated: contemplated,
      collection: collection,
      cadastroOnline: cadastroOnline,
      createdAt: createdAt,
      updatedAt: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY/MM/DD hh:mm:ss')
    };

    return customerObfuscated;
  }
});

/***/ }),

/***/ "ribu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__ = __webpack_require__("/ZBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__ = __webpack_require__("H2oj");
function injectStyle (ssrContext) {
  __webpack_require__("d8qD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rjFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rlIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnelCe_vue__ = __webpack_require__("+3Uf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd9153a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnelCe_vue__ = __webpack_require__("iAbS");
function injectStyle (ssrContext) {
  __webpack_require__("8CMD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd9153a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTermEnelCe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd9153a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTermEnelCe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rtMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONFIRMAÇÃO")]),_vm._v(" "),_c('th',[_vm._v("ENTR. GELAD. VELHA")]),_vm._v(" "),_c('th',[_vm._v("DOCUCMENTAÇÃO")]),_vm._v(" "),_c('th',[_vm._v("ENTR. GELAD. NOVA")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ryiV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6O8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseModule__ = __webpack_require__("tv5d");







var collection = 'tags';
var singleName = 'InputTag.vue';
var pluralName = 'tags';
var connection = 'config';

var model = {
  name: '',
  categorieId: '',
  color: ''
};

var validations = {
  name: {
    required: true,
    min: 1
  },
  categorieId: {
    required: true
  }
};

var getters = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["d" /* mapGetters */])());
getters[singleName] = function (state) {
  return state.one;
};
getters[pluralName] = function (state) {
  return state.all;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    selecteds: [],
    one: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0,
    textTagsFilters: ''
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["b" /* mapMutations */])(), {
    setSelecteds: function setSelecteds(state, payload) {
      var tags = {};
      for (var categorie in payload) {
        if (payload[categorie].length === 0) continue;
        tags[categorie] = payload[categorie];
      }
      state.selecteds = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tags));
    },
    SET_TEXT_TAGS_FILTERS: function SET_TEXT_TAGS_FILTERS(state, payload) {
      state.textTagsFilters = payload;
    }
  }),
  actions: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseModule__["c" /* mapActions */])(collection, model, connection), {
    setTagsDashboard: function setTagsDashboard(context, _ref) {
      var payload = _ref.payload,
          tags = _ref.tags;

      context.commit('setSelecteds', payload);
      context.dispatch('setTextFilters', {
        payload: payload,
        tags: tags
      });
    },
    setTextFilters: function setTextFilters(context, _ref2) {
      var payload = _ref2.payload,
          tags = _ref2.tags;

      try {
        if (!payload || !tags) {
          return;
        }

        var tagsFilter = {};

        for (var categorie in payload) {
          if (payload[categorie].length === 0) {
            continue;
          }
          if (!tagsFilter.hasOwnProperty(categorie)) {
            tagsFilter[categorie] = [];
          }

          var _loop = function _loop(tagId) {
            var tag = tags.find(function (item) {
              return item._id === tagId;
            });
            if (tag) {
              tagsFilter[categorie].push(tag.name);
            }
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(payload[categorie]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var tagId = _step.value;

              _loop(tagId);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        var text = '';
        var keysTagsFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagsFilter);
        var ammountCategories = keysTagsFilter.length;
        for (var iterator = 0; iterator < ammountCategories; iterator++) {
          var _categorie = keysTagsFilter[iterator];
          text += '(' + tagsFilter[_categorie].join(' ou ') + ')';
          if (iterator < ammountCategories - 1) {
            text += ' e ';
          }
        }

        context.commit('SET_TEXT_TAGS_FILTERS', text);
        return text;
      } catch (e) {
        console.log(e);
      }
    }
  }),
  getters: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, getters, {
    loading: function loading(state) {
      return state.loading;
    },
    validations: function validations(state) {
      return state.validations;
    },
    count: function count(state) {
      return state.count;
    },
    selecteds: function selecteds(state) {
      return state.selecteds;
    },
    selectedsIds: function selectedsIds(state) {
      var ids = [];
      for (var c in state.selecteds) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.selecteds[c]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            ids.push(id);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return ids;
    },
    textTagsFilters: function textTagsFilters(state) {
      return state.textTagsFilters;
    },
    tagsByCategories: function tagsByCategories(state) {
      return state.all.reduce(function (accumulator, current) {
        if (!accumulator.hasOwnProperty(current.categorieId)) accumulator[current.categorieId] = [];
        accumulator[current.categorieId].push(current);
        return accumulator;
      }, {});
    }
  })
});

/***/ }),

/***/ "s6Sl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sABW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.$can('surveys.associate'))?_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-lg-8 col-xs-12"},[_c('users-options',{attrs:{"ativos":"true","label":"Usuário: "},on:{"setUser":function($event){return _vm.$emit('setUser', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:" col-lg-4 col-xs-12"},[_c('button',{staticClass:"btn btn-wide btn-fill btn-primary",attrs:{"disabled":!_vm.enableAssociate},on:{"click":function($event){return _vm.$emit('runAssociateAll')}}},[_vm._v("\n              Associar\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("Pesquisar:")]),_vm._v(" "),_vm._l((_vm.event.surveysType),function(type,index){return _c('span',{key:index},[_vm._v("\n                  "+_vm._s(_vm.surveysOptions[type])+_vm._s(index < _vm.event.surveysType.length ? ',' : '.')+"\n              ")])})],2)])]),_vm._v(" "),(_vm.$can('surveys.associated.tickets.print'))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-wide btn-fill btn-info",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.printList()}}},[_vm._v("\n              Abrir lista de clientes associados\n            ")])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-list"}),_vm._v(" Ações")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sBKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-print-all-tickets',

  props: {
    eligibleNotWinners: {
      default: false
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  })),

  methods: {
    handleClick: function handleClick() {
      var routeData = this.$router.resolve({
        name: 'all.tickets.documents.print',
        params: {
          id: this.event._id,
          eligibleNotWinners: this.eligibleNotWinners
        }
      });
      window.open(routeData.href, 'documentsWindow', 'menubar=false,location=false,resizable=false,scrollbars=1,status=false');
    }
  }
});

/***/ }),

/***/ "sDpG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sE9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eventIdSelected: '',
      loading: false,
      progress: 0,
      total: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('events', {
    events: 'sortedByReference'
  }), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', { fetchTickets: 'fetchAll', upsertTickets: 'updateMany', updateMany: 'updateMany' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('events', { findEvent: 'fetchOne', upsertEvent: 'upsert' }), {
    handleRemoverRanking: function handleRemoverRanking() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.checkValid();

              case 2:
                valid = _context.sent;

                if (valid) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this.notifyFailure());

              case 7:
                _this.loading = true;
                _this.total = 0;
                _this.fetchTickets({ where: { eventId: _this.eventIdSelected }, limit: 9999999 }).then(function (docs) {
                  return _this.removeRanking(docs);
                }).catch(function (err) {
                  console.log('failed fetch ticket', err);
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkValid: function checkValid() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.findEvent(_this2.eventIdSelected);

              case 2:
                event = _context2.sent;

                console.log(event.hasSortTRG_889);
                return _context2.abrupt('return', event.hasSortTRG_889 ? event.hasSortTRG_889 : false);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeRanking: function removeRanking(docs) {
      var _this3 = this;

      docs = docs.map(function (item) {
        item.winner = false;
        delete item.rankingNow;
        delete item.rankingOriginal;
        return item;
      });
      this.total = docs.length + 1;
      if (docs.length === 0) {
        this.notifyRankingRemoval(docs);
      } else {
        this.askConfirmation(docs).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(valid) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!valid) {
                      _context3.next = 3;
                      break;
                    }

                    _context3.next = 3;
                    return _this3.removeWinners(docs);

                  case 3:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this3);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    removeWinners: function removeWinners(docs) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.findEvent(_this4.eventIdSelected);

              case 2:
                event = _context4.sent;

                event.drawn = false;
                docs.push(event);
                _context4.prev = 5;
                _context4.next = 8;
                return _this4.updateMany(docs);

              case 8:
                _this4.notifyFinish();
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                console.log(_context4.t0);
                _this4.notifyFailure(_context4.t0);

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[5, 11]]);
      }))();
    },
    notifyRankingRemoval: function notifyRankingRemoval(docs) {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Existem ' + docs.length + ' com ranking.',
        text: 'Todos os tickets est\xE3o sem ranking.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    askConfirmation: function askConfirmation(docs) {
      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Existem ' + docs.length + ' com ranking.',
        html: 'Voc\xEA quer remover ranking de todos os tickets?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, faça isso!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      var _this5 = this;

      this.loading = false;
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      }).then(function () {
        _this5.notifyEventUpdated();
      });
    },
    notifyEventUpdated: function notifyEventUpdated() {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        width: 1000,
        title: 'Foi removido ranking do evento.',
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      });
    },
    notifyFailure: function notifyFailure(err) {
      this.loading = false;

      return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        width: 1000,
        title: 'Ocorreu um erro ao executar essa ação.',
        text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "sFCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDetails_vue__ = __webpack_require__("QpYL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450d8821_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDetails_vue__ = __webpack_require__("/YW1");
function injectStyle (ssrContext) {
  __webpack_require__("zFT3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-450d8821"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450d8821_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f9ae83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("8HRS");
function injectStyle (ssrContext) {
  __webpack_require__("gBnQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f9ae83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sSe4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sTXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__);











__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first'
    };
  }
});

/***/ }),

/***/ "sW+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsConfigForm_vue__ = __webpack_require__("djyE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa51118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsConfigForm_vue__ = __webpack_require__("m5aZ");
function injectStyle (ssrContext) {
  __webpack_require__("3Xfj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faa51118"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsConfigForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa51118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsConfigForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sbDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("Z450");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("+WI1");
function injectStyle (ssrContext) {
  __webpack_require__("gP6t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "shfF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTag_vue__ = __webpack_require__("uW4N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb2b74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTag_vue__ = __webpack_require__("OeQI");
function injectStyle (ssrContext) {
  __webpack_require__("9OEy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb2b74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sk0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RadioColors"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cor")]),_vm._v(" "),_c('div',{staticClass:"row-radio"},_vm._l((_vm.colors),function(cor){return _c('div',{staticClass:"col-radio container"},[_c('button',{staticClass:"radioColor",class:[cor, _vm.color === cor ? 'selected' : '' ],on:{"click":function($event){$event.preventDefault();return _vm.setColor(cor)}}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sk1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "slvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.multiple)?_c('el-select',{staticClass:"select-default col-xs-12",attrs:{"multiple":"","name":"eventId","size":"large","placeholder":"Selecione os eventos"},on:{"change":function($event){return _vm.$emit('eventSelected', _vm.eventId)}},model:{value:(_vm.eventId),callback:function ($$v) {_vm.eventId=$$v},expression:"eventId"}},_vm._l((_vm.events),function(option){return _c('el-option',{key:option.label,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventId),expression:"eventId"}],staticClass:"events-options form-control",attrs:{"name":"eventId"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eventId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.$emit('eventSelected', _vm.eventId)}]}},[_c('option',{attrs:{"value":""}},[_vm._v(" Selecione um evento...")]),_vm._v(" "),_vm._l((_vm.events),function(event,index){return _c('option',{key:index,domProps:{"value":event.value}},[_vm._v(" "+_vm._s(event.label)+"\n    ")])})],2),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "soD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LampsForm"},[(_vm.lamps.length < this.lampsLeft)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._m(0),_vm._v(" "),_c('small',[_vm._v("Quantidade de lâmpadas no estoque: "+_vm._s(this.stock - this.countEventLamps)+" - "+_vm._s(this.countEventLamps)+" / "+_vm._s(this.stock))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.power),expression:"modelValidations.power"},{name:"model",rawName:"v-model",value:(_vm.model.power),expression:"model.power"}],staticClass:"form-control",attrs:{"name":"power"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "power", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","disabled":""}},[_vm._v("Selecione ...\n                ")]),_vm._v(" "),_vm._l((_vm.options.power),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n                ")])})],2)]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.type),expression:"modelValidations.type"},{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selecione ...\n                ")]),_vm._v(" "),_vm._l((_vm.options.type),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n                ")])})],2)]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.room),expression:"modelValidations.room"},{name:"model",rawName:"v-model",value:(_vm.model.room),expression:"model.room"}],staticClass:"form-control",attrs:{"name":"room"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "room", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selecione ...\n                ")]),_vm._v(" "),_vm._l((_vm.options.room),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n                ")])})],2)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.usageHoursPerDay),expression:"modelValidations.usageHoursPerDay"},{name:"model",rawName:"v-model",value:(_vm.model.usageHoursPerDay),expression:"model.usageHoursPerDay"}],staticClass:"form-control",attrs:{"type":"number","name":"usageHoursPerDay","min":"1","max":"24"},domProps:{"value":(_vm.model.usageHoursPerDay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "usageHoursPerDay", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('p-switch',{attrs:{"type":"primary","on-text":"Sim","off-text":"Não"},model:{value:(_vm.model.rushHour),callback:function ($$v) {_vm.$set(_vm.model, "rushHour", $$v)},expression:"model.rushHour"}})],1)]),_vm._v(" "),_c('tr',{staticClass:"helpers-table"},[_c('td',[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.power.invalid),expression:"power.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('power'))+"\n              ")])]),_vm._v(" "),_c('td',[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('type'))+"\n              ")])]),_vm._v(" "),_c('td',[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.room.invalid),expression:"room.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('room'))+"\n              ")])]),_vm._v(" "),_c('td',[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.usageHoursPerDay.invalid),expression:"usageHoursPerDay.invalid"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('usageHoursPerDay'))+"\n              ")])]),_vm._v(" "),_c('td')])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"button","disabled":_vm.stock <= 0 && _vm.lampsLeft >= _vm.lamps.length},on:{"click":function($event){$event.preventDefault();return _vm.handleAdd($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Adicionar\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.showResumeTable)?_c('div',{staticClass:"card"},[(_vm.showResumeTable)?_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-light-bulb"}),_vm._v(" Lâmpadas Adicionadas("+_vm._s(_vm.lamps.length)+")\n      ")])]):_vm._e(),_vm._v(" "),(_vm.showResumeTable)?_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.lamps}},[_c('el-table-column',{attrs:{"label":"Potência","property":"power"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.power)+"W")]}}],null,false,3111341630)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tipo de Lâmpada Recebida","property":"type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Cômodo","property":"room"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hora em Uso por Dia","property":"usageHoursPerDay"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"btn btn-danger btn-fill btn-icon remove",on:{"click":function($event){return _vm.handleRemove(props.$index, props.row)}}},[_c('i',{staticClass:"ti-trash"})])])]}}],null,false,2338366319)})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.showResumeTable)?_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 text-left"},[(_vm.event.hasOwnProperty('lamp') && _vm.event.lamp.requiredTermLamp)?_c('action-term-lamps',{attrs:{"event":_vm.event,"customer":_vm.customer,"lamps":_vm.lamps,"eventId":_vm.eventId},on:{"upload-file":function($event){return _vm.emitUploadFile($event)}}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.saving),expression:"saving"}],staticClass:"col-xs-6 text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.eventId === '' || _vm.saving,"type":"submit"},on:{"click":_vm.handleSave}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n\n          ")])])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-light-bulb"}),_vm._v(" Trocar Nova Lâmpada\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_c('label',{staticClass:"control-label"},[_vm._v("Potência")])]),_vm._v(" "),_c('th',[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de Lâmpada Recebida")])]),_vm._v(" "),_c('th',[_c('label',{staticClass:"control-label"},[_vm._v("Cômodo")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"12em"}},[_c('label',{staticClass:"control-label"},[_vm._v("Hora em Uso por Dia")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"14em"}},[_c('label',{staticClass:"control-label"},[_vm._v("Esta lâmpada foi utilizada em horário de pico?")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ssah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyAttachments_vue__ = __webpack_require__("eLih");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b02638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyAttachments_vue__ = __webpack_require__("Hpci");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyAttachments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b02638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyAttachments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sv1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__couchdbIndexManager__ = __webpack_require__("oj1o");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__couchdbIndexManager__["a"]; });


/***/ }),

/***/ "t+Cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CompanyInfoForm',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    project: {
      get: function get() {
        return this.$store.state.project.one;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('states', ['cities']))
});

/***/ }),

/***/ "t/OO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListReserves_vue__ = __webpack_require__("8Sj3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7ce298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListReserves_vue__ = __webpack_require__("G8lb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListReserves_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7ce298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListReserves_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t0aP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['name', 'informativeText']
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('manufacturers', {
    tableData: 'manufacturers',
    count: 'count',
    loading: 'loading'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.count;
      return this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),
  mounted: function mounted() {
    this.fetch();
  },

  watch: {
    currentPage: function currentPage(_currentPage) {
      this.fetch();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('manufacturers', ['fetchAll', 'delete']), {
    fetch: function fetch() {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search
      });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetch();
    },
    handleSort: function handleSort(sort) {
      this.fetch();
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this.delete(row._id).then(function (result) {
          _this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this.fetch();
        }).catch(function (err) {
          return console.log(err);
        });
      });
    }
  })
});

/***/ }),

/***/ "tBIA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tDgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'check-valid-online-register',

  props: {
    ticket: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isWinnerTrgOlder: false,
      allTickets: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  }), {

    events: {
      get: function get() {
        return this.$store.state.events.all.reduce(function (acc, curr, indx) {
          if (indx === 0) {
            acc = {};
          }
          acc[curr._id] = curr;
          return acc;
        }, {});
      }
    },

    event: function event() {
      return this.events[this.ticket.eventId] ? this.events[this.ticket.eventId] : this.$store.state.events.one;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('tickets', ['upsertWithView', 'getTicketsByEvent', 'getTicketsByCustomer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('tickets', { fetchTickets: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('events', { findEvent: 'fetchOne' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('customers', { fetchCustomer: 'fetchOne' }), {
    onClick: function onClick() {
      var _this = this;

      this.checkOldWinner().then(function (results) {
        var promises = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var event = _step.value;

            promises.push(_this.findEvent(event.eventId));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (promises.length === 0) {
          return _this.checkTicket().then(function () {
            _this.getTickets();
          });
        }

        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all(promises).then(function (events) {
          var lastDateWinner = _this.$moment(new Date(Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(events.map(function (event) {
            return new Date(event.dateTimeCeremony);
          })))));
          var today = _this.$moment();
          var isContemplated = lastDateWinner.add(_this.config.event.contemplatedPeriod, 'years');

          if (today.diff(isContemplated, 'years') >= 0) {
            _this.checkTicket();
          } else {
            var validate = { valid: false };
            var doc = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.ticket, validate);
            doc.reasonNotEligible = 'Já foi contemplado anteriormente.';

            _this.upsertWithView({
              find: {
                ddoc: 'tickets-by-id',
                view: 'tickets-by-id',
                key: doc._id
              },
              payload: doc
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
                title: '',
                text: 'Cliente j\xE1 contemplado anteriormente.',
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              });
            }).catch(function (err) {
              console.log(err);
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
                title: '',
                text: 'Ocorreu um problema ao validar ticket.',
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              });
            });
          }
        });

        _this.getTickets();
      });
    },
    checkOldWinner: function checkOldWinner() {
      var doc = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.ticket);
      return this.fetchTickets({
        select: ['eventId'],
        where: { customerId: doc.customerId, winner: true },
        limit: 99999
      }).then(function (results) {
        return results;
      });
    },
    checkTicket: function checkTicket() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var validate, doc, customer;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validate = {
                  valid: !_this2.ticket.valid,
                  eligible: !_this2.ticket.valid
                };
                doc = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this2.ticket, validate);
                _context.next = 4;
                return _this2.fetchCustomer(doc.customerId);

              case 4:
                customer = _context.sent;

                if (doc.valid && (doc.barcode === null || doc.barcode === undefined || doc.barcode === '')) {
                  doc.barcode = '' + customer.uc + __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.random(10000000, 99999999);
                  delete doc.reasonNotEligible;
                } else {
                  doc.reasonNotEligible = 'Não foi validado por um atendente.';
                  delete doc.barcode;
                }
                return _context.abrupt('return', _this2.upsertWithView({
                  find: {
                    ddoc: 'tickets-by-id',
                    view: 'tickets-by-id',
                    key: doc._id
                  },
                  payload: doc
                }).then(function () {
                  var options = {
                    message: 'Ticket validado com sucesso.',
                    type: 'success'
                  };

                  if (!doc.valid) {
                    options.message = 'Ticket invalidado com sucesso.';
                  }

                  _this2.getTickets().then(function () {
                    _this2.$notify(options);
                  });
                }).catch(function (err) {
                  console.log(err);
                  __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
                    title: '',
                    text: 'Ocorreu um problema ao validar ticket.',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  });
                }));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getTickets: function getTickets() {
      if (this.type === 'customer') {
        return this.getTicketsByCustomer(this.ticket.customerId);
      } else if (this.type === 'event') {
        return this.getTicketsByEvent(this.ticket.eventId);
      }
    }
  })
});

/***/ }),

/***/ "tGJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoContentGmap_vue__ = __webpack_require__("5Zy/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dba75070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoContentGmap_vue__ = __webpack_require__("8JKo");
function injectStyle (ssrContext) {
  __webpack_require__("+FyI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dba75070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoContentGmap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dba75070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoContentGmap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tGkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RankingListWinners__ = __webpack_require__("5bN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RankingListReserves__ = __webpack_require__("t/OO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RankingListAbsent__ = __webpack_require__("xmkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-list',

  props: {
    tickets: {
      required: true
    },

    surveys: {
      required: true
    },

    ticketsLoading: {
      required: true
    }
  },

  components: {
    RankingListWinners: __WEBPACK_IMPORTED_MODULE_3__RankingListWinners__["a" /* default */],
    RankingListReserves: __WEBPACK_IMPORTED_MODULE_4__RankingListReserves__["a" /* default */],
    RankingListAbsent: __WEBPACK_IMPORTED_MODULE_5__RankingListAbsent__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('events', {
    event: 'event'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('tickets', {
    ticketLoading: 'loading'
  }), {
    ticketsWinners: function ticketsWinners() {
      return this.tickets.filter(function (ticketFilter) {
        return ticketFilter.eligible && ticketFilter.winner;
      }).sort(function (a, b) {
        return a.rankingNow - b.rankingNow;
      });
    },
    ticketsReserves: function ticketsReserves() {
      return this.tickets.filter(function (ticketFilter) {
        return ticketFilter.eligible && !ticketFilter.winner && !ticketFilter.hasOwnProperty('absentAt');
      }).sort(function (a, b) {
        return a.rankingNow - b.rankingNow;
      });
    },
    ticketsClosed: function ticketsClosed() {
      return this.tickets.filter(function (ticketFilter) {
        return ticketFilter.eligible && !ticketFilter.winner && ticketFilter.hasOwnProperty('absentAt');
      });
    },
    newWinner: function newWinner() {
      return this.ticketsReserves.reduce(function (accum, current, index) {
        return accum && accum.rankingNow < current.rankingNow ? accum : current;
      }, {});
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tickets', { ticketCancel: 'ticketCancel' }), {
    cancelTicket: function cancelTicket(ticketId) {
      var ticketOut = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.tickets.find(function (ticketFind) {
        return ticketFind._id === ticketId;
      }));

      var ticketIn = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.ticketsReserves.reduce(function (accum, current, index) {
        return accum && accum.rankingNow < current.rankingNow ? accum : current;
      }, {}));

      var logTicketOut = { old: ticketOut };
      ticketOut.checkIn = false;
      ticketOut.energyMetering = false;
      ticketOut.winner = false;
      ticketOut.absentAt = new Date();

      logTicketOut.new = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, ticketOut);

      var logTicketIn = { old: ticketIn };
      ticketIn.winner = true;

      var ticketsNewWinners = this.recreateRanking(ticketIn, ticketOut);
      var remainingTicketsReserved = this.getRemainingSortedTicketsReserved();

      var logs = this.getLoggers(logTicketOut, logTicketIn, ticketsNewWinners);

      this.ticketCancel({
        tickets: [ticketOut].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ticketsNewWinners), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(remainingTicketsReserved)),
        logs: logs
      });
    },
    recreateRanking: function recreateRanking(ticketIn, ticketOut) {
      var ticketsNewWinners = this.ticketsWinners;
      ticketsNewWinners.push(ticketIn);

      return this.ticketsWinners.filter(function (item) {
        return item._id !== ticketOut._id;
      }).sort(function (a, b) {
        return a.rankingNow - b.rankingNow;
      }).map(function (ticket, index) {
        ticket.rankingNow = index + 1;
        return ticket;
      });
    },
    getLoggers: function getLoggers(logTicketOut, logTicketIn, ticketsNewWinners) {
      var _this = this;

      var logWinners = ticketsNewWinners.map(function (newTicket) {
        var oldTicket = _this.ticketsWinners.find(function (oldTicketWinner) {
          return oldTicketWinner._id === newTicket._id;
        });

        if (!oldTicket && logTicketIn.old._id === newTicket._id) {
          oldTicket = logTicketIn.old;
        }

        return {
          old: oldTicket,
          new: newTicket
        };
      });

      return [logTicketOut].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(logWinners));
    },
    getRemainingSortedTicketsReserved: function getRemainingSortedTicketsReserved() {
      var _this2 = this;

      return this.ticketsReserves.filter(function (reserved) {
        return reserved._id !== _this2.newWinner._id;
      }).sort(function (a, b) {
        return a.rankingNow - b.rankingNow;
      }).map(function (ticket, index) {
        ticket.rankingNow = index + parseInt(_this2.event.numberOfRefigerators) + 1;
        return ticket;
      });
    }
  })
});

/***/ }),

/***/ "tIWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.url),expression:"modelValidations.url"},{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"text","name":"url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.token),expression:"modelValidations.token"},{name:"model",rawName:"v-model",value:(_vm.model.token),expression:"model.token"}],staticClass:"form-control",attrs:{"type":"text","name":"token"},domProps:{"value":(_vm.model.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "token", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-bottom":"30px"}},[(_vm.$can('project.edit|projectCreate'))?_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.saving,"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.handleSave($event)}}},[_c('i',{staticClass:"ti-save"}),_vm._v(" Salvar\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Configurações API")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_c('strong',[_vm._v("URL")]),_vm._v(" do Projeto")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_c('strong',[_vm._v("Token")]),_vm._v(" de autenticação do Projeto")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tNaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsIndex_vue__ = __webpack_require__("wgiE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7ff67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsIndex_vue__ = __webpack_require__("6Jf6");
function injectStyle (ssrContext) {
  __webpack_require__("N/TY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7ff67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tP3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocTicketRegister_vue__ = __webpack_require__("UyF3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4880b6db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocTicketRegister_vue__ = __webpack_require__("0Hx9");
function injectStyle (ssrContext) {
  __webpack_require__("23/3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4880b6db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocTicketRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4880b6db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocTicketRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tP8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"participation-term",staticStyle:{"margin":"0.1cm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-4"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)\n        "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.ticket.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.ticket.customer.address.street)+", "+_vm._s(_vm.ticket.customer.address.number)+", "+_vm._s(_vm.ticket.customer.address.complement)+" - "+_vm._s(_vm.ticket.customer.address.neighborhood)+" - "+_vm._s(_vm.ticket.customer.address.zip)+", na cidade de "+_vm._s(_vm.ticket.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.ticket.customer.uc)+", CPF n.o "+_vm._s(_vm.ticket.customer.cpf)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Você esta participando do projeto "+_vm._s(_vm.projectName)+". O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.abbreviation)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.abbreviation)+" ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.abbreviation)+", o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia em Eficiência Energética")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.abbreviation)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.abbreviation)+";\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Perderá o beneficio, caso seja contemplado, se não comparecer no dia "+_vm._s(_vm.datetimeDelivery)+_vm._s(_vm.timeEndDelivery)+" com a sua geladeira antiga em funcionamento;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela "+_vm._s(_vm.abbreviation)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.abbreviation)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do \""+_vm._s(_vm.projectName)+"\" cancelados;\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.ticket.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v(", "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.ticket.customer}}),_vm._v(" "),_vm._m(1)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('th',[_vm._v("CONF")]),_vm._v(" "),_c('th',[_vm._v("EGV")]),_vm._v(" "),_c('th',[_vm._v("DOC")]),_vm._v(" "),_c('th',[_vm._v("EGN")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tXqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btn-csv-winners',

  props: {
    eligibleNotWinners: {
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tickets', {
    ticketsWinners: 'winners',
    elegibleNotWinner: 'elegibleNotWinner'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  })),

  methods: {
    handleClick: function handleClick() {
      if (this.eligibleNotWinners) {
        var customers = this.elegibleNotWinner.slice(0, 20);
        this.csvExport(customers);
      } else {
        this.csvExport(this.ticketsWinners);
      }
    },
    csvExport: function csvExport(tickets) {
      var customers = [];

      for (var id in tickets) {
        customers.push({
          uc: this.customers[tickets[id].customerId].uc,
          nome: this.customers[tickets[id].customerId].holder,
          cpf: this.customers[tickets[id].customerId].cpf,
          confirmado: ''
        });
      };

      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(customers[0]).join(';')].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(customers.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(item).join(';');
      }))).join('\n').replace(/(^\[)|(\]$)/gm, '');

      var data = encodeURI(csvContent);
      var fileName = this.eligibleNotWinners ? 'Reservas' : 'Ganhadores';
      __WEBPACK_IMPORTED_MODULE_4_downloadjs___default()(data, fileName, 'text/csv');
    }
  }
});

/***/ }),

/***/ "tecN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-search',
  props: {
    placeholder: {
      type: String,
      default: 'Pesquisar ...'
    },
    clearInput: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      query: '',
      queried: false
    };
  },

  computed: {
    iconClass: function iconClass() {
      return {
        'fa fa-search': !this.queried,
        'fa fa-close': this.queried
      };
    }
  },
  methods: {
    handleQuery: function handleQuery(event) {
      if (this.queried === true) {
        if (event.type !== 'keyup') {
          this.query = '';
          this.queried = false;
        }
        this.$emit('on-search', this.query);
      } else {
        this.$emit('on-search', this.query);
        this.queried = true;
      }
      if (this.clearInput) {
        this.query = '';
      }
    }
  }
});

/***/ }),

/***/ "th4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckValidOnlineRegister_vue__ = __webpack_require__("tDgC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5047db08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckValidOnlineRegister_vue__ = __webpack_require__("CtiB");
function injectStyle (ssrContext) {
  __webpack_require__("lTQr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5047db08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckValidOnlineRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5047db08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckValidOnlineRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tlmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password', 'confirm'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        },
        confirmPassword: {
          required: true,
          confirmed: 'password'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "toKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-view-detail"},[(_vm.hasRefrigerator)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Fabricante")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.manufacturer))]),_vm._v(" "),_c('dt',[_vm._v("Anos de uso")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.yearsUse))]),_vm._v(" "),_c('dt',[_vm._v("Número de série")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.sealingNumber))]),_vm._v(" "),_c('dt',[_vm._v("Nota")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.score))]),_vm._v(" "),_c('dt',[_vm._v("Carcaça")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.body))]),_vm._v(" "),_c('dt',[_vm._v("Serpentina")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.coil))]),_vm._v(" "),_c('dt',[_vm._v("Compartimentos")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.compartments))]),_vm._v(" "),_c('dt',[_vm._v("Portas")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.doors))]),_vm._v(" "),_c('dt',[_vm._v("Motor")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.engine))]),_vm._v(" "),_c('dt',[_vm._v("Borracha")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.survey.data.refrigerator.rubber))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tokM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'count-cards',
  components: { StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */] },
  props: {
    input: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      eventsEDUCount: null,
      speechesEDUCount: null,
      isLoadingEventsEDUCount: true,
      isLoadingSpeechesEDUCount: true
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    projectOnline: function projectOnline() {
      return true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    edu: 'apiEdu'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', {
    config: 'project'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('tags', {
    tags: 'selecteds'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    dateRange: 'rangeDate'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('surveys', {
    loadingSurveys: 'loading',
    surveysFinishedCount: 'dashboardCounter'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('events', {
    eventsCount: 'events',
    isLoadingEventsCount: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('lamps', {
    lampsCount: 'dashboardCounter',
    isLoadingLampsCount: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('tickets', {
    winnersCount: 'winningTickets',
    isLoadingWinnersCount: 'winningLoading',
    ticketsCount: 'dashboardCounter',
    isLoadingTicketsCount: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', {
    isLoadingCustomersCount: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', {
    participantsCount: 'dashboardCounter'
  }), {

    inputDate: function inputDate() {
      return this.input || null;
    }
  }),

  mounted: function mounted() {
    this.fetchTicketsCount();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('events', ['fetchTicketsCount', 'filterEvents']))
});

/***/ }),

/***/ "tv5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapGetters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__ = __webpack_require__("enEw");








var _this = this;



var Couchdb = void 0;

function payloadSettings(Couchdb, payload) {
  if (payload.hasOwnProperty('limit')) {
    Couchdb.limit(payload.limit);
  }
  if (payload.hasOwnProperty('skip')) {
    Couchdb.skip(payload.skip);
  }
  if (payload.hasOwnProperty('sort')) {
    Couchdb.sort(payload.sort);
  }
  if (payload.hasOwnProperty('search')) {
    Couchdb.search(payload.search);
  }
  if (payload.hasOwnProperty('where')) {
    if (payload.where instanceof Array) {
      payload.where.map(function (item) {
        for (var key in item) {
          Couchdb.where(key, item[key]);
        }
      });
    } else {
      for (var key in payload.where) {
        Couchdb.where(key, payload.where[key]);
      }
    }
  }
  if (payload.hasOwnProperty('select')) {
    Couchdb.select(payload.select);
  }
  if (payload.hasOwnProperty('trash')) {
    if (payload.trash) {
      Couchdb.withTrash();
    } else {
      Couchdb.noTrash();
    }
  }
  return Couchdb;
}

var mapStates = function mapStates() {
  return {
    model: {},
    total: 0,
    dashboardCounter: 0,
    loading: false,
    all: [],
    db: ''
  };
};

var mapGetters = function mapGetters() {
  return {
    loading: function loading(state) {
      return state.loading;
    },
    total: function total(state) {
      return state.total;
    },
    dashboardCounter: function dashboardCounter(state) {
      return state.dashboardCounter;
    },
    modelById: function modelById(state) {
      return state.all.reduce(function (acc, curr) {
        acc[curr._id] = curr;
        return acc;
      }, {});
    },
    db: function db(state) {
      return state.db;
    }
  };
};

var mapMutations = function mapMutations() {
  return {
    UPDATE_DEFAULT_MODEL: function UPDATE_DEFAULT_MODEL(state, payload) {
      for (var field in payload) {
        if (!state.hasOwnProperty('model')) {
          state.model = {};
        }
        if (state.model.hasOwnProperty(field)) {
          state.model[field] = payload[field];
        }
      }
    },
    setAll: function setAll(state, payload) {
      state.all = payload;
    },
    setObjectAll: function setObjectAll(state, payload) {
      state.objAll = payload;
    },
    setOne: function setOne(state, payload) {
      state.one = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, state.model, payload);
    },
    changeLoading: function changeLoading(state, payload) {
      state.loading = payload;
    },
    setCount: function setCount(state, payload) {
      state.count = payload;
    },
    SET_TOTAL: function SET_TOTAL(state, payload) {
      state.total = payload;
    },
    updateState: function updateState(state, payload) {
      state.one = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, state.one, payload);
    },
    SET_DASHBOARD_COUNTER: function SET_DASHBOARD_COUNTER(state, payload) {
      state.dashboardCounter = payload;
    },
    SET_DATABASE: function SET_DATABASE(state, db) {
      state.db = db;
    }
  };
};

var mapActions = function mapActions(collection, model, connection) {
  var Couchdb = new __WEBPACK_IMPORTED_MODULE_7_src_services_CouchdbClass__["a" /* default */]({
    connection: connection || 'default',
    collection: collection || ''
  });

  return {
    getDatabase: function getDatabase(_ref) {
      var commit = _ref.commit;

      console.log(Couchdb.getFullConnection());
      commit('SET_DATABASE', Couchdb.getFullConnection());
      return Couchdb.getFullConnection();
    },
    changeLoading: function changeLoading(_ref2, payload) {
      var commit = _ref2.commit;

      commit('changeLoading', payload);
    },
    updateDefaultModel: function updateDefaultModel(_ref3, payload) {
      var commit = _ref3.commit;

      commit('UPDATE_DEFAULT_MODEL', payload);
    },


    insertLogs: function insertLogs(context, logs) {
      Couchdb.connection('logs').collection('logs')._insertBuckLogs(logs);
    },

    updateMany: function updateMany(context, payload) {
      return Couchdb._updateBulkDocs(payload.map(function (item) {
        item.updatedAt = new Date();
        return item;
      }));
    },

    insertMany: function insertMany(context, payload) {
      return Couchdb._postBulkDocs(payload.map(function (item) {
        if (!item.hasOwnProperty('createdAt')) {
          item.createdAt = new Date();
        }
        item.updatedAt = new Date();
        return item;
      }));
    },

    setStateAll: function setStateAll(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setAll', payload);
    },
    setStateOne: function setStateOne(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setOne', payload);
    },
    setStateObjectAll: function setStateObjectAll(_ref6, payload) {
      var commit = _ref6.commit;

      commit('setObjectAll', payload);
    },

    fetchAll: function fetchAll(context, payload) {
      payload = payload === undefined ? {} : payload;
      payload.stateMutations = {
        all: 'setAll'
      };
      return context.dispatch('_all', payload);
    },

    fetchCount: function fetchCount(context, payload) {
      payload = payload === undefined ? {} : payload;
      context.commit('changeLoading', true);
      payload['select'] = ['_id'];
      Couchdb = payloadSettings(Couchdb, payload);
      return Couchdb.all().then(function (result) {
        context.commit('changeLoading', false);
        context.commit('SET_TOTAL', result.length);
        return result.length;
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
      });
    },

    fetchViewAll: function fetchViewAll(context, payload) {
      context.commit('changeLoading', true);
      payload = payload === undefined ? {} : payload;
      return Couchdb.view(payload.ddoc, payload.view, payload.key, payload.options).then(function (response) {
        if (payload.hasOwnProperty('options') && payload.options.hasOwnProperty('include_docs') && payload.options.include_docs) {
          context.commit('setAll', response.rows.map(function (item) {
            return item.doc;
          }));
        } else {
          context.commit('setAll', response.rows.map(function (item) {
            return item.value;
          }));
        }
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        context.commit('changeLoading', false);
      });
    },

    fetchIds: function fetchIds(context, _ref7) {
      var connection = _ref7.connection,
          ids = _ref7.ids;

      context.commit('changeLoading', true);
      return Couchdb.connection(connection || 'default')._bulkGet(ids).then(function (res) {
        context.commit('setAll', res);
        context.commit('changeLoading', false);
        return res;
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
        return err;
      });
    },

    _all: function _all(context, payload) {
      payload = payload === undefined ? {} : payload;
      context.commit('changeLoading', true);
      Couchdb = payloadSettings(Couchdb, payload);
      return Couchdb.all().then(function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var withPromises, resultWiths, all;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (payload.hasOwnProperty('with')) {
                    _context.next = 4;
                    break;
                  }

                  if (!payload.noCommit) {
                    context.commit(payload.stateMutations.all, result);
                  }
                  context.commit('changeLoading', false);
                  return _context.abrupt('return', result);

                case 4:
                  withPromises = helpers.getWithPromises(result, payload);
                  _context.next = 7;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(withPromises);

                case 7:
                  resultWiths = _context.sent;
                  all = helpers.bindWiths(result, resultWiths, payload);

                  if (!payload.noCommit) {
                    context.commit(payload.stateMutations.all, all);
                  }
                  context.commit('changeLoading', false);
                  return _context.abrupt('return', all);

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref8.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
      });
    },

    count: function count(context, payload) {
      context.dispatch('_count', payload);
    },
    _count: function _count(context, payload) {
      payload = payload === undefined ? {} : payload;
      context.commit('changeLoading', true);
      if (payload.hasOwnProperty('where')) {
        payload.where.map(function (item) {
          var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item);
          Couchdb.where(key[0], item[key]);
        });
      }
      if (payload.search) {
        Couchdb.search(payload.search);
      }
      Couchdb.collection(collection).count().then(function (result) {
        context.commit('changeLoading', false);
        context.commit(payload.stateMutations.count, result);
      }).catch(function (err) {
        console.log(err);
        context.commit('changeLoading', false);
      });
    },

    countAllReduce: function countAllReduce(context, payload) {
      var queries = [{
        start_key: [collection],
        end_key: [collection, {}],
        reduce: true,
        group_level: 1,
        skip: 0
      }];
      return Couchdb._view({
        ddoc: 'counter-collection-created_at',
        view: 'counter-collection-created_at',
        params: { queries: queries }
      }).then(function (response) {
        context.commit('setCount', response.rows[0].value);
      });
    },

    countByKeyView: function countByKeyView(context, _ref9) {
      var key = _ref9.key,
          ddoc = _ref9.ddoc,
          view = _ref9.view,
          commit = _ref9.commit;

      var queries = [{
        keys: [key],
        reduce: true,
        group: true,
        skip: 0
      }];
      return Couchdb._view({
        ddoc: ddoc,
        view: view,
        params: { queries: queries }
      }).then(function (response) {
        var value = response.hasOwnProperty('rows') && response.rows.length > 0 ? response.rows[0].value : 0;
        if (commit) {
          context.commit(commit, value);
        }
        return value;
      });
    },

    countByViewBetween: function countByViewBetween(context, _ref10) {
      var start_key = _ref10.start_key,
          end_key = _ref10.end_key,
          ddoc = _ref10.ddoc,
          view = _ref10.view,
          commit = _ref10.commit;

      var queries = [{
        start_key: start_key,
        end_key: end_key,
        reduce: true,
        group_level: 1,
        skip: 0
      }];
      return Couchdb._view({
        ddoc: ddoc,
        view: view,
        params: { queries: queries }
      }).then(function (response) {
        if (commit) {
          context.commit(commit, response.rows[0].value);
        }
        return response.rows[0].value;
      });
    },

    fetchOne: function fetchOne(context, payload, notCommit) {
      context.commit('changeLoading', true);
      var docId = payload instanceof Object ? payload.docId : payload;
      Couchdb = payloadSettings(Couchdb, payload);
      return Couchdb.collection(collection).find(docId).then(function (one) {
        if (!one) {
          return false;
        }
        if (payload.hasOwnProperty('with')) {
          var result = [one];
          var withPromises = helpers.getWithPromises(result, payload);
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(withPromises).then(function (resultWiths) {
            helpers.bindWiths(result, resultWiths, payload).then(function (all) {
              if (!notCommit) {
                context.commit('setOne', all[0]);
              }
              context.commit('changeLoading', false);
              return all[0];
            });
          });
        } else {
          if (!notCommit) {
            context.commit('setOne', one);
          }
          context.commit('changeLoading', false);
          return one;
        }
      }).catch(function (err) {
        console.log(err);
        if (!notCommit) {
          context.commit('setOne', {});
        }
        context.commit('changeLoading', false);
        return err;
      });
    },

    fetchViewOne: function fetchViewOne(context, _ref11) {
      var ddoc = _ref11.ddoc,
          view = _ref11.view,
          key = _ref11.key,
          options = _ref11.options,
          notCommit = _ref11.notCommit;

      context.commit('changeLoading', true);
      return Couchdb.view(ddoc, view, key, options).then(function (response) {
        var result = response.rows.map(function (item) {
          return item.value;
        }).reduce(function (acc, curr) {
          return curr;
        }, {});
        if (!notCommit) {
          context.commit('setOne', result);
        }
        return result;
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        context.commit('changeLoading', false);
      });
    },

    resetOne: function resetOne(context) {
      context.commit('setOne', JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(model)));
    },

    resetAll: function resetAll(_ref12) {
      var commit = _ref12.commit;

      commit('setAll', []);
    },

    insert: function insert(_ref13, payload) {
      var state = _ref13.state,
          commit = _ref13.commit,
          rootState = _ref13.rootState;

      payload.userId = rootState.user._id;
      return Couchdb.collection(collection).insert(payload);
    },

    insertAttachment: function insertAttachment(context, _ref14) {
      var docId = _ref14.docId,
          doc = _ref14.doc;

      return Couchdb.insertAttachment(docId, doc);
    },

    update: function update(state, payload) {
      return Couchdb.collection(collection).update(payload._id, payload);
    },

    upset: function upset(state, payload) {
      return Couchdb.collection(collection).upset(payload._id, payload);
    },

    upsert: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(state, payload, database) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', Couchdb.upsert(payload._id, payload, database));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function upsert(_x2, _x3, _x4) {
        return _ref15.apply(this, arguments);
      };
    }(),

    delete: function _delete(context, docId) {
      return Couchdb.collection(collection).delete(docId);
    },

    updateState: function updateState(_ref16, payload) {
      var commit = _ref16.commit;

      if ((typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(payload)) === 'object') {
        commit('updateState', payload);
      }
    },

    updateWithView: function updateWithView(context, payload) {
      return Couchdb.updateWithView(payload);
    },

    insertAll: function insertAll(context, docs) {
      return Couchdb.collection(collection)._insertBulk(docs);
    },

    updateAll: function updateAll(context, docs) {
      return Couchdb.collection(collection)._updateBulkDocs(docs);
    },
    findMany: function findMany(context, _ref17) {
      var keys = _ref17.keys,
          commit = _ref17.commit;

      return Couchdb.findMany(keys).then(function (result) {
        if (commit === false) {
          return result;
        }
        context.commit('setAll', result);
        return result;
      });
    },

    upsertWithView: function upsertWithView(context, _ref18) {
      var find = _ref18.find,
          payload = _ref18.payload;

      return Couchdb.upsertWithView(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, find, { payload: payload }));
    }
  };
};

var helpers = {
  getWithPromises: function getWithPromises(result, payload) {
    var conn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

    var withPromises = [];
    for (var key in payload.with) {
      if (payload.with.hasOwnProperty(key)) {
        (function () {
          var item = payload.with[key];
          var keys = result.map(function (row) {
            return row[item.localKey];
          }).filter(function (key) {
            return key !== null && key !== undefined;
          });
          withPromises.push(Couchdb.collection(item.collection).whereIn(item.foreignKey, keys).all());
        })();
      }
    }
    return withPromises;
  },
  bindWiths: function bindWiths(result, resultWiths, payload) {
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var i = 0;

      var _loop = function _loop(key) {
        var item = payload.with[key];
        result.map(function (row) {
          row[key] = resultWiths[i].find(function (obj) {
            return obj[item.foreignKey] === row[item.localKey];
          });
        });
        i++;
      };

      for (var key in payload.with) {
        _loop(key);
      }
      resolve(result);
    });
  }
};



/***/ }),

/***/ "ty5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnelGo_vue__ = __webpack_require__("r+uQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e738dea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnelGo_vue__ = __webpack_require__("/GdS");
function injectStyle (ssrContext) {
  __webpack_require__("KDiF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e738dea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermEnelGo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e738dea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermEnelGo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tyLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Events_EventDetail_vue__ = __webpack_require__("Jxjg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Events_Events__ = __webpack_require__("buCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Events_EventsForm_vue__ = __webpack_require__("1D+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_Events_EventsIndex_vue__ = __webpack_require__("tNaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_Actions_TicketsDocumentation__ = __webpack_require__("kAE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketsDetails__ = __webpack_require__("sFCf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_pages_Ranking_RankingIndex__ = __webpack_require__("3O11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_pages_Surveys_SurveysIndex__ = __webpack_require__("cjJV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_pages_Surveys_SurveyView__ = __webpack_require__("TtUQ");










var path = 'events';
var title = localStorage.getItem('eventLabel') || 'Ações';
/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Events_Events__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_3_src_pages_Events_EventsIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'audit/:id',
    name: path + '.audit',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "N+r+"));
    },
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Events_EventsForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Events_EventsForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'details/:id',
    name: path + '.details',
    component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Events_EventDetail_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'tickets/:id/documentation',
    name: 'tickets.documentation',
    component: __WEBPACK_IMPORTED_MODULE_4_src_pages_Tickets_Actions_TicketsDocumentation__["a" /* default */],
    meta: {
      title: 'Documentação do Ticket',
      requireAuth: true
    }
  }, {
    path: '/tickets/details/:id?',
    name: 'tickets.details',
    component: __WEBPACK_IMPORTED_MODULE_5_src_pages_Tickets_TicketsDetails__["a" /* default */],
    meta: {
      title: 'Detalhes do Ticket',
      requireAuth: true
    }
  }, {
    path: ':id/surveys',
    name: 'surveys.index',
    component: __WEBPACK_IMPORTED_MODULE_7_src_pages_Surveys_SurveysIndex__["a" /* default */],
    meta: {
      title: 'Pesquisas',
      requireAuth: true
    }
  }, {
    path: ':id/surveys/:customerId',
    name: 'surveys.view',
    component: __WEBPACK_IMPORTED_MODULE_8_src_pages_Surveys_SurveyView__["a" /* default */],
    meta: {
      title: 'Pesquisas',
      requireAuth: true
    }
  }, {
    path: ':id/ranking',
    name: 'ranking.index',
    component: __WEBPACK_IMPORTED_MODULE_6_src_pages_Ranking_RankingIndex__["a" /* default */],
    meta: {
      title: 'Ranking',
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "uAJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uB1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.$can('events.print.terms') && this.event.status !== 2))?_c('button',{staticClass:"btn btn-fill btn-wd btn-default btn-block btn-router",on:{"click":function($event){return _vm.handleDocumentsPrint()}}},[_vm._v("\n  Imprimir Protocolos de Entrega\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uClJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactivateUserAction_vue__ = __webpack_require__("EXfU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e38a56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReactivateUserAction_vue__ = __webpack_require__("4AOG");
function injectStyle (ssrContext) {
  __webpack_require__("qREe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90e38a56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactivateUserAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e38a56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReactivateUserAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0b907e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("8Grh");
function injectStyle (ssrContext) {
  __webpack_require__("bplT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0b907e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uOOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please tell us more about yourself.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          First Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"},{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"ex: Mike"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('firstName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"},{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"ex: Andrew"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uPAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Trg_EventsSpecifications_FormIconTags__ = __webpack_require__("OWjp");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexEventsSpecifications',
  components: {
    FormIconTags: __WEBPACK_IMPORTED_MODULE_2__components_Trg_EventsSpecifications_FormIconTags__["a" /* default */]
  },
  data: function data() {
    return {
      totalSpecifications: 0,
      search: '',
      currentPage: 1,
      pagination: {
        perPage: 40,
        currentPage: 1,
        total: 0
      }
    };
  },

  watch: {
    currentPage: function currentPage(_currentPage) {
      if (this.search.length > 0) {
        this.fetchAll({
          'search': { query: this.search, fields: ['event.reference'] },
          limit: this.pagination.perPage,
          skip: this.from,
          sort: {
            field: 'createdAt',
            direction: 'desc'
          }
        });
      } else {
        this.fetchAll({
          limit: this.pagination.perPage,
          skip: this.from,
          sort: {
            field: 'createdAt',
            direction: 'desc'
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('tags', ['tagsByCategories']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('eventsSpecifications', {
    eventsSpecifications: 'eventsSpecifications',
    loading: 'loading'
  }), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.totalSpecifications;
      return this.totalSpecifications;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('eventsSpecifications', ['fetchAll', 'fetchCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tags', { fetchTags: 'fetchAll' }), {
    handleSearch: function handleSearch(e) {
      var _this = this;

      this.search = e;
      this.fetchAll({
        'search': { query: e, fields: ['event.reference'] },
        limit: this.pagination.perPage,
        skip: this.from,
        sort: {
          field: 'createdAt',
          direction: 'desc'
        }
      });
      this.fetchCount({
        'search': { query: e, fields: ['event.reference'] },
        limit: 99999
      }).then(function (count) {
        _this.totalSpecifications = count;
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.fetchTags({ limit: 8888 }).then(function () {
      _this2.fetchAll({
        limit: _this2.pagination.perPage,
        skip: _this2.from,
        sort: {
          field: 'createdAt',
          direction: 'desc'
        }
      });
    });
    this.fetchCount({ limit: 9999 }).then(function (count) {
      _this2.totalSpecifications = count;
    });
  }
});

/***/ }),

/***/ "uS7Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uSbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerImageCard_vue__ = __webpack_require__("udrA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb7397a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerImageCard_vue__ = __webpack_require__("o+wQ");
function injectStyle (ssrContext) {
  __webpack_require__("65F3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerImageCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb7397a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerImageCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uW4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tag',
  props: ['name']
});

/***/ }),

/***/ "ua4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseModule__ = __webpack_require__("tv5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_DashboardCounter_js__ = __webpack_require__("fzNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_vuex_store__ = __webpack_require__("YtJ0");








var collection = 'surveys';
var connection = 'surveys';

var model = {
  ticketId: null,
  customerId: null,
  customer: null,
  userId: null,
  user: null,
  survey: null
};

var validations = {
  ticketId: { required: true },
  customerId: { required: true },
  customer: { required: true },
  userId: { required: true },
  user: { required: true },
  survey: { required: false }
};

var getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["d" /* mapGetters */])()), {
  surveys: function surveys(state) {
    return state.all;
  },
  survey: function survey(state) {
    return state.one;
  },
  loading: function loading(state) {
    return state.loading;
  },
  validations: function validations(state) {
    return state.validations;
  },
  surveyValid: function surveyValid(state) {
    return state.all.filter(function (survey) {
      return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && survey.data.accepted && survey.data.accepted !== 'false';
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations,
    count: 0
  }),

  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["b" /* mapMutations */])(), {

    setCount: function setCount(state, payload) {
      state.count = payload;
    }
  }),

  actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["c" /* mapActions */])(collection, model, connection), {
    associateSurveys: function associateSurveys(_ref, surveys) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('changeLoading', true);
        var oldSurveys = __WEBPACK_IMPORTED_MODULE_6_src_vuex_store__["a" /* default */].state.surveys.all;
        var logSurveys = [];
        var tickets = [];

        surveys = surveys.map(function (newSurvey) {
          var old = oldSurveys.find(function (surveyOld) {
            return surveyOld.ticketId === newSurvey.ticketId && surveyOld.surveyType === newSurvey.surveyType;
          });

          if (old) {
            logSurveys.push({
              old: old,
              new: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, newSurvey)
            });
            newSurvey._id = old._id;
            newSurvey._rev = old._rev;
            newSurvey.updatedAt = new Date();
          } else {
            newSurvey.createdAt = new Date();
          }

          var ticket = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, newSurvey.ticket);
          ticket.surveyAssociated = true;
          delete ticket.event;
          delete ticket.customer;
          delete ticket.stock;
          tickets.push(ticket);

          delete newSurvey.ticket;
          return newSurvey;
        });
        console.log('survey to save', surveys);
        return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('surveys').collection('surveys')._postBulkDocs(surveys).then(function (res) {
          dispatch('tickets/setSurveyAssociated', { tickets: tickets }, { root: true });
          dispatch('fetchViewAll', {
            ddoc: 'surveys-by-event',
            view: 'surveys-by-event',
            key: surveys[0].event._id
          });

          if (logSurveys.length > 0) {
            dispatch('insertLogs', logSurveys);
          }
          resolve(true);
        }).catch(function (err) {
          console.log(err);
          resolve(false);
        }).finally(function () {
          commit('changeLoading', false);
        });
      });
    },
    cleanSurvey: function cleanSurvey(_ref2, survey) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('changeLoading', true);
        var doc = {
          _id: survey._id,
          ticketId: survey.ticketId,
          customer: survey.customer,
          data: {},
          status: 'TODO',
          user: survey.user,
          event: survey.event,
          userId: survey.userId,
          surveyType: survey.surveyType,
          createdAt: survey.createdAt,
          collection: survey.collection
        };

        __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].collection('surveys')._update(doc._id, doc, 'surveys').then(function (res) {
          dispatch('fetchViewAll', {
            ddoc: 'surveys-by-event',
            view: 'surveys-by-event',
            key: survey.event._id
          });
          resolve(true);
        }).catch(function (err) {
          console.log(err);
          resolve(false);
        }).finally(function () {
          return commit('changeLoading', false);
        });
      });
    },
    counterSurveys: function counterSurveys(_ref3) {
      var commit = _ref3.commit;

      commit('changeLoading', true);
      __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].connection('surveys').collection('surveys').viewReduce('counters-surveys-by-status', 'counters-surveys-by-status').then(function (res) {
        var finished = res.rows.find(function (item) {
          return item.key === 'finished';
        });
        var todo = res.rows.find(function (item) {
          return item.key === 'todo';
        });
        commit('setCount', {
          finished: finished ? finished.value : 0,
          todo: todo ? todo.value : 0
        });
      }).finally(function () {
        return commit('changeLoading', false);
      });
    },
    dashboardSurveysByFilter: function dashboardSurveysByFilter(_ref4, _ref5) {
      var commit = _ref4.commit;
      var eventsId = _ref5.eventsId,
          dateRange = _ref5.dateRange;

      commit('changeLoading', true);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_services_DashboardCounter_js__["c" /* dashboardSurveysCounter */])(eventsId, dateRange).then(function (result) {
        console.log(result);
        commit('SET_DASHBOARD_COUNTER', result);
        commit('changeLoading', false);
        return result;
      }).catch(function (err) {
        commit('changeLoading', false);
        console.log(err);
        return err;
      });
    }
  }),
  getters: getters
});

/***/ }),

/***/ "udAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetDocumentedAtNullDeleteDoc_vue__ = __webpack_require__("Miey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e72545_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetDocumentedAtNullDeleteDoc_vue__ = __webpack_require__("RcoD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetDocumentedAtNullDeleteDoc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e72545_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetDocumentedAtNullDeleteDoc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "udrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomerImageCard',
  props: {
    customer: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true,
      type: Boolean
    },
    timestampImage: {
      default: new Date().getTime()
    },
    hasImage: {
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('customers', {
    urlImgs: 'urlImgs'
  }), {
    customerImage: function customerImage() {
      return this.hasImage ? this.urlImgs.image + '?' + this.timestampImage : '/static/img/profile-placeholder.svg';
    },
    customerImageClass: function customerImageClass() {
      return {
        'img-responsive': true,
        'center-block': true,
        'img-customer-placeholder': !this.hasImage,
        'img-thumbnail': this.hasImage
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('customers', {
    getUrlImg: 'getUrlImg'
  }), {
    editImage: function editImage() {
      this.$emit('editImage', this.customer);
    }
  })
});

/***/ }),

/***/ "uhoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujRx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectImages_vue__ = __webpack_require__("OqyN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547e3487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectImages_vue__ = __webpack_require__("WsnP");
function injectStyle (ssrContext) {
  __webpack_require__("qHx1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-547e3487"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547e3487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ulVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cpfIsValidRule; });


var cpfIsValidRule = {
  getMessage: function getMessage(field, args) {
    return 'CPF inválido.';
  },
  validate: function validate(value, args) {
    var cpf = value;
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') return false;

    if (cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
      return false;
    }

    var add = 0;
    for (var i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }var rev = 11 - add % 11;
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(9))) return false;

    add = 0;
    for (var _i = 0; _i < 10; _i++) {
      add += parseInt(cpf.charAt(_i)) * (11 - _i);
    }rev = 11 - add % 11;
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(10))) return false;
    return true;
  }
};



/***/ }),

/***/ "ulfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-list-canceled card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Ausentes ("+_vm._s(_vm.tickets.length)+")")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tickets}},[_c('el-table-column',{attrs:{"label":"Nome","property":"customer"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.customer.holder)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UC"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.customer.uc)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nota"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.survey && scope.row.survey.data)?[_vm._v(" "+_vm._s(scope.row.survey.data.refrigerator.score)+" ")]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Posição Inicial"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.rankingOriginal)+" ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Posição de Ausência"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(scope.row.rankingNow)+" ")]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "umJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitialDataForm_vue__ = __webpack_require__("bZk4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb6e812_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitialDataForm_vue__ = __webpack_require__("M7ZX");
function injectStyle (ssrContext) {
  __webpack_require__("y9at")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitialDataForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb6e812_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitialDataForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ungQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devlivery-term-iasc"},[_c('HeaderTerm',{attrs:{"imgsrc":_vm.urlImages.imgTermDelivery,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_vm._l(([1,2]),function(i){return _c('div',{key:i},[_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px black"}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Fabricante: "+_vm._s(_vm.manufacturer.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('h6',[_vm._v("Concessionária: "+_vm._s(_vm.abbreviation))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoice)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoice,'LL'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("NF Referência Nº:")]),_vm._v(" "+_vm._s(_vm.stock.invoicePowerCompany)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data de emissão:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.stock.dateInvoicePowerCompany,'LL'))+"\n            ")])])]),_vm._v(" "),_c('h6',[_vm._v("Destinatário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.customer.holder)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customer.cpf)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customer.uc)+" "),_c('br'),_vm._v(" "),(_vm.customer.phone2)?_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1.concat(' / ', _vm.customer.phone2))+"\n              ")]):_c('a',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.customer.phone1)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('p',[_c('strong',[_vm._v(" Endereço: ")]),_vm._v("\n              "+_vm._s(_vm.customer.address.street)+",\n              "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Bairro:")]),_vm._v(" "+_vm._s(_vm.customer.address.neighborhood)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Município:")]),_vm._v(" "+_vm._s(_vm.customer.address.city)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CEP:")]),_vm._v(" "+_vm._s(_vm.customer.address.zip)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_vm._v(_vm._s(_vm.stock.description))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"line-height":"1.5em"}},[_vm._v("\n              "+_vm._s(_vm.manufacturer.informativeText)+"\n            ")])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"border-bottom":"2px solid black"},style:(_vm.config.event.autoDateOnDeliveryTerm && _vm.dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;')},[_vm._v("\n            "+_vm._s(_vm.config.event.autoDateOnDeliveryTerm ? _vm.$moment(_vm.dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1",staticStyle:{"margin-top":"30px","border-bottom":"2px solid black"}})])])]),_vm._v(" "),(i === 1)?_c('div',{staticClass:"row",staticStyle:{"border":"1px dashed black","width":"100%","margin":"10px 0px 10px 0px"}}):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("Data de Recebimento")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-7 col-xs-offset-1"},[_c('strong',[_vm._v("Identificação e Assinatura")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uptt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsReportSimplified_vue__ = __webpack_require__("+33O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b24c958e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsReportSimplified_vue__ = __webpack_require__("0y/O");
function injectStyle (ssrContext) {
  __webpack_require__("Bm7B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b24c958e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LampsReportSimplified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b24c958e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LampsReportSimplified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvZG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__ = __webpack_require__("mmP5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__ = __webpack_require__("qjBI");
function injectStyle (ssrContext) {
  __webpack_require__("BItS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uzjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classStyle,attrs:{"title":_vm.title},on:{"click":_vm.onClick}},[_c('i',{class:_vm.iconClass}),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v+6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateNewTickets_vue__ = __webpack_require__("Ag9j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c8f92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateNewTickets_vue__ = __webpack_require__("CUgj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateNewTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c8f92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateNewTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v/xQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v4Cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions_BtnRunLottery__ = __webpack_require__("/7BP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actions_BtnAssociateStock__ = __webpack_require__("H3Rb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actions_BtnPrintTerms__ = __webpack_require__("KaKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Actions_BtnDownloadOldPresenter__ = __webpack_require__("aSi1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Actions_BtnDownloadDocumentation__ = __webpack_require__("jCXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Actions_BtnOpenNewPresenter__ = __webpack_require__("1uw6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Actions_BtnPrintAllTickets__ = __webpack_require__("ARCF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Actions_BtnDownloadPptx__ = __webpack_require__("MotM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions_BtnDownloadPptxSubstituteCustomers__ = __webpack_require__("Ul8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Actions_BtnCustomersImport__ = __webpack_require__("Lqpr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Actions_BtnCsvWinners__ = __webpack_require__("MRUy");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-actions',

  props: {
    event: {
      required: true
    }
  },

  components: {
    BtnRunLottery: __WEBPACK_IMPORTED_MODULE_0__Actions_BtnRunLottery__["a" /* default */],
    BtnAssociateStock: __WEBPACK_IMPORTED_MODULE_1__Actions_BtnAssociateStock__["a" /* default */],
    BtnPrintTerms: __WEBPACK_IMPORTED_MODULE_2__Actions_BtnPrintTerms__["a" /* default */],
    BtnDownloadOldPresenter: __WEBPACK_IMPORTED_MODULE_3__Actions_BtnDownloadOldPresenter__["a" /* default */],
    BtnDownloadDocumentation: __WEBPACK_IMPORTED_MODULE_4__Actions_BtnDownloadDocumentation__["a" /* default */],
    BtnOpenNewPresenter: __WEBPACK_IMPORTED_MODULE_5__Actions_BtnOpenNewPresenter__["a" /* default */],
    BtnPrintAllTickets: __WEBPACK_IMPORTED_MODULE_6__Actions_BtnPrintAllTickets__["a" /* default */],
    BtnDownloadPptx: __WEBPACK_IMPORTED_MODULE_7__Actions_BtnDownloadPptx__["a" /* default */],
    BtnDownloadPptxSubstituteCustomers: __WEBPACK_IMPORTED_MODULE_8__Actions_BtnDownloadPptxSubstituteCustomers__["a" /* default */],
    BtnCustomersImport: __WEBPACK_IMPORTED_MODULE_9__Actions_BtnCustomersImport__["a" /* default */],
    BtnCsvWinners: __WEBPACK_IMPORTED_MODULE_10__Actions_BtnCsvWinners__["a" /* default */]
  },

  computed: {
    isLottery: function isLottery() {
      return this.event.winnerChoiceMode === 'lottery' || this.event.winnerChoiceMode === '';
    },
    isRanking: function isRanking() {
      return this.event.winnerChoiceMode === 'ranking';
    }
  }
});

/***/ }),

/***/ "v98p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("jcvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("FQVD");
function injectStyle (ssrContext) {
  __webpack_require__("oHle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vD7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamps-alert',
  props: {
    alertText: {
      required: true
    }
  }
});

/***/ }),

/***/ "vGh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vIES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vJ5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-download-term-lamps',{attrs:{"event":_vm.event,"event-id":_vm.eventId,"lamps":_vm.lamps,"customer":_vm.customer}}),_vm._v(" "),_c('upload-term-lamps',{on:{"update-file":function($event){return _vm.$emit('upload-file', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vLBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderTerm__ = __webpack_require__("fd3O");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-enel',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_0__SignatureCustomerTicket__["a" /* default */],
    HeaderTerm: __WEBPACK_IMPORTED_MODULE_1__HeaderTerm__["a" /* default */]
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      company: 'Companhia Energética do Ceará - ENEL',
      shortname: 'ENEL',
      address: 'Rua Padre Valdevino, nº 150 – Centro, Fortaleza/CE',
      cpnj: '07.047.251/0001-70',
      stateRegistration: '06.105.848-3',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    };
  },

  computed: {}
});

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627ad2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("QUfe");
function injectStyle (ssrContext) {
  __webpack_require__("MqVy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627ad2de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627ad2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vTRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"30px"}},[(_vm.showTimeRange)?_c('div',{staticClass:"row filter-row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"date"},[_c('label',{staticClass:"demonstration"},[_vm._v("Intevalo")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetimerange","format":"dd/MM/yyyy","start-placeholder":"Data início","end-placeholder":"Data término"},on:{"change":function($event){return _vm.setRangeDate($event)}},model:{value:(_vm.rangeDate),callback:function ($$v) {_vm.rangeDate=$$v},expression:"rangeDate"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row filter-row"},[_c('div',{staticClass:"col-xs-12"},[_c('input-categories-tags',{on:{"change":_vm.onChangeFilters}})],1)]),_vm._v(" "),_c('div',{staticClass:"row filter-row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.$emit('filter')}}},[_vm._v(_vm._s(_vm.buttomLabel)+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vlUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermGeneric_vue__ = __webpack_require__("Q8dN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f7a90e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermGeneric_vue__ = __webpack_require__("AxDr");
function injectStyle (ssrContext) {
  __webpack_require__("pH0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2f7a90e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipationTermGeneric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f7a90e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipationTermGeneric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vpir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("dM8Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b2d297_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("95qz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b2d297_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vq0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey-view-general',

  props: ['survey'],

  computed: {
    hasEvent: function hasEvent() {
      return this.survey.hasOwnProperty('event');
    }
  }
});

/***/ }),

/***/ "vqHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-equatorial-pi',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project', 'urlImages']), {
    stateName: function stateName() {
      return this.project.company.address.state;
    },
    fullname: function fullname() {
      return this.project.company.longname + ' - ' + this.project.company.abbreviation;
    },
    longname: function longname() {
      return this.project.company.longname;
    },
    abbreviation: function abbreviation() {
      return this.project.company.abbreviation;
    },
    projectName: function projectName() {
      return this.project.name;
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return this.project.company.address;
    },
    cnpj: function cnpj() {
      return this.project.company.cnpj;
    },
    numberState: function numberState() {
      return this.project.company.stateNumber;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "vqd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Documents_Terms_DeliveryTerm__ = __webpack_require__("CY2R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Documents_Terms_LendingTerm__ = __webpack_require__("g73q");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocumentsPrint',
  components: {
    LendingTerm: __WEBPACK_IMPORTED_MODULE_6__Documents_Terms_LendingTerm__["a" /* default */],
    DeliveryTerm: __WEBPACK_IMPORTED_MODULE_5__Documents_Terms_DeliveryTerm__["a" /* default */]
  },
  data: function data() {
    return {
      loaded: false
    };
  },

  watch: {
    tickets: function tickets() {
      console.log('watch');
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('project', { config: 'project' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('manufacturers', {
    manufacturers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('surveys', {
    surveys: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('customers', {
    customers: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('stocks', {
    stocks: 'modelById'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tickets', {
    tickets: 'tickets'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', {
    event: 'event',
    eventPrintLending: 'eventPrintLending'
  }), {
    eventId: function eventId() {
      return this.$route.params.eventId;
    },
    ticketId: function ticketId() {
      return this.$route.params.ticketId;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tickets', {
    fetchTickets: 'fetchAll',
    fetchTicket: 'fetchOne',
    setTickets: 'setStateAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('events', {
    fetchEvent: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('stocks', {
    fetchStocksByIds: 'fetchIds'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('manufacturers', {
    fetchManufacturersByIds: 'fetchIds',
    fetchManufacturers: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('customers', {
    fetchCustomersById: 'fetchIds'
  }), {
    runPrint: function runPrint() {
      window.setTimeout(function () {}, 2000);
    },
    checkAllStocks: function checkAllStocks() {
      for (var t in this.tickets) {
        if (!this.tickets[t].stockId || !this.stocks[this.tickets[t].stockId]) {
          return false;
        }
      }
      return true;
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.getTickets(), this.fetchEvent(this.eventId)]).then(function (results) {
        var dataIds = _this.getStockCustomersIds(results[0]);
        return _this.fetchPromiseCustomerStocks([_this.fetchStocksByIds({
          connection: 'default',
          ids: dataIds.stockIds.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { id: item });
          })
        }), _this.fetchCustomersById({
          connection: 'default',
          ids: dataIds.customerIds.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { id: item });
          })
        })]);
      }).catch(function (e) {
        return console.log(e);
      });
    },
    fetchPromiseCustomerStocks: function fetchPromiseCustomerStocks(promises) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.loaded = true;
      });
    },
    getStockCustomersIds: function getStockCustomersIds(tickets) {
      if (tickets instanceof Array) {
        var stockIds = [];
        var customerIds = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tickets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ticket = _step.value;

            stockIds.push(ticket.stockId);
            customerIds.push(ticket.customerId);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          stockIds: stockIds,
          customerIds: customerIds
        };
      }
    },
    getTickets: function getTickets() {
      var _this3 = this;

      if (this.ticketId !== null && this.ticketId !== 'none') {
        return this.fetchTicket(this.ticketId).then(function (res) {
          _this3.setTickets([res]);
          return [res];
        });
      }

      return this.fetchTickets({
        where: {
          eventId: this.eventId,
          winner: true,
          '$and': [{ stockId: { '$exists': true } }, { stockId: { '$ne': null } }]
        }
      });
    },
    getManufacturer: function getManufacturer(stockId) {
      if (!this.stocks.hasOwnProperty(stockId)) {
        return {};
      }
      if (!this.manufacturers.hasOwnProperty(this.stocks[stockId].manufacturerId)) {
        return {};
      }

      return this.manufacturers[this.stocks[stockId].manufacturerId];
    }
  }),

  mounted: function mounted() {
    this.fetchManufacturers({ limit: 9999 });
    this.fetch();
  }
});

/***/ }),

/***/ "vtxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vxZ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp-terml",staticStyle:{"margin":"0.5cm"}},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")]),_vm._v(" "),_c('h5',{staticClass:"text-center"},[_vm._v("Termo de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n    A "+_vm._s(_vm.fullname)+" com sede na "+_vm._s(_vm.address.streetType)+" "+_vm._s(_vm.address.street)+", nº "+_vm._s(_vm.address.number)+" – "+_vm._s(_vm.address.neighborhood)+", "+_vm._s(_vm.address.city)+"/"+_vm._s(_vm.address.state)+" inscrita no CNPJ/MF sob o nº. "+_vm._s(_vm.cnpj)+" e Inscrição\n    Estadual nº. "+_vm._s(_vm.numberState)+", e o(a) Sr(a). "+_vm._s(_vm.payload.customer.holder)+", C.P.F.: "+_vm._s(_vm.payload.customer.cpf)+", e\n    N.I.S./N.I.T./N.B. "+_vm._s(_vm.payload.customer.nis)+"\n    "),(_vm.payload.customer.nis === '')?_c('span',[_vm._v("N/C")]):_vm._e(),_vm._v(" residente e domiciliado (a) na "+_vm._s(_vm.payload.customer.address.street)+" nº "+_vm._s(_vm.payload.customer.address.number)+" UC n.º "+_vm._s(_vm.payload.customer.uc)+" firmam\n    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se\n    descritos a seguir:\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Primeira — CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" está desenvolvendo o\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades\n      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia\n      elétrica e orientações na resolução dos problemas sociais nas comunidades;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de\n      lâmpadas econômicas;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" busca viabilizar essa prática nas comunidades atendidas pelo\n      "),_c('i',[_vm._v("“"+_vm._s(_vm.projectName)+"”")]),_vm._v("\n      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras\n      atendidas, nas condições constadas na "),_c('strong',[_vm._v("Cláula Segunda")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Segunda — CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      A "+_vm._s(_vm.fullname)+" fornecerá à unidade consumidora atendida pelo projeto a quantidade de\n      "+_vm._s(_vm.payload.lamps.length)+" lâmpadas LED de potência "+_vm._s(_vm.powerLampDeliveryLabel)+"W,\n      que serão substituídas por\n      "),(_vm.numFluorescentLampsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numFluorescentLampsReceived)+" lâmpadas fluorescentes de potência "+_vm._s(_vm.powerFluorescentLampsReceived)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.numFluorescentLampsReceived > 0 && _vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("e\n        ")]):_vm._e(),_vm._v(" "),(_vm.numIncandescentBulbsReceived > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.numIncandescentBulbsReceived)+" incandescentes de potência "+_vm._s(_vm.powerIncandescentBulbsReceived)+"\n        ")]):_vm._e(),_vm._v(", devendo estas ser entregues à "+_vm._s(_vm.abbreviation)+" no ato da substituição;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à "+_vm._s(_vm.abbreviation)+" para substituição\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o\n      parcelamento firmado com a "+_vm._s(_vm.fullname)+".\n    ")])]),_vm._v(" "),_c('h4',[_vm._v("Cláusula Terceira — DAS OBRIGAÇÕES DO USUÁRIO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas\n      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ "+_vm._s(_vm.projectName)+" ” suspensos;\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      O usuário, desde já, autoriza a inspeção pelos funcionários da "+_vm._s(_vm.fullname)+" para verificação da\n      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do\n      “"+_vm._s(_vm.projectName)+"” suspensos;\n    ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5cm"}},[_vm._v("\n    "+_vm._s(_vm.payload.customer.address.city)+", "+_vm._s(_vm._f("moment")(new Date(),'D'))+", "+_vm._s(_vm._f("moment")(new Date(),'MMMM'))+" de "+_vm._s(_vm._f("moment")(new
    Date(),'YYYY'))+"\n  ")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticStyle:{"margin-top":".5cm"}},[_c('li',[_vm._v("Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________\n    ")]),_vm._v(" "),_c('li',[_vm._v("Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n    ________________________________________________________________________\n    "),_c('br'),_vm._v("\n    Assinatura do(a) cliente beneficiado\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w/O6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Terms_ParticipationTerm__ = __webpack_require__("9RRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsbarcode__ = __webpack_require__("TwlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsbarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsbarcode__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-document',

  components: {
    ParticipationTerm: __WEBPACK_IMPORTED_MODULE_0__Terms_ParticipationTerm__["a" /* default */]
  },

  data: function data() {
    return {
      loaded: false
    };
  },


  props: {
    loading: {},
    ticket: {}
  },

  watch: {
    ticket: function ticket(_ticket) {
      this.makeBarcode();
    }
  },

  computed: {
    config: {
      get: function get() {
        return this.$store.state.config;
      }
    },

    imgId: function imgId() {
      return 'img-barcodeCanvas-' + this.ticket._id;
    }
  },

  methods: {
    makeBarcode: function makeBarcode() {
      __WEBPACK_IMPORTED_MODULE_1_jsbarcode___default()('#barcodeCanvas-' + this.ticket._id, this.ticket.barcode, {
        lineColor: '#000',
        fontSize: '16pt',
        width: 1,
        height: 50,
        displayValue: true
      });
    }
  },

  mounted: function mounted() {
    this.makeBarcode();
  }
});

/***/ }),

/***/ "w1iA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetStockNull_vue__ = __webpack_require__("g70d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5585db84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetStockNull_vue__ = __webpack_require__("g4+E");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetStockNull_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5585db84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetStockNull_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wEwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('p',{staticClass:"customer holder"},[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.ticket.customer.holder)+" ")]),_vm._v(" "),_c('p',{staticClass:"customer uc"},[_c('strong',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.ticket.customer.uc))]),_vm._v(" "),_c('p',{staticClass:"customer cpf"},[_c('strong',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.ticket.customer.cpf)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 text-center"},[_c('div',{staticClass:"barcode"},[_c('img',{attrs:{"id":("barcodeCanvas-" + (_vm.ticket._id))}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.5em","text-align":"right","font-size":"5pt"}},[_vm._v("\n        "+_vm._s(((_vm.ticket.eventId) + " - " + (_vm.ticket._id)))+"\n      ")])])]),_vm._v(" "),_c('ParticipationTerm',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading}}),_vm._v(" "),(_vm.ticket.user)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("Ticket gerado por: "),_c('b',[_vm._v(_vm._s(_vm.ticket.user.name))])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("GJqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wISe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'address-form',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['street', 'number', 'neighborhood', 'city', 'zip', 'complement']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('customers', {
    customer: 'customer',
    modelValidations: 'validations'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', {
    citiesOptions: 'citiesOptions'
  })),

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
});

/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wR4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wVKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[(_vm.showEditButton && _vm.customer._id)?_c('router-link',{attrs:{"to":{name: 'customers.edit', params: {id: _vm.customer._id}}}},[(_vm.$can('customers.edit'))?_c('a',{staticClass:"btn btn-fill btn-primary btn-sm btn"},[_c('i',{staticClass:"ti-pencil"}),_vm._v(" Editar\n          ")]):_vm._e()]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("UC")]),_vm._v(" "),_c('dd',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'customer.detail', params: { id: _vm.customer._id } })}}},[_vm._v(_vm._s(_vm.customer.uc))])]),_vm._v(" "),_c('dt',[_vm._v("Nome do titular")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(" "),_c('dt',[_vm._v("Conhecido como")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.aka))]),_vm._v(" "),_c('dt',[_vm._v("Nome da mãe")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.motherName ? _vm.customer.motherName : '-'))]),_vm._v(" "),_c('dt',[_vm._v("CPF")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.cpf))]),_vm._v(" "),_c('dt',[_vm._v("Data de nascimento")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.birthdate))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.customer.nis))])]),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Telefone 1")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.phone1))]),_vm._v(" "),_c('dt',[_vm._v("Telefone 2")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.phone2))])]),_vm._v(" "),(_vm.hasAdditionalData)?_c('dl',{staticClass:"dl-horizontal"},[(_vm.showEditButton)?_c('dt'):_vm._e(),_vm._v(" "),(_vm.showEditButton)?_c('dd',{staticClass:"text-right"},[(_vm.$can('customers.edit|customers.tickets'))?_c('button',{staticClass:"btn btn-fill btn-primary btn-sm btn",on:{"click":function($event){return _vm.editAdditionalData()}}},[_c('i',{staticClass:"ti-pencil"}),_vm._v(" Editar\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v("Endereço")]),_vm._v(" "),(_vm.customer.hasOwnProperty('address'))?_c('dd',[_vm._v("\n        "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+"\n        "),_c('br'),_vm._v("\n        "+_vm._s(_vm.customer.address.neighborhood)+", "+_vm._s(_vm.customer.address.city)+" - CEP: "+_vm._s(_vm.customer.address.zip)+"\n      ")]):_c('dd',[_vm._v("-")]),_vm._v(" "),_c('dt',[_vm._v("Complemento")]),_vm._v(" "),(_vm.customer.hasOwnProperty('address'))?_c('dd',[_vm._v(_vm._s(_vm.customer.address.complement ? _vm.customer.address.complement : '-')+"\n      ")]):_c('dd',[_vm._v("-")])]):_vm._e(),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Criado por:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.users[_vm.customer.userId]))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Dados do Cliente\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dt',[_c('strong',[_vm._v("NIS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wZqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__("TCD/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e7441_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__("E7lf");
function injectStyle (ssrContext) {
  __webpack_require__("c4e9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e7441_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wa7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-index',

  mounted: function mounted() {
    this.fetchOne('config');
    this.getImagesProject();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('project', {
    config: 'project',
    loading: 'loading'
  }), {
    urlImages: {
      get: function get() {
        return this.$store.state.project.urlImages;
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('project', ['fetchOne', 'getImagesProject']))
});

/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "wfNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.reporting),expression:"reporting"}],staticClass:"btn btn-wd btn-fill btn-tertiary",on:{"click":_vm.loadingReport}},[_vm._v("\n  Gerar relatório geral simplificado: "+_vm._s(_vm.eventLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wgiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Inputs_Search_vue__ = __webpack_require__("yntV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EventIcons__ = __webpack_require__("gkr/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_pages_Events_UploadPhotos_DialogUploadPhotosEvent__ = __webpack_require__("Z+/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_pages_Events_UploadPhotos_BtnUploadPhotosEvent__ = __webpack_require__("26Lh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__TableActionsEvents__ = __webpack_require__("a3Ul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__EventActions__ = __webpack_require__("IVAO");





























__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_menu___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'events-index',
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSearch: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Inputs_Search_vue__["a" /* default */],
    EventIcons: __WEBPACK_IMPORTED_MODULE_22__EventIcons__["a" /* default */],
    DialogUploadPhotosEvent: __WEBPACK_IMPORTED_MODULE_23_src_pages_Events_UploadPhotos_DialogUploadPhotosEvent__["a" /* default */],
    BtnUploadPhotosEvent: __WEBPACK_IMPORTED_MODULE_24_src_pages_Events_UploadPhotos_BtnUploadPhotosEvent__["a" /* default */],
    TableActionsEvents: __WEBPACK_IMPORTED_MODULE_25__TableActionsEvents__["a" /* default */],
    EventActions: __WEBPACK_IMPORTED_MODULE_26__EventActions__["a" /* default */]
  },
  data: function data() {
    return {
      dialogPhotos: {
        show: false,
        id: ''
      },
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      search: {
        query: '',
        fields: ['city', 'reference', 'place']
      },
      count: 0,
      searched: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["a" /* mapGetters */])('events', {
    loading: 'loading',
    ticketsCounter: 'ticketsCounter',
    lampsCounter: 'lampsCounter',
    tableData: 'events'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["a" /* mapGetters */])(['config']), {
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.searched ? this.tableData.length : this.count;
      return this.searched ? this.tableData.length : this.count;
    },
    currentPage: function currentPage() {
      return this.pagination.currentPage;
    }
  }),
  watch: {
    currentPage: function currentPage(_currentPage) {
      this.fetch();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapActions */])('events', ['fetchAll', 'fetchViewAll', 'delete', 'fetchTicketsCount', 'fetchLampsCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), {
    fetch: function fetch() {
      this.searched = false;
      this.fetchAll({
        limit: this.pagination.perPage,
        skip: this.from,
        sort: {
          field: 'startDate',
          direction: 'desc'
        }
      });
      this.counter();
    },
    fetchSearch: function fetchSearch() {
      this.searched = true;
      this.fetchAll({
        'search': this.search
      });
    },
    handleSearch: function handleSearch(query) {
      this.search.query = query;
      this.fetchSearch();
    },
    handleSort: function handleSort(sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      };
      this.fetch();
    },
    handleDelete: function handleDelete(row) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'N\xE3o ser\xE1 poss\xEDvel reverter essa a\xE7\xE3o!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(function () {
        _this.delete(row.id).then(function (result) {
          _this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          });
          _this.fetch();
        }).finally(function () {
          _this.$router.push({ name: 'events.index' });
        }).catch(function (err) {
          return console.log(err);
        });
      }).finally(function () {
        _this.$router.push({ name: 'events.index' });
      });
    },
    showRanking: function showRanking(winnerChoice) {
      return winnerChoice === 'ranking';
    },
    counter: function counter() {
      var _this2 = this;

      var couchdbAdmin = new __WEBPACK_IMPORTED_MODULE_16_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
      couchdbAdmin.view('count-events-all', 'count-events-all').then(function (result) {
        _this2.count = result.rows[0].value;
      });
    }
  }),

  mounted: function mounted() {
    if (!this.config) {
      this.fetchProject('config');
    }
    this.fetchTicketsCount();
    this.fetchLampsCount();
    this.fetch();
  }
});

/***/ }),

/***/ "whIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}),1)])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wjQF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wlRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dialog-upload-photos-event',
  props: {
    eventId: {
      required: true,
      type: String
    },
    show: {
      required: true,
      type: Boolean
    },
    files: {}
  },

  watch: {
    show: function show() {
      if (this.show === true) {
        this.showDialog();
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('events', ['getInsertDocEvent', 'uploadPhotosEvent']), {
    showDialog: function showDialog() {
      var _this = this;

      this.getInsertDocEvent({ _id: this.eventId }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          titleText: 'Confirmar envio das fotos?',
          text: 'Confirmar o envio de ' + _this.files.length + ' fotos?',
          confirmButtonText: 'Enviar',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCloseButton: true,
          showConfirmButton: true,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
              var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _iteratorNormalCompletion = true;
                      _didIteratorError = false;
                      _iteratorError = undefined;
                      _context.prev = 3;
                      _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.files);

                    case 5:
                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context.next = 12;
                        break;
                      }

                      file = _step.value;
                      _context.next = 9;
                      return _this.uploadPhotosEvent({
                        id: response,
                        mimeType: 'image/jpg',
                        name: 'imagem_evento_' + new Date().getTime() + '.jpg',
                        file: file.blob
                      });

                    case 9:
                      _iteratorNormalCompletion = true;
                      _context.next = 5;
                      break;

                    case 12:
                      _context.next = 18;
                      break;

                    case 14:
                      _context.prev = 14;
                      _context.t0 = _context['catch'](3);
                      _didIteratorError = true;
                      _iteratorError = _context.t0;

                    case 18:
                      _context.prev = 18;
                      _context.prev = 19;

                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }

                    case 21:
                      _context.prev = 21;

                      if (!_didIteratorError) {
                        _context.next = 24;
                        break;
                      }

                      throw _iteratorError;

                    case 24:
                      return _context.finish(21);

                    case 25:
                      return _context.finish(18);

                    case 26:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
            }));

            return function preConfirm() {
              return _ref.apply(this, arguments);
            };
          }()
        }).then(function () {
          return _this.$emit('upload-photos', true);
        }).catch(function (err) {
          return console.log(err);
        });
      });
    }
  }),

  render: function render() {
    return null;
  }
});

/***/ }),

/***/ "wrmY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    showNewButton: function showNewButton() {
      return this.$route.name === 'tags.index';
    }
  }
});

/***/ }),

/***/ "ww74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('all.tickets.documents.print'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-success btn-block btn-router",on:{"click":function($event){return _vm.handleClick()}}},[(_vm.eligibleNotWinners)?_c('span',[_vm._v("\n    Download CSV Reservas\n  ")]):_c('span',[_vm._v("\n    Download CSV Ganhadores\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "xAEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockIndex_vue__ = __webpack_require__("Nipe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460a3c11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockIndex_vue__ = __webpack_require__("xmDw");
function injectStyle (ssrContext) {
  __webpack_require__("+NH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460a3c11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xBgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Logradouro")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.street),expression:"modelValidations.additionalData.street"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.street),expression:"customer.address.street",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"street","autofocus":"","autocomplete":"off"},domProps:{"value":(_vm.customer.address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.address, "street", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.street.invalid),expression:"street.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('street'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.number),expression:"modelValidations.additionalData.number"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.number),expression:"customer.address.number",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('000000000'),expression:"'000000000'"}],staticClass:"form-control",attrs:{"type":"text","name":"number","autocomplete":"off"},domProps:{"value":(_vm.customer.address.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.address, "number", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('number'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.zip),expression:"modelValidations.additionalData.zip"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.zip),expression:"customer.address.zip",modifiers:{"trim":true}},{name:"mask",rawName:"v-mask",value:('00000-000'),expression:"'00000-000'"}],staticClass:"form-control",attrs:{"type":"text","name":"zip","autocomplete":"off"},domProps:{"value":(_vm.customer.address.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.address, "zip", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zip.invalid),expression:"zip.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('zip'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.neighborhood),expression:"modelValidations.additionalData.neighborhood"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.neighborhood),expression:"customer.address.neighborhood",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"neighborhood","autocomplete":"off"},domProps:{"value":(_vm.customer.address.neighborhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.address, "neighborhood", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.neighborhood.invalid),expression:"neighborhood.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('neighborhood'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Município")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.city),expression:"modelValidations.additionalData.city"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.city),expression:"customer.address.city",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"name":"city"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.customer.address, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selecione ...\n        ")]),_vm._v(" "),_vm._l((_vm.citiesOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n        ")])})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.city.invalid),expression:"city.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('city'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.additionalData.complement),expression:"modelValidations.additionalData.complement"},{name:"model",rawName:"v-model.trim",value:(_vm.customer.address.complement),expression:"customer.address.complement",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"complement","autocomplete":"off"},domProps:{"value":(_vm.customer.address.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.address, "complement", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.complement.invalid),expression:"complement.invalid"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.getError('complement'))+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xCNv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xDzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Sync_Sync__ = __webpack_require__("GYO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Sync_SyncIndex__ = __webpack_require__("0W5e");



var path = 'sync';
var title = 'Sincronia';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Sync_Sync__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Sync_SyncIndex__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "xH3n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('EventsOptions',{on:{"eventSelected":function (event) { return (_vm.eventSelectedId = event); }}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"disabled":_vm.eventSelectedId === '',"title":"Este botão remove tudo relacionado a um evento"},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Remover tudo relacionado ao evento.\n  ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceDelete),expression:"forceDelete"}],attrs:{"id":"checkbox-force-delete-event","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.forceDelete)?_vm._i(_vm.forceDelete,null)>-1:(_vm.forceDelete)},on:{"change":function($event){var $$a=_vm.forceDelete,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.forceDelete=$$a.concat([$$v]))}else{$$i>-1&&(_vm.forceDelete=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.forceDelete=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"checkbox-force-delete-event"}},[_vm._v("Forçar a remoção permanentemente")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xH5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEnergyMeteringTickets_vue__ = __webpack_require__("k6oI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bdaedf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEnergyMeteringTickets_vue__ = __webpack_require__("9ZWX");
function injectStyle (ssrContext) {
  __webpack_require__("rcmJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49bdaedf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEnergyMeteringTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bdaedf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEnergyMeteringTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xHTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_GalleryComponent__ = __webpack_require__("Z1yA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");







__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "p4sG"));

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GalleryComponent: __WEBPACK_IMPORTED_MODULE_1_src_components_GalleryComponent__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('gallery', ['showGallery', 'imagesGallery', 'galleryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['config', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', { users: 'users' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['project'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('gallery', ['defineGallery']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', { fetchUsers: 'fetchAll', fetchViewAll: 'fetchViewAll', resetUsers: 'resetAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' })),

  mounted: function mounted() {
    this.fetchProject('config').then(function (project) {
      localStorage.setItem('eventLabel', project.hasOwnProperty('eventLabel') ? project.eventLabel : 'evento');
    });
    if (this.users.length === 0 && this.user.hasOwnProperty('_id')) {
      this.fetchUsers({
        limit: 99999,
        sort: { field: 'createdAt', direction: 'desc' }
      });
    } else {
      this.resetUsers();
    }
  }
});

/***/ }),

/***/ "xJhi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xLa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingCustomers || _vm.loadingEvents || _vm.loadingTickets || _vm.loadingFiltered),expression:"loadingCustomers || loadingEvents || loadingTickets || loadingFiltered"}],staticClass:"tickets-list"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-ticket"}),_vm._v(" "+_vm._s(_vm.getTitle)+" ("+_vm._s(_vm.ticketsFiltered.length)+")\n      ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.showResume)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-select',{staticClass:"select-primary el-select",attrs:{"multiple":"","filterable":"","size":"large","placeholder":"Filtros"},on:{"change":_vm.setTicketsFiltered},model:{value:(_vm.filters.selected),callback:function ($$v) {_vm.$set(_vm.filters, "selected", $$v)},expression:"filters.selected"}},_vm._l((_vm.filtersOptions),function(option){return _c('el-option',{key:option.value,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p-search',{attrs:{"placeholder":"Pesquise por Nome Completo, CPF, UC ou Cod. do Ticket"},on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingFiltered),expression:"loadingFiltered"}],staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.ticketsFiltered,"default-sort":{prop: 'createdAt', order: 'descending'}}},[(_vm.showCustomerColumn)?_c('el-table-column',{attrs:{"label":"UC","property":"customerId.uc","min-width":"100","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.$can('tickets.print'))?_c('button',{staticClass:"btn btn-info",attrs:{"title":"Informações do Cliente"},on:{"click":function($event){return _vm.customerInfo(_vm.customers[scope.row.customerId])}}},[_vm._v("\n                  "+_vm._s(_vm.customers[scope.row.customerId].uc)+"\n                ")]):_vm._e()]}}],null,false,1019278143)}):_vm._e(),_vm._v(" "),(_vm.showCustomerColumn)?_c('el-table-column',{attrs:{"label":"Cliente","property":"customerId","min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.customers[scope.row.customerId])?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_c('b',[_vm._v("Nome Completo:")]),_vm._v(" "+_vm._s(_vm.customers[scope.row.customerId].holder)),_c('br'),_vm._v(" "),_c('b',[_vm._v("CPF:")]),_vm._v(" "+_vm._s(_vm.customers[scope.row.customerId].cpf)),_c('br'),_vm._v(" "),_c('b',[_vm._v("UC:")]),_vm._v(" "+_vm._s(_vm.customers[scope.row.customerId].uc)+"\n                  "),_c('b',[_vm._v("Código de barra:")]),_vm._v(" "+_vm._s(scope.row.barcode)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('a',{on:{"click":function($event){return _vm.handleDocumentation(scope.row)}}},[_c('i',{staticClass:"ti-info-alt"}),_vm._v(" "+_vm._s(_vm.customers[scope.row.customerId].holder)+"\n                  ")])])]):_vm._e()]}}],null,false,307585665)}):_vm._e(),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('icons-ticket-list',{attrs:{"ticket":scope.row,"reason":_vm.reason(scope.row),"not-eligible":_vm.notEligible(scope.row)}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Código do ticket","property":"barcode"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.barcode)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Data de Criação","property":"createdAt","width":"150","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm._f("moment")(new Date(scope.row.createdAt),'L'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ações","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingTickets),expression:"loadingTickets"}],staticClass:"text-right"},[_c('ticket-check-in',{attrs:{"ticket":scope.row,"icon":true,"event-id":scope.row.eventId}}),_vm._v(" "),_c('check-energy-metering-tickets',{attrs:{"ticket":scope.row},on:{"changeTickets":_vm.changeTickets}}),_vm._v(" "),_c('check-valid-online-register',{attrs:{"ticket":scope.row,"type":_vm.event ? 'event' : 'customer'}}),_vm._v(" "),_c('ticket-invalidate-error',{attrs:{"event":_vm.event,"ticket":scope.row,"type":_vm.event ? 'event' : 'customer'}}),_vm._v(" "),(_vm.enableReplace(scope.row))?_c('button',{staticClass:"btn btn-fill btn-icon btn-info",attrs:{"title":"Substituir"},on:{"click":function($event){return _vm.handleReplaceCustomer(scope.$index, scope.row)}}},[_c('i',{staticClass:"ti-control-shuffle"})]):_vm._e(),_vm._v(" "),_c('btn-open-ticket-documentation',{attrs:{"event":_vm.getEvent(scope.row.eventId),"ticket":scope.row,"scope":scope}}),_vm._v(" "),(!scope.row.error)?_c('btn-open-tickets-documentations-print',{attrs:{"ticket":scope.row}}):_vm._e(),_vm._v(" "),_c('BtnOpenTicketRegisterDocPrint',{attrs:{"event-prop":_vm.event,"ticket":scope.row}}),_vm._v(" "),(!scope.row.error)?_c('btn-open-ticket-print',{attrs:{"ticket":scope.row}}):_vm._e()],1)]}}])})],1)],1)])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Substituição de cliente sorteado","modal-append-to-body":false,"modal":true,"visible":_vm.replacementCustomerSync},on:{"update:visible":function($event){_vm.replacementCustomerSync=$event}}},[(_vm.showReplacement)?_c('replacement-customer',{attrs:{"oldWinner":_vm.winner,"tickets":_vm.tickets,"customers":_vm.customers,"automatic":_vm.config.event.automaticReplacement,"replacementCustomerSync":_vm.replacementCustomerSync},on:{"handleTicketPrint":_vm.handleTicketPrint}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xMTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexStatusReplication_vue__ = __webpack_require__("lfZT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae8f80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexStatusReplication_vue__ = __webpack_require__("C4ex");
function injectStyle (ssrContext) {
  __webpack_require__("/Ttc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ae8f80c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexStatusReplication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae8f80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexStatusReplication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xRT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blob_util__ = __webpack_require__("pDEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blob_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_blob_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_services_LGPD__ = __webpack_require__("rdXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'global-ranking-report-simplified',

  props: {
    events: {
      required: true
    },
    csvSeparator: {
      required: true,
      default: ';'
    },
    enablePartial: {
      default: false
    },
    enableLGPD: {
      default: false
    }
  },

  data: function data() {
    return {
      eventsData: {},
      event: {},
      options: {
        include_docs: true,
        inclusive_end: true,
        reduce: false,
        skip: 0
      },
      reporting: false,
      loadingTickets: true,
      loadingLamps: true,
      loadingSurveys: true,
      customersIds: [],
      reported: false,
      reportData: {},
      moreThanOneTicket: [],
      lampsCounterCustomer: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('users', ['usersIdName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('project', ['project']), {
    eventLabel: function eventLabel() {
      return localStorage.getItem('eventLabel') || 'Ações';
    },


    customersCouch: function customersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'customers' });
    },

    eventsCouch: function eventsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'events' });
    },

    ticketsCouch: function ticketsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'tickets' });
    },

    lampsCouch: function lampsCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'lamps' });
    },

    stocksCouch: function stocksCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: 'stocks' });
    },

    surveysCouch: function surveysCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'surveys', collection: 'surveys' });
    },

    manufacturersCouch: function manufacturersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'manufacturers' });
    },

    usersCouch: function usersCouch() {
      return new __WEBPACK_IMPORTED_MODULE_10_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: 'users' });
    },

    csvHeaders: function csvHeaders() {
      return {
        events: {
          'reference': 'Referência',
          'city': 'Município'
        },
        customers: {
          'uc': 'UC',
          'cpf': 'CPF',
          'holder': 'Titular',
          'phone1': 'Telefone 01',
          'phone2': 'Telefone 02',
          'city': 'Cidade',
          'userId': 'Atendente'
        },
        tickets: {
          'createdAt': 'Data de cadastro',
          'winner': 'Cliente comtemplado?'
        },
        lamps: {
          'changed': 'Trocou lampadas?',
          'count': 'Quantidade de lampadas?'
        }
      };
    },
    loading: function loading() {
      return this.loadingLamps && this.loadingTickets && this.loadingSurveys;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('project', { fetchProject: 'fetchOne' }), {
    mapKeyArrayToObject: function mapKeyArrayToObject(_ref) {
      var _this = this;

      var dataArray = _ref.dataArray,
          keyObject = _ref.keyObject,
          reportField = _ref.reportField;

      var _loop = function _loop(currentValue) {
        var keyObj = '';
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(keyObject.split('.')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            keyObj = keyObj === '' ? currentValue[key] : keyObj[key];
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (!_this.reportData[_this.event._id][reportField].hasOwnProperty(keyObj)) {
          _this.reportData[_this.event._id][reportField][keyObj] = [];
        }

        if (_this.reportData[_this.event._id][reportField][keyObj].find(function (item) {
          return item._id === currentValue._id;
        })) {
          return 'continue';
        }

        _this.reportData[_this.event._id][reportField][keyObj].push(currentValue);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(dataArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var currentValue = _step.value;

          var _ret = _loop(currentValue);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    loadingReport: function loadingReport() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        title: 'Informações',
        text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        onOpen: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.showLoading();
                    _context.next = 3;
                    return _this2.runReport();

                  case 3:
                    __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.hideLoading();
                    __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.close();

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function onOpen() {
            return _ref2.apply(this, arguments);
          };
        }()
      }).catch(function (err) {
        console.log(err);
      });
    },
    runReport: function runReport() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var report, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, e;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.reporting = true;
                _this3.$emit('progress', { current: 0, total: 0 });
                _this3.resetValues();
                report = _this3.addHeaders();
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 7;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this3.events);

              case 9:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context2.next = 21;
                  break;
                }

                e = _step3.value;

                _this3.event = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(e));
                if (!_this3.reportData.hasOwnProperty(e._id)) {
                  _this3.defineReportDataObject(e);
                }
                _context2.next = 15;
                return _this3.fetchData();

              case 15:
                _context2.next = 17;
                return _this3.handleReport();

              case 17:
                report += _context2.sent;

              case 18:
                _iteratorNormalCompletion3 = true;
                _context2.next = 9;
                break;

              case 21:
                _context2.next = 27;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t0;

              case 27:
                _context2.prev = 27;
                _context2.prev = 28;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 30:
                _context2.prev = 30;

                if (!_didIteratorError3) {
                  _context2.next = 33;
                  break;
                }

                throw _iteratorError3;

              case 33:
                return _context2.finish(30);

              case 34:
                return _context2.finish(27);

              case 35:
                report += _this3.addFooter();
                _this3.download(report);
                _this3.reporting = false;

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[7, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    fetchData: function fetchData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.fetchTickets();

              case 3:
                _context3.next = 5;
                return _this4.fetchLamps();

              case 5:
                _context3.next = 7;
                return _this4.fetchCustomers();

              case 7:
                _context3.next = 9;
                return _this4.fetchUsers();

              case 9:
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 14:
                return _context3.abrupt('return', true);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 11]]);
      }))();
    },
    fetchUsers: function fetchUsers() {
      var _this5 = this;

      return this.usersCouch.limit(999999).get().then(function (result) {
        return _this5.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'users' });
      });
    },
    fetchTickets: function fetchTickets() {
      var _this6 = this;

      return this.ticketsCouch.where('eventId', this.event._id).limit(99999999).get().then(function (result) {
        return _this6.mapKeyArrayToObject({ dataArray: result, keyObject: 'customerId', reportField: 'tickets' });
      });
    },
    fetchLamps: function fetchLamps() {
      var _this7 = this;

      return this.lampsCouch.where('eventId', this.event._id).limit(99999999).get().then(function (result) {
        return _this7.mapKeyArrayToObject({ dataArray: result, keyObject: 'customer.id', reportField: 'lamps' });
      });
    },
    fetchCustomers: function fetchCustomers() {
      var _this8 = this;

      var idsCustomers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].tickets).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { id: item });
      }).concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].lamps).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { id: item });
      }));
      return this.customersCouch._bulkGet(idsCustomers).then(function (result) {
        return _this8.mapKeyArrayToObject({ dataArray: result, keyObject: '_id', reportField: 'customers' });
      });
    },
    resetValues: function resetValues() {
      this.reporting = false;
      this.loadingTickets = true;
      this.loadingLamps = true;
      this.loadingSurveys = true;
      this.customersIds = [];
      this.reported = false;
      this.reportData = {};
      this.moreThanOneTicket = [];
      this.lampsCounterCustomer = {};
    },
    handleReport: function handleReport() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this9.moreThanOneTicket.length > 0)) {
                  _context4.next = 3;
                  break;
                }

                _this9.$notify({
                  message: '[ERROR: 409] Ocorreu um erro ao gerar o relatório. Entre em contato com o suporte e informe o código de erro 409.',
                  type: 'danger',
                  timeout: 10000
                });
                return _context4.abrupt('return', false);

              case 3:
                _context4.prev = 3;

                if (_this9.reporting) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return', _this9.makeReport());

              case 6:
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](3);

                _this9.$notify({
                  message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
                  type: 'danger',
                  timeout: 10000
                });
                console.log(_context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9, [[3, 8]]);
      }))();
    },
    addFooter: function addFooter() {
      return '\n"Arquivo gerado em: "' + this.csvSeparator + '"' + this.$moment(new Date()).format('DD-MM-YYYY HH:mm:ss') + '"';
    },
    makeReport: function makeReport() {
      var bodies = this.addBodies();

      if (!bodies) {
        this.$notify({ message: 'Dados insuficientes para gerar o relatório.', type: 'info' });
        return false;
      }

      return bodies;
    },
    download: function download(report) {
      var blob = __WEBPACK_IMPORTED_MODULE_8_blob_util___default.a.createBlob([report], { type: 'text/plain' });
      var now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss');
      var reportType = this.event.status === 2 ? 'Relatório_Simplificado_Geral' : 'Relatório_Simplificado_Parcial';
      var filename = reportType + '_' + now;
      this.reported = true;
      __WEBPACK_IMPORTED_MODULE_9_downloadjs___default()(blob, filename + '.csv');
    },
    addHeaders: function addHeaders() {
      var csv = this.addHeader(this.csvHeaders);
      return csv + '\n';
    },
    addHeader: function addHeader(headers) {
      var _this10 = this;

      var csv = '';
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(headers).forEach(function (header) {
        if (headers[header] !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(headers[header]) === 'object') {
          csv += _this10.addHeader(headers[header]);
        } else {
          csv += '' + headers[header] + _this10.csvSeparator;
        }
      });
      return csv;
    },
    addBodies: function addBodies() {
      var actualReportData = this.reportData[this.event._id];
      var csv = '';
      var current = 0;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.reportData[this.event._id].customers).length < 1) {
        this.reporting = false;
        this.$notify({ message: 'Não há clientes para este evento.', type: 'warning' });
        return '';
      }

      for (var customerId in actualReportData.customers) {
        csv += this.addEventReport(this.event);

        if (actualReportData.customers.hasOwnProperty(customerId)) {
          csv += this.addCustomerReport(actualReportData.customers[customerId][0]);
        } else {
          csv += this.addCustomerReport(undefined);
        }

        if (actualReportData.tickets.hasOwnProperty(customerId)) {
          csv += this.addTicketReport(actualReportData.tickets[customerId][0]);
        } else {
          csv += this.addTicketReport(undefined);
        }

        if (actualReportData.lamps.hasOwnProperty(customerId)) {
          csv += this.addLampsReport(actualReportData.lamps[customerId]);
        } else {
          csv += this.addLampsReport(undefined);
        }

        csv += this.csvSeparator + '\n';

        ++current;
        this.$emit('progress', { current: current, total: actualReportData.customers.length });
      }

      return csv;
    },
    addCustomerReport: function addCustomerReport(obj) {
      var csv = '';
      for (var field in this.csvHeaders.customers) {
        if (['street', 'number', 'neighborhood', 'city', 'zip', 'complement'].indexOf(field) !== -1 && obj.hasOwnProperty('address') && obj.address.hasOwnProperty(field)) {
          csv += '"' + obj['address'][field] + '"' + this.csvSeparator;
          continue;
        }
        csv += this.addDefaultCsv(field, obj);
      }
      return csv;
    },
    addEventReport: function addEventReport(obj) {
      var csv = '';
      for (var field in this.csvHeaders.events) {
        csv += this.addDefaultCsv(field, obj);
      }
      return csv;
    },
    addTicketReport: function addTicketReport(obj) {
      return this.addDefaultReport(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.csvHeaders.tickets), obj);
    },
    addLampsReport: function addLampsReport(lamps) {
      if (!lamps) {
        return 'N\xE3o' + this.csvSeparator + '-' + this.csvSeparator;
      }
      var csv = '';
      var count = lamps.reduce(function (sum, curr) {
        sum += curr.items.length;
        return sum;
      }, 0);
      csv += 'Sim' + this.csvSeparator;
      csv += '' + count + this.csvSeparator;

      return csv;
    },
    addDefaultReport: function addDefaultReport(fields, obj) {
      var csv = '';
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(fields), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var field = _step4.value;

          csv += '' + this.addDefaultCsv(field, obj);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return csv;
    },
    addDefaultCsv: function addDefaultCsv(key, obj) {
      if (this.fieldInvalid(key, obj)) {
        return '"-"' + this.csvSeparator;
      }

      if (key === 'userId' && this.reportData[this.event._id].users.hasOwnProperty(obj[key])) {
        return '"' + this.reportData[this.event._id].users[obj[key]][0].name + '"' + this.csvSeparator;
      }

      if (this.fieldDate(key)) {
        return this.addDate(key, obj);
      }

      if (this.fieldBoolean(key, obj)) {
        return this.addBoolean(key, obj);
      }

      if (this.fieldNumber(key)) {
        return this.addNumber(key, obj);
      }

      if (this.enableLGPD) {
        switch (key) {
          case 'holder':
            return '"' + __WEBPACK_IMPORTED_MODULE_11_src_services_LGPD__["a" /* default */].obfuscateString(obj[key]) + '"' + this.csvSeparator;
          default:
            break;
        }
      }

      return '"' + obj[key] + '"' + this.csvSeparator;
    },
    addDate: function addDate(key, obj) {
      if (!obj[key]) return '"-"' + this.csvSeparator;
      return '' + this.$moment(obj[key]).format('DD-MM-YYYY HH:mm:ss') + this.csvSeparator;
    },
    addBoolean: function addBoolean(key, obj) {
      if (obj[key] && obj[key].toString() === 'true') {
        return '"Sim"' + this.csvSeparator;
      }
      return '"Não"' + this.csvSeparator;
    },
    addNumber: function addNumber(key, obj) {
      return '"' + obj[key].replace('.', ',') + '"' + this.csvSeparator;
    },
    fieldDate: function fieldDate(key) {
      var fields = ['endDate', 'startDate', 'createdAt', 'dateTimeCeremony', 'documentedAt', 'dateInvoice', 'dateInvoicePowerCompany', 'updatedAt'];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(fields), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var field = _step5.value;

          if (key.includes(field)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    fieldInvalid: function fieldInvalid(key, obj) {
      return !obj || !obj.hasOwnProperty(key) || typeof obj[key] === 'undefined';
    },
    fieldBoolean: function fieldBoolean(key, obj) {
      return obj[key] === null || obj[key].toString() === 'true' || obj[key].toString() === 'false' || key.includes('drawn') || key.includes('checkIn');
    },
    fieldNumber: function fieldNumber(key) {
      return key.includes('score');
    },
    getUserIdName: function getUserIdName(id) {
      return this.usersIdName.hasOwnProperty(id) ? this.usersIdName[id] : 'deletado';
    },
    defineReportDataObject: function defineReportDataObject(event) {
      if (this.reportData.hasOwnProperty(event._id)) return;

      this.reportData[event._id] = {
        customers: {},
        tickets: {},
        surveys: {},
        lamps: {},
        manufacturers: {},
        stocks: {},
        users: {}
      };
    }
  }),

  mounted: function mounted() {
    this.fetchProject('config');
  }
});

/***/ }),

/***/ "xSky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesForm_vue__ = __webpack_require__("Ofbl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1182fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesForm_vue__ = __webpack_require__("1Kn4");
function injectStyle (ssrContext) {
  __webpack_require__("ZOKc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c1182fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1182fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xeBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsEventFormComponents_vue__ = __webpack_require__("XFT0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773511fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsEventFormComponents_vue__ = __webpack_require__("9AYq");
function injectStyle (ssrContext) {
  __webpack_require__("SqJ0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-773511fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsEventFormComponents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773511fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsEventFormComponents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xi0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xmDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('p-search',{on:{"on-search":function($event){return _vm.handleSearch($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"default-sort":{prop: 'createdAt', order: 'descending'}},on:{"sort-change":function($event){return _vm.handleSort($event)}}},[_c('el-table-column',{attrs:{"prop":"invoice","label":"NF Fabricante"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v("NF Concessionária: "+_vm._s(scope.row.invoicePowerCompany))]),_vm._v(" "),_c('p',[_vm._v("Descrição: "+_vm._s(scope.row.description))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"ti-info-alt"}),_vm._v(" "+_vm._s(scope.row.invoice)+"\n              ")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numberOfRefigerators","label":"Qtde","width":60}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"eventId","label":"Evento","min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.events instanceof Object)?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v("Município: "+_vm._s(_vm.events.hasOwnProperty(scope.row.eventId) ? _vm.events[scope.row.eventId].city : ''))]),_vm._v(" "),_c('p',[_vm._v("Referência: "+_vm._s(_vm.events.hasOwnProperty(scope.row.eventId) ? _vm.events[scope.row.eventId].reference : ''))]),_vm._v(" "),_c('p',[_vm._v("Cidade: "+_vm._s(_vm.events.hasOwnProperty(scope.row.eventId) ? _vm.events[scope.row.eventId].city : ''))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"ti-info-alt"}),_vm._v(_vm._s(_vm.events.hasOwnProperty(scope.row.eventId) ? _vm.events[scope.row.eventId].reference : '')+"\n              ")])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Criado Em","sortable":"custom","min-width":100},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm._f("moment")(new Date(scope.row.createdAt),'DD/MM/YYYY HH:mm:ss'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userId","label":"Criado Por","min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.getUserStock(scope.row.userId))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":{name: 'stock.edit', params: {id: props.row._id}}}},[(_vm.$can('stock.edit'))?_c('a',{staticClass:"btn btn-primary btn-fill btn-icon edit",attrs:{"title":"Editar estoque"}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e()])],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('p-pagination',{attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pagination-info text-right"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xmc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{attrs:{"multiple":"","filterable":"","size":"large","placeholder":"Filtros"},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.selecteds),callback:function ($$v) {_vm.selecteds=$$v},expression:"selecteds"}},_vm._l((_vm.tags),function(tag){return _c('el-option',{key:tag._id,attrs:{"value":tag._id,"label":tag.name}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xmkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListAbsent_vue__ = __webpack_require__("SAFq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1019db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListAbsent_vue__ = __webpack_require__("ulfJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingListAbsent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1019db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingListAbsent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xoRx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowCategories_vue__ = __webpack_require__("ctSI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ab1261_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowCategories_vue__ = __webpack_require__("VV8l");
function injectStyle (ssrContext) {
  __webpack_require__("f0zf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41ab1261"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ab1261_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xp4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total subscriptions "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('task-list'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('time-line',{attrs:{"type":"simple"}},[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n          11 hours ago via Twitter\n        ")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"success","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-info",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"info","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n            What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-chat"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Chat")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With Tania Andrew")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ol',{staticClass:"chat"},[_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Hola!\n                How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:20")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Puff...\n                I'm alright. How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:22")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])]),_vm._v(" "),_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                I'm ok too!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:24")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Well, it was nice hearing from you.\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"no-avatar"})]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                OK, bye-bye\n                See you!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"send-message"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})]),_vm._v(" "),_c('input',{staticClass:"form-control textarea",attrs:{"type":"text","placeholder":"Type here!"}}),_vm._v(" "),_c('div',{staticClass:"send-button"},[_c('button',{staticClass:"btn btn-primary btn-fill"},[_vm._v("Send")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xyxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-list"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.ticketsLoading),expression:"ticketsLoading"}],staticClass:"row"},[_c('div',{staticClass:"col-lg-7 col-xs-12"},[_c('ranking-list-winners',{attrs:{"tickets":_vm.ticketsWinners},on:{"cancelTicket":function($event){return _vm.cancelTicket($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-xs-12"},[_c('ranking-list-reserves',{attrs:{"tickets":_vm.ticketsReserves}})],1)]),_vm._v(" "),_c('div',{staticClass:"row ranking-list"},[_c('div',{staticClass:"col-xs-12"},[_c('ranking-list-absent',{attrs:{"tickets":_vm.ticketsClosed}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xzFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},_vm._l((_vm.docs),function(doc,i){return _c('div',{key:i,staticClass:"img-attch-ticket"},_vm._l((Object.keys(doc._attachments)),function(att,j){return _c('div',{key:j,staticClass:"attachment-file"},[_c('a',{attrs:{"href":_vm.getHref(doc._id, att),"target":"_blank"}},[_vm._v("\n          "+_vm._s(att)+"\n          ")])])}),0)}),0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Arquivos para este ticket")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y+/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-options',

  props: {
    'label': {}
  },

  data: function data() {
    return {
      userId: '',
      userActivate: this.onlyActivated || false
    };
  },


  watch: {
    showInactivate: function showInactivate() {
      var _this = this;

      this.$nextTick(function () {
        _this.userActivate = _this.showInactivate;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('users', {
    users: 'usersIdName',
    showInactivate: 'showInactivate'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('users', ['setUserSelected', 'fetchAll', 'setShowInactivate']), {
    setUser: function setUser() {
      this.$emit('setUser', { _id: this.userId, name: this.users[this.userId] });
      this.setUserSelected({ user: { _id: this.userId, name: this.users[this.userId] } });
    }
  }),

  mounted: function mounted() {
    this.setShowInactivate(false);
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.users).length === 0) {
      this.fetchAll({ limit: 99999 });
    }
  }
});

/***/ }),

/***/ "y+v+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BtnUploadFileInput',

  props: {
    ticket: {
      required: true,
      type: Object
    },

    event: {
      required: true,
      type: Object
    }
  },

  data: function data() {
    return {
      saving: false,
      selectedFiles: [],
      loading: false,
      isLoadingFile: false,
      typeFiles: [],
      binaryFiles: []
    };
  },


  computed: {
    filesSelected: function filesSelected() {
      return this.selectedFiles.length > 0;
    },
    unableToSend: function unableToSend() {
      var blockByWinnerRanking = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking';
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tickets', ['updateState', 'updateWithView']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('docs', {
    fetchDocs: 'fetchAll',
    insertDoc: 'insert',
    insertDocAttachment: 'insertAttachment'
  }), {
    handleSelectFile: function handleSelectFile() {
      this.$refs.filesContainer.click();
    },
    handleFiles: function handleFiles(data) {
      var _this = this;

      this.isLoadingFile = true;

      for (var index = 0; index < data.target.files.length; index++) {
        this.selectedFiles.push(data.target.files[index].name);
        this.typeFiles.push(data.target.files[index].type);
        this.loadFile(data.target.files[index]).then(function (binaryFiles) {
          _this.isLoadingFile = false;
          _this.binaryFiles.push(binaryFiles);
        });
      }
    },
    loadFile: function loadFile(file) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          resolve(e.target.result);
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    handleSaveFiles: function handleSaveFiles() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var docId, date, newTicket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.unableToSend) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', _this2.notifyUnable());

              case 2:

                _this2.loading = true;

                if (!_this2.verifyAmountFiles()) {
                  _context.next = 28;
                  break;
                }

                _this2.isLoadingFile = true;
                _context.next = 7;
                return _this2.getIdDocument();

              case 7:
                docId = _context.sent;
                _context.next = 10;
                return _this2.uploadDocuments(docId);

              case 10:
                date = new Date();
                newTicket = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.ticket, { documentedAt: date });


                delete newTicket.customer;
                delete newTicket.event;
                delete newTicket.stock;

                _context.prev = 15;
                _context.next = 18;
                return _this2.updateWithView({
                  ddoc: 'tickets-by-id',
                  view: 'tickets-by-id',
                  payload: newTicket,
                  database: 'default'
                });

              case 18:
                _this2.updateState({ documentedAt: date });
                _this2.resetFiles();
                _this2.isLoadingFile = false;
                _this2.notifySuccess();
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](15);

                console.log(_context.t0);

              case 27:
                _this2.loading = false;

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[15, 24]]);
      }))();
    },
    uploadDocuments: function uploadDocuments(docId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                index = 0;

              case 2:
                if (!(index < _this3.binaryFiles.length)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return _this3.insertDocAttachment({
                  docId: docId,
                  doc: {
                    mimeType: _this3.typeFiles[index],
                    attachmentName: _this3.selectedFiles[index],
                    attachment: _this3.binaryFiles[index]
                  }
                });

              case 5:
                index++;
                _context2.next = 2;
                break;

              case 8:
                return _context2.abrupt('return', true);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                return _context2.abrupt('return', false);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 11]]);
      }))();
    },
    getIdDocument: function getIdDocument() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var referenceDoc, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.fetchDocs({ where: { referenceId: _this4.ticket._id } });

              case 2:
                referenceDoc = _context3.sent;

                referenceDoc = referenceDoc.length > 0 ? referenceDoc[0] : undefined;

                if (!referenceDoc) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return', referenceDoc._id);

              case 6:
                _context3.next = 8;
                return _this4.insertDoc({
                  'database': "trg_eqpi_notiasc_admin",
                  'referenceId': _this4.ticket._id,
                  'collection': 'docs'
                });

              case 8:
                doc = _context3.sent;
                return _context3.abrupt('return', doc.id);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    verifyAmountFiles: function verifyAmountFiles() {
      if (this.binaryFiles.length === 0) {
        this.notifyNoFile();
        return false;
      } else {
        return true;
      }
    },
    notifyUnable: function notifyUnable() {
      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        text: 'N\xE3o \xE9 poss\xEDvel enviar documenta\xE7\xE3o para este cliente.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifyNoFile: function notifyNoFile() {
      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        text: 'Nenhum arquivo foi selecionado.',
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    notifySuccess: function notifySuccess() {
      this.$notify({
        message: 'Documentação salva com sucesso.',
        type: 'success'
      });
    },
    resetFiles: function resetFiles() {
      this.selectedFiles = [];
    }
  })
});

/***/ }),

/***/ "y4Zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnelCe_LendingTermEnelCe__ = __webpack_require__("iRF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnelGo_LendingTermEnelGo__ = __webpack_require__("7FZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cemar_LendingTermCemar__ = __webpack_require__("V20K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IascPi_LendingTermIasc__ = __webpack_require__("Bkzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IascMa_LendingTermIascMa__ = __webpack_require__("i6b2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IascAl_LendingTermIasc__ = __webpack_require__("0O1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnergisaPb_LendingTermEnergisaPb__ = __webpack_require__("/iRN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnergisaBorboremaPb_LendingTermEnergisaBorboremaPb__ = __webpack_require__("k6b8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Celpa_LendingTermCelpa__ = __webpack_require__("3suQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EquatorialPi_LendingTermEquatorialPi__ = __webpack_require__("Mbg7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CelpaJurunas_LendingTermCelpaJurunas__ = __webpack_require__("hMmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Trg_Terms_LendingTermGeneric__ = __webpack_require__("6S7i");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term',
  components: {
    LendingTermGeneric: __WEBPACK_IMPORTED_MODULE_11__components_Trg_Terms_LendingTermGeneric__["a" /* default */],
    LendingTermCelpaJurunas: __WEBPACK_IMPORTED_MODULE_10__CelpaJurunas_LendingTermCelpaJurunas__["a" /* default */],
    LendingTermEquatorialPi: __WEBPACK_IMPORTED_MODULE_9__EquatorialPi_LendingTermEquatorialPi__["a" /* default */],
    LendingTermEnelCe: __WEBPACK_IMPORTED_MODULE_0__EnelCe_LendingTermEnelCe__["a" /* default */],
    LendingTermEnelGo: __WEBPACK_IMPORTED_MODULE_1__EnelGo_LendingTermEnelGo__["a" /* default */],
    LendingTermCemar: __WEBPACK_IMPORTED_MODULE_2__Cemar_LendingTermCemar__["a" /* default */],
    LendingTermIascPi: __WEBPACK_IMPORTED_MODULE_3__IascPi_LendingTermIasc__["a" /* default */],
    LendingTermIascMa: __WEBPACK_IMPORTED_MODULE_4__IascMa_LendingTermIascMa__["a" /* default */],
    LendingTermIascAl: __WEBPACK_IMPORTED_MODULE_5__IascAl_LendingTermIasc__["a" /* default */],
    LendingTermEnergisaPb: __WEBPACK_IMPORTED_MODULE_6__EnergisaPb_LendingTermEnergisaPb__["a" /* default */],
    LendingTermEnergisaBorboremaPb: __WEBPACK_IMPORTED_MODULE_7__EnergisaBorboremaPb_LendingTermEnergisaBorboremaPb__["a" /* default */],
    LendingTermCelpa: __WEBPACK_IMPORTED_MODULE_8__Celpa_LendingTermCelpa__["a" /* default */]
  },
  props: {
    ticket: {
      required: true
    },
    config: {
      required: true
    },
    loading: {
      required: true
    },
    state: {
      required: true
    },
    customer: {
      required: true
    },
    manufacturer: {
      required: true
    },
    companyTerms: {
      required: true
    }
  }
});

/***/ }),

/***/ "y5T7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-light-bulb"}),_vm._v(" Lâmpadas Trocadas ("+_vm._s(_vm.countLamps)+")")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",on:{"click":function($event){return _vm.handleTermsDownload()}}},[_vm._v("\n          Download dos Termos\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.lamps}},[(_vm.hasEvent)?_c('el-table-column',{attrs:{"label":"Evento","property":"event"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.hasOwnProperty('event') && props.row.event.hasOwnProperty('reference') ? props.row.event.reference : '-'))]}}],null,false,3952664473)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Potência","property":"power"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.power)+"W")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tipo de Lâmpada Recebida","property":"type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Cômodo","property":"room"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hora em Uso por Dia","property":"usageHoursPerDay"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Trocada por","property":"power"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm.users[props.row.userId]))]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y5Wn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y9at":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yFiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Mp")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("My Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Ep")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Edit Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("S")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Settings")])])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n           Chet Fakerrr\n           "),_c('b',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yJ3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container",staticStyle:{"width":"calc(100% - 260px)"}},[_c('div',{staticClass:"copyright"},[_vm._v("\n      Desenvolvido por 3E Engenharia "+_vm._s(_vm.versionNumber)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yKB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[_c('li',_vm._l((_vm.members),function(member){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":member.image,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_vm._v("\n            "+_vm._s(member.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{class:_vm.getStatusClass(member.status)},[_c('small',[_vm._v(_vm._s(member.status))])])]),_vm._v(" "),_vm._m(0,true)])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3 text-right"},[_c('button',{staticClass:"btn btn-sm btn-success btn-icon"},[_c('i',{staticClass:"fa fa-envelope"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yKq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseModule__ = __webpack_require__("tv5d");




var _extends2;



var collection = 'docs';
var singleName = 'doc';
var pluralName = 'docs';
var connection = 'docs';

var model = {
  'referenceId': '',
  'collection': '',
  'createdAt': new Date(),
  'updatedAt': new Date(),
  '_attachments': {}
};
var validations = {
  database: { required: true },
  referenceId: { required: true },
  collection: { required: true }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["a" /* mapStates */])(), {
    loading: true,
    all: [],
    one: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model),
    validations: validations
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["b" /* mapMutations */])()),
  actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["c" /* mapActions */])(collection, model, connection)),
  getters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseModule__["d" /* mapGetters */])(), (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, singleName, function (state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, model, state.one);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, pluralName, function (state) {
    return state.all;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'loading', function loading(state) {
    return state.loading;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'validations', function validations(state) {
    return state.validations;
  }), _extends2))
});

/***/ }),

/***/ "yMmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeEventsTagNameToTagId_vue__ = __webpack_require__("XSiX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b16b01a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeEventsTagNameToTagId_vue__ = __webpack_require__("GjcG");
function injectStyle (ssrContext) {
  __webpack_require__("ikOl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b16b01a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeEventsTagNameToTagId_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b16b01a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeEventsTagNameToTagId_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yNZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yPnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__ = __webpack_require__("enEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MigrateConfigurationsToNewDatabase',

  computed: {
    collections: function collections() {
      return ['users', 'roles', 'projects', 'manufacturers', 'categories', 'tags', 'apis'];
    },
    CouchdbAdmin: function CouchdbAdmin() {
      return this.collections.reduce(function (accumulated, currentValue) {
        accumulated[currentValue] = new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'default', collection: currentValue });
        return accumulated;
      }, {});
    },
    CouchdbConfig: function CouchdbConfig() {
      return this.collections.reduce(function (accumulated, currentValue) {
        accumulated[currentValue] = new __WEBPACK_IMPORTED_MODULE_6_src_services_CouchdbClass__["a" /* default */]({ connection: 'config', collection: currentValue });
        return accumulated;
      }, {});
    }
  },

  methods: {
    migrate: function migrate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all(this.fetchData()).then(function (results) {
        _this.insertNewDatabase(results).then(function () {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: 'Migração finalizada',
            type: 'success',
            showConfirmButton: true
          });
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: 'Ocorreu uma falha ou os dados já foram migrados.',
            type: 'warning',
            showConfirmButton: true
          });
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchData: function fetchData() {
      var promises = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.collections), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var collection = _step.value;

          promises.push(this.CouchdbAdmin[collection].limit(9999999).all());
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return promises;
    },
    insertNewDatabase: function insertNewDatabase(results) {
      var promises = [];
      for (var iterator in results) {
        promises.push.apply(promises, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.inserDocsAttachments(results[iterator], this.collections[iterator])));
        promises.push(this.insertNew(results[iterator], this.collections[iterator]));
      }
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all(promises);
    },
    insertNew: function insertNew(result, collection) {
      return this.CouchdbConfig[collection]._insertBulk(result.map(function (item) {
        var doc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
        delete doc._rev;
        delete doc._attachments;
        return doc;
      }));
    },
    inserDocsAttachments: function inserDocsAttachments(result, collection) {
      var _this2 = this;

      return result.map(function (doc) {
        if (!doc.hasOwnProperty('_attachments')) {
          return [];
        }
        return [_this2.promiseInsertFile(doc, collection)];
      });
    },
    promiseInsertFile: function promiseInsertFile(doc, collection) {
      var couchdb = this.CouchdbConfig[collection];
      var couchdbAdmin = this.CouchdbAdmin[collection];
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
          var document, name, file;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  document = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(doc, {});
                  _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(document._attachments);

                case 2:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 19;
                    break;
                  }

                  name = _context.t1.value;
                  _context.next = 6;
                  return couchdbAdmin._getAttachment(document._id, name);

                case 6:
                  file = _context.sent;

                  console.log(file);
                  _context.prev = 8;
                  _context.next = 11;
                  return couchdb.insertAttachment(document._id, {
                    mymeType: file.type,
                    attachmentName: name,
                    attachment: file
                  });

                case 11:
                  _context.next = 17;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t2 = _context['catch'](8);

                  console.log(_context.t2);
                  reject(_context.t2);

                case 17:
                  _context.next = 2;
                  break;

                case 19:
                  resolve(true);

                case 20:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[8, 13]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),

/***/ "yTPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('button',{staticClass:"btn btn-danger btn-fill btn-wd",attrs:{"title":"Analisar todos os ids dos documentos em configurações e nos documentos do sistema, removendo duplicidades."},on:{"click":function($event){return _vm.handleCommand()}}},[_vm._v("\n    Remover duplicidade dos dados nas configurações\n  ")]),_vm._v(" "),_c('el-progress',{attrs:{"percentage":_vm.progressPercentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteLosers_vue__ = __webpack_require__("fkB5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d335380e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteLosers_vue__ = __webpack_require__("gsqU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteLosers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d335380e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteLosers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yWDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Trg_Filters_DashboardFormFilters__ = __webpack_require__("POBv");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardFilter',
  components: {
    DashboardFormFilters: __WEBPACK_IMPORTED_MODULE_2_src_components_Trg_Filters_DashboardFormFilters__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    rangeDate: 'rangeDate'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('tags', {
    tags: 'tags',
    tagsSelected: 'selecteds',
    textTagsFilters: 'textTagsFilters'
  }))
});

/***/ }),

/***/ "yWR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'tags.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yX6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersForm_vue__ = __webpack_require__("ncsX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620f1404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersForm_vue__ = __webpack_require__("01T7");
function injectStyle (ssrContext) {
  __webpack_require__("jxWh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620f1404_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yaHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewImages_vue__ = __webpack_require__("APnX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803bc7ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewImages_vue__ = __webpack_require__("+ddt");
function injectStyle (ssrContext) {
  __webpack_require__("WV3u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-803bc7ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyViewImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803bc7ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyViewImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ycPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Local que ocorrerá o evento")]),_vm._v(" "),_c('gmap-autocomplete',{ref:"inputAutocomplete",staticClass:"form-control form-control-alternative",staticStyle:{"width":"100%"},attrs:{"placeholder":"","value":_vm.place,"required":""},on:{"place_changed":_vm.setPlace}}),_vm._v(" "),_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"600px","margin-top":"10px"},attrs:{"center":_vm.marker,"zoom":_vm.defaultZoom,"options":{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
                gestureHandling: 'cooperative'
              }}},[_c('Gmap-Marker',{attrs:{"position":_vm.gps || _vm.marker,"draggable":true},on:{"dragend":_vm.setMarkerByClick}})],1),_vm._v(" "),_c('small',[_vm._v("Você pode clicar no mapa para marcar o local desejado.")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[(!_vm.img)?_c('webcam',{ref:"webcam",attrs:{"width":640,"height":480,"screenshotFormat":"image/jpeg"}}):_vm._e(),_vm._v(" "),(_vm.img)?_c('img',{staticClass:"img-thumbnail img-capture",attrs:{"src":this.img}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[(!_vm.img)?_c('button',{staticClass:"btn btn-fill btn-primary btn-wd",on:{"click":function($event){$event.preventDefault();return _vm.handleImageCapture()}}},[_c('i',{staticClass:"ti-camera"}),_vm._v("\n      Salvar Imagem\n    ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-primary btn-wd",on:{"click":function($event){return _vm.$refs['imgFile'].click()}}},[_c('input',{ref:"imgFile",staticStyle:{"display":"none"},attrs:{"id":"imgFile","type":"file","accept":"image/*"},on:{"change":_vm.selectImage}}),_vm._v("Upload Imagem\n    ")]),_vm._v(" "),(_vm.img)?_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"disabled":_vm.unabled},on:{"click":function($event){$event.preventDefault();return _vm.handleAcceptImage()}}},[_c('i',{staticClass:"ti-check"}),_vm._v("\n      Aceitar\n    ")]):_vm._e(),_vm._v(" "),(_vm.img)?_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",on:{"click":function($event){$event.preventDefault();return _vm.handleRefuseImage()}}},[_c('i',{staticClass:"ti-close"}),_vm._v("\n      Recusar\n    ")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-camera"}),_vm._v(" Foto ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yg6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__ = __webpack_require__("KyZi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__ = __webpack_require__("Ws9Q");
function injectStyle (ssrContext) {
  __webpack_require__("IsOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yhrE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc-energisa-borborema-pb',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Paraíba';
    },
    fullname: function fullname() {
      return this.abbreviation !== '' ? this.longname + ' - ' + this.abbreviation : this.longname;
    },
    longname: function longname() {
      return 'Energisa Borborema';
    },
    abbreviation: function abbreviation() {
      return '';
    },
    projectName: function projectName() {
      return 'Nossa Energia';
    },
    address: function address() {
      return {
        type: 'BR',
        street: '230',
        number: 'Km 158',
        neighborhood: 'Bairro 3 Irmãs',
        city: 'Campina Grande',
        state: 'PB'
      };
    },
    cnpj: function cnpj() {
      return '08.826.596/0001-95';
    },
    numberState: function numberState() {
      return '16.003.839/1';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "yk0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__ = __webpack_require__("Dlhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__ = __webpack_require__("fd3O");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lending-term-iasc-al',
  components: { SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_1__SignatureCustomerTicket__["a" /* default */], HeaderTerm: __WEBPACK_IMPORTED_MODULE_3__HeaderTerm__["a" /* default */] },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('project', ['urlImages']), {
    stateName: function stateName() {
      return 'Alagoas';
    },
    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Equatorial Alagoas Distribuidora De Energia S.A.';
    },
    abbreviation: function abbreviation() {
      return 'CEAL';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Rua',
        street: 'Fernandes Lima',
        number: '3349',
        neighborhood: 'Farol',
        city: 'Maceió',
        state: 'AL'
      };
    },
    cnpj: function cnpj() {
      return '12.272.084/0001-00';
    },
    numberState: function numberState() {
      return '24007177-8';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('project', ['getImagesProject'])),

  mounted: function mounted() {
    this.getImagesProject();
  }
});

/***/ }),

/***/ "ykHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TicketForm',

  props: {
    customer: { required: true, type: Object },
    ticketLoaded: { type: Boolean },
    winnerLoaded: { type: Boolean },
    tickets: {}
  },

  data: function data() {
    return {
      saving: false,
      isWinnerTrgOlder: false
    };
  },


  watch: {
    eventSelected: function eventSelected() {
      var _this = this;

      this.$nextTick(function () {
        _this.setTicketBarcode();
      });
    },
    customer: function customer() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setTicketBarcode();
      });
    },
    winner: function winner() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.checkWinnerOld();
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('tickets', {
    resetOne: 'resetOne',
    createTicket: 'createTicket',
    updateDefaultModel: 'updateDefaultModel'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['setEventSelected']), {
    handleCreateTicket: function handleCreateTicket() {
      var _this4 = this;

      this.saving = true;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.saveNewTicket();
        }
      });
    },
    saveNewTicket: function saveNewTicket() {
      var _this5 = this;

      var _JSON$parse = JSON.parse(localStorage.getItem('user')),
          userId = _JSON$parse._id;

      var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model);
      doc.collection = 'tickets';
      doc.customerId = this.customer._id;
      doc.winner = false;
      doc.eligible = this.isEligible;
      doc.reasonNotEligible = !this.isEligible ? 'Já foi contemplado anteriormente.' : '';
      doc.userId = userId;
      this.createTicket(doc).then(function (result) {
        if (result.ticketCreated) {
          _this5.$notify({
            message: result.message,
            type: 'success'
          });
          _this5.setEventId();
          _this5.$emit('on-ticket-create', {});
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
            title: 'Ocorreu um erro.',
            text: result.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }
      }).finally(function (e) {
        _this5.saving = false;
      });
    },
    handleSelectEvent: function handleSelectEvent() {
      this.setEventSelected(this.model.eventId);
      this.setTicketBarcode();
    },
    setTicketBarcode: function setTicketBarcode() {
      this.model.barcode = '' + this.customer.uc + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.random(10000000, 99999999);
      return this.updateDefaultModel({ barcode: this.model.barcode });
    },
    setEventId: function setEventId() {
      if (this.eventSelected.hasOwnProperty('_id')) {
        this.model.eventId = this.eventSelected._id;
        return this.updateDefaultModel({ eventId: this.eventSelected._id });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    checkWinnerOld: function checkWinnerOld() {
      var uc = this.config.validationContemplatedCustomer.uc && this.winner ? this.customer.uc === this.winner.uc : false;

      var cpf = this.config.validationContemplatedCustomer.cpf && this.winner ? this.customer.cpf.replace(/\D/g, '') === this.winner.cpf : false;

      var validPeriod = false;
      if (this.winner && this.winner.exchangeDate !== '') {
        var period = parseInt(this.config.event.contemplatedPeriod);
        var currentYear = parseInt(new Date().getFullYear());
        var exchangedAt = parseInt(new Date(this.winner.exchangeDate).getFullYear());

        validPeriod = exchangedAt + period < currentYear;
      }

      this.isWinnerTrgOlder = this.config.validationContemplatedCustomer.uc && this.config.validationContemplatedCustomer.cpf ? uc && cpf && !validPeriod : (uc || cpf) && !validPeriod;
    }
  }),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['eventId', 'barcode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('project', {
    config: 'project',
    loadingProject: 'loading'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['eventSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('events', {
    eventsOptions: 'startedOptions'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('tickets', {
    model: 'ticket',
    modelValidations: 'validations',
    loading: 'loading'
  }), {

    winner: {
      get: function get() {
        if (this.$store.state.winners.all.lenght > 0) {
          return this.$store.state.winners.all[0];
        }
        return {};
      }
    },


    isWinnerTrgNewer: function isWinnerTrgNewer() {
      if (this.tickets && this.tickets.length > 0) {
        return this.tickets.find(function (item) {
          return item.winner;
        }) !== undefined;
      } else {
        return false;
      }
    },

    isEligible: function isEligible() {
      return !this.isWinnerTrgNewer && !this.isWinnerTrgOlder;
    }
  }),

  mounted: function mounted() {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config');
    }
    if (this.customer) {
      this.setTicketBarcode();
    }

    this.setEventId();
  }
});

/***/ }),

/***/ "yldw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__ = __webpack_require__("pk/q");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'associated-tickets-print',

  data: function data() {
    return {
      tickets: [],
      customers: {},
      surveys: {}
    };
  },


  computed: {
    eventId: function eventId() {
      return this.$route.params.id;
    },
    loaded: function loaded() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.customers).length > 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tickets).length > 0;
    },
    surveyTakenIds: function surveyTakenIds() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.surveys);
    }
  },

  methods: {
    fetchTickets: function fetchTickets() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__["a" /* default */].connection('default').view({
        ddoc: 'tickets-associated-by-event',
        view: 'tickets-associated-by-event',
        key: this.eventId
      }).then(function (response) {
        if (response.rows && response.rows[0]) {
          _this.tickets = response.rows.map(function (item) {
            return item.value;
          });
          _this.fetchCustomers();
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchCustomers: function fetchCustomers() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__["a" /* default */].connection('default').view({
        ddoc: 'customers-by-id',
        view: 'customers-by-id',
        keys: this.tickets.map(function (item) {
          return item.customerId;
        })
      }).then(function (res) {
        if (!res.rows) {
          return;
        }
        _this2.customers = res.rows.map(function (item) {
          return item.value;
        }).reduce(function (acc, curr, index) {
          if (index === 0) {
            acc = {};
          }
          acc[curr._id] = curr;
          return acc;
        }, {});
        _this2.fetchSurveys();
      });
    },
    fetchSurveys: function fetchSurveys() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_src_services_Couchdb__["a" /* default */].connection('surveys').view({
        ddoc: 'surveys-by-event',
        view: 'surveys-by-event',
        key: this.eventId
      }).then(function (res) {
        if (!res.rows) {
          _this3.failed = true;
        }
        _this3.surveys = res.rows.map(function (item) {
          return item.value;
        }).reduce(function (acc, curr, indx) {
          if (indx === 0) {
            acc = {};
          }
          if (!acc.hasOwnProperty(curr.user._id)) {
            acc[curr.user._id] = [];
          }
          acc[curr.user._id].push(curr);
          return acc;
        }, {});
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getAddress: function getAddress(customer) {
      var addressText = customer.address.street + ', ' + customer.address.number + ', ' + customer.address.neighborhood + ', ' + customer.address.zip;
      addressText = customer.address.zip ? addressText + (', ' + customer.address.zip) : addressText;
      return addressText;
    }
  },

  mounted: function mounted() {
    if (this.eventId) {
      this.fetchTickets();
    }
  }
});

/***/ }),

/***/ "yntV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("tecN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b01c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("D/ca");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b01c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ypVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_pages_Users_Users_vue__ = __webpack_require__("0Bzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_pages_Users_UsersForm_vue__ = __webpack_require__("yX6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_Users_UsersIndex_vue__ = __webpack_require__("DxtY");




var path = 'users';
var title = 'Usuários';

/* harmony default export */ __webpack_exports__["a"] = ({
  path: path,
  component: __WEBPACK_IMPORTED_MODULE_0_src_pages_Users_Users_vue__["a" /* default */],
  children: [{
    path: '',
    name: path + '.index',
    component: __WEBPACK_IMPORTED_MODULE_2_src_pages_Users_UsersIndex_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'create',
    name: path + '.create',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Users_UsersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }, {
    path: 'edit/:id',
    name: path + '.edit',
    component: __WEBPACK_IMPORTED_MODULE_1_src_pages_Users_UsersForm_vue__["a" /* default */],
    meta: {
      title: title,
      requireAuth: true
    }
  }]
});

/***/ }),

/***/ "yq1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ticket-download-documents"},[(_vm.icon)?_c('button',{staticClass:"btn btn-default btn-icon btn-fill btn-sm",attrs:{"disabled":_vm.unabled,"type":"button","title":"Download documentação"},on:{"click":_vm.zipper}},[_c('i',{staticClass:"fa fa-download"})]):_c('button',{staticClass:"btn btn-block btn-fill btn-wd btn-default",attrs:{"disabled":_vm.unabled},on:{"click":function($event){return _vm.zipper()}}},[_vm._v("\n    Download Documentação\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"canvasPlace"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yqcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yuLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioColors_vue__ = __webpack_require__("bVnl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8779c966_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioColors_vue__ = __webpack_require__("sk0G");
function injectStyle (ssrContext) {
  __webpack_require__("YNtA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8779c966"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioColors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8779c966_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioColors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yvbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__ = __webpack_require__("Dlhx");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lamp-term-iasc-ma',
  components: {
    SignatureCustomerTicket: __WEBPACK_IMPORTED_MODULE_4__SignatureCustomerTicket__["a" /* default */]
  },

  props: {
    ticket: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    payload: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
      }
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data: function data() {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lamps', ['lampsTmp']), {

    numLedLampsDelivered: function numLedLampsDelivered() {
      return this.lampsTmp.length;
    },

    fullname: function fullname() {
      return this.longname + ' - ' + this.abbreviation;
    },
    longname: function longname() {
      return 'Companhia Energética do Maranhão';
    },
    abbreviation: function abbreviation() {
      return 'CEMAR';
    },
    projectName: function projectName() {
      return 'IASC 2019';
    },
    fulladdress: function fulladdress() {
      return this.address.type + ' ' + this.address.street + ', n\xBA ' + this.address.number + ' \u2013 ' + this.address.neighborhood + ', ' + this.address.city + '/' + this.address.state;
    },
    address: function address() {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      };
    },
    cnpj: function cnpj() {
      return '06.272.793/0001-84';
    },
    numberState: function numberState() {
      return '06.105.848-3';
    }
  }),

  mounted: function mounted() {
    this.setValues();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['resetOne']), {
    setValues: function setValues() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.payload.lamps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lamp = _step.value;

          if (lamp.type === 'Fluorescente') {
            this.numFluorescentLampsReceived++;
            this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          } else if (lamp.type === 'Incandescente') {
            this.numIncandescentBulbsReceived++;
            this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? lamp.power + 'W' : ', ' + lamp.power + 'W';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ "yyPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z33l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z48K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Full Screen Map")])]),_vm._v(" "),_c('div',{staticClass:"full-screen-map",attrs:{"id":"map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4QI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eventIdSelected: '',
      isLoading: false,
      progress: 0,
      total: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('events', {
    events: 'events'
  }), {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), {
    handleAddEventIdFromLamps: function handleAddEventIdFromLamps() {
      var _this = this;

      this.isLoading = true;
      this.total = 0;
      __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].collection('lamps').where('eventId', { '$or': [{ '$exists': false }, { '$eq': null }] }).get().then(function (docs) {
        _this.isLoading = false;
        _this.progress = 0;
        _this.total = docs.length;
        var swalOptions = {
          title: 'Existem ' + _this.total + ' l\xE2mpadas.'
        };
        if (_this.total === 0) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            title: swalOptions.title,
            text: 'Todas as l\xE2mpadas possui evento.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            title: swalOptions.title,
            html: 'Voc\xEA quer setar o evento em todos as l\xE2mpadas?',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, faça isso!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, lamp;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(docs);

                  case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context.next = 12;
                      break;
                    }

                    lamp = _step.value;
                    _context.next = 9;
                    return _this.exec(lamp).then(function (result) {
                      if (_this.progress === _this.total) {
                        _this.notifyFinish();
                      }
                    }).catch(function (err) {
                      console.log(err);
                      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                        width: 1000,
                        title: 'Ocorreu um erro ao executar essa ação.',
                        text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err),
                        type: 'error',
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                      });
                    });

                  case 9:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                  case 12:
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                  case 18:
                    _context.prev = 18;
                    _context.prev = 19;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 21:
                    _context.prev = 21;

                    if (!_didIteratorError) {
                      _context.next = 24;
                      break;
                    }

                    throw _iteratorError;

                  case 24:
                    return _context.finish(21);

                  case 25:
                    return _context.finish(18);

                  case 26:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
          })));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    exec: function exec(lamp) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, event, update;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this2.events);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 16;
                  break;
                }

                event = _step2.value;

                if (!(event.startDate <= lamp.createdAt && lamp.createdAt <= event.dateTimeCeremony)) {
                  _context2.next = 12;
                  break;
                }

                lamp.eventId = event._id;
                return _context2.abrupt('break', 16);

              case 12:
                lamp.eventId = null;

              case 13:
                _iteratorNormalCompletion2 = true;
                _context2.next = 5;
                break;

              case 16:
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 22:
                _context2.prev = 22;
                _context2.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context2.prev = 25;

                if (!_didIteratorError2) {
                  _context2.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context2.finish(25);

              case 29:
                return _context2.finish(22);

              case 30:
                _context2.next = 32;
                return __WEBPACK_IMPORTED_MODULE_5_src_services_Couchdb__["a" /* default */].update(lamp._id, lamp);

              case 32:
                update = _context2.sent;

                _this2.progress = _this2.progress + 1;
                return _context2.abrupt('return', update);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    notifyFinish: function notifyFinish() {
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Sucesso',
        text: 'A\xE7\xE3o executada com sucesso.',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    }
  })
});

/***/ }),

/***/ "z6dB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Trg_EventsSpecifications_EventLocalMap__ = __webpack_require__("GIE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Trg_EventsSpecifications_InputRadioIconRefrigeratoMap__ = __webpack_require__("JShI");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormEventsSpecifications',
  components: {
    EventLocalMap: __WEBPACK_IMPORTED_MODULE_4__components_Trg_EventsSpecifications_EventLocalMap__["a" /* default */],
    InputRadioIconRefrigeratoMap: __WEBPACK_IMPORTED_MODULE_5__components_Trg_EventsSpecifications_InputRadioIconRefrigeratoMap__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('eventsSpecifications', ['eventSpecifications']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('categories', ['categories']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('tags', ['tagsByCategories'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tags', { fetchTags: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('categories', { fetchCategories: 'fetchAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('eventsSpecifications', ['fetchOne', 'setTags', 'upsert']), {
    handleSave: function handleSave() {
      var _this = this;

      this.upsert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.eventSpecifications, { tagsIds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.eventSpecifications.tags) })).then(function () {
        _this.$router.push({ name: 'eventsSpecifications.index' });
      });
    },
    handlInputTag: function handlInputTag(event) {
      this.setTags({ categorie: event.target.name, tag: event.target._value });
    },
    checkedTag: function checkedTag(categorie, tag) {
      return this.eventSpecifications.tags.hasOwnProperty(categorie) && this.eventSpecifications.tags[categorie] === tag;
    }
  }),
  mounted: function mounted() {
    this.fetchTags({ limit: 999 });
    this.fetchCategories({ limit: 9999 });
    this.fetchOne(this.$route.params.id);
  }
});

/***/ }),

/***/ "zDTK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.event),expression:"!event"}],staticClass:"event-card"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"ti-user"}),_vm._v(" Dados: "+_vm._s(_vm.label))])]),_vm._v(" "),(_vm.showEditButton)?_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{attrs:{"to":{name: 'events.edit', params: {id: _vm.event._id}}}},[(_vm.$can('events.edit'))?_c('a',{staticClass:"btn btn-fill btn-primary btn-sm btn"},[_c('i',{staticClass:"ti-pencil"}),_vm._v(" Editar")]):_vm._e()])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Município")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event.city))]),_vm._v(" "),_c('dt',[_vm._v("Referência")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event.reference))]),_vm._v(" "),_c('dt',[_vm._v("Local")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event.place))]),_vm._v(" "),_c('dt',[_vm._v("Data de Início")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("moment")(new Date(_vm.event.startDate).toISOString(),'L')))]),_vm._v(" "),_c('dt',[_vm._v("Data de Fim")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("moment")(new Date(_vm.event.endDate).toISOString(),'L')))]),_vm._v(" "),_c('dt',[_vm._v("Data da Cerimônia")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("moment")(new Date(_vm.event.dateTimeCeremony).toISOString(),'L')))]),_vm._v(" "),_c('dt',[_vm._v("Nº de Refrigeradores")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event.numberOfRefigerators))]),_vm._v(" "),_c('dt',[_vm._v("Situação")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.event.present.status))]),_vm._v(" "),_c('dt',[_vm._v("Criado por:")]),_vm._v(" "),_c('dd',[_c('strong',[_vm._v(_vm._s(_vm.users[_vm.event.userId]))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zEvt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__ = __webpack_require__("pk/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-event-id-on-lamps',
  data: function data() {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      eventLamps: 0,
      events: [],
      lamps: []
    };
  },

  computed: {
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    }
  },
  methods: {
    handleCommand: function handleCommand() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _this.total = 0;
                _this.progress = 0;
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('lamps').select(['_id']).where('eventId', { '$exists': false }).all();

              case 6:
                _this.lamps = _context.sent;

                _this.total = _this.lamps.length;
                _this.isLoading = false;
                if (_this.total === 0) {
                  _this.notifyFinish();
                } else {
                  _this.notifyAmount().then(function () {
                    try {
                      _this.exec();
                    } catch (e) {
                      console.log('Falha no processo', e);
                    }
                  });
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.isLoading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 12]]);
      }))();
    },
    exec: function exec() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, lamp, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, event;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.events);

                if (!(_this2.events.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this2.getEvents();

              case 4:
                if (false) {
                  _context2.next = 79;
                  break;
                }

                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('lamps').where('eventId', { '$exists': false }).limit(5).all();

              case 7:
                _this2.lamps = _context2.sent;

                if (!(_this2.lamps.length <= 0)) {
                  _context2.next = 12;
                  break;
                }

                _this2.progress = _this2.progress < 100 ? ++_this2.progress : _this2.progress;
                _this2.notifyFinish();
                return _context2.abrupt('return', true);

              case 12:
                promises = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 16;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.lamps);

              case 18:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 55;
                  break;
                }

                lamp = _step.value;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 23;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.events);

              case 25:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 36;
                  break;
                }

                event = _step2.value;

                if (!(event.startDate <= lamp.createdAt && event.endDate >= lamp.createdAt)) {
                  _context2.next = 32;
                  break;
                }

                lamp.eventId = event._id;
                return _context2.abrupt('break', 36);

              case 32:
                lamp.eventId = null;

              case 33:
                _iteratorNormalCompletion2 = true;
                _context2.next = 25;
                break;

              case 36:
                _context2.next = 42;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t0 = _context2['catch'](23);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 42:
                _context2.prev = 42;
                _context2.prev = 43;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 45:
                _context2.prev = 45;

                if (!_didIteratorError2) {
                  _context2.next = 48;
                  break;
                }

                throw _iteratorError2;

              case 48:
                return _context2.finish(45);

              case 49:
                return _context2.finish(42);

              case 50:
                promises.push(__WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('lamps').update(lamp._id, lamp));
                ++_this2.progress;

              case 52:
                _iteratorNormalCompletion = true;
                _context2.next = 18;
                break;

              case 55:
                _context2.next = 61;
                break;

              case 57:
                _context2.prev = 57;
                _context2.t1 = _context2['catch'](16);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 61:
                _context2.prev = 61;
                _context2.prev = 62;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 64:
                _context2.prev = 64;

                if (!_didIteratorError) {
                  _context2.next = 67;
                  break;
                }

                throw _iteratorError;

              case 67:
                return _context2.finish(64);

              case 68:
                return _context2.finish(61);

              case 69:
                _context2.prev = 69;
                _context2.next = 72;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

              case 72:
                _context2.next = 77;
                break;

              case 74:
                _context2.prev = 74;
                _context2.t2 = _context2['catch'](69);

                console.log('Error when was updating the lamp', _context2.t2);

              case 77:
                _context2.next = 4;
                break;

              case 79:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[16, 57, 61, 69], [23, 38, 42, 50], [43,, 45, 49], [62,, 64, 68], [69, 74]]);
      }))();
    },
    notifyAmount: function notifyAmount() {
      return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Lâmpadas',
        html: 'Deseja inserir o ID do evento nas ' + this.total + ' trocas de l\xE2mpadas?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, inserir ID!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      });
    },
    notifyFinish: function notifyFinish() {
      this.total = 1;
      this.progress = 1;
      this.eventLamps = 1;
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Sucesso',
        text: 'Todas as l\xE2mpadas foram atualizadas com seus respectivos ID dos eventos',
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    getEvents: function getEvents() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_src_services_Couchdb__["a" /* default */].collection('events').select(['startDate', 'endDate', '_id']).all();

              case 2:
                _this3.events = _context3.sent;
                return _context3.abrupt('return', true);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "zFT3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zG9H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zH8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zPiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LampsReport__ = __webpack_require__("2s9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LampsReportSimplified__ = __webpack_require__("uptt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventsReport__ = __webpack_require__("Hcdn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GlobalRankingReport2__ = __webpack_require__("VHO4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GlobalRankingReportSimplified__ = __webpack_require__("n7La");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GeneralCounterReport__ = __webpack_require__("NtKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_EventsOptions__ = __webpack_require__("oVfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trg_Filters_DashboardFormFilters__ = __webpack_require__("POBv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_DashboardCounter__ = __webpack_require__("fzNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LampsUsersReport__ = __webpack_require__("gQ9i");



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-index',

  components: {
    LampsReportSimplified: __WEBPACK_IMPORTED_MODULE_6__LampsReportSimplified__["a" /* default */],
    GlobalRankingReportSimplified: __WEBPACK_IMPORTED_MODULE_9__GlobalRankingReportSimplified__["a" /* default */],
    DashboardFormFilters: __WEBPACK_IMPORTED_MODULE_12__components_Trg_Filters_DashboardFormFilters__["a" /* default */],
    EventsReport: __WEBPACK_IMPORTED_MODULE_7__EventsReport__["a" /* default */],
    LampsReport: __WEBPACK_IMPORTED_MODULE_5__LampsReport__["a" /* default */],
    GlobalRankingReport: __WEBPACK_IMPORTED_MODULE_8__GlobalRankingReport2__["a" /* default */],
    GeneralCounterReport: __WEBPACK_IMPORTED_MODULE_10__GeneralCounterReport__["a" /* default */],
    EventsOptions: __WEBPACK_IMPORTED_MODULE_11_src_components_EventsOptions__["a" /* default */],
    LampsUsersReport: __WEBPACK_IMPORTED_MODULE_15__LampsUsersReport__["a" /* default */]
  },

  data: function data() {
    return {
      eventsChosen: [],
      eventChoice: 'many',
      loading: false,
      allProject: false,
      csvSeparator: ';',
      eventSelected: '',
      total: 0,
      progress: 0,
      allEvents: false,
      enablePartial: false,
      enableLGPD: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({ formatedDate: 'formatedDate' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('events', { optionsById: 'optionsById', events: 'events' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('tags', { tagsSelected: 'selecteds' }), {
    eventLabel: function eventLabel() {
      return localStorage.getItem('eventLabel') || 'Ações';
    },
    eventsOptions: function eventsOptions() {
      var _this = this;

      return this.optionsById ? this.optionsById.filter(function (item) {
        return item.status === 2 || _this.enablePartial;
      }) : [];
    },
    progressPercentage: function progressPercentage() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progress / this.total * 100);
    },
    progressPercentageSimplified: function progressPercentageSimplified() {
      if (this.total === 0) {
        return 0;
      }
      return parseInt(this.progressSimplified / this.total * 100);
    },
    isEventRanking: function isEventRanking() {
      return this.event && this.event.winnerChoiceMode === 'ranking';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('events', {
    fetchEvents: 'fetchAll'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('eventsSpecifications', { fetchSpecifications: 'fetchAll' }), {
    handleFilter: function handleFilter() {
      var _this2 = this;

      var whereTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_DashboardCounter__["b" /* defineWhereObject */])(undefined, this.tagsSelected, 'tagsIds');
      console.log(whereTags, this.tagsSelected);
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        title: 'Aguarde',
        type: 'info',
        html: 'Executando o filtro',
        showConfirmButton: false,
        onBeforeOpen: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.showLoading();

                    _context.next = 3;
                    return _this2.fetchSpecifications({
                      where: {
                        '$and': whereTags['$and']
                      },
                      limit: 99999
                    }).then(function (specifications) {
                      var whereQuery = [];
                      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_DashboardCounter__["a" /* verifyEmptyTags */])(_this2.tagsSelected)) {
                        whereQuery.push({
                          '$or': specifications.map(function (item) {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
                              _id: item.eventId
                            });
                          })
                        });
                      }

                      if (_this2.formatedDate && _this2.formatedDate.length === 2) {
                        whereQuery.push({
                          'startDate': {
                            '$gte': _this2.formatedDate[0]
                          }
                        });
                        whereQuery.push({
                          'endDate': {
                            '$lte': _this2.formatedDate[1]
                          }
                        });
                      }

                      return whereQuery.length > 0 ? _this2.fetchEvents({
                        where: {
                          '$and': whereQuery
                        },
                        limit: 99999999
                      }) : _this2.fetchEvents({
                        limit: 99999999,
                        sort: { field: 'createdAt', direction: 'desc' }
                      });
                    });

                  case 3:

                    setTimeout(function () {
                      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
                    }, 1000);

                  case 4:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function onBeforeOpen() {
            return _ref.apply(this, arguments);
          };
        }()
      });
    },
    handleSimplifiedFilter: function handleSimplifiedFilter() {
      var _this3 = this;

      var whereTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_DashboardCounter__["b" /* defineWhereObject */])(undefined, this.tagsSelected, 'tagsIds');
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        title: 'Aguarde',
        type: 'info',
        html: 'Executando o filtro',
        showConfirmButton: false,
        onBeforeOpen: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.showLoading();

                    _context2.next = 3;
                    return _this3.fetchSpecifications({
                      where: {
                        '$and': whereTags['$and']
                      },
                      limit: 99999
                    }).then(function (specifications) {
                      var whereQuery = [];
                      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_DashboardCounter__["a" /* verifyEmptyTags */])(_this3.tagsSelected)) {
                        whereQuery.push({
                          '$or': specifications.map(function (item) {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
                              _id: item.eventId
                            });
                          })
                        });
                      }

                      if (_this3.formatedDate && _this3.formatedDate.length === 2) {
                        whereQuery.push({
                          'startDate': {
                            '$gte': _this3.formatedDate[0]
                          }
                        });
                        whereQuery.push({
                          'endDate': {
                            '$lte': _this3.formatedDate[1]
                          }
                        });
                      }

                      return whereQuery.length > 0 ? _this3.fetchEvents({
                        where: {
                          '$and': whereQuery
                        },
                        limit: 99999999
                      }) : _this3.fetchEvents({
                        limit: 99999999
                      });
                    });

                  case 3:

                    setTimeout(function () {
                      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
                    }, 1000);

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3);
          }));

          return function onBeforeOpen() {
            return _ref2.apply(this, arguments);
          };
        }()
      });
    },
    onEventSelected: function onEventSelected(event) {
      this.eventSelected = event;
      if (typeof event === 'string') {
        this.eventSelected = [event];
      }

      this.setEventChosen();
    },
    setEventChosen: function setEventChosen() {
      var _this4 = this;

      this.eventsChosen = this.events ? this.eventSelected.map(function (event) {
        return _this4.events.find(function (item) {
          return event === item._id;
        });
      }).filter(function (item) {
        return item;
      }) : [];
    },
    setProgress: function setProgress(_ref3) {
      var current = _ref3.current,
          total = _ref3.total;

      this.progress = current;
      this.total = total;
      if (this.progress < this.total) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    },
    setProgressSimplified: function setProgressSimplified(_ref4) {
      var current = _ref4.current,
          total = _ref4.total;

      this.progressSimplified = current;
      this.total = total;
      if (this.progressSimplified < this.total) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    }
  }),
  mounted: function mounted() {
    this.loading = false;
    this.progress = 0;
    this.progressSimplified = 0;
    this.total = 0;
    this.fetchEvents({ limit: 9999999 });
  }
});

/***/ }),

/***/ "zSxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_validations__ = __webpack_require__("7HpB");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdditionalDataForm',
  props: {
    customer: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      saving: false,
      addressStreet: '',
      addressNumber: '',
      addressNeighborhood: '',
      addressCity: '',
      addressZip: '',
      addressComplement: '',
      nis: '',
      regularity: '',
      maxLengthNIS: 11,
      errorNIS: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* mapFields */])(['street', 'number', 'neighborhood', 'city', 'zip', 'complement']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('customers', {
    modelValidations: 'validations'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('project', {
    'citiesOptions': 'citiesOptions',
    config: 'project',
    loading: 'loading'
  }), {

    nisRequired: function nisRequired() {
      return this.config.requiredNIS;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('project', {
    fetchProject: 'fetchOne'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('customers', ['upsert', 'changeLoading']), {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleSave: function handleSave() {
      var _this = this;

      this.saving = true;
      this.errorNIS = !__WEBPACK_IMPORTED_MODULE_4__services_validations__["a" /* nisService */].validate(this.nis);
      this.$validator.validateAll().then(function (isValid) {
        var nisIsValid = !_this.nisRequired || !_this.errorNIS;
        if (!isValid || !nisIsValid) {
          _this.saving = false;
          return;
        }

        var doc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.customer, {
          nis: _this.nis,
          regularity: _this.regularity
        }, {
          address: {
            street: _this.addressStreet,
            number: _this.addressNumber,
            neighborhood: _this.addressNeighborhood,
            city: _this.addressCity,
            zip: _this.addressZip,
            complement: _this.addressComplement
          }
        });

        delete doc.tickets;
        delete doc.lamps;

        _this.changeLoading(true);
        _this.upsert(doc).then(function () {
          _this.saving = false;
          _this.$notify({ message: 'Dados salvos com sucesso.', type: 'success' });
          _this.changeLoading(false);
          _this.$emit('on-save');
        }).catch(function () {
          _this.saving = false;
          _this.changeLoading(false);
          _this.$emit('on-save');
        });
      }).catch(function () {
        _this.saving = false;
        _this.changeLoading(false);
      });
    },
    onlyNumber: function onlyNumber(text) {
      if (text === 'nis') this.nis = this.nis.replace(/\D/g, '');
    }
  }),

  mounted: function mounted() {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config');
    }
    this.addressStreet = this.customer.address ? this.customer.address.street : '';
    this.addressNumber = this.customer.address ? this.customer.address.number : '';
    this.addressNeighborhood = this.customer.address ? this.customer.address.neighborhood : '';
    this.addressCity = this.customer.address ? this.customer.address.city : '';
    this.addressZip = this.customer.address ? this.customer.address.zip : '';
    this.addressComplement = this.customer.address ? this.customer.address.complement : '';

    this.nis = this.customer.nis;
    this.regularity = this.customer.regularity;
    this.modelValidations.additionalData.nis.required = this.nisRequired;
  }
});

/***/ }),

/***/ "zT1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociatedTicketsPrint_vue__ = __webpack_require__("yldw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c3918b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssociatedTicketsPrint_vue__ = __webpack_require__("cP1G");
function injectStyle (ssrContext) {
  __webpack_require__("WKyr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02c3918b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociatedTicketsPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c3918b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssociatedTicketsPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProjectName__ = __webpack_require__("nsE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TopNavbar',
  components: {
    ProjectName: __WEBPACK_IMPORTED_MODULE_1__components_ProjectName__["a" /* default */]
  },
  data: function data() {
    return {
      activeNotifications: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user'])),
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__services_AuthService__["a" /* default */].logout();
      this.$router.push('/login');
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
});

/***/ }),

/***/ "zX7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateEventsSpecificationsToNewDatabase_vue__ = __webpack_require__("EyBR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f175ed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateEventsSpecificationsToNewDatabase_vue__ = __webpack_require__("FPZg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MigrateEventsSpecificationsToNewDatabase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f175ed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MigrateEventsSpecificationsToNewDatabase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zXct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('actions-table-layout',{attrs:{"children":_vm.childrenMenu}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zctB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketInvalidateError_vue__ = __webpack_require__("Opun");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1c5a30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketInvalidateError_vue__ = __webpack_require__("7X6m");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketInvalidateError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1c5a30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketInvalidateError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zd6K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zfG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zmm5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zpVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetCustomerContemplado_vue__ = __webpack_require__("9hHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59de23fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetCustomerContemplado_vue__ = __webpack_require__("DEXS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetCustomerContemplado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59de23fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetCustomerContemplado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ }),

/***/ "zzrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"lending-term"},[_c('HeaderTerm',{attrs:{"title":"Termo Comodato","imgsrc":_vm.urlImages.imgTermLending,"event-id":_vm.ticket.eventId,"ticket-id":_vm.ticket._id}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.urlImages.imgTermLending}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('p',{staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"5pt"}},[_vm._v(" "+_vm._s(((_vm.ticket.eventId) + "-" + (_vm.ticket._id)))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"color":"#aaaaaa","margin-bottom":"0.1cm","text-align":"right","font-size":"8pt"}},[_c('p',[_vm._v("\n        A "+_vm._s(_vm.fullname)+", pessoa jurídica de direito privado, com sede em "+_vm._s(_vm.fulladdress)+", inscrita no CNPJ sob o no. "+_vm._s(_vm.cnpj)+" e Inscrição Estadual no. "+_vm._s(_vm.numberState)+", doravante denominada "+_vm._s(_vm.abbreviation)+", e o(a)"),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.customer.holder))]),_vm._v(", residente e domiciliado(a) na "+_vm._s(_vm.customer.address.street)+", "+_vm._s(_vm.customer.address.number)+", "+_vm._s(_vm.customer.address.complement)+" - "+_vm._s(_vm.customer.address.neighborhood)+" - "+_vm._s(_vm.customer.address.zip)+", na cidade de "+_vm._s(_vm.customer.address.city)+", "+_vm._s(_vm.stateName)+", UC n.o "+_vm._s(_vm.customer.uc)+", firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:\n      ")]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" está desenvolvendo o \""+_vm._s(_vm.projectName)+"\" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" buscando viabilizar essa prática nas comunidades atendidas pelo \""+_vm._s(_vm.projectName)+"\", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          A "+_vm._s(_vm.shortname)+" substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          A geladeira entregue pela "+_vm._s(_vm.shortname)+" ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Ao serem entregues a novas geladeiras pela "+_vm._s(_vm.shortname)+", o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da\n          "),_c('strong',[_vm._v("3E Engenharia")]),_vm._v(";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela "+_vm._s(_vm.shortname)+" em comodato, passa a ser de propriedade do consumidor;\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a "+_vm._s(_vm.shortname)+".\n        ")])]),_vm._v(" "),_c('h5',[_vm._v("CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto "+_vm._s(_vm.shortname)+" Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela "+_vm._s(_vm.shortname)+";\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da "+_vm._s(_vm.shortname)+", para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “"+_vm._s(_vm.projectName)+"” cancelados.\n        ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"captalize"},[_vm._v(_vm._s(_vm.customer.address.city)+"/"+_vm._s(_vm.config.state))]),_vm._v("\n        , "+_vm._s(_vm._f("moment")(new Date,'LLL'))+"\n      ")])])]),_vm._v(" "),_c('signature-customer-ticket',{attrs:{"customer":_vm.customer}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 text-center"},[_c('h3',[_vm._v("Termo Comodato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4be1fb89be772630ae2d.js